/* eslint-disable */
/* tslint:disable */

//////////////////////////////////////////////////////////////////////////////
/// Autogenerated by tailwindcss-classnames CLI. https://git.io/JtsPU
/// DO NOT EDIT THIS FILE DIRECTLY!
//////////////////////////////////////////////////////////////////////////////


import classnamesLib from 'clsx';
import type TCustomClassesFromExternalFile from './tailwindExtraClasses';

export type TScreenReaders =
  | 'sr-only'
  | 'not-sr-only'

export type TAccessibility =
  | TScreenReaders

export type TBackgroundAttachment =
  | 'bg-fixed'
  | 'bg-local'
  | 'bg-scroll'

export type TBackgroundClip =
  | 'bg-clip-border'
  | 'bg-clip-padding'
  | 'bg-clip-content'
  | 'bg-clip-text'

export type TBackgroundOrigin =
  | 'bg-origin-border'
  | 'bg-origin-padding'
  | 'bg-origin-content'

export type TBackgroundRepeat =
  | 'bg-repeat'
  | 'bg-no-repeat'
  | 'bg-repeat-x'
  | 'bg-repeat-y'
  | 'bg-repeat-round'
  | 'bg-repeat-space'

export type TBackgroundOpacity =
  | 'bg-opacity-0'
  | 'bg-opacity-5'
  | 'bg-opacity-10'
  | 'bg-opacity-20'
  | 'bg-opacity-25'
  | 'bg-opacity-30'
  | 'bg-opacity-40'
  | 'bg-opacity-50'
  | 'bg-opacity-60'
  | 'bg-opacity-70'
  | 'bg-opacity-75'
  | 'bg-opacity-80'
  | 'bg-opacity-90'
  | 'bg-opacity-95'
  | 'bg-opacity-100'

export type TBackgroundColor =
  | 'bg-transparent'
  | 'bg-current'
  | 'bg-overlay'
  | 'bg-black'
  | 'bg-white'
  | 'bg-white-hover'
  | 'bg-white-pressed'
  | 'bg-product-acid'
  | 'bg-product-aura'
  | 'bg-product-azul'
  | 'bg-product-blanch'
  | 'bg-product-blue-salt'
  | 'bg-product-burgundy'
  | 'bg-product-butter-yellow'
  | 'bg-product-chai'
  | 'bg-product-char'
  | 'bg-product-charm'
  | 'bg-product-chickpea'
  | 'bg-product-cielo'
  | 'bg-product-clay'
  | 'bg-product-clear'
  | 'bg-product-coriander'
  | 'bg-product-cream'
  | 'bg-product-crescent'
  | 'bg-product-dawn'
  | 'bg-product-dusk'
  | 'bg-product-egg-yolk'
  | 'bg-product-espresso'
  | 'bg-product-eve'
  | 'bg-product-firecracker'
  | 'bg-product-forget-me-not-blue'
  | 'bg-product-gold'
  | 'bg-product-golden'
  | 'bg-product-heat'
  | 'bg-product-himalayan-salt'
  | 'bg-product-indigo'
  | 'bg-product-lavender'
  | 'bg-product-lavender-marble'
  | 'bg-product-midnight-marble'
  | 'bg-product-nougat'
  | 'bg-product-pistachio'
  | 'bg-product-rosa'
  | 'bg-product-rose-gold'
  | 'bg-product-rust'
  | 'bg-product-saffron'
  | 'bg-product-sage'
  | 'bg-product-sear'
  | 'bg-product-spice'
  | 'bg-product-steam'
  | 'bg-product-strawberry'
  | 'bg-product-sunrise'
  | 'bg-product-sunset'
  | 'bg-product-sunset-marble'
  | 'bg-product-terracotta'
  | 'bg-product-tierra'
  | 'bg-product-turmeric'
  | 'bg-product-turqoise'
  | 'bg-product-twilight'
  | 'bg-product-walnut'
  | 'bg-product-warm-white'
  | 'bg-product-zest'
  | 'bg-placeholder'
  | 'bg-interactive-bone'
  | 'bg-interactive-brick'
  | 'bg-interactive-char'
  | 'bg-interactive-white'
  | 'bg-interactive-disabled'
  | 'bg-interactive-error'
  | 'bg-interactive-outline'
  | 'bg-translucent-char'
  | 'bg-translucent-white'
  | 'bg-char-50'
  | 'bg-char-100'
  | 'bg-char-200'
  | 'bg-char-300'
  | 'bg-char-400'
  | 'bg-char-500'
  | 'bg-char-600'
  | 'bg-char-700'
  | 'bg-char-800'
  | 'bg-char-900'
  | 'bg-bone-50'
  | 'bg-bone-100'
  | 'bg-bone-200'
  | 'bg-bone-300'
  | 'bg-bone-400'
  | 'bg-bone-500'
  | 'bg-bone-600'
  | 'bg-bone-700'
  | 'bg-bone-800'
  | 'bg-bone-900'
  | 'bg-brick-50'
  | 'bg-brick-300'
  | 'bg-brick-500'
  | 'bg-brick-700'
  | 'bg-brick-900'
  | 'bg-sage-50'
  | 'bg-sage-300'
  | 'bg-sage-500'
  | 'bg-sage-700'
  | 'bg-sage-900'
  | 'bg-blue-50'
  | 'bg-blue-300'
  | 'bg-blue-500'
  | 'bg-blue-700'
  | 'bg-blue-900'
  | 'bg-misc-bright-blue'
  | 'bg-misc-focus'
  | 'bg-misc-legal-blue'
  | 'bg-misc-neutral'
  | 'bg-misc-yellow-orange'

export type TBackgroundPosition =
  | 'bg-bottom'
  | 'bg-center'
  | 'bg-left'
  | 'bg-left-bottom'
  | 'bg-left-top'
  | 'bg-right'
  | 'bg-right-bottom'
  | 'bg-right-top'
  | 'bg-top'

export type TBackgroundSize =
  | 'bg-auto'
  | 'bg-cover'
  | 'bg-contain'

export type TBackgroundImage =
  | 'bg-none'
  | 'bg-gradient-to-t'
  | 'bg-gradient-to-tr'
  | 'bg-gradient-to-r'
  | 'bg-gradient-to-br'
  | 'bg-gradient-to-b'
  | 'bg-gradient-to-bl'
  | 'bg-gradient-to-l'
  | 'bg-gradient-to-tl'
  | 'bg-product-blue-salt-char'
  | 'bg-product-brushed'
  | 'bg-product-brushed-blue-salt'
  | 'bg-product-brushed-char'
  | 'bg-product-brushed-sage'
  | 'bg-product-brushed-spice'
  | 'bg-product-brushed-steam'
  | 'bg-product-char-blue-salt'
  | 'bg-product-chrome'
  | 'bg-product-chrome-blue-salt'
  | 'bg-product-chrome-char'
  | 'bg-product-chrome-gold'
  | 'bg-product-chrome-lavender'
  | 'bg-product-chrome-sage'
  | 'bg-product-chrome-spice'
  | 'bg-product-chrome-steam'
  | 'bg-product-clear-sunset'
  | 'bg-product-cool'
  | 'bg-product-crossed-out-char'
  | 'bg-product-crossed-out-white'
  | 'bg-product-day-rosa'
  | 'bg-product-deep-blend'
  | 'bg-product-gold'
  | 'bg-product-gold-blue-salt'
  | 'bg-product-gold-char'
  | 'bg-product-gold-lavender'
  | 'bg-product-gold-sage'
  | 'bg-product-gold-spice'
  | 'bg-product-gold-steam'
  | 'bg-product-iridescent'
  | 'bg-product-lavender-marble'
  | 'bg-product-lavender-steam'
  | 'bg-product-midnight-marble'
  | 'bg-product-mixed'
  | 'bg-product-mixed-spices'
  | 'bg-product-multi'
  | 'bg-product-olive-clay'
  | 'bg-product-rosa-dusk'
  | 'bg-product-sage-char'
  | 'bg-product-sage-steam'
  | 'bg-product-spice-lavender'
  | 'bg-product-spice-rosa'
  | 'bg-product-spice-steam'
  | 'bg-product-stainless-steel'
  | 'bg-product-steam-blue-salt'
  | 'bg-product-steam-lavender'
  | 'bg-product-steam-rosa'
  | 'bg-product-steam-sage'
  | 'bg-product-steam-spice'
  | 'bg-product-steam-turmeric'
  | 'bg-product-sunset-marble'
  | 'bg-product-twilight-dusk'
  | 'bg-product-vanilla-bean'
  | 'bg-product-warm'
  | 'bg-product-warm-blend'

export type TGradientColorStops =
  | 'from-transparent'
  | 'via-transparent'
  | 'to-transparent'
  | 'from-current'
  | 'via-current'
  | 'to-current'
  | 'from-overlay'
  | 'via-overlay'
  | 'to-overlay'
  | 'from-black'
  | 'via-black'
  | 'to-black'
  | 'from-white'
  | 'via-white'
  | 'to-white'
  | 'from-white-hover'
  | 'via-white-hover'
  | 'to-white-hover'
  | 'from-white-pressed'
  | 'via-white-pressed'
  | 'to-white-pressed'
  | 'from-product-acid'
  | 'via-product-acid'
  | 'to-product-acid'
  | 'from-product-aura'
  | 'via-product-aura'
  | 'to-product-aura'
  | 'from-product-azul'
  | 'via-product-azul'
  | 'to-product-azul'
  | 'from-product-blanch'
  | 'via-product-blanch'
  | 'to-product-blanch'
  | 'from-product-blue-salt'
  | 'via-product-blue-salt'
  | 'to-product-blue-salt'
  | 'from-product-burgundy'
  | 'via-product-burgundy'
  | 'to-product-burgundy'
  | 'from-product-butter-yellow'
  | 'via-product-butter-yellow'
  | 'to-product-butter-yellow'
  | 'from-product-chai'
  | 'via-product-chai'
  | 'to-product-chai'
  | 'from-product-char'
  | 'via-product-char'
  | 'to-product-char'
  | 'from-product-charm'
  | 'via-product-charm'
  | 'to-product-charm'
  | 'from-product-chickpea'
  | 'via-product-chickpea'
  | 'to-product-chickpea'
  | 'from-product-cielo'
  | 'via-product-cielo'
  | 'to-product-cielo'
  | 'from-product-clay'
  | 'via-product-clay'
  | 'to-product-clay'
  | 'from-product-clear'
  | 'via-product-clear'
  | 'to-product-clear'
  | 'from-product-coriander'
  | 'via-product-coriander'
  | 'to-product-coriander'
  | 'from-product-cream'
  | 'via-product-cream'
  | 'to-product-cream'
  | 'from-product-crescent'
  | 'via-product-crescent'
  | 'to-product-crescent'
  | 'from-product-dawn'
  | 'via-product-dawn'
  | 'to-product-dawn'
  | 'from-product-dusk'
  | 'via-product-dusk'
  | 'to-product-dusk'
  | 'from-product-egg-yolk'
  | 'via-product-egg-yolk'
  | 'to-product-egg-yolk'
  | 'from-product-espresso'
  | 'via-product-espresso'
  | 'to-product-espresso'
  | 'from-product-eve'
  | 'via-product-eve'
  | 'to-product-eve'
  | 'from-product-firecracker'
  | 'via-product-firecracker'
  | 'to-product-firecracker'
  | 'from-product-forget-me-not-blue'
  | 'via-product-forget-me-not-blue'
  | 'to-product-forget-me-not-blue'
  | 'from-product-gold'
  | 'via-product-gold'
  | 'to-product-gold'
  | 'from-product-golden'
  | 'via-product-golden'
  | 'to-product-golden'
  | 'from-product-heat'
  | 'via-product-heat'
  | 'to-product-heat'
  | 'from-product-himalayan-salt'
  | 'via-product-himalayan-salt'
  | 'to-product-himalayan-salt'
  | 'from-product-indigo'
  | 'via-product-indigo'
  | 'to-product-indigo'
  | 'from-product-lavender'
  | 'via-product-lavender'
  | 'to-product-lavender'
  | 'from-product-lavender-marble'
  | 'via-product-lavender-marble'
  | 'to-product-lavender-marble'
  | 'from-product-midnight-marble'
  | 'via-product-midnight-marble'
  | 'to-product-midnight-marble'
  | 'from-product-nougat'
  | 'via-product-nougat'
  | 'to-product-nougat'
  | 'from-product-pistachio'
  | 'via-product-pistachio'
  | 'to-product-pistachio'
  | 'from-product-rosa'
  | 'via-product-rosa'
  | 'to-product-rosa'
  | 'from-product-rose-gold'
  | 'via-product-rose-gold'
  | 'to-product-rose-gold'
  | 'from-product-rust'
  | 'via-product-rust'
  | 'to-product-rust'
  | 'from-product-saffron'
  | 'via-product-saffron'
  | 'to-product-saffron'
  | 'from-product-sage'
  | 'via-product-sage'
  | 'to-product-sage'
  | 'from-product-sear'
  | 'via-product-sear'
  | 'to-product-sear'
  | 'from-product-spice'
  | 'via-product-spice'
  | 'to-product-spice'
  | 'from-product-steam'
  | 'via-product-steam'
  | 'to-product-steam'
  | 'from-product-strawberry'
  | 'via-product-strawberry'
  | 'to-product-strawberry'
  | 'from-product-sunrise'
  | 'via-product-sunrise'
  | 'to-product-sunrise'
  | 'from-product-sunset'
  | 'via-product-sunset'
  | 'to-product-sunset'
  | 'from-product-sunset-marble'
  | 'via-product-sunset-marble'
  | 'to-product-sunset-marble'
  | 'from-product-terracotta'
  | 'via-product-terracotta'
  | 'to-product-terracotta'
  | 'from-product-tierra'
  | 'via-product-tierra'
  | 'to-product-tierra'
  | 'from-product-turmeric'
  | 'via-product-turmeric'
  | 'to-product-turmeric'
  | 'from-product-turqoise'
  | 'via-product-turqoise'
  | 'to-product-turqoise'
  | 'from-product-twilight'
  | 'via-product-twilight'
  | 'to-product-twilight'
  | 'from-product-walnut'
  | 'via-product-walnut'
  | 'to-product-walnut'
  | 'from-product-warm-white'
  | 'via-product-warm-white'
  | 'to-product-warm-white'
  | 'from-product-zest'
  | 'via-product-zest'
  | 'to-product-zest'
  | 'from-placeholder'
  | 'via-placeholder'
  | 'to-placeholder'
  | 'from-interactive-bone'
  | 'via-interactive-bone'
  | 'to-interactive-bone'
  | 'from-interactive-brick'
  | 'via-interactive-brick'
  | 'to-interactive-brick'
  | 'from-interactive-char'
  | 'via-interactive-char'
  | 'to-interactive-char'
  | 'from-interactive-white'
  | 'via-interactive-white'
  | 'to-interactive-white'
  | 'from-interactive-disabled'
  | 'via-interactive-disabled'
  | 'to-interactive-disabled'
  | 'from-interactive-error'
  | 'via-interactive-error'
  | 'to-interactive-error'
  | 'from-interactive-outline'
  | 'via-interactive-outline'
  | 'to-interactive-outline'
  | 'from-translucent-char'
  | 'via-translucent-char'
  | 'to-translucent-char'
  | 'from-translucent-white'
  | 'via-translucent-white'
  | 'to-translucent-white'
  | 'from-char-50'
  | 'via-char-50'
  | 'to-char-50'
  | 'from-char-100'
  | 'via-char-100'
  | 'to-char-100'
  | 'from-char-200'
  | 'via-char-200'
  | 'to-char-200'
  | 'from-char-300'
  | 'via-char-300'
  | 'to-char-300'
  | 'from-char-400'
  | 'via-char-400'
  | 'to-char-400'
  | 'from-char-500'
  | 'via-char-500'
  | 'to-char-500'
  | 'from-char-600'
  | 'via-char-600'
  | 'to-char-600'
  | 'from-char-700'
  | 'via-char-700'
  | 'to-char-700'
  | 'from-char-800'
  | 'via-char-800'
  | 'to-char-800'
  | 'from-char-900'
  | 'via-char-900'
  | 'to-char-900'
  | 'from-bone-50'
  | 'via-bone-50'
  | 'to-bone-50'
  | 'from-bone-100'
  | 'via-bone-100'
  | 'to-bone-100'
  | 'from-bone-200'
  | 'via-bone-200'
  | 'to-bone-200'
  | 'from-bone-300'
  | 'via-bone-300'
  | 'to-bone-300'
  | 'from-bone-400'
  | 'via-bone-400'
  | 'to-bone-400'
  | 'from-bone-500'
  | 'via-bone-500'
  | 'to-bone-500'
  | 'from-bone-600'
  | 'via-bone-600'
  | 'to-bone-600'
  | 'from-bone-700'
  | 'via-bone-700'
  | 'to-bone-700'
  | 'from-bone-800'
  | 'via-bone-800'
  | 'to-bone-800'
  | 'from-bone-900'
  | 'via-bone-900'
  | 'to-bone-900'
  | 'from-brick-50'
  | 'via-brick-50'
  | 'to-brick-50'
  | 'from-brick-300'
  | 'via-brick-300'
  | 'to-brick-300'
  | 'from-brick-500'
  | 'via-brick-500'
  | 'to-brick-500'
  | 'from-brick-700'
  | 'via-brick-700'
  | 'to-brick-700'
  | 'from-brick-900'
  | 'via-brick-900'
  | 'to-brick-900'
  | 'from-sage-50'
  | 'via-sage-50'
  | 'to-sage-50'
  | 'from-sage-300'
  | 'via-sage-300'
  | 'to-sage-300'
  | 'from-sage-500'
  | 'via-sage-500'
  | 'to-sage-500'
  | 'from-sage-700'
  | 'via-sage-700'
  | 'to-sage-700'
  | 'from-sage-900'
  | 'via-sage-900'
  | 'to-sage-900'
  | 'from-blue-50'
  | 'via-blue-50'
  | 'to-blue-50'
  | 'from-blue-300'
  | 'via-blue-300'
  | 'to-blue-300'
  | 'from-blue-500'
  | 'via-blue-500'
  | 'to-blue-500'
  | 'from-blue-700'
  | 'via-blue-700'
  | 'to-blue-700'
  | 'from-blue-900'
  | 'via-blue-900'
  | 'to-blue-900'
  | 'from-misc-bright-blue'
  | 'via-misc-bright-blue'
  | 'to-misc-bright-blue'
  | 'from-misc-focus'
  | 'via-misc-focus'
  | 'to-misc-focus'
  | 'from-misc-legal-blue'
  | 'via-misc-legal-blue'
  | 'to-misc-legal-blue'
  | 'from-misc-neutral'
  | 'via-misc-neutral'
  | 'to-misc-neutral'
  | 'from-misc-yellow-orange'
  | 'via-misc-yellow-orange'
  | 'to-misc-yellow-orange'

export type TBackgrounds =
  | TBackgroundAttachment
  | TBackgroundClip
  | TBackgroundOrigin
  | TBackgroundRepeat
  | TBackgroundOpacity
  | TBackgroundColor
  | TBackgroundPosition
  | TBackgroundSize
  | TBackgroundImage
  | TGradientColorStops

export type TBorderStyle =
  | 'border-solid'
  | 'border-dashed'
  | 'border-dotted'
  | 'border-double'
  | 'border-none'

export type TDivideStyle =
  | 'divide-solid'
  | 'divide-dashed'
  | 'divide-dotted'
  | 'divide-double'
  | 'divide-none'

export type TBorderColor =
  | 'border-transparent'
  | 'border-current'
  | 'border-overlay'
  | 'border-black'
  | 'border-white'
  | 'border-white-hover'
  | 'border-white-pressed'
  | 'border-product-acid'
  | 'border-product-aura'
  | 'border-product-azul'
  | 'border-product-blanch'
  | 'border-product-blue-salt'
  | 'border-product-burgundy'
  | 'border-product-butter-yellow'
  | 'border-product-chai'
  | 'border-product-char'
  | 'border-product-charm'
  | 'border-product-chickpea'
  | 'border-product-cielo'
  | 'border-product-clay'
  | 'border-product-clear'
  | 'border-product-coriander'
  | 'border-product-cream'
  | 'border-product-crescent'
  | 'border-product-dawn'
  | 'border-product-dusk'
  | 'border-product-egg-yolk'
  | 'border-product-espresso'
  | 'border-product-eve'
  | 'border-product-firecracker'
  | 'border-product-forget-me-not-blue'
  | 'border-product-gold'
  | 'border-product-golden'
  | 'border-product-heat'
  | 'border-product-himalayan-salt'
  | 'border-product-indigo'
  | 'border-product-lavender'
  | 'border-product-lavender-marble'
  | 'border-product-midnight-marble'
  | 'border-product-nougat'
  | 'border-product-pistachio'
  | 'border-product-rosa'
  | 'border-product-rose-gold'
  | 'border-product-rust'
  | 'border-product-saffron'
  | 'border-product-sage'
  | 'border-product-sear'
  | 'border-product-spice'
  | 'border-product-steam'
  | 'border-product-strawberry'
  | 'border-product-sunrise'
  | 'border-product-sunset'
  | 'border-product-sunset-marble'
  | 'border-product-terracotta'
  | 'border-product-tierra'
  | 'border-product-turmeric'
  | 'border-product-turqoise'
  | 'border-product-twilight'
  | 'border-product-walnut'
  | 'border-product-warm-white'
  | 'border-product-zest'
  | 'border-placeholder'
  | 'border-interactive-bone'
  | 'border-interactive-brick'
  | 'border-interactive-char'
  | 'border-interactive-white'
  | 'border-interactive-disabled'
  | 'border-interactive-error'
  | 'border-interactive-outline'
  | 'border-translucent-char'
  | 'border-translucent-white'
  | 'border-char-50'
  | 'border-char-100'
  | 'border-char-200'
  | 'border-char-300'
  | 'border-char-400'
  | 'border-char-500'
  | 'border-char-600'
  | 'border-char-700'
  | 'border-char-800'
  | 'border-char-900'
  | 'border-bone-50'
  | 'border-bone-100'
  | 'border-bone-200'
  | 'border-bone-300'
  | 'border-bone-400'
  | 'border-bone-500'
  | 'border-bone-600'
  | 'border-bone-700'
  | 'border-bone-800'
  | 'border-bone-900'
  | 'border-brick-50'
  | 'border-brick-300'
  | 'border-brick-500'
  | 'border-brick-700'
  | 'border-brick-900'
  | 'border-sage-50'
  | 'border-sage-300'
  | 'border-sage-500'
  | 'border-sage-700'
  | 'border-sage-900'
  | 'border-blue-50'
  | 'border-blue-300'
  | 'border-blue-500'
  | 'border-blue-700'
  | 'border-blue-900'
  | 'border-misc-bright-blue'
  | 'border-misc-focus'
  | 'border-misc-legal-blue'
  | 'border-misc-neutral'
  | 'border-misc-yellow-orange'

export type TBorderOpacity =
  | 'border-opacity-0'
  | 'border-opacity-5'
  | 'border-opacity-10'
  | 'border-opacity-20'
  | 'border-opacity-25'
  | 'border-opacity-30'
  | 'border-opacity-40'
  | 'border-opacity-50'
  | 'border-opacity-60'
  | 'border-opacity-70'
  | 'border-opacity-75'
  | 'border-opacity-80'
  | 'border-opacity-90'
  | 'border-opacity-95'
  | 'border-opacity-100'

export type TBorderRadius =
  | 'rounded-t-100'
  | 'rounded-r-100'
  | 'rounded-b-100'
  | 'rounded-l-100'
  | 'rounded-tr-100'
  | 'rounded-tl-100'
  | 'rounded-br-100'
  | 'rounded-bl-100'
  | 'rounded-100'
  | 'rounded-t-none'
  | 'rounded-r-none'
  | 'rounded-b-none'
  | 'rounded-l-none'
  | 'rounded-tr-none'
  | 'rounded-tl-none'
  | 'rounded-br-none'
  | 'rounded-bl-none'
  | 'rounded-none'
  | 'rounded-t-sm'
  | 'rounded-r-sm'
  | 'rounded-b-sm'
  | 'rounded-l-sm'
  | 'rounded-tr-sm'
  | 'rounded-tl-sm'
  | 'rounded-br-sm'
  | 'rounded-bl-sm'
  | 'rounded-sm'
  | 'rounded-t'
  | 'rounded-r'
  | 'rounded-b'
  | 'rounded-l'
  | 'rounded-tr'
  | 'rounded-tl'
  | 'rounded-br'
  | 'rounded-bl'
  | 'rounded'
  | 'rounded-t-md'
  | 'rounded-r-md'
  | 'rounded-b-md'
  | 'rounded-l-md'
  | 'rounded-tr-md'
  | 'rounded-tl-md'
  | 'rounded-br-md'
  | 'rounded-bl-md'
  | 'rounded-md'
  | 'rounded-t-lg'
  | 'rounded-r-lg'
  | 'rounded-b-lg'
  | 'rounded-l-lg'
  | 'rounded-tr-lg'
  | 'rounded-tl-lg'
  | 'rounded-br-lg'
  | 'rounded-bl-lg'
  | 'rounded-lg'
  | 'rounded-t-xl'
  | 'rounded-r-xl'
  | 'rounded-b-xl'
  | 'rounded-l-xl'
  | 'rounded-tr-xl'
  | 'rounded-tl-xl'
  | 'rounded-br-xl'
  | 'rounded-bl-xl'
  | 'rounded-xl'
  | 'rounded-t-2xl'
  | 'rounded-r-2xl'
  | 'rounded-b-2xl'
  | 'rounded-l-2xl'
  | 'rounded-tr-2xl'
  | 'rounded-tl-2xl'
  | 'rounded-br-2xl'
  | 'rounded-bl-2xl'
  | 'rounded-2xl'
  | 'rounded-t-3xl'
  | 'rounded-r-3xl'
  | 'rounded-b-3xl'
  | 'rounded-l-3xl'
  | 'rounded-tr-3xl'
  | 'rounded-tl-3xl'
  | 'rounded-br-3xl'
  | 'rounded-bl-3xl'
  | 'rounded-3xl'
  | 'rounded-t-4xl'
  | 'rounded-r-4xl'
  | 'rounded-b-4xl'
  | 'rounded-l-4xl'
  | 'rounded-tr-4xl'
  | 'rounded-tl-4xl'
  | 'rounded-br-4xl'
  | 'rounded-bl-4xl'
  | 'rounded-4xl'
  | 'rounded-t-5xl'
  | 'rounded-r-5xl'
  | 'rounded-b-5xl'
  | 'rounded-l-5xl'
  | 'rounded-tr-5xl'
  | 'rounded-tl-5xl'
  | 'rounded-br-5xl'
  | 'rounded-bl-5xl'
  | 'rounded-5xl'
  | 'rounded-t-6xl'
  | 'rounded-r-6xl'
  | 'rounded-b-6xl'
  | 'rounded-l-6xl'
  | 'rounded-tr-6xl'
  | 'rounded-tl-6xl'
  | 'rounded-br-6xl'
  | 'rounded-bl-6xl'
  | 'rounded-6xl'
  | 'rounded-t-full'
  | 'rounded-r-full'
  | 'rounded-b-full'
  | 'rounded-l-full'
  | 'rounded-tr-full'
  | 'rounded-tl-full'
  | 'rounded-br-full'
  | 'rounded-bl-full'
  | 'rounded-full'

export type TBorderWidth =
  | 'border-t-0'
  | 'border-r-0'
  | 'border-b-0'
  | 'border-l-0'
  | 'border-0'
  | 'border-t-2'
  | 'border-r-2'
  | 'border-b-2'
  | 'border-l-2'
  | 'border-2'
  | 'border-t-3'
  | 'border-r-3'
  | 'border-b-3'
  | 'border-l-3'
  | 'border-3'
  | 'border-t-4'
  | 'border-r-4'
  | 'border-b-4'
  | 'border-l-4'
  | 'border-4'
  | 'border-t-6'
  | 'border-r-6'
  | 'border-b-6'
  | 'border-l-6'
  | 'border-6'
  | 'border-t-8'
  | 'border-r-8'
  | 'border-b-8'
  | 'border-l-8'
  | 'border-8'
  | 'border-t'
  | 'border-r'
  | 'border-b'
  | 'border-l'
  | 'border'

export type TDivideColor =
  | 'divide-transparent'
  | 'divide-current'
  | 'divide-overlay'
  | 'divide-black'
  | 'divide-white'
  | 'divide-white-hover'
  | 'divide-white-pressed'
  | 'divide-product-acid'
  | 'divide-product-aura'
  | 'divide-product-azul'
  | 'divide-product-blanch'
  | 'divide-product-blue-salt'
  | 'divide-product-burgundy'
  | 'divide-product-butter-yellow'
  | 'divide-product-chai'
  | 'divide-product-char'
  | 'divide-product-charm'
  | 'divide-product-chickpea'
  | 'divide-product-cielo'
  | 'divide-product-clay'
  | 'divide-product-clear'
  | 'divide-product-coriander'
  | 'divide-product-cream'
  | 'divide-product-crescent'
  | 'divide-product-dawn'
  | 'divide-product-dusk'
  | 'divide-product-egg-yolk'
  | 'divide-product-espresso'
  | 'divide-product-eve'
  | 'divide-product-firecracker'
  | 'divide-product-forget-me-not-blue'
  | 'divide-product-gold'
  | 'divide-product-golden'
  | 'divide-product-heat'
  | 'divide-product-himalayan-salt'
  | 'divide-product-indigo'
  | 'divide-product-lavender'
  | 'divide-product-lavender-marble'
  | 'divide-product-midnight-marble'
  | 'divide-product-nougat'
  | 'divide-product-pistachio'
  | 'divide-product-rosa'
  | 'divide-product-rose-gold'
  | 'divide-product-rust'
  | 'divide-product-saffron'
  | 'divide-product-sage'
  | 'divide-product-sear'
  | 'divide-product-spice'
  | 'divide-product-steam'
  | 'divide-product-strawberry'
  | 'divide-product-sunrise'
  | 'divide-product-sunset'
  | 'divide-product-sunset-marble'
  | 'divide-product-terracotta'
  | 'divide-product-tierra'
  | 'divide-product-turmeric'
  | 'divide-product-turqoise'
  | 'divide-product-twilight'
  | 'divide-product-walnut'
  | 'divide-product-warm-white'
  | 'divide-product-zest'
  | 'divide-placeholder'
  | 'divide-interactive-bone'
  | 'divide-interactive-brick'
  | 'divide-interactive-char'
  | 'divide-interactive-white'
  | 'divide-interactive-disabled'
  | 'divide-interactive-error'
  | 'divide-interactive-outline'
  | 'divide-translucent-char'
  | 'divide-translucent-white'
  | 'divide-char-50'
  | 'divide-char-100'
  | 'divide-char-200'
  | 'divide-char-300'
  | 'divide-char-400'
  | 'divide-char-500'
  | 'divide-char-600'
  | 'divide-char-700'
  | 'divide-char-800'
  | 'divide-char-900'
  | 'divide-bone-50'
  | 'divide-bone-100'
  | 'divide-bone-200'
  | 'divide-bone-300'
  | 'divide-bone-400'
  | 'divide-bone-500'
  | 'divide-bone-600'
  | 'divide-bone-700'
  | 'divide-bone-800'
  | 'divide-bone-900'
  | 'divide-brick-50'
  | 'divide-brick-300'
  | 'divide-brick-500'
  | 'divide-brick-700'
  | 'divide-brick-900'
  | 'divide-sage-50'
  | 'divide-sage-300'
  | 'divide-sage-500'
  | 'divide-sage-700'
  | 'divide-sage-900'
  | 'divide-blue-50'
  | 'divide-blue-300'
  | 'divide-blue-500'
  | 'divide-blue-700'
  | 'divide-blue-900'
  | 'divide-misc-bright-blue'
  | 'divide-misc-focus'
  | 'divide-misc-legal-blue'
  | 'divide-misc-neutral'
  | 'divide-misc-yellow-orange'

export type TDivideOpacity =
  | 'divide-opacity-0'
  | 'divide-opacity-5'
  | 'divide-opacity-10'
  | 'divide-opacity-20'
  | 'divide-opacity-25'
  | 'divide-opacity-30'
  | 'divide-opacity-40'
  | 'divide-opacity-50'
  | 'divide-opacity-60'
  | 'divide-opacity-70'
  | 'divide-opacity-75'
  | 'divide-opacity-80'
  | 'divide-opacity-90'
  | 'divide-opacity-95'
  | 'divide-opacity-100'

export type TDivideWidth =
  | 'divide-x-0'
  | 'divide-y-0'
  | 'divide-x-2'
  | 'divide-y-2'
  | 'divide-x-3'
  | 'divide-y-3'
  | 'divide-x-4'
  | 'divide-y-4'
  | 'divide-x-6'
  | 'divide-y-6'
  | 'divide-x-8'
  | 'divide-y-8'
  | 'divide-x'
  | 'divide-y'
  | 'divide-x-reverse'
  | 'divide-y-reverse'

export type TRingColor =
  | 'ring-transparent'
  | 'ring-current'
  | 'ring-overlay'
  | 'ring-black'
  | 'ring-white'
  | 'ring-product'
  | 'ring-product-hover'
  | 'ring-product-pressed'
  | 'ring-placeholder-acid'
  | 'ring-placeholder-aura'
  | 'ring-placeholder-azul'
  | 'ring-placeholder-blanch'
  | 'ring-placeholder-blue-salt'
  | 'ring-placeholder-burgundy'
  | 'ring-placeholder-butter-yellow'
  | 'ring-placeholder-chai'
  | 'ring-placeholder-char'
  | 'ring-placeholder-charm'
  | 'ring-placeholder-chickpea'
  | 'ring-placeholder-cielo'
  | 'ring-placeholder-clay'
  | 'ring-placeholder-clear'
  | 'ring-placeholder-coriander'
  | 'ring-placeholder-cream'
  | 'ring-placeholder-crescent'
  | 'ring-placeholder-dawn'
  | 'ring-placeholder-dusk'
  | 'ring-placeholder-egg-yolk'
  | 'ring-placeholder-espresso'
  | 'ring-placeholder-eve'
  | 'ring-placeholder-firecracker'
  | 'ring-placeholder-forget-me-not-blue'
  | 'ring-placeholder-gold'
  | 'ring-placeholder-golden'
  | 'ring-placeholder-heat'
  | 'ring-placeholder-himalayan-salt'
  | 'ring-placeholder-indigo'
  | 'ring-placeholder-lavender'
  | 'ring-placeholder-lavender-marble'
  | 'ring-placeholder-midnight-marble'
  | 'ring-placeholder-nougat'
  | 'ring-placeholder-pistachio'
  | 'ring-placeholder-rosa'
  | 'ring-placeholder-rose-gold'
  | 'ring-placeholder-rust'
  | 'ring-placeholder-saffron'
  | 'ring-placeholder-sage'
  | 'ring-placeholder-sear'
  | 'ring-placeholder-spice'
  | 'ring-placeholder-steam'
  | 'ring-placeholder-strawberry'
  | 'ring-placeholder-sunrise'
  | 'ring-placeholder-sunset'
  | 'ring-placeholder-sunset-marble'
  | 'ring-placeholder-terracotta'
  | 'ring-placeholder-tierra'
  | 'ring-placeholder-turmeric'
  | 'ring-placeholder-turqoise'
  | 'ring-placeholder-twilight'
  | 'ring-placeholder-walnut'
  | 'ring-placeholder-warm-white'
  | 'ring-placeholder-zest'
  | 'ring-interactive'
  | 'ring-translucent-bone'
  | 'ring-translucent-brick'
  | 'ring-translucent-char'
  | 'ring-translucent-white'
  | 'ring-translucent-disabled'
  | 'ring-translucent-error'
  | 'ring-translucent-outline'
  | 'ring-char-char'
  | 'ring-char-white'
  | 'ring-bone-50'
  | 'ring-bone-100'
  | 'ring-bone-200'
  | 'ring-bone-300'
  | 'ring-bone-400'
  | 'ring-bone-500'
  | 'ring-bone-600'
  | 'ring-bone-700'
  | 'ring-bone-800'
  | 'ring-bone-900'
  | 'ring-brick-50'
  | 'ring-brick-100'
  | 'ring-brick-200'
  | 'ring-brick-300'
  | 'ring-brick-400'
  | 'ring-brick-500'
  | 'ring-brick-600'
  | 'ring-brick-700'
  | 'ring-brick-800'
  | 'ring-brick-900'
  | 'ring-sage-50'
  | 'ring-sage-300'
  | 'ring-sage-500'
  | 'ring-sage-700'
  | 'ring-sage-900'
  | 'ring-blue-50'
  | 'ring-blue-300'
  | 'ring-blue-500'
  | 'ring-blue-700'
  | 'ring-blue-900'
  | 'ring-misc-50'
  | 'ring-misc-300'
  | 'ring-misc-500'
  | 'ring-misc-700'
  | 'ring-misc-900'

export type TRingWidth =
  | 'ring-0'
  | 'ring-1'
  | 'ring-2'
  | 'ring-4'
  | 'ring-8'
  | 'ring'
  | 'inset'

export type TRingOpacity =
  | 'ring-opacity-0'
  | 'ring-opacity-5'
  | 'ring-opacity-10'
  | 'ring-opacity-20'
  | 'ring-opacity-25'
  | 'ring-opacity-30'
  | 'ring-opacity-40'
  | 'ring-opacity-50'
  | 'ring-opacity-60'
  | 'ring-opacity-70'
  | 'ring-opacity-75'
  | 'ring-opacity-80'
  | 'ring-opacity-90'
  | 'ring-opacity-95'
  | 'ring-opacity-100'
  | 'ring-opacity'

export type TRingOffsetColor =
  | 'ring-offset-transparent'
  | 'ring-offset-current'
  | 'ring-offset-overlay'
  | 'ring-offset-black'
  | 'ring-offset-white'
  | 'ring-offset-white-hover'
  | 'ring-offset-white-pressed'
  | 'ring-offset-product-acid'
  | 'ring-offset-product-aura'
  | 'ring-offset-product-azul'
  | 'ring-offset-product-blanch'
  | 'ring-offset-product-blue-salt'
  | 'ring-offset-product-burgundy'
  | 'ring-offset-product-butter-yellow'
  | 'ring-offset-product-chai'
  | 'ring-offset-product-char'
  | 'ring-offset-product-charm'
  | 'ring-offset-product-chickpea'
  | 'ring-offset-product-cielo'
  | 'ring-offset-product-clay'
  | 'ring-offset-product-clear'
  | 'ring-offset-product-coriander'
  | 'ring-offset-product-cream'
  | 'ring-offset-product-crescent'
  | 'ring-offset-product-dawn'
  | 'ring-offset-product-dusk'
  | 'ring-offset-product-egg-yolk'
  | 'ring-offset-product-espresso'
  | 'ring-offset-product-eve'
  | 'ring-offset-product-firecracker'
  | 'ring-offset-product-forget-me-not-blue'
  | 'ring-offset-product-gold'
  | 'ring-offset-product-golden'
  | 'ring-offset-product-heat'
  | 'ring-offset-product-himalayan-salt'
  | 'ring-offset-product-indigo'
  | 'ring-offset-product-lavender'
  | 'ring-offset-product-lavender-marble'
  | 'ring-offset-product-midnight-marble'
  | 'ring-offset-product-nougat'
  | 'ring-offset-product-pistachio'
  | 'ring-offset-product-rosa'
  | 'ring-offset-product-rose-gold'
  | 'ring-offset-product-rust'
  | 'ring-offset-product-saffron'
  | 'ring-offset-product-sage'
  | 'ring-offset-product-sear'
  | 'ring-offset-product-spice'
  | 'ring-offset-product-steam'
  | 'ring-offset-product-strawberry'
  | 'ring-offset-product-sunrise'
  | 'ring-offset-product-sunset'
  | 'ring-offset-product-sunset-marble'
  | 'ring-offset-product-terracotta'
  | 'ring-offset-product-tierra'
  | 'ring-offset-product-turmeric'
  | 'ring-offset-product-turqoise'
  | 'ring-offset-product-twilight'
  | 'ring-offset-product-walnut'
  | 'ring-offset-product-warm-white'
  | 'ring-offset-product-zest'
  | 'ring-offset-placeholder'
  | 'ring-offset-interactive-bone'
  | 'ring-offset-interactive-brick'
  | 'ring-offset-interactive-char'
  | 'ring-offset-interactive-white'
  | 'ring-offset-interactive-disabled'
  | 'ring-offset-interactive-error'
  | 'ring-offset-interactive-outline'
  | 'ring-offset-translucent-char'
  | 'ring-offset-translucent-white'
  | 'ring-offset-char-50'
  | 'ring-offset-char-100'
  | 'ring-offset-char-200'
  | 'ring-offset-char-300'
  | 'ring-offset-char-400'
  | 'ring-offset-char-500'
  | 'ring-offset-char-600'
  | 'ring-offset-char-700'
  | 'ring-offset-char-800'
  | 'ring-offset-char-900'
  | 'ring-offset-bone-50'
  | 'ring-offset-bone-100'
  | 'ring-offset-bone-200'
  | 'ring-offset-bone-300'
  | 'ring-offset-bone-400'
  | 'ring-offset-bone-500'
  | 'ring-offset-bone-600'
  | 'ring-offset-bone-700'
  | 'ring-offset-bone-800'
  | 'ring-offset-bone-900'
  | 'ring-offset-brick-50'
  | 'ring-offset-brick-300'
  | 'ring-offset-brick-500'
  | 'ring-offset-brick-700'
  | 'ring-offset-brick-900'
  | 'ring-offset-sage-50'
  | 'ring-offset-sage-300'
  | 'ring-offset-sage-500'
  | 'ring-offset-sage-700'
  | 'ring-offset-sage-900'
  | 'ring-offset-blue-50'
  | 'ring-offset-blue-300'
  | 'ring-offset-blue-500'
  | 'ring-offset-blue-700'
  | 'ring-offset-blue-900'
  | 'ring-offset-misc-bright-blue'
  | 'ring-offset-misc-focus'
  | 'ring-offset-misc-legal-blue'
  | 'ring-offset-misc-neutral'
  | 'ring-offset-misc-yellow-orange'

export type TRingOffsetWidth =
  | 'ring-offset-0'
  | 'ring-offset-1'
  | 'ring-offset-2'
  | 'ring-offset-4'
  | 'ring-offset-8'

export type TBorders =
  | TBorderStyle
  | TDivideStyle
  | TBorderColor
  | TBorderOpacity
  | TBorderRadius
  | TBorderWidth
  | TDivideColor
  | TDivideOpacity
  | TDivideWidth
  | TRingColor
  | TRingWidth
  | TRingOpacity
  | TRingOffsetColor
  | TRingOffsetWidth

export type TBorderCollapse =
  | 'border-collapse'
  | 'border-separate'

export type TTableLayout =
  | 'table-auto'
  | 'table-fixed'

export type TTables =
  | TBorderCollapse
  | TTableLayout

export type TMixBlendMode =
  | 'mix-blend-normal'
  | 'mix-blend-multiply'
  | 'mix-blend-screen'
  | 'mix-blend-overlay'
  | 'mix-blend-darken'
  | 'mix-blend-lighten'
  | 'mix-blend-color-dodge'
  | 'mix-blend-color-burn'
  | 'mix-blend-hard-light'
  | 'mix-blend-soft-light'
  | 'mix-blend-difference'
  | 'mix-blend-exclusion'
  | 'mix-blend-hue'
  | 'mix-blend-saturation'
  | 'mix-blend-color'
  | 'mix-blend-luminosity'

export type TBackgroundBlendMode =
  | 'bg-blend-normal'
  | 'bg-blend-multiply'
  | 'bg-blend-screen'
  | 'bg-blend-overlay'
  | 'bg-blend-darken'
  | 'bg-blend-lighten'
  | 'bg-blend-color-dodge'
  | 'bg-blend-color-burn'
  | 'bg-blend-hard-light'
  | 'bg-blend-soft-light'
  | 'bg-blend-difference'
  | 'bg-blend-exclusion'
  | 'bg-blend-hue'
  | 'bg-blend-saturation'
  | 'bg-blend-color'
  | 'bg-blend-luminosity'

export type TBoxShadow =
  | 'shadow-sm'
  | 'shadow'
  | 'shadow-md'
  | 'shadow-lg'
  | 'shadow-xl'
  | 'shadow-2xl'
  | 'shadow-inner'
  | 'shadow-none'
  | 'shadow-light-product-bar'
  | 'shadow-dark-product-bar'
  | 'shadow-highlight-card'

export type TOpacity =
  | 'opacity-0'
  | 'opacity-5'
  | 'opacity-10'
  | 'opacity-20'
  | 'opacity-25'
  | 'opacity-30'
  | 'opacity-40'
  | 'opacity-50'
  | 'opacity-60'
  | 'opacity-70'
  | 'opacity-75'
  | 'opacity-80'
  | 'opacity-90'
  | 'opacity-95'
  | 'opacity-100'

export type TEffects =
  | TMixBlendMode
  | TBackgroundBlendMode
  | TBoxShadow
  | TOpacity

export type TTransitionProperty =
  | 'transition-none'
  | 'transition-all'
  | 'transition'
  | 'transition-colors'
  | 'transition-opacity'
  | 'transition-shadow'
  | 'transition-transform'
  | 'transition-grid-rows'
  | 'transition-height'
  | 'transition-left'
  | 'transition-visibility'

export type TTransitionDuration =
  | 'duration-75'
  | 'duration-100'
  | 'duration-150'
  | 'duration-200'
  | 'duration-275'
  | 'duration-300'
  | 'duration-400'
  | 'duration-500'
  | 'duration-600'
  | 'duration-700'
  | 'duration-800'
  | 'duration-1000'
  | 'duration'
  | 'duration-debug'

export type TTransitionTimingFunction =
  | 'ease-linear'
  | 'ease-in'
  | 'ease-out'
  | 'ease-in-out'

export type TTransitionDelay =
  | 'delay-75'
  | 'delay-100'
  | 'delay-150'
  | 'delay-200'
  | 'delay-300'
  | 'delay-500'
  | 'delay-700'
  | 'delay-1000'

export type TAnimation =
  | 'animate-none'
  | 'animate-spin'
  | 'animate-ping'
  | 'animate-pulse'
  | 'animate-bounce'
  | 'animate-fade-in'
  | 'animate-fade-out'
  | 'animate-marquee-ltr'
  | 'animate-marquee-rtl'
  | 'animate-ripple-fast'
  | 'animate-ripple-slow'

export type TTransitionsAndAnimations =
  | TTransitionProperty
  | TTransitionDuration
  | TTransitionTimingFunction
  | TTransitionDelay
  | TAnimation

export type TFilter =
  | 'filter'
  | 'filter-none'

export type TBackdropFilter =
  | 'backdrop-filter'
  | 'backdrop-filter-none'

export type TBlur =
  | 'blur-0'
  | 'blur-none'
  | 'blur-sm'
  | 'blur'
  | 'blur-md'
  | 'blur-lg'
  | 'blur-xl'
  | 'blur-2xl'
  | 'blur-3xl'

export type TBrightness =
  | 'brightness-0'
  | 'brightness-50'
  | 'brightness-75'
  | 'brightness-90'
  | 'brightness-95'
  | 'brightness-100'
  | 'brightness-105'
  | 'brightness-110'
  | 'brightness-125'
  | 'brightness-150'
  | 'brightness-200'

export type TContrast =
  | 'contrast-0'
  | 'contrast-50'
  | 'contrast-75'
  | 'contrast-100'
  | 'contrast-125'
  | 'contrast-150'
  | 'contrast-200'

export type TDropShadow =
  | 'drop-shadow-sm'
  | 'drop-shadow'
  | 'drop-shadow-md'
  | 'drop-shadow-lg'
  | 'drop-shadow-xl'
  | 'drop-shadow-2xl'
  | 'drop-shadow-none'

export type TGrayscale =
  | 'grayscale-0'
  | 'grayscale'

export type THueRotate =
  | 'hue-rotate-0'
  | 'hue-rotate-15'
  | 'hue-rotate-30'
  | 'hue-rotate-60'
  | 'hue-rotate-90'
  | 'hue-rotate-180'
  | '-hue-rotate-180'
  | '-hue-rotate-90'
  | '-hue-rotate-60'
  | '-hue-rotate-30'
  | '-hue-rotate-15'

export type TInvert =
  | 'invert-0'
  | 'invert'

export type TSaturate =
  | 'saturate-0'
  | 'saturate-50'
  | 'saturate-100'
  | 'saturate-150'
  | 'saturate-200'

export type TSepia =
  | 'sepia-0'
  | 'sepia'

export type TBackdropBlur =
  | 'backdrop-blur-0'
  | 'backdrop-blur-none'
  | 'backdrop-blur-sm'
  | 'backdrop-blur'
  | 'backdrop-blur-md'
  | 'backdrop-blur-lg'
  | 'backdrop-blur-xl'
  | 'backdrop-blur-2xl'
  | 'backdrop-blur-3xl'

export type TBackdropBrightness =
  | 'backdrop-brightness-0'
  | 'backdrop-brightness-50'
  | 'backdrop-brightness-75'
  | 'backdrop-brightness-90'
  | 'backdrop-brightness-95'
  | 'backdrop-brightness-100'
  | 'backdrop-brightness-105'
  | 'backdrop-brightness-110'
  | 'backdrop-brightness-125'
  | 'backdrop-brightness-150'
  | 'backdrop-brightness-200'

export type TBackdropContrast =
  | 'backdrop-contrast-0'
  | 'backdrop-contrast-50'
  | 'backdrop-contrast-75'
  | 'backdrop-contrast-100'
  | 'backdrop-contrast-125'
  | 'backdrop-contrast-150'
  | 'backdrop-contrast-200'

export type TBackdropGrayscale =
  | 'backdrop-grayscale-0'
  | 'backdrop-grayscale'

export type TBackdropHueRotate =
  | 'backdrop-hue-rotate-0'
  | 'backdrop-hue-rotate-15'
  | 'backdrop-hue-rotate-30'
  | 'backdrop-hue-rotate-60'
  | 'backdrop-hue-rotate-90'
  | 'backdrop-hue-rotate-180'
  | '-backdrop-hue-rotate-180'
  | '-backdrop-hue-rotate-90'
  | '-backdrop-hue-rotate-60'
  | '-backdrop-hue-rotate-30'
  | '-backdrop-hue-rotate-15'

export type TBackdropInvert =
  | 'backdrop-invert-0'
  | 'backdrop-invert'

export type TBackdropOpacity =
  | 'backdrop-opacity-0'
  | 'backdrop-opacity-5'
  | 'backdrop-opacity-10'
  | 'backdrop-opacity-20'
  | 'backdrop-opacity-25'
  | 'backdrop-opacity-30'
  | 'backdrop-opacity-40'
  | 'backdrop-opacity-50'
  | 'backdrop-opacity-60'
  | 'backdrop-opacity-70'
  | 'backdrop-opacity-75'
  | 'backdrop-opacity-80'
  | 'backdrop-opacity-90'
  | 'backdrop-opacity-95'
  | 'backdrop-opacity-100'

export type TBackdropSaturate =
  | 'backdrop-saturate-0'
  | 'backdrop-saturate-50'
  | 'backdrop-saturate-100'
  | 'backdrop-saturate-150'
  | 'backdrop-saturate-200'

export type TBackdropSepia =
  | 'backdrop-sepia-0'
  | 'backdrop-sepia'

export type TFilters =
  | TFilter
  | TBackdropFilter
  | TBlur
  | TBrightness
  | TContrast
  | TDropShadow
  | TGrayscale
  | THueRotate
  | TInvert
  | TSaturate
  | TSepia
  | TBackdropBlur
  | TBackdropBrightness
  | TBackdropContrast
  | TBackdropGrayscale
  | TBackdropHueRotate
  | TBackdropInvert
  | TBackdropOpacity
  | TBackdropSaturate
  | TBackdropSepia

export type TFlexDirection =
  | 'flex-row'
  | 'flex-row-reverse'
  | 'flex-col'
  | 'flex-col-reverse'

export type TFlexWrap =
  | 'flex-nowrap'
  | 'flex-wrap'
  | 'flex-wrap-reverse'

export type TAlignItems =
  | 'items-stretch'
  | 'items-start'
  | 'items-center'
  | 'items-end'
  | 'items-baseline'

export type TAlignContent =
  | 'content-start'
  | 'content-center'
  | 'content-end'
  | 'content-between'
  | 'content-around'

export type TAlignSelf =
  | 'self-auto'
  | 'self-start'
  | 'self-center'
  | 'self-end'
  | 'self-stretch'
  | 'self-baseline'

export type TPlaceContent =
  | 'place-content-start'
  | 'place-content-center'
  | 'place-content-end'
  | 'place-content-between'
  | 'place-content-around'
  | 'place-content-evenly'
  | 'place-content-stretch'

export type TPlaceItems =
  | 'place-items-auto'
  | 'place-items-start'
  | 'place-items-center'
  | 'place-items-end'
  | 'place-items-stretch'

export type TPlaceSelf =
  | 'place-self-auto'
  | 'place-self-start'
  | 'place-self-center'
  | 'place-self-end'
  | 'place-self-stretch'

export type TJustifyContent =
  | 'justify-start'
  | 'justify-center'
  | 'justify-end'
  | 'justify-between'
  | 'justify-around'
  | 'justify-evenly'

export type TJustifyItems =
  | 'justify-items-auto'
  | 'justify-items-start'
  | 'justify-items-center'
  | 'justify-items-end'
  | 'justify-items-stretch'

export type TJustifySelf =
  | 'justify-self-auto'
  | 'justify-self-start'
  | 'justify-self-center'
  | 'justify-self-end'
  | 'justify-self-stretch'

export type TFlex =
  | 'flex-initial'
  | 'flex-1'
  | 'flex-auto'
  | 'flex-none'

export type TFlexGrow =
  | 'flex-grow-0'
  | 'flex-grow'

export type TFlexShrink =
  | 'flex-shrink-0'
  | 'flex-shrink'
  | 'flex-shrink-1/2'

export type TOrder =
  | 'order-1'
  | 'order-2'
  | 'order-3'
  | 'order-4'
  | 'order-5'
  | 'order-6'
  | 'order-7'
  | 'order-8'
  | 'order-9'
  | 'order-10'
  | 'order-11'
  | 'order-12'
  | 'order-first'
  | 'order-last'
  | 'order-none'

export type TFlexBox =
  | TFlexDirection
  | TFlexWrap
  | TAlignItems
  | TAlignContent
  | TAlignSelf
  | TPlaceContent
  | TPlaceItems
  | TPlaceSelf
  | TJustifyContent
  | TJustifyItems
  | TJustifySelf
  | TFlex
  | TFlexGrow
  | TFlexShrink
  | TOrder

export type TGridAutoFlow =
  | 'grid-flow-row'
  | 'grid-flow-col'
  | 'grid-flow-row-dense'
  | 'grid-flow-col-dense'

export type TGridTemplateColumns =
  | 'grid-cols-1'
  | 'grid-cols-2'
  | 'grid-cols-3'
  | 'grid-cols-4'
  | 'grid-cols-5'
  | 'grid-cols-6'
  | 'grid-cols-7'
  | 'grid-cols-8'
  | 'grid-cols-9'
  | 'grid-cols-10'
  | 'grid-cols-11'
  | 'grid-cols-12'
  | 'grid-cols-none'

export type TGridAutoColumns =
  | 'auto-cols-auto'
  | 'auto-cols-min'
  | 'auto-cols-max'
  | 'auto-cols-fr'

export type TGridColumn =
  | 'col-auto'
  | 'col-span-1'
  | 'col-span-2'
  | 'col-span-3'
  | 'col-span-4'
  | 'col-span-5'
  | 'col-span-6'
  | 'col-span-7'
  | 'col-span-8'
  | 'col-span-9'
  | 'col-span-10'
  | 'col-span-11'
  | 'col-span-12'
  | 'col-span-full'

export type TGridColumnStart =
  | 'col-start-1'
  | 'col-start-2'
  | 'col-start-3'
  | 'col-start-4'
  | 'col-start-5'
  | 'col-start-6'
  | 'col-start-7'
  | 'col-start-8'
  | 'col-start-9'
  | 'col-start-10'
  | 'col-start-11'
  | 'col-start-12'
  | 'col-start-13'
  | 'col-start-auto'

export type TGridColumnEnd =
  | 'col-end-1'
  | 'col-end-2'
  | 'col-end-3'
  | 'col-end-4'
  | 'col-end-5'
  | 'col-end-6'
  | 'col-end-7'
  | 'col-end-8'
  | 'col-end-9'
  | 'col-end-10'
  | 'col-end-11'
  | 'col-end-12'
  | 'col-end-13'
  | 'col-end-auto'

export type TGridTemplateRows =
  | 'grid-rows-1'
  | 'grid-rows-2'
  | 'grid-rows-3'
  | 'grid-rows-4'
  | 'grid-rows-5'
  | 'grid-rows-6'
  | 'grid-rows-none'
  | 'grid-rows-collapse'
  | 'grid-rows-expand'

export type TGridAutoRows =
  | 'auto-rows-auto'
  | 'auto-rows-min'
  | 'auto-rows-max'
  | 'auto-rows-fr'

export type TGridRow =
  | 'row-auto'
  | 'row-span-1'
  | 'row-span-2'
  | 'row-span-3'
  | 'row-span-4'
  | 'row-span-5'
  | 'row-span-6'
  | 'row-span-full'

export type TGridRowStart =
  | 'row-start-1'
  | 'row-start-2'
  | 'row-start-3'
  | 'row-start-4'
  | 'row-start-5'
  | 'row-start-6'
  | 'row-start-7'
  | 'row-start-auto'

export type TGridRowEnd =
  | 'row-end-1'
  | 'row-end-2'
  | 'row-end-3'
  | 'row-end-4'
  | 'row-end-5'
  | 'row-end-6'
  | 'row-end-7'
  | 'row-end-auto'

export type TGap =
  | 'gap-0'
  | 'gap-1'
  | 'gap-2'
  | 'gap-3'
  | 'gap-4'
  | 'gap-5'
  | 'gap-6'
  | 'gap-7'
  | 'gap-8'
  | 'gap-9'
  | 'gap-10'
  | 'gap-11'
  | 'gap-12'
  | 'gap-14'
  | 'gap-15'
  | 'gap-16'
  | 'gap-17'
  | 'gap-18'
  | 'gap-20'
  | 'gap-21'
  | 'gap-22'
  | 'gap-24'
  | 'gap-28'
  | 'gap-30'
  | 'gap-32'
  | 'gap-36'
  | 'gap-40'
  | 'gap-44'
  | 'gap-48'
  | 'gap-52'
  | 'gap-56'
  | 'gap-60'
  | 'gap-64'
  | 'gap-72'
  | 'gap-80'
  | 'gap-96'
  | 'gap-px'
  | 'gap-0.5'
  | 'gap-1.5'
  | 'gap-2.5'
  | 'gap-3.5'
  | 'gap-1/2'
  | 'gap-full'
  | 'gap-4.5'
  | 'gap-7.5'
  | 'gap-9.5'
  | 'gap-11.5'
  | 'gap-y-0'
  | 'gap-y-1'
  | 'gap-y-2'
  | 'gap-y-3'
  | 'gap-y-4'
  | 'gap-y-5'
  | 'gap-y-6'
  | 'gap-y-7'
  | 'gap-y-8'
  | 'gap-y-9'
  | 'gap-y-10'
  | 'gap-y-11'
  | 'gap-y-12'
  | 'gap-y-14'
  | 'gap-y-15'
  | 'gap-y-16'
  | 'gap-y-17'
  | 'gap-y-18'
  | 'gap-y-20'
  | 'gap-y-21'
  | 'gap-y-22'
  | 'gap-y-24'
  | 'gap-y-28'
  | 'gap-y-30'
  | 'gap-y-32'
  | 'gap-y-36'
  | 'gap-y-40'
  | 'gap-y-44'
  | 'gap-y-48'
  | 'gap-y-52'
  | 'gap-y-56'
  | 'gap-y-60'
  | 'gap-y-64'
  | 'gap-y-72'
  | 'gap-y-80'
  | 'gap-y-96'
  | 'gap-y-px'
  | 'gap-y-0.5'
  | 'gap-y-1.5'
  | 'gap-y-2.5'
  | 'gap-y-3.5'
  | 'gap-y-1/2'
  | 'gap-y-full'
  | 'gap-y-4.5'
  | 'gap-y-7.5'
  | 'gap-y-9.5'
  | 'gap-y-11.5'
  | 'gap-x-0'
  | 'gap-x-1'
  | 'gap-x-2'
  | 'gap-x-3'
  | 'gap-x-4'
  | 'gap-x-5'
  | 'gap-x-6'
  | 'gap-x-7'
  | 'gap-x-8'
  | 'gap-x-9'
  | 'gap-x-10'
  | 'gap-x-11'
  | 'gap-x-12'
  | 'gap-x-14'
  | 'gap-x-15'
  | 'gap-x-16'
  | 'gap-x-17'
  | 'gap-x-18'
  | 'gap-x-20'
  | 'gap-x-21'
  | 'gap-x-22'
  | 'gap-x-24'
  | 'gap-x-28'
  | 'gap-x-30'
  | 'gap-x-32'
  | 'gap-x-36'
  | 'gap-x-40'
  | 'gap-x-44'
  | 'gap-x-48'
  | 'gap-x-52'
  | 'gap-x-56'
  | 'gap-x-60'
  | 'gap-x-64'
  | 'gap-x-72'
  | 'gap-x-80'
  | 'gap-x-96'
  | 'gap-x-px'
  | 'gap-x-0.5'
  | 'gap-x-1.5'
  | 'gap-x-2.5'
  | 'gap-x-3.5'
  | 'gap-x-1/2'
  | 'gap-x-full'
  | 'gap-x-4.5'
  | 'gap-x-7.5'
  | 'gap-x-9.5'
  | 'gap-x-11.5'

export type TGrid =
  | TGridAutoFlow
  | TGridTemplateColumns
  | TGridAutoColumns
  | TGridColumn
  | TGridColumnStart
  | TGridColumnEnd
  | TGridTemplateRows
  | TGridAutoRows
  | TGridRow
  | TGridRowStart
  | TGridRowEnd
  | TGap

export type TPadding =
  | 'p-0'
  | 'p-1'
  | 'p-2'
  | 'p-3'
  | 'p-4'
  | 'p-5'
  | 'p-6'
  | 'p-7'
  | 'p-8'
  | 'p-9'
  | 'p-10'
  | 'p-11'
  | 'p-12'
  | 'p-14'
  | 'p-15'
  | 'p-16'
  | 'p-17'
  | 'p-18'
  | 'p-20'
  | 'p-21'
  | 'p-22'
  | 'p-24'
  | 'p-28'
  | 'p-30'
  | 'p-32'
  | 'p-36'
  | 'p-40'
  | 'p-44'
  | 'p-48'
  | 'p-52'
  | 'p-56'
  | 'p-60'
  | 'p-64'
  | 'p-72'
  | 'p-80'
  | 'p-96'
  | 'p-px'
  | 'p-0.5'
  | 'p-1.5'
  | 'p-2.5'
  | 'p-3.5'
  | 'p-1/2'
  | 'p-full'
  | 'p-4.5'
  | 'p-7.5'
  | 'p-9.5'
  | 'p-11.5'
  | 'py-0'
  | 'py-1'
  | 'py-2'
  | 'py-3'
  | 'py-4'
  | 'py-5'
  | 'py-6'
  | 'py-7'
  | 'py-8'
  | 'py-9'
  | 'py-10'
  | 'py-11'
  | 'py-12'
  | 'py-14'
  | 'py-15'
  | 'py-16'
  | 'py-17'
  | 'py-18'
  | 'py-20'
  | 'py-21'
  | 'py-22'
  | 'py-24'
  | 'py-28'
  | 'py-30'
  | 'py-32'
  | 'py-36'
  | 'py-40'
  | 'py-44'
  | 'py-48'
  | 'py-52'
  | 'py-56'
  | 'py-60'
  | 'py-64'
  | 'py-72'
  | 'py-80'
  | 'py-96'
  | 'py-px'
  | 'py-0.5'
  | 'py-1.5'
  | 'py-2.5'
  | 'py-3.5'
  | 'py-1/2'
  | 'py-full'
  | 'py-4.5'
  | 'py-7.5'
  | 'py-9.5'
  | 'py-11.5'
  | 'px-0'
  | 'px-1'
  | 'px-2'
  | 'px-3'
  | 'px-4'
  | 'px-5'
  | 'px-6'
  | 'px-7'
  | 'px-8'
  | 'px-9'
  | 'px-10'
  | 'px-11'
  | 'px-12'
  | 'px-14'
  | 'px-15'
  | 'px-16'
  | 'px-17'
  | 'px-18'
  | 'px-20'
  | 'px-21'
  | 'px-22'
  | 'px-24'
  | 'px-28'
  | 'px-30'
  | 'px-32'
  | 'px-36'
  | 'px-40'
  | 'px-44'
  | 'px-48'
  | 'px-52'
  | 'px-56'
  | 'px-60'
  | 'px-64'
  | 'px-72'
  | 'px-80'
  | 'px-96'
  | 'px-px'
  | 'px-0.5'
  | 'px-1.5'
  | 'px-2.5'
  | 'px-3.5'
  | 'px-1/2'
  | 'px-full'
  | 'px-4.5'
  | 'px-7.5'
  | 'px-9.5'
  | 'px-11.5'
  | 'pt-0'
  | 'pt-1'
  | 'pt-2'
  | 'pt-3'
  | 'pt-4'
  | 'pt-5'
  | 'pt-6'
  | 'pt-7'
  | 'pt-8'
  | 'pt-9'
  | 'pt-10'
  | 'pt-11'
  | 'pt-12'
  | 'pt-14'
  | 'pt-15'
  | 'pt-16'
  | 'pt-17'
  | 'pt-18'
  | 'pt-20'
  | 'pt-21'
  | 'pt-22'
  | 'pt-24'
  | 'pt-28'
  | 'pt-30'
  | 'pt-32'
  | 'pt-36'
  | 'pt-40'
  | 'pt-44'
  | 'pt-48'
  | 'pt-52'
  | 'pt-56'
  | 'pt-60'
  | 'pt-64'
  | 'pt-72'
  | 'pt-80'
  | 'pt-96'
  | 'pt-px'
  | 'pt-0.5'
  | 'pt-1.5'
  | 'pt-2.5'
  | 'pt-3.5'
  | 'pt-1/2'
  | 'pt-full'
  | 'pt-4.5'
  | 'pt-7.5'
  | 'pt-9.5'
  | 'pt-11.5'
  | 'pr-0'
  | 'pr-1'
  | 'pr-2'
  | 'pr-3'
  | 'pr-4'
  | 'pr-5'
  | 'pr-6'
  | 'pr-7'
  | 'pr-8'
  | 'pr-9'
  | 'pr-10'
  | 'pr-11'
  | 'pr-12'
  | 'pr-14'
  | 'pr-15'
  | 'pr-16'
  | 'pr-17'
  | 'pr-18'
  | 'pr-20'
  | 'pr-21'
  | 'pr-22'
  | 'pr-24'
  | 'pr-28'
  | 'pr-30'
  | 'pr-32'
  | 'pr-36'
  | 'pr-40'
  | 'pr-44'
  | 'pr-48'
  | 'pr-52'
  | 'pr-56'
  | 'pr-60'
  | 'pr-64'
  | 'pr-72'
  | 'pr-80'
  | 'pr-96'
  | 'pr-px'
  | 'pr-0.5'
  | 'pr-1.5'
  | 'pr-2.5'
  | 'pr-3.5'
  | 'pr-1/2'
  | 'pr-full'
  | 'pr-4.5'
  | 'pr-7.5'
  | 'pr-9.5'
  | 'pr-11.5'
  | 'pb-0'
  | 'pb-1'
  | 'pb-2'
  | 'pb-3'
  | 'pb-4'
  | 'pb-5'
  | 'pb-6'
  | 'pb-7'
  | 'pb-8'
  | 'pb-9'
  | 'pb-10'
  | 'pb-11'
  | 'pb-12'
  | 'pb-14'
  | 'pb-15'
  | 'pb-16'
  | 'pb-17'
  | 'pb-18'
  | 'pb-20'
  | 'pb-21'
  | 'pb-22'
  | 'pb-24'
  | 'pb-28'
  | 'pb-30'
  | 'pb-32'
  | 'pb-36'
  | 'pb-40'
  | 'pb-44'
  | 'pb-48'
  | 'pb-52'
  | 'pb-56'
  | 'pb-60'
  | 'pb-64'
  | 'pb-72'
  | 'pb-80'
  | 'pb-96'
  | 'pb-px'
  | 'pb-0.5'
  | 'pb-1.5'
  | 'pb-2.5'
  | 'pb-3.5'
  | 'pb-1/2'
  | 'pb-full'
  | 'pb-4.5'
  | 'pb-7.5'
  | 'pb-9.5'
  | 'pb-11.5'
  | 'pl-0'
  | 'pl-1'
  | 'pl-2'
  | 'pl-3'
  | 'pl-4'
  | 'pl-5'
  | 'pl-6'
  | 'pl-7'
  | 'pl-8'
  | 'pl-9'
  | 'pl-10'
  | 'pl-11'
  | 'pl-12'
  | 'pl-14'
  | 'pl-15'
  | 'pl-16'
  | 'pl-17'
  | 'pl-18'
  | 'pl-20'
  | 'pl-21'
  | 'pl-22'
  | 'pl-24'
  | 'pl-28'
  | 'pl-30'
  | 'pl-32'
  | 'pl-36'
  | 'pl-40'
  | 'pl-44'
  | 'pl-48'
  | 'pl-52'
  | 'pl-56'
  | 'pl-60'
  | 'pl-64'
  | 'pl-72'
  | 'pl-80'
  | 'pl-96'
  | 'pl-px'
  | 'pl-0.5'
  | 'pl-1.5'
  | 'pl-2.5'
  | 'pl-3.5'
  | 'pl-1/2'
  | 'pl-full'
  | 'pl-4.5'
  | 'pl-7.5'
  | 'pl-9.5'
  | 'pl-11.5'

export type TMargin =
  | 'm-0'
  | 'm-1'
  | 'm-2'
  | 'm-3'
  | 'm-4'
  | 'm-5'
  | 'm-6'
  | 'm-7'
  | 'm-8'
  | 'm-9'
  | 'm-10'
  | 'm-11'
  | 'm-12'
  | 'm-14'
  | 'm-15'
  | 'm-16'
  | 'm-17'
  | 'm-18'
  | 'm-20'
  | 'm-21'
  | 'm-22'
  | 'm-24'
  | 'm-28'
  | 'm-30'
  | 'm-32'
  | 'm-36'
  | 'm-40'
  | 'm-44'
  | 'm-48'
  | 'm-52'
  | 'm-56'
  | 'm-60'
  | 'm-64'
  | 'm-72'
  | 'm-80'
  | 'm-96'
  | 'm-auto'
  | 'm-px'
  | 'm-0.5'
  | 'm-1.5'
  | 'm-2.5'
  | 'm-3.5'
  | '-m-0'
  | '-m-1'
  | '-m-2'
  | '-m-3'
  | '-m-4'
  | '-m-5'
  | '-m-6'
  | '-m-7'
  | '-m-8'
  | '-m-9'
  | '-m-10'
  | '-m-11'
  | '-m-12'
  | '-m-14'
  | '-m-16'
  | '-m-20'
  | '-m-24'
  | '-m-28'
  | '-m-32'
  | '-m-36'
  | '-m-40'
  | '-m-44'
  | '-m-48'
  | '-m-52'
  | '-m-56'
  | '-m-60'
  | '-m-64'
  | '-m-72'
  | '-m-80'
  | '-m-96'
  | '-m-px'
  | '-m-0.5'
  | '-m-1.5'
  | '-m-2.5'
  | '-m-3.5'
  | 'm-1/2'
  | 'm-full'
  | 'm-4.5'
  | 'm-7.5'
  | 'm-9.5'
  | 'm-11.5'
  | '-m-15'
  | '-m-17'
  | '-m-18'
  | '-m-21'
  | '-m-22'
  | '-m-30'
  | '-m-1/2'
  | '-m-full'
  | '-m-4.5'
  | '-m-7.5'
  | '-m-9.5'
  | '-m-11.5'
  | 'my-0'
  | 'my-1'
  | 'my-2'
  | 'my-3'
  | 'my-4'
  | 'my-5'
  | 'my-6'
  | 'my-7'
  | 'my-8'
  | 'my-9'
  | 'my-10'
  | 'my-11'
  | 'my-12'
  | 'my-14'
  | 'my-15'
  | 'my-16'
  | 'my-17'
  | 'my-18'
  | 'my-20'
  | 'my-21'
  | 'my-22'
  | 'my-24'
  | 'my-28'
  | 'my-30'
  | 'my-32'
  | 'my-36'
  | 'my-40'
  | 'my-44'
  | 'my-48'
  | 'my-52'
  | 'my-56'
  | 'my-60'
  | 'my-64'
  | 'my-72'
  | 'my-80'
  | 'my-96'
  | 'my-auto'
  | 'my-px'
  | 'my-0.5'
  | 'my-1.5'
  | 'my-2.5'
  | 'my-3.5'
  | '-my-0'
  | '-my-1'
  | '-my-2'
  | '-my-3'
  | '-my-4'
  | '-my-5'
  | '-my-6'
  | '-my-7'
  | '-my-8'
  | '-my-9'
  | '-my-10'
  | '-my-11'
  | '-my-12'
  | '-my-14'
  | '-my-16'
  | '-my-20'
  | '-my-24'
  | '-my-28'
  | '-my-32'
  | '-my-36'
  | '-my-40'
  | '-my-44'
  | '-my-48'
  | '-my-52'
  | '-my-56'
  | '-my-60'
  | '-my-64'
  | '-my-72'
  | '-my-80'
  | '-my-96'
  | '-my-px'
  | '-my-0.5'
  | '-my-1.5'
  | '-my-2.5'
  | '-my-3.5'
  | 'my-1/2'
  | 'my-full'
  | 'my-4.5'
  | 'my-7.5'
  | 'my-9.5'
  | 'my-11.5'
  | '-my-15'
  | '-my-17'
  | '-my-18'
  | '-my-21'
  | '-my-22'
  | '-my-30'
  | '-my-1/2'
  | '-my-full'
  | '-my-4.5'
  | '-my-7.5'
  | '-my-9.5'
  | '-my-11.5'
  | 'mx-0'
  | 'mx-1'
  | 'mx-2'
  | 'mx-3'
  | 'mx-4'
  | 'mx-5'
  | 'mx-6'
  | 'mx-7'
  | 'mx-8'
  | 'mx-9'
  | 'mx-10'
  | 'mx-11'
  | 'mx-12'
  | 'mx-14'
  | 'mx-15'
  | 'mx-16'
  | 'mx-17'
  | 'mx-18'
  | 'mx-20'
  | 'mx-21'
  | 'mx-22'
  | 'mx-24'
  | 'mx-28'
  | 'mx-30'
  | 'mx-32'
  | 'mx-36'
  | 'mx-40'
  | 'mx-44'
  | 'mx-48'
  | 'mx-52'
  | 'mx-56'
  | 'mx-60'
  | 'mx-64'
  | 'mx-72'
  | 'mx-80'
  | 'mx-96'
  | 'mx-auto'
  | 'mx-px'
  | 'mx-0.5'
  | 'mx-1.5'
  | 'mx-2.5'
  | 'mx-3.5'
  | '-mx-0'
  | '-mx-1'
  | '-mx-2'
  | '-mx-3'
  | '-mx-4'
  | '-mx-5'
  | '-mx-6'
  | '-mx-7'
  | '-mx-8'
  | '-mx-9'
  | '-mx-10'
  | '-mx-11'
  | '-mx-12'
  | '-mx-14'
  | '-mx-16'
  | '-mx-20'
  | '-mx-24'
  | '-mx-28'
  | '-mx-32'
  | '-mx-36'
  | '-mx-40'
  | '-mx-44'
  | '-mx-48'
  | '-mx-52'
  | '-mx-56'
  | '-mx-60'
  | '-mx-64'
  | '-mx-72'
  | '-mx-80'
  | '-mx-96'
  | '-mx-px'
  | '-mx-0.5'
  | '-mx-1.5'
  | '-mx-2.5'
  | '-mx-3.5'
  | 'mx-1/2'
  | 'mx-full'
  | 'mx-4.5'
  | 'mx-7.5'
  | 'mx-9.5'
  | 'mx-11.5'
  | '-mx-15'
  | '-mx-17'
  | '-mx-18'
  | '-mx-21'
  | '-mx-22'
  | '-mx-30'
  | '-mx-1/2'
  | '-mx-full'
  | '-mx-4.5'
  | '-mx-7.5'
  | '-mx-9.5'
  | '-mx-11.5'
  | 'mt-0'
  | 'mt-1'
  | 'mt-2'
  | 'mt-3'
  | 'mt-4'
  | 'mt-5'
  | 'mt-6'
  | 'mt-7'
  | 'mt-8'
  | 'mt-9'
  | 'mt-10'
  | 'mt-11'
  | 'mt-12'
  | 'mt-14'
  | 'mt-15'
  | 'mt-16'
  | 'mt-17'
  | 'mt-18'
  | 'mt-20'
  | 'mt-21'
  | 'mt-22'
  | 'mt-24'
  | 'mt-28'
  | 'mt-30'
  | 'mt-32'
  | 'mt-36'
  | 'mt-40'
  | 'mt-44'
  | 'mt-48'
  | 'mt-52'
  | 'mt-56'
  | 'mt-60'
  | 'mt-64'
  | 'mt-72'
  | 'mt-80'
  | 'mt-96'
  | 'mt-auto'
  | 'mt-px'
  | 'mt-0.5'
  | 'mt-1.5'
  | 'mt-2.5'
  | 'mt-3.5'
  | '-mt-0'
  | '-mt-1'
  | '-mt-2'
  | '-mt-3'
  | '-mt-4'
  | '-mt-5'
  | '-mt-6'
  | '-mt-7'
  | '-mt-8'
  | '-mt-9'
  | '-mt-10'
  | '-mt-11'
  | '-mt-12'
  | '-mt-14'
  | '-mt-16'
  | '-mt-20'
  | '-mt-24'
  | '-mt-28'
  | '-mt-32'
  | '-mt-36'
  | '-mt-40'
  | '-mt-44'
  | '-mt-48'
  | '-mt-52'
  | '-mt-56'
  | '-mt-60'
  | '-mt-64'
  | '-mt-72'
  | '-mt-80'
  | '-mt-96'
  | '-mt-px'
  | '-mt-0.5'
  | '-mt-1.5'
  | '-mt-2.5'
  | '-mt-3.5'
  | 'mt-1/2'
  | 'mt-full'
  | 'mt-4.5'
  | 'mt-7.5'
  | 'mt-9.5'
  | 'mt-11.5'
  | '-mt-15'
  | '-mt-17'
  | '-mt-18'
  | '-mt-21'
  | '-mt-22'
  | '-mt-30'
  | '-mt-1/2'
  | '-mt-full'
  | '-mt-4.5'
  | '-mt-7.5'
  | '-mt-9.5'
  | '-mt-11.5'
  | 'mr-0'
  | 'mr-1'
  | 'mr-2'
  | 'mr-3'
  | 'mr-4'
  | 'mr-5'
  | 'mr-6'
  | 'mr-7'
  | 'mr-8'
  | 'mr-9'
  | 'mr-10'
  | 'mr-11'
  | 'mr-12'
  | 'mr-14'
  | 'mr-15'
  | 'mr-16'
  | 'mr-17'
  | 'mr-18'
  | 'mr-20'
  | 'mr-21'
  | 'mr-22'
  | 'mr-24'
  | 'mr-28'
  | 'mr-30'
  | 'mr-32'
  | 'mr-36'
  | 'mr-40'
  | 'mr-44'
  | 'mr-48'
  | 'mr-52'
  | 'mr-56'
  | 'mr-60'
  | 'mr-64'
  | 'mr-72'
  | 'mr-80'
  | 'mr-96'
  | 'mr-auto'
  | 'mr-px'
  | 'mr-0.5'
  | 'mr-1.5'
  | 'mr-2.5'
  | 'mr-3.5'
  | '-mr-0'
  | '-mr-1'
  | '-mr-2'
  | '-mr-3'
  | '-mr-4'
  | '-mr-5'
  | '-mr-6'
  | '-mr-7'
  | '-mr-8'
  | '-mr-9'
  | '-mr-10'
  | '-mr-11'
  | '-mr-12'
  | '-mr-14'
  | '-mr-16'
  | '-mr-20'
  | '-mr-24'
  | '-mr-28'
  | '-mr-32'
  | '-mr-36'
  | '-mr-40'
  | '-mr-44'
  | '-mr-48'
  | '-mr-52'
  | '-mr-56'
  | '-mr-60'
  | '-mr-64'
  | '-mr-72'
  | '-mr-80'
  | '-mr-96'
  | '-mr-px'
  | '-mr-0.5'
  | '-mr-1.5'
  | '-mr-2.5'
  | '-mr-3.5'
  | 'mr-1/2'
  | 'mr-full'
  | 'mr-4.5'
  | 'mr-7.5'
  | 'mr-9.5'
  | 'mr-11.5'
  | '-mr-15'
  | '-mr-17'
  | '-mr-18'
  | '-mr-21'
  | '-mr-22'
  | '-mr-30'
  | '-mr-1/2'
  | '-mr-full'
  | '-mr-4.5'
  | '-mr-7.5'
  | '-mr-9.5'
  | '-mr-11.5'
  | 'mb-0'
  | 'mb-1'
  | 'mb-2'
  | 'mb-3'
  | 'mb-4'
  | 'mb-5'
  | 'mb-6'
  | 'mb-7'
  | 'mb-8'
  | 'mb-9'
  | 'mb-10'
  | 'mb-11'
  | 'mb-12'
  | 'mb-14'
  | 'mb-15'
  | 'mb-16'
  | 'mb-17'
  | 'mb-18'
  | 'mb-20'
  | 'mb-21'
  | 'mb-22'
  | 'mb-24'
  | 'mb-28'
  | 'mb-30'
  | 'mb-32'
  | 'mb-36'
  | 'mb-40'
  | 'mb-44'
  | 'mb-48'
  | 'mb-52'
  | 'mb-56'
  | 'mb-60'
  | 'mb-64'
  | 'mb-72'
  | 'mb-80'
  | 'mb-96'
  | 'mb-auto'
  | 'mb-px'
  | 'mb-0.5'
  | 'mb-1.5'
  | 'mb-2.5'
  | 'mb-3.5'
  | '-mb-0'
  | '-mb-1'
  | '-mb-2'
  | '-mb-3'
  | '-mb-4'
  | '-mb-5'
  | '-mb-6'
  | '-mb-7'
  | '-mb-8'
  | '-mb-9'
  | '-mb-10'
  | '-mb-11'
  | '-mb-12'
  | '-mb-14'
  | '-mb-16'
  | '-mb-20'
  | '-mb-24'
  | '-mb-28'
  | '-mb-32'
  | '-mb-36'
  | '-mb-40'
  | '-mb-44'
  | '-mb-48'
  | '-mb-52'
  | '-mb-56'
  | '-mb-60'
  | '-mb-64'
  | '-mb-72'
  | '-mb-80'
  | '-mb-96'
  | '-mb-px'
  | '-mb-0.5'
  | '-mb-1.5'
  | '-mb-2.5'
  | '-mb-3.5'
  | 'mb-1/2'
  | 'mb-full'
  | 'mb-4.5'
  | 'mb-7.5'
  | 'mb-9.5'
  | 'mb-11.5'
  | '-mb-15'
  | '-mb-17'
  | '-mb-18'
  | '-mb-21'
  | '-mb-22'
  | '-mb-30'
  | '-mb-1/2'
  | '-mb-full'
  | '-mb-4.5'
  | '-mb-7.5'
  | '-mb-9.5'
  | '-mb-11.5'
  | 'ml-0'
  | 'ml-1'
  | 'ml-2'
  | 'ml-3'
  | 'ml-4'
  | 'ml-5'
  | 'ml-6'
  | 'ml-7'
  | 'ml-8'
  | 'ml-9'
  | 'ml-10'
  | 'ml-11'
  | 'ml-12'
  | 'ml-14'
  | 'ml-15'
  | 'ml-16'
  | 'ml-17'
  | 'ml-18'
  | 'ml-20'
  | 'ml-21'
  | 'ml-22'
  | 'ml-24'
  | 'ml-28'
  | 'ml-30'
  | 'ml-32'
  | 'ml-36'
  | 'ml-40'
  | 'ml-44'
  | 'ml-48'
  | 'ml-52'
  | 'ml-56'
  | 'ml-60'
  | 'ml-64'
  | 'ml-72'
  | 'ml-80'
  | 'ml-96'
  | 'ml-auto'
  | 'ml-px'
  | 'ml-0.5'
  | 'ml-1.5'
  | 'ml-2.5'
  | 'ml-3.5'
  | '-ml-0'
  | '-ml-1'
  | '-ml-2'
  | '-ml-3'
  | '-ml-4'
  | '-ml-5'
  | '-ml-6'
  | '-ml-7'
  | '-ml-8'
  | '-ml-9'
  | '-ml-10'
  | '-ml-11'
  | '-ml-12'
  | '-ml-14'
  | '-ml-16'
  | '-ml-20'
  | '-ml-24'
  | '-ml-28'
  | '-ml-32'
  | '-ml-36'
  | '-ml-40'
  | '-ml-44'
  | '-ml-48'
  | '-ml-52'
  | '-ml-56'
  | '-ml-60'
  | '-ml-64'
  | '-ml-72'
  | '-ml-80'
  | '-ml-96'
  | '-ml-px'
  | '-ml-0.5'
  | '-ml-1.5'
  | '-ml-2.5'
  | '-ml-3.5'
  | 'ml-1/2'
  | 'ml-full'
  | 'ml-4.5'
  | 'ml-7.5'
  | 'ml-9.5'
  | 'ml-11.5'
  | '-ml-15'
  | '-ml-17'
  | '-ml-18'
  | '-ml-21'
  | '-ml-22'
  | '-ml-30'
  | '-ml-1/2'
  | '-ml-full'
  | '-ml-4.5'
  | '-ml-7.5'
  | '-ml-9.5'
  | '-ml-11.5'

export type TSpace =
  | 'space-x-0'
  | 'space-x-1'
  | 'space-x-2'
  | 'space-x-3'
  | 'space-x-4'
  | 'space-x-5'
  | 'space-x-6'
  | 'space-x-7'
  | 'space-x-8'
  | 'space-x-9'
  | 'space-x-10'
  | 'space-x-11'
  | 'space-x-12'
  | 'space-x-14'
  | 'space-x-15'
  | 'space-x-16'
  | 'space-x-17'
  | 'space-x-18'
  | 'space-x-20'
  | 'space-x-21'
  | 'space-x-22'
  | 'space-x-24'
  | 'space-x-28'
  | 'space-x-30'
  | 'space-x-32'
  | 'space-x-36'
  | 'space-x-40'
  | 'space-x-44'
  | 'space-x-48'
  | 'space-x-52'
  | 'space-x-56'
  | 'space-x-60'
  | 'space-x-64'
  | 'space-x-72'
  | 'space-x-80'
  | 'space-x-96'
  | 'space-x-px'
  | 'space-x-0.5'
  | 'space-x-1.5'
  | 'space-x-2.5'
  | 'space-x-3.5'
  | '-space-x-0'
  | '-space-x-1'
  | '-space-x-2'
  | '-space-x-3'
  | '-space-x-4'
  | '-space-x-5'
  | '-space-x-6'
  | '-space-x-7'
  | '-space-x-8'
  | '-space-x-9'
  | '-space-x-10'
  | '-space-x-11'
  | '-space-x-12'
  | '-space-x-14'
  | '-space-x-16'
  | '-space-x-20'
  | '-space-x-24'
  | '-space-x-28'
  | '-space-x-32'
  | '-space-x-36'
  | '-space-x-40'
  | '-space-x-44'
  | '-space-x-48'
  | '-space-x-52'
  | '-space-x-56'
  | '-space-x-60'
  | '-space-x-64'
  | '-space-x-72'
  | '-space-x-80'
  | '-space-x-96'
  | '-space-x-px'
  | '-space-x-0.5'
  | '-space-x-1.5'
  | '-space-x-2.5'
  | '-space-x-3.5'
  | 'space-x-1/2'
  | 'space-x-full'
  | 'space-x-4.5'
  | 'space-x-7.5'
  | 'space-x-9.5'
  | 'space-x-11.5'
  | '-space-x-15'
  | '-space-x-17'
  | '-space-x-18'
  | '-space-x-21'
  | '-space-x-22'
  | '-space-x-30'
  | '-space-x-1/2'
  | '-space-x-full'
  | '-space-x-4.5'
  | '-space-x-7.5'
  | '-space-x-9.5'
  | '-space-x-11.5'
  | 'space-x-reverse'
  | 'space-y-0'
  | 'space-y-1'
  | 'space-y-2'
  | 'space-y-3'
  | 'space-y-4'
  | 'space-y-5'
  | 'space-y-6'
  | 'space-y-7'
  | 'space-y-8'
  | 'space-y-9'
  | 'space-y-10'
  | 'space-y-11'
  | 'space-y-12'
  | 'space-y-14'
  | 'space-y-15'
  | 'space-y-16'
  | 'space-y-17'
  | 'space-y-18'
  | 'space-y-20'
  | 'space-y-21'
  | 'space-y-22'
  | 'space-y-24'
  | 'space-y-28'
  | 'space-y-30'
  | 'space-y-32'
  | 'space-y-36'
  | 'space-y-40'
  | 'space-y-44'
  | 'space-y-48'
  | 'space-y-52'
  | 'space-y-56'
  | 'space-y-60'
  | 'space-y-64'
  | 'space-y-72'
  | 'space-y-80'
  | 'space-y-96'
  | 'space-y-px'
  | 'space-y-0.5'
  | 'space-y-1.5'
  | 'space-y-2.5'
  | 'space-y-3.5'
  | '-space-y-0'
  | '-space-y-1'
  | '-space-y-2'
  | '-space-y-3'
  | '-space-y-4'
  | '-space-y-5'
  | '-space-y-6'
  | '-space-y-7'
  | '-space-y-8'
  | '-space-y-9'
  | '-space-y-10'
  | '-space-y-11'
  | '-space-y-12'
  | '-space-y-14'
  | '-space-y-16'
  | '-space-y-20'
  | '-space-y-24'
  | '-space-y-28'
  | '-space-y-32'
  | '-space-y-36'
  | '-space-y-40'
  | '-space-y-44'
  | '-space-y-48'
  | '-space-y-52'
  | '-space-y-56'
  | '-space-y-60'
  | '-space-y-64'
  | '-space-y-72'
  | '-space-y-80'
  | '-space-y-96'
  | '-space-y-px'
  | '-space-y-0.5'
  | '-space-y-1.5'
  | '-space-y-2.5'
  | '-space-y-3.5'
  | 'space-y-1/2'
  | 'space-y-full'
  | 'space-y-4.5'
  | 'space-y-7.5'
  | 'space-y-9.5'
  | 'space-y-11.5'
  | '-space-y-15'
  | '-space-y-17'
  | '-space-y-18'
  | '-space-y-21'
  | '-space-y-22'
  | '-space-y-30'
  | '-space-y-1/2'
  | '-space-y-full'
  | '-space-y-4.5'
  | '-space-y-7.5'
  | '-space-y-9.5'
  | '-space-y-11.5'
  | 'space-y-reverse'

export type TSpacing =
  | TPadding
  | TMargin
  | TSpace

export type TAppearance =
  | 'appearance-none'

export type TPointerEvents =
  | 'pointer-events-none'
  | 'pointer-events-auto'

export type TResize =
  | 'resize-none'
  | 'resize'
  | 'resize-y'
  | 'resize-x'

export type TUserSelect =
  | 'select-none'
  | 'select-text'
  | 'select-all'
  | 'select-auto'

export type TCursor =
  | 'cursor-auto'
  | 'cursor-default'
  | 'cursor-pointer'
  | 'cursor-wait'
  | 'cursor-text'
  | 'cursor-move'
  | 'cursor-help'
  | 'cursor-not-allowed'

export type TOutline =
  | 'outline-none'
  | 'outline-white'
  | 'outline-black'

export type TInteractivity =
  | TAppearance
  | TPointerEvents
  | TResize
  | TUserSelect
  | TCursor
  | TOutline

export type TDisplay =
  | 'block'
  | 'inline-block'
  | 'inline'
  | 'flex'
  | 'inline-flex'
  | 'grid'
  | 'inline-grid'
  | 'table'
  | 'inline-table'
  | 'table-row'
  | 'table-cell'
  | 'contents'
  | 'list-item'
  | 'hidden'

export type TBoxDecorationBreak =
  | 'decoration-slice'
  | 'decoration-clone'

export type TBoxSizing =
  | 'box-border'
  | 'box-content'

export type TContainer =
  | 'container'

export type TFloat =
  | 'float-right'
  | 'float-left'
  | 'float-none'

export type TClear =
  | 'clear-left'
  | 'clear-right'
  | 'clear-both'
  | 'clear-none'

export type TIsolation =
  | 'isolate'
  | 'isolation-auto'

export type TObjectFit =
  | 'object-contain'
  | 'object-cover'
  | 'object-fill'
  | 'object-none'
  | 'object-scale-down'

export type TOverflow =
  | 'overflow-auto'
  | 'overflow-hidden'
  | 'overflow-visible'
  | 'overflow-scroll'
  | 'overflow-x-auto'
  | 'overflow-y-auto'
  | 'overflow-x-hidden'
  | 'overflow-y-hidden'
  | 'overflow-x-visible'
  | 'overflow-y-visible'
  | 'overflow-x-scroll'
  | 'overflow-y-scroll'

export type TOverscrollBehavior =
  | 'overscroll-auto'
  | 'overscroll-contain'
  | 'overscroll-none'
  | 'overscroll-y-auto'
  | 'overscroll-y-contain'
  | 'overscroll-y-none'
  | 'overscroll-x-auto'
  | 'overscroll-x-contain'
  | 'overscroll-x-none'

export type TPosition =
  | 'static'
  | 'fixed'
  | 'absolute'
  | 'relative'
  | 'sticky'

export type TVisibility =
  | 'visible'
  | 'invisible'

export type TObjectPosition =
  | 'object-bottom'
  | 'object-center'
  | 'object-left'
  | 'object-left-bottom'
  | 'object-left-top'
  | 'object-right'
  | 'object-right-bottom'
  | 'object-right-top'
  | 'object-top'
  | 'object-center-0'
  | 'object-center-20'
  | 'object-center-40'
  | 'object-center-50'
  | 'object-center-60'
  | 'object-center-80'
  | 'object-center-100'
  | 'object-center-top'
  | 'object-center-bottom'

export type TInset =
  | 'inset-0'
  | 'inset-x-0'
  | 'inset-y-0'
  | 'top-0'
  | 'right-0'
  | 'bottom-0'
  | 'left-0'
  | 'inset-1'
  | 'inset-x-1'
  | 'inset-y-1'
  | 'top-1'
  | 'right-1'
  | 'bottom-1'
  | 'left-1'
  | 'inset-2'
  | 'inset-x-2'
  | 'inset-y-2'
  | 'top-2'
  | 'right-2'
  | 'bottom-2'
  | 'left-2'
  | 'inset-3'
  | 'inset-x-3'
  | 'inset-y-3'
  | 'top-3'
  | 'right-3'
  | 'bottom-3'
  | 'left-3'
  | 'inset-4'
  | 'inset-x-4'
  | 'inset-y-4'
  | 'top-4'
  | 'right-4'
  | 'bottom-4'
  | 'left-4'
  | 'inset-5'
  | 'inset-x-5'
  | 'inset-y-5'
  | 'top-5'
  | 'right-5'
  | 'bottom-5'
  | 'left-5'
  | 'inset-6'
  | 'inset-x-6'
  | 'inset-y-6'
  | 'top-6'
  | 'right-6'
  | 'bottom-6'
  | 'left-6'
  | 'inset-7'
  | 'inset-x-7'
  | 'inset-y-7'
  | 'top-7'
  | 'right-7'
  | 'bottom-7'
  | 'left-7'
  | 'inset-8'
  | 'inset-x-8'
  | 'inset-y-8'
  | 'top-8'
  | 'right-8'
  | 'bottom-8'
  | 'left-8'
  | 'inset-9'
  | 'inset-x-9'
  | 'inset-y-9'
  | 'top-9'
  | 'right-9'
  | 'bottom-9'
  | 'left-9'
  | 'inset-10'
  | 'inset-x-10'
  | 'inset-y-10'
  | 'top-10'
  | 'right-10'
  | 'bottom-10'
  | 'left-10'
  | 'inset-11'
  | 'inset-x-11'
  | 'inset-y-11'
  | 'top-11'
  | 'right-11'
  | 'bottom-11'
  | 'left-11'
  | 'inset-12'
  | 'inset-x-12'
  | 'inset-y-12'
  | 'top-12'
  | 'right-12'
  | 'bottom-12'
  | 'left-12'
  | 'inset-14'
  | 'inset-x-14'
  | 'inset-y-14'
  | 'top-14'
  | 'right-14'
  | 'bottom-14'
  | 'left-14'
  | 'inset-15'
  | 'inset-x-15'
  | 'inset-y-15'
  | 'top-15'
  | 'right-15'
  | 'bottom-15'
  | 'left-15'
  | 'inset-16'
  | 'inset-x-16'
  | 'inset-y-16'
  | 'top-16'
  | 'right-16'
  | 'bottom-16'
  | 'left-16'
  | 'inset-17'
  | 'inset-x-17'
  | 'inset-y-17'
  | 'top-17'
  | 'right-17'
  | 'bottom-17'
  | 'left-17'
  | 'inset-18'
  | 'inset-x-18'
  | 'inset-y-18'
  | 'top-18'
  | 'right-18'
  | 'bottom-18'
  | 'left-18'
  | 'inset-20'
  | 'inset-x-20'
  | 'inset-y-20'
  | 'top-20'
  | 'right-20'
  | 'bottom-20'
  | 'left-20'
  | 'inset-21'
  | 'inset-x-21'
  | 'inset-y-21'
  | 'top-21'
  | 'right-21'
  | 'bottom-21'
  | 'left-21'
  | 'inset-22'
  | 'inset-x-22'
  | 'inset-y-22'
  | 'top-22'
  | 'right-22'
  | 'bottom-22'
  | 'left-22'
  | 'inset-24'
  | 'inset-x-24'
  | 'inset-y-24'
  | 'top-24'
  | 'right-24'
  | 'bottom-24'
  | 'left-24'
  | 'inset-28'
  | 'inset-x-28'
  | 'inset-y-28'
  | 'top-28'
  | 'right-28'
  | 'bottom-28'
  | 'left-28'
  | 'inset-30'
  | 'inset-x-30'
  | 'inset-y-30'
  | 'top-30'
  | 'right-30'
  | 'bottom-30'
  | 'left-30'
  | 'inset-32'
  | 'inset-x-32'
  | 'inset-y-32'
  | 'top-32'
  | 'right-32'
  | 'bottom-32'
  | 'left-32'
  | 'inset-36'
  | 'inset-x-36'
  | 'inset-y-36'
  | 'top-36'
  | 'right-36'
  | 'bottom-36'
  | 'left-36'
  | 'inset-40'
  | 'inset-x-40'
  | 'inset-y-40'
  | 'top-40'
  | 'right-40'
  | 'bottom-40'
  | 'left-40'
  | 'inset-44'
  | 'inset-x-44'
  | 'inset-y-44'
  | 'top-44'
  | 'right-44'
  | 'bottom-44'
  | 'left-44'
  | 'inset-48'
  | 'inset-x-48'
  | 'inset-y-48'
  | 'top-48'
  | 'right-48'
  | 'bottom-48'
  | 'left-48'
  | 'inset-52'
  | 'inset-x-52'
  | 'inset-y-52'
  | 'top-52'
  | 'right-52'
  | 'bottom-52'
  | 'left-52'
  | 'inset-56'
  | 'inset-x-56'
  | 'inset-y-56'
  | 'top-56'
  | 'right-56'
  | 'bottom-56'
  | 'left-56'
  | 'inset-60'
  | 'inset-x-60'
  | 'inset-y-60'
  | 'top-60'
  | 'right-60'
  | 'bottom-60'
  | 'left-60'
  | 'inset-64'
  | 'inset-x-64'
  | 'inset-y-64'
  | 'top-64'
  | 'right-64'
  | 'bottom-64'
  | 'left-64'
  | 'inset-72'
  | 'inset-x-72'
  | 'inset-y-72'
  | 'top-72'
  | 'right-72'
  | 'bottom-72'
  | 'left-72'
  | 'inset-80'
  | 'inset-x-80'
  | 'inset-y-80'
  | 'top-80'
  | 'right-80'
  | 'bottom-80'
  | 'left-80'
  | 'inset-96'
  | 'inset-x-96'
  | 'inset-y-96'
  | 'top-96'
  | 'right-96'
  | 'bottom-96'
  | 'left-96'
  | 'inset-auto'
  | 'inset-x-auto'
  | 'inset-y-auto'
  | 'top-auto'
  | 'right-auto'
  | 'bottom-auto'
  | 'left-auto'
  | 'inset-px'
  | 'inset-x-px'
  | 'inset-y-px'
  | 'top-px'
  | 'right-px'
  | 'bottom-px'
  | 'left-px'
  | 'inset-0.5'
  | 'inset-x-0.5'
  | 'inset-y-0.5'
  | 'top-0.5'
  | 'right-0.5'
  | 'bottom-0.5'
  | 'left-0.5'
  | 'inset-1.5'
  | 'inset-x-1.5'
  | 'inset-y-1.5'
  | 'top-1.5'
  | 'right-1.5'
  | 'bottom-1.5'
  | 'left-1.5'
  | 'inset-2.5'
  | 'inset-x-2.5'
  | 'inset-y-2.5'
  | 'top-2.5'
  | 'right-2.5'
  | 'bottom-2.5'
  | 'left-2.5'
  | 'inset-3.5'
  | 'inset-x-3.5'
  | 'inset-y-3.5'
  | 'top-3.5'
  | 'right-3.5'
  | 'bottom-3.5'
  | 'left-3.5'
  | '-inset-0'
  | '-inset-x-0'
  | '-inset-y-0'
  | '-top-0'
  | '-right-0'
  | '-bottom-0'
  | '-left-0'
  | '-inset-1'
  | '-inset-x-1'
  | '-inset-y-1'
  | '-top-1'
  | '-right-1'
  | '-bottom-1'
  | '-left-1'
  | '-inset-2'
  | '-inset-x-2'
  | '-inset-y-2'
  | '-top-2'
  | '-right-2'
  | '-bottom-2'
  | '-left-2'
  | '-inset-3'
  | '-inset-x-3'
  | '-inset-y-3'
  | '-top-3'
  | '-right-3'
  | '-bottom-3'
  | '-left-3'
  | '-inset-4'
  | '-inset-x-4'
  | '-inset-y-4'
  | '-top-4'
  | '-right-4'
  | '-bottom-4'
  | '-left-4'
  | '-inset-5'
  | '-inset-x-5'
  | '-inset-y-5'
  | '-top-5'
  | '-right-5'
  | '-bottom-5'
  | '-left-5'
  | '-inset-6'
  | '-inset-x-6'
  | '-inset-y-6'
  | '-top-6'
  | '-right-6'
  | '-bottom-6'
  | '-left-6'
  | '-inset-7'
  | '-inset-x-7'
  | '-inset-y-7'
  | '-top-7'
  | '-right-7'
  | '-bottom-7'
  | '-left-7'
  | '-inset-8'
  | '-inset-x-8'
  | '-inset-y-8'
  | '-top-8'
  | '-right-8'
  | '-bottom-8'
  | '-left-8'
  | '-inset-9'
  | '-inset-x-9'
  | '-inset-y-9'
  | '-top-9'
  | '-right-9'
  | '-bottom-9'
  | '-left-9'
  | '-inset-10'
  | '-inset-x-10'
  | '-inset-y-10'
  | '-top-10'
  | '-right-10'
  | '-bottom-10'
  | '-left-10'
  | '-inset-11'
  | '-inset-x-11'
  | '-inset-y-11'
  | '-top-11'
  | '-right-11'
  | '-bottom-11'
  | '-left-11'
  | '-inset-12'
  | '-inset-x-12'
  | '-inset-y-12'
  | '-top-12'
  | '-right-12'
  | '-bottom-12'
  | '-left-12'
  | '-inset-14'
  | '-inset-x-14'
  | '-inset-y-14'
  | '-top-14'
  | '-right-14'
  | '-bottom-14'
  | '-left-14'
  | '-inset-16'
  | '-inset-x-16'
  | '-inset-y-16'
  | '-top-16'
  | '-right-16'
  | '-bottom-16'
  | '-left-16'
  | '-inset-20'
  | '-inset-x-20'
  | '-inset-y-20'
  | '-top-20'
  | '-right-20'
  | '-bottom-20'
  | '-left-20'
  | '-inset-24'
  | '-inset-x-24'
  | '-inset-y-24'
  | '-top-24'
  | '-right-24'
  | '-bottom-24'
  | '-left-24'
  | '-inset-28'
  | '-inset-x-28'
  | '-inset-y-28'
  | '-top-28'
  | '-right-28'
  | '-bottom-28'
  | '-left-28'
  | '-inset-32'
  | '-inset-x-32'
  | '-inset-y-32'
  | '-top-32'
  | '-right-32'
  | '-bottom-32'
  | '-left-32'
  | '-inset-36'
  | '-inset-x-36'
  | '-inset-y-36'
  | '-top-36'
  | '-right-36'
  | '-bottom-36'
  | '-left-36'
  | '-inset-40'
  | '-inset-x-40'
  | '-inset-y-40'
  | '-top-40'
  | '-right-40'
  | '-bottom-40'
  | '-left-40'
  | '-inset-44'
  | '-inset-x-44'
  | '-inset-y-44'
  | '-top-44'
  | '-right-44'
  | '-bottom-44'
  | '-left-44'
  | '-inset-48'
  | '-inset-x-48'
  | '-inset-y-48'
  | '-top-48'
  | '-right-48'
  | '-bottom-48'
  | '-left-48'
  | '-inset-52'
  | '-inset-x-52'
  | '-inset-y-52'
  | '-top-52'
  | '-right-52'
  | '-bottom-52'
  | '-left-52'
  | '-inset-56'
  | '-inset-x-56'
  | '-inset-y-56'
  | '-top-56'
  | '-right-56'
  | '-bottom-56'
  | '-left-56'
  | '-inset-60'
  | '-inset-x-60'
  | '-inset-y-60'
  | '-top-60'
  | '-right-60'
  | '-bottom-60'
  | '-left-60'
  | '-inset-64'
  | '-inset-x-64'
  | '-inset-y-64'
  | '-top-64'
  | '-right-64'
  | '-bottom-64'
  | '-left-64'
  | '-inset-72'
  | '-inset-x-72'
  | '-inset-y-72'
  | '-top-72'
  | '-right-72'
  | '-bottom-72'
  | '-left-72'
  | '-inset-80'
  | '-inset-x-80'
  | '-inset-y-80'
  | '-top-80'
  | '-right-80'
  | '-bottom-80'
  | '-left-80'
  | '-inset-96'
  | '-inset-x-96'
  | '-inset-y-96'
  | '-top-96'
  | '-right-96'
  | '-bottom-96'
  | '-left-96'
  | '-inset-px'
  | '-inset-x-px'
  | '-inset-y-px'
  | '-top-px'
  | '-right-px'
  | '-bottom-px'
  | '-left-px'
  | '-inset-0.5'
  | '-inset-x-0.5'
  | '-inset-y-0.5'
  | '-top-0.5'
  | '-right-0.5'
  | '-bottom-0.5'
  | '-left-0.5'
  | '-inset-1.5'
  | '-inset-x-1.5'
  | '-inset-y-1.5'
  | '-top-1.5'
  | '-right-1.5'
  | '-bottom-1.5'
  | '-left-1.5'
  | '-inset-2.5'
  | '-inset-x-2.5'
  | '-inset-y-2.5'
  | '-top-2.5'
  | '-right-2.5'
  | '-bottom-2.5'
  | '-left-2.5'
  | '-inset-3.5'
  | '-inset-x-3.5'
  | '-inset-y-3.5'
  | '-top-3.5'
  | '-right-3.5'
  | '-bottom-3.5'
  | '-left-3.5'
  | 'inset-1/2'
  | 'inset-x-1/2'
  | 'inset-y-1/2'
  | 'top-1/2'
  | 'right-1/2'
  | 'bottom-1/2'
  | 'left-1/2'
  | 'inset-1/3'
  | 'inset-x-1/3'
  | 'inset-y-1/3'
  | 'top-1/3'
  | 'right-1/3'
  | 'bottom-1/3'
  | 'left-1/3'
  | 'inset-2/3'
  | 'inset-x-2/3'
  | 'inset-y-2/3'
  | 'top-2/3'
  | 'right-2/3'
  | 'bottom-2/3'
  | 'left-2/3'
  | 'inset-1/4'
  | 'inset-x-1/4'
  | 'inset-y-1/4'
  | 'top-1/4'
  | 'right-1/4'
  | 'bottom-1/4'
  | 'left-1/4'
  | 'inset-2/4'
  | 'inset-x-2/4'
  | 'inset-y-2/4'
  | 'top-2/4'
  | 'right-2/4'
  | 'bottom-2/4'
  | 'left-2/4'
  | 'inset-3/4'
  | 'inset-x-3/4'
  | 'inset-y-3/4'
  | 'top-3/4'
  | 'right-3/4'
  | 'bottom-3/4'
  | 'left-3/4'
  | 'inset-full'
  | 'inset-x-full'
  | 'inset-y-full'
  | 'top-full'
  | 'right-full'
  | 'bottom-full'
  | 'left-full'
  | '-inset-1/2'
  | '-inset-x-1/2'
  | '-inset-y-1/2'
  | '-top-1/2'
  | '-right-1/2'
  | '-bottom-1/2'
  | '-left-1/2'
  | '-inset-1/3'
  | '-inset-x-1/3'
  | '-inset-y-1/3'
  | '-top-1/3'
  | '-right-1/3'
  | '-bottom-1/3'
  | '-left-1/3'
  | '-inset-2/3'
  | '-inset-x-2/3'
  | '-inset-y-2/3'
  | '-top-2/3'
  | '-right-2/3'
  | '-bottom-2/3'
  | '-left-2/3'
  | '-inset-1/4'
  | '-inset-x-1/4'
  | '-inset-y-1/4'
  | '-top-1/4'
  | '-right-1/4'
  | '-bottom-1/4'
  | '-left-1/4'
  | '-inset-2/4'
  | '-inset-x-2/4'
  | '-inset-y-2/4'
  | '-top-2/4'
  | '-right-2/4'
  | '-bottom-2/4'
  | '-left-2/4'
  | '-inset-3/4'
  | '-inset-x-3/4'
  | '-inset-y-3/4'
  | '-top-3/4'
  | '-right-3/4'
  | '-bottom-3/4'
  | '-left-3/4'
  | '-inset-full'
  | '-inset-x-full'
  | '-inset-y-full'
  | '-top-full'
  | '-right-full'
  | '-bottom-full'
  | '-left-full'
  | 'inset-4.5'
  | 'inset-x-4.5'
  | 'inset-y-4.5'
  | 'top-4.5'
  | 'right-4.5'
  | 'bottom-4.5'
  | 'left-4.5'
  | 'inset-7.5'
  | 'inset-x-7.5'
  | 'inset-y-7.5'
  | 'top-7.5'
  | 'right-7.5'
  | 'bottom-7.5'
  | 'left-7.5'
  | 'inset-9.5'
  | 'inset-x-9.5'
  | 'inset-y-9.5'
  | 'top-9.5'
  | 'right-9.5'
  | 'bottom-9.5'
  | 'left-9.5'
  | 'inset-11.5'
  | 'inset-x-11.5'
  | 'inset-y-11.5'
  | 'top-11.5'
  | 'right-11.5'
  | 'bottom-11.5'
  | 'left-11.5'
  | '-inset-15'
  | '-inset-x-15'
  | '-inset-y-15'
  | '-top-15'
  | '-right-15'
  | '-bottom-15'
  | '-left-15'
  | '-inset-17'
  | '-inset-x-17'
  | '-inset-y-17'
  | '-top-17'
  | '-right-17'
  | '-bottom-17'
  | '-left-17'
  | '-inset-18'
  | '-inset-x-18'
  | '-inset-y-18'
  | '-top-18'
  | '-right-18'
  | '-bottom-18'
  | '-left-18'
  | '-inset-21'
  | '-inset-x-21'
  | '-inset-y-21'
  | '-top-21'
  | '-right-21'
  | '-bottom-21'
  | '-left-21'
  | '-inset-22'
  | '-inset-x-22'
  | '-inset-y-22'
  | '-top-22'
  | '-right-22'
  | '-bottom-22'
  | '-left-22'
  | '-inset-30'
  | '-inset-x-30'
  | '-inset-y-30'
  | '-top-30'
  | '-right-30'
  | '-bottom-30'
  | '-left-30'
  | '-inset-4.5'
  | '-inset-x-4.5'
  | '-inset-y-4.5'
  | '-top-4.5'
  | '-right-4.5'
  | '-bottom-4.5'
  | '-left-4.5'
  | '-inset-7.5'
  | '-inset-x-7.5'
  | '-inset-y-7.5'
  | '-top-7.5'
  | '-right-7.5'
  | '-bottom-7.5'
  | '-left-7.5'
  | '-inset-9.5'
  | '-inset-x-9.5'
  | '-inset-y-9.5'
  | '-top-9.5'
  | '-right-9.5'
  | '-bottom-9.5'
  | '-left-9.5'
  | '-inset-11.5'
  | '-inset-x-11.5'
  | '-inset-y-11.5'
  | '-top-11.5'
  | '-right-11.5'
  | '-bottom-11.5'
  | '-left-11.5'

export type TZIndex =
  | 'z-0'
  | 'z-10'
  | 'z-20'
  | 'z-30'
  | 'z-40'
  | 'z-50'
  | 'z-60'
  | 'z-70'
  | 'z-80'
  | 'z-90'
  | 'z-100'
  | 'z-200'
  | 'z-300'
  | 'z-400'
  | 'z-500'
  | 'z-1000'
  | 'z-auto'
  | 'z-max'

export type TLayout =
  | TDisplay
  | TBoxDecorationBreak
  | TBoxSizing
  | TContainer
  | TFloat
  | TClear
  | TIsolation
  | TObjectFit
  | TOverflow
  | TOverscrollBehavior
  | TPosition
  | TVisibility
  | TObjectPosition
  | TInset
  | TZIndex

export type TWidth =
  | 'w-0'
  | 'w-1'
  | 'w-2'
  | 'w-3'
  | 'w-4'
  | 'w-5'
  | 'w-6'
  | 'w-7'
  | 'w-8'
  | 'w-9'
  | 'w-10'
  | 'w-11'
  | 'w-12'
  | 'w-14'
  | 'w-15'
  | 'w-16'
  | 'w-17'
  | 'w-18'
  | 'w-20'
  | 'w-21'
  | 'w-22'
  | 'w-24'
  | 'w-28'
  | 'w-30'
  | 'w-32'
  | 'w-36'
  | 'w-40'
  | 'w-44'
  | 'w-48'
  | 'w-52'
  | 'w-56'
  | 'w-60'
  | 'w-64'
  | 'w-72'
  | 'w-80'
  | 'w-96'
  | 'w-auto'
  | 'w-px'
  | 'w-0.5'
  | 'w-1.5'
  | 'w-2.5'
  | 'w-3.5'
  | 'w-1/2'
  | 'w-1/3'
  | 'w-2/3'
  | 'w-1/4'
  | 'w-2/4'
  | 'w-3/4'
  | 'w-1/5'
  | 'w-2/5'
  | 'w-3/5'
  | 'w-4/5'
  | 'w-1/6'
  | 'w-2/6'
  | 'w-3/6'
  | 'w-4/6'
  | 'w-5/6'
  | 'w-1/12'
  | 'w-2/12'
  | 'w-3/12'
  | 'w-4/12'
  | 'w-5/12'
  | 'w-6/12'
  | 'w-7/12'
  | 'w-8/12'
  | 'w-9/12'
  | 'w-10/12'
  | 'w-11/12'
  | 'w-full'
  | 'w-screen'
  | 'w-min'
  | 'w-max'
  | 'w-4.5'
  | 'w-7.5'
  | 'w-9.5'
  | 'w-11.5'
  | 'w-sidebar'
  | 'w-tiny-swatch'
  | 'w-mini-swatch'
  | 'w-swatch'
  | 'w-collections-sidebar'
  | 'w-cart-upsell-card'

export type TMinWidth =
  | 'min-w-0'
  | 'min-w-24'
  | 'min-w-72'
  | 'min-w-full'
  | 'min-w-min'
  | 'min-w-max'
  | 'min-w-sidebar'
  | 'min-w-xxs'
  | 'min-w-1/2'
  | 'min-w-1/4'

export type TMaxWidth =
  | 'max-w-0'
  | 'max-w-24'
  | 'max-w-72'
  | 'max-w-none'
  | 'max-w-xs'
  | 'max-w-sm'
  | 'max-w-md'
  | 'max-w-lg'
  | 'max-w-xl'
  | 'max-w-2xl'
  | 'max-w-3xl'
  | 'max-w-4xl'
  | 'max-w-5xl'
  | 'max-w-6xl'
  | 'max-w-7xl'
  | 'max-w-full'
  | 'max-w-min'
  | 'max-w-max'
  | 'max-w-prose'
  | 'max-w-screen-sm'
  | 'max-w-screen-md'
  | 'max-w-screen-mg'
  | 'max-w-screen-lg'
  | 'max-w-screen-xl'
  | 'max-w-sidebar'
  | 'max-w-xxs'
  | 'max-w-1/2'
  | 'max-w-1/4'

export type THeight =
  | 'h-0'
  | 'h-1'
  | 'h-2'
  | 'h-3'
  | 'h-4'
  | 'h-5'
  | 'h-6'
  | 'h-7'
  | 'h-8'
  | 'h-9'
  | 'h-10'
  | 'h-11'
  | 'h-12'
  | 'h-14'
  | 'h-15'
  | 'h-16'
  | 'h-17'
  | 'h-18'
  | 'h-20'
  | 'h-21'
  | 'h-22'
  | 'h-24'
  | 'h-28'
  | 'h-30'
  | 'h-32'
  | 'h-36'
  | 'h-40'
  | 'h-44'
  | 'h-48'
  | 'h-52'
  | 'h-56'
  | 'h-60'
  | 'h-64'
  | 'h-72'
  | 'h-80'
  | 'h-96'
  | 'h-auto'
  | 'h-px'
  | 'h-0.5'
  | 'h-1.5'
  | 'h-2.5'
  | 'h-3.5'
  | 'h-1/2'
  | 'h-1/3'
  | 'h-2/3'
  | 'h-1/4'
  | 'h-2/4'
  | 'h-3/4'
  | 'h-1/5'
  | 'h-2/5'
  | 'h-3/5'
  | 'h-4/5'
  | 'h-1/6'
  | 'h-2/6'
  | 'h-3/6'
  | 'h-4/6'
  | 'h-5/6'
  | 'h-full'
  | 'h-screen'
  | 'h-dynamic-screen'
  | 'h-tiny-swatch'
  | 'h-mini-swatch'
  | 'h-swatch'
  | 'h-4.5'
  | 'h-7.5'
  | 'h-9.5'
  | 'h-11.5'

export type TMinHeight =
  | 'min-h-0'
  | 'min-h-11'
  | 'min-h-15'
  | 'min-h-full'
  | 'min-h-screen'
  | 'min-h-dynamic-screen'
  | 'min-h-tiny-swatch'
  | 'min-h-mini-swatch'
  | 'min-h-swatch'

export type TMaxHeight =
  | 'max-h-0'
  | 'max-h-1'
  | 'max-h-2'
  | 'max-h-3'
  | 'max-h-4'
  | 'max-h-5'
  | 'max-h-6'
  | 'max-h-7'
  | 'max-h-8'
  | 'max-h-9'
  | 'max-h-10'
  | 'max-h-11'
  | 'max-h-12'
  | 'max-h-14'
  | 'max-h-15'
  | 'max-h-16'
  | 'max-h-17'
  | 'max-h-18'
  | 'max-h-20'
  | 'max-h-21'
  | 'max-h-22'
  | 'max-h-24'
  | 'max-h-28'
  | 'max-h-30'
  | 'max-h-32'
  | 'max-h-36'
  | 'max-h-40'
  | 'max-h-44'
  | 'max-h-48'
  | 'max-h-52'
  | 'max-h-56'
  | 'max-h-60'
  | 'max-h-64'
  | 'max-h-72'
  | 'max-h-80'
  | 'max-h-96'
  | 'max-h-px'
  | 'max-h-0.5'
  | 'max-h-1.5'
  | 'max-h-2.5'
  | 'max-h-3.5'
  | 'max-h-full'
  | 'max-h-screen'
  | 'max-h-dynamic-screen'
  | 'max-h-tiny-swatch'
  | 'max-h-mini-swatch'
  | 'max-h-swatch'
  | 'max-h-1/2'
  | 'max-h-4.5'
  | 'max-h-7.5'
  | 'max-h-9.5'
  | 'max-h-11.5'

export type TSizing =
  | TWidth
  | TMinWidth
  | TMaxWidth
  | THeight
  | TMinHeight
  | TMaxHeight

export type TFill =
  | 'fill-current'

export type TStroke =
  | 'stroke-current'

export type TStrokeWidth =
  | 'stroke-0'
  | 'stroke-1'
  | 'stroke-2'

export type TSVG =
  | TFill
  | TStroke
  | TStrokeWidth

export type THardwareAcceleration =
  | 'transform-gpu'

export type TScale =
  | 'scale-0'
  | 'scale-50'
  | 'scale-75'
  | 'scale-90'
  | 'scale-95'
  | 'scale-100'
  | 'scale-105'
  | 'scale-110'
  | 'scale-125'
  | 'scale-150'
  | 'scale-x-0'
  | 'scale-x-50'
  | 'scale-x-75'
  | 'scale-x-90'
  | 'scale-x-95'
  | 'scale-x-100'
  | 'scale-x-105'
  | 'scale-x-110'
  | 'scale-x-125'
  | 'scale-x-150'
  | 'scale-y-0'
  | 'scale-y-50'
  | 'scale-y-75'
  | 'scale-y-90'
  | 'scale-y-95'
  | 'scale-y-100'
  | 'scale-y-105'
  | 'scale-y-110'
  | 'scale-y-125'
  | 'scale-y-150'

export type TRotate =
  | 'rotate-0'
  | 'rotate-1'
  | 'rotate-2'
  | 'rotate-3'
  | 'rotate-6'
  | 'rotate-12'
  | 'rotate-45'
  | 'rotate-90'
  | 'rotate-180'
  | '-rotate-180'
  | '-rotate-90'
  | '-rotate-45'
  | '-rotate-12'
  | '-rotate-6'
  | '-rotate-3'
  | '-rotate-2'
  | '-rotate-1'

export type TTranslate =
  | 'translate-x-0'
  | 'translate-x-1'
  | 'translate-x-2'
  | 'translate-x-3'
  | 'translate-x-4'
  | 'translate-x-5'
  | 'translate-x-6'
  | 'translate-x-7'
  | 'translate-x-8'
  | 'translate-x-9'
  | 'translate-x-10'
  | 'translate-x-11'
  | 'translate-x-12'
  | 'translate-x-14'
  | 'translate-x-15'
  | 'translate-x-16'
  | 'translate-x-17'
  | 'translate-x-18'
  | 'translate-x-20'
  | 'translate-x-21'
  | 'translate-x-22'
  | 'translate-x-24'
  | 'translate-x-28'
  | 'translate-x-30'
  | 'translate-x-32'
  | 'translate-x-36'
  | 'translate-x-40'
  | 'translate-x-44'
  | 'translate-x-48'
  | 'translate-x-52'
  | 'translate-x-56'
  | 'translate-x-60'
  | 'translate-x-64'
  | 'translate-x-72'
  | 'translate-x-80'
  | 'translate-x-96'
  | 'translate-x-px'
  | 'translate-x-0.5'
  | 'translate-x-1.5'
  | 'translate-x-2.5'
  | 'translate-x-3.5'
  | '-translate-x-0'
  | '-translate-x-1'
  | '-translate-x-2'
  | '-translate-x-3'
  | '-translate-x-4'
  | '-translate-x-5'
  | '-translate-x-6'
  | '-translate-x-7'
  | '-translate-x-8'
  | '-translate-x-9'
  | '-translate-x-10'
  | '-translate-x-11'
  | '-translate-x-12'
  | '-translate-x-14'
  | '-translate-x-16'
  | '-translate-x-20'
  | '-translate-x-24'
  | '-translate-x-28'
  | '-translate-x-32'
  | '-translate-x-36'
  | '-translate-x-40'
  | '-translate-x-44'
  | '-translate-x-48'
  | '-translate-x-52'
  | '-translate-x-56'
  | '-translate-x-60'
  | '-translate-x-64'
  | '-translate-x-72'
  | '-translate-x-80'
  | '-translate-x-96'
  | '-translate-x-px'
  | '-translate-x-0.5'
  | '-translate-x-1.5'
  | '-translate-x-2.5'
  | '-translate-x-3.5'
  | 'translate-x-1/2'
  | 'translate-x-1/3'
  | 'translate-x-2/3'
  | 'translate-x-1/4'
  | 'translate-x-2/4'
  | 'translate-x-3/4'
  | 'translate-x-full'
  | '-translate-x-1/2'
  | '-translate-x-1/3'
  | '-translate-x-2/3'
  | '-translate-x-1/4'
  | '-translate-x-2/4'
  | '-translate-x-3/4'
  | '-translate-x-full'
  | 'translate-x-4.5'
  | 'translate-x-7.5'
  | 'translate-x-9.5'
  | 'translate-x-11.5'
  | '-translate-x-15'
  | '-translate-x-17'
  | '-translate-x-18'
  | '-translate-x-21'
  | '-translate-x-22'
  | '-translate-x-30'
  | '-translate-x-4.5'
  | '-translate-x-7.5'
  | '-translate-x-9.5'
  | '-translate-x-11.5'
  | 'translate-y-0'
  | 'translate-y-1'
  | 'translate-y-2'
  | 'translate-y-3'
  | 'translate-y-4'
  | 'translate-y-5'
  | 'translate-y-6'
  | 'translate-y-7'
  | 'translate-y-8'
  | 'translate-y-9'
  | 'translate-y-10'
  | 'translate-y-11'
  | 'translate-y-12'
  | 'translate-y-14'
  | 'translate-y-15'
  | 'translate-y-16'
  | 'translate-y-17'
  | 'translate-y-18'
  | 'translate-y-20'
  | 'translate-y-21'
  | 'translate-y-22'
  | 'translate-y-24'
  | 'translate-y-28'
  | 'translate-y-30'
  | 'translate-y-32'
  | 'translate-y-36'
  | 'translate-y-40'
  | 'translate-y-44'
  | 'translate-y-48'
  | 'translate-y-52'
  | 'translate-y-56'
  | 'translate-y-60'
  | 'translate-y-64'
  | 'translate-y-72'
  | 'translate-y-80'
  | 'translate-y-96'
  | 'translate-y-px'
  | 'translate-y-0.5'
  | 'translate-y-1.5'
  | 'translate-y-2.5'
  | 'translate-y-3.5'
  | '-translate-y-0'
  | '-translate-y-1'
  | '-translate-y-2'
  | '-translate-y-3'
  | '-translate-y-4'
  | '-translate-y-5'
  | '-translate-y-6'
  | '-translate-y-7'
  | '-translate-y-8'
  | '-translate-y-9'
  | '-translate-y-10'
  | '-translate-y-11'
  | '-translate-y-12'
  | '-translate-y-14'
  | '-translate-y-16'
  | '-translate-y-20'
  | '-translate-y-24'
  | '-translate-y-28'
  | '-translate-y-32'
  | '-translate-y-36'
  | '-translate-y-40'
  | '-translate-y-44'
  | '-translate-y-48'
  | '-translate-y-52'
  | '-translate-y-56'
  | '-translate-y-60'
  | '-translate-y-64'
  | '-translate-y-72'
  | '-translate-y-80'
  | '-translate-y-96'
  | '-translate-y-px'
  | '-translate-y-0.5'
  | '-translate-y-1.5'
  | '-translate-y-2.5'
  | '-translate-y-3.5'
  | 'translate-y-1/2'
  | 'translate-y-1/3'
  | 'translate-y-2/3'
  | 'translate-y-1/4'
  | 'translate-y-2/4'
  | 'translate-y-3/4'
  | 'translate-y-full'
  | '-translate-y-1/2'
  | '-translate-y-1/3'
  | '-translate-y-2/3'
  | '-translate-y-1/4'
  | '-translate-y-2/4'
  | '-translate-y-3/4'
  | '-translate-y-full'
  | 'translate-y-4.5'
  | 'translate-y-7.5'
  | 'translate-y-9.5'
  | 'translate-y-11.5'
  | '-translate-y-15'
  | '-translate-y-17'
  | '-translate-y-18'
  | '-translate-y-21'
  | '-translate-y-22'
  | '-translate-y-30'
  | '-translate-y-4.5'
  | '-translate-y-7.5'
  | '-translate-y-9.5'
  | '-translate-y-11.5'

export type TSkew =
  | 'skew-x-0'
  | 'skew-x-1'
  | 'skew-x-2'
  | 'skew-x-3'
  | 'skew-x-6'
  | 'skew-x-12'
  | '-skew-x-12'
  | '-skew-x-6'
  | '-skew-x-3'
  | '-skew-x-2'
  | '-skew-x-1'
  | 'skew-y-0'
  | 'skew-y-1'
  | 'skew-y-2'
  | 'skew-y-3'
  | 'skew-y-6'
  | 'skew-y-12'
  | '-skew-y-12'
  | '-skew-y-6'
  | '-skew-y-3'
  | '-skew-y-2'
  | '-skew-y-1'

export type TTransformOrigin =
  | 'origin-center'
  | 'origin-top'
  | 'origin-top-right'
  | 'origin-right'
  | 'origin-bottom-right'
  | 'origin-bottom'
  | 'origin-bottom-left'
  | 'origin-left'
  | 'origin-top-left'

export type TTransforms =
  | THardwareAcceleration
  | TScale
  | TRotate
  | TTranslate
  | TSkew
  | TTransformOrigin

export type TFontSmoothing =
  | 'antialiased'
  | 'subpixel-antialiased'

export type TFontStyle =
  | 'italic'
  | 'non-italic'

export type TFontVariantNumeric =
  | 'normal-nums'
  | 'ordinal'
  | 'slashed-zero'
  | 'lining-nums'
  | 'oldstyle-nums'
  | 'proportional-nums'
  | 'tabular-nums'
  | 'diagonal-fractions'
  | 'stacked-fractions'

export type TListStylePosition =
  | 'list-inside'
  | 'list-outside'

export type TTextAlign =
  | 'text-left'
  | 'text-center'
  | 'text-right'
  | 'text-justify'

export type TTextDecoration =
  | 'underline'
  | 'line-through'
  | 'no-underline'

export type TTextTransform =
  | 'uppercase'
  | 'lowercase'
  | 'capitalize'
  | 'normal-case'

export type TTextOverflow =
  | 'truncate'
  | 'overflow-ellipsis'
  | 'overflow-clip'

export type TVerticalAlign =
  | 'align-baseline'
  | 'align-top'
  | 'align-middle'
  | 'align-bottom'
  | 'align-text-top'
  | 'align-text-bottom'

export type TWhitespace =
  | 'whitespace-normal'
  | 'whitespace-nowrap'
  | 'whitespace-pre'
  | 'whitespace-pre-line'
  | 'whitespace-pre-wrap'

export type TWordBreak =
  | 'break-normal'
  | 'break-words'
  | 'break-all'

export type TFontFamily =
  | 'font-calibre'
  | 'font-chelt'

export type TFontSize =
  | 'text-3xs'
  | 'text-2xs'
  | 'text-xs'
  | 'text-sm'
  | 'text-base'
  | 'text-lg'
  | 'text-xl'
  | 'text-2xl'
  | 'text-3xl'
  | 'text-4xl'
  | 'text-5xl'
  | 'text-6xl'
  | 'text-7xl'
  | 'text-8xl'
  | 'text-9xl'
  | 'text-10xl'

export type TFontWeight =
  | 'font-thin'
  | 'font-extralight'
  | 'font-light'
  | 'font-normal'
  | 'font-medium'
  | 'font-semibold'
  | 'font-bold'
  | 'font-extrabold'
  | 'font-black'

export type TLetterSpacing =
  | 'tracking-tightest'
  | 'tracking-tighter'
  | 'tracking-tight'
  | 'tracking-normal'
  | 'tracking-wide'
  | 'tracking-wider'
  | 'tracking-widest'

export type TLineHeight =
  | 'leading-0'
  | 'leading-3'
  | 'leading-4'
  | 'leading-5'
  | 'leading-6'
  | 'leading-7'
  | 'leading-8'
  | 'leading-9'
  | 'leading-10'
  | 'leading-12'
  | 'leading-none'
  | 'leading-tight'
  | 'leading-snug'
  | 'leading-normal'
  | 'leading-relaxed'
  | 'leading-loose'

export type TListStyleType =
  | 'list-none'
  | 'list-disc'
  | 'list-decimal'

export type TPlaceholderColor =
  | 'placeholder-transparent'
  | 'placeholder-current'
  | 'placeholder-overlay'
  | 'placeholder-black'
  | 'placeholder-white'
  | 'placeholder-white-hover'
  | 'placeholder-white-pressed'
  | 'placeholder-product-acid'
  | 'placeholder-product-aura'
  | 'placeholder-product-azul'
  | 'placeholder-product-blanch'
  | 'placeholder-product-blue-salt'
  | 'placeholder-product-burgundy'
  | 'placeholder-product-butter-yellow'
  | 'placeholder-product-chai'
  | 'placeholder-product-char'
  | 'placeholder-product-charm'
  | 'placeholder-product-chickpea'
  | 'placeholder-product-cielo'
  | 'placeholder-product-clay'
  | 'placeholder-product-clear'
  | 'placeholder-product-coriander'
  | 'placeholder-product-cream'
  | 'placeholder-product-crescent'
  | 'placeholder-product-dawn'
  | 'placeholder-product-dusk'
  | 'placeholder-product-egg-yolk'
  | 'placeholder-product-espresso'
  | 'placeholder-product-eve'
  | 'placeholder-product-firecracker'
  | 'placeholder-product-forget-me-not-blue'
  | 'placeholder-product-gold'
  | 'placeholder-product-golden'
  | 'placeholder-product-heat'
  | 'placeholder-product-himalayan-salt'
  | 'placeholder-product-indigo'
  | 'placeholder-product-lavender'
  | 'placeholder-product-lavender-marble'
  | 'placeholder-product-midnight-marble'
  | 'placeholder-product-nougat'
  | 'placeholder-product-pistachio'
  | 'placeholder-product-rosa'
  | 'placeholder-product-rose-gold'
  | 'placeholder-product-rust'
  | 'placeholder-product-saffron'
  | 'placeholder-product-sage'
  | 'placeholder-product-sear'
  | 'placeholder-product-spice'
  | 'placeholder-product-steam'
  | 'placeholder-product-strawberry'
  | 'placeholder-product-sunrise'
  | 'placeholder-product-sunset'
  | 'placeholder-product-sunset-marble'
  | 'placeholder-product-terracotta'
  | 'placeholder-product-tierra'
  | 'placeholder-product-turmeric'
  | 'placeholder-product-turqoise'
  | 'placeholder-product-twilight'
  | 'placeholder-product-walnut'
  | 'placeholder-product-warm-white'
  | 'placeholder-product-zest'
  | 'placeholder-placeholder'
  | 'placeholder-interactive-bone'
  | 'placeholder-interactive-brick'
  | 'placeholder-interactive-char'
  | 'placeholder-interactive-white'
  | 'placeholder-interactive-disabled'
  | 'placeholder-interactive-error'
  | 'placeholder-interactive-outline'
  | 'placeholder-translucent-char'
  | 'placeholder-translucent-white'
  | 'placeholder-char-50'
  | 'placeholder-char-100'
  | 'placeholder-char-200'
  | 'placeholder-char-300'
  | 'placeholder-char-400'
  | 'placeholder-char-500'
  | 'placeholder-char-600'
  | 'placeholder-char-700'
  | 'placeholder-char-800'
  | 'placeholder-char-900'
  | 'placeholder-bone-50'
  | 'placeholder-bone-100'
  | 'placeholder-bone-200'
  | 'placeholder-bone-300'
  | 'placeholder-bone-400'
  | 'placeholder-bone-500'
  | 'placeholder-bone-600'
  | 'placeholder-bone-700'
  | 'placeholder-bone-800'
  | 'placeholder-bone-900'
  | 'placeholder-brick-50'
  | 'placeholder-brick-300'
  | 'placeholder-brick-500'
  | 'placeholder-brick-700'
  | 'placeholder-brick-900'
  | 'placeholder-sage-50'
  | 'placeholder-sage-300'
  | 'placeholder-sage-500'
  | 'placeholder-sage-700'
  | 'placeholder-sage-900'
  | 'placeholder-blue-50'
  | 'placeholder-blue-300'
  | 'placeholder-blue-500'
  | 'placeholder-blue-700'
  | 'placeholder-blue-900'
  | 'placeholder-misc-bright-blue'
  | 'placeholder-misc-focus'
  | 'placeholder-misc-legal-blue'
  | 'placeholder-misc-neutral'
  | 'placeholder-misc-yellow-orange'

export type TPlaceholderOpacity =
  | 'placeholder-opacity-0'
  | 'placeholder-opacity-5'
  | 'placeholder-opacity-10'
  | 'placeholder-opacity-20'
  | 'placeholder-opacity-25'
  | 'placeholder-opacity-30'
  | 'placeholder-opacity-40'
  | 'placeholder-opacity-50'
  | 'placeholder-opacity-60'
  | 'placeholder-opacity-70'
  | 'placeholder-opacity-75'
  | 'placeholder-opacity-80'
  | 'placeholder-opacity-90'
  | 'placeholder-opacity-95'
  | 'placeholder-opacity-100'

export type TTextColor =
  | 'text-transparent'
  | 'text-current'
  | 'text-overlay'
  | 'text-black'
  | 'text-white'
  | 'text-white-hover'
  | 'text-white-pressed'
  | 'text-product-acid'
  | 'text-product-aura'
  | 'text-product-azul'
  | 'text-product-blanch'
  | 'text-product-blue-salt'
  | 'text-product-burgundy'
  | 'text-product-butter-yellow'
  | 'text-product-chai'
  | 'text-product-char'
  | 'text-product-charm'
  | 'text-product-chickpea'
  | 'text-product-cielo'
  | 'text-product-clay'
  | 'text-product-clear'
  | 'text-product-coriander'
  | 'text-product-cream'
  | 'text-product-crescent'
  | 'text-product-dawn'
  | 'text-product-dusk'
  | 'text-product-egg-yolk'
  | 'text-product-espresso'
  | 'text-product-eve'
  | 'text-product-firecracker'
  | 'text-product-forget-me-not-blue'
  | 'text-product-gold'
  | 'text-product-golden'
  | 'text-product-heat'
  | 'text-product-himalayan-salt'
  | 'text-product-indigo'
  | 'text-product-lavender'
  | 'text-product-lavender-marble'
  | 'text-product-midnight-marble'
  | 'text-product-nougat'
  | 'text-product-pistachio'
  | 'text-product-rosa'
  | 'text-product-rose-gold'
  | 'text-product-rust'
  | 'text-product-saffron'
  | 'text-product-sage'
  | 'text-product-sear'
  | 'text-product-spice'
  | 'text-product-steam'
  | 'text-product-strawberry'
  | 'text-product-sunrise'
  | 'text-product-sunset'
  | 'text-product-sunset-marble'
  | 'text-product-terracotta'
  | 'text-product-tierra'
  | 'text-product-turmeric'
  | 'text-product-turqoise'
  | 'text-product-twilight'
  | 'text-product-walnut'
  | 'text-product-warm-white'
  | 'text-product-zest'
  | 'text-placeholder'
  | 'text-interactive-bone'
  | 'text-interactive-brick'
  | 'text-interactive-char'
  | 'text-interactive-white'
  | 'text-interactive-disabled'
  | 'text-interactive-error'
  | 'text-interactive-outline'
  | 'text-translucent-char'
  | 'text-translucent-white'
  | 'text-char-50'
  | 'text-char-100'
  | 'text-char-200'
  | 'text-char-300'
  | 'text-char-400'
  | 'text-char-500'
  | 'text-char-600'
  | 'text-char-700'
  | 'text-char-800'
  | 'text-char-900'
  | 'text-bone-50'
  | 'text-bone-100'
  | 'text-bone-200'
  | 'text-bone-300'
  | 'text-bone-400'
  | 'text-bone-500'
  | 'text-bone-600'
  | 'text-bone-700'
  | 'text-bone-800'
  | 'text-bone-900'
  | 'text-brick-50'
  | 'text-brick-300'
  | 'text-brick-500'
  | 'text-brick-700'
  | 'text-brick-900'
  | 'text-sage-50'
  | 'text-sage-300'
  | 'text-sage-500'
  | 'text-sage-700'
  | 'text-sage-900'
  | 'text-blue-50'
  | 'text-blue-300'
  | 'text-blue-500'
  | 'text-blue-700'
  | 'text-blue-900'
  | 'text-misc-bright-blue'
  | 'text-misc-focus'
  | 'text-misc-legal-blue'
  | 'text-misc-neutral'
  | 'text-misc-yellow-orange'

export type TTextOpacity =
  | 'text-opacity-0'
  | 'text-opacity-5'
  | 'text-opacity-10'
  | 'text-opacity-20'
  | 'text-opacity-25'
  | 'text-opacity-30'
  | 'text-opacity-40'
  | 'text-opacity-50'
  | 'text-opacity-60'
  | 'text-opacity-70'
  | 'text-opacity-75'
  | 'text-opacity-80'
  | 'text-opacity-90'
  | 'text-opacity-95'
  | 'text-opacity-100'

export type TTypography =
  | TFontSmoothing
  | TFontStyle
  | TFontVariantNumeric
  | TListStylePosition
  | TTextAlign
  | TTextDecoration
  | TTextTransform
  | TTextOverflow
  | TVerticalAlign
  | TWhitespace
  | TWordBreak
  | TFontFamily
  | TFontSize
  | TFontWeight
  | TLetterSpacing
  | TLineHeight
  | TListStyleType
  | TPlaceholderColor
  | TPlaceholderOpacity
  | TTextColor
  | TTextOpacity


export type TPseudoClasses =
  | 'sm:content-start'
  | 'md:content-start'
  | 'mg:content-start'
  | 'lg:content-start'
  | 'xl:content-start'
  | 'sm:content-center'
  | 'md:content-center'
  | 'mg:content-center'
  | 'lg:content-center'
  | 'xl:content-center'
  | 'sm:content-end'
  | 'md:content-end'
  | 'mg:content-end'
  | 'lg:content-end'
  | 'xl:content-end'
  | 'sm:content-between'
  | 'md:content-between'
  | 'mg:content-between'
  | 'lg:content-between'
  | 'xl:content-between'
  | 'sm:content-around'
  | 'md:content-around'
  | 'mg:content-around'
  | 'lg:content-around'
  | 'xl:content-around'
  | 'sm:items-stretch'
  | 'md:items-stretch'
  | 'mg:items-stretch'
  | 'lg:items-stretch'
  | 'xl:items-stretch'
  | 'sm:items-start'
  | 'md:items-start'
  | 'mg:items-start'
  | 'lg:items-start'
  | 'xl:items-start'
  | 'sm:items-center'
  | 'md:items-center'
  | 'mg:items-center'
  | 'lg:items-center'
  | 'xl:items-center'
  | 'sm:items-end'
  | 'md:items-end'
  | 'mg:items-end'
  | 'lg:items-end'
  | 'xl:items-end'
  | 'sm:items-baseline'
  | 'md:items-baseline'
  | 'mg:items-baseline'
  | 'lg:items-baseline'
  | 'xl:items-baseline'
  | 'sm:self-auto'
  | 'md:self-auto'
  | 'mg:self-auto'
  | 'lg:self-auto'
  | 'xl:self-auto'
  | 'sm:self-start'
  | 'md:self-start'
  | 'mg:self-start'
  | 'lg:self-start'
  | 'xl:self-start'
  | 'sm:self-center'
  | 'md:self-center'
  | 'mg:self-center'
  | 'lg:self-center'
  | 'xl:self-center'
  | 'sm:self-end'
  | 'md:self-end'
  | 'mg:self-end'
  | 'lg:self-end'
  | 'xl:self-end'
  | 'sm:self-stretch'
  | 'md:self-stretch'
  | 'mg:self-stretch'
  | 'lg:self-stretch'
  | 'xl:self-stretch'
  | 'sm:self-baseline'
  | 'md:self-baseline'
  | 'mg:self-baseline'
  | 'lg:self-baseline'
  | 'xl:self-baseline'
  | 'sm:animate-none'
  | 'md:animate-none'
  | 'mg:animate-none'
  | 'lg:animate-none'
  | 'xl:animate-none'
  | 'sm:animate-spin'
  | 'md:animate-spin'
  | 'mg:animate-spin'
  | 'lg:animate-spin'
  | 'xl:animate-spin'
  | 'sm:animate-ping'
  | 'md:animate-ping'
  | 'mg:animate-ping'
  | 'lg:animate-ping'
  | 'xl:animate-ping'
  | 'sm:animate-pulse'
  | 'md:animate-pulse'
  | 'mg:animate-pulse'
  | 'lg:animate-pulse'
  | 'xl:animate-pulse'
  | 'sm:animate-bounce'
  | 'md:animate-bounce'
  | 'mg:animate-bounce'
  | 'lg:animate-bounce'
  | 'xl:animate-bounce'
  | 'sm:animate-fade-in'
  | 'md:animate-fade-in'
  | 'mg:animate-fade-in'
  | 'lg:animate-fade-in'
  | 'xl:animate-fade-in'
  | 'sm:animate-fade-out'
  | 'md:animate-fade-out'
  | 'mg:animate-fade-out'
  | 'lg:animate-fade-out'
  | 'xl:animate-fade-out'
  | 'sm:animate-marquee-ltr'
  | 'md:animate-marquee-ltr'
  | 'mg:animate-marquee-ltr'
  | 'lg:animate-marquee-ltr'
  | 'xl:animate-marquee-ltr'
  | 'sm:animate-marquee-rtl'
  | 'md:animate-marquee-rtl'
  | 'mg:animate-marquee-rtl'
  | 'lg:animate-marquee-rtl'
  | 'xl:animate-marquee-rtl'
  | 'sm:animate-ripple-fast'
  | 'md:animate-ripple-fast'
  | 'mg:animate-ripple-fast'
  | 'lg:animate-ripple-fast'
  | 'xl:animate-ripple-fast'
  | 'sm:animate-ripple-slow'
  | 'md:animate-ripple-slow'
  | 'mg:animate-ripple-slow'
  | 'lg:animate-ripple-slow'
  | 'xl:animate-ripple-slow'
  | 'sm:appearance-none'
  | 'md:appearance-none'
  | 'mg:appearance-none'
  | 'lg:appearance-none'
  | 'xl:appearance-none'
  | 'sm:backdrop-blur-0'
  | 'md:backdrop-blur-0'
  | 'mg:backdrop-blur-0'
  | 'lg:backdrop-blur-0'
  | 'xl:backdrop-blur-0'
  | 'sm:backdrop-blur-none'
  | 'md:backdrop-blur-none'
  | 'mg:backdrop-blur-none'
  | 'lg:backdrop-blur-none'
  | 'xl:backdrop-blur-none'
  | 'sm:backdrop-blur-sm'
  | 'md:backdrop-blur-sm'
  | 'mg:backdrop-blur-sm'
  | 'lg:backdrop-blur-sm'
  | 'xl:backdrop-blur-sm'
  | 'sm:backdrop-blur'
  | 'md:backdrop-blur'
  | 'mg:backdrop-blur'
  | 'lg:backdrop-blur'
  | 'xl:backdrop-blur'
  | 'sm:backdrop-blur-md'
  | 'md:backdrop-blur-md'
  | 'mg:backdrop-blur-md'
  | 'lg:backdrop-blur-md'
  | 'xl:backdrop-blur-md'
  | 'sm:backdrop-blur-lg'
  | 'md:backdrop-blur-lg'
  | 'mg:backdrop-blur-lg'
  | 'lg:backdrop-blur-lg'
  | 'xl:backdrop-blur-lg'
  | 'sm:backdrop-blur-xl'
  | 'md:backdrop-blur-xl'
  | 'mg:backdrop-blur-xl'
  | 'lg:backdrop-blur-xl'
  | 'xl:backdrop-blur-xl'
  | 'sm:backdrop-blur-2xl'
  | 'md:backdrop-blur-2xl'
  | 'mg:backdrop-blur-2xl'
  | 'lg:backdrop-blur-2xl'
  | 'xl:backdrop-blur-2xl'
  | 'sm:backdrop-blur-3xl'
  | 'md:backdrop-blur-3xl'
  | 'mg:backdrop-blur-3xl'
  | 'lg:backdrop-blur-3xl'
  | 'xl:backdrop-blur-3xl'
  | 'sm:backdrop-brightness-0'
  | 'md:backdrop-brightness-0'
  | 'mg:backdrop-brightness-0'
  | 'lg:backdrop-brightness-0'
  | 'xl:backdrop-brightness-0'
  | 'sm:backdrop-brightness-50'
  | 'md:backdrop-brightness-50'
  | 'mg:backdrop-brightness-50'
  | 'lg:backdrop-brightness-50'
  | 'xl:backdrop-brightness-50'
  | 'sm:backdrop-brightness-75'
  | 'md:backdrop-brightness-75'
  | 'mg:backdrop-brightness-75'
  | 'lg:backdrop-brightness-75'
  | 'xl:backdrop-brightness-75'
  | 'sm:backdrop-brightness-90'
  | 'md:backdrop-brightness-90'
  | 'mg:backdrop-brightness-90'
  | 'lg:backdrop-brightness-90'
  | 'xl:backdrop-brightness-90'
  | 'sm:backdrop-brightness-95'
  | 'md:backdrop-brightness-95'
  | 'mg:backdrop-brightness-95'
  | 'lg:backdrop-brightness-95'
  | 'xl:backdrop-brightness-95'
  | 'sm:backdrop-brightness-100'
  | 'md:backdrop-brightness-100'
  | 'mg:backdrop-brightness-100'
  | 'lg:backdrop-brightness-100'
  | 'xl:backdrop-brightness-100'
  | 'sm:backdrop-brightness-105'
  | 'md:backdrop-brightness-105'
  | 'mg:backdrop-brightness-105'
  | 'lg:backdrop-brightness-105'
  | 'xl:backdrop-brightness-105'
  | 'sm:backdrop-brightness-110'
  | 'md:backdrop-brightness-110'
  | 'mg:backdrop-brightness-110'
  | 'lg:backdrop-brightness-110'
  | 'xl:backdrop-brightness-110'
  | 'sm:backdrop-brightness-125'
  | 'md:backdrop-brightness-125'
  | 'mg:backdrop-brightness-125'
  | 'lg:backdrop-brightness-125'
  | 'xl:backdrop-brightness-125'
  | 'sm:backdrop-brightness-150'
  | 'md:backdrop-brightness-150'
  | 'mg:backdrop-brightness-150'
  | 'lg:backdrop-brightness-150'
  | 'xl:backdrop-brightness-150'
  | 'sm:backdrop-brightness-200'
  | 'md:backdrop-brightness-200'
  | 'mg:backdrop-brightness-200'
  | 'lg:backdrop-brightness-200'
  | 'xl:backdrop-brightness-200'
  | 'sm:backdrop-contrast-0'
  | 'md:backdrop-contrast-0'
  | 'mg:backdrop-contrast-0'
  | 'lg:backdrop-contrast-0'
  | 'xl:backdrop-contrast-0'
  | 'sm:backdrop-contrast-50'
  | 'md:backdrop-contrast-50'
  | 'mg:backdrop-contrast-50'
  | 'lg:backdrop-contrast-50'
  | 'xl:backdrop-contrast-50'
  | 'sm:backdrop-contrast-75'
  | 'md:backdrop-contrast-75'
  | 'mg:backdrop-contrast-75'
  | 'lg:backdrop-contrast-75'
  | 'xl:backdrop-contrast-75'
  | 'sm:backdrop-contrast-100'
  | 'md:backdrop-contrast-100'
  | 'mg:backdrop-contrast-100'
  | 'lg:backdrop-contrast-100'
  | 'xl:backdrop-contrast-100'
  | 'sm:backdrop-contrast-125'
  | 'md:backdrop-contrast-125'
  | 'mg:backdrop-contrast-125'
  | 'lg:backdrop-contrast-125'
  | 'xl:backdrop-contrast-125'
  | 'sm:backdrop-contrast-150'
  | 'md:backdrop-contrast-150'
  | 'mg:backdrop-contrast-150'
  | 'lg:backdrop-contrast-150'
  | 'xl:backdrop-contrast-150'
  | 'sm:backdrop-contrast-200'
  | 'md:backdrop-contrast-200'
  | 'mg:backdrop-contrast-200'
  | 'lg:backdrop-contrast-200'
  | 'xl:backdrop-contrast-200'
  | 'sm:backdrop-filter'
  | 'md:backdrop-filter'
  | 'mg:backdrop-filter'
  | 'lg:backdrop-filter'
  | 'xl:backdrop-filter'
  | 'sm:backdrop-filter-none'
  | 'md:backdrop-filter-none'
  | 'mg:backdrop-filter-none'
  | 'lg:backdrop-filter-none'
  | 'xl:backdrop-filter-none'
  | 'sm:backdrop-grayscale-0'
  | 'md:backdrop-grayscale-0'
  | 'mg:backdrop-grayscale-0'
  | 'lg:backdrop-grayscale-0'
  | 'xl:backdrop-grayscale-0'
  | 'sm:backdrop-grayscale'
  | 'md:backdrop-grayscale'
  | 'mg:backdrop-grayscale'
  | 'lg:backdrop-grayscale'
  | 'xl:backdrop-grayscale'
  | 'sm:backdrop-hue-rotate-0'
  | 'md:backdrop-hue-rotate-0'
  | 'mg:backdrop-hue-rotate-0'
  | 'lg:backdrop-hue-rotate-0'
  | 'xl:backdrop-hue-rotate-0'
  | 'sm:backdrop-hue-rotate-15'
  | 'md:backdrop-hue-rotate-15'
  | 'mg:backdrop-hue-rotate-15'
  | 'lg:backdrop-hue-rotate-15'
  | 'xl:backdrop-hue-rotate-15'
  | 'sm:backdrop-hue-rotate-30'
  | 'md:backdrop-hue-rotate-30'
  | 'mg:backdrop-hue-rotate-30'
  | 'lg:backdrop-hue-rotate-30'
  | 'xl:backdrop-hue-rotate-30'
  | 'sm:backdrop-hue-rotate-60'
  | 'md:backdrop-hue-rotate-60'
  | 'mg:backdrop-hue-rotate-60'
  | 'lg:backdrop-hue-rotate-60'
  | 'xl:backdrop-hue-rotate-60'
  | 'sm:backdrop-hue-rotate-90'
  | 'md:backdrop-hue-rotate-90'
  | 'mg:backdrop-hue-rotate-90'
  | 'lg:backdrop-hue-rotate-90'
  | 'xl:backdrop-hue-rotate-90'
  | 'sm:backdrop-hue-rotate-180'
  | 'md:backdrop-hue-rotate-180'
  | 'mg:backdrop-hue-rotate-180'
  | 'lg:backdrop-hue-rotate-180'
  | 'xl:backdrop-hue-rotate-180'
  | 'sm:-backdrop-hue-rotate-180'
  | 'md:-backdrop-hue-rotate-180'
  | 'mg:-backdrop-hue-rotate-180'
  | 'lg:-backdrop-hue-rotate-180'
  | 'xl:-backdrop-hue-rotate-180'
  | 'sm:-backdrop-hue-rotate-90'
  | 'md:-backdrop-hue-rotate-90'
  | 'mg:-backdrop-hue-rotate-90'
  | 'lg:-backdrop-hue-rotate-90'
  | 'xl:-backdrop-hue-rotate-90'
  | 'sm:-backdrop-hue-rotate-60'
  | 'md:-backdrop-hue-rotate-60'
  | 'mg:-backdrop-hue-rotate-60'
  | 'lg:-backdrop-hue-rotate-60'
  | 'xl:-backdrop-hue-rotate-60'
  | 'sm:-backdrop-hue-rotate-30'
  | 'md:-backdrop-hue-rotate-30'
  | 'mg:-backdrop-hue-rotate-30'
  | 'lg:-backdrop-hue-rotate-30'
  | 'xl:-backdrop-hue-rotate-30'
  | 'sm:-backdrop-hue-rotate-15'
  | 'md:-backdrop-hue-rotate-15'
  | 'mg:-backdrop-hue-rotate-15'
  | 'lg:-backdrop-hue-rotate-15'
  | 'xl:-backdrop-hue-rotate-15'
  | 'sm:backdrop-invert-0'
  | 'md:backdrop-invert-0'
  | 'mg:backdrop-invert-0'
  | 'lg:backdrop-invert-0'
  | 'xl:backdrop-invert-0'
  | 'sm:backdrop-invert'
  | 'md:backdrop-invert'
  | 'mg:backdrop-invert'
  | 'lg:backdrop-invert'
  | 'xl:backdrop-invert'
  | 'sm:backdrop-saturate-0'
  | 'md:backdrop-saturate-0'
  | 'mg:backdrop-saturate-0'
  | 'lg:backdrop-saturate-0'
  | 'xl:backdrop-saturate-0'
  | 'sm:backdrop-saturate-50'
  | 'md:backdrop-saturate-50'
  | 'mg:backdrop-saturate-50'
  | 'lg:backdrop-saturate-50'
  | 'xl:backdrop-saturate-50'
  | 'sm:backdrop-saturate-100'
  | 'md:backdrop-saturate-100'
  | 'mg:backdrop-saturate-100'
  | 'lg:backdrop-saturate-100'
  | 'xl:backdrop-saturate-100'
  | 'sm:backdrop-saturate-150'
  | 'md:backdrop-saturate-150'
  | 'mg:backdrop-saturate-150'
  | 'lg:backdrop-saturate-150'
  | 'xl:backdrop-saturate-150'
  | 'sm:backdrop-saturate-200'
  | 'md:backdrop-saturate-200'
  | 'mg:backdrop-saturate-200'
  | 'lg:backdrop-saturate-200'
  | 'xl:backdrop-saturate-200'
  | 'sm:backdrop-sepia-0'
  | 'md:backdrop-sepia-0'
  | 'mg:backdrop-sepia-0'
  | 'lg:backdrop-sepia-0'
  | 'xl:backdrop-sepia-0'
  | 'sm:backdrop-sepia'
  | 'md:backdrop-sepia'
  | 'mg:backdrop-sepia'
  | 'lg:backdrop-sepia'
  | 'xl:backdrop-sepia'
  | 'sm:bg-fixed'
  | 'md:bg-fixed'
  | 'mg:bg-fixed'
  | 'lg:bg-fixed'
  | 'xl:bg-fixed'
  | 'sm:bg-local'
  | 'md:bg-local'
  | 'mg:bg-local'
  | 'lg:bg-local'
  | 'xl:bg-local'
  | 'sm:bg-scroll'
  | 'md:bg-scroll'
  | 'mg:bg-scroll'
  | 'lg:bg-scroll'
  | 'xl:bg-scroll'
  | 'sm:bg-blend-normal'
  | 'md:bg-blend-normal'
  | 'mg:bg-blend-normal'
  | 'lg:bg-blend-normal'
  | 'xl:bg-blend-normal'
  | 'sm:bg-blend-multiply'
  | 'md:bg-blend-multiply'
  | 'mg:bg-blend-multiply'
  | 'lg:bg-blend-multiply'
  | 'xl:bg-blend-multiply'
  | 'sm:bg-blend-screen'
  | 'md:bg-blend-screen'
  | 'mg:bg-blend-screen'
  | 'lg:bg-blend-screen'
  | 'xl:bg-blend-screen'
  | 'sm:bg-blend-overlay'
  | 'md:bg-blend-overlay'
  | 'mg:bg-blend-overlay'
  | 'lg:bg-blend-overlay'
  | 'xl:bg-blend-overlay'
  | 'sm:bg-blend-darken'
  | 'md:bg-blend-darken'
  | 'mg:bg-blend-darken'
  | 'lg:bg-blend-darken'
  | 'xl:bg-blend-darken'
  | 'sm:bg-blend-lighten'
  | 'md:bg-blend-lighten'
  | 'mg:bg-blend-lighten'
  | 'lg:bg-blend-lighten'
  | 'xl:bg-blend-lighten'
  | 'sm:bg-blend-color-dodge'
  | 'md:bg-blend-color-dodge'
  | 'mg:bg-blend-color-dodge'
  | 'lg:bg-blend-color-dodge'
  | 'xl:bg-blend-color-dodge'
  | 'sm:bg-blend-color-burn'
  | 'md:bg-blend-color-burn'
  | 'mg:bg-blend-color-burn'
  | 'lg:bg-blend-color-burn'
  | 'xl:bg-blend-color-burn'
  | 'sm:bg-blend-hard-light'
  | 'md:bg-blend-hard-light'
  | 'mg:bg-blend-hard-light'
  | 'lg:bg-blend-hard-light'
  | 'xl:bg-blend-hard-light'
  | 'sm:bg-blend-soft-light'
  | 'md:bg-blend-soft-light'
  | 'mg:bg-blend-soft-light'
  | 'lg:bg-blend-soft-light'
  | 'xl:bg-blend-soft-light'
  | 'sm:bg-blend-difference'
  | 'md:bg-blend-difference'
  | 'mg:bg-blend-difference'
  | 'lg:bg-blend-difference'
  | 'xl:bg-blend-difference'
  | 'sm:bg-blend-exclusion'
  | 'md:bg-blend-exclusion'
  | 'mg:bg-blend-exclusion'
  | 'lg:bg-blend-exclusion'
  | 'xl:bg-blend-exclusion'
  | 'sm:bg-blend-hue'
  | 'md:bg-blend-hue'
  | 'mg:bg-blend-hue'
  | 'lg:bg-blend-hue'
  | 'xl:bg-blend-hue'
  | 'sm:bg-blend-saturation'
  | 'md:bg-blend-saturation'
  | 'mg:bg-blend-saturation'
  | 'lg:bg-blend-saturation'
  | 'xl:bg-blend-saturation'
  | 'sm:bg-blend-color'
  | 'md:bg-blend-color'
  | 'mg:bg-blend-color'
  | 'lg:bg-blend-color'
  | 'xl:bg-blend-color'
  | 'sm:bg-blend-luminosity'
  | 'md:bg-blend-luminosity'
  | 'mg:bg-blend-luminosity'
  | 'lg:bg-blend-luminosity'
  | 'xl:bg-blend-luminosity'
  | 'sm:bg-clip-border'
  | 'md:bg-clip-border'
  | 'mg:bg-clip-border'
  | 'lg:bg-clip-border'
  | 'xl:bg-clip-border'
  | 'sm:bg-clip-padding'
  | 'md:bg-clip-padding'
  | 'mg:bg-clip-padding'
  | 'lg:bg-clip-padding'
  | 'xl:bg-clip-padding'
  | 'sm:bg-clip-content'
  | 'md:bg-clip-content'
  | 'mg:bg-clip-content'
  | 'lg:bg-clip-content'
  | 'xl:bg-clip-content'
  | 'sm:bg-clip-text'
  | 'md:bg-clip-text'
  | 'mg:bg-clip-text'
  | 'lg:bg-clip-text'
  | 'xl:bg-clip-text'
  | 'sm:bg-transparent'
  | 'md:bg-transparent'
  | 'mg:bg-transparent'
  | 'lg:bg-transparent'
  | 'xl:bg-transparent'
  | 'group-hover:bg-transparent'
  | 'group'
  | 'focus-within:bg-transparent'
  | 'hover:bg-transparent'
  | 'focus:bg-transparent'
  | 'sm:bg-current'
  | 'md:bg-current'
  | 'mg:bg-current'
  | 'lg:bg-current'
  | 'xl:bg-current'
  | 'group-hover:bg-current'
  | 'focus-within:bg-current'
  | 'hover:bg-current'
  | 'focus:bg-current'
  | 'sm:bg-overlay'
  | 'md:bg-overlay'
  | 'mg:bg-overlay'
  | 'lg:bg-overlay'
  | 'xl:bg-overlay'
  | 'group-hover:bg-overlay'
  | 'focus-within:bg-overlay'
  | 'hover:bg-overlay'
  | 'focus:bg-overlay'
  | 'sm:bg-black'
  | 'md:bg-black'
  | 'mg:bg-black'
  | 'lg:bg-black'
  | 'xl:bg-black'
  | 'group-hover:bg-black'
  | 'focus-within:bg-black'
  | 'hover:bg-black'
  | 'focus:bg-black'
  | 'sm:bg-white'
  | 'md:bg-white'
  | 'mg:bg-white'
  | 'lg:bg-white'
  | 'xl:bg-white'
  | 'group-hover:bg-white'
  | 'focus-within:bg-white'
  | 'hover:bg-white'
  | 'focus:bg-white'
  | 'sm:bg-white-hover'
  | 'md:bg-white-hover'
  | 'mg:bg-white-hover'
  | 'lg:bg-white-hover'
  | 'xl:bg-white-hover'
  | 'group-hover:bg-white-hover'
  | 'focus-within:bg-white-hover'
  | 'hover:bg-white-hover'
  | 'focus:bg-white-hover'
  | 'sm:bg-white-pressed'
  | 'md:bg-white-pressed'
  | 'mg:bg-white-pressed'
  | 'lg:bg-white-pressed'
  | 'xl:bg-white-pressed'
  | 'group-hover:bg-white-pressed'
  | 'focus-within:bg-white-pressed'
  | 'hover:bg-white-pressed'
  | 'focus:bg-white-pressed'
  | 'sm:bg-product-acid'
  | 'md:bg-product-acid'
  | 'mg:bg-product-acid'
  | 'lg:bg-product-acid'
  | 'xl:bg-product-acid'
  | 'group-hover:bg-product-acid'
  | 'focus-within:bg-product-acid'
  | 'hover:bg-product-acid'
  | 'focus:bg-product-acid'
  | 'sm:bg-product-aura'
  | 'md:bg-product-aura'
  | 'mg:bg-product-aura'
  | 'lg:bg-product-aura'
  | 'xl:bg-product-aura'
  | 'group-hover:bg-product-aura'
  | 'focus-within:bg-product-aura'
  | 'hover:bg-product-aura'
  | 'focus:bg-product-aura'
  | 'sm:bg-product-azul'
  | 'md:bg-product-azul'
  | 'mg:bg-product-azul'
  | 'lg:bg-product-azul'
  | 'xl:bg-product-azul'
  | 'group-hover:bg-product-azul'
  | 'focus-within:bg-product-azul'
  | 'hover:bg-product-azul'
  | 'focus:bg-product-azul'
  | 'sm:bg-product-blanch'
  | 'md:bg-product-blanch'
  | 'mg:bg-product-blanch'
  | 'lg:bg-product-blanch'
  | 'xl:bg-product-blanch'
  | 'group-hover:bg-product-blanch'
  | 'focus-within:bg-product-blanch'
  | 'hover:bg-product-blanch'
  | 'focus:bg-product-blanch'
  | 'sm:bg-product-blue-salt'
  | 'md:bg-product-blue-salt'
  | 'mg:bg-product-blue-salt'
  | 'lg:bg-product-blue-salt'
  | 'xl:bg-product-blue-salt'
  | 'group-hover:bg-product-blue-salt'
  | 'focus-within:bg-product-blue-salt'
  | 'hover:bg-product-blue-salt'
  | 'focus:bg-product-blue-salt'
  | 'sm:bg-product-burgundy'
  | 'md:bg-product-burgundy'
  | 'mg:bg-product-burgundy'
  | 'lg:bg-product-burgundy'
  | 'xl:bg-product-burgundy'
  | 'group-hover:bg-product-burgundy'
  | 'focus-within:bg-product-burgundy'
  | 'hover:bg-product-burgundy'
  | 'focus:bg-product-burgundy'
  | 'sm:bg-product-butter-yellow'
  | 'md:bg-product-butter-yellow'
  | 'mg:bg-product-butter-yellow'
  | 'lg:bg-product-butter-yellow'
  | 'xl:bg-product-butter-yellow'
  | 'group-hover:bg-product-butter-yellow'
  | 'focus-within:bg-product-butter-yellow'
  | 'hover:bg-product-butter-yellow'
  | 'focus:bg-product-butter-yellow'
  | 'sm:bg-product-chai'
  | 'md:bg-product-chai'
  | 'mg:bg-product-chai'
  | 'lg:bg-product-chai'
  | 'xl:bg-product-chai'
  | 'group-hover:bg-product-chai'
  | 'focus-within:bg-product-chai'
  | 'hover:bg-product-chai'
  | 'focus:bg-product-chai'
  | 'sm:bg-product-char'
  | 'md:bg-product-char'
  | 'mg:bg-product-char'
  | 'lg:bg-product-char'
  | 'xl:bg-product-char'
  | 'group-hover:bg-product-char'
  | 'focus-within:bg-product-char'
  | 'hover:bg-product-char'
  | 'focus:bg-product-char'
  | 'sm:bg-product-charm'
  | 'md:bg-product-charm'
  | 'mg:bg-product-charm'
  | 'lg:bg-product-charm'
  | 'xl:bg-product-charm'
  | 'group-hover:bg-product-charm'
  | 'focus-within:bg-product-charm'
  | 'hover:bg-product-charm'
  | 'focus:bg-product-charm'
  | 'sm:bg-product-chickpea'
  | 'md:bg-product-chickpea'
  | 'mg:bg-product-chickpea'
  | 'lg:bg-product-chickpea'
  | 'xl:bg-product-chickpea'
  | 'group-hover:bg-product-chickpea'
  | 'focus-within:bg-product-chickpea'
  | 'hover:bg-product-chickpea'
  | 'focus:bg-product-chickpea'
  | 'sm:bg-product-cielo'
  | 'md:bg-product-cielo'
  | 'mg:bg-product-cielo'
  | 'lg:bg-product-cielo'
  | 'xl:bg-product-cielo'
  | 'group-hover:bg-product-cielo'
  | 'focus-within:bg-product-cielo'
  | 'hover:bg-product-cielo'
  | 'focus:bg-product-cielo'
  | 'sm:bg-product-clay'
  | 'md:bg-product-clay'
  | 'mg:bg-product-clay'
  | 'lg:bg-product-clay'
  | 'xl:bg-product-clay'
  | 'group-hover:bg-product-clay'
  | 'focus-within:bg-product-clay'
  | 'hover:bg-product-clay'
  | 'focus:bg-product-clay'
  | 'sm:bg-product-clear'
  | 'md:bg-product-clear'
  | 'mg:bg-product-clear'
  | 'lg:bg-product-clear'
  | 'xl:bg-product-clear'
  | 'group-hover:bg-product-clear'
  | 'focus-within:bg-product-clear'
  | 'hover:bg-product-clear'
  | 'focus:bg-product-clear'
  | 'sm:bg-product-coriander'
  | 'md:bg-product-coriander'
  | 'mg:bg-product-coriander'
  | 'lg:bg-product-coriander'
  | 'xl:bg-product-coriander'
  | 'group-hover:bg-product-coriander'
  | 'focus-within:bg-product-coriander'
  | 'hover:bg-product-coriander'
  | 'focus:bg-product-coriander'
  | 'sm:bg-product-cream'
  | 'md:bg-product-cream'
  | 'mg:bg-product-cream'
  | 'lg:bg-product-cream'
  | 'xl:bg-product-cream'
  | 'group-hover:bg-product-cream'
  | 'focus-within:bg-product-cream'
  | 'hover:bg-product-cream'
  | 'focus:bg-product-cream'
  | 'sm:bg-product-crescent'
  | 'md:bg-product-crescent'
  | 'mg:bg-product-crescent'
  | 'lg:bg-product-crescent'
  | 'xl:bg-product-crescent'
  | 'group-hover:bg-product-crescent'
  | 'focus-within:bg-product-crescent'
  | 'hover:bg-product-crescent'
  | 'focus:bg-product-crescent'
  | 'sm:bg-product-dawn'
  | 'md:bg-product-dawn'
  | 'mg:bg-product-dawn'
  | 'lg:bg-product-dawn'
  | 'xl:bg-product-dawn'
  | 'group-hover:bg-product-dawn'
  | 'focus-within:bg-product-dawn'
  | 'hover:bg-product-dawn'
  | 'focus:bg-product-dawn'
  | 'sm:bg-product-dusk'
  | 'md:bg-product-dusk'
  | 'mg:bg-product-dusk'
  | 'lg:bg-product-dusk'
  | 'xl:bg-product-dusk'
  | 'group-hover:bg-product-dusk'
  | 'focus-within:bg-product-dusk'
  | 'hover:bg-product-dusk'
  | 'focus:bg-product-dusk'
  | 'sm:bg-product-egg-yolk'
  | 'md:bg-product-egg-yolk'
  | 'mg:bg-product-egg-yolk'
  | 'lg:bg-product-egg-yolk'
  | 'xl:bg-product-egg-yolk'
  | 'group-hover:bg-product-egg-yolk'
  | 'focus-within:bg-product-egg-yolk'
  | 'hover:bg-product-egg-yolk'
  | 'focus:bg-product-egg-yolk'
  | 'sm:bg-product-espresso'
  | 'md:bg-product-espresso'
  | 'mg:bg-product-espresso'
  | 'lg:bg-product-espresso'
  | 'xl:bg-product-espresso'
  | 'group-hover:bg-product-espresso'
  | 'focus-within:bg-product-espresso'
  | 'hover:bg-product-espresso'
  | 'focus:bg-product-espresso'
  | 'sm:bg-product-eve'
  | 'md:bg-product-eve'
  | 'mg:bg-product-eve'
  | 'lg:bg-product-eve'
  | 'xl:bg-product-eve'
  | 'group-hover:bg-product-eve'
  | 'focus-within:bg-product-eve'
  | 'hover:bg-product-eve'
  | 'focus:bg-product-eve'
  | 'sm:bg-product-firecracker'
  | 'md:bg-product-firecracker'
  | 'mg:bg-product-firecracker'
  | 'lg:bg-product-firecracker'
  | 'xl:bg-product-firecracker'
  | 'group-hover:bg-product-firecracker'
  | 'focus-within:bg-product-firecracker'
  | 'hover:bg-product-firecracker'
  | 'focus:bg-product-firecracker'
  | 'sm:bg-product-forget-me-not-blue'
  | 'md:bg-product-forget-me-not-blue'
  | 'mg:bg-product-forget-me-not-blue'
  | 'lg:bg-product-forget-me-not-blue'
  | 'xl:bg-product-forget-me-not-blue'
  | 'group-hover:bg-product-forget-me-not-blue'
  | 'focus-within:bg-product-forget-me-not-blue'
  | 'hover:bg-product-forget-me-not-blue'
  | 'focus:bg-product-forget-me-not-blue'
  | 'sm:bg-product-gold'
  | 'md:bg-product-gold'
  | 'mg:bg-product-gold'
  | 'lg:bg-product-gold'
  | 'xl:bg-product-gold'
  | 'group-hover:bg-product-gold'
  | 'focus-within:bg-product-gold'
  | 'hover:bg-product-gold'
  | 'focus:bg-product-gold'
  | 'sm:bg-product-golden'
  | 'md:bg-product-golden'
  | 'mg:bg-product-golden'
  | 'lg:bg-product-golden'
  | 'xl:bg-product-golden'
  | 'group-hover:bg-product-golden'
  | 'focus-within:bg-product-golden'
  | 'hover:bg-product-golden'
  | 'focus:bg-product-golden'
  | 'sm:bg-product-heat'
  | 'md:bg-product-heat'
  | 'mg:bg-product-heat'
  | 'lg:bg-product-heat'
  | 'xl:bg-product-heat'
  | 'group-hover:bg-product-heat'
  | 'focus-within:bg-product-heat'
  | 'hover:bg-product-heat'
  | 'focus:bg-product-heat'
  | 'sm:bg-product-himalayan-salt'
  | 'md:bg-product-himalayan-salt'
  | 'mg:bg-product-himalayan-salt'
  | 'lg:bg-product-himalayan-salt'
  | 'xl:bg-product-himalayan-salt'
  | 'group-hover:bg-product-himalayan-salt'
  | 'focus-within:bg-product-himalayan-salt'
  | 'hover:bg-product-himalayan-salt'
  | 'focus:bg-product-himalayan-salt'
  | 'sm:bg-product-indigo'
  | 'md:bg-product-indigo'
  | 'mg:bg-product-indigo'
  | 'lg:bg-product-indigo'
  | 'xl:bg-product-indigo'
  | 'group-hover:bg-product-indigo'
  | 'focus-within:bg-product-indigo'
  | 'hover:bg-product-indigo'
  | 'focus:bg-product-indigo'
  | 'sm:bg-product-lavender'
  | 'md:bg-product-lavender'
  | 'mg:bg-product-lavender'
  | 'lg:bg-product-lavender'
  | 'xl:bg-product-lavender'
  | 'group-hover:bg-product-lavender'
  | 'focus-within:bg-product-lavender'
  | 'hover:bg-product-lavender'
  | 'focus:bg-product-lavender'
  | 'sm:bg-product-lavender-marble'
  | 'md:bg-product-lavender-marble'
  | 'mg:bg-product-lavender-marble'
  | 'lg:bg-product-lavender-marble'
  | 'xl:bg-product-lavender-marble'
  | 'group-hover:bg-product-lavender-marble'
  | 'focus-within:bg-product-lavender-marble'
  | 'hover:bg-product-lavender-marble'
  | 'focus:bg-product-lavender-marble'
  | 'sm:bg-product-midnight-marble'
  | 'md:bg-product-midnight-marble'
  | 'mg:bg-product-midnight-marble'
  | 'lg:bg-product-midnight-marble'
  | 'xl:bg-product-midnight-marble'
  | 'group-hover:bg-product-midnight-marble'
  | 'focus-within:bg-product-midnight-marble'
  | 'hover:bg-product-midnight-marble'
  | 'focus:bg-product-midnight-marble'
  | 'sm:bg-product-nougat'
  | 'md:bg-product-nougat'
  | 'mg:bg-product-nougat'
  | 'lg:bg-product-nougat'
  | 'xl:bg-product-nougat'
  | 'group-hover:bg-product-nougat'
  | 'focus-within:bg-product-nougat'
  | 'hover:bg-product-nougat'
  | 'focus:bg-product-nougat'
  | 'sm:bg-product-pistachio'
  | 'md:bg-product-pistachio'
  | 'mg:bg-product-pistachio'
  | 'lg:bg-product-pistachio'
  | 'xl:bg-product-pistachio'
  | 'group-hover:bg-product-pistachio'
  | 'focus-within:bg-product-pistachio'
  | 'hover:bg-product-pistachio'
  | 'focus:bg-product-pistachio'
  | 'sm:bg-product-rosa'
  | 'md:bg-product-rosa'
  | 'mg:bg-product-rosa'
  | 'lg:bg-product-rosa'
  | 'xl:bg-product-rosa'
  | 'group-hover:bg-product-rosa'
  | 'focus-within:bg-product-rosa'
  | 'hover:bg-product-rosa'
  | 'focus:bg-product-rosa'
  | 'sm:bg-product-rose-gold'
  | 'md:bg-product-rose-gold'
  | 'mg:bg-product-rose-gold'
  | 'lg:bg-product-rose-gold'
  | 'xl:bg-product-rose-gold'
  | 'group-hover:bg-product-rose-gold'
  | 'focus-within:bg-product-rose-gold'
  | 'hover:bg-product-rose-gold'
  | 'focus:bg-product-rose-gold'
  | 'sm:bg-product-rust'
  | 'md:bg-product-rust'
  | 'mg:bg-product-rust'
  | 'lg:bg-product-rust'
  | 'xl:bg-product-rust'
  | 'group-hover:bg-product-rust'
  | 'focus-within:bg-product-rust'
  | 'hover:bg-product-rust'
  | 'focus:bg-product-rust'
  | 'sm:bg-product-saffron'
  | 'md:bg-product-saffron'
  | 'mg:bg-product-saffron'
  | 'lg:bg-product-saffron'
  | 'xl:bg-product-saffron'
  | 'group-hover:bg-product-saffron'
  | 'focus-within:bg-product-saffron'
  | 'hover:bg-product-saffron'
  | 'focus:bg-product-saffron'
  | 'sm:bg-product-sage'
  | 'md:bg-product-sage'
  | 'mg:bg-product-sage'
  | 'lg:bg-product-sage'
  | 'xl:bg-product-sage'
  | 'group-hover:bg-product-sage'
  | 'focus-within:bg-product-sage'
  | 'hover:bg-product-sage'
  | 'focus:bg-product-sage'
  | 'sm:bg-product-sear'
  | 'md:bg-product-sear'
  | 'mg:bg-product-sear'
  | 'lg:bg-product-sear'
  | 'xl:bg-product-sear'
  | 'group-hover:bg-product-sear'
  | 'focus-within:bg-product-sear'
  | 'hover:bg-product-sear'
  | 'focus:bg-product-sear'
  | 'sm:bg-product-spice'
  | 'md:bg-product-spice'
  | 'mg:bg-product-spice'
  | 'lg:bg-product-spice'
  | 'xl:bg-product-spice'
  | 'group-hover:bg-product-spice'
  | 'focus-within:bg-product-spice'
  | 'hover:bg-product-spice'
  | 'focus:bg-product-spice'
  | 'sm:bg-product-steam'
  | 'md:bg-product-steam'
  | 'mg:bg-product-steam'
  | 'lg:bg-product-steam'
  | 'xl:bg-product-steam'
  | 'group-hover:bg-product-steam'
  | 'focus-within:bg-product-steam'
  | 'hover:bg-product-steam'
  | 'focus:bg-product-steam'
  | 'sm:bg-product-strawberry'
  | 'md:bg-product-strawberry'
  | 'mg:bg-product-strawberry'
  | 'lg:bg-product-strawberry'
  | 'xl:bg-product-strawberry'
  | 'group-hover:bg-product-strawberry'
  | 'focus-within:bg-product-strawberry'
  | 'hover:bg-product-strawberry'
  | 'focus:bg-product-strawberry'
  | 'sm:bg-product-sunrise'
  | 'md:bg-product-sunrise'
  | 'mg:bg-product-sunrise'
  | 'lg:bg-product-sunrise'
  | 'xl:bg-product-sunrise'
  | 'group-hover:bg-product-sunrise'
  | 'focus-within:bg-product-sunrise'
  | 'hover:bg-product-sunrise'
  | 'focus:bg-product-sunrise'
  | 'sm:bg-product-sunset'
  | 'md:bg-product-sunset'
  | 'mg:bg-product-sunset'
  | 'lg:bg-product-sunset'
  | 'xl:bg-product-sunset'
  | 'group-hover:bg-product-sunset'
  | 'focus-within:bg-product-sunset'
  | 'hover:bg-product-sunset'
  | 'focus:bg-product-sunset'
  | 'sm:bg-product-sunset-marble'
  | 'md:bg-product-sunset-marble'
  | 'mg:bg-product-sunset-marble'
  | 'lg:bg-product-sunset-marble'
  | 'xl:bg-product-sunset-marble'
  | 'group-hover:bg-product-sunset-marble'
  | 'focus-within:bg-product-sunset-marble'
  | 'hover:bg-product-sunset-marble'
  | 'focus:bg-product-sunset-marble'
  | 'sm:bg-product-terracotta'
  | 'md:bg-product-terracotta'
  | 'mg:bg-product-terracotta'
  | 'lg:bg-product-terracotta'
  | 'xl:bg-product-terracotta'
  | 'group-hover:bg-product-terracotta'
  | 'focus-within:bg-product-terracotta'
  | 'hover:bg-product-terracotta'
  | 'focus:bg-product-terracotta'
  | 'sm:bg-product-tierra'
  | 'md:bg-product-tierra'
  | 'mg:bg-product-tierra'
  | 'lg:bg-product-tierra'
  | 'xl:bg-product-tierra'
  | 'group-hover:bg-product-tierra'
  | 'focus-within:bg-product-tierra'
  | 'hover:bg-product-tierra'
  | 'focus:bg-product-tierra'
  | 'sm:bg-product-turmeric'
  | 'md:bg-product-turmeric'
  | 'mg:bg-product-turmeric'
  | 'lg:bg-product-turmeric'
  | 'xl:bg-product-turmeric'
  | 'group-hover:bg-product-turmeric'
  | 'focus-within:bg-product-turmeric'
  | 'hover:bg-product-turmeric'
  | 'focus:bg-product-turmeric'
  | 'sm:bg-product-turqoise'
  | 'md:bg-product-turqoise'
  | 'mg:bg-product-turqoise'
  | 'lg:bg-product-turqoise'
  | 'xl:bg-product-turqoise'
  | 'group-hover:bg-product-turqoise'
  | 'focus-within:bg-product-turqoise'
  | 'hover:bg-product-turqoise'
  | 'focus:bg-product-turqoise'
  | 'sm:bg-product-twilight'
  | 'md:bg-product-twilight'
  | 'mg:bg-product-twilight'
  | 'lg:bg-product-twilight'
  | 'xl:bg-product-twilight'
  | 'group-hover:bg-product-twilight'
  | 'focus-within:bg-product-twilight'
  | 'hover:bg-product-twilight'
  | 'focus:bg-product-twilight'
  | 'sm:bg-product-walnut'
  | 'md:bg-product-walnut'
  | 'mg:bg-product-walnut'
  | 'lg:bg-product-walnut'
  | 'xl:bg-product-walnut'
  | 'group-hover:bg-product-walnut'
  | 'focus-within:bg-product-walnut'
  | 'hover:bg-product-walnut'
  | 'focus:bg-product-walnut'
  | 'sm:bg-product-warm-white'
  | 'md:bg-product-warm-white'
  | 'mg:bg-product-warm-white'
  | 'lg:bg-product-warm-white'
  | 'xl:bg-product-warm-white'
  | 'group-hover:bg-product-warm-white'
  | 'focus-within:bg-product-warm-white'
  | 'hover:bg-product-warm-white'
  | 'focus:bg-product-warm-white'
  | 'sm:bg-product-zest'
  | 'md:bg-product-zest'
  | 'mg:bg-product-zest'
  | 'lg:bg-product-zest'
  | 'xl:bg-product-zest'
  | 'group-hover:bg-product-zest'
  | 'focus-within:bg-product-zest'
  | 'hover:bg-product-zest'
  | 'focus:bg-product-zest'
  | 'sm:bg-placeholder'
  | 'md:bg-placeholder'
  | 'mg:bg-placeholder'
  | 'lg:bg-placeholder'
  | 'xl:bg-placeholder'
  | 'group-hover:bg-placeholder'
  | 'focus-within:bg-placeholder'
  | 'hover:bg-placeholder'
  | 'focus:bg-placeholder'
  | 'sm:bg-interactive-bone'
  | 'md:bg-interactive-bone'
  | 'mg:bg-interactive-bone'
  | 'lg:bg-interactive-bone'
  | 'xl:bg-interactive-bone'
  | 'group-hover:bg-interactive-bone'
  | 'focus-within:bg-interactive-bone'
  | 'hover:bg-interactive-bone'
  | 'focus:bg-interactive-bone'
  | 'sm:bg-interactive-brick'
  | 'md:bg-interactive-brick'
  | 'mg:bg-interactive-brick'
  | 'lg:bg-interactive-brick'
  | 'xl:bg-interactive-brick'
  | 'group-hover:bg-interactive-brick'
  | 'focus-within:bg-interactive-brick'
  | 'hover:bg-interactive-brick'
  | 'focus:bg-interactive-brick'
  | 'sm:bg-interactive-char'
  | 'md:bg-interactive-char'
  | 'mg:bg-interactive-char'
  | 'lg:bg-interactive-char'
  | 'xl:bg-interactive-char'
  | 'group-hover:bg-interactive-char'
  | 'focus-within:bg-interactive-char'
  | 'hover:bg-interactive-char'
  | 'focus:bg-interactive-char'
  | 'sm:bg-interactive-white'
  | 'md:bg-interactive-white'
  | 'mg:bg-interactive-white'
  | 'lg:bg-interactive-white'
  | 'xl:bg-interactive-white'
  | 'group-hover:bg-interactive-white'
  | 'focus-within:bg-interactive-white'
  | 'hover:bg-interactive-white'
  | 'focus:bg-interactive-white'
  | 'sm:bg-interactive-disabled'
  | 'md:bg-interactive-disabled'
  | 'mg:bg-interactive-disabled'
  | 'lg:bg-interactive-disabled'
  | 'xl:bg-interactive-disabled'
  | 'group-hover:bg-interactive-disabled'
  | 'focus-within:bg-interactive-disabled'
  | 'hover:bg-interactive-disabled'
  | 'focus:bg-interactive-disabled'
  | 'sm:bg-interactive-error'
  | 'md:bg-interactive-error'
  | 'mg:bg-interactive-error'
  | 'lg:bg-interactive-error'
  | 'xl:bg-interactive-error'
  | 'group-hover:bg-interactive-error'
  | 'focus-within:bg-interactive-error'
  | 'hover:bg-interactive-error'
  | 'focus:bg-interactive-error'
  | 'sm:bg-interactive-outline'
  | 'md:bg-interactive-outline'
  | 'mg:bg-interactive-outline'
  | 'lg:bg-interactive-outline'
  | 'xl:bg-interactive-outline'
  | 'group-hover:bg-interactive-outline'
  | 'focus-within:bg-interactive-outline'
  | 'hover:bg-interactive-outline'
  | 'focus:bg-interactive-outline'
  | 'sm:bg-translucent-char'
  | 'md:bg-translucent-char'
  | 'mg:bg-translucent-char'
  | 'lg:bg-translucent-char'
  | 'xl:bg-translucent-char'
  | 'group-hover:bg-translucent-char'
  | 'focus-within:bg-translucent-char'
  | 'hover:bg-translucent-char'
  | 'focus:bg-translucent-char'
  | 'sm:bg-translucent-white'
  | 'md:bg-translucent-white'
  | 'mg:bg-translucent-white'
  | 'lg:bg-translucent-white'
  | 'xl:bg-translucent-white'
  | 'group-hover:bg-translucent-white'
  | 'focus-within:bg-translucent-white'
  | 'hover:bg-translucent-white'
  | 'focus:bg-translucent-white'
  | 'sm:bg-char-50'
  | 'md:bg-char-50'
  | 'mg:bg-char-50'
  | 'lg:bg-char-50'
  | 'xl:bg-char-50'
  | 'group-hover:bg-char-50'
  | 'focus-within:bg-char-50'
  | 'hover:bg-char-50'
  | 'focus:bg-char-50'
  | 'sm:bg-char-100'
  | 'md:bg-char-100'
  | 'mg:bg-char-100'
  | 'lg:bg-char-100'
  | 'xl:bg-char-100'
  | 'group-hover:bg-char-100'
  | 'focus-within:bg-char-100'
  | 'hover:bg-char-100'
  | 'focus:bg-char-100'
  | 'sm:bg-char-200'
  | 'md:bg-char-200'
  | 'mg:bg-char-200'
  | 'lg:bg-char-200'
  | 'xl:bg-char-200'
  | 'group-hover:bg-char-200'
  | 'focus-within:bg-char-200'
  | 'hover:bg-char-200'
  | 'focus:bg-char-200'
  | 'sm:bg-char-300'
  | 'md:bg-char-300'
  | 'mg:bg-char-300'
  | 'lg:bg-char-300'
  | 'xl:bg-char-300'
  | 'group-hover:bg-char-300'
  | 'focus-within:bg-char-300'
  | 'hover:bg-char-300'
  | 'focus:bg-char-300'
  | 'sm:bg-char-400'
  | 'md:bg-char-400'
  | 'mg:bg-char-400'
  | 'lg:bg-char-400'
  | 'xl:bg-char-400'
  | 'group-hover:bg-char-400'
  | 'focus-within:bg-char-400'
  | 'hover:bg-char-400'
  | 'focus:bg-char-400'
  | 'sm:bg-char-500'
  | 'md:bg-char-500'
  | 'mg:bg-char-500'
  | 'lg:bg-char-500'
  | 'xl:bg-char-500'
  | 'group-hover:bg-char-500'
  | 'focus-within:bg-char-500'
  | 'hover:bg-char-500'
  | 'focus:bg-char-500'
  | 'sm:bg-char-600'
  | 'md:bg-char-600'
  | 'mg:bg-char-600'
  | 'lg:bg-char-600'
  | 'xl:bg-char-600'
  | 'group-hover:bg-char-600'
  | 'focus-within:bg-char-600'
  | 'hover:bg-char-600'
  | 'focus:bg-char-600'
  | 'sm:bg-char-700'
  | 'md:bg-char-700'
  | 'mg:bg-char-700'
  | 'lg:bg-char-700'
  | 'xl:bg-char-700'
  | 'group-hover:bg-char-700'
  | 'focus-within:bg-char-700'
  | 'hover:bg-char-700'
  | 'focus:bg-char-700'
  | 'sm:bg-char-800'
  | 'md:bg-char-800'
  | 'mg:bg-char-800'
  | 'lg:bg-char-800'
  | 'xl:bg-char-800'
  | 'group-hover:bg-char-800'
  | 'focus-within:bg-char-800'
  | 'hover:bg-char-800'
  | 'focus:bg-char-800'
  | 'sm:bg-char-900'
  | 'md:bg-char-900'
  | 'mg:bg-char-900'
  | 'lg:bg-char-900'
  | 'xl:bg-char-900'
  | 'group-hover:bg-char-900'
  | 'focus-within:bg-char-900'
  | 'hover:bg-char-900'
  | 'focus:bg-char-900'
  | 'sm:bg-bone-50'
  | 'md:bg-bone-50'
  | 'mg:bg-bone-50'
  | 'lg:bg-bone-50'
  | 'xl:bg-bone-50'
  | 'group-hover:bg-bone-50'
  | 'focus-within:bg-bone-50'
  | 'hover:bg-bone-50'
  | 'focus:bg-bone-50'
  | 'sm:bg-bone-100'
  | 'md:bg-bone-100'
  | 'mg:bg-bone-100'
  | 'lg:bg-bone-100'
  | 'xl:bg-bone-100'
  | 'group-hover:bg-bone-100'
  | 'focus-within:bg-bone-100'
  | 'hover:bg-bone-100'
  | 'focus:bg-bone-100'
  | 'sm:bg-bone-200'
  | 'md:bg-bone-200'
  | 'mg:bg-bone-200'
  | 'lg:bg-bone-200'
  | 'xl:bg-bone-200'
  | 'group-hover:bg-bone-200'
  | 'focus-within:bg-bone-200'
  | 'hover:bg-bone-200'
  | 'focus:bg-bone-200'
  | 'sm:bg-bone-300'
  | 'md:bg-bone-300'
  | 'mg:bg-bone-300'
  | 'lg:bg-bone-300'
  | 'xl:bg-bone-300'
  | 'group-hover:bg-bone-300'
  | 'focus-within:bg-bone-300'
  | 'hover:bg-bone-300'
  | 'focus:bg-bone-300'
  | 'sm:bg-bone-400'
  | 'md:bg-bone-400'
  | 'mg:bg-bone-400'
  | 'lg:bg-bone-400'
  | 'xl:bg-bone-400'
  | 'group-hover:bg-bone-400'
  | 'focus-within:bg-bone-400'
  | 'hover:bg-bone-400'
  | 'focus:bg-bone-400'
  | 'sm:bg-bone-500'
  | 'md:bg-bone-500'
  | 'mg:bg-bone-500'
  | 'lg:bg-bone-500'
  | 'xl:bg-bone-500'
  | 'group-hover:bg-bone-500'
  | 'focus-within:bg-bone-500'
  | 'hover:bg-bone-500'
  | 'focus:bg-bone-500'
  | 'sm:bg-bone-600'
  | 'md:bg-bone-600'
  | 'mg:bg-bone-600'
  | 'lg:bg-bone-600'
  | 'xl:bg-bone-600'
  | 'group-hover:bg-bone-600'
  | 'focus-within:bg-bone-600'
  | 'hover:bg-bone-600'
  | 'focus:bg-bone-600'
  | 'sm:bg-bone-700'
  | 'md:bg-bone-700'
  | 'mg:bg-bone-700'
  | 'lg:bg-bone-700'
  | 'xl:bg-bone-700'
  | 'group-hover:bg-bone-700'
  | 'focus-within:bg-bone-700'
  | 'hover:bg-bone-700'
  | 'focus:bg-bone-700'
  | 'sm:bg-bone-800'
  | 'md:bg-bone-800'
  | 'mg:bg-bone-800'
  | 'lg:bg-bone-800'
  | 'xl:bg-bone-800'
  | 'group-hover:bg-bone-800'
  | 'focus-within:bg-bone-800'
  | 'hover:bg-bone-800'
  | 'focus:bg-bone-800'
  | 'sm:bg-bone-900'
  | 'md:bg-bone-900'
  | 'mg:bg-bone-900'
  | 'lg:bg-bone-900'
  | 'xl:bg-bone-900'
  | 'group-hover:bg-bone-900'
  | 'focus-within:bg-bone-900'
  | 'hover:bg-bone-900'
  | 'focus:bg-bone-900'
  | 'sm:bg-brick-50'
  | 'md:bg-brick-50'
  | 'mg:bg-brick-50'
  | 'lg:bg-brick-50'
  | 'xl:bg-brick-50'
  | 'group-hover:bg-brick-50'
  | 'focus-within:bg-brick-50'
  | 'hover:bg-brick-50'
  | 'focus:bg-brick-50'
  | 'sm:bg-brick-300'
  | 'md:bg-brick-300'
  | 'mg:bg-brick-300'
  | 'lg:bg-brick-300'
  | 'xl:bg-brick-300'
  | 'group-hover:bg-brick-300'
  | 'focus-within:bg-brick-300'
  | 'hover:bg-brick-300'
  | 'focus:bg-brick-300'
  | 'sm:bg-brick-500'
  | 'md:bg-brick-500'
  | 'mg:bg-brick-500'
  | 'lg:bg-brick-500'
  | 'xl:bg-brick-500'
  | 'group-hover:bg-brick-500'
  | 'focus-within:bg-brick-500'
  | 'hover:bg-brick-500'
  | 'focus:bg-brick-500'
  | 'sm:bg-brick-700'
  | 'md:bg-brick-700'
  | 'mg:bg-brick-700'
  | 'lg:bg-brick-700'
  | 'xl:bg-brick-700'
  | 'group-hover:bg-brick-700'
  | 'focus-within:bg-brick-700'
  | 'hover:bg-brick-700'
  | 'focus:bg-brick-700'
  | 'sm:bg-brick-900'
  | 'md:bg-brick-900'
  | 'mg:bg-brick-900'
  | 'lg:bg-brick-900'
  | 'xl:bg-brick-900'
  | 'group-hover:bg-brick-900'
  | 'focus-within:bg-brick-900'
  | 'hover:bg-brick-900'
  | 'focus:bg-brick-900'
  | 'sm:bg-sage-50'
  | 'md:bg-sage-50'
  | 'mg:bg-sage-50'
  | 'lg:bg-sage-50'
  | 'xl:bg-sage-50'
  | 'group-hover:bg-sage-50'
  | 'focus-within:bg-sage-50'
  | 'hover:bg-sage-50'
  | 'focus:bg-sage-50'
  | 'sm:bg-sage-300'
  | 'md:bg-sage-300'
  | 'mg:bg-sage-300'
  | 'lg:bg-sage-300'
  | 'xl:bg-sage-300'
  | 'group-hover:bg-sage-300'
  | 'focus-within:bg-sage-300'
  | 'hover:bg-sage-300'
  | 'focus:bg-sage-300'
  | 'sm:bg-sage-500'
  | 'md:bg-sage-500'
  | 'mg:bg-sage-500'
  | 'lg:bg-sage-500'
  | 'xl:bg-sage-500'
  | 'group-hover:bg-sage-500'
  | 'focus-within:bg-sage-500'
  | 'hover:bg-sage-500'
  | 'focus:bg-sage-500'
  | 'sm:bg-sage-700'
  | 'md:bg-sage-700'
  | 'mg:bg-sage-700'
  | 'lg:bg-sage-700'
  | 'xl:bg-sage-700'
  | 'group-hover:bg-sage-700'
  | 'focus-within:bg-sage-700'
  | 'hover:bg-sage-700'
  | 'focus:bg-sage-700'
  | 'sm:bg-sage-900'
  | 'md:bg-sage-900'
  | 'mg:bg-sage-900'
  | 'lg:bg-sage-900'
  | 'xl:bg-sage-900'
  | 'group-hover:bg-sage-900'
  | 'focus-within:bg-sage-900'
  | 'hover:bg-sage-900'
  | 'focus:bg-sage-900'
  | 'sm:bg-blue-50'
  | 'md:bg-blue-50'
  | 'mg:bg-blue-50'
  | 'lg:bg-blue-50'
  | 'xl:bg-blue-50'
  | 'group-hover:bg-blue-50'
  | 'focus-within:bg-blue-50'
  | 'hover:bg-blue-50'
  | 'focus:bg-blue-50'
  | 'sm:bg-blue-300'
  | 'md:bg-blue-300'
  | 'mg:bg-blue-300'
  | 'lg:bg-blue-300'
  | 'xl:bg-blue-300'
  | 'group-hover:bg-blue-300'
  | 'focus-within:bg-blue-300'
  | 'hover:bg-blue-300'
  | 'focus:bg-blue-300'
  | 'sm:bg-blue-500'
  | 'md:bg-blue-500'
  | 'mg:bg-blue-500'
  | 'lg:bg-blue-500'
  | 'xl:bg-blue-500'
  | 'group-hover:bg-blue-500'
  | 'focus-within:bg-blue-500'
  | 'hover:bg-blue-500'
  | 'focus:bg-blue-500'
  | 'sm:bg-blue-700'
  | 'md:bg-blue-700'
  | 'mg:bg-blue-700'
  | 'lg:bg-blue-700'
  | 'xl:bg-blue-700'
  | 'group-hover:bg-blue-700'
  | 'focus-within:bg-blue-700'
  | 'hover:bg-blue-700'
  | 'focus:bg-blue-700'
  | 'sm:bg-blue-900'
  | 'md:bg-blue-900'
  | 'mg:bg-blue-900'
  | 'lg:bg-blue-900'
  | 'xl:bg-blue-900'
  | 'group-hover:bg-blue-900'
  | 'focus-within:bg-blue-900'
  | 'hover:bg-blue-900'
  | 'focus:bg-blue-900'
  | 'sm:bg-misc-bright-blue'
  | 'md:bg-misc-bright-blue'
  | 'mg:bg-misc-bright-blue'
  | 'lg:bg-misc-bright-blue'
  | 'xl:bg-misc-bright-blue'
  | 'group-hover:bg-misc-bright-blue'
  | 'focus-within:bg-misc-bright-blue'
  | 'hover:bg-misc-bright-blue'
  | 'focus:bg-misc-bright-blue'
  | 'sm:bg-misc-focus'
  | 'md:bg-misc-focus'
  | 'mg:bg-misc-focus'
  | 'lg:bg-misc-focus'
  | 'xl:bg-misc-focus'
  | 'group-hover:bg-misc-focus'
  | 'focus-within:bg-misc-focus'
  | 'hover:bg-misc-focus'
  | 'focus:bg-misc-focus'
  | 'sm:bg-misc-legal-blue'
  | 'md:bg-misc-legal-blue'
  | 'mg:bg-misc-legal-blue'
  | 'lg:bg-misc-legal-blue'
  | 'xl:bg-misc-legal-blue'
  | 'group-hover:bg-misc-legal-blue'
  | 'focus-within:bg-misc-legal-blue'
  | 'hover:bg-misc-legal-blue'
  | 'focus:bg-misc-legal-blue'
  | 'sm:bg-misc-neutral'
  | 'md:bg-misc-neutral'
  | 'mg:bg-misc-neutral'
  | 'lg:bg-misc-neutral'
  | 'xl:bg-misc-neutral'
  | 'group-hover:bg-misc-neutral'
  | 'focus-within:bg-misc-neutral'
  | 'hover:bg-misc-neutral'
  | 'focus:bg-misc-neutral'
  | 'sm:bg-misc-yellow-orange'
  | 'md:bg-misc-yellow-orange'
  | 'mg:bg-misc-yellow-orange'
  | 'lg:bg-misc-yellow-orange'
  | 'xl:bg-misc-yellow-orange'
  | 'group-hover:bg-misc-yellow-orange'
  | 'focus-within:bg-misc-yellow-orange'
  | 'hover:bg-misc-yellow-orange'
  | 'focus:bg-misc-yellow-orange'
  | 'sm:bg-none'
  | 'md:bg-none'
  | 'mg:bg-none'
  | 'lg:bg-none'
  | 'xl:bg-none'
  | 'sm:bg-gradient-to-t'
  | 'md:bg-gradient-to-t'
  | 'mg:bg-gradient-to-t'
  | 'lg:bg-gradient-to-t'
  | 'xl:bg-gradient-to-t'
  | 'sm:bg-gradient-to-tr'
  | 'md:bg-gradient-to-tr'
  | 'mg:bg-gradient-to-tr'
  | 'lg:bg-gradient-to-tr'
  | 'xl:bg-gradient-to-tr'
  | 'sm:bg-gradient-to-r'
  | 'md:bg-gradient-to-r'
  | 'mg:bg-gradient-to-r'
  | 'lg:bg-gradient-to-r'
  | 'xl:bg-gradient-to-r'
  | 'sm:bg-gradient-to-br'
  | 'md:bg-gradient-to-br'
  | 'mg:bg-gradient-to-br'
  | 'lg:bg-gradient-to-br'
  | 'xl:bg-gradient-to-br'
  | 'sm:bg-gradient-to-b'
  | 'md:bg-gradient-to-b'
  | 'mg:bg-gradient-to-b'
  | 'lg:bg-gradient-to-b'
  | 'xl:bg-gradient-to-b'
  | 'sm:bg-gradient-to-bl'
  | 'md:bg-gradient-to-bl'
  | 'mg:bg-gradient-to-bl'
  | 'lg:bg-gradient-to-bl'
  | 'xl:bg-gradient-to-bl'
  | 'sm:bg-gradient-to-l'
  | 'md:bg-gradient-to-l'
  | 'mg:bg-gradient-to-l'
  | 'lg:bg-gradient-to-l'
  | 'xl:bg-gradient-to-l'
  | 'sm:bg-gradient-to-tl'
  | 'md:bg-gradient-to-tl'
  | 'mg:bg-gradient-to-tl'
  | 'lg:bg-gradient-to-tl'
  | 'xl:bg-gradient-to-tl'
  | 'sm:bg-product-blue-salt-char'
  | 'md:bg-product-blue-salt-char'
  | 'mg:bg-product-blue-salt-char'
  | 'lg:bg-product-blue-salt-char'
  | 'xl:bg-product-blue-salt-char'
  | 'sm:bg-product-brushed'
  | 'md:bg-product-brushed'
  | 'mg:bg-product-brushed'
  | 'lg:bg-product-brushed'
  | 'xl:bg-product-brushed'
  | 'sm:bg-product-brushed-blue-salt'
  | 'md:bg-product-brushed-blue-salt'
  | 'mg:bg-product-brushed-blue-salt'
  | 'lg:bg-product-brushed-blue-salt'
  | 'xl:bg-product-brushed-blue-salt'
  | 'sm:bg-product-brushed-char'
  | 'md:bg-product-brushed-char'
  | 'mg:bg-product-brushed-char'
  | 'lg:bg-product-brushed-char'
  | 'xl:bg-product-brushed-char'
  | 'sm:bg-product-brushed-sage'
  | 'md:bg-product-brushed-sage'
  | 'mg:bg-product-brushed-sage'
  | 'lg:bg-product-brushed-sage'
  | 'xl:bg-product-brushed-sage'
  | 'sm:bg-product-brushed-spice'
  | 'md:bg-product-brushed-spice'
  | 'mg:bg-product-brushed-spice'
  | 'lg:bg-product-brushed-spice'
  | 'xl:bg-product-brushed-spice'
  | 'sm:bg-product-brushed-steam'
  | 'md:bg-product-brushed-steam'
  | 'mg:bg-product-brushed-steam'
  | 'lg:bg-product-brushed-steam'
  | 'xl:bg-product-brushed-steam'
  | 'sm:bg-product-char-blue-salt'
  | 'md:bg-product-char-blue-salt'
  | 'mg:bg-product-char-blue-salt'
  | 'lg:bg-product-char-blue-salt'
  | 'xl:bg-product-char-blue-salt'
  | 'sm:bg-product-chrome'
  | 'md:bg-product-chrome'
  | 'mg:bg-product-chrome'
  | 'lg:bg-product-chrome'
  | 'xl:bg-product-chrome'
  | 'sm:bg-product-chrome-blue-salt'
  | 'md:bg-product-chrome-blue-salt'
  | 'mg:bg-product-chrome-blue-salt'
  | 'lg:bg-product-chrome-blue-salt'
  | 'xl:bg-product-chrome-blue-salt'
  | 'sm:bg-product-chrome-char'
  | 'md:bg-product-chrome-char'
  | 'mg:bg-product-chrome-char'
  | 'lg:bg-product-chrome-char'
  | 'xl:bg-product-chrome-char'
  | 'sm:bg-product-chrome-gold'
  | 'md:bg-product-chrome-gold'
  | 'mg:bg-product-chrome-gold'
  | 'lg:bg-product-chrome-gold'
  | 'xl:bg-product-chrome-gold'
  | 'sm:bg-product-chrome-lavender'
  | 'md:bg-product-chrome-lavender'
  | 'mg:bg-product-chrome-lavender'
  | 'lg:bg-product-chrome-lavender'
  | 'xl:bg-product-chrome-lavender'
  | 'sm:bg-product-chrome-sage'
  | 'md:bg-product-chrome-sage'
  | 'mg:bg-product-chrome-sage'
  | 'lg:bg-product-chrome-sage'
  | 'xl:bg-product-chrome-sage'
  | 'sm:bg-product-chrome-spice'
  | 'md:bg-product-chrome-spice'
  | 'mg:bg-product-chrome-spice'
  | 'lg:bg-product-chrome-spice'
  | 'xl:bg-product-chrome-spice'
  | 'sm:bg-product-chrome-steam'
  | 'md:bg-product-chrome-steam'
  | 'mg:bg-product-chrome-steam'
  | 'lg:bg-product-chrome-steam'
  | 'xl:bg-product-chrome-steam'
  | 'sm:bg-product-clear-sunset'
  | 'md:bg-product-clear-sunset'
  | 'mg:bg-product-clear-sunset'
  | 'lg:bg-product-clear-sunset'
  | 'xl:bg-product-clear-sunset'
  | 'sm:bg-product-cool'
  | 'md:bg-product-cool'
  | 'mg:bg-product-cool'
  | 'lg:bg-product-cool'
  | 'xl:bg-product-cool'
  | 'sm:bg-product-crossed-out-char'
  | 'md:bg-product-crossed-out-char'
  | 'mg:bg-product-crossed-out-char'
  | 'lg:bg-product-crossed-out-char'
  | 'xl:bg-product-crossed-out-char'
  | 'sm:bg-product-crossed-out-white'
  | 'md:bg-product-crossed-out-white'
  | 'mg:bg-product-crossed-out-white'
  | 'lg:bg-product-crossed-out-white'
  | 'xl:bg-product-crossed-out-white'
  | 'sm:bg-product-day-rosa'
  | 'md:bg-product-day-rosa'
  | 'mg:bg-product-day-rosa'
  | 'lg:bg-product-day-rosa'
  | 'xl:bg-product-day-rosa'
  | 'sm:bg-product-deep-blend'
  | 'md:bg-product-deep-blend'
  | 'mg:bg-product-deep-blend'
  | 'lg:bg-product-deep-blend'
  | 'xl:bg-product-deep-blend'
  | 'sm:bg-product-gold'
  | 'md:bg-product-gold'
  | 'mg:bg-product-gold'
  | 'lg:bg-product-gold'
  | 'xl:bg-product-gold'
  | 'sm:bg-product-gold-blue-salt'
  | 'md:bg-product-gold-blue-salt'
  | 'mg:bg-product-gold-blue-salt'
  | 'lg:bg-product-gold-blue-salt'
  | 'xl:bg-product-gold-blue-salt'
  | 'sm:bg-product-gold-char'
  | 'md:bg-product-gold-char'
  | 'mg:bg-product-gold-char'
  | 'lg:bg-product-gold-char'
  | 'xl:bg-product-gold-char'
  | 'sm:bg-product-gold-lavender'
  | 'md:bg-product-gold-lavender'
  | 'mg:bg-product-gold-lavender'
  | 'lg:bg-product-gold-lavender'
  | 'xl:bg-product-gold-lavender'
  | 'sm:bg-product-gold-sage'
  | 'md:bg-product-gold-sage'
  | 'mg:bg-product-gold-sage'
  | 'lg:bg-product-gold-sage'
  | 'xl:bg-product-gold-sage'
  | 'sm:bg-product-gold-spice'
  | 'md:bg-product-gold-spice'
  | 'mg:bg-product-gold-spice'
  | 'lg:bg-product-gold-spice'
  | 'xl:bg-product-gold-spice'
  | 'sm:bg-product-gold-steam'
  | 'md:bg-product-gold-steam'
  | 'mg:bg-product-gold-steam'
  | 'lg:bg-product-gold-steam'
  | 'xl:bg-product-gold-steam'
  | 'sm:bg-product-iridescent'
  | 'md:bg-product-iridescent'
  | 'mg:bg-product-iridescent'
  | 'lg:bg-product-iridescent'
  | 'xl:bg-product-iridescent'
  | 'sm:bg-product-lavender-marble'
  | 'md:bg-product-lavender-marble'
  | 'mg:bg-product-lavender-marble'
  | 'lg:bg-product-lavender-marble'
  | 'xl:bg-product-lavender-marble'
  | 'sm:bg-product-lavender-steam'
  | 'md:bg-product-lavender-steam'
  | 'mg:bg-product-lavender-steam'
  | 'lg:bg-product-lavender-steam'
  | 'xl:bg-product-lavender-steam'
  | 'sm:bg-product-midnight-marble'
  | 'md:bg-product-midnight-marble'
  | 'mg:bg-product-midnight-marble'
  | 'lg:bg-product-midnight-marble'
  | 'xl:bg-product-midnight-marble'
  | 'sm:bg-product-mixed'
  | 'md:bg-product-mixed'
  | 'mg:bg-product-mixed'
  | 'lg:bg-product-mixed'
  | 'xl:bg-product-mixed'
  | 'sm:bg-product-mixed-spices'
  | 'md:bg-product-mixed-spices'
  | 'mg:bg-product-mixed-spices'
  | 'lg:bg-product-mixed-spices'
  | 'xl:bg-product-mixed-spices'
  | 'sm:bg-product-multi'
  | 'md:bg-product-multi'
  | 'mg:bg-product-multi'
  | 'lg:bg-product-multi'
  | 'xl:bg-product-multi'
  | 'sm:bg-product-olive-clay'
  | 'md:bg-product-olive-clay'
  | 'mg:bg-product-olive-clay'
  | 'lg:bg-product-olive-clay'
  | 'xl:bg-product-olive-clay'
  | 'sm:bg-product-rosa-dusk'
  | 'md:bg-product-rosa-dusk'
  | 'mg:bg-product-rosa-dusk'
  | 'lg:bg-product-rosa-dusk'
  | 'xl:bg-product-rosa-dusk'
  | 'sm:bg-product-sage-char'
  | 'md:bg-product-sage-char'
  | 'mg:bg-product-sage-char'
  | 'lg:bg-product-sage-char'
  | 'xl:bg-product-sage-char'
  | 'sm:bg-product-sage-steam'
  | 'md:bg-product-sage-steam'
  | 'mg:bg-product-sage-steam'
  | 'lg:bg-product-sage-steam'
  | 'xl:bg-product-sage-steam'
  | 'sm:bg-product-spice-lavender'
  | 'md:bg-product-spice-lavender'
  | 'mg:bg-product-spice-lavender'
  | 'lg:bg-product-spice-lavender'
  | 'xl:bg-product-spice-lavender'
  | 'sm:bg-product-spice-rosa'
  | 'md:bg-product-spice-rosa'
  | 'mg:bg-product-spice-rosa'
  | 'lg:bg-product-spice-rosa'
  | 'xl:bg-product-spice-rosa'
  | 'sm:bg-product-spice-steam'
  | 'md:bg-product-spice-steam'
  | 'mg:bg-product-spice-steam'
  | 'lg:bg-product-spice-steam'
  | 'xl:bg-product-spice-steam'
  | 'sm:bg-product-stainless-steel'
  | 'md:bg-product-stainless-steel'
  | 'mg:bg-product-stainless-steel'
  | 'lg:bg-product-stainless-steel'
  | 'xl:bg-product-stainless-steel'
  | 'sm:bg-product-steam-blue-salt'
  | 'md:bg-product-steam-blue-salt'
  | 'mg:bg-product-steam-blue-salt'
  | 'lg:bg-product-steam-blue-salt'
  | 'xl:bg-product-steam-blue-salt'
  | 'sm:bg-product-steam-lavender'
  | 'md:bg-product-steam-lavender'
  | 'mg:bg-product-steam-lavender'
  | 'lg:bg-product-steam-lavender'
  | 'xl:bg-product-steam-lavender'
  | 'sm:bg-product-steam-rosa'
  | 'md:bg-product-steam-rosa'
  | 'mg:bg-product-steam-rosa'
  | 'lg:bg-product-steam-rosa'
  | 'xl:bg-product-steam-rosa'
  | 'sm:bg-product-steam-sage'
  | 'md:bg-product-steam-sage'
  | 'mg:bg-product-steam-sage'
  | 'lg:bg-product-steam-sage'
  | 'xl:bg-product-steam-sage'
  | 'sm:bg-product-steam-spice'
  | 'md:bg-product-steam-spice'
  | 'mg:bg-product-steam-spice'
  | 'lg:bg-product-steam-spice'
  | 'xl:bg-product-steam-spice'
  | 'sm:bg-product-steam-turmeric'
  | 'md:bg-product-steam-turmeric'
  | 'mg:bg-product-steam-turmeric'
  | 'lg:bg-product-steam-turmeric'
  | 'xl:bg-product-steam-turmeric'
  | 'sm:bg-product-sunset-marble'
  | 'md:bg-product-sunset-marble'
  | 'mg:bg-product-sunset-marble'
  | 'lg:bg-product-sunset-marble'
  | 'xl:bg-product-sunset-marble'
  | 'sm:bg-product-twilight-dusk'
  | 'md:bg-product-twilight-dusk'
  | 'mg:bg-product-twilight-dusk'
  | 'lg:bg-product-twilight-dusk'
  | 'xl:bg-product-twilight-dusk'
  | 'sm:bg-product-vanilla-bean'
  | 'md:bg-product-vanilla-bean'
  | 'mg:bg-product-vanilla-bean'
  | 'lg:bg-product-vanilla-bean'
  | 'xl:bg-product-vanilla-bean'
  | 'sm:bg-product-warm'
  | 'md:bg-product-warm'
  | 'mg:bg-product-warm'
  | 'lg:bg-product-warm'
  | 'xl:bg-product-warm'
  | 'sm:bg-product-warm-blend'
  | 'md:bg-product-warm-blend'
  | 'mg:bg-product-warm-blend'
  | 'lg:bg-product-warm-blend'
  | 'xl:bg-product-warm-blend'
  | 'sm:bg-opacity-0'
  | 'md:bg-opacity-0'
  | 'mg:bg-opacity-0'
  | 'lg:bg-opacity-0'
  | 'xl:bg-opacity-0'
  | 'group-hover:bg-opacity-0'
  | 'focus-within:bg-opacity-0'
  | 'hover:bg-opacity-0'
  | 'focus:bg-opacity-0'
  | 'sm:bg-opacity-5'
  | 'md:bg-opacity-5'
  | 'mg:bg-opacity-5'
  | 'lg:bg-opacity-5'
  | 'xl:bg-opacity-5'
  | 'group-hover:bg-opacity-5'
  | 'focus-within:bg-opacity-5'
  | 'hover:bg-opacity-5'
  | 'focus:bg-opacity-5'
  | 'sm:bg-opacity-10'
  | 'md:bg-opacity-10'
  | 'mg:bg-opacity-10'
  | 'lg:bg-opacity-10'
  | 'xl:bg-opacity-10'
  | 'group-hover:bg-opacity-10'
  | 'focus-within:bg-opacity-10'
  | 'hover:bg-opacity-10'
  | 'focus:bg-opacity-10'
  | 'sm:bg-opacity-20'
  | 'md:bg-opacity-20'
  | 'mg:bg-opacity-20'
  | 'lg:bg-opacity-20'
  | 'xl:bg-opacity-20'
  | 'group-hover:bg-opacity-20'
  | 'focus-within:bg-opacity-20'
  | 'hover:bg-opacity-20'
  | 'focus:bg-opacity-20'
  | 'sm:bg-opacity-25'
  | 'md:bg-opacity-25'
  | 'mg:bg-opacity-25'
  | 'lg:bg-opacity-25'
  | 'xl:bg-opacity-25'
  | 'group-hover:bg-opacity-25'
  | 'focus-within:bg-opacity-25'
  | 'hover:bg-opacity-25'
  | 'focus:bg-opacity-25'
  | 'sm:bg-opacity-30'
  | 'md:bg-opacity-30'
  | 'mg:bg-opacity-30'
  | 'lg:bg-opacity-30'
  | 'xl:bg-opacity-30'
  | 'group-hover:bg-opacity-30'
  | 'focus-within:bg-opacity-30'
  | 'hover:bg-opacity-30'
  | 'focus:bg-opacity-30'
  | 'sm:bg-opacity-40'
  | 'md:bg-opacity-40'
  | 'mg:bg-opacity-40'
  | 'lg:bg-opacity-40'
  | 'xl:bg-opacity-40'
  | 'group-hover:bg-opacity-40'
  | 'focus-within:bg-opacity-40'
  | 'hover:bg-opacity-40'
  | 'focus:bg-opacity-40'
  | 'sm:bg-opacity-50'
  | 'md:bg-opacity-50'
  | 'mg:bg-opacity-50'
  | 'lg:bg-opacity-50'
  | 'xl:bg-opacity-50'
  | 'group-hover:bg-opacity-50'
  | 'focus-within:bg-opacity-50'
  | 'hover:bg-opacity-50'
  | 'focus:bg-opacity-50'
  | 'sm:bg-opacity-60'
  | 'md:bg-opacity-60'
  | 'mg:bg-opacity-60'
  | 'lg:bg-opacity-60'
  | 'xl:bg-opacity-60'
  | 'group-hover:bg-opacity-60'
  | 'focus-within:bg-opacity-60'
  | 'hover:bg-opacity-60'
  | 'focus:bg-opacity-60'
  | 'sm:bg-opacity-70'
  | 'md:bg-opacity-70'
  | 'mg:bg-opacity-70'
  | 'lg:bg-opacity-70'
  | 'xl:bg-opacity-70'
  | 'group-hover:bg-opacity-70'
  | 'focus-within:bg-opacity-70'
  | 'hover:bg-opacity-70'
  | 'focus:bg-opacity-70'
  | 'sm:bg-opacity-75'
  | 'md:bg-opacity-75'
  | 'mg:bg-opacity-75'
  | 'lg:bg-opacity-75'
  | 'xl:bg-opacity-75'
  | 'group-hover:bg-opacity-75'
  | 'focus-within:bg-opacity-75'
  | 'hover:bg-opacity-75'
  | 'focus:bg-opacity-75'
  | 'sm:bg-opacity-80'
  | 'md:bg-opacity-80'
  | 'mg:bg-opacity-80'
  | 'lg:bg-opacity-80'
  | 'xl:bg-opacity-80'
  | 'group-hover:bg-opacity-80'
  | 'focus-within:bg-opacity-80'
  | 'hover:bg-opacity-80'
  | 'focus:bg-opacity-80'
  | 'sm:bg-opacity-90'
  | 'md:bg-opacity-90'
  | 'mg:bg-opacity-90'
  | 'lg:bg-opacity-90'
  | 'xl:bg-opacity-90'
  | 'group-hover:bg-opacity-90'
  | 'focus-within:bg-opacity-90'
  | 'hover:bg-opacity-90'
  | 'focus:bg-opacity-90'
  | 'sm:bg-opacity-95'
  | 'md:bg-opacity-95'
  | 'mg:bg-opacity-95'
  | 'lg:bg-opacity-95'
  | 'xl:bg-opacity-95'
  | 'group-hover:bg-opacity-95'
  | 'focus-within:bg-opacity-95'
  | 'hover:bg-opacity-95'
  | 'focus:bg-opacity-95'
  | 'sm:bg-opacity-100'
  | 'md:bg-opacity-100'
  | 'mg:bg-opacity-100'
  | 'lg:bg-opacity-100'
  | 'xl:bg-opacity-100'
  | 'group-hover:bg-opacity-100'
  | 'focus-within:bg-opacity-100'
  | 'hover:bg-opacity-100'
  | 'focus:bg-opacity-100'
  | 'sm:bg-bottom'
  | 'md:bg-bottom'
  | 'mg:bg-bottom'
  | 'lg:bg-bottom'
  | 'xl:bg-bottom'
  | 'sm:bg-center'
  | 'md:bg-center'
  | 'mg:bg-center'
  | 'lg:bg-center'
  | 'xl:bg-center'
  | 'sm:bg-left'
  | 'md:bg-left'
  | 'mg:bg-left'
  | 'lg:bg-left'
  | 'xl:bg-left'
  | 'sm:bg-left-bottom'
  | 'md:bg-left-bottom'
  | 'mg:bg-left-bottom'
  | 'lg:bg-left-bottom'
  | 'xl:bg-left-bottom'
  | 'sm:bg-left-top'
  | 'md:bg-left-top'
  | 'mg:bg-left-top'
  | 'lg:bg-left-top'
  | 'xl:bg-left-top'
  | 'sm:bg-right'
  | 'md:bg-right'
  | 'mg:bg-right'
  | 'lg:bg-right'
  | 'xl:bg-right'
  | 'sm:bg-right-bottom'
  | 'md:bg-right-bottom'
  | 'mg:bg-right-bottom'
  | 'lg:bg-right-bottom'
  | 'xl:bg-right-bottom'
  | 'sm:bg-right-top'
  | 'md:bg-right-top'
  | 'mg:bg-right-top'
  | 'lg:bg-right-top'
  | 'xl:bg-right-top'
  | 'sm:bg-top'
  | 'md:bg-top'
  | 'mg:bg-top'
  | 'lg:bg-top'
  | 'xl:bg-top'
  | 'sm:bg-repeat'
  | 'md:bg-repeat'
  | 'mg:bg-repeat'
  | 'lg:bg-repeat'
  | 'xl:bg-repeat'
  | 'sm:bg-no-repeat'
  | 'md:bg-no-repeat'
  | 'mg:bg-no-repeat'
  | 'lg:bg-no-repeat'
  | 'xl:bg-no-repeat'
  | 'sm:bg-repeat-x'
  | 'md:bg-repeat-x'
  | 'mg:bg-repeat-x'
  | 'lg:bg-repeat-x'
  | 'xl:bg-repeat-x'
  | 'sm:bg-repeat-y'
  | 'md:bg-repeat-y'
  | 'mg:bg-repeat-y'
  | 'lg:bg-repeat-y'
  | 'xl:bg-repeat-y'
  | 'sm:bg-repeat-round'
  | 'md:bg-repeat-round'
  | 'mg:bg-repeat-round'
  | 'lg:bg-repeat-round'
  | 'xl:bg-repeat-round'
  | 'sm:bg-repeat-space'
  | 'md:bg-repeat-space'
  | 'mg:bg-repeat-space'
  | 'lg:bg-repeat-space'
  | 'xl:bg-repeat-space'
  | 'sm:bg-auto'
  | 'md:bg-auto'
  | 'mg:bg-auto'
  | 'lg:bg-auto'
  | 'xl:bg-auto'
  | 'sm:bg-cover'
  | 'md:bg-cover'
  | 'mg:bg-cover'
  | 'lg:bg-cover'
  | 'xl:bg-cover'
  | 'sm:bg-contain'
  | 'md:bg-contain'
  | 'mg:bg-contain'
  | 'lg:bg-contain'
  | 'xl:bg-contain'
  | 'sm:bg-origin-border'
  | 'md:bg-origin-border'
  | 'mg:bg-origin-border'
  | 'lg:bg-origin-border'
  | 'xl:bg-origin-border'
  | 'sm:bg-origin-padding'
  | 'md:bg-origin-padding'
  | 'mg:bg-origin-padding'
  | 'lg:bg-origin-padding'
  | 'xl:bg-origin-padding'
  | 'sm:bg-origin-content'
  | 'md:bg-origin-content'
  | 'mg:bg-origin-content'
  | 'lg:bg-origin-content'
  | 'xl:bg-origin-content'
  | 'sm:blur-0'
  | 'md:blur-0'
  | 'mg:blur-0'
  | 'lg:blur-0'
  | 'xl:blur-0'
  | 'sm:blur-none'
  | 'md:blur-none'
  | 'mg:blur-none'
  | 'lg:blur-none'
  | 'xl:blur-none'
  | 'sm:blur-sm'
  | 'md:blur-sm'
  | 'mg:blur-sm'
  | 'lg:blur-sm'
  | 'xl:blur-sm'
  | 'sm:blur'
  | 'md:blur'
  | 'mg:blur'
  | 'lg:blur'
  | 'xl:blur'
  | 'sm:blur-md'
  | 'md:blur-md'
  | 'mg:blur-md'
  | 'lg:blur-md'
  | 'xl:blur-md'
  | 'sm:blur-lg'
  | 'md:blur-lg'
  | 'mg:blur-lg'
  | 'lg:blur-lg'
  | 'xl:blur-lg'
  | 'sm:blur-xl'
  | 'md:blur-xl'
  | 'mg:blur-xl'
  | 'lg:blur-xl'
  | 'xl:blur-xl'
  | 'sm:blur-2xl'
  | 'md:blur-2xl'
  | 'mg:blur-2xl'
  | 'lg:blur-2xl'
  | 'xl:blur-2xl'
  | 'sm:blur-3xl'
  | 'md:blur-3xl'
  | 'mg:blur-3xl'
  | 'lg:blur-3xl'
  | 'xl:blur-3xl'
  | 'sm:border-collapse'
  | 'md:border-collapse'
  | 'mg:border-collapse'
  | 'lg:border-collapse'
  | 'xl:border-collapse'
  | 'sm:border-separate'
  | 'md:border-separate'
  | 'mg:border-separate'
  | 'lg:border-separate'
  | 'xl:border-separate'
  | 'sm:border-transparent'
  | 'md:border-transparent'
  | 'mg:border-transparent'
  | 'lg:border-transparent'
  | 'xl:border-transparent'
  | 'group-hover:border-transparent'
  | 'focus-within:border-transparent'
  | 'hover:border-transparent'
  | 'focus:border-transparent'
  | 'sm:border-current'
  | 'md:border-current'
  | 'mg:border-current'
  | 'lg:border-current'
  | 'xl:border-current'
  | 'group-hover:border-current'
  | 'focus-within:border-current'
  | 'hover:border-current'
  | 'focus:border-current'
  | 'sm:border-overlay'
  | 'md:border-overlay'
  | 'mg:border-overlay'
  | 'lg:border-overlay'
  | 'xl:border-overlay'
  | 'group-hover:border-overlay'
  | 'focus-within:border-overlay'
  | 'hover:border-overlay'
  | 'focus:border-overlay'
  | 'sm:border-black'
  | 'md:border-black'
  | 'mg:border-black'
  | 'lg:border-black'
  | 'xl:border-black'
  | 'group-hover:border-black'
  | 'focus-within:border-black'
  | 'hover:border-black'
  | 'focus:border-black'
  | 'sm:border-white'
  | 'md:border-white'
  | 'mg:border-white'
  | 'lg:border-white'
  | 'xl:border-white'
  | 'group-hover:border-white'
  | 'focus-within:border-white'
  | 'hover:border-white'
  | 'focus:border-white'
  | 'sm:border-white-hover'
  | 'md:border-white-hover'
  | 'mg:border-white-hover'
  | 'lg:border-white-hover'
  | 'xl:border-white-hover'
  | 'group-hover:border-white-hover'
  | 'focus-within:border-white-hover'
  | 'hover:border-white-hover'
  | 'focus:border-white-hover'
  | 'sm:border-white-pressed'
  | 'md:border-white-pressed'
  | 'mg:border-white-pressed'
  | 'lg:border-white-pressed'
  | 'xl:border-white-pressed'
  | 'group-hover:border-white-pressed'
  | 'focus-within:border-white-pressed'
  | 'hover:border-white-pressed'
  | 'focus:border-white-pressed'
  | 'sm:border-product-acid'
  | 'md:border-product-acid'
  | 'mg:border-product-acid'
  | 'lg:border-product-acid'
  | 'xl:border-product-acid'
  | 'group-hover:border-product-acid'
  | 'focus-within:border-product-acid'
  | 'hover:border-product-acid'
  | 'focus:border-product-acid'
  | 'sm:border-product-aura'
  | 'md:border-product-aura'
  | 'mg:border-product-aura'
  | 'lg:border-product-aura'
  | 'xl:border-product-aura'
  | 'group-hover:border-product-aura'
  | 'focus-within:border-product-aura'
  | 'hover:border-product-aura'
  | 'focus:border-product-aura'
  | 'sm:border-product-azul'
  | 'md:border-product-azul'
  | 'mg:border-product-azul'
  | 'lg:border-product-azul'
  | 'xl:border-product-azul'
  | 'group-hover:border-product-azul'
  | 'focus-within:border-product-azul'
  | 'hover:border-product-azul'
  | 'focus:border-product-azul'
  | 'sm:border-product-blanch'
  | 'md:border-product-blanch'
  | 'mg:border-product-blanch'
  | 'lg:border-product-blanch'
  | 'xl:border-product-blanch'
  | 'group-hover:border-product-blanch'
  | 'focus-within:border-product-blanch'
  | 'hover:border-product-blanch'
  | 'focus:border-product-blanch'
  | 'sm:border-product-blue-salt'
  | 'md:border-product-blue-salt'
  | 'mg:border-product-blue-salt'
  | 'lg:border-product-blue-salt'
  | 'xl:border-product-blue-salt'
  | 'group-hover:border-product-blue-salt'
  | 'focus-within:border-product-blue-salt'
  | 'hover:border-product-blue-salt'
  | 'focus:border-product-blue-salt'
  | 'sm:border-product-burgundy'
  | 'md:border-product-burgundy'
  | 'mg:border-product-burgundy'
  | 'lg:border-product-burgundy'
  | 'xl:border-product-burgundy'
  | 'group-hover:border-product-burgundy'
  | 'focus-within:border-product-burgundy'
  | 'hover:border-product-burgundy'
  | 'focus:border-product-burgundy'
  | 'sm:border-product-butter-yellow'
  | 'md:border-product-butter-yellow'
  | 'mg:border-product-butter-yellow'
  | 'lg:border-product-butter-yellow'
  | 'xl:border-product-butter-yellow'
  | 'group-hover:border-product-butter-yellow'
  | 'focus-within:border-product-butter-yellow'
  | 'hover:border-product-butter-yellow'
  | 'focus:border-product-butter-yellow'
  | 'sm:border-product-chai'
  | 'md:border-product-chai'
  | 'mg:border-product-chai'
  | 'lg:border-product-chai'
  | 'xl:border-product-chai'
  | 'group-hover:border-product-chai'
  | 'focus-within:border-product-chai'
  | 'hover:border-product-chai'
  | 'focus:border-product-chai'
  | 'sm:border-product-char'
  | 'md:border-product-char'
  | 'mg:border-product-char'
  | 'lg:border-product-char'
  | 'xl:border-product-char'
  | 'group-hover:border-product-char'
  | 'focus-within:border-product-char'
  | 'hover:border-product-char'
  | 'focus:border-product-char'
  | 'sm:border-product-charm'
  | 'md:border-product-charm'
  | 'mg:border-product-charm'
  | 'lg:border-product-charm'
  | 'xl:border-product-charm'
  | 'group-hover:border-product-charm'
  | 'focus-within:border-product-charm'
  | 'hover:border-product-charm'
  | 'focus:border-product-charm'
  | 'sm:border-product-chickpea'
  | 'md:border-product-chickpea'
  | 'mg:border-product-chickpea'
  | 'lg:border-product-chickpea'
  | 'xl:border-product-chickpea'
  | 'group-hover:border-product-chickpea'
  | 'focus-within:border-product-chickpea'
  | 'hover:border-product-chickpea'
  | 'focus:border-product-chickpea'
  | 'sm:border-product-cielo'
  | 'md:border-product-cielo'
  | 'mg:border-product-cielo'
  | 'lg:border-product-cielo'
  | 'xl:border-product-cielo'
  | 'group-hover:border-product-cielo'
  | 'focus-within:border-product-cielo'
  | 'hover:border-product-cielo'
  | 'focus:border-product-cielo'
  | 'sm:border-product-clay'
  | 'md:border-product-clay'
  | 'mg:border-product-clay'
  | 'lg:border-product-clay'
  | 'xl:border-product-clay'
  | 'group-hover:border-product-clay'
  | 'focus-within:border-product-clay'
  | 'hover:border-product-clay'
  | 'focus:border-product-clay'
  | 'sm:border-product-clear'
  | 'md:border-product-clear'
  | 'mg:border-product-clear'
  | 'lg:border-product-clear'
  | 'xl:border-product-clear'
  | 'group-hover:border-product-clear'
  | 'focus-within:border-product-clear'
  | 'hover:border-product-clear'
  | 'focus:border-product-clear'
  | 'sm:border-product-coriander'
  | 'md:border-product-coriander'
  | 'mg:border-product-coriander'
  | 'lg:border-product-coriander'
  | 'xl:border-product-coriander'
  | 'group-hover:border-product-coriander'
  | 'focus-within:border-product-coriander'
  | 'hover:border-product-coriander'
  | 'focus:border-product-coriander'
  | 'sm:border-product-cream'
  | 'md:border-product-cream'
  | 'mg:border-product-cream'
  | 'lg:border-product-cream'
  | 'xl:border-product-cream'
  | 'group-hover:border-product-cream'
  | 'focus-within:border-product-cream'
  | 'hover:border-product-cream'
  | 'focus:border-product-cream'
  | 'sm:border-product-crescent'
  | 'md:border-product-crescent'
  | 'mg:border-product-crescent'
  | 'lg:border-product-crescent'
  | 'xl:border-product-crescent'
  | 'group-hover:border-product-crescent'
  | 'focus-within:border-product-crescent'
  | 'hover:border-product-crescent'
  | 'focus:border-product-crescent'
  | 'sm:border-product-dawn'
  | 'md:border-product-dawn'
  | 'mg:border-product-dawn'
  | 'lg:border-product-dawn'
  | 'xl:border-product-dawn'
  | 'group-hover:border-product-dawn'
  | 'focus-within:border-product-dawn'
  | 'hover:border-product-dawn'
  | 'focus:border-product-dawn'
  | 'sm:border-product-dusk'
  | 'md:border-product-dusk'
  | 'mg:border-product-dusk'
  | 'lg:border-product-dusk'
  | 'xl:border-product-dusk'
  | 'group-hover:border-product-dusk'
  | 'focus-within:border-product-dusk'
  | 'hover:border-product-dusk'
  | 'focus:border-product-dusk'
  | 'sm:border-product-egg-yolk'
  | 'md:border-product-egg-yolk'
  | 'mg:border-product-egg-yolk'
  | 'lg:border-product-egg-yolk'
  | 'xl:border-product-egg-yolk'
  | 'group-hover:border-product-egg-yolk'
  | 'focus-within:border-product-egg-yolk'
  | 'hover:border-product-egg-yolk'
  | 'focus:border-product-egg-yolk'
  | 'sm:border-product-espresso'
  | 'md:border-product-espresso'
  | 'mg:border-product-espresso'
  | 'lg:border-product-espresso'
  | 'xl:border-product-espresso'
  | 'group-hover:border-product-espresso'
  | 'focus-within:border-product-espresso'
  | 'hover:border-product-espresso'
  | 'focus:border-product-espresso'
  | 'sm:border-product-eve'
  | 'md:border-product-eve'
  | 'mg:border-product-eve'
  | 'lg:border-product-eve'
  | 'xl:border-product-eve'
  | 'group-hover:border-product-eve'
  | 'focus-within:border-product-eve'
  | 'hover:border-product-eve'
  | 'focus:border-product-eve'
  | 'sm:border-product-firecracker'
  | 'md:border-product-firecracker'
  | 'mg:border-product-firecracker'
  | 'lg:border-product-firecracker'
  | 'xl:border-product-firecracker'
  | 'group-hover:border-product-firecracker'
  | 'focus-within:border-product-firecracker'
  | 'hover:border-product-firecracker'
  | 'focus:border-product-firecracker'
  | 'sm:border-product-forget-me-not-blue'
  | 'md:border-product-forget-me-not-blue'
  | 'mg:border-product-forget-me-not-blue'
  | 'lg:border-product-forget-me-not-blue'
  | 'xl:border-product-forget-me-not-blue'
  | 'group-hover:border-product-forget-me-not-blue'
  | 'focus-within:border-product-forget-me-not-blue'
  | 'hover:border-product-forget-me-not-blue'
  | 'focus:border-product-forget-me-not-blue'
  | 'sm:border-product-gold'
  | 'md:border-product-gold'
  | 'mg:border-product-gold'
  | 'lg:border-product-gold'
  | 'xl:border-product-gold'
  | 'group-hover:border-product-gold'
  | 'focus-within:border-product-gold'
  | 'hover:border-product-gold'
  | 'focus:border-product-gold'
  | 'sm:border-product-golden'
  | 'md:border-product-golden'
  | 'mg:border-product-golden'
  | 'lg:border-product-golden'
  | 'xl:border-product-golden'
  | 'group-hover:border-product-golden'
  | 'focus-within:border-product-golden'
  | 'hover:border-product-golden'
  | 'focus:border-product-golden'
  | 'sm:border-product-heat'
  | 'md:border-product-heat'
  | 'mg:border-product-heat'
  | 'lg:border-product-heat'
  | 'xl:border-product-heat'
  | 'group-hover:border-product-heat'
  | 'focus-within:border-product-heat'
  | 'hover:border-product-heat'
  | 'focus:border-product-heat'
  | 'sm:border-product-himalayan-salt'
  | 'md:border-product-himalayan-salt'
  | 'mg:border-product-himalayan-salt'
  | 'lg:border-product-himalayan-salt'
  | 'xl:border-product-himalayan-salt'
  | 'group-hover:border-product-himalayan-salt'
  | 'focus-within:border-product-himalayan-salt'
  | 'hover:border-product-himalayan-salt'
  | 'focus:border-product-himalayan-salt'
  | 'sm:border-product-indigo'
  | 'md:border-product-indigo'
  | 'mg:border-product-indigo'
  | 'lg:border-product-indigo'
  | 'xl:border-product-indigo'
  | 'group-hover:border-product-indigo'
  | 'focus-within:border-product-indigo'
  | 'hover:border-product-indigo'
  | 'focus:border-product-indigo'
  | 'sm:border-product-lavender'
  | 'md:border-product-lavender'
  | 'mg:border-product-lavender'
  | 'lg:border-product-lavender'
  | 'xl:border-product-lavender'
  | 'group-hover:border-product-lavender'
  | 'focus-within:border-product-lavender'
  | 'hover:border-product-lavender'
  | 'focus:border-product-lavender'
  | 'sm:border-product-lavender-marble'
  | 'md:border-product-lavender-marble'
  | 'mg:border-product-lavender-marble'
  | 'lg:border-product-lavender-marble'
  | 'xl:border-product-lavender-marble'
  | 'group-hover:border-product-lavender-marble'
  | 'focus-within:border-product-lavender-marble'
  | 'hover:border-product-lavender-marble'
  | 'focus:border-product-lavender-marble'
  | 'sm:border-product-midnight-marble'
  | 'md:border-product-midnight-marble'
  | 'mg:border-product-midnight-marble'
  | 'lg:border-product-midnight-marble'
  | 'xl:border-product-midnight-marble'
  | 'group-hover:border-product-midnight-marble'
  | 'focus-within:border-product-midnight-marble'
  | 'hover:border-product-midnight-marble'
  | 'focus:border-product-midnight-marble'
  | 'sm:border-product-nougat'
  | 'md:border-product-nougat'
  | 'mg:border-product-nougat'
  | 'lg:border-product-nougat'
  | 'xl:border-product-nougat'
  | 'group-hover:border-product-nougat'
  | 'focus-within:border-product-nougat'
  | 'hover:border-product-nougat'
  | 'focus:border-product-nougat'
  | 'sm:border-product-pistachio'
  | 'md:border-product-pistachio'
  | 'mg:border-product-pistachio'
  | 'lg:border-product-pistachio'
  | 'xl:border-product-pistachio'
  | 'group-hover:border-product-pistachio'
  | 'focus-within:border-product-pistachio'
  | 'hover:border-product-pistachio'
  | 'focus:border-product-pistachio'
  | 'sm:border-product-rosa'
  | 'md:border-product-rosa'
  | 'mg:border-product-rosa'
  | 'lg:border-product-rosa'
  | 'xl:border-product-rosa'
  | 'group-hover:border-product-rosa'
  | 'focus-within:border-product-rosa'
  | 'hover:border-product-rosa'
  | 'focus:border-product-rosa'
  | 'sm:border-product-rose-gold'
  | 'md:border-product-rose-gold'
  | 'mg:border-product-rose-gold'
  | 'lg:border-product-rose-gold'
  | 'xl:border-product-rose-gold'
  | 'group-hover:border-product-rose-gold'
  | 'focus-within:border-product-rose-gold'
  | 'hover:border-product-rose-gold'
  | 'focus:border-product-rose-gold'
  | 'sm:border-product-rust'
  | 'md:border-product-rust'
  | 'mg:border-product-rust'
  | 'lg:border-product-rust'
  | 'xl:border-product-rust'
  | 'group-hover:border-product-rust'
  | 'focus-within:border-product-rust'
  | 'hover:border-product-rust'
  | 'focus:border-product-rust'
  | 'sm:border-product-saffron'
  | 'md:border-product-saffron'
  | 'mg:border-product-saffron'
  | 'lg:border-product-saffron'
  | 'xl:border-product-saffron'
  | 'group-hover:border-product-saffron'
  | 'focus-within:border-product-saffron'
  | 'hover:border-product-saffron'
  | 'focus:border-product-saffron'
  | 'sm:border-product-sage'
  | 'md:border-product-sage'
  | 'mg:border-product-sage'
  | 'lg:border-product-sage'
  | 'xl:border-product-sage'
  | 'group-hover:border-product-sage'
  | 'focus-within:border-product-sage'
  | 'hover:border-product-sage'
  | 'focus:border-product-sage'
  | 'sm:border-product-sear'
  | 'md:border-product-sear'
  | 'mg:border-product-sear'
  | 'lg:border-product-sear'
  | 'xl:border-product-sear'
  | 'group-hover:border-product-sear'
  | 'focus-within:border-product-sear'
  | 'hover:border-product-sear'
  | 'focus:border-product-sear'
  | 'sm:border-product-spice'
  | 'md:border-product-spice'
  | 'mg:border-product-spice'
  | 'lg:border-product-spice'
  | 'xl:border-product-spice'
  | 'group-hover:border-product-spice'
  | 'focus-within:border-product-spice'
  | 'hover:border-product-spice'
  | 'focus:border-product-spice'
  | 'sm:border-product-steam'
  | 'md:border-product-steam'
  | 'mg:border-product-steam'
  | 'lg:border-product-steam'
  | 'xl:border-product-steam'
  | 'group-hover:border-product-steam'
  | 'focus-within:border-product-steam'
  | 'hover:border-product-steam'
  | 'focus:border-product-steam'
  | 'sm:border-product-strawberry'
  | 'md:border-product-strawberry'
  | 'mg:border-product-strawberry'
  | 'lg:border-product-strawberry'
  | 'xl:border-product-strawberry'
  | 'group-hover:border-product-strawberry'
  | 'focus-within:border-product-strawberry'
  | 'hover:border-product-strawberry'
  | 'focus:border-product-strawberry'
  | 'sm:border-product-sunrise'
  | 'md:border-product-sunrise'
  | 'mg:border-product-sunrise'
  | 'lg:border-product-sunrise'
  | 'xl:border-product-sunrise'
  | 'group-hover:border-product-sunrise'
  | 'focus-within:border-product-sunrise'
  | 'hover:border-product-sunrise'
  | 'focus:border-product-sunrise'
  | 'sm:border-product-sunset'
  | 'md:border-product-sunset'
  | 'mg:border-product-sunset'
  | 'lg:border-product-sunset'
  | 'xl:border-product-sunset'
  | 'group-hover:border-product-sunset'
  | 'focus-within:border-product-sunset'
  | 'hover:border-product-sunset'
  | 'focus:border-product-sunset'
  | 'sm:border-product-sunset-marble'
  | 'md:border-product-sunset-marble'
  | 'mg:border-product-sunset-marble'
  | 'lg:border-product-sunset-marble'
  | 'xl:border-product-sunset-marble'
  | 'group-hover:border-product-sunset-marble'
  | 'focus-within:border-product-sunset-marble'
  | 'hover:border-product-sunset-marble'
  | 'focus:border-product-sunset-marble'
  | 'sm:border-product-terracotta'
  | 'md:border-product-terracotta'
  | 'mg:border-product-terracotta'
  | 'lg:border-product-terracotta'
  | 'xl:border-product-terracotta'
  | 'group-hover:border-product-terracotta'
  | 'focus-within:border-product-terracotta'
  | 'hover:border-product-terracotta'
  | 'focus:border-product-terracotta'
  | 'sm:border-product-tierra'
  | 'md:border-product-tierra'
  | 'mg:border-product-tierra'
  | 'lg:border-product-tierra'
  | 'xl:border-product-tierra'
  | 'group-hover:border-product-tierra'
  | 'focus-within:border-product-tierra'
  | 'hover:border-product-tierra'
  | 'focus:border-product-tierra'
  | 'sm:border-product-turmeric'
  | 'md:border-product-turmeric'
  | 'mg:border-product-turmeric'
  | 'lg:border-product-turmeric'
  | 'xl:border-product-turmeric'
  | 'group-hover:border-product-turmeric'
  | 'focus-within:border-product-turmeric'
  | 'hover:border-product-turmeric'
  | 'focus:border-product-turmeric'
  | 'sm:border-product-turqoise'
  | 'md:border-product-turqoise'
  | 'mg:border-product-turqoise'
  | 'lg:border-product-turqoise'
  | 'xl:border-product-turqoise'
  | 'group-hover:border-product-turqoise'
  | 'focus-within:border-product-turqoise'
  | 'hover:border-product-turqoise'
  | 'focus:border-product-turqoise'
  | 'sm:border-product-twilight'
  | 'md:border-product-twilight'
  | 'mg:border-product-twilight'
  | 'lg:border-product-twilight'
  | 'xl:border-product-twilight'
  | 'group-hover:border-product-twilight'
  | 'focus-within:border-product-twilight'
  | 'hover:border-product-twilight'
  | 'focus:border-product-twilight'
  | 'sm:border-product-walnut'
  | 'md:border-product-walnut'
  | 'mg:border-product-walnut'
  | 'lg:border-product-walnut'
  | 'xl:border-product-walnut'
  | 'group-hover:border-product-walnut'
  | 'focus-within:border-product-walnut'
  | 'hover:border-product-walnut'
  | 'focus:border-product-walnut'
  | 'sm:border-product-warm-white'
  | 'md:border-product-warm-white'
  | 'mg:border-product-warm-white'
  | 'lg:border-product-warm-white'
  | 'xl:border-product-warm-white'
  | 'group-hover:border-product-warm-white'
  | 'focus-within:border-product-warm-white'
  | 'hover:border-product-warm-white'
  | 'focus:border-product-warm-white'
  | 'sm:border-product-zest'
  | 'md:border-product-zest'
  | 'mg:border-product-zest'
  | 'lg:border-product-zest'
  | 'xl:border-product-zest'
  | 'group-hover:border-product-zest'
  | 'focus-within:border-product-zest'
  | 'hover:border-product-zest'
  | 'focus:border-product-zest'
  | 'sm:border-placeholder'
  | 'md:border-placeholder'
  | 'mg:border-placeholder'
  | 'lg:border-placeholder'
  | 'xl:border-placeholder'
  | 'group-hover:border-placeholder'
  | 'focus-within:border-placeholder'
  | 'hover:border-placeholder'
  | 'focus:border-placeholder'
  | 'sm:border-interactive-bone'
  | 'md:border-interactive-bone'
  | 'mg:border-interactive-bone'
  | 'lg:border-interactive-bone'
  | 'xl:border-interactive-bone'
  | 'group-hover:border-interactive-bone'
  | 'focus-within:border-interactive-bone'
  | 'hover:border-interactive-bone'
  | 'focus:border-interactive-bone'
  | 'sm:border-interactive-brick'
  | 'md:border-interactive-brick'
  | 'mg:border-interactive-brick'
  | 'lg:border-interactive-brick'
  | 'xl:border-interactive-brick'
  | 'group-hover:border-interactive-brick'
  | 'focus-within:border-interactive-brick'
  | 'hover:border-interactive-brick'
  | 'focus:border-interactive-brick'
  | 'sm:border-interactive-char'
  | 'md:border-interactive-char'
  | 'mg:border-interactive-char'
  | 'lg:border-interactive-char'
  | 'xl:border-interactive-char'
  | 'group-hover:border-interactive-char'
  | 'focus-within:border-interactive-char'
  | 'hover:border-interactive-char'
  | 'focus:border-interactive-char'
  | 'sm:border-interactive-white'
  | 'md:border-interactive-white'
  | 'mg:border-interactive-white'
  | 'lg:border-interactive-white'
  | 'xl:border-interactive-white'
  | 'group-hover:border-interactive-white'
  | 'focus-within:border-interactive-white'
  | 'hover:border-interactive-white'
  | 'focus:border-interactive-white'
  | 'sm:border-interactive-disabled'
  | 'md:border-interactive-disabled'
  | 'mg:border-interactive-disabled'
  | 'lg:border-interactive-disabled'
  | 'xl:border-interactive-disabled'
  | 'group-hover:border-interactive-disabled'
  | 'focus-within:border-interactive-disabled'
  | 'hover:border-interactive-disabled'
  | 'focus:border-interactive-disabled'
  | 'sm:border-interactive-error'
  | 'md:border-interactive-error'
  | 'mg:border-interactive-error'
  | 'lg:border-interactive-error'
  | 'xl:border-interactive-error'
  | 'group-hover:border-interactive-error'
  | 'focus-within:border-interactive-error'
  | 'hover:border-interactive-error'
  | 'focus:border-interactive-error'
  | 'sm:border-interactive-outline'
  | 'md:border-interactive-outline'
  | 'mg:border-interactive-outline'
  | 'lg:border-interactive-outline'
  | 'xl:border-interactive-outline'
  | 'group-hover:border-interactive-outline'
  | 'focus-within:border-interactive-outline'
  | 'hover:border-interactive-outline'
  | 'focus:border-interactive-outline'
  | 'sm:border-translucent-char'
  | 'md:border-translucent-char'
  | 'mg:border-translucent-char'
  | 'lg:border-translucent-char'
  | 'xl:border-translucent-char'
  | 'group-hover:border-translucent-char'
  | 'focus-within:border-translucent-char'
  | 'hover:border-translucent-char'
  | 'focus:border-translucent-char'
  | 'sm:border-translucent-white'
  | 'md:border-translucent-white'
  | 'mg:border-translucent-white'
  | 'lg:border-translucent-white'
  | 'xl:border-translucent-white'
  | 'group-hover:border-translucent-white'
  | 'focus-within:border-translucent-white'
  | 'hover:border-translucent-white'
  | 'focus:border-translucent-white'
  | 'sm:border-char-50'
  | 'md:border-char-50'
  | 'mg:border-char-50'
  | 'lg:border-char-50'
  | 'xl:border-char-50'
  | 'group-hover:border-char-50'
  | 'focus-within:border-char-50'
  | 'hover:border-char-50'
  | 'focus:border-char-50'
  | 'sm:border-char-100'
  | 'md:border-char-100'
  | 'mg:border-char-100'
  | 'lg:border-char-100'
  | 'xl:border-char-100'
  | 'group-hover:border-char-100'
  | 'focus-within:border-char-100'
  | 'hover:border-char-100'
  | 'focus:border-char-100'
  | 'sm:border-char-200'
  | 'md:border-char-200'
  | 'mg:border-char-200'
  | 'lg:border-char-200'
  | 'xl:border-char-200'
  | 'group-hover:border-char-200'
  | 'focus-within:border-char-200'
  | 'hover:border-char-200'
  | 'focus:border-char-200'
  | 'sm:border-char-300'
  | 'md:border-char-300'
  | 'mg:border-char-300'
  | 'lg:border-char-300'
  | 'xl:border-char-300'
  | 'group-hover:border-char-300'
  | 'focus-within:border-char-300'
  | 'hover:border-char-300'
  | 'focus:border-char-300'
  | 'sm:border-char-400'
  | 'md:border-char-400'
  | 'mg:border-char-400'
  | 'lg:border-char-400'
  | 'xl:border-char-400'
  | 'group-hover:border-char-400'
  | 'focus-within:border-char-400'
  | 'hover:border-char-400'
  | 'focus:border-char-400'
  | 'sm:border-char-500'
  | 'md:border-char-500'
  | 'mg:border-char-500'
  | 'lg:border-char-500'
  | 'xl:border-char-500'
  | 'group-hover:border-char-500'
  | 'focus-within:border-char-500'
  | 'hover:border-char-500'
  | 'focus:border-char-500'
  | 'sm:border-char-600'
  | 'md:border-char-600'
  | 'mg:border-char-600'
  | 'lg:border-char-600'
  | 'xl:border-char-600'
  | 'group-hover:border-char-600'
  | 'focus-within:border-char-600'
  | 'hover:border-char-600'
  | 'focus:border-char-600'
  | 'sm:border-char-700'
  | 'md:border-char-700'
  | 'mg:border-char-700'
  | 'lg:border-char-700'
  | 'xl:border-char-700'
  | 'group-hover:border-char-700'
  | 'focus-within:border-char-700'
  | 'hover:border-char-700'
  | 'focus:border-char-700'
  | 'sm:border-char-800'
  | 'md:border-char-800'
  | 'mg:border-char-800'
  | 'lg:border-char-800'
  | 'xl:border-char-800'
  | 'group-hover:border-char-800'
  | 'focus-within:border-char-800'
  | 'hover:border-char-800'
  | 'focus:border-char-800'
  | 'sm:border-char-900'
  | 'md:border-char-900'
  | 'mg:border-char-900'
  | 'lg:border-char-900'
  | 'xl:border-char-900'
  | 'group-hover:border-char-900'
  | 'focus-within:border-char-900'
  | 'hover:border-char-900'
  | 'focus:border-char-900'
  | 'sm:border-bone-50'
  | 'md:border-bone-50'
  | 'mg:border-bone-50'
  | 'lg:border-bone-50'
  | 'xl:border-bone-50'
  | 'group-hover:border-bone-50'
  | 'focus-within:border-bone-50'
  | 'hover:border-bone-50'
  | 'focus:border-bone-50'
  | 'sm:border-bone-100'
  | 'md:border-bone-100'
  | 'mg:border-bone-100'
  | 'lg:border-bone-100'
  | 'xl:border-bone-100'
  | 'group-hover:border-bone-100'
  | 'focus-within:border-bone-100'
  | 'hover:border-bone-100'
  | 'focus:border-bone-100'
  | 'sm:border-bone-200'
  | 'md:border-bone-200'
  | 'mg:border-bone-200'
  | 'lg:border-bone-200'
  | 'xl:border-bone-200'
  | 'group-hover:border-bone-200'
  | 'focus-within:border-bone-200'
  | 'hover:border-bone-200'
  | 'focus:border-bone-200'
  | 'sm:border-bone-300'
  | 'md:border-bone-300'
  | 'mg:border-bone-300'
  | 'lg:border-bone-300'
  | 'xl:border-bone-300'
  | 'group-hover:border-bone-300'
  | 'focus-within:border-bone-300'
  | 'hover:border-bone-300'
  | 'focus:border-bone-300'
  | 'sm:border-bone-400'
  | 'md:border-bone-400'
  | 'mg:border-bone-400'
  | 'lg:border-bone-400'
  | 'xl:border-bone-400'
  | 'group-hover:border-bone-400'
  | 'focus-within:border-bone-400'
  | 'hover:border-bone-400'
  | 'focus:border-bone-400'
  | 'sm:border-bone-500'
  | 'md:border-bone-500'
  | 'mg:border-bone-500'
  | 'lg:border-bone-500'
  | 'xl:border-bone-500'
  | 'group-hover:border-bone-500'
  | 'focus-within:border-bone-500'
  | 'hover:border-bone-500'
  | 'focus:border-bone-500'
  | 'sm:border-bone-600'
  | 'md:border-bone-600'
  | 'mg:border-bone-600'
  | 'lg:border-bone-600'
  | 'xl:border-bone-600'
  | 'group-hover:border-bone-600'
  | 'focus-within:border-bone-600'
  | 'hover:border-bone-600'
  | 'focus:border-bone-600'
  | 'sm:border-bone-700'
  | 'md:border-bone-700'
  | 'mg:border-bone-700'
  | 'lg:border-bone-700'
  | 'xl:border-bone-700'
  | 'group-hover:border-bone-700'
  | 'focus-within:border-bone-700'
  | 'hover:border-bone-700'
  | 'focus:border-bone-700'
  | 'sm:border-bone-800'
  | 'md:border-bone-800'
  | 'mg:border-bone-800'
  | 'lg:border-bone-800'
  | 'xl:border-bone-800'
  | 'group-hover:border-bone-800'
  | 'focus-within:border-bone-800'
  | 'hover:border-bone-800'
  | 'focus:border-bone-800'
  | 'sm:border-bone-900'
  | 'md:border-bone-900'
  | 'mg:border-bone-900'
  | 'lg:border-bone-900'
  | 'xl:border-bone-900'
  | 'group-hover:border-bone-900'
  | 'focus-within:border-bone-900'
  | 'hover:border-bone-900'
  | 'focus:border-bone-900'
  | 'sm:border-brick-50'
  | 'md:border-brick-50'
  | 'mg:border-brick-50'
  | 'lg:border-brick-50'
  | 'xl:border-brick-50'
  | 'group-hover:border-brick-50'
  | 'focus-within:border-brick-50'
  | 'hover:border-brick-50'
  | 'focus:border-brick-50'
  | 'sm:border-brick-300'
  | 'md:border-brick-300'
  | 'mg:border-brick-300'
  | 'lg:border-brick-300'
  | 'xl:border-brick-300'
  | 'group-hover:border-brick-300'
  | 'focus-within:border-brick-300'
  | 'hover:border-brick-300'
  | 'focus:border-brick-300'
  | 'sm:border-brick-500'
  | 'md:border-brick-500'
  | 'mg:border-brick-500'
  | 'lg:border-brick-500'
  | 'xl:border-brick-500'
  | 'group-hover:border-brick-500'
  | 'focus-within:border-brick-500'
  | 'hover:border-brick-500'
  | 'focus:border-brick-500'
  | 'sm:border-brick-700'
  | 'md:border-brick-700'
  | 'mg:border-brick-700'
  | 'lg:border-brick-700'
  | 'xl:border-brick-700'
  | 'group-hover:border-brick-700'
  | 'focus-within:border-brick-700'
  | 'hover:border-brick-700'
  | 'focus:border-brick-700'
  | 'sm:border-brick-900'
  | 'md:border-brick-900'
  | 'mg:border-brick-900'
  | 'lg:border-brick-900'
  | 'xl:border-brick-900'
  | 'group-hover:border-brick-900'
  | 'focus-within:border-brick-900'
  | 'hover:border-brick-900'
  | 'focus:border-brick-900'
  | 'sm:border-sage-50'
  | 'md:border-sage-50'
  | 'mg:border-sage-50'
  | 'lg:border-sage-50'
  | 'xl:border-sage-50'
  | 'group-hover:border-sage-50'
  | 'focus-within:border-sage-50'
  | 'hover:border-sage-50'
  | 'focus:border-sage-50'
  | 'sm:border-sage-300'
  | 'md:border-sage-300'
  | 'mg:border-sage-300'
  | 'lg:border-sage-300'
  | 'xl:border-sage-300'
  | 'group-hover:border-sage-300'
  | 'focus-within:border-sage-300'
  | 'hover:border-sage-300'
  | 'focus:border-sage-300'
  | 'sm:border-sage-500'
  | 'md:border-sage-500'
  | 'mg:border-sage-500'
  | 'lg:border-sage-500'
  | 'xl:border-sage-500'
  | 'group-hover:border-sage-500'
  | 'focus-within:border-sage-500'
  | 'hover:border-sage-500'
  | 'focus:border-sage-500'
  | 'sm:border-sage-700'
  | 'md:border-sage-700'
  | 'mg:border-sage-700'
  | 'lg:border-sage-700'
  | 'xl:border-sage-700'
  | 'group-hover:border-sage-700'
  | 'focus-within:border-sage-700'
  | 'hover:border-sage-700'
  | 'focus:border-sage-700'
  | 'sm:border-sage-900'
  | 'md:border-sage-900'
  | 'mg:border-sage-900'
  | 'lg:border-sage-900'
  | 'xl:border-sage-900'
  | 'group-hover:border-sage-900'
  | 'focus-within:border-sage-900'
  | 'hover:border-sage-900'
  | 'focus:border-sage-900'
  | 'sm:border-blue-50'
  | 'md:border-blue-50'
  | 'mg:border-blue-50'
  | 'lg:border-blue-50'
  | 'xl:border-blue-50'
  | 'group-hover:border-blue-50'
  | 'focus-within:border-blue-50'
  | 'hover:border-blue-50'
  | 'focus:border-blue-50'
  | 'sm:border-blue-300'
  | 'md:border-blue-300'
  | 'mg:border-blue-300'
  | 'lg:border-blue-300'
  | 'xl:border-blue-300'
  | 'group-hover:border-blue-300'
  | 'focus-within:border-blue-300'
  | 'hover:border-blue-300'
  | 'focus:border-blue-300'
  | 'sm:border-blue-500'
  | 'md:border-blue-500'
  | 'mg:border-blue-500'
  | 'lg:border-blue-500'
  | 'xl:border-blue-500'
  | 'group-hover:border-blue-500'
  | 'focus-within:border-blue-500'
  | 'hover:border-blue-500'
  | 'focus:border-blue-500'
  | 'sm:border-blue-700'
  | 'md:border-blue-700'
  | 'mg:border-blue-700'
  | 'lg:border-blue-700'
  | 'xl:border-blue-700'
  | 'group-hover:border-blue-700'
  | 'focus-within:border-blue-700'
  | 'hover:border-blue-700'
  | 'focus:border-blue-700'
  | 'sm:border-blue-900'
  | 'md:border-blue-900'
  | 'mg:border-blue-900'
  | 'lg:border-blue-900'
  | 'xl:border-blue-900'
  | 'group-hover:border-blue-900'
  | 'focus-within:border-blue-900'
  | 'hover:border-blue-900'
  | 'focus:border-blue-900'
  | 'sm:border-misc-bright-blue'
  | 'md:border-misc-bright-blue'
  | 'mg:border-misc-bright-blue'
  | 'lg:border-misc-bright-blue'
  | 'xl:border-misc-bright-blue'
  | 'group-hover:border-misc-bright-blue'
  | 'focus-within:border-misc-bright-blue'
  | 'hover:border-misc-bright-blue'
  | 'focus:border-misc-bright-blue'
  | 'sm:border-misc-focus'
  | 'md:border-misc-focus'
  | 'mg:border-misc-focus'
  | 'lg:border-misc-focus'
  | 'xl:border-misc-focus'
  | 'group-hover:border-misc-focus'
  | 'focus-within:border-misc-focus'
  | 'hover:border-misc-focus'
  | 'focus:border-misc-focus'
  | 'sm:border-misc-legal-blue'
  | 'md:border-misc-legal-blue'
  | 'mg:border-misc-legal-blue'
  | 'lg:border-misc-legal-blue'
  | 'xl:border-misc-legal-blue'
  | 'group-hover:border-misc-legal-blue'
  | 'focus-within:border-misc-legal-blue'
  | 'hover:border-misc-legal-blue'
  | 'focus:border-misc-legal-blue'
  | 'sm:border-misc-neutral'
  | 'md:border-misc-neutral'
  | 'mg:border-misc-neutral'
  | 'lg:border-misc-neutral'
  | 'xl:border-misc-neutral'
  | 'group-hover:border-misc-neutral'
  | 'focus-within:border-misc-neutral'
  | 'hover:border-misc-neutral'
  | 'focus:border-misc-neutral'
  | 'sm:border-misc-yellow-orange'
  | 'md:border-misc-yellow-orange'
  | 'mg:border-misc-yellow-orange'
  | 'lg:border-misc-yellow-orange'
  | 'xl:border-misc-yellow-orange'
  | 'group-hover:border-misc-yellow-orange'
  | 'focus-within:border-misc-yellow-orange'
  | 'hover:border-misc-yellow-orange'
  | 'focus:border-misc-yellow-orange'
  | 'sm:border-opacity-0'
  | 'md:border-opacity-0'
  | 'mg:border-opacity-0'
  | 'lg:border-opacity-0'
  | 'xl:border-opacity-0'
  | 'group-hover:border-opacity-0'
  | 'focus-within:border-opacity-0'
  | 'hover:border-opacity-0'
  | 'focus:border-opacity-0'
  | 'sm:border-opacity-5'
  | 'md:border-opacity-5'
  | 'mg:border-opacity-5'
  | 'lg:border-opacity-5'
  | 'xl:border-opacity-5'
  | 'group-hover:border-opacity-5'
  | 'focus-within:border-opacity-5'
  | 'hover:border-opacity-5'
  | 'focus:border-opacity-5'
  | 'sm:border-opacity-10'
  | 'md:border-opacity-10'
  | 'mg:border-opacity-10'
  | 'lg:border-opacity-10'
  | 'xl:border-opacity-10'
  | 'group-hover:border-opacity-10'
  | 'focus-within:border-opacity-10'
  | 'hover:border-opacity-10'
  | 'focus:border-opacity-10'
  | 'sm:border-opacity-20'
  | 'md:border-opacity-20'
  | 'mg:border-opacity-20'
  | 'lg:border-opacity-20'
  | 'xl:border-opacity-20'
  | 'group-hover:border-opacity-20'
  | 'focus-within:border-opacity-20'
  | 'hover:border-opacity-20'
  | 'focus:border-opacity-20'
  | 'sm:border-opacity-25'
  | 'md:border-opacity-25'
  | 'mg:border-opacity-25'
  | 'lg:border-opacity-25'
  | 'xl:border-opacity-25'
  | 'group-hover:border-opacity-25'
  | 'focus-within:border-opacity-25'
  | 'hover:border-opacity-25'
  | 'focus:border-opacity-25'
  | 'sm:border-opacity-30'
  | 'md:border-opacity-30'
  | 'mg:border-opacity-30'
  | 'lg:border-opacity-30'
  | 'xl:border-opacity-30'
  | 'group-hover:border-opacity-30'
  | 'focus-within:border-opacity-30'
  | 'hover:border-opacity-30'
  | 'focus:border-opacity-30'
  | 'sm:border-opacity-40'
  | 'md:border-opacity-40'
  | 'mg:border-opacity-40'
  | 'lg:border-opacity-40'
  | 'xl:border-opacity-40'
  | 'group-hover:border-opacity-40'
  | 'focus-within:border-opacity-40'
  | 'hover:border-opacity-40'
  | 'focus:border-opacity-40'
  | 'sm:border-opacity-50'
  | 'md:border-opacity-50'
  | 'mg:border-opacity-50'
  | 'lg:border-opacity-50'
  | 'xl:border-opacity-50'
  | 'group-hover:border-opacity-50'
  | 'focus-within:border-opacity-50'
  | 'hover:border-opacity-50'
  | 'focus:border-opacity-50'
  | 'sm:border-opacity-60'
  | 'md:border-opacity-60'
  | 'mg:border-opacity-60'
  | 'lg:border-opacity-60'
  | 'xl:border-opacity-60'
  | 'group-hover:border-opacity-60'
  | 'focus-within:border-opacity-60'
  | 'hover:border-opacity-60'
  | 'focus:border-opacity-60'
  | 'sm:border-opacity-70'
  | 'md:border-opacity-70'
  | 'mg:border-opacity-70'
  | 'lg:border-opacity-70'
  | 'xl:border-opacity-70'
  | 'group-hover:border-opacity-70'
  | 'focus-within:border-opacity-70'
  | 'hover:border-opacity-70'
  | 'focus:border-opacity-70'
  | 'sm:border-opacity-75'
  | 'md:border-opacity-75'
  | 'mg:border-opacity-75'
  | 'lg:border-opacity-75'
  | 'xl:border-opacity-75'
  | 'group-hover:border-opacity-75'
  | 'focus-within:border-opacity-75'
  | 'hover:border-opacity-75'
  | 'focus:border-opacity-75'
  | 'sm:border-opacity-80'
  | 'md:border-opacity-80'
  | 'mg:border-opacity-80'
  | 'lg:border-opacity-80'
  | 'xl:border-opacity-80'
  | 'group-hover:border-opacity-80'
  | 'focus-within:border-opacity-80'
  | 'hover:border-opacity-80'
  | 'focus:border-opacity-80'
  | 'sm:border-opacity-90'
  | 'md:border-opacity-90'
  | 'mg:border-opacity-90'
  | 'lg:border-opacity-90'
  | 'xl:border-opacity-90'
  | 'group-hover:border-opacity-90'
  | 'focus-within:border-opacity-90'
  | 'hover:border-opacity-90'
  | 'focus:border-opacity-90'
  | 'sm:border-opacity-95'
  | 'md:border-opacity-95'
  | 'mg:border-opacity-95'
  | 'lg:border-opacity-95'
  | 'xl:border-opacity-95'
  | 'group-hover:border-opacity-95'
  | 'focus-within:border-opacity-95'
  | 'hover:border-opacity-95'
  | 'focus:border-opacity-95'
  | 'sm:border-opacity-100'
  | 'md:border-opacity-100'
  | 'mg:border-opacity-100'
  | 'lg:border-opacity-100'
  | 'xl:border-opacity-100'
  | 'group-hover:border-opacity-100'
  | 'focus-within:border-opacity-100'
  | 'hover:border-opacity-100'
  | 'focus:border-opacity-100'
  | 'sm:rounded-t-100'
  | 'md:rounded-t-100'
  | 'mg:rounded-t-100'
  | 'lg:rounded-t-100'
  | 'xl:rounded-t-100'
  | 'sm:rounded-r-100'
  | 'md:rounded-r-100'
  | 'mg:rounded-r-100'
  | 'lg:rounded-r-100'
  | 'xl:rounded-r-100'
  | 'sm:rounded-b-100'
  | 'md:rounded-b-100'
  | 'mg:rounded-b-100'
  | 'lg:rounded-b-100'
  | 'xl:rounded-b-100'
  | 'sm:rounded-l-100'
  | 'md:rounded-l-100'
  | 'mg:rounded-l-100'
  | 'lg:rounded-l-100'
  | 'xl:rounded-l-100'
  | 'sm:rounded-tr-100'
  | 'md:rounded-tr-100'
  | 'mg:rounded-tr-100'
  | 'lg:rounded-tr-100'
  | 'xl:rounded-tr-100'
  | 'sm:rounded-tl-100'
  | 'md:rounded-tl-100'
  | 'mg:rounded-tl-100'
  | 'lg:rounded-tl-100'
  | 'xl:rounded-tl-100'
  | 'sm:rounded-br-100'
  | 'md:rounded-br-100'
  | 'mg:rounded-br-100'
  | 'lg:rounded-br-100'
  | 'xl:rounded-br-100'
  | 'sm:rounded-bl-100'
  | 'md:rounded-bl-100'
  | 'mg:rounded-bl-100'
  | 'lg:rounded-bl-100'
  | 'xl:rounded-bl-100'
  | 'sm:rounded-100'
  | 'md:rounded-100'
  | 'mg:rounded-100'
  | 'lg:rounded-100'
  | 'xl:rounded-100'
  | 'sm:rounded-t-none'
  | 'md:rounded-t-none'
  | 'mg:rounded-t-none'
  | 'lg:rounded-t-none'
  | 'xl:rounded-t-none'
  | 'sm:rounded-r-none'
  | 'md:rounded-r-none'
  | 'mg:rounded-r-none'
  | 'lg:rounded-r-none'
  | 'xl:rounded-r-none'
  | 'sm:rounded-b-none'
  | 'md:rounded-b-none'
  | 'mg:rounded-b-none'
  | 'lg:rounded-b-none'
  | 'xl:rounded-b-none'
  | 'sm:rounded-l-none'
  | 'md:rounded-l-none'
  | 'mg:rounded-l-none'
  | 'lg:rounded-l-none'
  | 'xl:rounded-l-none'
  | 'sm:rounded-tr-none'
  | 'md:rounded-tr-none'
  | 'mg:rounded-tr-none'
  | 'lg:rounded-tr-none'
  | 'xl:rounded-tr-none'
  | 'sm:rounded-tl-none'
  | 'md:rounded-tl-none'
  | 'mg:rounded-tl-none'
  | 'lg:rounded-tl-none'
  | 'xl:rounded-tl-none'
  | 'sm:rounded-br-none'
  | 'md:rounded-br-none'
  | 'mg:rounded-br-none'
  | 'lg:rounded-br-none'
  | 'xl:rounded-br-none'
  | 'sm:rounded-bl-none'
  | 'md:rounded-bl-none'
  | 'mg:rounded-bl-none'
  | 'lg:rounded-bl-none'
  | 'xl:rounded-bl-none'
  | 'sm:rounded-none'
  | 'md:rounded-none'
  | 'mg:rounded-none'
  | 'lg:rounded-none'
  | 'xl:rounded-none'
  | 'sm:rounded-t-sm'
  | 'md:rounded-t-sm'
  | 'mg:rounded-t-sm'
  | 'lg:rounded-t-sm'
  | 'xl:rounded-t-sm'
  | 'sm:rounded-r-sm'
  | 'md:rounded-r-sm'
  | 'mg:rounded-r-sm'
  | 'lg:rounded-r-sm'
  | 'xl:rounded-r-sm'
  | 'sm:rounded-b-sm'
  | 'md:rounded-b-sm'
  | 'mg:rounded-b-sm'
  | 'lg:rounded-b-sm'
  | 'xl:rounded-b-sm'
  | 'sm:rounded-l-sm'
  | 'md:rounded-l-sm'
  | 'mg:rounded-l-sm'
  | 'lg:rounded-l-sm'
  | 'xl:rounded-l-sm'
  | 'sm:rounded-tr-sm'
  | 'md:rounded-tr-sm'
  | 'mg:rounded-tr-sm'
  | 'lg:rounded-tr-sm'
  | 'xl:rounded-tr-sm'
  | 'sm:rounded-tl-sm'
  | 'md:rounded-tl-sm'
  | 'mg:rounded-tl-sm'
  | 'lg:rounded-tl-sm'
  | 'xl:rounded-tl-sm'
  | 'sm:rounded-br-sm'
  | 'md:rounded-br-sm'
  | 'mg:rounded-br-sm'
  | 'lg:rounded-br-sm'
  | 'xl:rounded-br-sm'
  | 'sm:rounded-bl-sm'
  | 'md:rounded-bl-sm'
  | 'mg:rounded-bl-sm'
  | 'lg:rounded-bl-sm'
  | 'xl:rounded-bl-sm'
  | 'sm:rounded-sm'
  | 'md:rounded-sm'
  | 'mg:rounded-sm'
  | 'lg:rounded-sm'
  | 'xl:rounded-sm'
  | 'sm:rounded-t'
  | 'md:rounded-t'
  | 'mg:rounded-t'
  | 'lg:rounded-t'
  | 'xl:rounded-t'
  | 'sm:rounded-r'
  | 'md:rounded-r'
  | 'mg:rounded-r'
  | 'lg:rounded-r'
  | 'xl:rounded-r'
  | 'sm:rounded-b'
  | 'md:rounded-b'
  | 'mg:rounded-b'
  | 'lg:rounded-b'
  | 'xl:rounded-b'
  | 'sm:rounded-l'
  | 'md:rounded-l'
  | 'mg:rounded-l'
  | 'lg:rounded-l'
  | 'xl:rounded-l'
  | 'sm:rounded-tr'
  | 'md:rounded-tr'
  | 'mg:rounded-tr'
  | 'lg:rounded-tr'
  | 'xl:rounded-tr'
  | 'sm:rounded-tl'
  | 'md:rounded-tl'
  | 'mg:rounded-tl'
  | 'lg:rounded-tl'
  | 'xl:rounded-tl'
  | 'sm:rounded-br'
  | 'md:rounded-br'
  | 'mg:rounded-br'
  | 'lg:rounded-br'
  | 'xl:rounded-br'
  | 'sm:rounded-bl'
  | 'md:rounded-bl'
  | 'mg:rounded-bl'
  | 'lg:rounded-bl'
  | 'xl:rounded-bl'
  | 'sm:rounded'
  | 'md:rounded'
  | 'mg:rounded'
  | 'lg:rounded'
  | 'xl:rounded'
  | 'sm:rounded-t-md'
  | 'md:rounded-t-md'
  | 'mg:rounded-t-md'
  | 'lg:rounded-t-md'
  | 'xl:rounded-t-md'
  | 'sm:rounded-r-md'
  | 'md:rounded-r-md'
  | 'mg:rounded-r-md'
  | 'lg:rounded-r-md'
  | 'xl:rounded-r-md'
  | 'sm:rounded-b-md'
  | 'md:rounded-b-md'
  | 'mg:rounded-b-md'
  | 'lg:rounded-b-md'
  | 'xl:rounded-b-md'
  | 'sm:rounded-l-md'
  | 'md:rounded-l-md'
  | 'mg:rounded-l-md'
  | 'lg:rounded-l-md'
  | 'xl:rounded-l-md'
  | 'sm:rounded-tr-md'
  | 'md:rounded-tr-md'
  | 'mg:rounded-tr-md'
  | 'lg:rounded-tr-md'
  | 'xl:rounded-tr-md'
  | 'sm:rounded-tl-md'
  | 'md:rounded-tl-md'
  | 'mg:rounded-tl-md'
  | 'lg:rounded-tl-md'
  | 'xl:rounded-tl-md'
  | 'sm:rounded-br-md'
  | 'md:rounded-br-md'
  | 'mg:rounded-br-md'
  | 'lg:rounded-br-md'
  | 'xl:rounded-br-md'
  | 'sm:rounded-bl-md'
  | 'md:rounded-bl-md'
  | 'mg:rounded-bl-md'
  | 'lg:rounded-bl-md'
  | 'xl:rounded-bl-md'
  | 'sm:rounded-md'
  | 'md:rounded-md'
  | 'mg:rounded-md'
  | 'lg:rounded-md'
  | 'xl:rounded-md'
  | 'sm:rounded-t-lg'
  | 'md:rounded-t-lg'
  | 'mg:rounded-t-lg'
  | 'lg:rounded-t-lg'
  | 'xl:rounded-t-lg'
  | 'sm:rounded-r-lg'
  | 'md:rounded-r-lg'
  | 'mg:rounded-r-lg'
  | 'lg:rounded-r-lg'
  | 'xl:rounded-r-lg'
  | 'sm:rounded-b-lg'
  | 'md:rounded-b-lg'
  | 'mg:rounded-b-lg'
  | 'lg:rounded-b-lg'
  | 'xl:rounded-b-lg'
  | 'sm:rounded-l-lg'
  | 'md:rounded-l-lg'
  | 'mg:rounded-l-lg'
  | 'lg:rounded-l-lg'
  | 'xl:rounded-l-lg'
  | 'sm:rounded-tr-lg'
  | 'md:rounded-tr-lg'
  | 'mg:rounded-tr-lg'
  | 'lg:rounded-tr-lg'
  | 'xl:rounded-tr-lg'
  | 'sm:rounded-tl-lg'
  | 'md:rounded-tl-lg'
  | 'mg:rounded-tl-lg'
  | 'lg:rounded-tl-lg'
  | 'xl:rounded-tl-lg'
  | 'sm:rounded-br-lg'
  | 'md:rounded-br-lg'
  | 'mg:rounded-br-lg'
  | 'lg:rounded-br-lg'
  | 'xl:rounded-br-lg'
  | 'sm:rounded-bl-lg'
  | 'md:rounded-bl-lg'
  | 'mg:rounded-bl-lg'
  | 'lg:rounded-bl-lg'
  | 'xl:rounded-bl-lg'
  | 'sm:rounded-lg'
  | 'md:rounded-lg'
  | 'mg:rounded-lg'
  | 'lg:rounded-lg'
  | 'xl:rounded-lg'
  | 'sm:rounded-t-xl'
  | 'md:rounded-t-xl'
  | 'mg:rounded-t-xl'
  | 'lg:rounded-t-xl'
  | 'xl:rounded-t-xl'
  | 'sm:rounded-r-xl'
  | 'md:rounded-r-xl'
  | 'mg:rounded-r-xl'
  | 'lg:rounded-r-xl'
  | 'xl:rounded-r-xl'
  | 'sm:rounded-b-xl'
  | 'md:rounded-b-xl'
  | 'mg:rounded-b-xl'
  | 'lg:rounded-b-xl'
  | 'xl:rounded-b-xl'
  | 'sm:rounded-l-xl'
  | 'md:rounded-l-xl'
  | 'mg:rounded-l-xl'
  | 'lg:rounded-l-xl'
  | 'xl:rounded-l-xl'
  | 'sm:rounded-tr-xl'
  | 'md:rounded-tr-xl'
  | 'mg:rounded-tr-xl'
  | 'lg:rounded-tr-xl'
  | 'xl:rounded-tr-xl'
  | 'sm:rounded-tl-xl'
  | 'md:rounded-tl-xl'
  | 'mg:rounded-tl-xl'
  | 'lg:rounded-tl-xl'
  | 'xl:rounded-tl-xl'
  | 'sm:rounded-br-xl'
  | 'md:rounded-br-xl'
  | 'mg:rounded-br-xl'
  | 'lg:rounded-br-xl'
  | 'xl:rounded-br-xl'
  | 'sm:rounded-bl-xl'
  | 'md:rounded-bl-xl'
  | 'mg:rounded-bl-xl'
  | 'lg:rounded-bl-xl'
  | 'xl:rounded-bl-xl'
  | 'sm:rounded-xl'
  | 'md:rounded-xl'
  | 'mg:rounded-xl'
  | 'lg:rounded-xl'
  | 'xl:rounded-xl'
  | 'sm:rounded-t-2xl'
  | 'md:rounded-t-2xl'
  | 'mg:rounded-t-2xl'
  | 'lg:rounded-t-2xl'
  | 'xl:rounded-t-2xl'
  | 'sm:rounded-r-2xl'
  | 'md:rounded-r-2xl'
  | 'mg:rounded-r-2xl'
  | 'lg:rounded-r-2xl'
  | 'xl:rounded-r-2xl'
  | 'sm:rounded-b-2xl'
  | 'md:rounded-b-2xl'
  | 'mg:rounded-b-2xl'
  | 'lg:rounded-b-2xl'
  | 'xl:rounded-b-2xl'
  | 'sm:rounded-l-2xl'
  | 'md:rounded-l-2xl'
  | 'mg:rounded-l-2xl'
  | 'lg:rounded-l-2xl'
  | 'xl:rounded-l-2xl'
  | 'sm:rounded-tr-2xl'
  | 'md:rounded-tr-2xl'
  | 'mg:rounded-tr-2xl'
  | 'lg:rounded-tr-2xl'
  | 'xl:rounded-tr-2xl'
  | 'sm:rounded-tl-2xl'
  | 'md:rounded-tl-2xl'
  | 'mg:rounded-tl-2xl'
  | 'lg:rounded-tl-2xl'
  | 'xl:rounded-tl-2xl'
  | 'sm:rounded-br-2xl'
  | 'md:rounded-br-2xl'
  | 'mg:rounded-br-2xl'
  | 'lg:rounded-br-2xl'
  | 'xl:rounded-br-2xl'
  | 'sm:rounded-bl-2xl'
  | 'md:rounded-bl-2xl'
  | 'mg:rounded-bl-2xl'
  | 'lg:rounded-bl-2xl'
  | 'xl:rounded-bl-2xl'
  | 'sm:rounded-2xl'
  | 'md:rounded-2xl'
  | 'mg:rounded-2xl'
  | 'lg:rounded-2xl'
  | 'xl:rounded-2xl'
  | 'sm:rounded-t-3xl'
  | 'md:rounded-t-3xl'
  | 'mg:rounded-t-3xl'
  | 'lg:rounded-t-3xl'
  | 'xl:rounded-t-3xl'
  | 'sm:rounded-r-3xl'
  | 'md:rounded-r-3xl'
  | 'mg:rounded-r-3xl'
  | 'lg:rounded-r-3xl'
  | 'xl:rounded-r-3xl'
  | 'sm:rounded-b-3xl'
  | 'md:rounded-b-3xl'
  | 'mg:rounded-b-3xl'
  | 'lg:rounded-b-3xl'
  | 'xl:rounded-b-3xl'
  | 'sm:rounded-l-3xl'
  | 'md:rounded-l-3xl'
  | 'mg:rounded-l-3xl'
  | 'lg:rounded-l-3xl'
  | 'xl:rounded-l-3xl'
  | 'sm:rounded-tr-3xl'
  | 'md:rounded-tr-3xl'
  | 'mg:rounded-tr-3xl'
  | 'lg:rounded-tr-3xl'
  | 'xl:rounded-tr-3xl'
  | 'sm:rounded-tl-3xl'
  | 'md:rounded-tl-3xl'
  | 'mg:rounded-tl-3xl'
  | 'lg:rounded-tl-3xl'
  | 'xl:rounded-tl-3xl'
  | 'sm:rounded-br-3xl'
  | 'md:rounded-br-3xl'
  | 'mg:rounded-br-3xl'
  | 'lg:rounded-br-3xl'
  | 'xl:rounded-br-3xl'
  | 'sm:rounded-bl-3xl'
  | 'md:rounded-bl-3xl'
  | 'mg:rounded-bl-3xl'
  | 'lg:rounded-bl-3xl'
  | 'xl:rounded-bl-3xl'
  | 'sm:rounded-3xl'
  | 'md:rounded-3xl'
  | 'mg:rounded-3xl'
  | 'lg:rounded-3xl'
  | 'xl:rounded-3xl'
  | 'sm:rounded-t-4xl'
  | 'md:rounded-t-4xl'
  | 'mg:rounded-t-4xl'
  | 'lg:rounded-t-4xl'
  | 'xl:rounded-t-4xl'
  | 'sm:rounded-r-4xl'
  | 'md:rounded-r-4xl'
  | 'mg:rounded-r-4xl'
  | 'lg:rounded-r-4xl'
  | 'xl:rounded-r-4xl'
  | 'sm:rounded-b-4xl'
  | 'md:rounded-b-4xl'
  | 'mg:rounded-b-4xl'
  | 'lg:rounded-b-4xl'
  | 'xl:rounded-b-4xl'
  | 'sm:rounded-l-4xl'
  | 'md:rounded-l-4xl'
  | 'mg:rounded-l-4xl'
  | 'lg:rounded-l-4xl'
  | 'xl:rounded-l-4xl'
  | 'sm:rounded-tr-4xl'
  | 'md:rounded-tr-4xl'
  | 'mg:rounded-tr-4xl'
  | 'lg:rounded-tr-4xl'
  | 'xl:rounded-tr-4xl'
  | 'sm:rounded-tl-4xl'
  | 'md:rounded-tl-4xl'
  | 'mg:rounded-tl-4xl'
  | 'lg:rounded-tl-4xl'
  | 'xl:rounded-tl-4xl'
  | 'sm:rounded-br-4xl'
  | 'md:rounded-br-4xl'
  | 'mg:rounded-br-4xl'
  | 'lg:rounded-br-4xl'
  | 'xl:rounded-br-4xl'
  | 'sm:rounded-bl-4xl'
  | 'md:rounded-bl-4xl'
  | 'mg:rounded-bl-4xl'
  | 'lg:rounded-bl-4xl'
  | 'xl:rounded-bl-4xl'
  | 'sm:rounded-4xl'
  | 'md:rounded-4xl'
  | 'mg:rounded-4xl'
  | 'lg:rounded-4xl'
  | 'xl:rounded-4xl'
  | 'sm:rounded-t-5xl'
  | 'md:rounded-t-5xl'
  | 'mg:rounded-t-5xl'
  | 'lg:rounded-t-5xl'
  | 'xl:rounded-t-5xl'
  | 'sm:rounded-r-5xl'
  | 'md:rounded-r-5xl'
  | 'mg:rounded-r-5xl'
  | 'lg:rounded-r-5xl'
  | 'xl:rounded-r-5xl'
  | 'sm:rounded-b-5xl'
  | 'md:rounded-b-5xl'
  | 'mg:rounded-b-5xl'
  | 'lg:rounded-b-5xl'
  | 'xl:rounded-b-5xl'
  | 'sm:rounded-l-5xl'
  | 'md:rounded-l-5xl'
  | 'mg:rounded-l-5xl'
  | 'lg:rounded-l-5xl'
  | 'xl:rounded-l-5xl'
  | 'sm:rounded-tr-5xl'
  | 'md:rounded-tr-5xl'
  | 'mg:rounded-tr-5xl'
  | 'lg:rounded-tr-5xl'
  | 'xl:rounded-tr-5xl'
  | 'sm:rounded-tl-5xl'
  | 'md:rounded-tl-5xl'
  | 'mg:rounded-tl-5xl'
  | 'lg:rounded-tl-5xl'
  | 'xl:rounded-tl-5xl'
  | 'sm:rounded-br-5xl'
  | 'md:rounded-br-5xl'
  | 'mg:rounded-br-5xl'
  | 'lg:rounded-br-5xl'
  | 'xl:rounded-br-5xl'
  | 'sm:rounded-bl-5xl'
  | 'md:rounded-bl-5xl'
  | 'mg:rounded-bl-5xl'
  | 'lg:rounded-bl-5xl'
  | 'xl:rounded-bl-5xl'
  | 'sm:rounded-5xl'
  | 'md:rounded-5xl'
  | 'mg:rounded-5xl'
  | 'lg:rounded-5xl'
  | 'xl:rounded-5xl'
  | 'sm:rounded-t-6xl'
  | 'md:rounded-t-6xl'
  | 'mg:rounded-t-6xl'
  | 'lg:rounded-t-6xl'
  | 'xl:rounded-t-6xl'
  | 'sm:rounded-r-6xl'
  | 'md:rounded-r-6xl'
  | 'mg:rounded-r-6xl'
  | 'lg:rounded-r-6xl'
  | 'xl:rounded-r-6xl'
  | 'sm:rounded-b-6xl'
  | 'md:rounded-b-6xl'
  | 'mg:rounded-b-6xl'
  | 'lg:rounded-b-6xl'
  | 'xl:rounded-b-6xl'
  | 'sm:rounded-l-6xl'
  | 'md:rounded-l-6xl'
  | 'mg:rounded-l-6xl'
  | 'lg:rounded-l-6xl'
  | 'xl:rounded-l-6xl'
  | 'sm:rounded-tr-6xl'
  | 'md:rounded-tr-6xl'
  | 'mg:rounded-tr-6xl'
  | 'lg:rounded-tr-6xl'
  | 'xl:rounded-tr-6xl'
  | 'sm:rounded-tl-6xl'
  | 'md:rounded-tl-6xl'
  | 'mg:rounded-tl-6xl'
  | 'lg:rounded-tl-6xl'
  | 'xl:rounded-tl-6xl'
  | 'sm:rounded-br-6xl'
  | 'md:rounded-br-6xl'
  | 'mg:rounded-br-6xl'
  | 'lg:rounded-br-6xl'
  | 'xl:rounded-br-6xl'
  | 'sm:rounded-bl-6xl'
  | 'md:rounded-bl-6xl'
  | 'mg:rounded-bl-6xl'
  | 'lg:rounded-bl-6xl'
  | 'xl:rounded-bl-6xl'
  | 'sm:rounded-6xl'
  | 'md:rounded-6xl'
  | 'mg:rounded-6xl'
  | 'lg:rounded-6xl'
  | 'xl:rounded-6xl'
  | 'sm:rounded-t-full'
  | 'md:rounded-t-full'
  | 'mg:rounded-t-full'
  | 'lg:rounded-t-full'
  | 'xl:rounded-t-full'
  | 'sm:rounded-r-full'
  | 'md:rounded-r-full'
  | 'mg:rounded-r-full'
  | 'lg:rounded-r-full'
  | 'xl:rounded-r-full'
  | 'sm:rounded-b-full'
  | 'md:rounded-b-full'
  | 'mg:rounded-b-full'
  | 'lg:rounded-b-full'
  | 'xl:rounded-b-full'
  | 'sm:rounded-l-full'
  | 'md:rounded-l-full'
  | 'mg:rounded-l-full'
  | 'lg:rounded-l-full'
  | 'xl:rounded-l-full'
  | 'sm:rounded-tr-full'
  | 'md:rounded-tr-full'
  | 'mg:rounded-tr-full'
  | 'lg:rounded-tr-full'
  | 'xl:rounded-tr-full'
  | 'sm:rounded-tl-full'
  | 'md:rounded-tl-full'
  | 'mg:rounded-tl-full'
  | 'lg:rounded-tl-full'
  | 'xl:rounded-tl-full'
  | 'sm:rounded-br-full'
  | 'md:rounded-br-full'
  | 'mg:rounded-br-full'
  | 'lg:rounded-br-full'
  | 'xl:rounded-br-full'
  | 'sm:rounded-bl-full'
  | 'md:rounded-bl-full'
  | 'mg:rounded-bl-full'
  | 'lg:rounded-bl-full'
  | 'xl:rounded-bl-full'
  | 'sm:rounded-full'
  | 'md:rounded-full'
  | 'mg:rounded-full'
  | 'lg:rounded-full'
  | 'xl:rounded-full'
  | 'sm:border-solid'
  | 'md:border-solid'
  | 'mg:border-solid'
  | 'lg:border-solid'
  | 'xl:border-solid'
  | 'sm:border-dashed'
  | 'md:border-dashed'
  | 'mg:border-dashed'
  | 'lg:border-dashed'
  | 'xl:border-dashed'
  | 'sm:border-dotted'
  | 'md:border-dotted'
  | 'mg:border-dotted'
  | 'lg:border-dotted'
  | 'xl:border-dotted'
  | 'sm:border-double'
  | 'md:border-double'
  | 'mg:border-double'
  | 'lg:border-double'
  | 'xl:border-double'
  | 'sm:border-none'
  | 'md:border-none'
  | 'mg:border-none'
  | 'lg:border-none'
  | 'xl:border-none'
  | 'sm:border-t-0'
  | 'md:border-t-0'
  | 'mg:border-t-0'
  | 'lg:border-t-0'
  | 'xl:border-t-0'
  | 'sm:border-r-0'
  | 'md:border-r-0'
  | 'mg:border-r-0'
  | 'lg:border-r-0'
  | 'xl:border-r-0'
  | 'sm:border-b-0'
  | 'md:border-b-0'
  | 'mg:border-b-0'
  | 'lg:border-b-0'
  | 'xl:border-b-0'
  | 'sm:border-l-0'
  | 'md:border-l-0'
  | 'mg:border-l-0'
  | 'lg:border-l-0'
  | 'xl:border-l-0'
  | 'sm:border-0'
  | 'md:border-0'
  | 'mg:border-0'
  | 'lg:border-0'
  | 'xl:border-0'
  | 'sm:border-t-2'
  | 'md:border-t-2'
  | 'mg:border-t-2'
  | 'lg:border-t-2'
  | 'xl:border-t-2'
  | 'sm:border-r-2'
  | 'md:border-r-2'
  | 'mg:border-r-2'
  | 'lg:border-r-2'
  | 'xl:border-r-2'
  | 'sm:border-b-2'
  | 'md:border-b-2'
  | 'mg:border-b-2'
  | 'lg:border-b-2'
  | 'xl:border-b-2'
  | 'sm:border-l-2'
  | 'md:border-l-2'
  | 'mg:border-l-2'
  | 'lg:border-l-2'
  | 'xl:border-l-2'
  | 'sm:border-2'
  | 'md:border-2'
  | 'mg:border-2'
  | 'lg:border-2'
  | 'xl:border-2'
  | 'sm:border-t-3'
  | 'md:border-t-3'
  | 'mg:border-t-3'
  | 'lg:border-t-3'
  | 'xl:border-t-3'
  | 'sm:border-r-3'
  | 'md:border-r-3'
  | 'mg:border-r-3'
  | 'lg:border-r-3'
  | 'xl:border-r-3'
  | 'sm:border-b-3'
  | 'md:border-b-3'
  | 'mg:border-b-3'
  | 'lg:border-b-3'
  | 'xl:border-b-3'
  | 'sm:border-l-3'
  | 'md:border-l-3'
  | 'mg:border-l-3'
  | 'lg:border-l-3'
  | 'xl:border-l-3'
  | 'sm:border-3'
  | 'md:border-3'
  | 'mg:border-3'
  | 'lg:border-3'
  | 'xl:border-3'
  | 'sm:border-t-4'
  | 'md:border-t-4'
  | 'mg:border-t-4'
  | 'lg:border-t-4'
  | 'xl:border-t-4'
  | 'sm:border-r-4'
  | 'md:border-r-4'
  | 'mg:border-r-4'
  | 'lg:border-r-4'
  | 'xl:border-r-4'
  | 'sm:border-b-4'
  | 'md:border-b-4'
  | 'mg:border-b-4'
  | 'lg:border-b-4'
  | 'xl:border-b-4'
  | 'sm:border-l-4'
  | 'md:border-l-4'
  | 'mg:border-l-4'
  | 'lg:border-l-4'
  | 'xl:border-l-4'
  | 'sm:border-4'
  | 'md:border-4'
  | 'mg:border-4'
  | 'lg:border-4'
  | 'xl:border-4'
  | 'sm:border-t-6'
  | 'md:border-t-6'
  | 'mg:border-t-6'
  | 'lg:border-t-6'
  | 'xl:border-t-6'
  | 'sm:border-r-6'
  | 'md:border-r-6'
  | 'mg:border-r-6'
  | 'lg:border-r-6'
  | 'xl:border-r-6'
  | 'sm:border-b-6'
  | 'md:border-b-6'
  | 'mg:border-b-6'
  | 'lg:border-b-6'
  | 'xl:border-b-6'
  | 'sm:border-l-6'
  | 'md:border-l-6'
  | 'mg:border-l-6'
  | 'lg:border-l-6'
  | 'xl:border-l-6'
  | 'sm:border-6'
  | 'md:border-6'
  | 'mg:border-6'
  | 'lg:border-6'
  | 'xl:border-6'
  | 'sm:border-t-8'
  | 'md:border-t-8'
  | 'mg:border-t-8'
  | 'lg:border-t-8'
  | 'xl:border-t-8'
  | 'sm:border-r-8'
  | 'md:border-r-8'
  | 'mg:border-r-8'
  | 'lg:border-r-8'
  | 'xl:border-r-8'
  | 'sm:border-b-8'
  | 'md:border-b-8'
  | 'mg:border-b-8'
  | 'lg:border-b-8'
  | 'xl:border-b-8'
  | 'sm:border-l-8'
  | 'md:border-l-8'
  | 'mg:border-l-8'
  | 'lg:border-l-8'
  | 'xl:border-l-8'
  | 'sm:border-8'
  | 'md:border-8'
  | 'mg:border-8'
  | 'lg:border-8'
  | 'xl:border-8'
  | 'sm:border-t'
  | 'md:border-t'
  | 'mg:border-t'
  | 'lg:border-t'
  | 'xl:border-t'
  | 'sm:border-r'
  | 'md:border-r'
  | 'mg:border-r'
  | 'lg:border-r'
  | 'xl:border-r'
  | 'sm:border-b'
  | 'md:border-b'
  | 'mg:border-b'
  | 'lg:border-b'
  | 'xl:border-b'
  | 'sm:border-l'
  | 'md:border-l'
  | 'mg:border-l'
  | 'lg:border-l'
  | 'xl:border-l'
  | 'sm:border'
  | 'md:border'
  | 'mg:border'
  | 'lg:border'
  | 'xl:border'
  | 'sm:decoration-slice'
  | 'md:decoration-slice'
  | 'mg:decoration-slice'
  | 'lg:decoration-slice'
  | 'xl:decoration-slice'
  | 'sm:decoration-clone'
  | 'md:decoration-clone'
  | 'mg:decoration-clone'
  | 'lg:decoration-clone'
  | 'xl:decoration-clone'
  | 'sm:shadow-sm'
  | 'md:shadow-sm'
  | 'mg:shadow-sm'
  | 'lg:shadow-sm'
  | 'xl:shadow-sm'
  | 'group-hover:shadow-sm'
  | 'focus-within:shadow-sm'
  | 'hover:shadow-sm'
  | 'focus:shadow-sm'
  | 'sm:shadow'
  | 'md:shadow'
  | 'mg:shadow'
  | 'lg:shadow'
  | 'xl:shadow'
  | 'group-hover:shadow'
  | 'focus-within:shadow'
  | 'hover:shadow'
  | 'focus:shadow'
  | 'sm:shadow-md'
  | 'md:shadow-md'
  | 'mg:shadow-md'
  | 'lg:shadow-md'
  | 'xl:shadow-md'
  | 'group-hover:shadow-md'
  | 'focus-within:shadow-md'
  | 'hover:shadow-md'
  | 'focus:shadow-md'
  | 'sm:shadow-lg'
  | 'md:shadow-lg'
  | 'mg:shadow-lg'
  | 'lg:shadow-lg'
  | 'xl:shadow-lg'
  | 'group-hover:shadow-lg'
  | 'focus-within:shadow-lg'
  | 'hover:shadow-lg'
  | 'focus:shadow-lg'
  | 'sm:shadow-xl'
  | 'md:shadow-xl'
  | 'mg:shadow-xl'
  | 'lg:shadow-xl'
  | 'xl:shadow-xl'
  | 'group-hover:shadow-xl'
  | 'focus-within:shadow-xl'
  | 'hover:shadow-xl'
  | 'focus:shadow-xl'
  | 'sm:shadow-2xl'
  | 'md:shadow-2xl'
  | 'mg:shadow-2xl'
  | 'lg:shadow-2xl'
  | 'xl:shadow-2xl'
  | 'group-hover:shadow-2xl'
  | 'focus-within:shadow-2xl'
  | 'hover:shadow-2xl'
  | 'focus:shadow-2xl'
  | 'sm:shadow-inner'
  | 'md:shadow-inner'
  | 'mg:shadow-inner'
  | 'lg:shadow-inner'
  | 'xl:shadow-inner'
  | 'group-hover:shadow-inner'
  | 'focus-within:shadow-inner'
  | 'hover:shadow-inner'
  | 'focus:shadow-inner'
  | 'sm:shadow-none'
  | 'md:shadow-none'
  | 'mg:shadow-none'
  | 'lg:shadow-none'
  | 'xl:shadow-none'
  | 'group-hover:shadow-none'
  | 'focus-within:shadow-none'
  | 'hover:shadow-none'
  | 'focus:shadow-none'
  | 'sm:shadow-light-product-bar'
  | 'md:shadow-light-product-bar'
  | 'mg:shadow-light-product-bar'
  | 'lg:shadow-light-product-bar'
  | 'xl:shadow-light-product-bar'
  | 'group-hover:shadow-light-product-bar'
  | 'focus-within:shadow-light-product-bar'
  | 'hover:shadow-light-product-bar'
  | 'focus:shadow-light-product-bar'
  | 'sm:shadow-dark-product-bar'
  | 'md:shadow-dark-product-bar'
  | 'mg:shadow-dark-product-bar'
  | 'lg:shadow-dark-product-bar'
  | 'xl:shadow-dark-product-bar'
  | 'group-hover:shadow-dark-product-bar'
  | 'focus-within:shadow-dark-product-bar'
  | 'hover:shadow-dark-product-bar'
  | 'focus:shadow-dark-product-bar'
  | 'sm:shadow-highlight-card'
  | 'md:shadow-highlight-card'
  | 'mg:shadow-highlight-card'
  | 'lg:shadow-highlight-card'
  | 'xl:shadow-highlight-card'
  | 'group-hover:shadow-highlight-card'
  | 'focus-within:shadow-highlight-card'
  | 'hover:shadow-highlight-card'
  | 'focus:shadow-highlight-card'
  | 'sm:box-border'
  | 'md:box-border'
  | 'mg:box-border'
  | 'lg:box-border'
  | 'xl:box-border'
  | 'sm:box-content'
  | 'md:box-content'
  | 'mg:box-content'
  | 'lg:box-content'
  | 'xl:box-content'
  | 'sm:brightness-0'
  | 'md:brightness-0'
  | 'mg:brightness-0'
  | 'lg:brightness-0'
  | 'xl:brightness-0'
  | 'sm:brightness-50'
  | 'md:brightness-50'
  | 'mg:brightness-50'
  | 'lg:brightness-50'
  | 'xl:brightness-50'
  | 'sm:brightness-75'
  | 'md:brightness-75'
  | 'mg:brightness-75'
  | 'lg:brightness-75'
  | 'xl:brightness-75'
  | 'sm:brightness-90'
  | 'md:brightness-90'
  | 'mg:brightness-90'
  | 'lg:brightness-90'
  | 'xl:brightness-90'
  | 'sm:brightness-95'
  | 'md:brightness-95'
  | 'mg:brightness-95'
  | 'lg:brightness-95'
  | 'xl:brightness-95'
  | 'sm:brightness-100'
  | 'md:brightness-100'
  | 'mg:brightness-100'
  | 'lg:brightness-100'
  | 'xl:brightness-100'
  | 'sm:brightness-105'
  | 'md:brightness-105'
  | 'mg:brightness-105'
  | 'lg:brightness-105'
  | 'xl:brightness-105'
  | 'sm:brightness-110'
  | 'md:brightness-110'
  | 'mg:brightness-110'
  | 'lg:brightness-110'
  | 'xl:brightness-110'
  | 'sm:brightness-125'
  | 'md:brightness-125'
  | 'mg:brightness-125'
  | 'lg:brightness-125'
  | 'xl:brightness-125'
  | 'sm:brightness-150'
  | 'md:brightness-150'
  | 'mg:brightness-150'
  | 'lg:brightness-150'
  | 'xl:brightness-150'
  | 'sm:brightness-200'
  | 'md:brightness-200'
  | 'mg:brightness-200'
  | 'lg:brightness-200'
  | 'xl:brightness-200'
  | 'sm:clear-left'
  | 'md:clear-left'
  | 'mg:clear-left'
  | 'lg:clear-left'
  | 'xl:clear-left'
  | 'sm:clear-right'
  | 'md:clear-right'
  | 'mg:clear-right'
  | 'lg:clear-right'
  | 'xl:clear-right'
  | 'sm:clear-both'
  | 'md:clear-both'
  | 'mg:clear-both'
  | 'lg:clear-both'
  | 'xl:clear-both'
  | 'sm:clear-none'
  | 'md:clear-none'
  | 'mg:clear-none'
  | 'lg:clear-none'
  | 'xl:clear-none'
  | 'sm:container'
  | 'md:container'
  | 'mg:container'
  | 'lg:container'
  | 'xl:container'
  | 'sm:contrast-0'
  | 'md:contrast-0'
  | 'mg:contrast-0'
  | 'lg:contrast-0'
  | 'xl:contrast-0'
  | 'sm:contrast-50'
  | 'md:contrast-50'
  | 'mg:contrast-50'
  | 'lg:contrast-50'
  | 'xl:contrast-50'
  | 'sm:contrast-75'
  | 'md:contrast-75'
  | 'mg:contrast-75'
  | 'lg:contrast-75'
  | 'xl:contrast-75'
  | 'sm:contrast-100'
  | 'md:contrast-100'
  | 'mg:contrast-100'
  | 'lg:contrast-100'
  | 'xl:contrast-100'
  | 'sm:contrast-125'
  | 'md:contrast-125'
  | 'mg:contrast-125'
  | 'lg:contrast-125'
  | 'xl:contrast-125'
  | 'sm:contrast-150'
  | 'md:contrast-150'
  | 'mg:contrast-150'
  | 'lg:contrast-150'
  | 'xl:contrast-150'
  | 'sm:contrast-200'
  | 'md:contrast-200'
  | 'mg:contrast-200'
  | 'lg:contrast-200'
  | 'xl:contrast-200'
  | 'sm:cursor-auto'
  | 'md:cursor-auto'
  | 'mg:cursor-auto'
  | 'lg:cursor-auto'
  | 'xl:cursor-auto'
  | 'sm:cursor-default'
  | 'md:cursor-default'
  | 'mg:cursor-default'
  | 'lg:cursor-default'
  | 'xl:cursor-default'
  | 'sm:cursor-pointer'
  | 'md:cursor-pointer'
  | 'mg:cursor-pointer'
  | 'lg:cursor-pointer'
  | 'xl:cursor-pointer'
  | 'sm:cursor-wait'
  | 'md:cursor-wait'
  | 'mg:cursor-wait'
  | 'lg:cursor-wait'
  | 'xl:cursor-wait'
  | 'sm:cursor-text'
  | 'md:cursor-text'
  | 'mg:cursor-text'
  | 'lg:cursor-text'
  | 'xl:cursor-text'
  | 'sm:cursor-move'
  | 'md:cursor-move'
  | 'mg:cursor-move'
  | 'lg:cursor-move'
  | 'xl:cursor-move'
  | 'sm:cursor-help'
  | 'md:cursor-help'
  | 'mg:cursor-help'
  | 'lg:cursor-help'
  | 'xl:cursor-help'
  | 'sm:cursor-not-allowed'
  | 'md:cursor-not-allowed'
  | 'mg:cursor-not-allowed'
  | 'lg:cursor-not-allowed'
  | 'xl:cursor-not-allowed'
  | 'sm:block'
  | 'md:block'
  | 'mg:block'
  | 'lg:block'
  | 'xl:block'
  | 'sm:inline-block'
  | 'md:inline-block'
  | 'mg:inline-block'
  | 'lg:inline-block'
  | 'xl:inline-block'
  | 'sm:inline'
  | 'md:inline'
  | 'mg:inline'
  | 'lg:inline'
  | 'xl:inline'
  | 'sm:flex'
  | 'md:flex'
  | 'mg:flex'
  | 'lg:flex'
  | 'xl:flex'
  | 'sm:inline-flex'
  | 'md:inline-flex'
  | 'mg:inline-flex'
  | 'lg:inline-flex'
  | 'xl:inline-flex'
  | 'sm:grid'
  | 'md:grid'
  | 'mg:grid'
  | 'lg:grid'
  | 'xl:grid'
  | 'sm:inline-grid'
  | 'md:inline-grid'
  | 'mg:inline-grid'
  | 'lg:inline-grid'
  | 'xl:inline-grid'
  | 'sm:table'
  | 'md:table'
  | 'mg:table'
  | 'lg:table'
  | 'xl:table'
  | 'sm:inline-table'
  | 'md:inline-table'
  | 'mg:inline-table'
  | 'lg:inline-table'
  | 'xl:inline-table'
  | 'sm:table-row'
  | 'md:table-row'
  | 'mg:table-row'
  | 'lg:table-row'
  | 'xl:table-row'
  | 'sm:table-cell'
  | 'md:table-cell'
  | 'mg:table-cell'
  | 'lg:table-cell'
  | 'xl:table-cell'
  | 'sm:contents'
  | 'md:contents'
  | 'mg:contents'
  | 'lg:contents'
  | 'xl:contents'
  | 'sm:list-item'
  | 'md:list-item'
  | 'mg:list-item'
  | 'lg:list-item'
  | 'xl:list-item'
  | 'sm:hidden'
  | 'md:hidden'
  | 'mg:hidden'
  | 'lg:hidden'
  | 'xl:hidden'
  | 'sm:divide-transparent'
  | 'md:divide-transparent'
  | 'mg:divide-transparent'
  | 'lg:divide-transparent'
  | 'xl:divide-transparent'
  | 'sm:divide-current'
  | 'md:divide-current'
  | 'mg:divide-current'
  | 'lg:divide-current'
  | 'xl:divide-current'
  | 'sm:divide-overlay'
  | 'md:divide-overlay'
  | 'mg:divide-overlay'
  | 'lg:divide-overlay'
  | 'xl:divide-overlay'
  | 'sm:divide-black'
  | 'md:divide-black'
  | 'mg:divide-black'
  | 'lg:divide-black'
  | 'xl:divide-black'
  | 'sm:divide-white'
  | 'md:divide-white'
  | 'mg:divide-white'
  | 'lg:divide-white'
  | 'xl:divide-white'
  | 'sm:divide-white-hover'
  | 'md:divide-white-hover'
  | 'mg:divide-white-hover'
  | 'lg:divide-white-hover'
  | 'xl:divide-white-hover'
  | 'sm:divide-white-pressed'
  | 'md:divide-white-pressed'
  | 'mg:divide-white-pressed'
  | 'lg:divide-white-pressed'
  | 'xl:divide-white-pressed'
  | 'sm:divide-product-acid'
  | 'md:divide-product-acid'
  | 'mg:divide-product-acid'
  | 'lg:divide-product-acid'
  | 'xl:divide-product-acid'
  | 'sm:divide-product-aura'
  | 'md:divide-product-aura'
  | 'mg:divide-product-aura'
  | 'lg:divide-product-aura'
  | 'xl:divide-product-aura'
  | 'sm:divide-product-azul'
  | 'md:divide-product-azul'
  | 'mg:divide-product-azul'
  | 'lg:divide-product-azul'
  | 'xl:divide-product-azul'
  | 'sm:divide-product-blanch'
  | 'md:divide-product-blanch'
  | 'mg:divide-product-blanch'
  | 'lg:divide-product-blanch'
  | 'xl:divide-product-blanch'
  | 'sm:divide-product-blue-salt'
  | 'md:divide-product-blue-salt'
  | 'mg:divide-product-blue-salt'
  | 'lg:divide-product-blue-salt'
  | 'xl:divide-product-blue-salt'
  | 'sm:divide-product-burgundy'
  | 'md:divide-product-burgundy'
  | 'mg:divide-product-burgundy'
  | 'lg:divide-product-burgundy'
  | 'xl:divide-product-burgundy'
  | 'sm:divide-product-butter-yellow'
  | 'md:divide-product-butter-yellow'
  | 'mg:divide-product-butter-yellow'
  | 'lg:divide-product-butter-yellow'
  | 'xl:divide-product-butter-yellow'
  | 'sm:divide-product-chai'
  | 'md:divide-product-chai'
  | 'mg:divide-product-chai'
  | 'lg:divide-product-chai'
  | 'xl:divide-product-chai'
  | 'sm:divide-product-char'
  | 'md:divide-product-char'
  | 'mg:divide-product-char'
  | 'lg:divide-product-char'
  | 'xl:divide-product-char'
  | 'sm:divide-product-charm'
  | 'md:divide-product-charm'
  | 'mg:divide-product-charm'
  | 'lg:divide-product-charm'
  | 'xl:divide-product-charm'
  | 'sm:divide-product-chickpea'
  | 'md:divide-product-chickpea'
  | 'mg:divide-product-chickpea'
  | 'lg:divide-product-chickpea'
  | 'xl:divide-product-chickpea'
  | 'sm:divide-product-cielo'
  | 'md:divide-product-cielo'
  | 'mg:divide-product-cielo'
  | 'lg:divide-product-cielo'
  | 'xl:divide-product-cielo'
  | 'sm:divide-product-clay'
  | 'md:divide-product-clay'
  | 'mg:divide-product-clay'
  | 'lg:divide-product-clay'
  | 'xl:divide-product-clay'
  | 'sm:divide-product-clear'
  | 'md:divide-product-clear'
  | 'mg:divide-product-clear'
  | 'lg:divide-product-clear'
  | 'xl:divide-product-clear'
  | 'sm:divide-product-coriander'
  | 'md:divide-product-coriander'
  | 'mg:divide-product-coriander'
  | 'lg:divide-product-coriander'
  | 'xl:divide-product-coriander'
  | 'sm:divide-product-cream'
  | 'md:divide-product-cream'
  | 'mg:divide-product-cream'
  | 'lg:divide-product-cream'
  | 'xl:divide-product-cream'
  | 'sm:divide-product-crescent'
  | 'md:divide-product-crescent'
  | 'mg:divide-product-crescent'
  | 'lg:divide-product-crescent'
  | 'xl:divide-product-crescent'
  | 'sm:divide-product-dawn'
  | 'md:divide-product-dawn'
  | 'mg:divide-product-dawn'
  | 'lg:divide-product-dawn'
  | 'xl:divide-product-dawn'
  | 'sm:divide-product-dusk'
  | 'md:divide-product-dusk'
  | 'mg:divide-product-dusk'
  | 'lg:divide-product-dusk'
  | 'xl:divide-product-dusk'
  | 'sm:divide-product-egg-yolk'
  | 'md:divide-product-egg-yolk'
  | 'mg:divide-product-egg-yolk'
  | 'lg:divide-product-egg-yolk'
  | 'xl:divide-product-egg-yolk'
  | 'sm:divide-product-espresso'
  | 'md:divide-product-espresso'
  | 'mg:divide-product-espresso'
  | 'lg:divide-product-espresso'
  | 'xl:divide-product-espresso'
  | 'sm:divide-product-eve'
  | 'md:divide-product-eve'
  | 'mg:divide-product-eve'
  | 'lg:divide-product-eve'
  | 'xl:divide-product-eve'
  | 'sm:divide-product-firecracker'
  | 'md:divide-product-firecracker'
  | 'mg:divide-product-firecracker'
  | 'lg:divide-product-firecracker'
  | 'xl:divide-product-firecracker'
  | 'sm:divide-product-forget-me-not-blue'
  | 'md:divide-product-forget-me-not-blue'
  | 'mg:divide-product-forget-me-not-blue'
  | 'lg:divide-product-forget-me-not-blue'
  | 'xl:divide-product-forget-me-not-blue'
  | 'sm:divide-product-gold'
  | 'md:divide-product-gold'
  | 'mg:divide-product-gold'
  | 'lg:divide-product-gold'
  | 'xl:divide-product-gold'
  | 'sm:divide-product-golden'
  | 'md:divide-product-golden'
  | 'mg:divide-product-golden'
  | 'lg:divide-product-golden'
  | 'xl:divide-product-golden'
  | 'sm:divide-product-heat'
  | 'md:divide-product-heat'
  | 'mg:divide-product-heat'
  | 'lg:divide-product-heat'
  | 'xl:divide-product-heat'
  | 'sm:divide-product-himalayan-salt'
  | 'md:divide-product-himalayan-salt'
  | 'mg:divide-product-himalayan-salt'
  | 'lg:divide-product-himalayan-salt'
  | 'xl:divide-product-himalayan-salt'
  | 'sm:divide-product-indigo'
  | 'md:divide-product-indigo'
  | 'mg:divide-product-indigo'
  | 'lg:divide-product-indigo'
  | 'xl:divide-product-indigo'
  | 'sm:divide-product-lavender'
  | 'md:divide-product-lavender'
  | 'mg:divide-product-lavender'
  | 'lg:divide-product-lavender'
  | 'xl:divide-product-lavender'
  | 'sm:divide-product-lavender-marble'
  | 'md:divide-product-lavender-marble'
  | 'mg:divide-product-lavender-marble'
  | 'lg:divide-product-lavender-marble'
  | 'xl:divide-product-lavender-marble'
  | 'sm:divide-product-midnight-marble'
  | 'md:divide-product-midnight-marble'
  | 'mg:divide-product-midnight-marble'
  | 'lg:divide-product-midnight-marble'
  | 'xl:divide-product-midnight-marble'
  | 'sm:divide-product-nougat'
  | 'md:divide-product-nougat'
  | 'mg:divide-product-nougat'
  | 'lg:divide-product-nougat'
  | 'xl:divide-product-nougat'
  | 'sm:divide-product-pistachio'
  | 'md:divide-product-pistachio'
  | 'mg:divide-product-pistachio'
  | 'lg:divide-product-pistachio'
  | 'xl:divide-product-pistachio'
  | 'sm:divide-product-rosa'
  | 'md:divide-product-rosa'
  | 'mg:divide-product-rosa'
  | 'lg:divide-product-rosa'
  | 'xl:divide-product-rosa'
  | 'sm:divide-product-rose-gold'
  | 'md:divide-product-rose-gold'
  | 'mg:divide-product-rose-gold'
  | 'lg:divide-product-rose-gold'
  | 'xl:divide-product-rose-gold'
  | 'sm:divide-product-rust'
  | 'md:divide-product-rust'
  | 'mg:divide-product-rust'
  | 'lg:divide-product-rust'
  | 'xl:divide-product-rust'
  | 'sm:divide-product-saffron'
  | 'md:divide-product-saffron'
  | 'mg:divide-product-saffron'
  | 'lg:divide-product-saffron'
  | 'xl:divide-product-saffron'
  | 'sm:divide-product-sage'
  | 'md:divide-product-sage'
  | 'mg:divide-product-sage'
  | 'lg:divide-product-sage'
  | 'xl:divide-product-sage'
  | 'sm:divide-product-sear'
  | 'md:divide-product-sear'
  | 'mg:divide-product-sear'
  | 'lg:divide-product-sear'
  | 'xl:divide-product-sear'
  | 'sm:divide-product-spice'
  | 'md:divide-product-spice'
  | 'mg:divide-product-spice'
  | 'lg:divide-product-spice'
  | 'xl:divide-product-spice'
  | 'sm:divide-product-steam'
  | 'md:divide-product-steam'
  | 'mg:divide-product-steam'
  | 'lg:divide-product-steam'
  | 'xl:divide-product-steam'
  | 'sm:divide-product-strawberry'
  | 'md:divide-product-strawberry'
  | 'mg:divide-product-strawberry'
  | 'lg:divide-product-strawberry'
  | 'xl:divide-product-strawberry'
  | 'sm:divide-product-sunrise'
  | 'md:divide-product-sunrise'
  | 'mg:divide-product-sunrise'
  | 'lg:divide-product-sunrise'
  | 'xl:divide-product-sunrise'
  | 'sm:divide-product-sunset'
  | 'md:divide-product-sunset'
  | 'mg:divide-product-sunset'
  | 'lg:divide-product-sunset'
  | 'xl:divide-product-sunset'
  | 'sm:divide-product-sunset-marble'
  | 'md:divide-product-sunset-marble'
  | 'mg:divide-product-sunset-marble'
  | 'lg:divide-product-sunset-marble'
  | 'xl:divide-product-sunset-marble'
  | 'sm:divide-product-terracotta'
  | 'md:divide-product-terracotta'
  | 'mg:divide-product-terracotta'
  | 'lg:divide-product-terracotta'
  | 'xl:divide-product-terracotta'
  | 'sm:divide-product-tierra'
  | 'md:divide-product-tierra'
  | 'mg:divide-product-tierra'
  | 'lg:divide-product-tierra'
  | 'xl:divide-product-tierra'
  | 'sm:divide-product-turmeric'
  | 'md:divide-product-turmeric'
  | 'mg:divide-product-turmeric'
  | 'lg:divide-product-turmeric'
  | 'xl:divide-product-turmeric'
  | 'sm:divide-product-turqoise'
  | 'md:divide-product-turqoise'
  | 'mg:divide-product-turqoise'
  | 'lg:divide-product-turqoise'
  | 'xl:divide-product-turqoise'
  | 'sm:divide-product-twilight'
  | 'md:divide-product-twilight'
  | 'mg:divide-product-twilight'
  | 'lg:divide-product-twilight'
  | 'xl:divide-product-twilight'
  | 'sm:divide-product-walnut'
  | 'md:divide-product-walnut'
  | 'mg:divide-product-walnut'
  | 'lg:divide-product-walnut'
  | 'xl:divide-product-walnut'
  | 'sm:divide-product-warm-white'
  | 'md:divide-product-warm-white'
  | 'mg:divide-product-warm-white'
  | 'lg:divide-product-warm-white'
  | 'xl:divide-product-warm-white'
  | 'sm:divide-product-zest'
  | 'md:divide-product-zest'
  | 'mg:divide-product-zest'
  | 'lg:divide-product-zest'
  | 'xl:divide-product-zest'
  | 'sm:divide-placeholder'
  | 'md:divide-placeholder'
  | 'mg:divide-placeholder'
  | 'lg:divide-placeholder'
  | 'xl:divide-placeholder'
  | 'sm:divide-interactive-bone'
  | 'md:divide-interactive-bone'
  | 'mg:divide-interactive-bone'
  | 'lg:divide-interactive-bone'
  | 'xl:divide-interactive-bone'
  | 'sm:divide-interactive-brick'
  | 'md:divide-interactive-brick'
  | 'mg:divide-interactive-brick'
  | 'lg:divide-interactive-brick'
  | 'xl:divide-interactive-brick'
  | 'sm:divide-interactive-char'
  | 'md:divide-interactive-char'
  | 'mg:divide-interactive-char'
  | 'lg:divide-interactive-char'
  | 'xl:divide-interactive-char'
  | 'sm:divide-interactive-white'
  | 'md:divide-interactive-white'
  | 'mg:divide-interactive-white'
  | 'lg:divide-interactive-white'
  | 'xl:divide-interactive-white'
  | 'sm:divide-interactive-disabled'
  | 'md:divide-interactive-disabled'
  | 'mg:divide-interactive-disabled'
  | 'lg:divide-interactive-disabled'
  | 'xl:divide-interactive-disabled'
  | 'sm:divide-interactive-error'
  | 'md:divide-interactive-error'
  | 'mg:divide-interactive-error'
  | 'lg:divide-interactive-error'
  | 'xl:divide-interactive-error'
  | 'sm:divide-interactive-outline'
  | 'md:divide-interactive-outline'
  | 'mg:divide-interactive-outline'
  | 'lg:divide-interactive-outline'
  | 'xl:divide-interactive-outline'
  | 'sm:divide-translucent-char'
  | 'md:divide-translucent-char'
  | 'mg:divide-translucent-char'
  | 'lg:divide-translucent-char'
  | 'xl:divide-translucent-char'
  | 'sm:divide-translucent-white'
  | 'md:divide-translucent-white'
  | 'mg:divide-translucent-white'
  | 'lg:divide-translucent-white'
  | 'xl:divide-translucent-white'
  | 'sm:divide-char-50'
  | 'md:divide-char-50'
  | 'mg:divide-char-50'
  | 'lg:divide-char-50'
  | 'xl:divide-char-50'
  | 'sm:divide-char-100'
  | 'md:divide-char-100'
  | 'mg:divide-char-100'
  | 'lg:divide-char-100'
  | 'xl:divide-char-100'
  | 'sm:divide-char-200'
  | 'md:divide-char-200'
  | 'mg:divide-char-200'
  | 'lg:divide-char-200'
  | 'xl:divide-char-200'
  | 'sm:divide-char-300'
  | 'md:divide-char-300'
  | 'mg:divide-char-300'
  | 'lg:divide-char-300'
  | 'xl:divide-char-300'
  | 'sm:divide-char-400'
  | 'md:divide-char-400'
  | 'mg:divide-char-400'
  | 'lg:divide-char-400'
  | 'xl:divide-char-400'
  | 'sm:divide-char-500'
  | 'md:divide-char-500'
  | 'mg:divide-char-500'
  | 'lg:divide-char-500'
  | 'xl:divide-char-500'
  | 'sm:divide-char-600'
  | 'md:divide-char-600'
  | 'mg:divide-char-600'
  | 'lg:divide-char-600'
  | 'xl:divide-char-600'
  | 'sm:divide-char-700'
  | 'md:divide-char-700'
  | 'mg:divide-char-700'
  | 'lg:divide-char-700'
  | 'xl:divide-char-700'
  | 'sm:divide-char-800'
  | 'md:divide-char-800'
  | 'mg:divide-char-800'
  | 'lg:divide-char-800'
  | 'xl:divide-char-800'
  | 'sm:divide-char-900'
  | 'md:divide-char-900'
  | 'mg:divide-char-900'
  | 'lg:divide-char-900'
  | 'xl:divide-char-900'
  | 'sm:divide-bone-50'
  | 'md:divide-bone-50'
  | 'mg:divide-bone-50'
  | 'lg:divide-bone-50'
  | 'xl:divide-bone-50'
  | 'sm:divide-bone-100'
  | 'md:divide-bone-100'
  | 'mg:divide-bone-100'
  | 'lg:divide-bone-100'
  | 'xl:divide-bone-100'
  | 'sm:divide-bone-200'
  | 'md:divide-bone-200'
  | 'mg:divide-bone-200'
  | 'lg:divide-bone-200'
  | 'xl:divide-bone-200'
  | 'sm:divide-bone-300'
  | 'md:divide-bone-300'
  | 'mg:divide-bone-300'
  | 'lg:divide-bone-300'
  | 'xl:divide-bone-300'
  | 'sm:divide-bone-400'
  | 'md:divide-bone-400'
  | 'mg:divide-bone-400'
  | 'lg:divide-bone-400'
  | 'xl:divide-bone-400'
  | 'sm:divide-bone-500'
  | 'md:divide-bone-500'
  | 'mg:divide-bone-500'
  | 'lg:divide-bone-500'
  | 'xl:divide-bone-500'
  | 'sm:divide-bone-600'
  | 'md:divide-bone-600'
  | 'mg:divide-bone-600'
  | 'lg:divide-bone-600'
  | 'xl:divide-bone-600'
  | 'sm:divide-bone-700'
  | 'md:divide-bone-700'
  | 'mg:divide-bone-700'
  | 'lg:divide-bone-700'
  | 'xl:divide-bone-700'
  | 'sm:divide-bone-800'
  | 'md:divide-bone-800'
  | 'mg:divide-bone-800'
  | 'lg:divide-bone-800'
  | 'xl:divide-bone-800'
  | 'sm:divide-bone-900'
  | 'md:divide-bone-900'
  | 'mg:divide-bone-900'
  | 'lg:divide-bone-900'
  | 'xl:divide-bone-900'
  | 'sm:divide-brick-50'
  | 'md:divide-brick-50'
  | 'mg:divide-brick-50'
  | 'lg:divide-brick-50'
  | 'xl:divide-brick-50'
  | 'sm:divide-brick-300'
  | 'md:divide-brick-300'
  | 'mg:divide-brick-300'
  | 'lg:divide-brick-300'
  | 'xl:divide-brick-300'
  | 'sm:divide-brick-500'
  | 'md:divide-brick-500'
  | 'mg:divide-brick-500'
  | 'lg:divide-brick-500'
  | 'xl:divide-brick-500'
  | 'sm:divide-brick-700'
  | 'md:divide-brick-700'
  | 'mg:divide-brick-700'
  | 'lg:divide-brick-700'
  | 'xl:divide-brick-700'
  | 'sm:divide-brick-900'
  | 'md:divide-brick-900'
  | 'mg:divide-brick-900'
  | 'lg:divide-brick-900'
  | 'xl:divide-brick-900'
  | 'sm:divide-sage-50'
  | 'md:divide-sage-50'
  | 'mg:divide-sage-50'
  | 'lg:divide-sage-50'
  | 'xl:divide-sage-50'
  | 'sm:divide-sage-300'
  | 'md:divide-sage-300'
  | 'mg:divide-sage-300'
  | 'lg:divide-sage-300'
  | 'xl:divide-sage-300'
  | 'sm:divide-sage-500'
  | 'md:divide-sage-500'
  | 'mg:divide-sage-500'
  | 'lg:divide-sage-500'
  | 'xl:divide-sage-500'
  | 'sm:divide-sage-700'
  | 'md:divide-sage-700'
  | 'mg:divide-sage-700'
  | 'lg:divide-sage-700'
  | 'xl:divide-sage-700'
  | 'sm:divide-sage-900'
  | 'md:divide-sage-900'
  | 'mg:divide-sage-900'
  | 'lg:divide-sage-900'
  | 'xl:divide-sage-900'
  | 'sm:divide-blue-50'
  | 'md:divide-blue-50'
  | 'mg:divide-blue-50'
  | 'lg:divide-blue-50'
  | 'xl:divide-blue-50'
  | 'sm:divide-blue-300'
  | 'md:divide-blue-300'
  | 'mg:divide-blue-300'
  | 'lg:divide-blue-300'
  | 'xl:divide-blue-300'
  | 'sm:divide-blue-500'
  | 'md:divide-blue-500'
  | 'mg:divide-blue-500'
  | 'lg:divide-blue-500'
  | 'xl:divide-blue-500'
  | 'sm:divide-blue-700'
  | 'md:divide-blue-700'
  | 'mg:divide-blue-700'
  | 'lg:divide-blue-700'
  | 'xl:divide-blue-700'
  | 'sm:divide-blue-900'
  | 'md:divide-blue-900'
  | 'mg:divide-blue-900'
  | 'lg:divide-blue-900'
  | 'xl:divide-blue-900'
  | 'sm:divide-misc-bright-blue'
  | 'md:divide-misc-bright-blue'
  | 'mg:divide-misc-bright-blue'
  | 'lg:divide-misc-bright-blue'
  | 'xl:divide-misc-bright-blue'
  | 'sm:divide-misc-focus'
  | 'md:divide-misc-focus'
  | 'mg:divide-misc-focus'
  | 'lg:divide-misc-focus'
  | 'xl:divide-misc-focus'
  | 'sm:divide-misc-legal-blue'
  | 'md:divide-misc-legal-blue'
  | 'mg:divide-misc-legal-blue'
  | 'lg:divide-misc-legal-blue'
  | 'xl:divide-misc-legal-blue'
  | 'sm:divide-misc-neutral'
  | 'md:divide-misc-neutral'
  | 'mg:divide-misc-neutral'
  | 'lg:divide-misc-neutral'
  | 'xl:divide-misc-neutral'
  | 'sm:divide-misc-yellow-orange'
  | 'md:divide-misc-yellow-orange'
  | 'mg:divide-misc-yellow-orange'
  | 'lg:divide-misc-yellow-orange'
  | 'xl:divide-misc-yellow-orange'
  | 'sm:divide-opacity-0'
  | 'md:divide-opacity-0'
  | 'mg:divide-opacity-0'
  | 'lg:divide-opacity-0'
  | 'xl:divide-opacity-0'
  | 'sm:divide-opacity-5'
  | 'md:divide-opacity-5'
  | 'mg:divide-opacity-5'
  | 'lg:divide-opacity-5'
  | 'xl:divide-opacity-5'
  | 'sm:divide-opacity-10'
  | 'md:divide-opacity-10'
  | 'mg:divide-opacity-10'
  | 'lg:divide-opacity-10'
  | 'xl:divide-opacity-10'
  | 'sm:divide-opacity-20'
  | 'md:divide-opacity-20'
  | 'mg:divide-opacity-20'
  | 'lg:divide-opacity-20'
  | 'xl:divide-opacity-20'
  | 'sm:divide-opacity-25'
  | 'md:divide-opacity-25'
  | 'mg:divide-opacity-25'
  | 'lg:divide-opacity-25'
  | 'xl:divide-opacity-25'
  | 'sm:divide-opacity-30'
  | 'md:divide-opacity-30'
  | 'mg:divide-opacity-30'
  | 'lg:divide-opacity-30'
  | 'xl:divide-opacity-30'
  | 'sm:divide-opacity-40'
  | 'md:divide-opacity-40'
  | 'mg:divide-opacity-40'
  | 'lg:divide-opacity-40'
  | 'xl:divide-opacity-40'
  | 'sm:divide-opacity-50'
  | 'md:divide-opacity-50'
  | 'mg:divide-opacity-50'
  | 'lg:divide-opacity-50'
  | 'xl:divide-opacity-50'
  | 'sm:divide-opacity-60'
  | 'md:divide-opacity-60'
  | 'mg:divide-opacity-60'
  | 'lg:divide-opacity-60'
  | 'xl:divide-opacity-60'
  | 'sm:divide-opacity-70'
  | 'md:divide-opacity-70'
  | 'mg:divide-opacity-70'
  | 'lg:divide-opacity-70'
  | 'xl:divide-opacity-70'
  | 'sm:divide-opacity-75'
  | 'md:divide-opacity-75'
  | 'mg:divide-opacity-75'
  | 'lg:divide-opacity-75'
  | 'xl:divide-opacity-75'
  | 'sm:divide-opacity-80'
  | 'md:divide-opacity-80'
  | 'mg:divide-opacity-80'
  | 'lg:divide-opacity-80'
  | 'xl:divide-opacity-80'
  | 'sm:divide-opacity-90'
  | 'md:divide-opacity-90'
  | 'mg:divide-opacity-90'
  | 'lg:divide-opacity-90'
  | 'xl:divide-opacity-90'
  | 'sm:divide-opacity-95'
  | 'md:divide-opacity-95'
  | 'mg:divide-opacity-95'
  | 'lg:divide-opacity-95'
  | 'xl:divide-opacity-95'
  | 'sm:divide-opacity-100'
  | 'md:divide-opacity-100'
  | 'mg:divide-opacity-100'
  | 'lg:divide-opacity-100'
  | 'xl:divide-opacity-100'
  | 'sm:divide-solid'
  | 'md:divide-solid'
  | 'mg:divide-solid'
  | 'lg:divide-solid'
  | 'xl:divide-solid'
  | 'sm:divide-dashed'
  | 'md:divide-dashed'
  | 'mg:divide-dashed'
  | 'lg:divide-dashed'
  | 'xl:divide-dashed'
  | 'sm:divide-dotted'
  | 'md:divide-dotted'
  | 'mg:divide-dotted'
  | 'lg:divide-dotted'
  | 'xl:divide-dotted'
  | 'sm:divide-double'
  | 'md:divide-double'
  | 'mg:divide-double'
  | 'lg:divide-double'
  | 'xl:divide-double'
  | 'sm:divide-none'
  | 'md:divide-none'
  | 'mg:divide-none'
  | 'lg:divide-none'
  | 'xl:divide-none'
  | 'sm:divide-x-0'
  | 'md:divide-x-0'
  | 'mg:divide-x-0'
  | 'lg:divide-x-0'
  | 'xl:divide-x-0'
  | 'sm:divide-y-0'
  | 'md:divide-y-0'
  | 'mg:divide-y-0'
  | 'lg:divide-y-0'
  | 'xl:divide-y-0'
  | 'sm:divide-x-2'
  | 'md:divide-x-2'
  | 'mg:divide-x-2'
  | 'lg:divide-x-2'
  | 'xl:divide-x-2'
  | 'sm:divide-y-2'
  | 'md:divide-y-2'
  | 'mg:divide-y-2'
  | 'lg:divide-y-2'
  | 'xl:divide-y-2'
  | 'sm:divide-x-3'
  | 'md:divide-x-3'
  | 'mg:divide-x-3'
  | 'lg:divide-x-3'
  | 'xl:divide-x-3'
  | 'sm:divide-y-3'
  | 'md:divide-y-3'
  | 'mg:divide-y-3'
  | 'lg:divide-y-3'
  | 'xl:divide-y-3'
  | 'sm:divide-x-4'
  | 'md:divide-x-4'
  | 'mg:divide-x-4'
  | 'lg:divide-x-4'
  | 'xl:divide-x-4'
  | 'sm:divide-y-4'
  | 'md:divide-y-4'
  | 'mg:divide-y-4'
  | 'lg:divide-y-4'
  | 'xl:divide-y-4'
  | 'sm:divide-x-6'
  | 'md:divide-x-6'
  | 'mg:divide-x-6'
  | 'lg:divide-x-6'
  | 'xl:divide-x-6'
  | 'sm:divide-y-6'
  | 'md:divide-y-6'
  | 'mg:divide-y-6'
  | 'lg:divide-y-6'
  | 'xl:divide-y-6'
  | 'sm:divide-x-8'
  | 'md:divide-x-8'
  | 'mg:divide-x-8'
  | 'lg:divide-x-8'
  | 'xl:divide-x-8'
  | 'sm:divide-y-8'
  | 'md:divide-y-8'
  | 'mg:divide-y-8'
  | 'lg:divide-y-8'
  | 'xl:divide-y-8'
  | 'sm:divide-x'
  | 'md:divide-x'
  | 'mg:divide-x'
  | 'lg:divide-x'
  | 'xl:divide-x'
  | 'sm:divide-y'
  | 'md:divide-y'
  | 'mg:divide-y'
  | 'lg:divide-y'
  | 'xl:divide-y'
  | 'sm:divide-x-reverse'
  | 'md:divide-x-reverse'
  | 'mg:divide-x-reverse'
  | 'lg:divide-x-reverse'
  | 'xl:divide-x-reverse'
  | 'sm:divide-y-reverse'
  | 'md:divide-y-reverse'
  | 'mg:divide-y-reverse'
  | 'lg:divide-y-reverse'
  | 'xl:divide-y-reverse'
  | 'sm:drop-shadow-sm'
  | 'md:drop-shadow-sm'
  | 'mg:drop-shadow-sm'
  | 'lg:drop-shadow-sm'
  | 'xl:drop-shadow-sm'
  | 'sm:drop-shadow'
  | 'md:drop-shadow'
  | 'mg:drop-shadow'
  | 'lg:drop-shadow'
  | 'xl:drop-shadow'
  | 'sm:drop-shadow-md'
  | 'md:drop-shadow-md'
  | 'mg:drop-shadow-md'
  | 'lg:drop-shadow-md'
  | 'xl:drop-shadow-md'
  | 'sm:drop-shadow-lg'
  | 'md:drop-shadow-lg'
  | 'mg:drop-shadow-lg'
  | 'lg:drop-shadow-lg'
  | 'xl:drop-shadow-lg'
  | 'sm:drop-shadow-xl'
  | 'md:drop-shadow-xl'
  | 'mg:drop-shadow-xl'
  | 'lg:drop-shadow-xl'
  | 'xl:drop-shadow-xl'
  | 'sm:drop-shadow-2xl'
  | 'md:drop-shadow-2xl'
  | 'mg:drop-shadow-2xl'
  | 'lg:drop-shadow-2xl'
  | 'xl:drop-shadow-2xl'
  | 'sm:drop-shadow-none'
  | 'md:drop-shadow-none'
  | 'mg:drop-shadow-none'
  | 'lg:drop-shadow-none'
  | 'xl:drop-shadow-none'
  | 'sm:fill-current'
  | 'md:fill-current'
  | 'mg:fill-current'
  | 'lg:fill-current'
  | 'xl:fill-current'
  | 'sm:filter'
  | 'md:filter'
  | 'mg:filter'
  | 'lg:filter'
  | 'xl:filter'
  | 'sm:filter-none'
  | 'md:filter-none'
  | 'mg:filter-none'
  | 'lg:filter-none'
  | 'xl:filter-none'
  | 'sm:flex-initial'
  | 'md:flex-initial'
  | 'mg:flex-initial'
  | 'lg:flex-initial'
  | 'xl:flex-initial'
  | 'sm:flex-1'
  | 'md:flex-1'
  | 'mg:flex-1'
  | 'lg:flex-1'
  | 'xl:flex-1'
  | 'sm:flex-auto'
  | 'md:flex-auto'
  | 'mg:flex-auto'
  | 'lg:flex-auto'
  | 'xl:flex-auto'
  | 'sm:flex-none'
  | 'md:flex-none'
  | 'mg:flex-none'
  | 'lg:flex-none'
  | 'xl:flex-none'
  | 'sm:flex-row'
  | 'md:flex-row'
  | 'mg:flex-row'
  | 'lg:flex-row'
  | 'xl:flex-row'
  | 'sm:flex-row-reverse'
  | 'md:flex-row-reverse'
  | 'mg:flex-row-reverse'
  | 'lg:flex-row-reverse'
  | 'xl:flex-row-reverse'
  | 'sm:flex-col'
  | 'md:flex-col'
  | 'mg:flex-col'
  | 'lg:flex-col'
  | 'xl:flex-col'
  | 'sm:flex-col-reverse'
  | 'md:flex-col-reverse'
  | 'mg:flex-col-reverse'
  | 'lg:flex-col-reverse'
  | 'xl:flex-col-reverse'
  | 'sm:flex-grow-0'
  | 'md:flex-grow-0'
  | 'mg:flex-grow-0'
  | 'lg:flex-grow-0'
  | 'xl:flex-grow-0'
  | 'sm:flex-grow'
  | 'md:flex-grow'
  | 'mg:flex-grow'
  | 'lg:flex-grow'
  | 'xl:flex-grow'
  | 'sm:flex-shrink-0'
  | 'md:flex-shrink-0'
  | 'mg:flex-shrink-0'
  | 'lg:flex-shrink-0'
  | 'xl:flex-shrink-0'
  | 'sm:flex-shrink'
  | 'md:flex-shrink'
  | 'mg:flex-shrink'
  | 'lg:flex-shrink'
  | 'xl:flex-shrink'
  | 'sm:flex-shrink-1/2'
  | 'md:flex-shrink-1/2'
  | 'mg:flex-shrink-1/2'
  | 'lg:flex-shrink-1/2'
  | 'xl:flex-shrink-1/2'
  | 'sm:flex-nowrap'
  | 'md:flex-nowrap'
  | 'mg:flex-nowrap'
  | 'lg:flex-nowrap'
  | 'xl:flex-nowrap'
  | 'sm:flex-wrap'
  | 'md:flex-wrap'
  | 'mg:flex-wrap'
  | 'lg:flex-wrap'
  | 'xl:flex-wrap'
  | 'sm:flex-wrap-reverse'
  | 'md:flex-wrap-reverse'
  | 'mg:flex-wrap-reverse'
  | 'lg:flex-wrap-reverse'
  | 'xl:flex-wrap-reverse'
  | 'sm:float-right'
  | 'md:float-right'
  | 'mg:float-right'
  | 'lg:float-right'
  | 'xl:float-right'
  | 'sm:float-left'
  | 'md:float-left'
  | 'mg:float-left'
  | 'lg:float-left'
  | 'xl:float-left'
  | 'sm:float-none'
  | 'md:float-none'
  | 'mg:float-none'
  | 'lg:float-none'
  | 'xl:float-none'
  | 'sm:font-calibre'
  | 'md:font-calibre'
  | 'mg:font-calibre'
  | 'lg:font-calibre'
  | 'xl:font-calibre'
  | 'sm:font-chelt'
  | 'md:font-chelt'
  | 'mg:font-chelt'
  | 'lg:font-chelt'
  | 'xl:font-chelt'
  | 'sm:text-3xs'
  | 'md:text-3xs'
  | 'mg:text-3xs'
  | 'lg:text-3xs'
  | 'xl:text-3xs'
  | 'sm:text-2xs'
  | 'md:text-2xs'
  | 'mg:text-2xs'
  | 'lg:text-2xs'
  | 'xl:text-2xs'
  | 'sm:text-xs'
  | 'md:text-xs'
  | 'mg:text-xs'
  | 'lg:text-xs'
  | 'xl:text-xs'
  | 'sm:text-sm'
  | 'md:text-sm'
  | 'mg:text-sm'
  | 'lg:text-sm'
  | 'xl:text-sm'
  | 'sm:text-base'
  | 'md:text-base'
  | 'mg:text-base'
  | 'lg:text-base'
  | 'xl:text-base'
  | 'sm:text-lg'
  | 'md:text-lg'
  | 'mg:text-lg'
  | 'lg:text-lg'
  | 'xl:text-lg'
  | 'sm:text-xl'
  | 'md:text-xl'
  | 'mg:text-xl'
  | 'lg:text-xl'
  | 'xl:text-xl'
  | 'sm:text-2xl'
  | 'md:text-2xl'
  | 'mg:text-2xl'
  | 'lg:text-2xl'
  | 'xl:text-2xl'
  | 'sm:text-3xl'
  | 'md:text-3xl'
  | 'mg:text-3xl'
  | 'lg:text-3xl'
  | 'xl:text-3xl'
  | 'sm:text-4xl'
  | 'md:text-4xl'
  | 'mg:text-4xl'
  | 'lg:text-4xl'
  | 'xl:text-4xl'
  | 'sm:text-5xl'
  | 'md:text-5xl'
  | 'mg:text-5xl'
  | 'lg:text-5xl'
  | 'xl:text-5xl'
  | 'sm:text-6xl'
  | 'md:text-6xl'
  | 'mg:text-6xl'
  | 'lg:text-6xl'
  | 'xl:text-6xl'
  | 'sm:text-7xl'
  | 'md:text-7xl'
  | 'mg:text-7xl'
  | 'lg:text-7xl'
  | 'xl:text-7xl'
  | 'sm:text-8xl'
  | 'md:text-8xl'
  | 'mg:text-8xl'
  | 'lg:text-8xl'
  | 'xl:text-8xl'
  | 'sm:text-9xl'
  | 'md:text-9xl'
  | 'mg:text-9xl'
  | 'lg:text-9xl'
  | 'xl:text-9xl'
  | 'sm:text-10xl'
  | 'md:text-10xl'
  | 'mg:text-10xl'
  | 'lg:text-10xl'
  | 'xl:text-10xl'
  | 'sm:antialiased'
  | 'md:antialiased'
  | 'mg:antialiased'
  | 'lg:antialiased'
  | 'xl:antialiased'
  | 'sm:subpixel-antialiased'
  | 'md:subpixel-antialiased'
  | 'mg:subpixel-antialiased'
  | 'lg:subpixel-antialiased'
  | 'xl:subpixel-antialiased'
  | 'sm:italic'
  | 'md:italic'
  | 'mg:italic'
  | 'lg:italic'
  | 'xl:italic'
  | 'sm:non-italic'
  | 'md:non-italic'
  | 'mg:non-italic'
  | 'lg:non-italic'
  | 'xl:non-italic'
  | 'sm:normal-nums'
  | 'md:normal-nums'
  | 'mg:normal-nums'
  | 'lg:normal-nums'
  | 'xl:normal-nums'
  | 'sm:ordinal'
  | 'md:ordinal'
  | 'mg:ordinal'
  | 'lg:ordinal'
  | 'xl:ordinal'
  | 'sm:slashed-zero'
  | 'md:slashed-zero'
  | 'mg:slashed-zero'
  | 'lg:slashed-zero'
  | 'xl:slashed-zero'
  | 'sm:lining-nums'
  | 'md:lining-nums'
  | 'mg:lining-nums'
  | 'lg:lining-nums'
  | 'xl:lining-nums'
  | 'sm:oldstyle-nums'
  | 'md:oldstyle-nums'
  | 'mg:oldstyle-nums'
  | 'lg:oldstyle-nums'
  | 'xl:oldstyle-nums'
  | 'sm:proportional-nums'
  | 'md:proportional-nums'
  | 'mg:proportional-nums'
  | 'lg:proportional-nums'
  | 'xl:proportional-nums'
  | 'sm:tabular-nums'
  | 'md:tabular-nums'
  | 'mg:tabular-nums'
  | 'lg:tabular-nums'
  | 'xl:tabular-nums'
  | 'sm:diagonal-fractions'
  | 'md:diagonal-fractions'
  | 'mg:diagonal-fractions'
  | 'lg:diagonal-fractions'
  | 'xl:diagonal-fractions'
  | 'sm:stacked-fractions'
  | 'md:stacked-fractions'
  | 'mg:stacked-fractions'
  | 'lg:stacked-fractions'
  | 'xl:stacked-fractions'
  | 'sm:font-thin'
  | 'md:font-thin'
  | 'mg:font-thin'
  | 'lg:font-thin'
  | 'xl:font-thin'
  | 'sm:font-extralight'
  | 'md:font-extralight'
  | 'mg:font-extralight'
  | 'lg:font-extralight'
  | 'xl:font-extralight'
  | 'sm:font-light'
  | 'md:font-light'
  | 'mg:font-light'
  | 'lg:font-light'
  | 'xl:font-light'
  | 'sm:font-normal'
  | 'md:font-normal'
  | 'mg:font-normal'
  | 'lg:font-normal'
  | 'xl:font-normal'
  | 'sm:font-medium'
  | 'md:font-medium'
  | 'mg:font-medium'
  | 'lg:font-medium'
  | 'xl:font-medium'
  | 'sm:font-semibold'
  | 'md:font-semibold'
  | 'mg:font-semibold'
  | 'lg:font-semibold'
  | 'xl:font-semibold'
  | 'sm:font-bold'
  | 'md:font-bold'
  | 'mg:font-bold'
  | 'lg:font-bold'
  | 'xl:font-bold'
  | 'sm:font-extrabold'
  | 'md:font-extrabold'
  | 'mg:font-extrabold'
  | 'lg:font-extrabold'
  | 'xl:font-extrabold'
  | 'sm:font-black'
  | 'md:font-black'
  | 'mg:font-black'
  | 'lg:font-black'
  | 'xl:font-black'
  | 'sm:gap-0'
  | 'md:gap-0'
  | 'mg:gap-0'
  | 'lg:gap-0'
  | 'xl:gap-0'
  | 'sm:gap-1'
  | 'md:gap-1'
  | 'mg:gap-1'
  | 'lg:gap-1'
  | 'xl:gap-1'
  | 'sm:gap-2'
  | 'md:gap-2'
  | 'mg:gap-2'
  | 'lg:gap-2'
  | 'xl:gap-2'
  | 'sm:gap-3'
  | 'md:gap-3'
  | 'mg:gap-3'
  | 'lg:gap-3'
  | 'xl:gap-3'
  | 'sm:gap-4'
  | 'md:gap-4'
  | 'mg:gap-4'
  | 'lg:gap-4'
  | 'xl:gap-4'
  | 'sm:gap-5'
  | 'md:gap-5'
  | 'mg:gap-5'
  | 'lg:gap-5'
  | 'xl:gap-5'
  | 'sm:gap-6'
  | 'md:gap-6'
  | 'mg:gap-6'
  | 'lg:gap-6'
  | 'xl:gap-6'
  | 'sm:gap-7'
  | 'md:gap-7'
  | 'mg:gap-7'
  | 'lg:gap-7'
  | 'xl:gap-7'
  | 'sm:gap-8'
  | 'md:gap-8'
  | 'mg:gap-8'
  | 'lg:gap-8'
  | 'xl:gap-8'
  | 'sm:gap-9'
  | 'md:gap-9'
  | 'mg:gap-9'
  | 'lg:gap-9'
  | 'xl:gap-9'
  | 'sm:gap-10'
  | 'md:gap-10'
  | 'mg:gap-10'
  | 'lg:gap-10'
  | 'xl:gap-10'
  | 'sm:gap-11'
  | 'md:gap-11'
  | 'mg:gap-11'
  | 'lg:gap-11'
  | 'xl:gap-11'
  | 'sm:gap-12'
  | 'md:gap-12'
  | 'mg:gap-12'
  | 'lg:gap-12'
  | 'xl:gap-12'
  | 'sm:gap-14'
  | 'md:gap-14'
  | 'mg:gap-14'
  | 'lg:gap-14'
  | 'xl:gap-14'
  | 'sm:gap-15'
  | 'md:gap-15'
  | 'mg:gap-15'
  | 'lg:gap-15'
  | 'xl:gap-15'
  | 'sm:gap-16'
  | 'md:gap-16'
  | 'mg:gap-16'
  | 'lg:gap-16'
  | 'xl:gap-16'
  | 'sm:gap-17'
  | 'md:gap-17'
  | 'mg:gap-17'
  | 'lg:gap-17'
  | 'xl:gap-17'
  | 'sm:gap-18'
  | 'md:gap-18'
  | 'mg:gap-18'
  | 'lg:gap-18'
  | 'xl:gap-18'
  | 'sm:gap-20'
  | 'md:gap-20'
  | 'mg:gap-20'
  | 'lg:gap-20'
  | 'xl:gap-20'
  | 'sm:gap-21'
  | 'md:gap-21'
  | 'mg:gap-21'
  | 'lg:gap-21'
  | 'xl:gap-21'
  | 'sm:gap-22'
  | 'md:gap-22'
  | 'mg:gap-22'
  | 'lg:gap-22'
  | 'xl:gap-22'
  | 'sm:gap-24'
  | 'md:gap-24'
  | 'mg:gap-24'
  | 'lg:gap-24'
  | 'xl:gap-24'
  | 'sm:gap-28'
  | 'md:gap-28'
  | 'mg:gap-28'
  | 'lg:gap-28'
  | 'xl:gap-28'
  | 'sm:gap-30'
  | 'md:gap-30'
  | 'mg:gap-30'
  | 'lg:gap-30'
  | 'xl:gap-30'
  | 'sm:gap-32'
  | 'md:gap-32'
  | 'mg:gap-32'
  | 'lg:gap-32'
  | 'xl:gap-32'
  | 'sm:gap-36'
  | 'md:gap-36'
  | 'mg:gap-36'
  | 'lg:gap-36'
  | 'xl:gap-36'
  | 'sm:gap-40'
  | 'md:gap-40'
  | 'mg:gap-40'
  | 'lg:gap-40'
  | 'xl:gap-40'
  | 'sm:gap-44'
  | 'md:gap-44'
  | 'mg:gap-44'
  | 'lg:gap-44'
  | 'xl:gap-44'
  | 'sm:gap-48'
  | 'md:gap-48'
  | 'mg:gap-48'
  | 'lg:gap-48'
  | 'xl:gap-48'
  | 'sm:gap-52'
  | 'md:gap-52'
  | 'mg:gap-52'
  | 'lg:gap-52'
  | 'xl:gap-52'
  | 'sm:gap-56'
  | 'md:gap-56'
  | 'mg:gap-56'
  | 'lg:gap-56'
  | 'xl:gap-56'
  | 'sm:gap-60'
  | 'md:gap-60'
  | 'mg:gap-60'
  | 'lg:gap-60'
  | 'xl:gap-60'
  | 'sm:gap-64'
  | 'md:gap-64'
  | 'mg:gap-64'
  | 'lg:gap-64'
  | 'xl:gap-64'
  | 'sm:gap-72'
  | 'md:gap-72'
  | 'mg:gap-72'
  | 'lg:gap-72'
  | 'xl:gap-72'
  | 'sm:gap-80'
  | 'md:gap-80'
  | 'mg:gap-80'
  | 'lg:gap-80'
  | 'xl:gap-80'
  | 'sm:gap-96'
  | 'md:gap-96'
  | 'mg:gap-96'
  | 'lg:gap-96'
  | 'xl:gap-96'
  | 'sm:gap-px'
  | 'md:gap-px'
  | 'mg:gap-px'
  | 'lg:gap-px'
  | 'xl:gap-px'
  | 'sm:gap-0.5'
  | 'md:gap-0.5'
  | 'mg:gap-0.5'
  | 'lg:gap-0.5'
  | 'xl:gap-0.5'
  | 'sm:gap-1.5'
  | 'md:gap-1.5'
  | 'mg:gap-1.5'
  | 'lg:gap-1.5'
  | 'xl:gap-1.5'
  | 'sm:gap-2.5'
  | 'md:gap-2.5'
  | 'mg:gap-2.5'
  | 'lg:gap-2.5'
  | 'xl:gap-2.5'
  | 'sm:gap-3.5'
  | 'md:gap-3.5'
  | 'mg:gap-3.5'
  | 'lg:gap-3.5'
  | 'xl:gap-3.5'
  | 'sm:gap-1/2'
  | 'md:gap-1/2'
  | 'mg:gap-1/2'
  | 'lg:gap-1/2'
  | 'xl:gap-1/2'
  | 'sm:gap-full'
  | 'md:gap-full'
  | 'mg:gap-full'
  | 'lg:gap-full'
  | 'xl:gap-full'
  | 'sm:gap-4.5'
  | 'md:gap-4.5'
  | 'mg:gap-4.5'
  | 'lg:gap-4.5'
  | 'xl:gap-4.5'
  | 'sm:gap-7.5'
  | 'md:gap-7.5'
  | 'mg:gap-7.5'
  | 'lg:gap-7.5'
  | 'xl:gap-7.5'
  | 'sm:gap-9.5'
  | 'md:gap-9.5'
  | 'mg:gap-9.5'
  | 'lg:gap-9.5'
  | 'xl:gap-9.5'
  | 'sm:gap-11.5'
  | 'md:gap-11.5'
  | 'mg:gap-11.5'
  | 'lg:gap-11.5'
  | 'xl:gap-11.5'
  | 'sm:gap-y-0'
  | 'md:gap-y-0'
  | 'mg:gap-y-0'
  | 'lg:gap-y-0'
  | 'xl:gap-y-0'
  | 'sm:gap-y-1'
  | 'md:gap-y-1'
  | 'mg:gap-y-1'
  | 'lg:gap-y-1'
  | 'xl:gap-y-1'
  | 'sm:gap-y-2'
  | 'md:gap-y-2'
  | 'mg:gap-y-2'
  | 'lg:gap-y-2'
  | 'xl:gap-y-2'
  | 'sm:gap-y-3'
  | 'md:gap-y-3'
  | 'mg:gap-y-3'
  | 'lg:gap-y-3'
  | 'xl:gap-y-3'
  | 'sm:gap-y-4'
  | 'md:gap-y-4'
  | 'mg:gap-y-4'
  | 'lg:gap-y-4'
  | 'xl:gap-y-4'
  | 'sm:gap-y-5'
  | 'md:gap-y-5'
  | 'mg:gap-y-5'
  | 'lg:gap-y-5'
  | 'xl:gap-y-5'
  | 'sm:gap-y-6'
  | 'md:gap-y-6'
  | 'mg:gap-y-6'
  | 'lg:gap-y-6'
  | 'xl:gap-y-6'
  | 'sm:gap-y-7'
  | 'md:gap-y-7'
  | 'mg:gap-y-7'
  | 'lg:gap-y-7'
  | 'xl:gap-y-7'
  | 'sm:gap-y-8'
  | 'md:gap-y-8'
  | 'mg:gap-y-8'
  | 'lg:gap-y-8'
  | 'xl:gap-y-8'
  | 'sm:gap-y-9'
  | 'md:gap-y-9'
  | 'mg:gap-y-9'
  | 'lg:gap-y-9'
  | 'xl:gap-y-9'
  | 'sm:gap-y-10'
  | 'md:gap-y-10'
  | 'mg:gap-y-10'
  | 'lg:gap-y-10'
  | 'xl:gap-y-10'
  | 'sm:gap-y-11'
  | 'md:gap-y-11'
  | 'mg:gap-y-11'
  | 'lg:gap-y-11'
  | 'xl:gap-y-11'
  | 'sm:gap-y-12'
  | 'md:gap-y-12'
  | 'mg:gap-y-12'
  | 'lg:gap-y-12'
  | 'xl:gap-y-12'
  | 'sm:gap-y-14'
  | 'md:gap-y-14'
  | 'mg:gap-y-14'
  | 'lg:gap-y-14'
  | 'xl:gap-y-14'
  | 'sm:gap-y-15'
  | 'md:gap-y-15'
  | 'mg:gap-y-15'
  | 'lg:gap-y-15'
  | 'xl:gap-y-15'
  | 'sm:gap-y-16'
  | 'md:gap-y-16'
  | 'mg:gap-y-16'
  | 'lg:gap-y-16'
  | 'xl:gap-y-16'
  | 'sm:gap-y-17'
  | 'md:gap-y-17'
  | 'mg:gap-y-17'
  | 'lg:gap-y-17'
  | 'xl:gap-y-17'
  | 'sm:gap-y-18'
  | 'md:gap-y-18'
  | 'mg:gap-y-18'
  | 'lg:gap-y-18'
  | 'xl:gap-y-18'
  | 'sm:gap-y-20'
  | 'md:gap-y-20'
  | 'mg:gap-y-20'
  | 'lg:gap-y-20'
  | 'xl:gap-y-20'
  | 'sm:gap-y-21'
  | 'md:gap-y-21'
  | 'mg:gap-y-21'
  | 'lg:gap-y-21'
  | 'xl:gap-y-21'
  | 'sm:gap-y-22'
  | 'md:gap-y-22'
  | 'mg:gap-y-22'
  | 'lg:gap-y-22'
  | 'xl:gap-y-22'
  | 'sm:gap-y-24'
  | 'md:gap-y-24'
  | 'mg:gap-y-24'
  | 'lg:gap-y-24'
  | 'xl:gap-y-24'
  | 'sm:gap-y-28'
  | 'md:gap-y-28'
  | 'mg:gap-y-28'
  | 'lg:gap-y-28'
  | 'xl:gap-y-28'
  | 'sm:gap-y-30'
  | 'md:gap-y-30'
  | 'mg:gap-y-30'
  | 'lg:gap-y-30'
  | 'xl:gap-y-30'
  | 'sm:gap-y-32'
  | 'md:gap-y-32'
  | 'mg:gap-y-32'
  | 'lg:gap-y-32'
  | 'xl:gap-y-32'
  | 'sm:gap-y-36'
  | 'md:gap-y-36'
  | 'mg:gap-y-36'
  | 'lg:gap-y-36'
  | 'xl:gap-y-36'
  | 'sm:gap-y-40'
  | 'md:gap-y-40'
  | 'mg:gap-y-40'
  | 'lg:gap-y-40'
  | 'xl:gap-y-40'
  | 'sm:gap-y-44'
  | 'md:gap-y-44'
  | 'mg:gap-y-44'
  | 'lg:gap-y-44'
  | 'xl:gap-y-44'
  | 'sm:gap-y-48'
  | 'md:gap-y-48'
  | 'mg:gap-y-48'
  | 'lg:gap-y-48'
  | 'xl:gap-y-48'
  | 'sm:gap-y-52'
  | 'md:gap-y-52'
  | 'mg:gap-y-52'
  | 'lg:gap-y-52'
  | 'xl:gap-y-52'
  | 'sm:gap-y-56'
  | 'md:gap-y-56'
  | 'mg:gap-y-56'
  | 'lg:gap-y-56'
  | 'xl:gap-y-56'
  | 'sm:gap-y-60'
  | 'md:gap-y-60'
  | 'mg:gap-y-60'
  | 'lg:gap-y-60'
  | 'xl:gap-y-60'
  | 'sm:gap-y-64'
  | 'md:gap-y-64'
  | 'mg:gap-y-64'
  | 'lg:gap-y-64'
  | 'xl:gap-y-64'
  | 'sm:gap-y-72'
  | 'md:gap-y-72'
  | 'mg:gap-y-72'
  | 'lg:gap-y-72'
  | 'xl:gap-y-72'
  | 'sm:gap-y-80'
  | 'md:gap-y-80'
  | 'mg:gap-y-80'
  | 'lg:gap-y-80'
  | 'xl:gap-y-80'
  | 'sm:gap-y-96'
  | 'md:gap-y-96'
  | 'mg:gap-y-96'
  | 'lg:gap-y-96'
  | 'xl:gap-y-96'
  | 'sm:gap-y-px'
  | 'md:gap-y-px'
  | 'mg:gap-y-px'
  | 'lg:gap-y-px'
  | 'xl:gap-y-px'
  | 'sm:gap-y-0.5'
  | 'md:gap-y-0.5'
  | 'mg:gap-y-0.5'
  | 'lg:gap-y-0.5'
  | 'xl:gap-y-0.5'
  | 'sm:gap-y-1.5'
  | 'md:gap-y-1.5'
  | 'mg:gap-y-1.5'
  | 'lg:gap-y-1.5'
  | 'xl:gap-y-1.5'
  | 'sm:gap-y-2.5'
  | 'md:gap-y-2.5'
  | 'mg:gap-y-2.5'
  | 'lg:gap-y-2.5'
  | 'xl:gap-y-2.5'
  | 'sm:gap-y-3.5'
  | 'md:gap-y-3.5'
  | 'mg:gap-y-3.5'
  | 'lg:gap-y-3.5'
  | 'xl:gap-y-3.5'
  | 'sm:gap-y-1/2'
  | 'md:gap-y-1/2'
  | 'mg:gap-y-1/2'
  | 'lg:gap-y-1/2'
  | 'xl:gap-y-1/2'
  | 'sm:gap-y-full'
  | 'md:gap-y-full'
  | 'mg:gap-y-full'
  | 'lg:gap-y-full'
  | 'xl:gap-y-full'
  | 'sm:gap-y-4.5'
  | 'md:gap-y-4.5'
  | 'mg:gap-y-4.5'
  | 'lg:gap-y-4.5'
  | 'xl:gap-y-4.5'
  | 'sm:gap-y-7.5'
  | 'md:gap-y-7.5'
  | 'mg:gap-y-7.5'
  | 'lg:gap-y-7.5'
  | 'xl:gap-y-7.5'
  | 'sm:gap-y-9.5'
  | 'md:gap-y-9.5'
  | 'mg:gap-y-9.5'
  | 'lg:gap-y-9.5'
  | 'xl:gap-y-9.5'
  | 'sm:gap-y-11.5'
  | 'md:gap-y-11.5'
  | 'mg:gap-y-11.5'
  | 'lg:gap-y-11.5'
  | 'xl:gap-y-11.5'
  | 'sm:gap-x-0'
  | 'md:gap-x-0'
  | 'mg:gap-x-0'
  | 'lg:gap-x-0'
  | 'xl:gap-x-0'
  | 'sm:gap-x-1'
  | 'md:gap-x-1'
  | 'mg:gap-x-1'
  | 'lg:gap-x-1'
  | 'xl:gap-x-1'
  | 'sm:gap-x-2'
  | 'md:gap-x-2'
  | 'mg:gap-x-2'
  | 'lg:gap-x-2'
  | 'xl:gap-x-2'
  | 'sm:gap-x-3'
  | 'md:gap-x-3'
  | 'mg:gap-x-3'
  | 'lg:gap-x-3'
  | 'xl:gap-x-3'
  | 'sm:gap-x-4'
  | 'md:gap-x-4'
  | 'mg:gap-x-4'
  | 'lg:gap-x-4'
  | 'xl:gap-x-4'
  | 'sm:gap-x-5'
  | 'md:gap-x-5'
  | 'mg:gap-x-5'
  | 'lg:gap-x-5'
  | 'xl:gap-x-5'
  | 'sm:gap-x-6'
  | 'md:gap-x-6'
  | 'mg:gap-x-6'
  | 'lg:gap-x-6'
  | 'xl:gap-x-6'
  | 'sm:gap-x-7'
  | 'md:gap-x-7'
  | 'mg:gap-x-7'
  | 'lg:gap-x-7'
  | 'xl:gap-x-7'
  | 'sm:gap-x-8'
  | 'md:gap-x-8'
  | 'mg:gap-x-8'
  | 'lg:gap-x-8'
  | 'xl:gap-x-8'
  | 'sm:gap-x-9'
  | 'md:gap-x-9'
  | 'mg:gap-x-9'
  | 'lg:gap-x-9'
  | 'xl:gap-x-9'
  | 'sm:gap-x-10'
  | 'md:gap-x-10'
  | 'mg:gap-x-10'
  | 'lg:gap-x-10'
  | 'xl:gap-x-10'
  | 'sm:gap-x-11'
  | 'md:gap-x-11'
  | 'mg:gap-x-11'
  | 'lg:gap-x-11'
  | 'xl:gap-x-11'
  | 'sm:gap-x-12'
  | 'md:gap-x-12'
  | 'mg:gap-x-12'
  | 'lg:gap-x-12'
  | 'xl:gap-x-12'
  | 'sm:gap-x-14'
  | 'md:gap-x-14'
  | 'mg:gap-x-14'
  | 'lg:gap-x-14'
  | 'xl:gap-x-14'
  | 'sm:gap-x-15'
  | 'md:gap-x-15'
  | 'mg:gap-x-15'
  | 'lg:gap-x-15'
  | 'xl:gap-x-15'
  | 'sm:gap-x-16'
  | 'md:gap-x-16'
  | 'mg:gap-x-16'
  | 'lg:gap-x-16'
  | 'xl:gap-x-16'
  | 'sm:gap-x-17'
  | 'md:gap-x-17'
  | 'mg:gap-x-17'
  | 'lg:gap-x-17'
  | 'xl:gap-x-17'
  | 'sm:gap-x-18'
  | 'md:gap-x-18'
  | 'mg:gap-x-18'
  | 'lg:gap-x-18'
  | 'xl:gap-x-18'
  | 'sm:gap-x-20'
  | 'md:gap-x-20'
  | 'mg:gap-x-20'
  | 'lg:gap-x-20'
  | 'xl:gap-x-20'
  | 'sm:gap-x-21'
  | 'md:gap-x-21'
  | 'mg:gap-x-21'
  | 'lg:gap-x-21'
  | 'xl:gap-x-21'
  | 'sm:gap-x-22'
  | 'md:gap-x-22'
  | 'mg:gap-x-22'
  | 'lg:gap-x-22'
  | 'xl:gap-x-22'
  | 'sm:gap-x-24'
  | 'md:gap-x-24'
  | 'mg:gap-x-24'
  | 'lg:gap-x-24'
  | 'xl:gap-x-24'
  | 'sm:gap-x-28'
  | 'md:gap-x-28'
  | 'mg:gap-x-28'
  | 'lg:gap-x-28'
  | 'xl:gap-x-28'
  | 'sm:gap-x-30'
  | 'md:gap-x-30'
  | 'mg:gap-x-30'
  | 'lg:gap-x-30'
  | 'xl:gap-x-30'
  | 'sm:gap-x-32'
  | 'md:gap-x-32'
  | 'mg:gap-x-32'
  | 'lg:gap-x-32'
  | 'xl:gap-x-32'
  | 'sm:gap-x-36'
  | 'md:gap-x-36'
  | 'mg:gap-x-36'
  | 'lg:gap-x-36'
  | 'xl:gap-x-36'
  | 'sm:gap-x-40'
  | 'md:gap-x-40'
  | 'mg:gap-x-40'
  | 'lg:gap-x-40'
  | 'xl:gap-x-40'
  | 'sm:gap-x-44'
  | 'md:gap-x-44'
  | 'mg:gap-x-44'
  | 'lg:gap-x-44'
  | 'xl:gap-x-44'
  | 'sm:gap-x-48'
  | 'md:gap-x-48'
  | 'mg:gap-x-48'
  | 'lg:gap-x-48'
  | 'xl:gap-x-48'
  | 'sm:gap-x-52'
  | 'md:gap-x-52'
  | 'mg:gap-x-52'
  | 'lg:gap-x-52'
  | 'xl:gap-x-52'
  | 'sm:gap-x-56'
  | 'md:gap-x-56'
  | 'mg:gap-x-56'
  | 'lg:gap-x-56'
  | 'xl:gap-x-56'
  | 'sm:gap-x-60'
  | 'md:gap-x-60'
  | 'mg:gap-x-60'
  | 'lg:gap-x-60'
  | 'xl:gap-x-60'
  | 'sm:gap-x-64'
  | 'md:gap-x-64'
  | 'mg:gap-x-64'
  | 'lg:gap-x-64'
  | 'xl:gap-x-64'
  | 'sm:gap-x-72'
  | 'md:gap-x-72'
  | 'mg:gap-x-72'
  | 'lg:gap-x-72'
  | 'xl:gap-x-72'
  | 'sm:gap-x-80'
  | 'md:gap-x-80'
  | 'mg:gap-x-80'
  | 'lg:gap-x-80'
  | 'xl:gap-x-80'
  | 'sm:gap-x-96'
  | 'md:gap-x-96'
  | 'mg:gap-x-96'
  | 'lg:gap-x-96'
  | 'xl:gap-x-96'
  | 'sm:gap-x-px'
  | 'md:gap-x-px'
  | 'mg:gap-x-px'
  | 'lg:gap-x-px'
  | 'xl:gap-x-px'
  | 'sm:gap-x-0.5'
  | 'md:gap-x-0.5'
  | 'mg:gap-x-0.5'
  | 'lg:gap-x-0.5'
  | 'xl:gap-x-0.5'
  | 'sm:gap-x-1.5'
  | 'md:gap-x-1.5'
  | 'mg:gap-x-1.5'
  | 'lg:gap-x-1.5'
  | 'xl:gap-x-1.5'
  | 'sm:gap-x-2.5'
  | 'md:gap-x-2.5'
  | 'mg:gap-x-2.5'
  | 'lg:gap-x-2.5'
  | 'xl:gap-x-2.5'
  | 'sm:gap-x-3.5'
  | 'md:gap-x-3.5'
  | 'mg:gap-x-3.5'
  | 'lg:gap-x-3.5'
  | 'xl:gap-x-3.5'
  | 'sm:gap-x-1/2'
  | 'md:gap-x-1/2'
  | 'mg:gap-x-1/2'
  | 'lg:gap-x-1/2'
  | 'xl:gap-x-1/2'
  | 'sm:gap-x-full'
  | 'md:gap-x-full'
  | 'mg:gap-x-full'
  | 'lg:gap-x-full'
  | 'xl:gap-x-full'
  | 'sm:gap-x-4.5'
  | 'md:gap-x-4.5'
  | 'mg:gap-x-4.5'
  | 'lg:gap-x-4.5'
  | 'xl:gap-x-4.5'
  | 'sm:gap-x-7.5'
  | 'md:gap-x-7.5'
  | 'mg:gap-x-7.5'
  | 'lg:gap-x-7.5'
  | 'xl:gap-x-7.5'
  | 'sm:gap-x-9.5'
  | 'md:gap-x-9.5'
  | 'mg:gap-x-9.5'
  | 'lg:gap-x-9.5'
  | 'xl:gap-x-9.5'
  | 'sm:gap-x-11.5'
  | 'md:gap-x-11.5'
  | 'mg:gap-x-11.5'
  | 'lg:gap-x-11.5'
  | 'xl:gap-x-11.5'
  | 'sm:from-transparent'
  | 'md:from-transparent'
  | 'mg:from-transparent'
  | 'lg:from-transparent'
  | 'xl:from-transparent'
  | 'hover:from-transparent'
  | 'focus:from-transparent'
  | 'sm:via-transparent'
  | 'md:via-transparent'
  | 'mg:via-transparent'
  | 'lg:via-transparent'
  | 'xl:via-transparent'
  | 'hover:via-transparent'
  | 'focus:via-transparent'
  | 'sm:to-transparent'
  | 'md:to-transparent'
  | 'mg:to-transparent'
  | 'lg:to-transparent'
  | 'xl:to-transparent'
  | 'hover:to-transparent'
  | 'focus:to-transparent'
  | 'sm:from-current'
  | 'md:from-current'
  | 'mg:from-current'
  | 'lg:from-current'
  | 'xl:from-current'
  | 'hover:from-current'
  | 'focus:from-current'
  | 'sm:via-current'
  | 'md:via-current'
  | 'mg:via-current'
  | 'lg:via-current'
  | 'xl:via-current'
  | 'hover:via-current'
  | 'focus:via-current'
  | 'sm:to-current'
  | 'md:to-current'
  | 'mg:to-current'
  | 'lg:to-current'
  | 'xl:to-current'
  | 'hover:to-current'
  | 'focus:to-current'
  | 'sm:from-overlay'
  | 'md:from-overlay'
  | 'mg:from-overlay'
  | 'lg:from-overlay'
  | 'xl:from-overlay'
  | 'hover:from-overlay'
  | 'focus:from-overlay'
  | 'sm:via-overlay'
  | 'md:via-overlay'
  | 'mg:via-overlay'
  | 'lg:via-overlay'
  | 'xl:via-overlay'
  | 'hover:via-overlay'
  | 'focus:via-overlay'
  | 'sm:to-overlay'
  | 'md:to-overlay'
  | 'mg:to-overlay'
  | 'lg:to-overlay'
  | 'xl:to-overlay'
  | 'hover:to-overlay'
  | 'focus:to-overlay'
  | 'sm:from-black'
  | 'md:from-black'
  | 'mg:from-black'
  | 'lg:from-black'
  | 'xl:from-black'
  | 'hover:from-black'
  | 'focus:from-black'
  | 'sm:via-black'
  | 'md:via-black'
  | 'mg:via-black'
  | 'lg:via-black'
  | 'xl:via-black'
  | 'hover:via-black'
  | 'focus:via-black'
  | 'sm:to-black'
  | 'md:to-black'
  | 'mg:to-black'
  | 'lg:to-black'
  | 'xl:to-black'
  | 'hover:to-black'
  | 'focus:to-black'
  | 'sm:from-white'
  | 'md:from-white'
  | 'mg:from-white'
  | 'lg:from-white'
  | 'xl:from-white'
  | 'hover:from-white'
  | 'focus:from-white'
  | 'sm:via-white'
  | 'md:via-white'
  | 'mg:via-white'
  | 'lg:via-white'
  | 'xl:via-white'
  | 'hover:via-white'
  | 'focus:via-white'
  | 'sm:to-white'
  | 'md:to-white'
  | 'mg:to-white'
  | 'lg:to-white'
  | 'xl:to-white'
  | 'hover:to-white'
  | 'focus:to-white'
  | 'sm:from-white-hover'
  | 'md:from-white-hover'
  | 'mg:from-white-hover'
  | 'lg:from-white-hover'
  | 'xl:from-white-hover'
  | 'hover:from-white-hover'
  | 'focus:from-white-hover'
  | 'sm:via-white-hover'
  | 'md:via-white-hover'
  | 'mg:via-white-hover'
  | 'lg:via-white-hover'
  | 'xl:via-white-hover'
  | 'hover:via-white-hover'
  | 'focus:via-white-hover'
  | 'sm:to-white-hover'
  | 'md:to-white-hover'
  | 'mg:to-white-hover'
  | 'lg:to-white-hover'
  | 'xl:to-white-hover'
  | 'hover:to-white-hover'
  | 'focus:to-white-hover'
  | 'sm:from-white-pressed'
  | 'md:from-white-pressed'
  | 'mg:from-white-pressed'
  | 'lg:from-white-pressed'
  | 'xl:from-white-pressed'
  | 'hover:from-white-pressed'
  | 'focus:from-white-pressed'
  | 'sm:via-white-pressed'
  | 'md:via-white-pressed'
  | 'mg:via-white-pressed'
  | 'lg:via-white-pressed'
  | 'xl:via-white-pressed'
  | 'hover:via-white-pressed'
  | 'focus:via-white-pressed'
  | 'sm:to-white-pressed'
  | 'md:to-white-pressed'
  | 'mg:to-white-pressed'
  | 'lg:to-white-pressed'
  | 'xl:to-white-pressed'
  | 'hover:to-white-pressed'
  | 'focus:to-white-pressed'
  | 'sm:from-product-acid'
  | 'md:from-product-acid'
  | 'mg:from-product-acid'
  | 'lg:from-product-acid'
  | 'xl:from-product-acid'
  | 'hover:from-product-acid'
  | 'focus:from-product-acid'
  | 'sm:via-product-acid'
  | 'md:via-product-acid'
  | 'mg:via-product-acid'
  | 'lg:via-product-acid'
  | 'xl:via-product-acid'
  | 'hover:via-product-acid'
  | 'focus:via-product-acid'
  | 'sm:to-product-acid'
  | 'md:to-product-acid'
  | 'mg:to-product-acid'
  | 'lg:to-product-acid'
  | 'xl:to-product-acid'
  | 'hover:to-product-acid'
  | 'focus:to-product-acid'
  | 'sm:from-product-aura'
  | 'md:from-product-aura'
  | 'mg:from-product-aura'
  | 'lg:from-product-aura'
  | 'xl:from-product-aura'
  | 'hover:from-product-aura'
  | 'focus:from-product-aura'
  | 'sm:via-product-aura'
  | 'md:via-product-aura'
  | 'mg:via-product-aura'
  | 'lg:via-product-aura'
  | 'xl:via-product-aura'
  | 'hover:via-product-aura'
  | 'focus:via-product-aura'
  | 'sm:to-product-aura'
  | 'md:to-product-aura'
  | 'mg:to-product-aura'
  | 'lg:to-product-aura'
  | 'xl:to-product-aura'
  | 'hover:to-product-aura'
  | 'focus:to-product-aura'
  | 'sm:from-product-azul'
  | 'md:from-product-azul'
  | 'mg:from-product-azul'
  | 'lg:from-product-azul'
  | 'xl:from-product-azul'
  | 'hover:from-product-azul'
  | 'focus:from-product-azul'
  | 'sm:via-product-azul'
  | 'md:via-product-azul'
  | 'mg:via-product-azul'
  | 'lg:via-product-azul'
  | 'xl:via-product-azul'
  | 'hover:via-product-azul'
  | 'focus:via-product-azul'
  | 'sm:to-product-azul'
  | 'md:to-product-azul'
  | 'mg:to-product-azul'
  | 'lg:to-product-azul'
  | 'xl:to-product-azul'
  | 'hover:to-product-azul'
  | 'focus:to-product-azul'
  | 'sm:from-product-blanch'
  | 'md:from-product-blanch'
  | 'mg:from-product-blanch'
  | 'lg:from-product-blanch'
  | 'xl:from-product-blanch'
  | 'hover:from-product-blanch'
  | 'focus:from-product-blanch'
  | 'sm:via-product-blanch'
  | 'md:via-product-blanch'
  | 'mg:via-product-blanch'
  | 'lg:via-product-blanch'
  | 'xl:via-product-blanch'
  | 'hover:via-product-blanch'
  | 'focus:via-product-blanch'
  | 'sm:to-product-blanch'
  | 'md:to-product-blanch'
  | 'mg:to-product-blanch'
  | 'lg:to-product-blanch'
  | 'xl:to-product-blanch'
  | 'hover:to-product-blanch'
  | 'focus:to-product-blanch'
  | 'sm:from-product-blue-salt'
  | 'md:from-product-blue-salt'
  | 'mg:from-product-blue-salt'
  | 'lg:from-product-blue-salt'
  | 'xl:from-product-blue-salt'
  | 'hover:from-product-blue-salt'
  | 'focus:from-product-blue-salt'
  | 'sm:via-product-blue-salt'
  | 'md:via-product-blue-salt'
  | 'mg:via-product-blue-salt'
  | 'lg:via-product-blue-salt'
  | 'xl:via-product-blue-salt'
  | 'hover:via-product-blue-salt'
  | 'focus:via-product-blue-salt'
  | 'sm:to-product-blue-salt'
  | 'md:to-product-blue-salt'
  | 'mg:to-product-blue-salt'
  | 'lg:to-product-blue-salt'
  | 'xl:to-product-blue-salt'
  | 'hover:to-product-blue-salt'
  | 'focus:to-product-blue-salt'
  | 'sm:from-product-burgundy'
  | 'md:from-product-burgundy'
  | 'mg:from-product-burgundy'
  | 'lg:from-product-burgundy'
  | 'xl:from-product-burgundy'
  | 'hover:from-product-burgundy'
  | 'focus:from-product-burgundy'
  | 'sm:via-product-burgundy'
  | 'md:via-product-burgundy'
  | 'mg:via-product-burgundy'
  | 'lg:via-product-burgundy'
  | 'xl:via-product-burgundy'
  | 'hover:via-product-burgundy'
  | 'focus:via-product-burgundy'
  | 'sm:to-product-burgundy'
  | 'md:to-product-burgundy'
  | 'mg:to-product-burgundy'
  | 'lg:to-product-burgundy'
  | 'xl:to-product-burgundy'
  | 'hover:to-product-burgundy'
  | 'focus:to-product-burgundy'
  | 'sm:from-product-butter-yellow'
  | 'md:from-product-butter-yellow'
  | 'mg:from-product-butter-yellow'
  | 'lg:from-product-butter-yellow'
  | 'xl:from-product-butter-yellow'
  | 'hover:from-product-butter-yellow'
  | 'focus:from-product-butter-yellow'
  | 'sm:via-product-butter-yellow'
  | 'md:via-product-butter-yellow'
  | 'mg:via-product-butter-yellow'
  | 'lg:via-product-butter-yellow'
  | 'xl:via-product-butter-yellow'
  | 'hover:via-product-butter-yellow'
  | 'focus:via-product-butter-yellow'
  | 'sm:to-product-butter-yellow'
  | 'md:to-product-butter-yellow'
  | 'mg:to-product-butter-yellow'
  | 'lg:to-product-butter-yellow'
  | 'xl:to-product-butter-yellow'
  | 'hover:to-product-butter-yellow'
  | 'focus:to-product-butter-yellow'
  | 'sm:from-product-chai'
  | 'md:from-product-chai'
  | 'mg:from-product-chai'
  | 'lg:from-product-chai'
  | 'xl:from-product-chai'
  | 'hover:from-product-chai'
  | 'focus:from-product-chai'
  | 'sm:via-product-chai'
  | 'md:via-product-chai'
  | 'mg:via-product-chai'
  | 'lg:via-product-chai'
  | 'xl:via-product-chai'
  | 'hover:via-product-chai'
  | 'focus:via-product-chai'
  | 'sm:to-product-chai'
  | 'md:to-product-chai'
  | 'mg:to-product-chai'
  | 'lg:to-product-chai'
  | 'xl:to-product-chai'
  | 'hover:to-product-chai'
  | 'focus:to-product-chai'
  | 'sm:from-product-char'
  | 'md:from-product-char'
  | 'mg:from-product-char'
  | 'lg:from-product-char'
  | 'xl:from-product-char'
  | 'hover:from-product-char'
  | 'focus:from-product-char'
  | 'sm:via-product-char'
  | 'md:via-product-char'
  | 'mg:via-product-char'
  | 'lg:via-product-char'
  | 'xl:via-product-char'
  | 'hover:via-product-char'
  | 'focus:via-product-char'
  | 'sm:to-product-char'
  | 'md:to-product-char'
  | 'mg:to-product-char'
  | 'lg:to-product-char'
  | 'xl:to-product-char'
  | 'hover:to-product-char'
  | 'focus:to-product-char'
  | 'sm:from-product-charm'
  | 'md:from-product-charm'
  | 'mg:from-product-charm'
  | 'lg:from-product-charm'
  | 'xl:from-product-charm'
  | 'hover:from-product-charm'
  | 'focus:from-product-charm'
  | 'sm:via-product-charm'
  | 'md:via-product-charm'
  | 'mg:via-product-charm'
  | 'lg:via-product-charm'
  | 'xl:via-product-charm'
  | 'hover:via-product-charm'
  | 'focus:via-product-charm'
  | 'sm:to-product-charm'
  | 'md:to-product-charm'
  | 'mg:to-product-charm'
  | 'lg:to-product-charm'
  | 'xl:to-product-charm'
  | 'hover:to-product-charm'
  | 'focus:to-product-charm'
  | 'sm:from-product-chickpea'
  | 'md:from-product-chickpea'
  | 'mg:from-product-chickpea'
  | 'lg:from-product-chickpea'
  | 'xl:from-product-chickpea'
  | 'hover:from-product-chickpea'
  | 'focus:from-product-chickpea'
  | 'sm:via-product-chickpea'
  | 'md:via-product-chickpea'
  | 'mg:via-product-chickpea'
  | 'lg:via-product-chickpea'
  | 'xl:via-product-chickpea'
  | 'hover:via-product-chickpea'
  | 'focus:via-product-chickpea'
  | 'sm:to-product-chickpea'
  | 'md:to-product-chickpea'
  | 'mg:to-product-chickpea'
  | 'lg:to-product-chickpea'
  | 'xl:to-product-chickpea'
  | 'hover:to-product-chickpea'
  | 'focus:to-product-chickpea'
  | 'sm:from-product-cielo'
  | 'md:from-product-cielo'
  | 'mg:from-product-cielo'
  | 'lg:from-product-cielo'
  | 'xl:from-product-cielo'
  | 'hover:from-product-cielo'
  | 'focus:from-product-cielo'
  | 'sm:via-product-cielo'
  | 'md:via-product-cielo'
  | 'mg:via-product-cielo'
  | 'lg:via-product-cielo'
  | 'xl:via-product-cielo'
  | 'hover:via-product-cielo'
  | 'focus:via-product-cielo'
  | 'sm:to-product-cielo'
  | 'md:to-product-cielo'
  | 'mg:to-product-cielo'
  | 'lg:to-product-cielo'
  | 'xl:to-product-cielo'
  | 'hover:to-product-cielo'
  | 'focus:to-product-cielo'
  | 'sm:from-product-clay'
  | 'md:from-product-clay'
  | 'mg:from-product-clay'
  | 'lg:from-product-clay'
  | 'xl:from-product-clay'
  | 'hover:from-product-clay'
  | 'focus:from-product-clay'
  | 'sm:via-product-clay'
  | 'md:via-product-clay'
  | 'mg:via-product-clay'
  | 'lg:via-product-clay'
  | 'xl:via-product-clay'
  | 'hover:via-product-clay'
  | 'focus:via-product-clay'
  | 'sm:to-product-clay'
  | 'md:to-product-clay'
  | 'mg:to-product-clay'
  | 'lg:to-product-clay'
  | 'xl:to-product-clay'
  | 'hover:to-product-clay'
  | 'focus:to-product-clay'
  | 'sm:from-product-clear'
  | 'md:from-product-clear'
  | 'mg:from-product-clear'
  | 'lg:from-product-clear'
  | 'xl:from-product-clear'
  | 'hover:from-product-clear'
  | 'focus:from-product-clear'
  | 'sm:via-product-clear'
  | 'md:via-product-clear'
  | 'mg:via-product-clear'
  | 'lg:via-product-clear'
  | 'xl:via-product-clear'
  | 'hover:via-product-clear'
  | 'focus:via-product-clear'
  | 'sm:to-product-clear'
  | 'md:to-product-clear'
  | 'mg:to-product-clear'
  | 'lg:to-product-clear'
  | 'xl:to-product-clear'
  | 'hover:to-product-clear'
  | 'focus:to-product-clear'
  | 'sm:from-product-coriander'
  | 'md:from-product-coriander'
  | 'mg:from-product-coriander'
  | 'lg:from-product-coriander'
  | 'xl:from-product-coriander'
  | 'hover:from-product-coriander'
  | 'focus:from-product-coriander'
  | 'sm:via-product-coriander'
  | 'md:via-product-coriander'
  | 'mg:via-product-coriander'
  | 'lg:via-product-coriander'
  | 'xl:via-product-coriander'
  | 'hover:via-product-coriander'
  | 'focus:via-product-coriander'
  | 'sm:to-product-coriander'
  | 'md:to-product-coriander'
  | 'mg:to-product-coriander'
  | 'lg:to-product-coriander'
  | 'xl:to-product-coriander'
  | 'hover:to-product-coriander'
  | 'focus:to-product-coriander'
  | 'sm:from-product-cream'
  | 'md:from-product-cream'
  | 'mg:from-product-cream'
  | 'lg:from-product-cream'
  | 'xl:from-product-cream'
  | 'hover:from-product-cream'
  | 'focus:from-product-cream'
  | 'sm:via-product-cream'
  | 'md:via-product-cream'
  | 'mg:via-product-cream'
  | 'lg:via-product-cream'
  | 'xl:via-product-cream'
  | 'hover:via-product-cream'
  | 'focus:via-product-cream'
  | 'sm:to-product-cream'
  | 'md:to-product-cream'
  | 'mg:to-product-cream'
  | 'lg:to-product-cream'
  | 'xl:to-product-cream'
  | 'hover:to-product-cream'
  | 'focus:to-product-cream'
  | 'sm:from-product-crescent'
  | 'md:from-product-crescent'
  | 'mg:from-product-crescent'
  | 'lg:from-product-crescent'
  | 'xl:from-product-crescent'
  | 'hover:from-product-crescent'
  | 'focus:from-product-crescent'
  | 'sm:via-product-crescent'
  | 'md:via-product-crescent'
  | 'mg:via-product-crescent'
  | 'lg:via-product-crescent'
  | 'xl:via-product-crescent'
  | 'hover:via-product-crescent'
  | 'focus:via-product-crescent'
  | 'sm:to-product-crescent'
  | 'md:to-product-crescent'
  | 'mg:to-product-crescent'
  | 'lg:to-product-crescent'
  | 'xl:to-product-crescent'
  | 'hover:to-product-crescent'
  | 'focus:to-product-crescent'
  | 'sm:from-product-dawn'
  | 'md:from-product-dawn'
  | 'mg:from-product-dawn'
  | 'lg:from-product-dawn'
  | 'xl:from-product-dawn'
  | 'hover:from-product-dawn'
  | 'focus:from-product-dawn'
  | 'sm:via-product-dawn'
  | 'md:via-product-dawn'
  | 'mg:via-product-dawn'
  | 'lg:via-product-dawn'
  | 'xl:via-product-dawn'
  | 'hover:via-product-dawn'
  | 'focus:via-product-dawn'
  | 'sm:to-product-dawn'
  | 'md:to-product-dawn'
  | 'mg:to-product-dawn'
  | 'lg:to-product-dawn'
  | 'xl:to-product-dawn'
  | 'hover:to-product-dawn'
  | 'focus:to-product-dawn'
  | 'sm:from-product-dusk'
  | 'md:from-product-dusk'
  | 'mg:from-product-dusk'
  | 'lg:from-product-dusk'
  | 'xl:from-product-dusk'
  | 'hover:from-product-dusk'
  | 'focus:from-product-dusk'
  | 'sm:via-product-dusk'
  | 'md:via-product-dusk'
  | 'mg:via-product-dusk'
  | 'lg:via-product-dusk'
  | 'xl:via-product-dusk'
  | 'hover:via-product-dusk'
  | 'focus:via-product-dusk'
  | 'sm:to-product-dusk'
  | 'md:to-product-dusk'
  | 'mg:to-product-dusk'
  | 'lg:to-product-dusk'
  | 'xl:to-product-dusk'
  | 'hover:to-product-dusk'
  | 'focus:to-product-dusk'
  | 'sm:from-product-egg-yolk'
  | 'md:from-product-egg-yolk'
  | 'mg:from-product-egg-yolk'
  | 'lg:from-product-egg-yolk'
  | 'xl:from-product-egg-yolk'
  | 'hover:from-product-egg-yolk'
  | 'focus:from-product-egg-yolk'
  | 'sm:via-product-egg-yolk'
  | 'md:via-product-egg-yolk'
  | 'mg:via-product-egg-yolk'
  | 'lg:via-product-egg-yolk'
  | 'xl:via-product-egg-yolk'
  | 'hover:via-product-egg-yolk'
  | 'focus:via-product-egg-yolk'
  | 'sm:to-product-egg-yolk'
  | 'md:to-product-egg-yolk'
  | 'mg:to-product-egg-yolk'
  | 'lg:to-product-egg-yolk'
  | 'xl:to-product-egg-yolk'
  | 'hover:to-product-egg-yolk'
  | 'focus:to-product-egg-yolk'
  | 'sm:from-product-espresso'
  | 'md:from-product-espresso'
  | 'mg:from-product-espresso'
  | 'lg:from-product-espresso'
  | 'xl:from-product-espresso'
  | 'hover:from-product-espresso'
  | 'focus:from-product-espresso'
  | 'sm:via-product-espresso'
  | 'md:via-product-espresso'
  | 'mg:via-product-espresso'
  | 'lg:via-product-espresso'
  | 'xl:via-product-espresso'
  | 'hover:via-product-espresso'
  | 'focus:via-product-espresso'
  | 'sm:to-product-espresso'
  | 'md:to-product-espresso'
  | 'mg:to-product-espresso'
  | 'lg:to-product-espresso'
  | 'xl:to-product-espresso'
  | 'hover:to-product-espresso'
  | 'focus:to-product-espresso'
  | 'sm:from-product-eve'
  | 'md:from-product-eve'
  | 'mg:from-product-eve'
  | 'lg:from-product-eve'
  | 'xl:from-product-eve'
  | 'hover:from-product-eve'
  | 'focus:from-product-eve'
  | 'sm:via-product-eve'
  | 'md:via-product-eve'
  | 'mg:via-product-eve'
  | 'lg:via-product-eve'
  | 'xl:via-product-eve'
  | 'hover:via-product-eve'
  | 'focus:via-product-eve'
  | 'sm:to-product-eve'
  | 'md:to-product-eve'
  | 'mg:to-product-eve'
  | 'lg:to-product-eve'
  | 'xl:to-product-eve'
  | 'hover:to-product-eve'
  | 'focus:to-product-eve'
  | 'sm:from-product-firecracker'
  | 'md:from-product-firecracker'
  | 'mg:from-product-firecracker'
  | 'lg:from-product-firecracker'
  | 'xl:from-product-firecracker'
  | 'hover:from-product-firecracker'
  | 'focus:from-product-firecracker'
  | 'sm:via-product-firecracker'
  | 'md:via-product-firecracker'
  | 'mg:via-product-firecracker'
  | 'lg:via-product-firecracker'
  | 'xl:via-product-firecracker'
  | 'hover:via-product-firecracker'
  | 'focus:via-product-firecracker'
  | 'sm:to-product-firecracker'
  | 'md:to-product-firecracker'
  | 'mg:to-product-firecracker'
  | 'lg:to-product-firecracker'
  | 'xl:to-product-firecracker'
  | 'hover:to-product-firecracker'
  | 'focus:to-product-firecracker'
  | 'sm:from-product-forget-me-not-blue'
  | 'md:from-product-forget-me-not-blue'
  | 'mg:from-product-forget-me-not-blue'
  | 'lg:from-product-forget-me-not-blue'
  | 'xl:from-product-forget-me-not-blue'
  | 'hover:from-product-forget-me-not-blue'
  | 'focus:from-product-forget-me-not-blue'
  | 'sm:via-product-forget-me-not-blue'
  | 'md:via-product-forget-me-not-blue'
  | 'mg:via-product-forget-me-not-blue'
  | 'lg:via-product-forget-me-not-blue'
  | 'xl:via-product-forget-me-not-blue'
  | 'hover:via-product-forget-me-not-blue'
  | 'focus:via-product-forget-me-not-blue'
  | 'sm:to-product-forget-me-not-blue'
  | 'md:to-product-forget-me-not-blue'
  | 'mg:to-product-forget-me-not-blue'
  | 'lg:to-product-forget-me-not-blue'
  | 'xl:to-product-forget-me-not-blue'
  | 'hover:to-product-forget-me-not-blue'
  | 'focus:to-product-forget-me-not-blue'
  | 'sm:from-product-gold'
  | 'md:from-product-gold'
  | 'mg:from-product-gold'
  | 'lg:from-product-gold'
  | 'xl:from-product-gold'
  | 'hover:from-product-gold'
  | 'focus:from-product-gold'
  | 'sm:via-product-gold'
  | 'md:via-product-gold'
  | 'mg:via-product-gold'
  | 'lg:via-product-gold'
  | 'xl:via-product-gold'
  | 'hover:via-product-gold'
  | 'focus:via-product-gold'
  | 'sm:to-product-gold'
  | 'md:to-product-gold'
  | 'mg:to-product-gold'
  | 'lg:to-product-gold'
  | 'xl:to-product-gold'
  | 'hover:to-product-gold'
  | 'focus:to-product-gold'
  | 'sm:from-product-golden'
  | 'md:from-product-golden'
  | 'mg:from-product-golden'
  | 'lg:from-product-golden'
  | 'xl:from-product-golden'
  | 'hover:from-product-golden'
  | 'focus:from-product-golden'
  | 'sm:via-product-golden'
  | 'md:via-product-golden'
  | 'mg:via-product-golden'
  | 'lg:via-product-golden'
  | 'xl:via-product-golden'
  | 'hover:via-product-golden'
  | 'focus:via-product-golden'
  | 'sm:to-product-golden'
  | 'md:to-product-golden'
  | 'mg:to-product-golden'
  | 'lg:to-product-golden'
  | 'xl:to-product-golden'
  | 'hover:to-product-golden'
  | 'focus:to-product-golden'
  | 'sm:from-product-heat'
  | 'md:from-product-heat'
  | 'mg:from-product-heat'
  | 'lg:from-product-heat'
  | 'xl:from-product-heat'
  | 'hover:from-product-heat'
  | 'focus:from-product-heat'
  | 'sm:via-product-heat'
  | 'md:via-product-heat'
  | 'mg:via-product-heat'
  | 'lg:via-product-heat'
  | 'xl:via-product-heat'
  | 'hover:via-product-heat'
  | 'focus:via-product-heat'
  | 'sm:to-product-heat'
  | 'md:to-product-heat'
  | 'mg:to-product-heat'
  | 'lg:to-product-heat'
  | 'xl:to-product-heat'
  | 'hover:to-product-heat'
  | 'focus:to-product-heat'
  | 'sm:from-product-himalayan-salt'
  | 'md:from-product-himalayan-salt'
  | 'mg:from-product-himalayan-salt'
  | 'lg:from-product-himalayan-salt'
  | 'xl:from-product-himalayan-salt'
  | 'hover:from-product-himalayan-salt'
  | 'focus:from-product-himalayan-salt'
  | 'sm:via-product-himalayan-salt'
  | 'md:via-product-himalayan-salt'
  | 'mg:via-product-himalayan-salt'
  | 'lg:via-product-himalayan-salt'
  | 'xl:via-product-himalayan-salt'
  | 'hover:via-product-himalayan-salt'
  | 'focus:via-product-himalayan-salt'
  | 'sm:to-product-himalayan-salt'
  | 'md:to-product-himalayan-salt'
  | 'mg:to-product-himalayan-salt'
  | 'lg:to-product-himalayan-salt'
  | 'xl:to-product-himalayan-salt'
  | 'hover:to-product-himalayan-salt'
  | 'focus:to-product-himalayan-salt'
  | 'sm:from-product-indigo'
  | 'md:from-product-indigo'
  | 'mg:from-product-indigo'
  | 'lg:from-product-indigo'
  | 'xl:from-product-indigo'
  | 'hover:from-product-indigo'
  | 'focus:from-product-indigo'
  | 'sm:via-product-indigo'
  | 'md:via-product-indigo'
  | 'mg:via-product-indigo'
  | 'lg:via-product-indigo'
  | 'xl:via-product-indigo'
  | 'hover:via-product-indigo'
  | 'focus:via-product-indigo'
  | 'sm:to-product-indigo'
  | 'md:to-product-indigo'
  | 'mg:to-product-indigo'
  | 'lg:to-product-indigo'
  | 'xl:to-product-indigo'
  | 'hover:to-product-indigo'
  | 'focus:to-product-indigo'
  | 'sm:from-product-lavender'
  | 'md:from-product-lavender'
  | 'mg:from-product-lavender'
  | 'lg:from-product-lavender'
  | 'xl:from-product-lavender'
  | 'hover:from-product-lavender'
  | 'focus:from-product-lavender'
  | 'sm:via-product-lavender'
  | 'md:via-product-lavender'
  | 'mg:via-product-lavender'
  | 'lg:via-product-lavender'
  | 'xl:via-product-lavender'
  | 'hover:via-product-lavender'
  | 'focus:via-product-lavender'
  | 'sm:to-product-lavender'
  | 'md:to-product-lavender'
  | 'mg:to-product-lavender'
  | 'lg:to-product-lavender'
  | 'xl:to-product-lavender'
  | 'hover:to-product-lavender'
  | 'focus:to-product-lavender'
  | 'sm:from-product-lavender-marble'
  | 'md:from-product-lavender-marble'
  | 'mg:from-product-lavender-marble'
  | 'lg:from-product-lavender-marble'
  | 'xl:from-product-lavender-marble'
  | 'hover:from-product-lavender-marble'
  | 'focus:from-product-lavender-marble'
  | 'sm:via-product-lavender-marble'
  | 'md:via-product-lavender-marble'
  | 'mg:via-product-lavender-marble'
  | 'lg:via-product-lavender-marble'
  | 'xl:via-product-lavender-marble'
  | 'hover:via-product-lavender-marble'
  | 'focus:via-product-lavender-marble'
  | 'sm:to-product-lavender-marble'
  | 'md:to-product-lavender-marble'
  | 'mg:to-product-lavender-marble'
  | 'lg:to-product-lavender-marble'
  | 'xl:to-product-lavender-marble'
  | 'hover:to-product-lavender-marble'
  | 'focus:to-product-lavender-marble'
  | 'sm:from-product-midnight-marble'
  | 'md:from-product-midnight-marble'
  | 'mg:from-product-midnight-marble'
  | 'lg:from-product-midnight-marble'
  | 'xl:from-product-midnight-marble'
  | 'hover:from-product-midnight-marble'
  | 'focus:from-product-midnight-marble'
  | 'sm:via-product-midnight-marble'
  | 'md:via-product-midnight-marble'
  | 'mg:via-product-midnight-marble'
  | 'lg:via-product-midnight-marble'
  | 'xl:via-product-midnight-marble'
  | 'hover:via-product-midnight-marble'
  | 'focus:via-product-midnight-marble'
  | 'sm:to-product-midnight-marble'
  | 'md:to-product-midnight-marble'
  | 'mg:to-product-midnight-marble'
  | 'lg:to-product-midnight-marble'
  | 'xl:to-product-midnight-marble'
  | 'hover:to-product-midnight-marble'
  | 'focus:to-product-midnight-marble'
  | 'sm:from-product-nougat'
  | 'md:from-product-nougat'
  | 'mg:from-product-nougat'
  | 'lg:from-product-nougat'
  | 'xl:from-product-nougat'
  | 'hover:from-product-nougat'
  | 'focus:from-product-nougat'
  | 'sm:via-product-nougat'
  | 'md:via-product-nougat'
  | 'mg:via-product-nougat'
  | 'lg:via-product-nougat'
  | 'xl:via-product-nougat'
  | 'hover:via-product-nougat'
  | 'focus:via-product-nougat'
  | 'sm:to-product-nougat'
  | 'md:to-product-nougat'
  | 'mg:to-product-nougat'
  | 'lg:to-product-nougat'
  | 'xl:to-product-nougat'
  | 'hover:to-product-nougat'
  | 'focus:to-product-nougat'
  | 'sm:from-product-pistachio'
  | 'md:from-product-pistachio'
  | 'mg:from-product-pistachio'
  | 'lg:from-product-pistachio'
  | 'xl:from-product-pistachio'
  | 'hover:from-product-pistachio'
  | 'focus:from-product-pistachio'
  | 'sm:via-product-pistachio'
  | 'md:via-product-pistachio'
  | 'mg:via-product-pistachio'
  | 'lg:via-product-pistachio'
  | 'xl:via-product-pistachio'
  | 'hover:via-product-pistachio'
  | 'focus:via-product-pistachio'
  | 'sm:to-product-pistachio'
  | 'md:to-product-pistachio'
  | 'mg:to-product-pistachio'
  | 'lg:to-product-pistachio'
  | 'xl:to-product-pistachio'
  | 'hover:to-product-pistachio'
  | 'focus:to-product-pistachio'
  | 'sm:from-product-rosa'
  | 'md:from-product-rosa'
  | 'mg:from-product-rosa'
  | 'lg:from-product-rosa'
  | 'xl:from-product-rosa'
  | 'hover:from-product-rosa'
  | 'focus:from-product-rosa'
  | 'sm:via-product-rosa'
  | 'md:via-product-rosa'
  | 'mg:via-product-rosa'
  | 'lg:via-product-rosa'
  | 'xl:via-product-rosa'
  | 'hover:via-product-rosa'
  | 'focus:via-product-rosa'
  | 'sm:to-product-rosa'
  | 'md:to-product-rosa'
  | 'mg:to-product-rosa'
  | 'lg:to-product-rosa'
  | 'xl:to-product-rosa'
  | 'hover:to-product-rosa'
  | 'focus:to-product-rosa'
  | 'sm:from-product-rose-gold'
  | 'md:from-product-rose-gold'
  | 'mg:from-product-rose-gold'
  | 'lg:from-product-rose-gold'
  | 'xl:from-product-rose-gold'
  | 'hover:from-product-rose-gold'
  | 'focus:from-product-rose-gold'
  | 'sm:via-product-rose-gold'
  | 'md:via-product-rose-gold'
  | 'mg:via-product-rose-gold'
  | 'lg:via-product-rose-gold'
  | 'xl:via-product-rose-gold'
  | 'hover:via-product-rose-gold'
  | 'focus:via-product-rose-gold'
  | 'sm:to-product-rose-gold'
  | 'md:to-product-rose-gold'
  | 'mg:to-product-rose-gold'
  | 'lg:to-product-rose-gold'
  | 'xl:to-product-rose-gold'
  | 'hover:to-product-rose-gold'
  | 'focus:to-product-rose-gold'
  | 'sm:from-product-rust'
  | 'md:from-product-rust'
  | 'mg:from-product-rust'
  | 'lg:from-product-rust'
  | 'xl:from-product-rust'
  | 'hover:from-product-rust'
  | 'focus:from-product-rust'
  | 'sm:via-product-rust'
  | 'md:via-product-rust'
  | 'mg:via-product-rust'
  | 'lg:via-product-rust'
  | 'xl:via-product-rust'
  | 'hover:via-product-rust'
  | 'focus:via-product-rust'
  | 'sm:to-product-rust'
  | 'md:to-product-rust'
  | 'mg:to-product-rust'
  | 'lg:to-product-rust'
  | 'xl:to-product-rust'
  | 'hover:to-product-rust'
  | 'focus:to-product-rust'
  | 'sm:from-product-saffron'
  | 'md:from-product-saffron'
  | 'mg:from-product-saffron'
  | 'lg:from-product-saffron'
  | 'xl:from-product-saffron'
  | 'hover:from-product-saffron'
  | 'focus:from-product-saffron'
  | 'sm:via-product-saffron'
  | 'md:via-product-saffron'
  | 'mg:via-product-saffron'
  | 'lg:via-product-saffron'
  | 'xl:via-product-saffron'
  | 'hover:via-product-saffron'
  | 'focus:via-product-saffron'
  | 'sm:to-product-saffron'
  | 'md:to-product-saffron'
  | 'mg:to-product-saffron'
  | 'lg:to-product-saffron'
  | 'xl:to-product-saffron'
  | 'hover:to-product-saffron'
  | 'focus:to-product-saffron'
  | 'sm:from-product-sage'
  | 'md:from-product-sage'
  | 'mg:from-product-sage'
  | 'lg:from-product-sage'
  | 'xl:from-product-sage'
  | 'hover:from-product-sage'
  | 'focus:from-product-sage'
  | 'sm:via-product-sage'
  | 'md:via-product-sage'
  | 'mg:via-product-sage'
  | 'lg:via-product-sage'
  | 'xl:via-product-sage'
  | 'hover:via-product-sage'
  | 'focus:via-product-sage'
  | 'sm:to-product-sage'
  | 'md:to-product-sage'
  | 'mg:to-product-sage'
  | 'lg:to-product-sage'
  | 'xl:to-product-sage'
  | 'hover:to-product-sage'
  | 'focus:to-product-sage'
  | 'sm:from-product-sear'
  | 'md:from-product-sear'
  | 'mg:from-product-sear'
  | 'lg:from-product-sear'
  | 'xl:from-product-sear'
  | 'hover:from-product-sear'
  | 'focus:from-product-sear'
  | 'sm:via-product-sear'
  | 'md:via-product-sear'
  | 'mg:via-product-sear'
  | 'lg:via-product-sear'
  | 'xl:via-product-sear'
  | 'hover:via-product-sear'
  | 'focus:via-product-sear'
  | 'sm:to-product-sear'
  | 'md:to-product-sear'
  | 'mg:to-product-sear'
  | 'lg:to-product-sear'
  | 'xl:to-product-sear'
  | 'hover:to-product-sear'
  | 'focus:to-product-sear'
  | 'sm:from-product-spice'
  | 'md:from-product-spice'
  | 'mg:from-product-spice'
  | 'lg:from-product-spice'
  | 'xl:from-product-spice'
  | 'hover:from-product-spice'
  | 'focus:from-product-spice'
  | 'sm:via-product-spice'
  | 'md:via-product-spice'
  | 'mg:via-product-spice'
  | 'lg:via-product-spice'
  | 'xl:via-product-spice'
  | 'hover:via-product-spice'
  | 'focus:via-product-spice'
  | 'sm:to-product-spice'
  | 'md:to-product-spice'
  | 'mg:to-product-spice'
  | 'lg:to-product-spice'
  | 'xl:to-product-spice'
  | 'hover:to-product-spice'
  | 'focus:to-product-spice'
  | 'sm:from-product-steam'
  | 'md:from-product-steam'
  | 'mg:from-product-steam'
  | 'lg:from-product-steam'
  | 'xl:from-product-steam'
  | 'hover:from-product-steam'
  | 'focus:from-product-steam'
  | 'sm:via-product-steam'
  | 'md:via-product-steam'
  | 'mg:via-product-steam'
  | 'lg:via-product-steam'
  | 'xl:via-product-steam'
  | 'hover:via-product-steam'
  | 'focus:via-product-steam'
  | 'sm:to-product-steam'
  | 'md:to-product-steam'
  | 'mg:to-product-steam'
  | 'lg:to-product-steam'
  | 'xl:to-product-steam'
  | 'hover:to-product-steam'
  | 'focus:to-product-steam'
  | 'sm:from-product-strawberry'
  | 'md:from-product-strawberry'
  | 'mg:from-product-strawberry'
  | 'lg:from-product-strawberry'
  | 'xl:from-product-strawberry'
  | 'hover:from-product-strawberry'
  | 'focus:from-product-strawberry'
  | 'sm:via-product-strawberry'
  | 'md:via-product-strawberry'
  | 'mg:via-product-strawberry'
  | 'lg:via-product-strawberry'
  | 'xl:via-product-strawberry'
  | 'hover:via-product-strawberry'
  | 'focus:via-product-strawberry'
  | 'sm:to-product-strawberry'
  | 'md:to-product-strawberry'
  | 'mg:to-product-strawberry'
  | 'lg:to-product-strawberry'
  | 'xl:to-product-strawberry'
  | 'hover:to-product-strawberry'
  | 'focus:to-product-strawberry'
  | 'sm:from-product-sunrise'
  | 'md:from-product-sunrise'
  | 'mg:from-product-sunrise'
  | 'lg:from-product-sunrise'
  | 'xl:from-product-sunrise'
  | 'hover:from-product-sunrise'
  | 'focus:from-product-sunrise'
  | 'sm:via-product-sunrise'
  | 'md:via-product-sunrise'
  | 'mg:via-product-sunrise'
  | 'lg:via-product-sunrise'
  | 'xl:via-product-sunrise'
  | 'hover:via-product-sunrise'
  | 'focus:via-product-sunrise'
  | 'sm:to-product-sunrise'
  | 'md:to-product-sunrise'
  | 'mg:to-product-sunrise'
  | 'lg:to-product-sunrise'
  | 'xl:to-product-sunrise'
  | 'hover:to-product-sunrise'
  | 'focus:to-product-sunrise'
  | 'sm:from-product-sunset'
  | 'md:from-product-sunset'
  | 'mg:from-product-sunset'
  | 'lg:from-product-sunset'
  | 'xl:from-product-sunset'
  | 'hover:from-product-sunset'
  | 'focus:from-product-sunset'
  | 'sm:via-product-sunset'
  | 'md:via-product-sunset'
  | 'mg:via-product-sunset'
  | 'lg:via-product-sunset'
  | 'xl:via-product-sunset'
  | 'hover:via-product-sunset'
  | 'focus:via-product-sunset'
  | 'sm:to-product-sunset'
  | 'md:to-product-sunset'
  | 'mg:to-product-sunset'
  | 'lg:to-product-sunset'
  | 'xl:to-product-sunset'
  | 'hover:to-product-sunset'
  | 'focus:to-product-sunset'
  | 'sm:from-product-sunset-marble'
  | 'md:from-product-sunset-marble'
  | 'mg:from-product-sunset-marble'
  | 'lg:from-product-sunset-marble'
  | 'xl:from-product-sunset-marble'
  | 'hover:from-product-sunset-marble'
  | 'focus:from-product-sunset-marble'
  | 'sm:via-product-sunset-marble'
  | 'md:via-product-sunset-marble'
  | 'mg:via-product-sunset-marble'
  | 'lg:via-product-sunset-marble'
  | 'xl:via-product-sunset-marble'
  | 'hover:via-product-sunset-marble'
  | 'focus:via-product-sunset-marble'
  | 'sm:to-product-sunset-marble'
  | 'md:to-product-sunset-marble'
  | 'mg:to-product-sunset-marble'
  | 'lg:to-product-sunset-marble'
  | 'xl:to-product-sunset-marble'
  | 'hover:to-product-sunset-marble'
  | 'focus:to-product-sunset-marble'
  | 'sm:from-product-terracotta'
  | 'md:from-product-terracotta'
  | 'mg:from-product-terracotta'
  | 'lg:from-product-terracotta'
  | 'xl:from-product-terracotta'
  | 'hover:from-product-terracotta'
  | 'focus:from-product-terracotta'
  | 'sm:via-product-terracotta'
  | 'md:via-product-terracotta'
  | 'mg:via-product-terracotta'
  | 'lg:via-product-terracotta'
  | 'xl:via-product-terracotta'
  | 'hover:via-product-terracotta'
  | 'focus:via-product-terracotta'
  | 'sm:to-product-terracotta'
  | 'md:to-product-terracotta'
  | 'mg:to-product-terracotta'
  | 'lg:to-product-terracotta'
  | 'xl:to-product-terracotta'
  | 'hover:to-product-terracotta'
  | 'focus:to-product-terracotta'
  | 'sm:from-product-tierra'
  | 'md:from-product-tierra'
  | 'mg:from-product-tierra'
  | 'lg:from-product-tierra'
  | 'xl:from-product-tierra'
  | 'hover:from-product-tierra'
  | 'focus:from-product-tierra'
  | 'sm:via-product-tierra'
  | 'md:via-product-tierra'
  | 'mg:via-product-tierra'
  | 'lg:via-product-tierra'
  | 'xl:via-product-tierra'
  | 'hover:via-product-tierra'
  | 'focus:via-product-tierra'
  | 'sm:to-product-tierra'
  | 'md:to-product-tierra'
  | 'mg:to-product-tierra'
  | 'lg:to-product-tierra'
  | 'xl:to-product-tierra'
  | 'hover:to-product-tierra'
  | 'focus:to-product-tierra'
  | 'sm:from-product-turmeric'
  | 'md:from-product-turmeric'
  | 'mg:from-product-turmeric'
  | 'lg:from-product-turmeric'
  | 'xl:from-product-turmeric'
  | 'hover:from-product-turmeric'
  | 'focus:from-product-turmeric'
  | 'sm:via-product-turmeric'
  | 'md:via-product-turmeric'
  | 'mg:via-product-turmeric'
  | 'lg:via-product-turmeric'
  | 'xl:via-product-turmeric'
  | 'hover:via-product-turmeric'
  | 'focus:via-product-turmeric'
  | 'sm:to-product-turmeric'
  | 'md:to-product-turmeric'
  | 'mg:to-product-turmeric'
  | 'lg:to-product-turmeric'
  | 'xl:to-product-turmeric'
  | 'hover:to-product-turmeric'
  | 'focus:to-product-turmeric'
  | 'sm:from-product-turqoise'
  | 'md:from-product-turqoise'
  | 'mg:from-product-turqoise'
  | 'lg:from-product-turqoise'
  | 'xl:from-product-turqoise'
  | 'hover:from-product-turqoise'
  | 'focus:from-product-turqoise'
  | 'sm:via-product-turqoise'
  | 'md:via-product-turqoise'
  | 'mg:via-product-turqoise'
  | 'lg:via-product-turqoise'
  | 'xl:via-product-turqoise'
  | 'hover:via-product-turqoise'
  | 'focus:via-product-turqoise'
  | 'sm:to-product-turqoise'
  | 'md:to-product-turqoise'
  | 'mg:to-product-turqoise'
  | 'lg:to-product-turqoise'
  | 'xl:to-product-turqoise'
  | 'hover:to-product-turqoise'
  | 'focus:to-product-turqoise'
  | 'sm:from-product-twilight'
  | 'md:from-product-twilight'
  | 'mg:from-product-twilight'
  | 'lg:from-product-twilight'
  | 'xl:from-product-twilight'
  | 'hover:from-product-twilight'
  | 'focus:from-product-twilight'
  | 'sm:via-product-twilight'
  | 'md:via-product-twilight'
  | 'mg:via-product-twilight'
  | 'lg:via-product-twilight'
  | 'xl:via-product-twilight'
  | 'hover:via-product-twilight'
  | 'focus:via-product-twilight'
  | 'sm:to-product-twilight'
  | 'md:to-product-twilight'
  | 'mg:to-product-twilight'
  | 'lg:to-product-twilight'
  | 'xl:to-product-twilight'
  | 'hover:to-product-twilight'
  | 'focus:to-product-twilight'
  | 'sm:from-product-walnut'
  | 'md:from-product-walnut'
  | 'mg:from-product-walnut'
  | 'lg:from-product-walnut'
  | 'xl:from-product-walnut'
  | 'hover:from-product-walnut'
  | 'focus:from-product-walnut'
  | 'sm:via-product-walnut'
  | 'md:via-product-walnut'
  | 'mg:via-product-walnut'
  | 'lg:via-product-walnut'
  | 'xl:via-product-walnut'
  | 'hover:via-product-walnut'
  | 'focus:via-product-walnut'
  | 'sm:to-product-walnut'
  | 'md:to-product-walnut'
  | 'mg:to-product-walnut'
  | 'lg:to-product-walnut'
  | 'xl:to-product-walnut'
  | 'hover:to-product-walnut'
  | 'focus:to-product-walnut'
  | 'sm:from-product-warm-white'
  | 'md:from-product-warm-white'
  | 'mg:from-product-warm-white'
  | 'lg:from-product-warm-white'
  | 'xl:from-product-warm-white'
  | 'hover:from-product-warm-white'
  | 'focus:from-product-warm-white'
  | 'sm:via-product-warm-white'
  | 'md:via-product-warm-white'
  | 'mg:via-product-warm-white'
  | 'lg:via-product-warm-white'
  | 'xl:via-product-warm-white'
  | 'hover:via-product-warm-white'
  | 'focus:via-product-warm-white'
  | 'sm:to-product-warm-white'
  | 'md:to-product-warm-white'
  | 'mg:to-product-warm-white'
  | 'lg:to-product-warm-white'
  | 'xl:to-product-warm-white'
  | 'hover:to-product-warm-white'
  | 'focus:to-product-warm-white'
  | 'sm:from-product-zest'
  | 'md:from-product-zest'
  | 'mg:from-product-zest'
  | 'lg:from-product-zest'
  | 'xl:from-product-zest'
  | 'hover:from-product-zest'
  | 'focus:from-product-zest'
  | 'sm:via-product-zest'
  | 'md:via-product-zest'
  | 'mg:via-product-zest'
  | 'lg:via-product-zest'
  | 'xl:via-product-zest'
  | 'hover:via-product-zest'
  | 'focus:via-product-zest'
  | 'sm:to-product-zest'
  | 'md:to-product-zest'
  | 'mg:to-product-zest'
  | 'lg:to-product-zest'
  | 'xl:to-product-zest'
  | 'hover:to-product-zest'
  | 'focus:to-product-zest'
  | 'sm:from-placeholder'
  | 'md:from-placeholder'
  | 'mg:from-placeholder'
  | 'lg:from-placeholder'
  | 'xl:from-placeholder'
  | 'hover:from-placeholder'
  | 'focus:from-placeholder'
  | 'sm:via-placeholder'
  | 'md:via-placeholder'
  | 'mg:via-placeholder'
  | 'lg:via-placeholder'
  | 'xl:via-placeholder'
  | 'hover:via-placeholder'
  | 'focus:via-placeholder'
  | 'sm:to-placeholder'
  | 'md:to-placeholder'
  | 'mg:to-placeholder'
  | 'lg:to-placeholder'
  | 'xl:to-placeholder'
  | 'hover:to-placeholder'
  | 'focus:to-placeholder'
  | 'sm:from-interactive-bone'
  | 'md:from-interactive-bone'
  | 'mg:from-interactive-bone'
  | 'lg:from-interactive-bone'
  | 'xl:from-interactive-bone'
  | 'hover:from-interactive-bone'
  | 'focus:from-interactive-bone'
  | 'sm:via-interactive-bone'
  | 'md:via-interactive-bone'
  | 'mg:via-interactive-bone'
  | 'lg:via-interactive-bone'
  | 'xl:via-interactive-bone'
  | 'hover:via-interactive-bone'
  | 'focus:via-interactive-bone'
  | 'sm:to-interactive-bone'
  | 'md:to-interactive-bone'
  | 'mg:to-interactive-bone'
  | 'lg:to-interactive-bone'
  | 'xl:to-interactive-bone'
  | 'hover:to-interactive-bone'
  | 'focus:to-interactive-bone'
  | 'sm:from-interactive-brick'
  | 'md:from-interactive-brick'
  | 'mg:from-interactive-brick'
  | 'lg:from-interactive-brick'
  | 'xl:from-interactive-brick'
  | 'hover:from-interactive-brick'
  | 'focus:from-interactive-brick'
  | 'sm:via-interactive-brick'
  | 'md:via-interactive-brick'
  | 'mg:via-interactive-brick'
  | 'lg:via-interactive-brick'
  | 'xl:via-interactive-brick'
  | 'hover:via-interactive-brick'
  | 'focus:via-interactive-brick'
  | 'sm:to-interactive-brick'
  | 'md:to-interactive-brick'
  | 'mg:to-interactive-brick'
  | 'lg:to-interactive-brick'
  | 'xl:to-interactive-brick'
  | 'hover:to-interactive-brick'
  | 'focus:to-interactive-brick'
  | 'sm:from-interactive-char'
  | 'md:from-interactive-char'
  | 'mg:from-interactive-char'
  | 'lg:from-interactive-char'
  | 'xl:from-interactive-char'
  | 'hover:from-interactive-char'
  | 'focus:from-interactive-char'
  | 'sm:via-interactive-char'
  | 'md:via-interactive-char'
  | 'mg:via-interactive-char'
  | 'lg:via-interactive-char'
  | 'xl:via-interactive-char'
  | 'hover:via-interactive-char'
  | 'focus:via-interactive-char'
  | 'sm:to-interactive-char'
  | 'md:to-interactive-char'
  | 'mg:to-interactive-char'
  | 'lg:to-interactive-char'
  | 'xl:to-interactive-char'
  | 'hover:to-interactive-char'
  | 'focus:to-interactive-char'
  | 'sm:from-interactive-white'
  | 'md:from-interactive-white'
  | 'mg:from-interactive-white'
  | 'lg:from-interactive-white'
  | 'xl:from-interactive-white'
  | 'hover:from-interactive-white'
  | 'focus:from-interactive-white'
  | 'sm:via-interactive-white'
  | 'md:via-interactive-white'
  | 'mg:via-interactive-white'
  | 'lg:via-interactive-white'
  | 'xl:via-interactive-white'
  | 'hover:via-interactive-white'
  | 'focus:via-interactive-white'
  | 'sm:to-interactive-white'
  | 'md:to-interactive-white'
  | 'mg:to-interactive-white'
  | 'lg:to-interactive-white'
  | 'xl:to-interactive-white'
  | 'hover:to-interactive-white'
  | 'focus:to-interactive-white'
  | 'sm:from-interactive-disabled'
  | 'md:from-interactive-disabled'
  | 'mg:from-interactive-disabled'
  | 'lg:from-interactive-disabled'
  | 'xl:from-interactive-disabled'
  | 'hover:from-interactive-disabled'
  | 'focus:from-interactive-disabled'
  | 'sm:via-interactive-disabled'
  | 'md:via-interactive-disabled'
  | 'mg:via-interactive-disabled'
  | 'lg:via-interactive-disabled'
  | 'xl:via-interactive-disabled'
  | 'hover:via-interactive-disabled'
  | 'focus:via-interactive-disabled'
  | 'sm:to-interactive-disabled'
  | 'md:to-interactive-disabled'
  | 'mg:to-interactive-disabled'
  | 'lg:to-interactive-disabled'
  | 'xl:to-interactive-disabled'
  | 'hover:to-interactive-disabled'
  | 'focus:to-interactive-disabled'
  | 'sm:from-interactive-error'
  | 'md:from-interactive-error'
  | 'mg:from-interactive-error'
  | 'lg:from-interactive-error'
  | 'xl:from-interactive-error'
  | 'hover:from-interactive-error'
  | 'focus:from-interactive-error'
  | 'sm:via-interactive-error'
  | 'md:via-interactive-error'
  | 'mg:via-interactive-error'
  | 'lg:via-interactive-error'
  | 'xl:via-interactive-error'
  | 'hover:via-interactive-error'
  | 'focus:via-interactive-error'
  | 'sm:to-interactive-error'
  | 'md:to-interactive-error'
  | 'mg:to-interactive-error'
  | 'lg:to-interactive-error'
  | 'xl:to-interactive-error'
  | 'hover:to-interactive-error'
  | 'focus:to-interactive-error'
  | 'sm:from-interactive-outline'
  | 'md:from-interactive-outline'
  | 'mg:from-interactive-outline'
  | 'lg:from-interactive-outline'
  | 'xl:from-interactive-outline'
  | 'hover:from-interactive-outline'
  | 'focus:from-interactive-outline'
  | 'sm:via-interactive-outline'
  | 'md:via-interactive-outline'
  | 'mg:via-interactive-outline'
  | 'lg:via-interactive-outline'
  | 'xl:via-interactive-outline'
  | 'hover:via-interactive-outline'
  | 'focus:via-interactive-outline'
  | 'sm:to-interactive-outline'
  | 'md:to-interactive-outline'
  | 'mg:to-interactive-outline'
  | 'lg:to-interactive-outline'
  | 'xl:to-interactive-outline'
  | 'hover:to-interactive-outline'
  | 'focus:to-interactive-outline'
  | 'sm:from-translucent-char'
  | 'md:from-translucent-char'
  | 'mg:from-translucent-char'
  | 'lg:from-translucent-char'
  | 'xl:from-translucent-char'
  | 'hover:from-translucent-char'
  | 'focus:from-translucent-char'
  | 'sm:via-translucent-char'
  | 'md:via-translucent-char'
  | 'mg:via-translucent-char'
  | 'lg:via-translucent-char'
  | 'xl:via-translucent-char'
  | 'hover:via-translucent-char'
  | 'focus:via-translucent-char'
  | 'sm:to-translucent-char'
  | 'md:to-translucent-char'
  | 'mg:to-translucent-char'
  | 'lg:to-translucent-char'
  | 'xl:to-translucent-char'
  | 'hover:to-translucent-char'
  | 'focus:to-translucent-char'
  | 'sm:from-translucent-white'
  | 'md:from-translucent-white'
  | 'mg:from-translucent-white'
  | 'lg:from-translucent-white'
  | 'xl:from-translucent-white'
  | 'hover:from-translucent-white'
  | 'focus:from-translucent-white'
  | 'sm:via-translucent-white'
  | 'md:via-translucent-white'
  | 'mg:via-translucent-white'
  | 'lg:via-translucent-white'
  | 'xl:via-translucent-white'
  | 'hover:via-translucent-white'
  | 'focus:via-translucent-white'
  | 'sm:to-translucent-white'
  | 'md:to-translucent-white'
  | 'mg:to-translucent-white'
  | 'lg:to-translucent-white'
  | 'xl:to-translucent-white'
  | 'hover:to-translucent-white'
  | 'focus:to-translucent-white'
  | 'sm:from-char-50'
  | 'md:from-char-50'
  | 'mg:from-char-50'
  | 'lg:from-char-50'
  | 'xl:from-char-50'
  | 'hover:from-char-50'
  | 'focus:from-char-50'
  | 'sm:via-char-50'
  | 'md:via-char-50'
  | 'mg:via-char-50'
  | 'lg:via-char-50'
  | 'xl:via-char-50'
  | 'hover:via-char-50'
  | 'focus:via-char-50'
  | 'sm:to-char-50'
  | 'md:to-char-50'
  | 'mg:to-char-50'
  | 'lg:to-char-50'
  | 'xl:to-char-50'
  | 'hover:to-char-50'
  | 'focus:to-char-50'
  | 'sm:from-char-100'
  | 'md:from-char-100'
  | 'mg:from-char-100'
  | 'lg:from-char-100'
  | 'xl:from-char-100'
  | 'hover:from-char-100'
  | 'focus:from-char-100'
  | 'sm:via-char-100'
  | 'md:via-char-100'
  | 'mg:via-char-100'
  | 'lg:via-char-100'
  | 'xl:via-char-100'
  | 'hover:via-char-100'
  | 'focus:via-char-100'
  | 'sm:to-char-100'
  | 'md:to-char-100'
  | 'mg:to-char-100'
  | 'lg:to-char-100'
  | 'xl:to-char-100'
  | 'hover:to-char-100'
  | 'focus:to-char-100'
  | 'sm:from-char-200'
  | 'md:from-char-200'
  | 'mg:from-char-200'
  | 'lg:from-char-200'
  | 'xl:from-char-200'
  | 'hover:from-char-200'
  | 'focus:from-char-200'
  | 'sm:via-char-200'
  | 'md:via-char-200'
  | 'mg:via-char-200'
  | 'lg:via-char-200'
  | 'xl:via-char-200'
  | 'hover:via-char-200'
  | 'focus:via-char-200'
  | 'sm:to-char-200'
  | 'md:to-char-200'
  | 'mg:to-char-200'
  | 'lg:to-char-200'
  | 'xl:to-char-200'
  | 'hover:to-char-200'
  | 'focus:to-char-200'
  | 'sm:from-char-300'
  | 'md:from-char-300'
  | 'mg:from-char-300'
  | 'lg:from-char-300'
  | 'xl:from-char-300'
  | 'hover:from-char-300'
  | 'focus:from-char-300'
  | 'sm:via-char-300'
  | 'md:via-char-300'
  | 'mg:via-char-300'
  | 'lg:via-char-300'
  | 'xl:via-char-300'
  | 'hover:via-char-300'
  | 'focus:via-char-300'
  | 'sm:to-char-300'
  | 'md:to-char-300'
  | 'mg:to-char-300'
  | 'lg:to-char-300'
  | 'xl:to-char-300'
  | 'hover:to-char-300'
  | 'focus:to-char-300'
  | 'sm:from-char-400'
  | 'md:from-char-400'
  | 'mg:from-char-400'
  | 'lg:from-char-400'
  | 'xl:from-char-400'
  | 'hover:from-char-400'
  | 'focus:from-char-400'
  | 'sm:via-char-400'
  | 'md:via-char-400'
  | 'mg:via-char-400'
  | 'lg:via-char-400'
  | 'xl:via-char-400'
  | 'hover:via-char-400'
  | 'focus:via-char-400'
  | 'sm:to-char-400'
  | 'md:to-char-400'
  | 'mg:to-char-400'
  | 'lg:to-char-400'
  | 'xl:to-char-400'
  | 'hover:to-char-400'
  | 'focus:to-char-400'
  | 'sm:from-char-500'
  | 'md:from-char-500'
  | 'mg:from-char-500'
  | 'lg:from-char-500'
  | 'xl:from-char-500'
  | 'hover:from-char-500'
  | 'focus:from-char-500'
  | 'sm:via-char-500'
  | 'md:via-char-500'
  | 'mg:via-char-500'
  | 'lg:via-char-500'
  | 'xl:via-char-500'
  | 'hover:via-char-500'
  | 'focus:via-char-500'
  | 'sm:to-char-500'
  | 'md:to-char-500'
  | 'mg:to-char-500'
  | 'lg:to-char-500'
  | 'xl:to-char-500'
  | 'hover:to-char-500'
  | 'focus:to-char-500'
  | 'sm:from-char-600'
  | 'md:from-char-600'
  | 'mg:from-char-600'
  | 'lg:from-char-600'
  | 'xl:from-char-600'
  | 'hover:from-char-600'
  | 'focus:from-char-600'
  | 'sm:via-char-600'
  | 'md:via-char-600'
  | 'mg:via-char-600'
  | 'lg:via-char-600'
  | 'xl:via-char-600'
  | 'hover:via-char-600'
  | 'focus:via-char-600'
  | 'sm:to-char-600'
  | 'md:to-char-600'
  | 'mg:to-char-600'
  | 'lg:to-char-600'
  | 'xl:to-char-600'
  | 'hover:to-char-600'
  | 'focus:to-char-600'
  | 'sm:from-char-700'
  | 'md:from-char-700'
  | 'mg:from-char-700'
  | 'lg:from-char-700'
  | 'xl:from-char-700'
  | 'hover:from-char-700'
  | 'focus:from-char-700'
  | 'sm:via-char-700'
  | 'md:via-char-700'
  | 'mg:via-char-700'
  | 'lg:via-char-700'
  | 'xl:via-char-700'
  | 'hover:via-char-700'
  | 'focus:via-char-700'
  | 'sm:to-char-700'
  | 'md:to-char-700'
  | 'mg:to-char-700'
  | 'lg:to-char-700'
  | 'xl:to-char-700'
  | 'hover:to-char-700'
  | 'focus:to-char-700'
  | 'sm:from-char-800'
  | 'md:from-char-800'
  | 'mg:from-char-800'
  | 'lg:from-char-800'
  | 'xl:from-char-800'
  | 'hover:from-char-800'
  | 'focus:from-char-800'
  | 'sm:via-char-800'
  | 'md:via-char-800'
  | 'mg:via-char-800'
  | 'lg:via-char-800'
  | 'xl:via-char-800'
  | 'hover:via-char-800'
  | 'focus:via-char-800'
  | 'sm:to-char-800'
  | 'md:to-char-800'
  | 'mg:to-char-800'
  | 'lg:to-char-800'
  | 'xl:to-char-800'
  | 'hover:to-char-800'
  | 'focus:to-char-800'
  | 'sm:from-char-900'
  | 'md:from-char-900'
  | 'mg:from-char-900'
  | 'lg:from-char-900'
  | 'xl:from-char-900'
  | 'hover:from-char-900'
  | 'focus:from-char-900'
  | 'sm:via-char-900'
  | 'md:via-char-900'
  | 'mg:via-char-900'
  | 'lg:via-char-900'
  | 'xl:via-char-900'
  | 'hover:via-char-900'
  | 'focus:via-char-900'
  | 'sm:to-char-900'
  | 'md:to-char-900'
  | 'mg:to-char-900'
  | 'lg:to-char-900'
  | 'xl:to-char-900'
  | 'hover:to-char-900'
  | 'focus:to-char-900'
  | 'sm:from-bone-50'
  | 'md:from-bone-50'
  | 'mg:from-bone-50'
  | 'lg:from-bone-50'
  | 'xl:from-bone-50'
  | 'hover:from-bone-50'
  | 'focus:from-bone-50'
  | 'sm:via-bone-50'
  | 'md:via-bone-50'
  | 'mg:via-bone-50'
  | 'lg:via-bone-50'
  | 'xl:via-bone-50'
  | 'hover:via-bone-50'
  | 'focus:via-bone-50'
  | 'sm:to-bone-50'
  | 'md:to-bone-50'
  | 'mg:to-bone-50'
  | 'lg:to-bone-50'
  | 'xl:to-bone-50'
  | 'hover:to-bone-50'
  | 'focus:to-bone-50'
  | 'sm:from-bone-100'
  | 'md:from-bone-100'
  | 'mg:from-bone-100'
  | 'lg:from-bone-100'
  | 'xl:from-bone-100'
  | 'hover:from-bone-100'
  | 'focus:from-bone-100'
  | 'sm:via-bone-100'
  | 'md:via-bone-100'
  | 'mg:via-bone-100'
  | 'lg:via-bone-100'
  | 'xl:via-bone-100'
  | 'hover:via-bone-100'
  | 'focus:via-bone-100'
  | 'sm:to-bone-100'
  | 'md:to-bone-100'
  | 'mg:to-bone-100'
  | 'lg:to-bone-100'
  | 'xl:to-bone-100'
  | 'hover:to-bone-100'
  | 'focus:to-bone-100'
  | 'sm:from-bone-200'
  | 'md:from-bone-200'
  | 'mg:from-bone-200'
  | 'lg:from-bone-200'
  | 'xl:from-bone-200'
  | 'hover:from-bone-200'
  | 'focus:from-bone-200'
  | 'sm:via-bone-200'
  | 'md:via-bone-200'
  | 'mg:via-bone-200'
  | 'lg:via-bone-200'
  | 'xl:via-bone-200'
  | 'hover:via-bone-200'
  | 'focus:via-bone-200'
  | 'sm:to-bone-200'
  | 'md:to-bone-200'
  | 'mg:to-bone-200'
  | 'lg:to-bone-200'
  | 'xl:to-bone-200'
  | 'hover:to-bone-200'
  | 'focus:to-bone-200'
  | 'sm:from-bone-300'
  | 'md:from-bone-300'
  | 'mg:from-bone-300'
  | 'lg:from-bone-300'
  | 'xl:from-bone-300'
  | 'hover:from-bone-300'
  | 'focus:from-bone-300'
  | 'sm:via-bone-300'
  | 'md:via-bone-300'
  | 'mg:via-bone-300'
  | 'lg:via-bone-300'
  | 'xl:via-bone-300'
  | 'hover:via-bone-300'
  | 'focus:via-bone-300'
  | 'sm:to-bone-300'
  | 'md:to-bone-300'
  | 'mg:to-bone-300'
  | 'lg:to-bone-300'
  | 'xl:to-bone-300'
  | 'hover:to-bone-300'
  | 'focus:to-bone-300'
  | 'sm:from-bone-400'
  | 'md:from-bone-400'
  | 'mg:from-bone-400'
  | 'lg:from-bone-400'
  | 'xl:from-bone-400'
  | 'hover:from-bone-400'
  | 'focus:from-bone-400'
  | 'sm:via-bone-400'
  | 'md:via-bone-400'
  | 'mg:via-bone-400'
  | 'lg:via-bone-400'
  | 'xl:via-bone-400'
  | 'hover:via-bone-400'
  | 'focus:via-bone-400'
  | 'sm:to-bone-400'
  | 'md:to-bone-400'
  | 'mg:to-bone-400'
  | 'lg:to-bone-400'
  | 'xl:to-bone-400'
  | 'hover:to-bone-400'
  | 'focus:to-bone-400'
  | 'sm:from-bone-500'
  | 'md:from-bone-500'
  | 'mg:from-bone-500'
  | 'lg:from-bone-500'
  | 'xl:from-bone-500'
  | 'hover:from-bone-500'
  | 'focus:from-bone-500'
  | 'sm:via-bone-500'
  | 'md:via-bone-500'
  | 'mg:via-bone-500'
  | 'lg:via-bone-500'
  | 'xl:via-bone-500'
  | 'hover:via-bone-500'
  | 'focus:via-bone-500'
  | 'sm:to-bone-500'
  | 'md:to-bone-500'
  | 'mg:to-bone-500'
  | 'lg:to-bone-500'
  | 'xl:to-bone-500'
  | 'hover:to-bone-500'
  | 'focus:to-bone-500'
  | 'sm:from-bone-600'
  | 'md:from-bone-600'
  | 'mg:from-bone-600'
  | 'lg:from-bone-600'
  | 'xl:from-bone-600'
  | 'hover:from-bone-600'
  | 'focus:from-bone-600'
  | 'sm:via-bone-600'
  | 'md:via-bone-600'
  | 'mg:via-bone-600'
  | 'lg:via-bone-600'
  | 'xl:via-bone-600'
  | 'hover:via-bone-600'
  | 'focus:via-bone-600'
  | 'sm:to-bone-600'
  | 'md:to-bone-600'
  | 'mg:to-bone-600'
  | 'lg:to-bone-600'
  | 'xl:to-bone-600'
  | 'hover:to-bone-600'
  | 'focus:to-bone-600'
  | 'sm:from-bone-700'
  | 'md:from-bone-700'
  | 'mg:from-bone-700'
  | 'lg:from-bone-700'
  | 'xl:from-bone-700'
  | 'hover:from-bone-700'
  | 'focus:from-bone-700'
  | 'sm:via-bone-700'
  | 'md:via-bone-700'
  | 'mg:via-bone-700'
  | 'lg:via-bone-700'
  | 'xl:via-bone-700'
  | 'hover:via-bone-700'
  | 'focus:via-bone-700'
  | 'sm:to-bone-700'
  | 'md:to-bone-700'
  | 'mg:to-bone-700'
  | 'lg:to-bone-700'
  | 'xl:to-bone-700'
  | 'hover:to-bone-700'
  | 'focus:to-bone-700'
  | 'sm:from-bone-800'
  | 'md:from-bone-800'
  | 'mg:from-bone-800'
  | 'lg:from-bone-800'
  | 'xl:from-bone-800'
  | 'hover:from-bone-800'
  | 'focus:from-bone-800'
  | 'sm:via-bone-800'
  | 'md:via-bone-800'
  | 'mg:via-bone-800'
  | 'lg:via-bone-800'
  | 'xl:via-bone-800'
  | 'hover:via-bone-800'
  | 'focus:via-bone-800'
  | 'sm:to-bone-800'
  | 'md:to-bone-800'
  | 'mg:to-bone-800'
  | 'lg:to-bone-800'
  | 'xl:to-bone-800'
  | 'hover:to-bone-800'
  | 'focus:to-bone-800'
  | 'sm:from-bone-900'
  | 'md:from-bone-900'
  | 'mg:from-bone-900'
  | 'lg:from-bone-900'
  | 'xl:from-bone-900'
  | 'hover:from-bone-900'
  | 'focus:from-bone-900'
  | 'sm:via-bone-900'
  | 'md:via-bone-900'
  | 'mg:via-bone-900'
  | 'lg:via-bone-900'
  | 'xl:via-bone-900'
  | 'hover:via-bone-900'
  | 'focus:via-bone-900'
  | 'sm:to-bone-900'
  | 'md:to-bone-900'
  | 'mg:to-bone-900'
  | 'lg:to-bone-900'
  | 'xl:to-bone-900'
  | 'hover:to-bone-900'
  | 'focus:to-bone-900'
  | 'sm:from-brick-50'
  | 'md:from-brick-50'
  | 'mg:from-brick-50'
  | 'lg:from-brick-50'
  | 'xl:from-brick-50'
  | 'hover:from-brick-50'
  | 'focus:from-brick-50'
  | 'sm:via-brick-50'
  | 'md:via-brick-50'
  | 'mg:via-brick-50'
  | 'lg:via-brick-50'
  | 'xl:via-brick-50'
  | 'hover:via-brick-50'
  | 'focus:via-brick-50'
  | 'sm:to-brick-50'
  | 'md:to-brick-50'
  | 'mg:to-brick-50'
  | 'lg:to-brick-50'
  | 'xl:to-brick-50'
  | 'hover:to-brick-50'
  | 'focus:to-brick-50'
  | 'sm:from-brick-300'
  | 'md:from-brick-300'
  | 'mg:from-brick-300'
  | 'lg:from-brick-300'
  | 'xl:from-brick-300'
  | 'hover:from-brick-300'
  | 'focus:from-brick-300'
  | 'sm:via-brick-300'
  | 'md:via-brick-300'
  | 'mg:via-brick-300'
  | 'lg:via-brick-300'
  | 'xl:via-brick-300'
  | 'hover:via-brick-300'
  | 'focus:via-brick-300'
  | 'sm:to-brick-300'
  | 'md:to-brick-300'
  | 'mg:to-brick-300'
  | 'lg:to-brick-300'
  | 'xl:to-brick-300'
  | 'hover:to-brick-300'
  | 'focus:to-brick-300'
  | 'sm:from-brick-500'
  | 'md:from-brick-500'
  | 'mg:from-brick-500'
  | 'lg:from-brick-500'
  | 'xl:from-brick-500'
  | 'hover:from-brick-500'
  | 'focus:from-brick-500'
  | 'sm:via-brick-500'
  | 'md:via-brick-500'
  | 'mg:via-brick-500'
  | 'lg:via-brick-500'
  | 'xl:via-brick-500'
  | 'hover:via-brick-500'
  | 'focus:via-brick-500'
  | 'sm:to-brick-500'
  | 'md:to-brick-500'
  | 'mg:to-brick-500'
  | 'lg:to-brick-500'
  | 'xl:to-brick-500'
  | 'hover:to-brick-500'
  | 'focus:to-brick-500'
  | 'sm:from-brick-700'
  | 'md:from-brick-700'
  | 'mg:from-brick-700'
  | 'lg:from-brick-700'
  | 'xl:from-brick-700'
  | 'hover:from-brick-700'
  | 'focus:from-brick-700'
  | 'sm:via-brick-700'
  | 'md:via-brick-700'
  | 'mg:via-brick-700'
  | 'lg:via-brick-700'
  | 'xl:via-brick-700'
  | 'hover:via-brick-700'
  | 'focus:via-brick-700'
  | 'sm:to-brick-700'
  | 'md:to-brick-700'
  | 'mg:to-brick-700'
  | 'lg:to-brick-700'
  | 'xl:to-brick-700'
  | 'hover:to-brick-700'
  | 'focus:to-brick-700'
  | 'sm:from-brick-900'
  | 'md:from-brick-900'
  | 'mg:from-brick-900'
  | 'lg:from-brick-900'
  | 'xl:from-brick-900'
  | 'hover:from-brick-900'
  | 'focus:from-brick-900'
  | 'sm:via-brick-900'
  | 'md:via-brick-900'
  | 'mg:via-brick-900'
  | 'lg:via-brick-900'
  | 'xl:via-brick-900'
  | 'hover:via-brick-900'
  | 'focus:via-brick-900'
  | 'sm:to-brick-900'
  | 'md:to-brick-900'
  | 'mg:to-brick-900'
  | 'lg:to-brick-900'
  | 'xl:to-brick-900'
  | 'hover:to-brick-900'
  | 'focus:to-brick-900'
  | 'sm:from-sage-50'
  | 'md:from-sage-50'
  | 'mg:from-sage-50'
  | 'lg:from-sage-50'
  | 'xl:from-sage-50'
  | 'hover:from-sage-50'
  | 'focus:from-sage-50'
  | 'sm:via-sage-50'
  | 'md:via-sage-50'
  | 'mg:via-sage-50'
  | 'lg:via-sage-50'
  | 'xl:via-sage-50'
  | 'hover:via-sage-50'
  | 'focus:via-sage-50'
  | 'sm:to-sage-50'
  | 'md:to-sage-50'
  | 'mg:to-sage-50'
  | 'lg:to-sage-50'
  | 'xl:to-sage-50'
  | 'hover:to-sage-50'
  | 'focus:to-sage-50'
  | 'sm:from-sage-300'
  | 'md:from-sage-300'
  | 'mg:from-sage-300'
  | 'lg:from-sage-300'
  | 'xl:from-sage-300'
  | 'hover:from-sage-300'
  | 'focus:from-sage-300'
  | 'sm:via-sage-300'
  | 'md:via-sage-300'
  | 'mg:via-sage-300'
  | 'lg:via-sage-300'
  | 'xl:via-sage-300'
  | 'hover:via-sage-300'
  | 'focus:via-sage-300'
  | 'sm:to-sage-300'
  | 'md:to-sage-300'
  | 'mg:to-sage-300'
  | 'lg:to-sage-300'
  | 'xl:to-sage-300'
  | 'hover:to-sage-300'
  | 'focus:to-sage-300'
  | 'sm:from-sage-500'
  | 'md:from-sage-500'
  | 'mg:from-sage-500'
  | 'lg:from-sage-500'
  | 'xl:from-sage-500'
  | 'hover:from-sage-500'
  | 'focus:from-sage-500'
  | 'sm:via-sage-500'
  | 'md:via-sage-500'
  | 'mg:via-sage-500'
  | 'lg:via-sage-500'
  | 'xl:via-sage-500'
  | 'hover:via-sage-500'
  | 'focus:via-sage-500'
  | 'sm:to-sage-500'
  | 'md:to-sage-500'
  | 'mg:to-sage-500'
  | 'lg:to-sage-500'
  | 'xl:to-sage-500'
  | 'hover:to-sage-500'
  | 'focus:to-sage-500'
  | 'sm:from-sage-700'
  | 'md:from-sage-700'
  | 'mg:from-sage-700'
  | 'lg:from-sage-700'
  | 'xl:from-sage-700'
  | 'hover:from-sage-700'
  | 'focus:from-sage-700'
  | 'sm:via-sage-700'
  | 'md:via-sage-700'
  | 'mg:via-sage-700'
  | 'lg:via-sage-700'
  | 'xl:via-sage-700'
  | 'hover:via-sage-700'
  | 'focus:via-sage-700'
  | 'sm:to-sage-700'
  | 'md:to-sage-700'
  | 'mg:to-sage-700'
  | 'lg:to-sage-700'
  | 'xl:to-sage-700'
  | 'hover:to-sage-700'
  | 'focus:to-sage-700'
  | 'sm:from-sage-900'
  | 'md:from-sage-900'
  | 'mg:from-sage-900'
  | 'lg:from-sage-900'
  | 'xl:from-sage-900'
  | 'hover:from-sage-900'
  | 'focus:from-sage-900'
  | 'sm:via-sage-900'
  | 'md:via-sage-900'
  | 'mg:via-sage-900'
  | 'lg:via-sage-900'
  | 'xl:via-sage-900'
  | 'hover:via-sage-900'
  | 'focus:via-sage-900'
  | 'sm:to-sage-900'
  | 'md:to-sage-900'
  | 'mg:to-sage-900'
  | 'lg:to-sage-900'
  | 'xl:to-sage-900'
  | 'hover:to-sage-900'
  | 'focus:to-sage-900'
  | 'sm:from-blue-50'
  | 'md:from-blue-50'
  | 'mg:from-blue-50'
  | 'lg:from-blue-50'
  | 'xl:from-blue-50'
  | 'hover:from-blue-50'
  | 'focus:from-blue-50'
  | 'sm:via-blue-50'
  | 'md:via-blue-50'
  | 'mg:via-blue-50'
  | 'lg:via-blue-50'
  | 'xl:via-blue-50'
  | 'hover:via-blue-50'
  | 'focus:via-blue-50'
  | 'sm:to-blue-50'
  | 'md:to-blue-50'
  | 'mg:to-blue-50'
  | 'lg:to-blue-50'
  | 'xl:to-blue-50'
  | 'hover:to-blue-50'
  | 'focus:to-blue-50'
  | 'sm:from-blue-300'
  | 'md:from-blue-300'
  | 'mg:from-blue-300'
  | 'lg:from-blue-300'
  | 'xl:from-blue-300'
  | 'hover:from-blue-300'
  | 'focus:from-blue-300'
  | 'sm:via-blue-300'
  | 'md:via-blue-300'
  | 'mg:via-blue-300'
  | 'lg:via-blue-300'
  | 'xl:via-blue-300'
  | 'hover:via-blue-300'
  | 'focus:via-blue-300'
  | 'sm:to-blue-300'
  | 'md:to-blue-300'
  | 'mg:to-blue-300'
  | 'lg:to-blue-300'
  | 'xl:to-blue-300'
  | 'hover:to-blue-300'
  | 'focus:to-blue-300'
  | 'sm:from-blue-500'
  | 'md:from-blue-500'
  | 'mg:from-blue-500'
  | 'lg:from-blue-500'
  | 'xl:from-blue-500'
  | 'hover:from-blue-500'
  | 'focus:from-blue-500'
  | 'sm:via-blue-500'
  | 'md:via-blue-500'
  | 'mg:via-blue-500'
  | 'lg:via-blue-500'
  | 'xl:via-blue-500'
  | 'hover:via-blue-500'
  | 'focus:via-blue-500'
  | 'sm:to-blue-500'
  | 'md:to-blue-500'
  | 'mg:to-blue-500'
  | 'lg:to-blue-500'
  | 'xl:to-blue-500'
  | 'hover:to-blue-500'
  | 'focus:to-blue-500'
  | 'sm:from-blue-700'
  | 'md:from-blue-700'
  | 'mg:from-blue-700'
  | 'lg:from-blue-700'
  | 'xl:from-blue-700'
  | 'hover:from-blue-700'
  | 'focus:from-blue-700'
  | 'sm:via-blue-700'
  | 'md:via-blue-700'
  | 'mg:via-blue-700'
  | 'lg:via-blue-700'
  | 'xl:via-blue-700'
  | 'hover:via-blue-700'
  | 'focus:via-blue-700'
  | 'sm:to-blue-700'
  | 'md:to-blue-700'
  | 'mg:to-blue-700'
  | 'lg:to-blue-700'
  | 'xl:to-blue-700'
  | 'hover:to-blue-700'
  | 'focus:to-blue-700'
  | 'sm:from-blue-900'
  | 'md:from-blue-900'
  | 'mg:from-blue-900'
  | 'lg:from-blue-900'
  | 'xl:from-blue-900'
  | 'hover:from-blue-900'
  | 'focus:from-blue-900'
  | 'sm:via-blue-900'
  | 'md:via-blue-900'
  | 'mg:via-blue-900'
  | 'lg:via-blue-900'
  | 'xl:via-blue-900'
  | 'hover:via-blue-900'
  | 'focus:via-blue-900'
  | 'sm:to-blue-900'
  | 'md:to-blue-900'
  | 'mg:to-blue-900'
  | 'lg:to-blue-900'
  | 'xl:to-blue-900'
  | 'hover:to-blue-900'
  | 'focus:to-blue-900'
  | 'sm:from-misc-bright-blue'
  | 'md:from-misc-bright-blue'
  | 'mg:from-misc-bright-blue'
  | 'lg:from-misc-bright-blue'
  | 'xl:from-misc-bright-blue'
  | 'hover:from-misc-bright-blue'
  | 'focus:from-misc-bright-blue'
  | 'sm:via-misc-bright-blue'
  | 'md:via-misc-bright-blue'
  | 'mg:via-misc-bright-blue'
  | 'lg:via-misc-bright-blue'
  | 'xl:via-misc-bright-blue'
  | 'hover:via-misc-bright-blue'
  | 'focus:via-misc-bright-blue'
  | 'sm:to-misc-bright-blue'
  | 'md:to-misc-bright-blue'
  | 'mg:to-misc-bright-blue'
  | 'lg:to-misc-bright-blue'
  | 'xl:to-misc-bright-blue'
  | 'hover:to-misc-bright-blue'
  | 'focus:to-misc-bright-blue'
  | 'sm:from-misc-focus'
  | 'md:from-misc-focus'
  | 'mg:from-misc-focus'
  | 'lg:from-misc-focus'
  | 'xl:from-misc-focus'
  | 'hover:from-misc-focus'
  | 'focus:from-misc-focus'
  | 'sm:via-misc-focus'
  | 'md:via-misc-focus'
  | 'mg:via-misc-focus'
  | 'lg:via-misc-focus'
  | 'xl:via-misc-focus'
  | 'hover:via-misc-focus'
  | 'focus:via-misc-focus'
  | 'sm:to-misc-focus'
  | 'md:to-misc-focus'
  | 'mg:to-misc-focus'
  | 'lg:to-misc-focus'
  | 'xl:to-misc-focus'
  | 'hover:to-misc-focus'
  | 'focus:to-misc-focus'
  | 'sm:from-misc-legal-blue'
  | 'md:from-misc-legal-blue'
  | 'mg:from-misc-legal-blue'
  | 'lg:from-misc-legal-blue'
  | 'xl:from-misc-legal-blue'
  | 'hover:from-misc-legal-blue'
  | 'focus:from-misc-legal-blue'
  | 'sm:via-misc-legal-blue'
  | 'md:via-misc-legal-blue'
  | 'mg:via-misc-legal-blue'
  | 'lg:via-misc-legal-blue'
  | 'xl:via-misc-legal-blue'
  | 'hover:via-misc-legal-blue'
  | 'focus:via-misc-legal-blue'
  | 'sm:to-misc-legal-blue'
  | 'md:to-misc-legal-blue'
  | 'mg:to-misc-legal-blue'
  | 'lg:to-misc-legal-blue'
  | 'xl:to-misc-legal-blue'
  | 'hover:to-misc-legal-blue'
  | 'focus:to-misc-legal-blue'
  | 'sm:from-misc-neutral'
  | 'md:from-misc-neutral'
  | 'mg:from-misc-neutral'
  | 'lg:from-misc-neutral'
  | 'xl:from-misc-neutral'
  | 'hover:from-misc-neutral'
  | 'focus:from-misc-neutral'
  | 'sm:via-misc-neutral'
  | 'md:via-misc-neutral'
  | 'mg:via-misc-neutral'
  | 'lg:via-misc-neutral'
  | 'xl:via-misc-neutral'
  | 'hover:via-misc-neutral'
  | 'focus:via-misc-neutral'
  | 'sm:to-misc-neutral'
  | 'md:to-misc-neutral'
  | 'mg:to-misc-neutral'
  | 'lg:to-misc-neutral'
  | 'xl:to-misc-neutral'
  | 'hover:to-misc-neutral'
  | 'focus:to-misc-neutral'
  | 'sm:from-misc-yellow-orange'
  | 'md:from-misc-yellow-orange'
  | 'mg:from-misc-yellow-orange'
  | 'lg:from-misc-yellow-orange'
  | 'xl:from-misc-yellow-orange'
  | 'hover:from-misc-yellow-orange'
  | 'focus:from-misc-yellow-orange'
  | 'sm:via-misc-yellow-orange'
  | 'md:via-misc-yellow-orange'
  | 'mg:via-misc-yellow-orange'
  | 'lg:via-misc-yellow-orange'
  | 'xl:via-misc-yellow-orange'
  | 'hover:via-misc-yellow-orange'
  | 'focus:via-misc-yellow-orange'
  | 'sm:to-misc-yellow-orange'
  | 'md:to-misc-yellow-orange'
  | 'mg:to-misc-yellow-orange'
  | 'lg:to-misc-yellow-orange'
  | 'xl:to-misc-yellow-orange'
  | 'hover:to-misc-yellow-orange'
  | 'focus:to-misc-yellow-orange'
  | 'sm:grayscale-0'
  | 'md:grayscale-0'
  | 'mg:grayscale-0'
  | 'lg:grayscale-0'
  | 'xl:grayscale-0'
  | 'sm:grayscale'
  | 'md:grayscale'
  | 'mg:grayscale'
  | 'lg:grayscale'
  | 'xl:grayscale'
  | 'sm:auto-cols-auto'
  | 'md:auto-cols-auto'
  | 'mg:auto-cols-auto'
  | 'lg:auto-cols-auto'
  | 'xl:auto-cols-auto'
  | 'sm:auto-cols-min'
  | 'md:auto-cols-min'
  | 'mg:auto-cols-min'
  | 'lg:auto-cols-min'
  | 'xl:auto-cols-min'
  | 'sm:auto-cols-max'
  | 'md:auto-cols-max'
  | 'mg:auto-cols-max'
  | 'lg:auto-cols-max'
  | 'xl:auto-cols-max'
  | 'sm:auto-cols-fr'
  | 'md:auto-cols-fr'
  | 'mg:auto-cols-fr'
  | 'lg:auto-cols-fr'
  | 'xl:auto-cols-fr'
  | 'sm:grid-flow-row'
  | 'md:grid-flow-row'
  | 'mg:grid-flow-row'
  | 'lg:grid-flow-row'
  | 'xl:grid-flow-row'
  | 'sm:grid-flow-col'
  | 'md:grid-flow-col'
  | 'mg:grid-flow-col'
  | 'lg:grid-flow-col'
  | 'xl:grid-flow-col'
  | 'sm:grid-flow-row-dense'
  | 'md:grid-flow-row-dense'
  | 'mg:grid-flow-row-dense'
  | 'lg:grid-flow-row-dense'
  | 'xl:grid-flow-row-dense'
  | 'sm:grid-flow-col-dense'
  | 'md:grid-flow-col-dense'
  | 'mg:grid-flow-col-dense'
  | 'lg:grid-flow-col-dense'
  | 'xl:grid-flow-col-dense'
  | 'sm:auto-rows-auto'
  | 'md:auto-rows-auto'
  | 'mg:auto-rows-auto'
  | 'lg:auto-rows-auto'
  | 'xl:auto-rows-auto'
  | 'sm:auto-rows-min'
  | 'md:auto-rows-min'
  | 'mg:auto-rows-min'
  | 'lg:auto-rows-min'
  | 'xl:auto-rows-min'
  | 'sm:auto-rows-max'
  | 'md:auto-rows-max'
  | 'mg:auto-rows-max'
  | 'lg:auto-rows-max'
  | 'xl:auto-rows-max'
  | 'sm:auto-rows-fr'
  | 'md:auto-rows-fr'
  | 'mg:auto-rows-fr'
  | 'lg:auto-rows-fr'
  | 'xl:auto-rows-fr'
  | 'sm:col-auto'
  | 'md:col-auto'
  | 'mg:col-auto'
  | 'lg:col-auto'
  | 'xl:col-auto'
  | 'sm:col-span-1'
  | 'md:col-span-1'
  | 'mg:col-span-1'
  | 'lg:col-span-1'
  | 'xl:col-span-1'
  | 'sm:col-span-2'
  | 'md:col-span-2'
  | 'mg:col-span-2'
  | 'lg:col-span-2'
  | 'xl:col-span-2'
  | 'sm:col-span-3'
  | 'md:col-span-3'
  | 'mg:col-span-3'
  | 'lg:col-span-3'
  | 'xl:col-span-3'
  | 'sm:col-span-4'
  | 'md:col-span-4'
  | 'mg:col-span-4'
  | 'lg:col-span-4'
  | 'xl:col-span-4'
  | 'sm:col-span-5'
  | 'md:col-span-5'
  | 'mg:col-span-5'
  | 'lg:col-span-5'
  | 'xl:col-span-5'
  | 'sm:col-span-6'
  | 'md:col-span-6'
  | 'mg:col-span-6'
  | 'lg:col-span-6'
  | 'xl:col-span-6'
  | 'sm:col-span-7'
  | 'md:col-span-7'
  | 'mg:col-span-7'
  | 'lg:col-span-7'
  | 'xl:col-span-7'
  | 'sm:col-span-8'
  | 'md:col-span-8'
  | 'mg:col-span-8'
  | 'lg:col-span-8'
  | 'xl:col-span-8'
  | 'sm:col-span-9'
  | 'md:col-span-9'
  | 'mg:col-span-9'
  | 'lg:col-span-9'
  | 'xl:col-span-9'
  | 'sm:col-span-10'
  | 'md:col-span-10'
  | 'mg:col-span-10'
  | 'lg:col-span-10'
  | 'xl:col-span-10'
  | 'sm:col-span-11'
  | 'md:col-span-11'
  | 'mg:col-span-11'
  | 'lg:col-span-11'
  | 'xl:col-span-11'
  | 'sm:col-span-12'
  | 'md:col-span-12'
  | 'mg:col-span-12'
  | 'lg:col-span-12'
  | 'xl:col-span-12'
  | 'sm:col-span-full'
  | 'md:col-span-full'
  | 'mg:col-span-full'
  | 'lg:col-span-full'
  | 'xl:col-span-full'
  | 'sm:col-end-1'
  | 'md:col-end-1'
  | 'mg:col-end-1'
  | 'lg:col-end-1'
  | 'xl:col-end-1'
  | 'sm:col-end-2'
  | 'md:col-end-2'
  | 'mg:col-end-2'
  | 'lg:col-end-2'
  | 'xl:col-end-2'
  | 'sm:col-end-3'
  | 'md:col-end-3'
  | 'mg:col-end-3'
  | 'lg:col-end-3'
  | 'xl:col-end-3'
  | 'sm:col-end-4'
  | 'md:col-end-4'
  | 'mg:col-end-4'
  | 'lg:col-end-4'
  | 'xl:col-end-4'
  | 'sm:col-end-5'
  | 'md:col-end-5'
  | 'mg:col-end-5'
  | 'lg:col-end-5'
  | 'xl:col-end-5'
  | 'sm:col-end-6'
  | 'md:col-end-6'
  | 'mg:col-end-6'
  | 'lg:col-end-6'
  | 'xl:col-end-6'
  | 'sm:col-end-7'
  | 'md:col-end-7'
  | 'mg:col-end-7'
  | 'lg:col-end-7'
  | 'xl:col-end-7'
  | 'sm:col-end-8'
  | 'md:col-end-8'
  | 'mg:col-end-8'
  | 'lg:col-end-8'
  | 'xl:col-end-8'
  | 'sm:col-end-9'
  | 'md:col-end-9'
  | 'mg:col-end-9'
  | 'lg:col-end-9'
  | 'xl:col-end-9'
  | 'sm:col-end-10'
  | 'md:col-end-10'
  | 'mg:col-end-10'
  | 'lg:col-end-10'
  | 'xl:col-end-10'
  | 'sm:col-end-11'
  | 'md:col-end-11'
  | 'mg:col-end-11'
  | 'lg:col-end-11'
  | 'xl:col-end-11'
  | 'sm:col-end-12'
  | 'md:col-end-12'
  | 'mg:col-end-12'
  | 'lg:col-end-12'
  | 'xl:col-end-12'
  | 'sm:col-end-13'
  | 'md:col-end-13'
  | 'mg:col-end-13'
  | 'lg:col-end-13'
  | 'xl:col-end-13'
  | 'sm:col-end-auto'
  | 'md:col-end-auto'
  | 'mg:col-end-auto'
  | 'lg:col-end-auto'
  | 'xl:col-end-auto'
  | 'sm:col-start-1'
  | 'md:col-start-1'
  | 'mg:col-start-1'
  | 'lg:col-start-1'
  | 'xl:col-start-1'
  | 'sm:col-start-2'
  | 'md:col-start-2'
  | 'mg:col-start-2'
  | 'lg:col-start-2'
  | 'xl:col-start-2'
  | 'sm:col-start-3'
  | 'md:col-start-3'
  | 'mg:col-start-3'
  | 'lg:col-start-3'
  | 'xl:col-start-3'
  | 'sm:col-start-4'
  | 'md:col-start-4'
  | 'mg:col-start-4'
  | 'lg:col-start-4'
  | 'xl:col-start-4'
  | 'sm:col-start-5'
  | 'md:col-start-5'
  | 'mg:col-start-5'
  | 'lg:col-start-5'
  | 'xl:col-start-5'
  | 'sm:col-start-6'
  | 'md:col-start-6'
  | 'mg:col-start-6'
  | 'lg:col-start-6'
  | 'xl:col-start-6'
  | 'sm:col-start-7'
  | 'md:col-start-7'
  | 'mg:col-start-7'
  | 'lg:col-start-7'
  | 'xl:col-start-7'
  | 'sm:col-start-8'
  | 'md:col-start-8'
  | 'mg:col-start-8'
  | 'lg:col-start-8'
  | 'xl:col-start-8'
  | 'sm:col-start-9'
  | 'md:col-start-9'
  | 'mg:col-start-9'
  | 'lg:col-start-9'
  | 'xl:col-start-9'
  | 'sm:col-start-10'
  | 'md:col-start-10'
  | 'mg:col-start-10'
  | 'lg:col-start-10'
  | 'xl:col-start-10'
  | 'sm:col-start-11'
  | 'md:col-start-11'
  | 'mg:col-start-11'
  | 'lg:col-start-11'
  | 'xl:col-start-11'
  | 'sm:col-start-12'
  | 'md:col-start-12'
  | 'mg:col-start-12'
  | 'lg:col-start-12'
  | 'xl:col-start-12'
  | 'sm:col-start-13'
  | 'md:col-start-13'
  | 'mg:col-start-13'
  | 'lg:col-start-13'
  | 'xl:col-start-13'
  | 'sm:col-start-auto'
  | 'md:col-start-auto'
  | 'mg:col-start-auto'
  | 'lg:col-start-auto'
  | 'xl:col-start-auto'
  | 'sm:row-auto'
  | 'md:row-auto'
  | 'mg:row-auto'
  | 'lg:row-auto'
  | 'xl:row-auto'
  | 'sm:row-span-1'
  | 'md:row-span-1'
  | 'mg:row-span-1'
  | 'lg:row-span-1'
  | 'xl:row-span-1'
  | 'sm:row-span-2'
  | 'md:row-span-2'
  | 'mg:row-span-2'
  | 'lg:row-span-2'
  | 'xl:row-span-2'
  | 'sm:row-span-3'
  | 'md:row-span-3'
  | 'mg:row-span-3'
  | 'lg:row-span-3'
  | 'xl:row-span-3'
  | 'sm:row-span-4'
  | 'md:row-span-4'
  | 'mg:row-span-4'
  | 'lg:row-span-4'
  | 'xl:row-span-4'
  | 'sm:row-span-5'
  | 'md:row-span-5'
  | 'mg:row-span-5'
  | 'lg:row-span-5'
  | 'xl:row-span-5'
  | 'sm:row-span-6'
  | 'md:row-span-6'
  | 'mg:row-span-6'
  | 'lg:row-span-6'
  | 'xl:row-span-6'
  | 'sm:row-span-full'
  | 'md:row-span-full'
  | 'mg:row-span-full'
  | 'lg:row-span-full'
  | 'xl:row-span-full'
  | 'sm:row-end-1'
  | 'md:row-end-1'
  | 'mg:row-end-1'
  | 'lg:row-end-1'
  | 'xl:row-end-1'
  | 'sm:row-end-2'
  | 'md:row-end-2'
  | 'mg:row-end-2'
  | 'lg:row-end-2'
  | 'xl:row-end-2'
  | 'sm:row-end-3'
  | 'md:row-end-3'
  | 'mg:row-end-3'
  | 'lg:row-end-3'
  | 'xl:row-end-3'
  | 'sm:row-end-4'
  | 'md:row-end-4'
  | 'mg:row-end-4'
  | 'lg:row-end-4'
  | 'xl:row-end-4'
  | 'sm:row-end-5'
  | 'md:row-end-5'
  | 'mg:row-end-5'
  | 'lg:row-end-5'
  | 'xl:row-end-5'
  | 'sm:row-end-6'
  | 'md:row-end-6'
  | 'mg:row-end-6'
  | 'lg:row-end-6'
  | 'xl:row-end-6'
  | 'sm:row-end-7'
  | 'md:row-end-7'
  | 'mg:row-end-7'
  | 'lg:row-end-7'
  | 'xl:row-end-7'
  | 'sm:row-end-auto'
  | 'md:row-end-auto'
  | 'mg:row-end-auto'
  | 'lg:row-end-auto'
  | 'xl:row-end-auto'
  | 'sm:row-start-1'
  | 'md:row-start-1'
  | 'mg:row-start-1'
  | 'lg:row-start-1'
  | 'xl:row-start-1'
  | 'sm:row-start-2'
  | 'md:row-start-2'
  | 'mg:row-start-2'
  | 'lg:row-start-2'
  | 'xl:row-start-2'
  | 'sm:row-start-3'
  | 'md:row-start-3'
  | 'mg:row-start-3'
  | 'lg:row-start-3'
  | 'xl:row-start-3'
  | 'sm:row-start-4'
  | 'md:row-start-4'
  | 'mg:row-start-4'
  | 'lg:row-start-4'
  | 'xl:row-start-4'
  | 'sm:row-start-5'
  | 'md:row-start-5'
  | 'mg:row-start-5'
  | 'lg:row-start-5'
  | 'xl:row-start-5'
  | 'sm:row-start-6'
  | 'md:row-start-6'
  | 'mg:row-start-6'
  | 'lg:row-start-6'
  | 'xl:row-start-6'
  | 'sm:row-start-7'
  | 'md:row-start-7'
  | 'mg:row-start-7'
  | 'lg:row-start-7'
  | 'xl:row-start-7'
  | 'sm:row-start-auto'
  | 'md:row-start-auto'
  | 'mg:row-start-auto'
  | 'lg:row-start-auto'
  | 'xl:row-start-auto'
  | 'sm:grid-cols-1'
  | 'md:grid-cols-1'
  | 'mg:grid-cols-1'
  | 'lg:grid-cols-1'
  | 'xl:grid-cols-1'
  | 'sm:grid-cols-2'
  | 'md:grid-cols-2'
  | 'mg:grid-cols-2'
  | 'lg:grid-cols-2'
  | 'xl:grid-cols-2'
  | 'sm:grid-cols-3'
  | 'md:grid-cols-3'
  | 'mg:grid-cols-3'
  | 'lg:grid-cols-3'
  | 'xl:grid-cols-3'
  | 'sm:grid-cols-4'
  | 'md:grid-cols-4'
  | 'mg:grid-cols-4'
  | 'lg:grid-cols-4'
  | 'xl:grid-cols-4'
  | 'sm:grid-cols-5'
  | 'md:grid-cols-5'
  | 'mg:grid-cols-5'
  | 'lg:grid-cols-5'
  | 'xl:grid-cols-5'
  | 'sm:grid-cols-6'
  | 'md:grid-cols-6'
  | 'mg:grid-cols-6'
  | 'lg:grid-cols-6'
  | 'xl:grid-cols-6'
  | 'sm:grid-cols-7'
  | 'md:grid-cols-7'
  | 'mg:grid-cols-7'
  | 'lg:grid-cols-7'
  | 'xl:grid-cols-7'
  | 'sm:grid-cols-8'
  | 'md:grid-cols-8'
  | 'mg:grid-cols-8'
  | 'lg:grid-cols-8'
  | 'xl:grid-cols-8'
  | 'sm:grid-cols-9'
  | 'md:grid-cols-9'
  | 'mg:grid-cols-9'
  | 'lg:grid-cols-9'
  | 'xl:grid-cols-9'
  | 'sm:grid-cols-10'
  | 'md:grid-cols-10'
  | 'mg:grid-cols-10'
  | 'lg:grid-cols-10'
  | 'xl:grid-cols-10'
  | 'sm:grid-cols-11'
  | 'md:grid-cols-11'
  | 'mg:grid-cols-11'
  | 'lg:grid-cols-11'
  | 'xl:grid-cols-11'
  | 'sm:grid-cols-12'
  | 'md:grid-cols-12'
  | 'mg:grid-cols-12'
  | 'lg:grid-cols-12'
  | 'xl:grid-cols-12'
  | 'sm:grid-cols-none'
  | 'md:grid-cols-none'
  | 'mg:grid-cols-none'
  | 'lg:grid-cols-none'
  | 'xl:grid-cols-none'
  | 'sm:grid-rows-1'
  | 'md:grid-rows-1'
  | 'mg:grid-rows-1'
  | 'lg:grid-rows-1'
  | 'xl:grid-rows-1'
  | 'sm:grid-rows-2'
  | 'md:grid-rows-2'
  | 'mg:grid-rows-2'
  | 'lg:grid-rows-2'
  | 'xl:grid-rows-2'
  | 'sm:grid-rows-3'
  | 'md:grid-rows-3'
  | 'mg:grid-rows-3'
  | 'lg:grid-rows-3'
  | 'xl:grid-rows-3'
  | 'sm:grid-rows-4'
  | 'md:grid-rows-4'
  | 'mg:grid-rows-4'
  | 'lg:grid-rows-4'
  | 'xl:grid-rows-4'
  | 'sm:grid-rows-5'
  | 'md:grid-rows-5'
  | 'mg:grid-rows-5'
  | 'lg:grid-rows-5'
  | 'xl:grid-rows-5'
  | 'sm:grid-rows-6'
  | 'md:grid-rows-6'
  | 'mg:grid-rows-6'
  | 'lg:grid-rows-6'
  | 'xl:grid-rows-6'
  | 'sm:grid-rows-none'
  | 'md:grid-rows-none'
  | 'mg:grid-rows-none'
  | 'lg:grid-rows-none'
  | 'xl:grid-rows-none'
  | 'sm:grid-rows-collapse'
  | 'md:grid-rows-collapse'
  | 'mg:grid-rows-collapse'
  | 'lg:grid-rows-collapse'
  | 'xl:grid-rows-collapse'
  | 'sm:grid-rows-expand'
  | 'md:grid-rows-expand'
  | 'mg:grid-rows-expand'
  | 'lg:grid-rows-expand'
  | 'xl:grid-rows-expand'
  | 'sm:h-0'
  | 'md:h-0'
  | 'mg:h-0'
  | 'lg:h-0'
  | 'xl:h-0'
  | 'sm:h-1'
  | 'md:h-1'
  | 'mg:h-1'
  | 'lg:h-1'
  | 'xl:h-1'
  | 'sm:h-2'
  | 'md:h-2'
  | 'mg:h-2'
  | 'lg:h-2'
  | 'xl:h-2'
  | 'sm:h-3'
  | 'md:h-3'
  | 'mg:h-3'
  | 'lg:h-3'
  | 'xl:h-3'
  | 'sm:h-4'
  | 'md:h-4'
  | 'mg:h-4'
  | 'lg:h-4'
  | 'xl:h-4'
  | 'sm:h-5'
  | 'md:h-5'
  | 'mg:h-5'
  | 'lg:h-5'
  | 'xl:h-5'
  | 'sm:h-6'
  | 'md:h-6'
  | 'mg:h-6'
  | 'lg:h-6'
  | 'xl:h-6'
  | 'sm:h-7'
  | 'md:h-7'
  | 'mg:h-7'
  | 'lg:h-7'
  | 'xl:h-7'
  | 'sm:h-8'
  | 'md:h-8'
  | 'mg:h-8'
  | 'lg:h-8'
  | 'xl:h-8'
  | 'sm:h-9'
  | 'md:h-9'
  | 'mg:h-9'
  | 'lg:h-9'
  | 'xl:h-9'
  | 'sm:h-10'
  | 'md:h-10'
  | 'mg:h-10'
  | 'lg:h-10'
  | 'xl:h-10'
  | 'sm:h-11'
  | 'md:h-11'
  | 'mg:h-11'
  | 'lg:h-11'
  | 'xl:h-11'
  | 'sm:h-12'
  | 'md:h-12'
  | 'mg:h-12'
  | 'lg:h-12'
  | 'xl:h-12'
  | 'sm:h-14'
  | 'md:h-14'
  | 'mg:h-14'
  | 'lg:h-14'
  | 'xl:h-14'
  | 'sm:h-15'
  | 'md:h-15'
  | 'mg:h-15'
  | 'lg:h-15'
  | 'xl:h-15'
  | 'sm:h-16'
  | 'md:h-16'
  | 'mg:h-16'
  | 'lg:h-16'
  | 'xl:h-16'
  | 'sm:h-17'
  | 'md:h-17'
  | 'mg:h-17'
  | 'lg:h-17'
  | 'xl:h-17'
  | 'sm:h-18'
  | 'md:h-18'
  | 'mg:h-18'
  | 'lg:h-18'
  | 'xl:h-18'
  | 'sm:h-20'
  | 'md:h-20'
  | 'mg:h-20'
  | 'lg:h-20'
  | 'xl:h-20'
  | 'sm:h-21'
  | 'md:h-21'
  | 'mg:h-21'
  | 'lg:h-21'
  | 'xl:h-21'
  | 'sm:h-22'
  | 'md:h-22'
  | 'mg:h-22'
  | 'lg:h-22'
  | 'xl:h-22'
  | 'sm:h-24'
  | 'md:h-24'
  | 'mg:h-24'
  | 'lg:h-24'
  | 'xl:h-24'
  | 'sm:h-28'
  | 'md:h-28'
  | 'mg:h-28'
  | 'lg:h-28'
  | 'xl:h-28'
  | 'sm:h-30'
  | 'md:h-30'
  | 'mg:h-30'
  | 'lg:h-30'
  | 'xl:h-30'
  | 'sm:h-32'
  | 'md:h-32'
  | 'mg:h-32'
  | 'lg:h-32'
  | 'xl:h-32'
  | 'sm:h-36'
  | 'md:h-36'
  | 'mg:h-36'
  | 'lg:h-36'
  | 'xl:h-36'
  | 'sm:h-40'
  | 'md:h-40'
  | 'mg:h-40'
  | 'lg:h-40'
  | 'xl:h-40'
  | 'sm:h-44'
  | 'md:h-44'
  | 'mg:h-44'
  | 'lg:h-44'
  | 'xl:h-44'
  | 'sm:h-48'
  | 'md:h-48'
  | 'mg:h-48'
  | 'lg:h-48'
  | 'xl:h-48'
  | 'sm:h-52'
  | 'md:h-52'
  | 'mg:h-52'
  | 'lg:h-52'
  | 'xl:h-52'
  | 'sm:h-56'
  | 'md:h-56'
  | 'mg:h-56'
  | 'lg:h-56'
  | 'xl:h-56'
  | 'sm:h-60'
  | 'md:h-60'
  | 'mg:h-60'
  | 'lg:h-60'
  | 'xl:h-60'
  | 'sm:h-64'
  | 'md:h-64'
  | 'mg:h-64'
  | 'lg:h-64'
  | 'xl:h-64'
  | 'sm:h-72'
  | 'md:h-72'
  | 'mg:h-72'
  | 'lg:h-72'
  | 'xl:h-72'
  | 'sm:h-80'
  | 'md:h-80'
  | 'mg:h-80'
  | 'lg:h-80'
  | 'xl:h-80'
  | 'sm:h-96'
  | 'md:h-96'
  | 'mg:h-96'
  | 'lg:h-96'
  | 'xl:h-96'
  | 'sm:h-auto'
  | 'md:h-auto'
  | 'mg:h-auto'
  | 'lg:h-auto'
  | 'xl:h-auto'
  | 'sm:h-px'
  | 'md:h-px'
  | 'mg:h-px'
  | 'lg:h-px'
  | 'xl:h-px'
  | 'sm:h-0.5'
  | 'md:h-0.5'
  | 'mg:h-0.5'
  | 'lg:h-0.5'
  | 'xl:h-0.5'
  | 'sm:h-1.5'
  | 'md:h-1.5'
  | 'mg:h-1.5'
  | 'lg:h-1.5'
  | 'xl:h-1.5'
  | 'sm:h-2.5'
  | 'md:h-2.5'
  | 'mg:h-2.5'
  | 'lg:h-2.5'
  | 'xl:h-2.5'
  | 'sm:h-3.5'
  | 'md:h-3.5'
  | 'mg:h-3.5'
  | 'lg:h-3.5'
  | 'xl:h-3.5'
  | 'sm:h-1/2'
  | 'md:h-1/2'
  | 'mg:h-1/2'
  | 'lg:h-1/2'
  | 'xl:h-1/2'
  | 'sm:h-1/3'
  | 'md:h-1/3'
  | 'mg:h-1/3'
  | 'lg:h-1/3'
  | 'xl:h-1/3'
  | 'sm:h-2/3'
  | 'md:h-2/3'
  | 'mg:h-2/3'
  | 'lg:h-2/3'
  | 'xl:h-2/3'
  | 'sm:h-1/4'
  | 'md:h-1/4'
  | 'mg:h-1/4'
  | 'lg:h-1/4'
  | 'xl:h-1/4'
  | 'sm:h-2/4'
  | 'md:h-2/4'
  | 'mg:h-2/4'
  | 'lg:h-2/4'
  | 'xl:h-2/4'
  | 'sm:h-3/4'
  | 'md:h-3/4'
  | 'mg:h-3/4'
  | 'lg:h-3/4'
  | 'xl:h-3/4'
  | 'sm:h-1/5'
  | 'md:h-1/5'
  | 'mg:h-1/5'
  | 'lg:h-1/5'
  | 'xl:h-1/5'
  | 'sm:h-2/5'
  | 'md:h-2/5'
  | 'mg:h-2/5'
  | 'lg:h-2/5'
  | 'xl:h-2/5'
  | 'sm:h-3/5'
  | 'md:h-3/5'
  | 'mg:h-3/5'
  | 'lg:h-3/5'
  | 'xl:h-3/5'
  | 'sm:h-4/5'
  | 'md:h-4/5'
  | 'mg:h-4/5'
  | 'lg:h-4/5'
  | 'xl:h-4/5'
  | 'sm:h-1/6'
  | 'md:h-1/6'
  | 'mg:h-1/6'
  | 'lg:h-1/6'
  | 'xl:h-1/6'
  | 'sm:h-2/6'
  | 'md:h-2/6'
  | 'mg:h-2/6'
  | 'lg:h-2/6'
  | 'xl:h-2/6'
  | 'sm:h-3/6'
  | 'md:h-3/6'
  | 'mg:h-3/6'
  | 'lg:h-3/6'
  | 'xl:h-3/6'
  | 'sm:h-4/6'
  | 'md:h-4/6'
  | 'mg:h-4/6'
  | 'lg:h-4/6'
  | 'xl:h-4/6'
  | 'sm:h-5/6'
  | 'md:h-5/6'
  | 'mg:h-5/6'
  | 'lg:h-5/6'
  | 'xl:h-5/6'
  | 'sm:h-full'
  | 'md:h-full'
  | 'mg:h-full'
  | 'lg:h-full'
  | 'xl:h-full'
  | 'sm:h-screen'
  | 'md:h-screen'
  | 'mg:h-screen'
  | 'lg:h-screen'
  | 'xl:h-screen'
  | 'sm:h-dynamic-screen'
  | 'md:h-dynamic-screen'
  | 'mg:h-dynamic-screen'
  | 'lg:h-dynamic-screen'
  | 'xl:h-dynamic-screen'
  | 'sm:h-tiny-swatch'
  | 'md:h-tiny-swatch'
  | 'mg:h-tiny-swatch'
  | 'lg:h-tiny-swatch'
  | 'xl:h-tiny-swatch'
  | 'sm:h-mini-swatch'
  | 'md:h-mini-swatch'
  | 'mg:h-mini-swatch'
  | 'lg:h-mini-swatch'
  | 'xl:h-mini-swatch'
  | 'sm:h-swatch'
  | 'md:h-swatch'
  | 'mg:h-swatch'
  | 'lg:h-swatch'
  | 'xl:h-swatch'
  | 'sm:h-4.5'
  | 'md:h-4.5'
  | 'mg:h-4.5'
  | 'lg:h-4.5'
  | 'xl:h-4.5'
  | 'sm:h-7.5'
  | 'md:h-7.5'
  | 'mg:h-7.5'
  | 'lg:h-7.5'
  | 'xl:h-7.5'
  | 'sm:h-9.5'
  | 'md:h-9.5'
  | 'mg:h-9.5'
  | 'lg:h-9.5'
  | 'xl:h-9.5'
  | 'sm:h-11.5'
  | 'md:h-11.5'
  | 'mg:h-11.5'
  | 'lg:h-11.5'
  | 'xl:h-11.5'
  | 'sm:hue-rotate-0'
  | 'md:hue-rotate-0'
  | 'mg:hue-rotate-0'
  | 'lg:hue-rotate-0'
  | 'xl:hue-rotate-0'
  | 'sm:hue-rotate-15'
  | 'md:hue-rotate-15'
  | 'mg:hue-rotate-15'
  | 'lg:hue-rotate-15'
  | 'xl:hue-rotate-15'
  | 'sm:hue-rotate-30'
  | 'md:hue-rotate-30'
  | 'mg:hue-rotate-30'
  | 'lg:hue-rotate-30'
  | 'xl:hue-rotate-30'
  | 'sm:hue-rotate-60'
  | 'md:hue-rotate-60'
  | 'mg:hue-rotate-60'
  | 'lg:hue-rotate-60'
  | 'xl:hue-rotate-60'
  | 'sm:hue-rotate-90'
  | 'md:hue-rotate-90'
  | 'mg:hue-rotate-90'
  | 'lg:hue-rotate-90'
  | 'xl:hue-rotate-90'
  | 'sm:hue-rotate-180'
  | 'md:hue-rotate-180'
  | 'mg:hue-rotate-180'
  | 'lg:hue-rotate-180'
  | 'xl:hue-rotate-180'
  | 'sm:-hue-rotate-180'
  | 'md:-hue-rotate-180'
  | 'mg:-hue-rotate-180'
  | 'lg:-hue-rotate-180'
  | 'xl:-hue-rotate-180'
  | 'sm:-hue-rotate-90'
  | 'md:-hue-rotate-90'
  | 'mg:-hue-rotate-90'
  | 'lg:-hue-rotate-90'
  | 'xl:-hue-rotate-90'
  | 'sm:-hue-rotate-60'
  | 'md:-hue-rotate-60'
  | 'mg:-hue-rotate-60'
  | 'lg:-hue-rotate-60'
  | 'xl:-hue-rotate-60'
  | 'sm:-hue-rotate-30'
  | 'md:-hue-rotate-30'
  | 'mg:-hue-rotate-30'
  | 'lg:-hue-rotate-30'
  | 'xl:-hue-rotate-30'
  | 'sm:-hue-rotate-15'
  | 'md:-hue-rotate-15'
  | 'mg:-hue-rotate-15'
  | 'lg:-hue-rotate-15'
  | 'xl:-hue-rotate-15'
  | 'sm:inset-0'
  | 'md:inset-0'
  | 'mg:inset-0'
  | 'lg:inset-0'
  | 'xl:inset-0'
  | 'sm:inset-x-0'
  | 'md:inset-x-0'
  | 'mg:inset-x-0'
  | 'lg:inset-x-0'
  | 'xl:inset-x-0'
  | 'sm:inset-y-0'
  | 'md:inset-y-0'
  | 'mg:inset-y-0'
  | 'lg:inset-y-0'
  | 'xl:inset-y-0'
  | 'sm:top-0'
  | 'md:top-0'
  | 'mg:top-0'
  | 'lg:top-0'
  | 'xl:top-0'
  | 'sm:right-0'
  | 'md:right-0'
  | 'mg:right-0'
  | 'lg:right-0'
  | 'xl:right-0'
  | 'sm:bottom-0'
  | 'md:bottom-0'
  | 'mg:bottom-0'
  | 'lg:bottom-0'
  | 'xl:bottom-0'
  | 'sm:left-0'
  | 'md:left-0'
  | 'mg:left-0'
  | 'lg:left-0'
  | 'xl:left-0'
  | 'sm:inset-1'
  | 'md:inset-1'
  | 'mg:inset-1'
  | 'lg:inset-1'
  | 'xl:inset-1'
  | 'sm:inset-x-1'
  | 'md:inset-x-1'
  | 'mg:inset-x-1'
  | 'lg:inset-x-1'
  | 'xl:inset-x-1'
  | 'sm:inset-y-1'
  | 'md:inset-y-1'
  | 'mg:inset-y-1'
  | 'lg:inset-y-1'
  | 'xl:inset-y-1'
  | 'sm:top-1'
  | 'md:top-1'
  | 'mg:top-1'
  | 'lg:top-1'
  | 'xl:top-1'
  | 'sm:right-1'
  | 'md:right-1'
  | 'mg:right-1'
  | 'lg:right-1'
  | 'xl:right-1'
  | 'sm:bottom-1'
  | 'md:bottom-1'
  | 'mg:bottom-1'
  | 'lg:bottom-1'
  | 'xl:bottom-1'
  | 'sm:left-1'
  | 'md:left-1'
  | 'mg:left-1'
  | 'lg:left-1'
  | 'xl:left-1'
  | 'sm:inset-2'
  | 'md:inset-2'
  | 'mg:inset-2'
  | 'lg:inset-2'
  | 'xl:inset-2'
  | 'sm:inset-x-2'
  | 'md:inset-x-2'
  | 'mg:inset-x-2'
  | 'lg:inset-x-2'
  | 'xl:inset-x-2'
  | 'sm:inset-y-2'
  | 'md:inset-y-2'
  | 'mg:inset-y-2'
  | 'lg:inset-y-2'
  | 'xl:inset-y-2'
  | 'sm:top-2'
  | 'md:top-2'
  | 'mg:top-2'
  | 'lg:top-2'
  | 'xl:top-2'
  | 'sm:right-2'
  | 'md:right-2'
  | 'mg:right-2'
  | 'lg:right-2'
  | 'xl:right-2'
  | 'sm:bottom-2'
  | 'md:bottom-2'
  | 'mg:bottom-2'
  | 'lg:bottom-2'
  | 'xl:bottom-2'
  | 'sm:left-2'
  | 'md:left-2'
  | 'mg:left-2'
  | 'lg:left-2'
  | 'xl:left-2'
  | 'sm:inset-3'
  | 'md:inset-3'
  | 'mg:inset-3'
  | 'lg:inset-3'
  | 'xl:inset-3'
  | 'sm:inset-x-3'
  | 'md:inset-x-3'
  | 'mg:inset-x-3'
  | 'lg:inset-x-3'
  | 'xl:inset-x-3'
  | 'sm:inset-y-3'
  | 'md:inset-y-3'
  | 'mg:inset-y-3'
  | 'lg:inset-y-3'
  | 'xl:inset-y-3'
  | 'sm:top-3'
  | 'md:top-3'
  | 'mg:top-3'
  | 'lg:top-3'
  | 'xl:top-3'
  | 'sm:right-3'
  | 'md:right-3'
  | 'mg:right-3'
  | 'lg:right-3'
  | 'xl:right-3'
  | 'sm:bottom-3'
  | 'md:bottom-3'
  | 'mg:bottom-3'
  | 'lg:bottom-3'
  | 'xl:bottom-3'
  | 'sm:left-3'
  | 'md:left-3'
  | 'mg:left-3'
  | 'lg:left-3'
  | 'xl:left-3'
  | 'sm:inset-4'
  | 'md:inset-4'
  | 'mg:inset-4'
  | 'lg:inset-4'
  | 'xl:inset-4'
  | 'sm:inset-x-4'
  | 'md:inset-x-4'
  | 'mg:inset-x-4'
  | 'lg:inset-x-4'
  | 'xl:inset-x-4'
  | 'sm:inset-y-4'
  | 'md:inset-y-4'
  | 'mg:inset-y-4'
  | 'lg:inset-y-4'
  | 'xl:inset-y-4'
  | 'sm:top-4'
  | 'md:top-4'
  | 'mg:top-4'
  | 'lg:top-4'
  | 'xl:top-4'
  | 'sm:right-4'
  | 'md:right-4'
  | 'mg:right-4'
  | 'lg:right-4'
  | 'xl:right-4'
  | 'sm:bottom-4'
  | 'md:bottom-4'
  | 'mg:bottom-4'
  | 'lg:bottom-4'
  | 'xl:bottom-4'
  | 'sm:left-4'
  | 'md:left-4'
  | 'mg:left-4'
  | 'lg:left-4'
  | 'xl:left-4'
  | 'sm:inset-5'
  | 'md:inset-5'
  | 'mg:inset-5'
  | 'lg:inset-5'
  | 'xl:inset-5'
  | 'sm:inset-x-5'
  | 'md:inset-x-5'
  | 'mg:inset-x-5'
  | 'lg:inset-x-5'
  | 'xl:inset-x-5'
  | 'sm:inset-y-5'
  | 'md:inset-y-5'
  | 'mg:inset-y-5'
  | 'lg:inset-y-5'
  | 'xl:inset-y-5'
  | 'sm:top-5'
  | 'md:top-5'
  | 'mg:top-5'
  | 'lg:top-5'
  | 'xl:top-5'
  | 'sm:right-5'
  | 'md:right-5'
  | 'mg:right-5'
  | 'lg:right-5'
  | 'xl:right-5'
  | 'sm:bottom-5'
  | 'md:bottom-5'
  | 'mg:bottom-5'
  | 'lg:bottom-5'
  | 'xl:bottom-5'
  | 'sm:left-5'
  | 'md:left-5'
  | 'mg:left-5'
  | 'lg:left-5'
  | 'xl:left-5'
  | 'sm:inset-6'
  | 'md:inset-6'
  | 'mg:inset-6'
  | 'lg:inset-6'
  | 'xl:inset-6'
  | 'sm:inset-x-6'
  | 'md:inset-x-6'
  | 'mg:inset-x-6'
  | 'lg:inset-x-6'
  | 'xl:inset-x-6'
  | 'sm:inset-y-6'
  | 'md:inset-y-6'
  | 'mg:inset-y-6'
  | 'lg:inset-y-6'
  | 'xl:inset-y-6'
  | 'sm:top-6'
  | 'md:top-6'
  | 'mg:top-6'
  | 'lg:top-6'
  | 'xl:top-6'
  | 'sm:right-6'
  | 'md:right-6'
  | 'mg:right-6'
  | 'lg:right-6'
  | 'xl:right-6'
  | 'sm:bottom-6'
  | 'md:bottom-6'
  | 'mg:bottom-6'
  | 'lg:bottom-6'
  | 'xl:bottom-6'
  | 'sm:left-6'
  | 'md:left-6'
  | 'mg:left-6'
  | 'lg:left-6'
  | 'xl:left-6'
  | 'sm:inset-7'
  | 'md:inset-7'
  | 'mg:inset-7'
  | 'lg:inset-7'
  | 'xl:inset-7'
  | 'sm:inset-x-7'
  | 'md:inset-x-7'
  | 'mg:inset-x-7'
  | 'lg:inset-x-7'
  | 'xl:inset-x-7'
  | 'sm:inset-y-7'
  | 'md:inset-y-7'
  | 'mg:inset-y-7'
  | 'lg:inset-y-7'
  | 'xl:inset-y-7'
  | 'sm:top-7'
  | 'md:top-7'
  | 'mg:top-7'
  | 'lg:top-7'
  | 'xl:top-7'
  | 'sm:right-7'
  | 'md:right-7'
  | 'mg:right-7'
  | 'lg:right-7'
  | 'xl:right-7'
  | 'sm:bottom-7'
  | 'md:bottom-7'
  | 'mg:bottom-7'
  | 'lg:bottom-7'
  | 'xl:bottom-7'
  | 'sm:left-7'
  | 'md:left-7'
  | 'mg:left-7'
  | 'lg:left-7'
  | 'xl:left-7'
  | 'sm:inset-8'
  | 'md:inset-8'
  | 'mg:inset-8'
  | 'lg:inset-8'
  | 'xl:inset-8'
  | 'sm:inset-x-8'
  | 'md:inset-x-8'
  | 'mg:inset-x-8'
  | 'lg:inset-x-8'
  | 'xl:inset-x-8'
  | 'sm:inset-y-8'
  | 'md:inset-y-8'
  | 'mg:inset-y-8'
  | 'lg:inset-y-8'
  | 'xl:inset-y-8'
  | 'sm:top-8'
  | 'md:top-8'
  | 'mg:top-8'
  | 'lg:top-8'
  | 'xl:top-8'
  | 'sm:right-8'
  | 'md:right-8'
  | 'mg:right-8'
  | 'lg:right-8'
  | 'xl:right-8'
  | 'sm:bottom-8'
  | 'md:bottom-8'
  | 'mg:bottom-8'
  | 'lg:bottom-8'
  | 'xl:bottom-8'
  | 'sm:left-8'
  | 'md:left-8'
  | 'mg:left-8'
  | 'lg:left-8'
  | 'xl:left-8'
  | 'sm:inset-9'
  | 'md:inset-9'
  | 'mg:inset-9'
  | 'lg:inset-9'
  | 'xl:inset-9'
  | 'sm:inset-x-9'
  | 'md:inset-x-9'
  | 'mg:inset-x-9'
  | 'lg:inset-x-9'
  | 'xl:inset-x-9'
  | 'sm:inset-y-9'
  | 'md:inset-y-9'
  | 'mg:inset-y-9'
  | 'lg:inset-y-9'
  | 'xl:inset-y-9'
  | 'sm:top-9'
  | 'md:top-9'
  | 'mg:top-9'
  | 'lg:top-9'
  | 'xl:top-9'
  | 'sm:right-9'
  | 'md:right-9'
  | 'mg:right-9'
  | 'lg:right-9'
  | 'xl:right-9'
  | 'sm:bottom-9'
  | 'md:bottom-9'
  | 'mg:bottom-9'
  | 'lg:bottom-9'
  | 'xl:bottom-9'
  | 'sm:left-9'
  | 'md:left-9'
  | 'mg:left-9'
  | 'lg:left-9'
  | 'xl:left-9'
  | 'sm:inset-10'
  | 'md:inset-10'
  | 'mg:inset-10'
  | 'lg:inset-10'
  | 'xl:inset-10'
  | 'sm:inset-x-10'
  | 'md:inset-x-10'
  | 'mg:inset-x-10'
  | 'lg:inset-x-10'
  | 'xl:inset-x-10'
  | 'sm:inset-y-10'
  | 'md:inset-y-10'
  | 'mg:inset-y-10'
  | 'lg:inset-y-10'
  | 'xl:inset-y-10'
  | 'sm:top-10'
  | 'md:top-10'
  | 'mg:top-10'
  | 'lg:top-10'
  | 'xl:top-10'
  | 'sm:right-10'
  | 'md:right-10'
  | 'mg:right-10'
  | 'lg:right-10'
  | 'xl:right-10'
  | 'sm:bottom-10'
  | 'md:bottom-10'
  | 'mg:bottom-10'
  | 'lg:bottom-10'
  | 'xl:bottom-10'
  | 'sm:left-10'
  | 'md:left-10'
  | 'mg:left-10'
  | 'lg:left-10'
  | 'xl:left-10'
  | 'sm:inset-11'
  | 'md:inset-11'
  | 'mg:inset-11'
  | 'lg:inset-11'
  | 'xl:inset-11'
  | 'sm:inset-x-11'
  | 'md:inset-x-11'
  | 'mg:inset-x-11'
  | 'lg:inset-x-11'
  | 'xl:inset-x-11'
  | 'sm:inset-y-11'
  | 'md:inset-y-11'
  | 'mg:inset-y-11'
  | 'lg:inset-y-11'
  | 'xl:inset-y-11'
  | 'sm:top-11'
  | 'md:top-11'
  | 'mg:top-11'
  | 'lg:top-11'
  | 'xl:top-11'
  | 'sm:right-11'
  | 'md:right-11'
  | 'mg:right-11'
  | 'lg:right-11'
  | 'xl:right-11'
  | 'sm:bottom-11'
  | 'md:bottom-11'
  | 'mg:bottom-11'
  | 'lg:bottom-11'
  | 'xl:bottom-11'
  | 'sm:left-11'
  | 'md:left-11'
  | 'mg:left-11'
  | 'lg:left-11'
  | 'xl:left-11'
  | 'sm:inset-12'
  | 'md:inset-12'
  | 'mg:inset-12'
  | 'lg:inset-12'
  | 'xl:inset-12'
  | 'sm:inset-x-12'
  | 'md:inset-x-12'
  | 'mg:inset-x-12'
  | 'lg:inset-x-12'
  | 'xl:inset-x-12'
  | 'sm:inset-y-12'
  | 'md:inset-y-12'
  | 'mg:inset-y-12'
  | 'lg:inset-y-12'
  | 'xl:inset-y-12'
  | 'sm:top-12'
  | 'md:top-12'
  | 'mg:top-12'
  | 'lg:top-12'
  | 'xl:top-12'
  | 'sm:right-12'
  | 'md:right-12'
  | 'mg:right-12'
  | 'lg:right-12'
  | 'xl:right-12'
  | 'sm:bottom-12'
  | 'md:bottom-12'
  | 'mg:bottom-12'
  | 'lg:bottom-12'
  | 'xl:bottom-12'
  | 'sm:left-12'
  | 'md:left-12'
  | 'mg:left-12'
  | 'lg:left-12'
  | 'xl:left-12'
  | 'sm:inset-14'
  | 'md:inset-14'
  | 'mg:inset-14'
  | 'lg:inset-14'
  | 'xl:inset-14'
  | 'sm:inset-x-14'
  | 'md:inset-x-14'
  | 'mg:inset-x-14'
  | 'lg:inset-x-14'
  | 'xl:inset-x-14'
  | 'sm:inset-y-14'
  | 'md:inset-y-14'
  | 'mg:inset-y-14'
  | 'lg:inset-y-14'
  | 'xl:inset-y-14'
  | 'sm:top-14'
  | 'md:top-14'
  | 'mg:top-14'
  | 'lg:top-14'
  | 'xl:top-14'
  | 'sm:right-14'
  | 'md:right-14'
  | 'mg:right-14'
  | 'lg:right-14'
  | 'xl:right-14'
  | 'sm:bottom-14'
  | 'md:bottom-14'
  | 'mg:bottom-14'
  | 'lg:bottom-14'
  | 'xl:bottom-14'
  | 'sm:left-14'
  | 'md:left-14'
  | 'mg:left-14'
  | 'lg:left-14'
  | 'xl:left-14'
  | 'sm:inset-15'
  | 'md:inset-15'
  | 'mg:inset-15'
  | 'lg:inset-15'
  | 'xl:inset-15'
  | 'sm:inset-x-15'
  | 'md:inset-x-15'
  | 'mg:inset-x-15'
  | 'lg:inset-x-15'
  | 'xl:inset-x-15'
  | 'sm:inset-y-15'
  | 'md:inset-y-15'
  | 'mg:inset-y-15'
  | 'lg:inset-y-15'
  | 'xl:inset-y-15'
  | 'sm:top-15'
  | 'md:top-15'
  | 'mg:top-15'
  | 'lg:top-15'
  | 'xl:top-15'
  | 'sm:right-15'
  | 'md:right-15'
  | 'mg:right-15'
  | 'lg:right-15'
  | 'xl:right-15'
  | 'sm:bottom-15'
  | 'md:bottom-15'
  | 'mg:bottom-15'
  | 'lg:bottom-15'
  | 'xl:bottom-15'
  | 'sm:left-15'
  | 'md:left-15'
  | 'mg:left-15'
  | 'lg:left-15'
  | 'xl:left-15'
  | 'sm:inset-16'
  | 'md:inset-16'
  | 'mg:inset-16'
  | 'lg:inset-16'
  | 'xl:inset-16'
  | 'sm:inset-x-16'
  | 'md:inset-x-16'
  | 'mg:inset-x-16'
  | 'lg:inset-x-16'
  | 'xl:inset-x-16'
  | 'sm:inset-y-16'
  | 'md:inset-y-16'
  | 'mg:inset-y-16'
  | 'lg:inset-y-16'
  | 'xl:inset-y-16'
  | 'sm:top-16'
  | 'md:top-16'
  | 'mg:top-16'
  | 'lg:top-16'
  | 'xl:top-16'
  | 'sm:right-16'
  | 'md:right-16'
  | 'mg:right-16'
  | 'lg:right-16'
  | 'xl:right-16'
  | 'sm:bottom-16'
  | 'md:bottom-16'
  | 'mg:bottom-16'
  | 'lg:bottom-16'
  | 'xl:bottom-16'
  | 'sm:left-16'
  | 'md:left-16'
  | 'mg:left-16'
  | 'lg:left-16'
  | 'xl:left-16'
  | 'sm:inset-17'
  | 'md:inset-17'
  | 'mg:inset-17'
  | 'lg:inset-17'
  | 'xl:inset-17'
  | 'sm:inset-x-17'
  | 'md:inset-x-17'
  | 'mg:inset-x-17'
  | 'lg:inset-x-17'
  | 'xl:inset-x-17'
  | 'sm:inset-y-17'
  | 'md:inset-y-17'
  | 'mg:inset-y-17'
  | 'lg:inset-y-17'
  | 'xl:inset-y-17'
  | 'sm:top-17'
  | 'md:top-17'
  | 'mg:top-17'
  | 'lg:top-17'
  | 'xl:top-17'
  | 'sm:right-17'
  | 'md:right-17'
  | 'mg:right-17'
  | 'lg:right-17'
  | 'xl:right-17'
  | 'sm:bottom-17'
  | 'md:bottom-17'
  | 'mg:bottom-17'
  | 'lg:bottom-17'
  | 'xl:bottom-17'
  | 'sm:left-17'
  | 'md:left-17'
  | 'mg:left-17'
  | 'lg:left-17'
  | 'xl:left-17'
  | 'sm:inset-18'
  | 'md:inset-18'
  | 'mg:inset-18'
  | 'lg:inset-18'
  | 'xl:inset-18'
  | 'sm:inset-x-18'
  | 'md:inset-x-18'
  | 'mg:inset-x-18'
  | 'lg:inset-x-18'
  | 'xl:inset-x-18'
  | 'sm:inset-y-18'
  | 'md:inset-y-18'
  | 'mg:inset-y-18'
  | 'lg:inset-y-18'
  | 'xl:inset-y-18'
  | 'sm:top-18'
  | 'md:top-18'
  | 'mg:top-18'
  | 'lg:top-18'
  | 'xl:top-18'
  | 'sm:right-18'
  | 'md:right-18'
  | 'mg:right-18'
  | 'lg:right-18'
  | 'xl:right-18'
  | 'sm:bottom-18'
  | 'md:bottom-18'
  | 'mg:bottom-18'
  | 'lg:bottom-18'
  | 'xl:bottom-18'
  | 'sm:left-18'
  | 'md:left-18'
  | 'mg:left-18'
  | 'lg:left-18'
  | 'xl:left-18'
  | 'sm:inset-20'
  | 'md:inset-20'
  | 'mg:inset-20'
  | 'lg:inset-20'
  | 'xl:inset-20'
  | 'sm:inset-x-20'
  | 'md:inset-x-20'
  | 'mg:inset-x-20'
  | 'lg:inset-x-20'
  | 'xl:inset-x-20'
  | 'sm:inset-y-20'
  | 'md:inset-y-20'
  | 'mg:inset-y-20'
  | 'lg:inset-y-20'
  | 'xl:inset-y-20'
  | 'sm:top-20'
  | 'md:top-20'
  | 'mg:top-20'
  | 'lg:top-20'
  | 'xl:top-20'
  | 'sm:right-20'
  | 'md:right-20'
  | 'mg:right-20'
  | 'lg:right-20'
  | 'xl:right-20'
  | 'sm:bottom-20'
  | 'md:bottom-20'
  | 'mg:bottom-20'
  | 'lg:bottom-20'
  | 'xl:bottom-20'
  | 'sm:left-20'
  | 'md:left-20'
  | 'mg:left-20'
  | 'lg:left-20'
  | 'xl:left-20'
  | 'sm:inset-21'
  | 'md:inset-21'
  | 'mg:inset-21'
  | 'lg:inset-21'
  | 'xl:inset-21'
  | 'sm:inset-x-21'
  | 'md:inset-x-21'
  | 'mg:inset-x-21'
  | 'lg:inset-x-21'
  | 'xl:inset-x-21'
  | 'sm:inset-y-21'
  | 'md:inset-y-21'
  | 'mg:inset-y-21'
  | 'lg:inset-y-21'
  | 'xl:inset-y-21'
  | 'sm:top-21'
  | 'md:top-21'
  | 'mg:top-21'
  | 'lg:top-21'
  | 'xl:top-21'
  | 'sm:right-21'
  | 'md:right-21'
  | 'mg:right-21'
  | 'lg:right-21'
  | 'xl:right-21'
  | 'sm:bottom-21'
  | 'md:bottom-21'
  | 'mg:bottom-21'
  | 'lg:bottom-21'
  | 'xl:bottom-21'
  | 'sm:left-21'
  | 'md:left-21'
  | 'mg:left-21'
  | 'lg:left-21'
  | 'xl:left-21'
  | 'sm:inset-22'
  | 'md:inset-22'
  | 'mg:inset-22'
  | 'lg:inset-22'
  | 'xl:inset-22'
  | 'sm:inset-x-22'
  | 'md:inset-x-22'
  | 'mg:inset-x-22'
  | 'lg:inset-x-22'
  | 'xl:inset-x-22'
  | 'sm:inset-y-22'
  | 'md:inset-y-22'
  | 'mg:inset-y-22'
  | 'lg:inset-y-22'
  | 'xl:inset-y-22'
  | 'sm:top-22'
  | 'md:top-22'
  | 'mg:top-22'
  | 'lg:top-22'
  | 'xl:top-22'
  | 'sm:right-22'
  | 'md:right-22'
  | 'mg:right-22'
  | 'lg:right-22'
  | 'xl:right-22'
  | 'sm:bottom-22'
  | 'md:bottom-22'
  | 'mg:bottom-22'
  | 'lg:bottom-22'
  | 'xl:bottom-22'
  | 'sm:left-22'
  | 'md:left-22'
  | 'mg:left-22'
  | 'lg:left-22'
  | 'xl:left-22'
  | 'sm:inset-24'
  | 'md:inset-24'
  | 'mg:inset-24'
  | 'lg:inset-24'
  | 'xl:inset-24'
  | 'sm:inset-x-24'
  | 'md:inset-x-24'
  | 'mg:inset-x-24'
  | 'lg:inset-x-24'
  | 'xl:inset-x-24'
  | 'sm:inset-y-24'
  | 'md:inset-y-24'
  | 'mg:inset-y-24'
  | 'lg:inset-y-24'
  | 'xl:inset-y-24'
  | 'sm:top-24'
  | 'md:top-24'
  | 'mg:top-24'
  | 'lg:top-24'
  | 'xl:top-24'
  | 'sm:right-24'
  | 'md:right-24'
  | 'mg:right-24'
  | 'lg:right-24'
  | 'xl:right-24'
  | 'sm:bottom-24'
  | 'md:bottom-24'
  | 'mg:bottom-24'
  | 'lg:bottom-24'
  | 'xl:bottom-24'
  | 'sm:left-24'
  | 'md:left-24'
  | 'mg:left-24'
  | 'lg:left-24'
  | 'xl:left-24'
  | 'sm:inset-28'
  | 'md:inset-28'
  | 'mg:inset-28'
  | 'lg:inset-28'
  | 'xl:inset-28'
  | 'sm:inset-x-28'
  | 'md:inset-x-28'
  | 'mg:inset-x-28'
  | 'lg:inset-x-28'
  | 'xl:inset-x-28'
  | 'sm:inset-y-28'
  | 'md:inset-y-28'
  | 'mg:inset-y-28'
  | 'lg:inset-y-28'
  | 'xl:inset-y-28'
  | 'sm:top-28'
  | 'md:top-28'
  | 'mg:top-28'
  | 'lg:top-28'
  | 'xl:top-28'
  | 'sm:right-28'
  | 'md:right-28'
  | 'mg:right-28'
  | 'lg:right-28'
  | 'xl:right-28'
  | 'sm:bottom-28'
  | 'md:bottom-28'
  | 'mg:bottom-28'
  | 'lg:bottom-28'
  | 'xl:bottom-28'
  | 'sm:left-28'
  | 'md:left-28'
  | 'mg:left-28'
  | 'lg:left-28'
  | 'xl:left-28'
  | 'sm:inset-30'
  | 'md:inset-30'
  | 'mg:inset-30'
  | 'lg:inset-30'
  | 'xl:inset-30'
  | 'sm:inset-x-30'
  | 'md:inset-x-30'
  | 'mg:inset-x-30'
  | 'lg:inset-x-30'
  | 'xl:inset-x-30'
  | 'sm:inset-y-30'
  | 'md:inset-y-30'
  | 'mg:inset-y-30'
  | 'lg:inset-y-30'
  | 'xl:inset-y-30'
  | 'sm:top-30'
  | 'md:top-30'
  | 'mg:top-30'
  | 'lg:top-30'
  | 'xl:top-30'
  | 'sm:right-30'
  | 'md:right-30'
  | 'mg:right-30'
  | 'lg:right-30'
  | 'xl:right-30'
  | 'sm:bottom-30'
  | 'md:bottom-30'
  | 'mg:bottom-30'
  | 'lg:bottom-30'
  | 'xl:bottom-30'
  | 'sm:left-30'
  | 'md:left-30'
  | 'mg:left-30'
  | 'lg:left-30'
  | 'xl:left-30'
  | 'sm:inset-32'
  | 'md:inset-32'
  | 'mg:inset-32'
  | 'lg:inset-32'
  | 'xl:inset-32'
  | 'sm:inset-x-32'
  | 'md:inset-x-32'
  | 'mg:inset-x-32'
  | 'lg:inset-x-32'
  | 'xl:inset-x-32'
  | 'sm:inset-y-32'
  | 'md:inset-y-32'
  | 'mg:inset-y-32'
  | 'lg:inset-y-32'
  | 'xl:inset-y-32'
  | 'sm:top-32'
  | 'md:top-32'
  | 'mg:top-32'
  | 'lg:top-32'
  | 'xl:top-32'
  | 'sm:right-32'
  | 'md:right-32'
  | 'mg:right-32'
  | 'lg:right-32'
  | 'xl:right-32'
  | 'sm:bottom-32'
  | 'md:bottom-32'
  | 'mg:bottom-32'
  | 'lg:bottom-32'
  | 'xl:bottom-32'
  | 'sm:left-32'
  | 'md:left-32'
  | 'mg:left-32'
  | 'lg:left-32'
  | 'xl:left-32'
  | 'sm:inset-36'
  | 'md:inset-36'
  | 'mg:inset-36'
  | 'lg:inset-36'
  | 'xl:inset-36'
  | 'sm:inset-x-36'
  | 'md:inset-x-36'
  | 'mg:inset-x-36'
  | 'lg:inset-x-36'
  | 'xl:inset-x-36'
  | 'sm:inset-y-36'
  | 'md:inset-y-36'
  | 'mg:inset-y-36'
  | 'lg:inset-y-36'
  | 'xl:inset-y-36'
  | 'sm:top-36'
  | 'md:top-36'
  | 'mg:top-36'
  | 'lg:top-36'
  | 'xl:top-36'
  | 'sm:right-36'
  | 'md:right-36'
  | 'mg:right-36'
  | 'lg:right-36'
  | 'xl:right-36'
  | 'sm:bottom-36'
  | 'md:bottom-36'
  | 'mg:bottom-36'
  | 'lg:bottom-36'
  | 'xl:bottom-36'
  | 'sm:left-36'
  | 'md:left-36'
  | 'mg:left-36'
  | 'lg:left-36'
  | 'xl:left-36'
  | 'sm:inset-40'
  | 'md:inset-40'
  | 'mg:inset-40'
  | 'lg:inset-40'
  | 'xl:inset-40'
  | 'sm:inset-x-40'
  | 'md:inset-x-40'
  | 'mg:inset-x-40'
  | 'lg:inset-x-40'
  | 'xl:inset-x-40'
  | 'sm:inset-y-40'
  | 'md:inset-y-40'
  | 'mg:inset-y-40'
  | 'lg:inset-y-40'
  | 'xl:inset-y-40'
  | 'sm:top-40'
  | 'md:top-40'
  | 'mg:top-40'
  | 'lg:top-40'
  | 'xl:top-40'
  | 'sm:right-40'
  | 'md:right-40'
  | 'mg:right-40'
  | 'lg:right-40'
  | 'xl:right-40'
  | 'sm:bottom-40'
  | 'md:bottom-40'
  | 'mg:bottom-40'
  | 'lg:bottom-40'
  | 'xl:bottom-40'
  | 'sm:left-40'
  | 'md:left-40'
  | 'mg:left-40'
  | 'lg:left-40'
  | 'xl:left-40'
  | 'sm:inset-44'
  | 'md:inset-44'
  | 'mg:inset-44'
  | 'lg:inset-44'
  | 'xl:inset-44'
  | 'sm:inset-x-44'
  | 'md:inset-x-44'
  | 'mg:inset-x-44'
  | 'lg:inset-x-44'
  | 'xl:inset-x-44'
  | 'sm:inset-y-44'
  | 'md:inset-y-44'
  | 'mg:inset-y-44'
  | 'lg:inset-y-44'
  | 'xl:inset-y-44'
  | 'sm:top-44'
  | 'md:top-44'
  | 'mg:top-44'
  | 'lg:top-44'
  | 'xl:top-44'
  | 'sm:right-44'
  | 'md:right-44'
  | 'mg:right-44'
  | 'lg:right-44'
  | 'xl:right-44'
  | 'sm:bottom-44'
  | 'md:bottom-44'
  | 'mg:bottom-44'
  | 'lg:bottom-44'
  | 'xl:bottom-44'
  | 'sm:left-44'
  | 'md:left-44'
  | 'mg:left-44'
  | 'lg:left-44'
  | 'xl:left-44'
  | 'sm:inset-48'
  | 'md:inset-48'
  | 'mg:inset-48'
  | 'lg:inset-48'
  | 'xl:inset-48'
  | 'sm:inset-x-48'
  | 'md:inset-x-48'
  | 'mg:inset-x-48'
  | 'lg:inset-x-48'
  | 'xl:inset-x-48'
  | 'sm:inset-y-48'
  | 'md:inset-y-48'
  | 'mg:inset-y-48'
  | 'lg:inset-y-48'
  | 'xl:inset-y-48'
  | 'sm:top-48'
  | 'md:top-48'
  | 'mg:top-48'
  | 'lg:top-48'
  | 'xl:top-48'
  | 'sm:right-48'
  | 'md:right-48'
  | 'mg:right-48'
  | 'lg:right-48'
  | 'xl:right-48'
  | 'sm:bottom-48'
  | 'md:bottom-48'
  | 'mg:bottom-48'
  | 'lg:bottom-48'
  | 'xl:bottom-48'
  | 'sm:left-48'
  | 'md:left-48'
  | 'mg:left-48'
  | 'lg:left-48'
  | 'xl:left-48'
  | 'sm:inset-52'
  | 'md:inset-52'
  | 'mg:inset-52'
  | 'lg:inset-52'
  | 'xl:inset-52'
  | 'sm:inset-x-52'
  | 'md:inset-x-52'
  | 'mg:inset-x-52'
  | 'lg:inset-x-52'
  | 'xl:inset-x-52'
  | 'sm:inset-y-52'
  | 'md:inset-y-52'
  | 'mg:inset-y-52'
  | 'lg:inset-y-52'
  | 'xl:inset-y-52'
  | 'sm:top-52'
  | 'md:top-52'
  | 'mg:top-52'
  | 'lg:top-52'
  | 'xl:top-52'
  | 'sm:right-52'
  | 'md:right-52'
  | 'mg:right-52'
  | 'lg:right-52'
  | 'xl:right-52'
  | 'sm:bottom-52'
  | 'md:bottom-52'
  | 'mg:bottom-52'
  | 'lg:bottom-52'
  | 'xl:bottom-52'
  | 'sm:left-52'
  | 'md:left-52'
  | 'mg:left-52'
  | 'lg:left-52'
  | 'xl:left-52'
  | 'sm:inset-56'
  | 'md:inset-56'
  | 'mg:inset-56'
  | 'lg:inset-56'
  | 'xl:inset-56'
  | 'sm:inset-x-56'
  | 'md:inset-x-56'
  | 'mg:inset-x-56'
  | 'lg:inset-x-56'
  | 'xl:inset-x-56'
  | 'sm:inset-y-56'
  | 'md:inset-y-56'
  | 'mg:inset-y-56'
  | 'lg:inset-y-56'
  | 'xl:inset-y-56'
  | 'sm:top-56'
  | 'md:top-56'
  | 'mg:top-56'
  | 'lg:top-56'
  | 'xl:top-56'
  | 'sm:right-56'
  | 'md:right-56'
  | 'mg:right-56'
  | 'lg:right-56'
  | 'xl:right-56'
  | 'sm:bottom-56'
  | 'md:bottom-56'
  | 'mg:bottom-56'
  | 'lg:bottom-56'
  | 'xl:bottom-56'
  | 'sm:left-56'
  | 'md:left-56'
  | 'mg:left-56'
  | 'lg:left-56'
  | 'xl:left-56'
  | 'sm:inset-60'
  | 'md:inset-60'
  | 'mg:inset-60'
  | 'lg:inset-60'
  | 'xl:inset-60'
  | 'sm:inset-x-60'
  | 'md:inset-x-60'
  | 'mg:inset-x-60'
  | 'lg:inset-x-60'
  | 'xl:inset-x-60'
  | 'sm:inset-y-60'
  | 'md:inset-y-60'
  | 'mg:inset-y-60'
  | 'lg:inset-y-60'
  | 'xl:inset-y-60'
  | 'sm:top-60'
  | 'md:top-60'
  | 'mg:top-60'
  | 'lg:top-60'
  | 'xl:top-60'
  | 'sm:right-60'
  | 'md:right-60'
  | 'mg:right-60'
  | 'lg:right-60'
  | 'xl:right-60'
  | 'sm:bottom-60'
  | 'md:bottom-60'
  | 'mg:bottom-60'
  | 'lg:bottom-60'
  | 'xl:bottom-60'
  | 'sm:left-60'
  | 'md:left-60'
  | 'mg:left-60'
  | 'lg:left-60'
  | 'xl:left-60'
  | 'sm:inset-64'
  | 'md:inset-64'
  | 'mg:inset-64'
  | 'lg:inset-64'
  | 'xl:inset-64'
  | 'sm:inset-x-64'
  | 'md:inset-x-64'
  | 'mg:inset-x-64'
  | 'lg:inset-x-64'
  | 'xl:inset-x-64'
  | 'sm:inset-y-64'
  | 'md:inset-y-64'
  | 'mg:inset-y-64'
  | 'lg:inset-y-64'
  | 'xl:inset-y-64'
  | 'sm:top-64'
  | 'md:top-64'
  | 'mg:top-64'
  | 'lg:top-64'
  | 'xl:top-64'
  | 'sm:right-64'
  | 'md:right-64'
  | 'mg:right-64'
  | 'lg:right-64'
  | 'xl:right-64'
  | 'sm:bottom-64'
  | 'md:bottom-64'
  | 'mg:bottom-64'
  | 'lg:bottom-64'
  | 'xl:bottom-64'
  | 'sm:left-64'
  | 'md:left-64'
  | 'mg:left-64'
  | 'lg:left-64'
  | 'xl:left-64'
  | 'sm:inset-72'
  | 'md:inset-72'
  | 'mg:inset-72'
  | 'lg:inset-72'
  | 'xl:inset-72'
  | 'sm:inset-x-72'
  | 'md:inset-x-72'
  | 'mg:inset-x-72'
  | 'lg:inset-x-72'
  | 'xl:inset-x-72'
  | 'sm:inset-y-72'
  | 'md:inset-y-72'
  | 'mg:inset-y-72'
  | 'lg:inset-y-72'
  | 'xl:inset-y-72'
  | 'sm:top-72'
  | 'md:top-72'
  | 'mg:top-72'
  | 'lg:top-72'
  | 'xl:top-72'
  | 'sm:right-72'
  | 'md:right-72'
  | 'mg:right-72'
  | 'lg:right-72'
  | 'xl:right-72'
  | 'sm:bottom-72'
  | 'md:bottom-72'
  | 'mg:bottom-72'
  | 'lg:bottom-72'
  | 'xl:bottom-72'
  | 'sm:left-72'
  | 'md:left-72'
  | 'mg:left-72'
  | 'lg:left-72'
  | 'xl:left-72'
  | 'sm:inset-80'
  | 'md:inset-80'
  | 'mg:inset-80'
  | 'lg:inset-80'
  | 'xl:inset-80'
  | 'sm:inset-x-80'
  | 'md:inset-x-80'
  | 'mg:inset-x-80'
  | 'lg:inset-x-80'
  | 'xl:inset-x-80'
  | 'sm:inset-y-80'
  | 'md:inset-y-80'
  | 'mg:inset-y-80'
  | 'lg:inset-y-80'
  | 'xl:inset-y-80'
  | 'sm:top-80'
  | 'md:top-80'
  | 'mg:top-80'
  | 'lg:top-80'
  | 'xl:top-80'
  | 'sm:right-80'
  | 'md:right-80'
  | 'mg:right-80'
  | 'lg:right-80'
  | 'xl:right-80'
  | 'sm:bottom-80'
  | 'md:bottom-80'
  | 'mg:bottom-80'
  | 'lg:bottom-80'
  | 'xl:bottom-80'
  | 'sm:left-80'
  | 'md:left-80'
  | 'mg:left-80'
  | 'lg:left-80'
  | 'xl:left-80'
  | 'sm:inset-96'
  | 'md:inset-96'
  | 'mg:inset-96'
  | 'lg:inset-96'
  | 'xl:inset-96'
  | 'sm:inset-x-96'
  | 'md:inset-x-96'
  | 'mg:inset-x-96'
  | 'lg:inset-x-96'
  | 'xl:inset-x-96'
  | 'sm:inset-y-96'
  | 'md:inset-y-96'
  | 'mg:inset-y-96'
  | 'lg:inset-y-96'
  | 'xl:inset-y-96'
  | 'sm:top-96'
  | 'md:top-96'
  | 'mg:top-96'
  | 'lg:top-96'
  | 'xl:top-96'
  | 'sm:right-96'
  | 'md:right-96'
  | 'mg:right-96'
  | 'lg:right-96'
  | 'xl:right-96'
  | 'sm:bottom-96'
  | 'md:bottom-96'
  | 'mg:bottom-96'
  | 'lg:bottom-96'
  | 'xl:bottom-96'
  | 'sm:left-96'
  | 'md:left-96'
  | 'mg:left-96'
  | 'lg:left-96'
  | 'xl:left-96'
  | 'sm:inset-auto'
  | 'md:inset-auto'
  | 'mg:inset-auto'
  | 'lg:inset-auto'
  | 'xl:inset-auto'
  | 'sm:inset-x-auto'
  | 'md:inset-x-auto'
  | 'mg:inset-x-auto'
  | 'lg:inset-x-auto'
  | 'xl:inset-x-auto'
  | 'sm:inset-y-auto'
  | 'md:inset-y-auto'
  | 'mg:inset-y-auto'
  | 'lg:inset-y-auto'
  | 'xl:inset-y-auto'
  | 'sm:top-auto'
  | 'md:top-auto'
  | 'mg:top-auto'
  | 'lg:top-auto'
  | 'xl:top-auto'
  | 'sm:right-auto'
  | 'md:right-auto'
  | 'mg:right-auto'
  | 'lg:right-auto'
  | 'xl:right-auto'
  | 'sm:bottom-auto'
  | 'md:bottom-auto'
  | 'mg:bottom-auto'
  | 'lg:bottom-auto'
  | 'xl:bottom-auto'
  | 'sm:left-auto'
  | 'md:left-auto'
  | 'mg:left-auto'
  | 'lg:left-auto'
  | 'xl:left-auto'
  | 'sm:inset-px'
  | 'md:inset-px'
  | 'mg:inset-px'
  | 'lg:inset-px'
  | 'xl:inset-px'
  | 'sm:inset-x-px'
  | 'md:inset-x-px'
  | 'mg:inset-x-px'
  | 'lg:inset-x-px'
  | 'xl:inset-x-px'
  | 'sm:inset-y-px'
  | 'md:inset-y-px'
  | 'mg:inset-y-px'
  | 'lg:inset-y-px'
  | 'xl:inset-y-px'
  | 'sm:top-px'
  | 'md:top-px'
  | 'mg:top-px'
  | 'lg:top-px'
  | 'xl:top-px'
  | 'sm:right-px'
  | 'md:right-px'
  | 'mg:right-px'
  | 'lg:right-px'
  | 'xl:right-px'
  | 'sm:bottom-px'
  | 'md:bottom-px'
  | 'mg:bottom-px'
  | 'lg:bottom-px'
  | 'xl:bottom-px'
  | 'sm:left-px'
  | 'md:left-px'
  | 'mg:left-px'
  | 'lg:left-px'
  | 'xl:left-px'
  | 'sm:inset-0.5'
  | 'md:inset-0.5'
  | 'mg:inset-0.5'
  | 'lg:inset-0.5'
  | 'xl:inset-0.5'
  | 'sm:inset-x-0.5'
  | 'md:inset-x-0.5'
  | 'mg:inset-x-0.5'
  | 'lg:inset-x-0.5'
  | 'xl:inset-x-0.5'
  | 'sm:inset-y-0.5'
  | 'md:inset-y-0.5'
  | 'mg:inset-y-0.5'
  | 'lg:inset-y-0.5'
  | 'xl:inset-y-0.5'
  | 'sm:top-0.5'
  | 'md:top-0.5'
  | 'mg:top-0.5'
  | 'lg:top-0.5'
  | 'xl:top-0.5'
  | 'sm:right-0.5'
  | 'md:right-0.5'
  | 'mg:right-0.5'
  | 'lg:right-0.5'
  | 'xl:right-0.5'
  | 'sm:bottom-0.5'
  | 'md:bottom-0.5'
  | 'mg:bottom-0.5'
  | 'lg:bottom-0.5'
  | 'xl:bottom-0.5'
  | 'sm:left-0.5'
  | 'md:left-0.5'
  | 'mg:left-0.5'
  | 'lg:left-0.5'
  | 'xl:left-0.5'
  | 'sm:inset-1.5'
  | 'md:inset-1.5'
  | 'mg:inset-1.5'
  | 'lg:inset-1.5'
  | 'xl:inset-1.5'
  | 'sm:inset-x-1.5'
  | 'md:inset-x-1.5'
  | 'mg:inset-x-1.5'
  | 'lg:inset-x-1.5'
  | 'xl:inset-x-1.5'
  | 'sm:inset-y-1.5'
  | 'md:inset-y-1.5'
  | 'mg:inset-y-1.5'
  | 'lg:inset-y-1.5'
  | 'xl:inset-y-1.5'
  | 'sm:top-1.5'
  | 'md:top-1.5'
  | 'mg:top-1.5'
  | 'lg:top-1.5'
  | 'xl:top-1.5'
  | 'sm:right-1.5'
  | 'md:right-1.5'
  | 'mg:right-1.5'
  | 'lg:right-1.5'
  | 'xl:right-1.5'
  | 'sm:bottom-1.5'
  | 'md:bottom-1.5'
  | 'mg:bottom-1.5'
  | 'lg:bottom-1.5'
  | 'xl:bottom-1.5'
  | 'sm:left-1.5'
  | 'md:left-1.5'
  | 'mg:left-1.5'
  | 'lg:left-1.5'
  | 'xl:left-1.5'
  | 'sm:inset-2.5'
  | 'md:inset-2.5'
  | 'mg:inset-2.5'
  | 'lg:inset-2.5'
  | 'xl:inset-2.5'
  | 'sm:inset-x-2.5'
  | 'md:inset-x-2.5'
  | 'mg:inset-x-2.5'
  | 'lg:inset-x-2.5'
  | 'xl:inset-x-2.5'
  | 'sm:inset-y-2.5'
  | 'md:inset-y-2.5'
  | 'mg:inset-y-2.5'
  | 'lg:inset-y-2.5'
  | 'xl:inset-y-2.5'
  | 'sm:top-2.5'
  | 'md:top-2.5'
  | 'mg:top-2.5'
  | 'lg:top-2.5'
  | 'xl:top-2.5'
  | 'sm:right-2.5'
  | 'md:right-2.5'
  | 'mg:right-2.5'
  | 'lg:right-2.5'
  | 'xl:right-2.5'
  | 'sm:bottom-2.5'
  | 'md:bottom-2.5'
  | 'mg:bottom-2.5'
  | 'lg:bottom-2.5'
  | 'xl:bottom-2.5'
  | 'sm:left-2.5'
  | 'md:left-2.5'
  | 'mg:left-2.5'
  | 'lg:left-2.5'
  | 'xl:left-2.5'
  | 'sm:inset-3.5'
  | 'md:inset-3.5'
  | 'mg:inset-3.5'
  | 'lg:inset-3.5'
  | 'xl:inset-3.5'
  | 'sm:inset-x-3.5'
  | 'md:inset-x-3.5'
  | 'mg:inset-x-3.5'
  | 'lg:inset-x-3.5'
  | 'xl:inset-x-3.5'
  | 'sm:inset-y-3.5'
  | 'md:inset-y-3.5'
  | 'mg:inset-y-3.5'
  | 'lg:inset-y-3.5'
  | 'xl:inset-y-3.5'
  | 'sm:top-3.5'
  | 'md:top-3.5'
  | 'mg:top-3.5'
  | 'lg:top-3.5'
  | 'xl:top-3.5'
  | 'sm:right-3.5'
  | 'md:right-3.5'
  | 'mg:right-3.5'
  | 'lg:right-3.5'
  | 'xl:right-3.5'
  | 'sm:bottom-3.5'
  | 'md:bottom-3.5'
  | 'mg:bottom-3.5'
  | 'lg:bottom-3.5'
  | 'xl:bottom-3.5'
  | 'sm:left-3.5'
  | 'md:left-3.5'
  | 'mg:left-3.5'
  | 'lg:left-3.5'
  | 'xl:left-3.5'
  | 'sm:-inset-0'
  | 'md:-inset-0'
  | 'mg:-inset-0'
  | 'lg:-inset-0'
  | 'xl:-inset-0'
  | 'sm:-inset-x-0'
  | 'md:-inset-x-0'
  | 'mg:-inset-x-0'
  | 'lg:-inset-x-0'
  | 'xl:-inset-x-0'
  | 'sm:-inset-y-0'
  | 'md:-inset-y-0'
  | 'mg:-inset-y-0'
  | 'lg:-inset-y-0'
  | 'xl:-inset-y-0'
  | 'sm:-top-0'
  | 'md:-top-0'
  | 'mg:-top-0'
  | 'lg:-top-0'
  | 'xl:-top-0'
  | 'sm:-right-0'
  | 'md:-right-0'
  | 'mg:-right-0'
  | 'lg:-right-0'
  | 'xl:-right-0'
  | 'sm:-bottom-0'
  | 'md:-bottom-0'
  | 'mg:-bottom-0'
  | 'lg:-bottom-0'
  | 'xl:-bottom-0'
  | 'sm:-left-0'
  | 'md:-left-0'
  | 'mg:-left-0'
  | 'lg:-left-0'
  | 'xl:-left-0'
  | 'sm:-inset-1'
  | 'md:-inset-1'
  | 'mg:-inset-1'
  | 'lg:-inset-1'
  | 'xl:-inset-1'
  | 'sm:-inset-x-1'
  | 'md:-inset-x-1'
  | 'mg:-inset-x-1'
  | 'lg:-inset-x-1'
  | 'xl:-inset-x-1'
  | 'sm:-inset-y-1'
  | 'md:-inset-y-1'
  | 'mg:-inset-y-1'
  | 'lg:-inset-y-1'
  | 'xl:-inset-y-1'
  | 'sm:-top-1'
  | 'md:-top-1'
  | 'mg:-top-1'
  | 'lg:-top-1'
  | 'xl:-top-1'
  | 'sm:-right-1'
  | 'md:-right-1'
  | 'mg:-right-1'
  | 'lg:-right-1'
  | 'xl:-right-1'
  | 'sm:-bottom-1'
  | 'md:-bottom-1'
  | 'mg:-bottom-1'
  | 'lg:-bottom-1'
  | 'xl:-bottom-1'
  | 'sm:-left-1'
  | 'md:-left-1'
  | 'mg:-left-1'
  | 'lg:-left-1'
  | 'xl:-left-1'
  | 'sm:-inset-2'
  | 'md:-inset-2'
  | 'mg:-inset-2'
  | 'lg:-inset-2'
  | 'xl:-inset-2'
  | 'sm:-inset-x-2'
  | 'md:-inset-x-2'
  | 'mg:-inset-x-2'
  | 'lg:-inset-x-2'
  | 'xl:-inset-x-2'
  | 'sm:-inset-y-2'
  | 'md:-inset-y-2'
  | 'mg:-inset-y-2'
  | 'lg:-inset-y-2'
  | 'xl:-inset-y-2'
  | 'sm:-top-2'
  | 'md:-top-2'
  | 'mg:-top-2'
  | 'lg:-top-2'
  | 'xl:-top-2'
  | 'sm:-right-2'
  | 'md:-right-2'
  | 'mg:-right-2'
  | 'lg:-right-2'
  | 'xl:-right-2'
  | 'sm:-bottom-2'
  | 'md:-bottom-2'
  | 'mg:-bottom-2'
  | 'lg:-bottom-2'
  | 'xl:-bottom-2'
  | 'sm:-left-2'
  | 'md:-left-2'
  | 'mg:-left-2'
  | 'lg:-left-2'
  | 'xl:-left-2'
  | 'sm:-inset-3'
  | 'md:-inset-3'
  | 'mg:-inset-3'
  | 'lg:-inset-3'
  | 'xl:-inset-3'
  | 'sm:-inset-x-3'
  | 'md:-inset-x-3'
  | 'mg:-inset-x-3'
  | 'lg:-inset-x-3'
  | 'xl:-inset-x-3'
  | 'sm:-inset-y-3'
  | 'md:-inset-y-3'
  | 'mg:-inset-y-3'
  | 'lg:-inset-y-3'
  | 'xl:-inset-y-3'
  | 'sm:-top-3'
  | 'md:-top-3'
  | 'mg:-top-3'
  | 'lg:-top-3'
  | 'xl:-top-3'
  | 'sm:-right-3'
  | 'md:-right-3'
  | 'mg:-right-3'
  | 'lg:-right-3'
  | 'xl:-right-3'
  | 'sm:-bottom-3'
  | 'md:-bottom-3'
  | 'mg:-bottom-3'
  | 'lg:-bottom-3'
  | 'xl:-bottom-3'
  | 'sm:-left-3'
  | 'md:-left-3'
  | 'mg:-left-3'
  | 'lg:-left-3'
  | 'xl:-left-3'
  | 'sm:-inset-4'
  | 'md:-inset-4'
  | 'mg:-inset-4'
  | 'lg:-inset-4'
  | 'xl:-inset-4'
  | 'sm:-inset-x-4'
  | 'md:-inset-x-4'
  | 'mg:-inset-x-4'
  | 'lg:-inset-x-4'
  | 'xl:-inset-x-4'
  | 'sm:-inset-y-4'
  | 'md:-inset-y-4'
  | 'mg:-inset-y-4'
  | 'lg:-inset-y-4'
  | 'xl:-inset-y-4'
  | 'sm:-top-4'
  | 'md:-top-4'
  | 'mg:-top-4'
  | 'lg:-top-4'
  | 'xl:-top-4'
  | 'sm:-right-4'
  | 'md:-right-4'
  | 'mg:-right-4'
  | 'lg:-right-4'
  | 'xl:-right-4'
  | 'sm:-bottom-4'
  | 'md:-bottom-4'
  | 'mg:-bottom-4'
  | 'lg:-bottom-4'
  | 'xl:-bottom-4'
  | 'sm:-left-4'
  | 'md:-left-4'
  | 'mg:-left-4'
  | 'lg:-left-4'
  | 'xl:-left-4'
  | 'sm:-inset-5'
  | 'md:-inset-5'
  | 'mg:-inset-5'
  | 'lg:-inset-5'
  | 'xl:-inset-5'
  | 'sm:-inset-x-5'
  | 'md:-inset-x-5'
  | 'mg:-inset-x-5'
  | 'lg:-inset-x-5'
  | 'xl:-inset-x-5'
  | 'sm:-inset-y-5'
  | 'md:-inset-y-5'
  | 'mg:-inset-y-5'
  | 'lg:-inset-y-5'
  | 'xl:-inset-y-5'
  | 'sm:-top-5'
  | 'md:-top-5'
  | 'mg:-top-5'
  | 'lg:-top-5'
  | 'xl:-top-5'
  | 'sm:-right-5'
  | 'md:-right-5'
  | 'mg:-right-5'
  | 'lg:-right-5'
  | 'xl:-right-5'
  | 'sm:-bottom-5'
  | 'md:-bottom-5'
  | 'mg:-bottom-5'
  | 'lg:-bottom-5'
  | 'xl:-bottom-5'
  | 'sm:-left-5'
  | 'md:-left-5'
  | 'mg:-left-5'
  | 'lg:-left-5'
  | 'xl:-left-5'
  | 'sm:-inset-6'
  | 'md:-inset-6'
  | 'mg:-inset-6'
  | 'lg:-inset-6'
  | 'xl:-inset-6'
  | 'sm:-inset-x-6'
  | 'md:-inset-x-6'
  | 'mg:-inset-x-6'
  | 'lg:-inset-x-6'
  | 'xl:-inset-x-6'
  | 'sm:-inset-y-6'
  | 'md:-inset-y-6'
  | 'mg:-inset-y-6'
  | 'lg:-inset-y-6'
  | 'xl:-inset-y-6'
  | 'sm:-top-6'
  | 'md:-top-6'
  | 'mg:-top-6'
  | 'lg:-top-6'
  | 'xl:-top-6'
  | 'sm:-right-6'
  | 'md:-right-6'
  | 'mg:-right-6'
  | 'lg:-right-6'
  | 'xl:-right-6'
  | 'sm:-bottom-6'
  | 'md:-bottom-6'
  | 'mg:-bottom-6'
  | 'lg:-bottom-6'
  | 'xl:-bottom-6'
  | 'sm:-left-6'
  | 'md:-left-6'
  | 'mg:-left-6'
  | 'lg:-left-6'
  | 'xl:-left-6'
  | 'sm:-inset-7'
  | 'md:-inset-7'
  | 'mg:-inset-7'
  | 'lg:-inset-7'
  | 'xl:-inset-7'
  | 'sm:-inset-x-7'
  | 'md:-inset-x-7'
  | 'mg:-inset-x-7'
  | 'lg:-inset-x-7'
  | 'xl:-inset-x-7'
  | 'sm:-inset-y-7'
  | 'md:-inset-y-7'
  | 'mg:-inset-y-7'
  | 'lg:-inset-y-7'
  | 'xl:-inset-y-7'
  | 'sm:-top-7'
  | 'md:-top-7'
  | 'mg:-top-7'
  | 'lg:-top-7'
  | 'xl:-top-7'
  | 'sm:-right-7'
  | 'md:-right-7'
  | 'mg:-right-7'
  | 'lg:-right-7'
  | 'xl:-right-7'
  | 'sm:-bottom-7'
  | 'md:-bottom-7'
  | 'mg:-bottom-7'
  | 'lg:-bottom-7'
  | 'xl:-bottom-7'
  | 'sm:-left-7'
  | 'md:-left-7'
  | 'mg:-left-7'
  | 'lg:-left-7'
  | 'xl:-left-7'
  | 'sm:-inset-8'
  | 'md:-inset-8'
  | 'mg:-inset-8'
  | 'lg:-inset-8'
  | 'xl:-inset-8'
  | 'sm:-inset-x-8'
  | 'md:-inset-x-8'
  | 'mg:-inset-x-8'
  | 'lg:-inset-x-8'
  | 'xl:-inset-x-8'
  | 'sm:-inset-y-8'
  | 'md:-inset-y-8'
  | 'mg:-inset-y-8'
  | 'lg:-inset-y-8'
  | 'xl:-inset-y-8'
  | 'sm:-top-8'
  | 'md:-top-8'
  | 'mg:-top-8'
  | 'lg:-top-8'
  | 'xl:-top-8'
  | 'sm:-right-8'
  | 'md:-right-8'
  | 'mg:-right-8'
  | 'lg:-right-8'
  | 'xl:-right-8'
  | 'sm:-bottom-8'
  | 'md:-bottom-8'
  | 'mg:-bottom-8'
  | 'lg:-bottom-8'
  | 'xl:-bottom-8'
  | 'sm:-left-8'
  | 'md:-left-8'
  | 'mg:-left-8'
  | 'lg:-left-8'
  | 'xl:-left-8'
  | 'sm:-inset-9'
  | 'md:-inset-9'
  | 'mg:-inset-9'
  | 'lg:-inset-9'
  | 'xl:-inset-9'
  | 'sm:-inset-x-9'
  | 'md:-inset-x-9'
  | 'mg:-inset-x-9'
  | 'lg:-inset-x-9'
  | 'xl:-inset-x-9'
  | 'sm:-inset-y-9'
  | 'md:-inset-y-9'
  | 'mg:-inset-y-9'
  | 'lg:-inset-y-9'
  | 'xl:-inset-y-9'
  | 'sm:-top-9'
  | 'md:-top-9'
  | 'mg:-top-9'
  | 'lg:-top-9'
  | 'xl:-top-9'
  | 'sm:-right-9'
  | 'md:-right-9'
  | 'mg:-right-9'
  | 'lg:-right-9'
  | 'xl:-right-9'
  | 'sm:-bottom-9'
  | 'md:-bottom-9'
  | 'mg:-bottom-9'
  | 'lg:-bottom-9'
  | 'xl:-bottom-9'
  | 'sm:-left-9'
  | 'md:-left-9'
  | 'mg:-left-9'
  | 'lg:-left-9'
  | 'xl:-left-9'
  | 'sm:-inset-10'
  | 'md:-inset-10'
  | 'mg:-inset-10'
  | 'lg:-inset-10'
  | 'xl:-inset-10'
  | 'sm:-inset-x-10'
  | 'md:-inset-x-10'
  | 'mg:-inset-x-10'
  | 'lg:-inset-x-10'
  | 'xl:-inset-x-10'
  | 'sm:-inset-y-10'
  | 'md:-inset-y-10'
  | 'mg:-inset-y-10'
  | 'lg:-inset-y-10'
  | 'xl:-inset-y-10'
  | 'sm:-top-10'
  | 'md:-top-10'
  | 'mg:-top-10'
  | 'lg:-top-10'
  | 'xl:-top-10'
  | 'sm:-right-10'
  | 'md:-right-10'
  | 'mg:-right-10'
  | 'lg:-right-10'
  | 'xl:-right-10'
  | 'sm:-bottom-10'
  | 'md:-bottom-10'
  | 'mg:-bottom-10'
  | 'lg:-bottom-10'
  | 'xl:-bottom-10'
  | 'sm:-left-10'
  | 'md:-left-10'
  | 'mg:-left-10'
  | 'lg:-left-10'
  | 'xl:-left-10'
  | 'sm:-inset-11'
  | 'md:-inset-11'
  | 'mg:-inset-11'
  | 'lg:-inset-11'
  | 'xl:-inset-11'
  | 'sm:-inset-x-11'
  | 'md:-inset-x-11'
  | 'mg:-inset-x-11'
  | 'lg:-inset-x-11'
  | 'xl:-inset-x-11'
  | 'sm:-inset-y-11'
  | 'md:-inset-y-11'
  | 'mg:-inset-y-11'
  | 'lg:-inset-y-11'
  | 'xl:-inset-y-11'
  | 'sm:-top-11'
  | 'md:-top-11'
  | 'mg:-top-11'
  | 'lg:-top-11'
  | 'xl:-top-11'
  | 'sm:-right-11'
  | 'md:-right-11'
  | 'mg:-right-11'
  | 'lg:-right-11'
  | 'xl:-right-11'
  | 'sm:-bottom-11'
  | 'md:-bottom-11'
  | 'mg:-bottom-11'
  | 'lg:-bottom-11'
  | 'xl:-bottom-11'
  | 'sm:-left-11'
  | 'md:-left-11'
  | 'mg:-left-11'
  | 'lg:-left-11'
  | 'xl:-left-11'
  | 'sm:-inset-12'
  | 'md:-inset-12'
  | 'mg:-inset-12'
  | 'lg:-inset-12'
  | 'xl:-inset-12'
  | 'sm:-inset-x-12'
  | 'md:-inset-x-12'
  | 'mg:-inset-x-12'
  | 'lg:-inset-x-12'
  | 'xl:-inset-x-12'
  | 'sm:-inset-y-12'
  | 'md:-inset-y-12'
  | 'mg:-inset-y-12'
  | 'lg:-inset-y-12'
  | 'xl:-inset-y-12'
  | 'sm:-top-12'
  | 'md:-top-12'
  | 'mg:-top-12'
  | 'lg:-top-12'
  | 'xl:-top-12'
  | 'sm:-right-12'
  | 'md:-right-12'
  | 'mg:-right-12'
  | 'lg:-right-12'
  | 'xl:-right-12'
  | 'sm:-bottom-12'
  | 'md:-bottom-12'
  | 'mg:-bottom-12'
  | 'lg:-bottom-12'
  | 'xl:-bottom-12'
  | 'sm:-left-12'
  | 'md:-left-12'
  | 'mg:-left-12'
  | 'lg:-left-12'
  | 'xl:-left-12'
  | 'sm:-inset-14'
  | 'md:-inset-14'
  | 'mg:-inset-14'
  | 'lg:-inset-14'
  | 'xl:-inset-14'
  | 'sm:-inset-x-14'
  | 'md:-inset-x-14'
  | 'mg:-inset-x-14'
  | 'lg:-inset-x-14'
  | 'xl:-inset-x-14'
  | 'sm:-inset-y-14'
  | 'md:-inset-y-14'
  | 'mg:-inset-y-14'
  | 'lg:-inset-y-14'
  | 'xl:-inset-y-14'
  | 'sm:-top-14'
  | 'md:-top-14'
  | 'mg:-top-14'
  | 'lg:-top-14'
  | 'xl:-top-14'
  | 'sm:-right-14'
  | 'md:-right-14'
  | 'mg:-right-14'
  | 'lg:-right-14'
  | 'xl:-right-14'
  | 'sm:-bottom-14'
  | 'md:-bottom-14'
  | 'mg:-bottom-14'
  | 'lg:-bottom-14'
  | 'xl:-bottom-14'
  | 'sm:-left-14'
  | 'md:-left-14'
  | 'mg:-left-14'
  | 'lg:-left-14'
  | 'xl:-left-14'
  | 'sm:-inset-16'
  | 'md:-inset-16'
  | 'mg:-inset-16'
  | 'lg:-inset-16'
  | 'xl:-inset-16'
  | 'sm:-inset-x-16'
  | 'md:-inset-x-16'
  | 'mg:-inset-x-16'
  | 'lg:-inset-x-16'
  | 'xl:-inset-x-16'
  | 'sm:-inset-y-16'
  | 'md:-inset-y-16'
  | 'mg:-inset-y-16'
  | 'lg:-inset-y-16'
  | 'xl:-inset-y-16'
  | 'sm:-top-16'
  | 'md:-top-16'
  | 'mg:-top-16'
  | 'lg:-top-16'
  | 'xl:-top-16'
  | 'sm:-right-16'
  | 'md:-right-16'
  | 'mg:-right-16'
  | 'lg:-right-16'
  | 'xl:-right-16'
  | 'sm:-bottom-16'
  | 'md:-bottom-16'
  | 'mg:-bottom-16'
  | 'lg:-bottom-16'
  | 'xl:-bottom-16'
  | 'sm:-left-16'
  | 'md:-left-16'
  | 'mg:-left-16'
  | 'lg:-left-16'
  | 'xl:-left-16'
  | 'sm:-inset-20'
  | 'md:-inset-20'
  | 'mg:-inset-20'
  | 'lg:-inset-20'
  | 'xl:-inset-20'
  | 'sm:-inset-x-20'
  | 'md:-inset-x-20'
  | 'mg:-inset-x-20'
  | 'lg:-inset-x-20'
  | 'xl:-inset-x-20'
  | 'sm:-inset-y-20'
  | 'md:-inset-y-20'
  | 'mg:-inset-y-20'
  | 'lg:-inset-y-20'
  | 'xl:-inset-y-20'
  | 'sm:-top-20'
  | 'md:-top-20'
  | 'mg:-top-20'
  | 'lg:-top-20'
  | 'xl:-top-20'
  | 'sm:-right-20'
  | 'md:-right-20'
  | 'mg:-right-20'
  | 'lg:-right-20'
  | 'xl:-right-20'
  | 'sm:-bottom-20'
  | 'md:-bottom-20'
  | 'mg:-bottom-20'
  | 'lg:-bottom-20'
  | 'xl:-bottom-20'
  | 'sm:-left-20'
  | 'md:-left-20'
  | 'mg:-left-20'
  | 'lg:-left-20'
  | 'xl:-left-20'
  | 'sm:-inset-24'
  | 'md:-inset-24'
  | 'mg:-inset-24'
  | 'lg:-inset-24'
  | 'xl:-inset-24'
  | 'sm:-inset-x-24'
  | 'md:-inset-x-24'
  | 'mg:-inset-x-24'
  | 'lg:-inset-x-24'
  | 'xl:-inset-x-24'
  | 'sm:-inset-y-24'
  | 'md:-inset-y-24'
  | 'mg:-inset-y-24'
  | 'lg:-inset-y-24'
  | 'xl:-inset-y-24'
  | 'sm:-top-24'
  | 'md:-top-24'
  | 'mg:-top-24'
  | 'lg:-top-24'
  | 'xl:-top-24'
  | 'sm:-right-24'
  | 'md:-right-24'
  | 'mg:-right-24'
  | 'lg:-right-24'
  | 'xl:-right-24'
  | 'sm:-bottom-24'
  | 'md:-bottom-24'
  | 'mg:-bottom-24'
  | 'lg:-bottom-24'
  | 'xl:-bottom-24'
  | 'sm:-left-24'
  | 'md:-left-24'
  | 'mg:-left-24'
  | 'lg:-left-24'
  | 'xl:-left-24'
  | 'sm:-inset-28'
  | 'md:-inset-28'
  | 'mg:-inset-28'
  | 'lg:-inset-28'
  | 'xl:-inset-28'
  | 'sm:-inset-x-28'
  | 'md:-inset-x-28'
  | 'mg:-inset-x-28'
  | 'lg:-inset-x-28'
  | 'xl:-inset-x-28'
  | 'sm:-inset-y-28'
  | 'md:-inset-y-28'
  | 'mg:-inset-y-28'
  | 'lg:-inset-y-28'
  | 'xl:-inset-y-28'
  | 'sm:-top-28'
  | 'md:-top-28'
  | 'mg:-top-28'
  | 'lg:-top-28'
  | 'xl:-top-28'
  | 'sm:-right-28'
  | 'md:-right-28'
  | 'mg:-right-28'
  | 'lg:-right-28'
  | 'xl:-right-28'
  | 'sm:-bottom-28'
  | 'md:-bottom-28'
  | 'mg:-bottom-28'
  | 'lg:-bottom-28'
  | 'xl:-bottom-28'
  | 'sm:-left-28'
  | 'md:-left-28'
  | 'mg:-left-28'
  | 'lg:-left-28'
  | 'xl:-left-28'
  | 'sm:-inset-32'
  | 'md:-inset-32'
  | 'mg:-inset-32'
  | 'lg:-inset-32'
  | 'xl:-inset-32'
  | 'sm:-inset-x-32'
  | 'md:-inset-x-32'
  | 'mg:-inset-x-32'
  | 'lg:-inset-x-32'
  | 'xl:-inset-x-32'
  | 'sm:-inset-y-32'
  | 'md:-inset-y-32'
  | 'mg:-inset-y-32'
  | 'lg:-inset-y-32'
  | 'xl:-inset-y-32'
  | 'sm:-top-32'
  | 'md:-top-32'
  | 'mg:-top-32'
  | 'lg:-top-32'
  | 'xl:-top-32'
  | 'sm:-right-32'
  | 'md:-right-32'
  | 'mg:-right-32'
  | 'lg:-right-32'
  | 'xl:-right-32'
  | 'sm:-bottom-32'
  | 'md:-bottom-32'
  | 'mg:-bottom-32'
  | 'lg:-bottom-32'
  | 'xl:-bottom-32'
  | 'sm:-left-32'
  | 'md:-left-32'
  | 'mg:-left-32'
  | 'lg:-left-32'
  | 'xl:-left-32'
  | 'sm:-inset-36'
  | 'md:-inset-36'
  | 'mg:-inset-36'
  | 'lg:-inset-36'
  | 'xl:-inset-36'
  | 'sm:-inset-x-36'
  | 'md:-inset-x-36'
  | 'mg:-inset-x-36'
  | 'lg:-inset-x-36'
  | 'xl:-inset-x-36'
  | 'sm:-inset-y-36'
  | 'md:-inset-y-36'
  | 'mg:-inset-y-36'
  | 'lg:-inset-y-36'
  | 'xl:-inset-y-36'
  | 'sm:-top-36'
  | 'md:-top-36'
  | 'mg:-top-36'
  | 'lg:-top-36'
  | 'xl:-top-36'
  | 'sm:-right-36'
  | 'md:-right-36'
  | 'mg:-right-36'
  | 'lg:-right-36'
  | 'xl:-right-36'
  | 'sm:-bottom-36'
  | 'md:-bottom-36'
  | 'mg:-bottom-36'
  | 'lg:-bottom-36'
  | 'xl:-bottom-36'
  | 'sm:-left-36'
  | 'md:-left-36'
  | 'mg:-left-36'
  | 'lg:-left-36'
  | 'xl:-left-36'
  | 'sm:-inset-40'
  | 'md:-inset-40'
  | 'mg:-inset-40'
  | 'lg:-inset-40'
  | 'xl:-inset-40'
  | 'sm:-inset-x-40'
  | 'md:-inset-x-40'
  | 'mg:-inset-x-40'
  | 'lg:-inset-x-40'
  | 'xl:-inset-x-40'
  | 'sm:-inset-y-40'
  | 'md:-inset-y-40'
  | 'mg:-inset-y-40'
  | 'lg:-inset-y-40'
  | 'xl:-inset-y-40'
  | 'sm:-top-40'
  | 'md:-top-40'
  | 'mg:-top-40'
  | 'lg:-top-40'
  | 'xl:-top-40'
  | 'sm:-right-40'
  | 'md:-right-40'
  | 'mg:-right-40'
  | 'lg:-right-40'
  | 'xl:-right-40'
  | 'sm:-bottom-40'
  | 'md:-bottom-40'
  | 'mg:-bottom-40'
  | 'lg:-bottom-40'
  | 'xl:-bottom-40'
  | 'sm:-left-40'
  | 'md:-left-40'
  | 'mg:-left-40'
  | 'lg:-left-40'
  | 'xl:-left-40'
  | 'sm:-inset-44'
  | 'md:-inset-44'
  | 'mg:-inset-44'
  | 'lg:-inset-44'
  | 'xl:-inset-44'
  | 'sm:-inset-x-44'
  | 'md:-inset-x-44'
  | 'mg:-inset-x-44'
  | 'lg:-inset-x-44'
  | 'xl:-inset-x-44'
  | 'sm:-inset-y-44'
  | 'md:-inset-y-44'
  | 'mg:-inset-y-44'
  | 'lg:-inset-y-44'
  | 'xl:-inset-y-44'
  | 'sm:-top-44'
  | 'md:-top-44'
  | 'mg:-top-44'
  | 'lg:-top-44'
  | 'xl:-top-44'
  | 'sm:-right-44'
  | 'md:-right-44'
  | 'mg:-right-44'
  | 'lg:-right-44'
  | 'xl:-right-44'
  | 'sm:-bottom-44'
  | 'md:-bottom-44'
  | 'mg:-bottom-44'
  | 'lg:-bottom-44'
  | 'xl:-bottom-44'
  | 'sm:-left-44'
  | 'md:-left-44'
  | 'mg:-left-44'
  | 'lg:-left-44'
  | 'xl:-left-44'
  | 'sm:-inset-48'
  | 'md:-inset-48'
  | 'mg:-inset-48'
  | 'lg:-inset-48'
  | 'xl:-inset-48'
  | 'sm:-inset-x-48'
  | 'md:-inset-x-48'
  | 'mg:-inset-x-48'
  | 'lg:-inset-x-48'
  | 'xl:-inset-x-48'
  | 'sm:-inset-y-48'
  | 'md:-inset-y-48'
  | 'mg:-inset-y-48'
  | 'lg:-inset-y-48'
  | 'xl:-inset-y-48'
  | 'sm:-top-48'
  | 'md:-top-48'
  | 'mg:-top-48'
  | 'lg:-top-48'
  | 'xl:-top-48'
  | 'sm:-right-48'
  | 'md:-right-48'
  | 'mg:-right-48'
  | 'lg:-right-48'
  | 'xl:-right-48'
  | 'sm:-bottom-48'
  | 'md:-bottom-48'
  | 'mg:-bottom-48'
  | 'lg:-bottom-48'
  | 'xl:-bottom-48'
  | 'sm:-left-48'
  | 'md:-left-48'
  | 'mg:-left-48'
  | 'lg:-left-48'
  | 'xl:-left-48'
  | 'sm:-inset-52'
  | 'md:-inset-52'
  | 'mg:-inset-52'
  | 'lg:-inset-52'
  | 'xl:-inset-52'
  | 'sm:-inset-x-52'
  | 'md:-inset-x-52'
  | 'mg:-inset-x-52'
  | 'lg:-inset-x-52'
  | 'xl:-inset-x-52'
  | 'sm:-inset-y-52'
  | 'md:-inset-y-52'
  | 'mg:-inset-y-52'
  | 'lg:-inset-y-52'
  | 'xl:-inset-y-52'
  | 'sm:-top-52'
  | 'md:-top-52'
  | 'mg:-top-52'
  | 'lg:-top-52'
  | 'xl:-top-52'
  | 'sm:-right-52'
  | 'md:-right-52'
  | 'mg:-right-52'
  | 'lg:-right-52'
  | 'xl:-right-52'
  | 'sm:-bottom-52'
  | 'md:-bottom-52'
  | 'mg:-bottom-52'
  | 'lg:-bottom-52'
  | 'xl:-bottom-52'
  | 'sm:-left-52'
  | 'md:-left-52'
  | 'mg:-left-52'
  | 'lg:-left-52'
  | 'xl:-left-52'
  | 'sm:-inset-56'
  | 'md:-inset-56'
  | 'mg:-inset-56'
  | 'lg:-inset-56'
  | 'xl:-inset-56'
  | 'sm:-inset-x-56'
  | 'md:-inset-x-56'
  | 'mg:-inset-x-56'
  | 'lg:-inset-x-56'
  | 'xl:-inset-x-56'
  | 'sm:-inset-y-56'
  | 'md:-inset-y-56'
  | 'mg:-inset-y-56'
  | 'lg:-inset-y-56'
  | 'xl:-inset-y-56'
  | 'sm:-top-56'
  | 'md:-top-56'
  | 'mg:-top-56'
  | 'lg:-top-56'
  | 'xl:-top-56'
  | 'sm:-right-56'
  | 'md:-right-56'
  | 'mg:-right-56'
  | 'lg:-right-56'
  | 'xl:-right-56'
  | 'sm:-bottom-56'
  | 'md:-bottom-56'
  | 'mg:-bottom-56'
  | 'lg:-bottom-56'
  | 'xl:-bottom-56'
  | 'sm:-left-56'
  | 'md:-left-56'
  | 'mg:-left-56'
  | 'lg:-left-56'
  | 'xl:-left-56'
  | 'sm:-inset-60'
  | 'md:-inset-60'
  | 'mg:-inset-60'
  | 'lg:-inset-60'
  | 'xl:-inset-60'
  | 'sm:-inset-x-60'
  | 'md:-inset-x-60'
  | 'mg:-inset-x-60'
  | 'lg:-inset-x-60'
  | 'xl:-inset-x-60'
  | 'sm:-inset-y-60'
  | 'md:-inset-y-60'
  | 'mg:-inset-y-60'
  | 'lg:-inset-y-60'
  | 'xl:-inset-y-60'
  | 'sm:-top-60'
  | 'md:-top-60'
  | 'mg:-top-60'
  | 'lg:-top-60'
  | 'xl:-top-60'
  | 'sm:-right-60'
  | 'md:-right-60'
  | 'mg:-right-60'
  | 'lg:-right-60'
  | 'xl:-right-60'
  | 'sm:-bottom-60'
  | 'md:-bottom-60'
  | 'mg:-bottom-60'
  | 'lg:-bottom-60'
  | 'xl:-bottom-60'
  | 'sm:-left-60'
  | 'md:-left-60'
  | 'mg:-left-60'
  | 'lg:-left-60'
  | 'xl:-left-60'
  | 'sm:-inset-64'
  | 'md:-inset-64'
  | 'mg:-inset-64'
  | 'lg:-inset-64'
  | 'xl:-inset-64'
  | 'sm:-inset-x-64'
  | 'md:-inset-x-64'
  | 'mg:-inset-x-64'
  | 'lg:-inset-x-64'
  | 'xl:-inset-x-64'
  | 'sm:-inset-y-64'
  | 'md:-inset-y-64'
  | 'mg:-inset-y-64'
  | 'lg:-inset-y-64'
  | 'xl:-inset-y-64'
  | 'sm:-top-64'
  | 'md:-top-64'
  | 'mg:-top-64'
  | 'lg:-top-64'
  | 'xl:-top-64'
  | 'sm:-right-64'
  | 'md:-right-64'
  | 'mg:-right-64'
  | 'lg:-right-64'
  | 'xl:-right-64'
  | 'sm:-bottom-64'
  | 'md:-bottom-64'
  | 'mg:-bottom-64'
  | 'lg:-bottom-64'
  | 'xl:-bottom-64'
  | 'sm:-left-64'
  | 'md:-left-64'
  | 'mg:-left-64'
  | 'lg:-left-64'
  | 'xl:-left-64'
  | 'sm:-inset-72'
  | 'md:-inset-72'
  | 'mg:-inset-72'
  | 'lg:-inset-72'
  | 'xl:-inset-72'
  | 'sm:-inset-x-72'
  | 'md:-inset-x-72'
  | 'mg:-inset-x-72'
  | 'lg:-inset-x-72'
  | 'xl:-inset-x-72'
  | 'sm:-inset-y-72'
  | 'md:-inset-y-72'
  | 'mg:-inset-y-72'
  | 'lg:-inset-y-72'
  | 'xl:-inset-y-72'
  | 'sm:-top-72'
  | 'md:-top-72'
  | 'mg:-top-72'
  | 'lg:-top-72'
  | 'xl:-top-72'
  | 'sm:-right-72'
  | 'md:-right-72'
  | 'mg:-right-72'
  | 'lg:-right-72'
  | 'xl:-right-72'
  | 'sm:-bottom-72'
  | 'md:-bottom-72'
  | 'mg:-bottom-72'
  | 'lg:-bottom-72'
  | 'xl:-bottom-72'
  | 'sm:-left-72'
  | 'md:-left-72'
  | 'mg:-left-72'
  | 'lg:-left-72'
  | 'xl:-left-72'
  | 'sm:-inset-80'
  | 'md:-inset-80'
  | 'mg:-inset-80'
  | 'lg:-inset-80'
  | 'xl:-inset-80'
  | 'sm:-inset-x-80'
  | 'md:-inset-x-80'
  | 'mg:-inset-x-80'
  | 'lg:-inset-x-80'
  | 'xl:-inset-x-80'
  | 'sm:-inset-y-80'
  | 'md:-inset-y-80'
  | 'mg:-inset-y-80'
  | 'lg:-inset-y-80'
  | 'xl:-inset-y-80'
  | 'sm:-top-80'
  | 'md:-top-80'
  | 'mg:-top-80'
  | 'lg:-top-80'
  | 'xl:-top-80'
  | 'sm:-right-80'
  | 'md:-right-80'
  | 'mg:-right-80'
  | 'lg:-right-80'
  | 'xl:-right-80'
  | 'sm:-bottom-80'
  | 'md:-bottom-80'
  | 'mg:-bottom-80'
  | 'lg:-bottom-80'
  | 'xl:-bottom-80'
  | 'sm:-left-80'
  | 'md:-left-80'
  | 'mg:-left-80'
  | 'lg:-left-80'
  | 'xl:-left-80'
  | 'sm:-inset-96'
  | 'md:-inset-96'
  | 'mg:-inset-96'
  | 'lg:-inset-96'
  | 'xl:-inset-96'
  | 'sm:-inset-x-96'
  | 'md:-inset-x-96'
  | 'mg:-inset-x-96'
  | 'lg:-inset-x-96'
  | 'xl:-inset-x-96'
  | 'sm:-inset-y-96'
  | 'md:-inset-y-96'
  | 'mg:-inset-y-96'
  | 'lg:-inset-y-96'
  | 'xl:-inset-y-96'
  | 'sm:-top-96'
  | 'md:-top-96'
  | 'mg:-top-96'
  | 'lg:-top-96'
  | 'xl:-top-96'
  | 'sm:-right-96'
  | 'md:-right-96'
  | 'mg:-right-96'
  | 'lg:-right-96'
  | 'xl:-right-96'
  | 'sm:-bottom-96'
  | 'md:-bottom-96'
  | 'mg:-bottom-96'
  | 'lg:-bottom-96'
  | 'xl:-bottom-96'
  | 'sm:-left-96'
  | 'md:-left-96'
  | 'mg:-left-96'
  | 'lg:-left-96'
  | 'xl:-left-96'
  | 'sm:-inset-px'
  | 'md:-inset-px'
  | 'mg:-inset-px'
  | 'lg:-inset-px'
  | 'xl:-inset-px'
  | 'sm:-inset-x-px'
  | 'md:-inset-x-px'
  | 'mg:-inset-x-px'
  | 'lg:-inset-x-px'
  | 'xl:-inset-x-px'
  | 'sm:-inset-y-px'
  | 'md:-inset-y-px'
  | 'mg:-inset-y-px'
  | 'lg:-inset-y-px'
  | 'xl:-inset-y-px'
  | 'sm:-top-px'
  | 'md:-top-px'
  | 'mg:-top-px'
  | 'lg:-top-px'
  | 'xl:-top-px'
  | 'sm:-right-px'
  | 'md:-right-px'
  | 'mg:-right-px'
  | 'lg:-right-px'
  | 'xl:-right-px'
  | 'sm:-bottom-px'
  | 'md:-bottom-px'
  | 'mg:-bottom-px'
  | 'lg:-bottom-px'
  | 'xl:-bottom-px'
  | 'sm:-left-px'
  | 'md:-left-px'
  | 'mg:-left-px'
  | 'lg:-left-px'
  | 'xl:-left-px'
  | 'sm:-inset-0.5'
  | 'md:-inset-0.5'
  | 'mg:-inset-0.5'
  | 'lg:-inset-0.5'
  | 'xl:-inset-0.5'
  | 'sm:-inset-x-0.5'
  | 'md:-inset-x-0.5'
  | 'mg:-inset-x-0.5'
  | 'lg:-inset-x-0.5'
  | 'xl:-inset-x-0.5'
  | 'sm:-inset-y-0.5'
  | 'md:-inset-y-0.5'
  | 'mg:-inset-y-0.5'
  | 'lg:-inset-y-0.5'
  | 'xl:-inset-y-0.5'
  | 'sm:-top-0.5'
  | 'md:-top-0.5'
  | 'mg:-top-0.5'
  | 'lg:-top-0.5'
  | 'xl:-top-0.5'
  | 'sm:-right-0.5'
  | 'md:-right-0.5'
  | 'mg:-right-0.5'
  | 'lg:-right-0.5'
  | 'xl:-right-0.5'
  | 'sm:-bottom-0.5'
  | 'md:-bottom-0.5'
  | 'mg:-bottom-0.5'
  | 'lg:-bottom-0.5'
  | 'xl:-bottom-0.5'
  | 'sm:-left-0.5'
  | 'md:-left-0.5'
  | 'mg:-left-0.5'
  | 'lg:-left-0.5'
  | 'xl:-left-0.5'
  | 'sm:-inset-1.5'
  | 'md:-inset-1.5'
  | 'mg:-inset-1.5'
  | 'lg:-inset-1.5'
  | 'xl:-inset-1.5'
  | 'sm:-inset-x-1.5'
  | 'md:-inset-x-1.5'
  | 'mg:-inset-x-1.5'
  | 'lg:-inset-x-1.5'
  | 'xl:-inset-x-1.5'
  | 'sm:-inset-y-1.5'
  | 'md:-inset-y-1.5'
  | 'mg:-inset-y-1.5'
  | 'lg:-inset-y-1.5'
  | 'xl:-inset-y-1.5'
  | 'sm:-top-1.5'
  | 'md:-top-1.5'
  | 'mg:-top-1.5'
  | 'lg:-top-1.5'
  | 'xl:-top-1.5'
  | 'sm:-right-1.5'
  | 'md:-right-1.5'
  | 'mg:-right-1.5'
  | 'lg:-right-1.5'
  | 'xl:-right-1.5'
  | 'sm:-bottom-1.5'
  | 'md:-bottom-1.5'
  | 'mg:-bottom-1.5'
  | 'lg:-bottom-1.5'
  | 'xl:-bottom-1.5'
  | 'sm:-left-1.5'
  | 'md:-left-1.5'
  | 'mg:-left-1.5'
  | 'lg:-left-1.5'
  | 'xl:-left-1.5'
  | 'sm:-inset-2.5'
  | 'md:-inset-2.5'
  | 'mg:-inset-2.5'
  | 'lg:-inset-2.5'
  | 'xl:-inset-2.5'
  | 'sm:-inset-x-2.5'
  | 'md:-inset-x-2.5'
  | 'mg:-inset-x-2.5'
  | 'lg:-inset-x-2.5'
  | 'xl:-inset-x-2.5'
  | 'sm:-inset-y-2.5'
  | 'md:-inset-y-2.5'
  | 'mg:-inset-y-2.5'
  | 'lg:-inset-y-2.5'
  | 'xl:-inset-y-2.5'
  | 'sm:-top-2.5'
  | 'md:-top-2.5'
  | 'mg:-top-2.5'
  | 'lg:-top-2.5'
  | 'xl:-top-2.5'
  | 'sm:-right-2.5'
  | 'md:-right-2.5'
  | 'mg:-right-2.5'
  | 'lg:-right-2.5'
  | 'xl:-right-2.5'
  | 'sm:-bottom-2.5'
  | 'md:-bottom-2.5'
  | 'mg:-bottom-2.5'
  | 'lg:-bottom-2.5'
  | 'xl:-bottom-2.5'
  | 'sm:-left-2.5'
  | 'md:-left-2.5'
  | 'mg:-left-2.5'
  | 'lg:-left-2.5'
  | 'xl:-left-2.5'
  | 'sm:-inset-3.5'
  | 'md:-inset-3.5'
  | 'mg:-inset-3.5'
  | 'lg:-inset-3.5'
  | 'xl:-inset-3.5'
  | 'sm:-inset-x-3.5'
  | 'md:-inset-x-3.5'
  | 'mg:-inset-x-3.5'
  | 'lg:-inset-x-3.5'
  | 'xl:-inset-x-3.5'
  | 'sm:-inset-y-3.5'
  | 'md:-inset-y-3.5'
  | 'mg:-inset-y-3.5'
  | 'lg:-inset-y-3.5'
  | 'xl:-inset-y-3.5'
  | 'sm:-top-3.5'
  | 'md:-top-3.5'
  | 'mg:-top-3.5'
  | 'lg:-top-3.5'
  | 'xl:-top-3.5'
  | 'sm:-right-3.5'
  | 'md:-right-3.5'
  | 'mg:-right-3.5'
  | 'lg:-right-3.5'
  | 'xl:-right-3.5'
  | 'sm:-bottom-3.5'
  | 'md:-bottom-3.5'
  | 'mg:-bottom-3.5'
  | 'lg:-bottom-3.5'
  | 'xl:-bottom-3.5'
  | 'sm:-left-3.5'
  | 'md:-left-3.5'
  | 'mg:-left-3.5'
  | 'lg:-left-3.5'
  | 'xl:-left-3.5'
  | 'sm:inset-1/2'
  | 'md:inset-1/2'
  | 'mg:inset-1/2'
  | 'lg:inset-1/2'
  | 'xl:inset-1/2'
  | 'sm:inset-x-1/2'
  | 'md:inset-x-1/2'
  | 'mg:inset-x-1/2'
  | 'lg:inset-x-1/2'
  | 'xl:inset-x-1/2'
  | 'sm:inset-y-1/2'
  | 'md:inset-y-1/2'
  | 'mg:inset-y-1/2'
  | 'lg:inset-y-1/2'
  | 'xl:inset-y-1/2'
  | 'sm:top-1/2'
  | 'md:top-1/2'
  | 'mg:top-1/2'
  | 'lg:top-1/2'
  | 'xl:top-1/2'
  | 'sm:right-1/2'
  | 'md:right-1/2'
  | 'mg:right-1/2'
  | 'lg:right-1/2'
  | 'xl:right-1/2'
  | 'sm:bottom-1/2'
  | 'md:bottom-1/2'
  | 'mg:bottom-1/2'
  | 'lg:bottom-1/2'
  | 'xl:bottom-1/2'
  | 'sm:left-1/2'
  | 'md:left-1/2'
  | 'mg:left-1/2'
  | 'lg:left-1/2'
  | 'xl:left-1/2'
  | 'sm:inset-1/3'
  | 'md:inset-1/3'
  | 'mg:inset-1/3'
  | 'lg:inset-1/3'
  | 'xl:inset-1/3'
  | 'sm:inset-x-1/3'
  | 'md:inset-x-1/3'
  | 'mg:inset-x-1/3'
  | 'lg:inset-x-1/3'
  | 'xl:inset-x-1/3'
  | 'sm:inset-y-1/3'
  | 'md:inset-y-1/3'
  | 'mg:inset-y-1/3'
  | 'lg:inset-y-1/3'
  | 'xl:inset-y-1/3'
  | 'sm:top-1/3'
  | 'md:top-1/3'
  | 'mg:top-1/3'
  | 'lg:top-1/3'
  | 'xl:top-1/3'
  | 'sm:right-1/3'
  | 'md:right-1/3'
  | 'mg:right-1/3'
  | 'lg:right-1/3'
  | 'xl:right-1/3'
  | 'sm:bottom-1/3'
  | 'md:bottom-1/3'
  | 'mg:bottom-1/3'
  | 'lg:bottom-1/3'
  | 'xl:bottom-1/3'
  | 'sm:left-1/3'
  | 'md:left-1/3'
  | 'mg:left-1/3'
  | 'lg:left-1/3'
  | 'xl:left-1/3'
  | 'sm:inset-2/3'
  | 'md:inset-2/3'
  | 'mg:inset-2/3'
  | 'lg:inset-2/3'
  | 'xl:inset-2/3'
  | 'sm:inset-x-2/3'
  | 'md:inset-x-2/3'
  | 'mg:inset-x-2/3'
  | 'lg:inset-x-2/3'
  | 'xl:inset-x-2/3'
  | 'sm:inset-y-2/3'
  | 'md:inset-y-2/3'
  | 'mg:inset-y-2/3'
  | 'lg:inset-y-2/3'
  | 'xl:inset-y-2/3'
  | 'sm:top-2/3'
  | 'md:top-2/3'
  | 'mg:top-2/3'
  | 'lg:top-2/3'
  | 'xl:top-2/3'
  | 'sm:right-2/3'
  | 'md:right-2/3'
  | 'mg:right-2/3'
  | 'lg:right-2/3'
  | 'xl:right-2/3'
  | 'sm:bottom-2/3'
  | 'md:bottom-2/3'
  | 'mg:bottom-2/3'
  | 'lg:bottom-2/3'
  | 'xl:bottom-2/3'
  | 'sm:left-2/3'
  | 'md:left-2/3'
  | 'mg:left-2/3'
  | 'lg:left-2/3'
  | 'xl:left-2/3'
  | 'sm:inset-1/4'
  | 'md:inset-1/4'
  | 'mg:inset-1/4'
  | 'lg:inset-1/4'
  | 'xl:inset-1/4'
  | 'sm:inset-x-1/4'
  | 'md:inset-x-1/4'
  | 'mg:inset-x-1/4'
  | 'lg:inset-x-1/4'
  | 'xl:inset-x-1/4'
  | 'sm:inset-y-1/4'
  | 'md:inset-y-1/4'
  | 'mg:inset-y-1/4'
  | 'lg:inset-y-1/4'
  | 'xl:inset-y-1/4'
  | 'sm:top-1/4'
  | 'md:top-1/4'
  | 'mg:top-1/4'
  | 'lg:top-1/4'
  | 'xl:top-1/4'
  | 'sm:right-1/4'
  | 'md:right-1/4'
  | 'mg:right-1/4'
  | 'lg:right-1/4'
  | 'xl:right-1/4'
  | 'sm:bottom-1/4'
  | 'md:bottom-1/4'
  | 'mg:bottom-1/4'
  | 'lg:bottom-1/4'
  | 'xl:bottom-1/4'
  | 'sm:left-1/4'
  | 'md:left-1/4'
  | 'mg:left-1/4'
  | 'lg:left-1/4'
  | 'xl:left-1/4'
  | 'sm:inset-2/4'
  | 'md:inset-2/4'
  | 'mg:inset-2/4'
  | 'lg:inset-2/4'
  | 'xl:inset-2/4'
  | 'sm:inset-x-2/4'
  | 'md:inset-x-2/4'
  | 'mg:inset-x-2/4'
  | 'lg:inset-x-2/4'
  | 'xl:inset-x-2/4'
  | 'sm:inset-y-2/4'
  | 'md:inset-y-2/4'
  | 'mg:inset-y-2/4'
  | 'lg:inset-y-2/4'
  | 'xl:inset-y-2/4'
  | 'sm:top-2/4'
  | 'md:top-2/4'
  | 'mg:top-2/4'
  | 'lg:top-2/4'
  | 'xl:top-2/4'
  | 'sm:right-2/4'
  | 'md:right-2/4'
  | 'mg:right-2/4'
  | 'lg:right-2/4'
  | 'xl:right-2/4'
  | 'sm:bottom-2/4'
  | 'md:bottom-2/4'
  | 'mg:bottom-2/4'
  | 'lg:bottom-2/4'
  | 'xl:bottom-2/4'
  | 'sm:left-2/4'
  | 'md:left-2/4'
  | 'mg:left-2/4'
  | 'lg:left-2/4'
  | 'xl:left-2/4'
  | 'sm:inset-3/4'
  | 'md:inset-3/4'
  | 'mg:inset-3/4'
  | 'lg:inset-3/4'
  | 'xl:inset-3/4'
  | 'sm:inset-x-3/4'
  | 'md:inset-x-3/4'
  | 'mg:inset-x-3/4'
  | 'lg:inset-x-3/4'
  | 'xl:inset-x-3/4'
  | 'sm:inset-y-3/4'
  | 'md:inset-y-3/4'
  | 'mg:inset-y-3/4'
  | 'lg:inset-y-3/4'
  | 'xl:inset-y-3/4'
  | 'sm:top-3/4'
  | 'md:top-3/4'
  | 'mg:top-3/4'
  | 'lg:top-3/4'
  | 'xl:top-3/4'
  | 'sm:right-3/4'
  | 'md:right-3/4'
  | 'mg:right-3/4'
  | 'lg:right-3/4'
  | 'xl:right-3/4'
  | 'sm:bottom-3/4'
  | 'md:bottom-3/4'
  | 'mg:bottom-3/4'
  | 'lg:bottom-3/4'
  | 'xl:bottom-3/4'
  | 'sm:left-3/4'
  | 'md:left-3/4'
  | 'mg:left-3/4'
  | 'lg:left-3/4'
  | 'xl:left-3/4'
  | 'sm:inset-full'
  | 'md:inset-full'
  | 'mg:inset-full'
  | 'lg:inset-full'
  | 'xl:inset-full'
  | 'sm:inset-x-full'
  | 'md:inset-x-full'
  | 'mg:inset-x-full'
  | 'lg:inset-x-full'
  | 'xl:inset-x-full'
  | 'sm:inset-y-full'
  | 'md:inset-y-full'
  | 'mg:inset-y-full'
  | 'lg:inset-y-full'
  | 'xl:inset-y-full'
  | 'sm:top-full'
  | 'md:top-full'
  | 'mg:top-full'
  | 'lg:top-full'
  | 'xl:top-full'
  | 'sm:right-full'
  | 'md:right-full'
  | 'mg:right-full'
  | 'lg:right-full'
  | 'xl:right-full'
  | 'sm:bottom-full'
  | 'md:bottom-full'
  | 'mg:bottom-full'
  | 'lg:bottom-full'
  | 'xl:bottom-full'
  | 'sm:left-full'
  | 'md:left-full'
  | 'mg:left-full'
  | 'lg:left-full'
  | 'xl:left-full'
  | 'sm:-inset-1/2'
  | 'md:-inset-1/2'
  | 'mg:-inset-1/2'
  | 'lg:-inset-1/2'
  | 'xl:-inset-1/2'
  | 'sm:-inset-x-1/2'
  | 'md:-inset-x-1/2'
  | 'mg:-inset-x-1/2'
  | 'lg:-inset-x-1/2'
  | 'xl:-inset-x-1/2'
  | 'sm:-inset-y-1/2'
  | 'md:-inset-y-1/2'
  | 'mg:-inset-y-1/2'
  | 'lg:-inset-y-1/2'
  | 'xl:-inset-y-1/2'
  | 'sm:-top-1/2'
  | 'md:-top-1/2'
  | 'mg:-top-1/2'
  | 'lg:-top-1/2'
  | 'xl:-top-1/2'
  | 'sm:-right-1/2'
  | 'md:-right-1/2'
  | 'mg:-right-1/2'
  | 'lg:-right-1/2'
  | 'xl:-right-1/2'
  | 'sm:-bottom-1/2'
  | 'md:-bottom-1/2'
  | 'mg:-bottom-1/2'
  | 'lg:-bottom-1/2'
  | 'xl:-bottom-1/2'
  | 'sm:-left-1/2'
  | 'md:-left-1/2'
  | 'mg:-left-1/2'
  | 'lg:-left-1/2'
  | 'xl:-left-1/2'
  | 'sm:-inset-1/3'
  | 'md:-inset-1/3'
  | 'mg:-inset-1/3'
  | 'lg:-inset-1/3'
  | 'xl:-inset-1/3'
  | 'sm:-inset-x-1/3'
  | 'md:-inset-x-1/3'
  | 'mg:-inset-x-1/3'
  | 'lg:-inset-x-1/3'
  | 'xl:-inset-x-1/3'
  | 'sm:-inset-y-1/3'
  | 'md:-inset-y-1/3'
  | 'mg:-inset-y-1/3'
  | 'lg:-inset-y-1/3'
  | 'xl:-inset-y-1/3'
  | 'sm:-top-1/3'
  | 'md:-top-1/3'
  | 'mg:-top-1/3'
  | 'lg:-top-1/3'
  | 'xl:-top-1/3'
  | 'sm:-right-1/3'
  | 'md:-right-1/3'
  | 'mg:-right-1/3'
  | 'lg:-right-1/3'
  | 'xl:-right-1/3'
  | 'sm:-bottom-1/3'
  | 'md:-bottom-1/3'
  | 'mg:-bottom-1/3'
  | 'lg:-bottom-1/3'
  | 'xl:-bottom-1/3'
  | 'sm:-left-1/3'
  | 'md:-left-1/3'
  | 'mg:-left-1/3'
  | 'lg:-left-1/3'
  | 'xl:-left-1/3'
  | 'sm:-inset-2/3'
  | 'md:-inset-2/3'
  | 'mg:-inset-2/3'
  | 'lg:-inset-2/3'
  | 'xl:-inset-2/3'
  | 'sm:-inset-x-2/3'
  | 'md:-inset-x-2/3'
  | 'mg:-inset-x-2/3'
  | 'lg:-inset-x-2/3'
  | 'xl:-inset-x-2/3'
  | 'sm:-inset-y-2/3'
  | 'md:-inset-y-2/3'
  | 'mg:-inset-y-2/3'
  | 'lg:-inset-y-2/3'
  | 'xl:-inset-y-2/3'
  | 'sm:-top-2/3'
  | 'md:-top-2/3'
  | 'mg:-top-2/3'
  | 'lg:-top-2/3'
  | 'xl:-top-2/3'
  | 'sm:-right-2/3'
  | 'md:-right-2/3'
  | 'mg:-right-2/3'
  | 'lg:-right-2/3'
  | 'xl:-right-2/3'
  | 'sm:-bottom-2/3'
  | 'md:-bottom-2/3'
  | 'mg:-bottom-2/3'
  | 'lg:-bottom-2/3'
  | 'xl:-bottom-2/3'
  | 'sm:-left-2/3'
  | 'md:-left-2/3'
  | 'mg:-left-2/3'
  | 'lg:-left-2/3'
  | 'xl:-left-2/3'
  | 'sm:-inset-1/4'
  | 'md:-inset-1/4'
  | 'mg:-inset-1/4'
  | 'lg:-inset-1/4'
  | 'xl:-inset-1/4'
  | 'sm:-inset-x-1/4'
  | 'md:-inset-x-1/4'
  | 'mg:-inset-x-1/4'
  | 'lg:-inset-x-1/4'
  | 'xl:-inset-x-1/4'
  | 'sm:-inset-y-1/4'
  | 'md:-inset-y-1/4'
  | 'mg:-inset-y-1/4'
  | 'lg:-inset-y-1/4'
  | 'xl:-inset-y-1/4'
  | 'sm:-top-1/4'
  | 'md:-top-1/4'
  | 'mg:-top-1/4'
  | 'lg:-top-1/4'
  | 'xl:-top-1/4'
  | 'sm:-right-1/4'
  | 'md:-right-1/4'
  | 'mg:-right-1/4'
  | 'lg:-right-1/4'
  | 'xl:-right-1/4'
  | 'sm:-bottom-1/4'
  | 'md:-bottom-1/4'
  | 'mg:-bottom-1/4'
  | 'lg:-bottom-1/4'
  | 'xl:-bottom-1/4'
  | 'sm:-left-1/4'
  | 'md:-left-1/4'
  | 'mg:-left-1/4'
  | 'lg:-left-1/4'
  | 'xl:-left-1/4'
  | 'sm:-inset-2/4'
  | 'md:-inset-2/4'
  | 'mg:-inset-2/4'
  | 'lg:-inset-2/4'
  | 'xl:-inset-2/4'
  | 'sm:-inset-x-2/4'
  | 'md:-inset-x-2/4'
  | 'mg:-inset-x-2/4'
  | 'lg:-inset-x-2/4'
  | 'xl:-inset-x-2/4'
  | 'sm:-inset-y-2/4'
  | 'md:-inset-y-2/4'
  | 'mg:-inset-y-2/4'
  | 'lg:-inset-y-2/4'
  | 'xl:-inset-y-2/4'
  | 'sm:-top-2/4'
  | 'md:-top-2/4'
  | 'mg:-top-2/4'
  | 'lg:-top-2/4'
  | 'xl:-top-2/4'
  | 'sm:-right-2/4'
  | 'md:-right-2/4'
  | 'mg:-right-2/4'
  | 'lg:-right-2/4'
  | 'xl:-right-2/4'
  | 'sm:-bottom-2/4'
  | 'md:-bottom-2/4'
  | 'mg:-bottom-2/4'
  | 'lg:-bottom-2/4'
  | 'xl:-bottom-2/4'
  | 'sm:-left-2/4'
  | 'md:-left-2/4'
  | 'mg:-left-2/4'
  | 'lg:-left-2/4'
  | 'xl:-left-2/4'
  | 'sm:-inset-3/4'
  | 'md:-inset-3/4'
  | 'mg:-inset-3/4'
  | 'lg:-inset-3/4'
  | 'xl:-inset-3/4'
  | 'sm:-inset-x-3/4'
  | 'md:-inset-x-3/4'
  | 'mg:-inset-x-3/4'
  | 'lg:-inset-x-3/4'
  | 'xl:-inset-x-3/4'
  | 'sm:-inset-y-3/4'
  | 'md:-inset-y-3/4'
  | 'mg:-inset-y-3/4'
  | 'lg:-inset-y-3/4'
  | 'xl:-inset-y-3/4'
  | 'sm:-top-3/4'
  | 'md:-top-3/4'
  | 'mg:-top-3/4'
  | 'lg:-top-3/4'
  | 'xl:-top-3/4'
  | 'sm:-right-3/4'
  | 'md:-right-3/4'
  | 'mg:-right-3/4'
  | 'lg:-right-3/4'
  | 'xl:-right-3/4'
  | 'sm:-bottom-3/4'
  | 'md:-bottom-3/4'
  | 'mg:-bottom-3/4'
  | 'lg:-bottom-3/4'
  | 'xl:-bottom-3/4'
  | 'sm:-left-3/4'
  | 'md:-left-3/4'
  | 'mg:-left-3/4'
  | 'lg:-left-3/4'
  | 'xl:-left-3/4'
  | 'sm:-inset-full'
  | 'md:-inset-full'
  | 'mg:-inset-full'
  | 'lg:-inset-full'
  | 'xl:-inset-full'
  | 'sm:-inset-x-full'
  | 'md:-inset-x-full'
  | 'mg:-inset-x-full'
  | 'lg:-inset-x-full'
  | 'xl:-inset-x-full'
  | 'sm:-inset-y-full'
  | 'md:-inset-y-full'
  | 'mg:-inset-y-full'
  | 'lg:-inset-y-full'
  | 'xl:-inset-y-full'
  | 'sm:-top-full'
  | 'md:-top-full'
  | 'mg:-top-full'
  | 'lg:-top-full'
  | 'xl:-top-full'
  | 'sm:-right-full'
  | 'md:-right-full'
  | 'mg:-right-full'
  | 'lg:-right-full'
  | 'xl:-right-full'
  | 'sm:-bottom-full'
  | 'md:-bottom-full'
  | 'mg:-bottom-full'
  | 'lg:-bottom-full'
  | 'xl:-bottom-full'
  | 'sm:-left-full'
  | 'md:-left-full'
  | 'mg:-left-full'
  | 'lg:-left-full'
  | 'xl:-left-full'
  | 'sm:inset-4.5'
  | 'md:inset-4.5'
  | 'mg:inset-4.5'
  | 'lg:inset-4.5'
  | 'xl:inset-4.5'
  | 'sm:inset-x-4.5'
  | 'md:inset-x-4.5'
  | 'mg:inset-x-4.5'
  | 'lg:inset-x-4.5'
  | 'xl:inset-x-4.5'
  | 'sm:inset-y-4.5'
  | 'md:inset-y-4.5'
  | 'mg:inset-y-4.5'
  | 'lg:inset-y-4.5'
  | 'xl:inset-y-4.5'
  | 'sm:top-4.5'
  | 'md:top-4.5'
  | 'mg:top-4.5'
  | 'lg:top-4.5'
  | 'xl:top-4.5'
  | 'sm:right-4.5'
  | 'md:right-4.5'
  | 'mg:right-4.5'
  | 'lg:right-4.5'
  | 'xl:right-4.5'
  | 'sm:bottom-4.5'
  | 'md:bottom-4.5'
  | 'mg:bottom-4.5'
  | 'lg:bottom-4.5'
  | 'xl:bottom-4.5'
  | 'sm:left-4.5'
  | 'md:left-4.5'
  | 'mg:left-4.5'
  | 'lg:left-4.5'
  | 'xl:left-4.5'
  | 'sm:inset-7.5'
  | 'md:inset-7.5'
  | 'mg:inset-7.5'
  | 'lg:inset-7.5'
  | 'xl:inset-7.5'
  | 'sm:inset-x-7.5'
  | 'md:inset-x-7.5'
  | 'mg:inset-x-7.5'
  | 'lg:inset-x-7.5'
  | 'xl:inset-x-7.5'
  | 'sm:inset-y-7.5'
  | 'md:inset-y-7.5'
  | 'mg:inset-y-7.5'
  | 'lg:inset-y-7.5'
  | 'xl:inset-y-7.5'
  | 'sm:top-7.5'
  | 'md:top-7.5'
  | 'mg:top-7.5'
  | 'lg:top-7.5'
  | 'xl:top-7.5'
  | 'sm:right-7.5'
  | 'md:right-7.5'
  | 'mg:right-7.5'
  | 'lg:right-7.5'
  | 'xl:right-7.5'
  | 'sm:bottom-7.5'
  | 'md:bottom-7.5'
  | 'mg:bottom-7.5'
  | 'lg:bottom-7.5'
  | 'xl:bottom-7.5'
  | 'sm:left-7.5'
  | 'md:left-7.5'
  | 'mg:left-7.5'
  | 'lg:left-7.5'
  | 'xl:left-7.5'
  | 'sm:inset-9.5'
  | 'md:inset-9.5'
  | 'mg:inset-9.5'
  | 'lg:inset-9.5'
  | 'xl:inset-9.5'
  | 'sm:inset-x-9.5'
  | 'md:inset-x-9.5'
  | 'mg:inset-x-9.5'
  | 'lg:inset-x-9.5'
  | 'xl:inset-x-9.5'
  | 'sm:inset-y-9.5'
  | 'md:inset-y-9.5'
  | 'mg:inset-y-9.5'
  | 'lg:inset-y-9.5'
  | 'xl:inset-y-9.5'
  | 'sm:top-9.5'
  | 'md:top-9.5'
  | 'mg:top-9.5'
  | 'lg:top-9.5'
  | 'xl:top-9.5'
  | 'sm:right-9.5'
  | 'md:right-9.5'
  | 'mg:right-9.5'
  | 'lg:right-9.5'
  | 'xl:right-9.5'
  | 'sm:bottom-9.5'
  | 'md:bottom-9.5'
  | 'mg:bottom-9.5'
  | 'lg:bottom-9.5'
  | 'xl:bottom-9.5'
  | 'sm:left-9.5'
  | 'md:left-9.5'
  | 'mg:left-9.5'
  | 'lg:left-9.5'
  | 'xl:left-9.5'
  | 'sm:inset-11.5'
  | 'md:inset-11.5'
  | 'mg:inset-11.5'
  | 'lg:inset-11.5'
  | 'xl:inset-11.5'
  | 'sm:inset-x-11.5'
  | 'md:inset-x-11.5'
  | 'mg:inset-x-11.5'
  | 'lg:inset-x-11.5'
  | 'xl:inset-x-11.5'
  | 'sm:inset-y-11.5'
  | 'md:inset-y-11.5'
  | 'mg:inset-y-11.5'
  | 'lg:inset-y-11.5'
  | 'xl:inset-y-11.5'
  | 'sm:top-11.5'
  | 'md:top-11.5'
  | 'mg:top-11.5'
  | 'lg:top-11.5'
  | 'xl:top-11.5'
  | 'sm:right-11.5'
  | 'md:right-11.5'
  | 'mg:right-11.5'
  | 'lg:right-11.5'
  | 'xl:right-11.5'
  | 'sm:bottom-11.5'
  | 'md:bottom-11.5'
  | 'mg:bottom-11.5'
  | 'lg:bottom-11.5'
  | 'xl:bottom-11.5'
  | 'sm:left-11.5'
  | 'md:left-11.5'
  | 'mg:left-11.5'
  | 'lg:left-11.5'
  | 'xl:left-11.5'
  | 'sm:-inset-15'
  | 'md:-inset-15'
  | 'mg:-inset-15'
  | 'lg:-inset-15'
  | 'xl:-inset-15'
  | 'sm:-inset-x-15'
  | 'md:-inset-x-15'
  | 'mg:-inset-x-15'
  | 'lg:-inset-x-15'
  | 'xl:-inset-x-15'
  | 'sm:-inset-y-15'
  | 'md:-inset-y-15'
  | 'mg:-inset-y-15'
  | 'lg:-inset-y-15'
  | 'xl:-inset-y-15'
  | 'sm:-top-15'
  | 'md:-top-15'
  | 'mg:-top-15'
  | 'lg:-top-15'
  | 'xl:-top-15'
  | 'sm:-right-15'
  | 'md:-right-15'
  | 'mg:-right-15'
  | 'lg:-right-15'
  | 'xl:-right-15'
  | 'sm:-bottom-15'
  | 'md:-bottom-15'
  | 'mg:-bottom-15'
  | 'lg:-bottom-15'
  | 'xl:-bottom-15'
  | 'sm:-left-15'
  | 'md:-left-15'
  | 'mg:-left-15'
  | 'lg:-left-15'
  | 'xl:-left-15'
  | 'sm:-inset-17'
  | 'md:-inset-17'
  | 'mg:-inset-17'
  | 'lg:-inset-17'
  | 'xl:-inset-17'
  | 'sm:-inset-x-17'
  | 'md:-inset-x-17'
  | 'mg:-inset-x-17'
  | 'lg:-inset-x-17'
  | 'xl:-inset-x-17'
  | 'sm:-inset-y-17'
  | 'md:-inset-y-17'
  | 'mg:-inset-y-17'
  | 'lg:-inset-y-17'
  | 'xl:-inset-y-17'
  | 'sm:-top-17'
  | 'md:-top-17'
  | 'mg:-top-17'
  | 'lg:-top-17'
  | 'xl:-top-17'
  | 'sm:-right-17'
  | 'md:-right-17'
  | 'mg:-right-17'
  | 'lg:-right-17'
  | 'xl:-right-17'
  | 'sm:-bottom-17'
  | 'md:-bottom-17'
  | 'mg:-bottom-17'
  | 'lg:-bottom-17'
  | 'xl:-bottom-17'
  | 'sm:-left-17'
  | 'md:-left-17'
  | 'mg:-left-17'
  | 'lg:-left-17'
  | 'xl:-left-17'
  | 'sm:-inset-18'
  | 'md:-inset-18'
  | 'mg:-inset-18'
  | 'lg:-inset-18'
  | 'xl:-inset-18'
  | 'sm:-inset-x-18'
  | 'md:-inset-x-18'
  | 'mg:-inset-x-18'
  | 'lg:-inset-x-18'
  | 'xl:-inset-x-18'
  | 'sm:-inset-y-18'
  | 'md:-inset-y-18'
  | 'mg:-inset-y-18'
  | 'lg:-inset-y-18'
  | 'xl:-inset-y-18'
  | 'sm:-top-18'
  | 'md:-top-18'
  | 'mg:-top-18'
  | 'lg:-top-18'
  | 'xl:-top-18'
  | 'sm:-right-18'
  | 'md:-right-18'
  | 'mg:-right-18'
  | 'lg:-right-18'
  | 'xl:-right-18'
  | 'sm:-bottom-18'
  | 'md:-bottom-18'
  | 'mg:-bottom-18'
  | 'lg:-bottom-18'
  | 'xl:-bottom-18'
  | 'sm:-left-18'
  | 'md:-left-18'
  | 'mg:-left-18'
  | 'lg:-left-18'
  | 'xl:-left-18'
  | 'sm:-inset-21'
  | 'md:-inset-21'
  | 'mg:-inset-21'
  | 'lg:-inset-21'
  | 'xl:-inset-21'
  | 'sm:-inset-x-21'
  | 'md:-inset-x-21'
  | 'mg:-inset-x-21'
  | 'lg:-inset-x-21'
  | 'xl:-inset-x-21'
  | 'sm:-inset-y-21'
  | 'md:-inset-y-21'
  | 'mg:-inset-y-21'
  | 'lg:-inset-y-21'
  | 'xl:-inset-y-21'
  | 'sm:-top-21'
  | 'md:-top-21'
  | 'mg:-top-21'
  | 'lg:-top-21'
  | 'xl:-top-21'
  | 'sm:-right-21'
  | 'md:-right-21'
  | 'mg:-right-21'
  | 'lg:-right-21'
  | 'xl:-right-21'
  | 'sm:-bottom-21'
  | 'md:-bottom-21'
  | 'mg:-bottom-21'
  | 'lg:-bottom-21'
  | 'xl:-bottom-21'
  | 'sm:-left-21'
  | 'md:-left-21'
  | 'mg:-left-21'
  | 'lg:-left-21'
  | 'xl:-left-21'
  | 'sm:-inset-22'
  | 'md:-inset-22'
  | 'mg:-inset-22'
  | 'lg:-inset-22'
  | 'xl:-inset-22'
  | 'sm:-inset-x-22'
  | 'md:-inset-x-22'
  | 'mg:-inset-x-22'
  | 'lg:-inset-x-22'
  | 'xl:-inset-x-22'
  | 'sm:-inset-y-22'
  | 'md:-inset-y-22'
  | 'mg:-inset-y-22'
  | 'lg:-inset-y-22'
  | 'xl:-inset-y-22'
  | 'sm:-top-22'
  | 'md:-top-22'
  | 'mg:-top-22'
  | 'lg:-top-22'
  | 'xl:-top-22'
  | 'sm:-right-22'
  | 'md:-right-22'
  | 'mg:-right-22'
  | 'lg:-right-22'
  | 'xl:-right-22'
  | 'sm:-bottom-22'
  | 'md:-bottom-22'
  | 'mg:-bottom-22'
  | 'lg:-bottom-22'
  | 'xl:-bottom-22'
  | 'sm:-left-22'
  | 'md:-left-22'
  | 'mg:-left-22'
  | 'lg:-left-22'
  | 'xl:-left-22'
  | 'sm:-inset-30'
  | 'md:-inset-30'
  | 'mg:-inset-30'
  | 'lg:-inset-30'
  | 'xl:-inset-30'
  | 'sm:-inset-x-30'
  | 'md:-inset-x-30'
  | 'mg:-inset-x-30'
  | 'lg:-inset-x-30'
  | 'xl:-inset-x-30'
  | 'sm:-inset-y-30'
  | 'md:-inset-y-30'
  | 'mg:-inset-y-30'
  | 'lg:-inset-y-30'
  | 'xl:-inset-y-30'
  | 'sm:-top-30'
  | 'md:-top-30'
  | 'mg:-top-30'
  | 'lg:-top-30'
  | 'xl:-top-30'
  | 'sm:-right-30'
  | 'md:-right-30'
  | 'mg:-right-30'
  | 'lg:-right-30'
  | 'xl:-right-30'
  | 'sm:-bottom-30'
  | 'md:-bottom-30'
  | 'mg:-bottom-30'
  | 'lg:-bottom-30'
  | 'xl:-bottom-30'
  | 'sm:-left-30'
  | 'md:-left-30'
  | 'mg:-left-30'
  | 'lg:-left-30'
  | 'xl:-left-30'
  | 'sm:-inset-4.5'
  | 'md:-inset-4.5'
  | 'mg:-inset-4.5'
  | 'lg:-inset-4.5'
  | 'xl:-inset-4.5'
  | 'sm:-inset-x-4.5'
  | 'md:-inset-x-4.5'
  | 'mg:-inset-x-4.5'
  | 'lg:-inset-x-4.5'
  | 'xl:-inset-x-4.5'
  | 'sm:-inset-y-4.5'
  | 'md:-inset-y-4.5'
  | 'mg:-inset-y-4.5'
  | 'lg:-inset-y-4.5'
  | 'xl:-inset-y-4.5'
  | 'sm:-top-4.5'
  | 'md:-top-4.5'
  | 'mg:-top-4.5'
  | 'lg:-top-4.5'
  | 'xl:-top-4.5'
  | 'sm:-right-4.5'
  | 'md:-right-4.5'
  | 'mg:-right-4.5'
  | 'lg:-right-4.5'
  | 'xl:-right-4.5'
  | 'sm:-bottom-4.5'
  | 'md:-bottom-4.5'
  | 'mg:-bottom-4.5'
  | 'lg:-bottom-4.5'
  | 'xl:-bottom-4.5'
  | 'sm:-left-4.5'
  | 'md:-left-4.5'
  | 'mg:-left-4.5'
  | 'lg:-left-4.5'
  | 'xl:-left-4.5'
  | 'sm:-inset-7.5'
  | 'md:-inset-7.5'
  | 'mg:-inset-7.5'
  | 'lg:-inset-7.5'
  | 'xl:-inset-7.5'
  | 'sm:-inset-x-7.5'
  | 'md:-inset-x-7.5'
  | 'mg:-inset-x-7.5'
  | 'lg:-inset-x-7.5'
  | 'xl:-inset-x-7.5'
  | 'sm:-inset-y-7.5'
  | 'md:-inset-y-7.5'
  | 'mg:-inset-y-7.5'
  | 'lg:-inset-y-7.5'
  | 'xl:-inset-y-7.5'
  | 'sm:-top-7.5'
  | 'md:-top-7.5'
  | 'mg:-top-7.5'
  | 'lg:-top-7.5'
  | 'xl:-top-7.5'
  | 'sm:-right-7.5'
  | 'md:-right-7.5'
  | 'mg:-right-7.5'
  | 'lg:-right-7.5'
  | 'xl:-right-7.5'
  | 'sm:-bottom-7.5'
  | 'md:-bottom-7.5'
  | 'mg:-bottom-7.5'
  | 'lg:-bottom-7.5'
  | 'xl:-bottom-7.5'
  | 'sm:-left-7.5'
  | 'md:-left-7.5'
  | 'mg:-left-7.5'
  | 'lg:-left-7.5'
  | 'xl:-left-7.5'
  | 'sm:-inset-9.5'
  | 'md:-inset-9.5'
  | 'mg:-inset-9.5'
  | 'lg:-inset-9.5'
  | 'xl:-inset-9.5'
  | 'sm:-inset-x-9.5'
  | 'md:-inset-x-9.5'
  | 'mg:-inset-x-9.5'
  | 'lg:-inset-x-9.5'
  | 'xl:-inset-x-9.5'
  | 'sm:-inset-y-9.5'
  | 'md:-inset-y-9.5'
  | 'mg:-inset-y-9.5'
  | 'lg:-inset-y-9.5'
  | 'xl:-inset-y-9.5'
  | 'sm:-top-9.5'
  | 'md:-top-9.5'
  | 'mg:-top-9.5'
  | 'lg:-top-9.5'
  | 'xl:-top-9.5'
  | 'sm:-right-9.5'
  | 'md:-right-9.5'
  | 'mg:-right-9.5'
  | 'lg:-right-9.5'
  | 'xl:-right-9.5'
  | 'sm:-bottom-9.5'
  | 'md:-bottom-9.5'
  | 'mg:-bottom-9.5'
  | 'lg:-bottom-9.5'
  | 'xl:-bottom-9.5'
  | 'sm:-left-9.5'
  | 'md:-left-9.5'
  | 'mg:-left-9.5'
  | 'lg:-left-9.5'
  | 'xl:-left-9.5'
  | 'sm:-inset-11.5'
  | 'md:-inset-11.5'
  | 'mg:-inset-11.5'
  | 'lg:-inset-11.5'
  | 'xl:-inset-11.5'
  | 'sm:-inset-x-11.5'
  | 'md:-inset-x-11.5'
  | 'mg:-inset-x-11.5'
  | 'lg:-inset-x-11.5'
  | 'xl:-inset-x-11.5'
  | 'sm:-inset-y-11.5'
  | 'md:-inset-y-11.5'
  | 'mg:-inset-y-11.5'
  | 'lg:-inset-y-11.5'
  | 'xl:-inset-y-11.5'
  | 'sm:-top-11.5'
  | 'md:-top-11.5'
  | 'mg:-top-11.5'
  | 'lg:-top-11.5'
  | 'xl:-top-11.5'
  | 'sm:-right-11.5'
  | 'md:-right-11.5'
  | 'mg:-right-11.5'
  | 'lg:-right-11.5'
  | 'xl:-right-11.5'
  | 'sm:-bottom-11.5'
  | 'md:-bottom-11.5'
  | 'mg:-bottom-11.5'
  | 'lg:-bottom-11.5'
  | 'xl:-bottom-11.5'
  | 'sm:-left-11.5'
  | 'md:-left-11.5'
  | 'mg:-left-11.5'
  | 'lg:-left-11.5'
  | 'xl:-left-11.5'
  | 'sm:invert-0'
  | 'md:invert-0'
  | 'mg:invert-0'
  | 'lg:invert-0'
  | 'xl:invert-0'
  | 'sm:invert'
  | 'md:invert'
  | 'mg:invert'
  | 'lg:invert'
  | 'xl:invert'
  | 'sm:isolate'
  | 'md:isolate'
  | 'mg:isolate'
  | 'lg:isolate'
  | 'xl:isolate'
  | 'sm:isolation-auto'
  | 'md:isolation-auto'
  | 'mg:isolation-auto'
  | 'lg:isolation-auto'
  | 'xl:isolation-auto'
  | 'sm:justify-start'
  | 'md:justify-start'
  | 'mg:justify-start'
  | 'lg:justify-start'
  | 'xl:justify-start'
  | 'sm:justify-center'
  | 'md:justify-center'
  | 'mg:justify-center'
  | 'lg:justify-center'
  | 'xl:justify-center'
  | 'sm:justify-end'
  | 'md:justify-end'
  | 'mg:justify-end'
  | 'lg:justify-end'
  | 'xl:justify-end'
  | 'sm:justify-between'
  | 'md:justify-between'
  | 'mg:justify-between'
  | 'lg:justify-between'
  | 'xl:justify-between'
  | 'sm:justify-around'
  | 'md:justify-around'
  | 'mg:justify-around'
  | 'lg:justify-around'
  | 'xl:justify-around'
  | 'sm:justify-evenly'
  | 'md:justify-evenly'
  | 'mg:justify-evenly'
  | 'lg:justify-evenly'
  | 'xl:justify-evenly'
  | 'sm:justify-items-auto'
  | 'md:justify-items-auto'
  | 'mg:justify-items-auto'
  | 'lg:justify-items-auto'
  | 'xl:justify-items-auto'
  | 'sm:justify-items-start'
  | 'md:justify-items-start'
  | 'mg:justify-items-start'
  | 'lg:justify-items-start'
  | 'xl:justify-items-start'
  | 'sm:justify-items-center'
  | 'md:justify-items-center'
  | 'mg:justify-items-center'
  | 'lg:justify-items-center'
  | 'xl:justify-items-center'
  | 'sm:justify-items-end'
  | 'md:justify-items-end'
  | 'mg:justify-items-end'
  | 'lg:justify-items-end'
  | 'xl:justify-items-end'
  | 'sm:justify-items-stretch'
  | 'md:justify-items-stretch'
  | 'mg:justify-items-stretch'
  | 'lg:justify-items-stretch'
  | 'xl:justify-items-stretch'
  | 'sm:justify-self-auto'
  | 'md:justify-self-auto'
  | 'mg:justify-self-auto'
  | 'lg:justify-self-auto'
  | 'xl:justify-self-auto'
  | 'sm:justify-self-start'
  | 'md:justify-self-start'
  | 'mg:justify-self-start'
  | 'lg:justify-self-start'
  | 'xl:justify-self-start'
  | 'sm:justify-self-center'
  | 'md:justify-self-center'
  | 'mg:justify-self-center'
  | 'lg:justify-self-center'
  | 'xl:justify-self-center'
  | 'sm:justify-self-end'
  | 'md:justify-self-end'
  | 'mg:justify-self-end'
  | 'lg:justify-self-end'
  | 'xl:justify-self-end'
  | 'sm:justify-self-stretch'
  | 'md:justify-self-stretch'
  | 'mg:justify-self-stretch'
  | 'lg:justify-self-stretch'
  | 'xl:justify-self-stretch'
  | 'sm:tracking-tightest'
  | 'md:tracking-tightest'
  | 'mg:tracking-tightest'
  | 'lg:tracking-tightest'
  | 'xl:tracking-tightest'
  | 'sm:tracking-tighter'
  | 'md:tracking-tighter'
  | 'mg:tracking-tighter'
  | 'lg:tracking-tighter'
  | 'xl:tracking-tighter'
  | 'sm:tracking-tight'
  | 'md:tracking-tight'
  | 'mg:tracking-tight'
  | 'lg:tracking-tight'
  | 'xl:tracking-tight'
  | 'sm:tracking-normal'
  | 'md:tracking-normal'
  | 'mg:tracking-normal'
  | 'lg:tracking-normal'
  | 'xl:tracking-normal'
  | 'sm:tracking-wide'
  | 'md:tracking-wide'
  | 'mg:tracking-wide'
  | 'lg:tracking-wide'
  | 'xl:tracking-wide'
  | 'sm:tracking-wider'
  | 'md:tracking-wider'
  | 'mg:tracking-wider'
  | 'lg:tracking-wider'
  | 'xl:tracking-wider'
  | 'sm:tracking-widest'
  | 'md:tracking-widest'
  | 'mg:tracking-widest'
  | 'lg:tracking-widest'
  | 'xl:tracking-widest'
  | 'sm:leading-0'
  | 'md:leading-0'
  | 'mg:leading-0'
  | 'lg:leading-0'
  | 'xl:leading-0'
  | 'sm:leading-3'
  | 'md:leading-3'
  | 'mg:leading-3'
  | 'lg:leading-3'
  | 'xl:leading-3'
  | 'sm:leading-4'
  | 'md:leading-4'
  | 'mg:leading-4'
  | 'lg:leading-4'
  | 'xl:leading-4'
  | 'sm:leading-5'
  | 'md:leading-5'
  | 'mg:leading-5'
  | 'lg:leading-5'
  | 'xl:leading-5'
  | 'sm:leading-6'
  | 'md:leading-6'
  | 'mg:leading-6'
  | 'lg:leading-6'
  | 'xl:leading-6'
  | 'sm:leading-7'
  | 'md:leading-7'
  | 'mg:leading-7'
  | 'lg:leading-7'
  | 'xl:leading-7'
  | 'sm:leading-8'
  | 'md:leading-8'
  | 'mg:leading-8'
  | 'lg:leading-8'
  | 'xl:leading-8'
  | 'sm:leading-9'
  | 'md:leading-9'
  | 'mg:leading-9'
  | 'lg:leading-9'
  | 'xl:leading-9'
  | 'sm:leading-10'
  | 'md:leading-10'
  | 'mg:leading-10'
  | 'lg:leading-10'
  | 'xl:leading-10'
  | 'sm:leading-12'
  | 'md:leading-12'
  | 'mg:leading-12'
  | 'lg:leading-12'
  | 'xl:leading-12'
  | 'sm:leading-none'
  | 'md:leading-none'
  | 'mg:leading-none'
  | 'lg:leading-none'
  | 'xl:leading-none'
  | 'sm:leading-tight'
  | 'md:leading-tight'
  | 'mg:leading-tight'
  | 'lg:leading-tight'
  | 'xl:leading-tight'
  | 'sm:leading-snug'
  | 'md:leading-snug'
  | 'mg:leading-snug'
  | 'lg:leading-snug'
  | 'xl:leading-snug'
  | 'sm:leading-normal'
  | 'md:leading-normal'
  | 'mg:leading-normal'
  | 'lg:leading-normal'
  | 'xl:leading-normal'
  | 'sm:leading-relaxed'
  | 'md:leading-relaxed'
  | 'mg:leading-relaxed'
  | 'lg:leading-relaxed'
  | 'xl:leading-relaxed'
  | 'sm:leading-loose'
  | 'md:leading-loose'
  | 'mg:leading-loose'
  | 'lg:leading-loose'
  | 'xl:leading-loose'
  | 'sm:list-inside'
  | 'md:list-inside'
  | 'mg:list-inside'
  | 'lg:list-inside'
  | 'xl:list-inside'
  | 'sm:list-outside'
  | 'md:list-outside'
  | 'mg:list-outside'
  | 'lg:list-outside'
  | 'xl:list-outside'
  | 'sm:list-none'
  | 'md:list-none'
  | 'mg:list-none'
  | 'lg:list-none'
  | 'xl:list-none'
  | 'sm:list-disc'
  | 'md:list-disc'
  | 'mg:list-disc'
  | 'lg:list-disc'
  | 'xl:list-disc'
  | 'sm:list-decimal'
  | 'md:list-decimal'
  | 'mg:list-decimal'
  | 'lg:list-decimal'
  | 'xl:list-decimal'
  | 'sm:m-0'
  | 'md:m-0'
  | 'mg:m-0'
  | 'lg:m-0'
  | 'xl:m-0'
  | 'sm:m-1'
  | 'md:m-1'
  | 'mg:m-1'
  | 'lg:m-1'
  | 'xl:m-1'
  | 'sm:m-2'
  | 'md:m-2'
  | 'mg:m-2'
  | 'lg:m-2'
  | 'xl:m-2'
  | 'sm:m-3'
  | 'md:m-3'
  | 'mg:m-3'
  | 'lg:m-3'
  | 'xl:m-3'
  | 'sm:m-4'
  | 'md:m-4'
  | 'mg:m-4'
  | 'lg:m-4'
  | 'xl:m-4'
  | 'sm:m-5'
  | 'md:m-5'
  | 'mg:m-5'
  | 'lg:m-5'
  | 'xl:m-5'
  | 'sm:m-6'
  | 'md:m-6'
  | 'mg:m-6'
  | 'lg:m-6'
  | 'xl:m-6'
  | 'sm:m-7'
  | 'md:m-7'
  | 'mg:m-7'
  | 'lg:m-7'
  | 'xl:m-7'
  | 'sm:m-8'
  | 'md:m-8'
  | 'mg:m-8'
  | 'lg:m-8'
  | 'xl:m-8'
  | 'sm:m-9'
  | 'md:m-9'
  | 'mg:m-9'
  | 'lg:m-9'
  | 'xl:m-9'
  | 'sm:m-10'
  | 'md:m-10'
  | 'mg:m-10'
  | 'lg:m-10'
  | 'xl:m-10'
  | 'sm:m-11'
  | 'md:m-11'
  | 'mg:m-11'
  | 'lg:m-11'
  | 'xl:m-11'
  | 'sm:m-12'
  | 'md:m-12'
  | 'mg:m-12'
  | 'lg:m-12'
  | 'xl:m-12'
  | 'sm:m-14'
  | 'md:m-14'
  | 'mg:m-14'
  | 'lg:m-14'
  | 'xl:m-14'
  | 'sm:m-15'
  | 'md:m-15'
  | 'mg:m-15'
  | 'lg:m-15'
  | 'xl:m-15'
  | 'sm:m-16'
  | 'md:m-16'
  | 'mg:m-16'
  | 'lg:m-16'
  | 'xl:m-16'
  | 'sm:m-17'
  | 'md:m-17'
  | 'mg:m-17'
  | 'lg:m-17'
  | 'xl:m-17'
  | 'sm:m-18'
  | 'md:m-18'
  | 'mg:m-18'
  | 'lg:m-18'
  | 'xl:m-18'
  | 'sm:m-20'
  | 'md:m-20'
  | 'mg:m-20'
  | 'lg:m-20'
  | 'xl:m-20'
  | 'sm:m-21'
  | 'md:m-21'
  | 'mg:m-21'
  | 'lg:m-21'
  | 'xl:m-21'
  | 'sm:m-22'
  | 'md:m-22'
  | 'mg:m-22'
  | 'lg:m-22'
  | 'xl:m-22'
  | 'sm:m-24'
  | 'md:m-24'
  | 'mg:m-24'
  | 'lg:m-24'
  | 'xl:m-24'
  | 'sm:m-28'
  | 'md:m-28'
  | 'mg:m-28'
  | 'lg:m-28'
  | 'xl:m-28'
  | 'sm:m-30'
  | 'md:m-30'
  | 'mg:m-30'
  | 'lg:m-30'
  | 'xl:m-30'
  | 'sm:m-32'
  | 'md:m-32'
  | 'mg:m-32'
  | 'lg:m-32'
  | 'xl:m-32'
  | 'sm:m-36'
  | 'md:m-36'
  | 'mg:m-36'
  | 'lg:m-36'
  | 'xl:m-36'
  | 'sm:m-40'
  | 'md:m-40'
  | 'mg:m-40'
  | 'lg:m-40'
  | 'xl:m-40'
  | 'sm:m-44'
  | 'md:m-44'
  | 'mg:m-44'
  | 'lg:m-44'
  | 'xl:m-44'
  | 'sm:m-48'
  | 'md:m-48'
  | 'mg:m-48'
  | 'lg:m-48'
  | 'xl:m-48'
  | 'sm:m-52'
  | 'md:m-52'
  | 'mg:m-52'
  | 'lg:m-52'
  | 'xl:m-52'
  | 'sm:m-56'
  | 'md:m-56'
  | 'mg:m-56'
  | 'lg:m-56'
  | 'xl:m-56'
  | 'sm:m-60'
  | 'md:m-60'
  | 'mg:m-60'
  | 'lg:m-60'
  | 'xl:m-60'
  | 'sm:m-64'
  | 'md:m-64'
  | 'mg:m-64'
  | 'lg:m-64'
  | 'xl:m-64'
  | 'sm:m-72'
  | 'md:m-72'
  | 'mg:m-72'
  | 'lg:m-72'
  | 'xl:m-72'
  | 'sm:m-80'
  | 'md:m-80'
  | 'mg:m-80'
  | 'lg:m-80'
  | 'xl:m-80'
  | 'sm:m-96'
  | 'md:m-96'
  | 'mg:m-96'
  | 'lg:m-96'
  | 'xl:m-96'
  | 'sm:m-auto'
  | 'md:m-auto'
  | 'mg:m-auto'
  | 'lg:m-auto'
  | 'xl:m-auto'
  | 'sm:m-px'
  | 'md:m-px'
  | 'mg:m-px'
  | 'lg:m-px'
  | 'xl:m-px'
  | 'sm:m-0.5'
  | 'md:m-0.5'
  | 'mg:m-0.5'
  | 'lg:m-0.5'
  | 'xl:m-0.5'
  | 'sm:m-1.5'
  | 'md:m-1.5'
  | 'mg:m-1.5'
  | 'lg:m-1.5'
  | 'xl:m-1.5'
  | 'sm:m-2.5'
  | 'md:m-2.5'
  | 'mg:m-2.5'
  | 'lg:m-2.5'
  | 'xl:m-2.5'
  | 'sm:m-3.5'
  | 'md:m-3.5'
  | 'mg:m-3.5'
  | 'lg:m-3.5'
  | 'xl:m-3.5'
  | 'sm:-m-0'
  | 'md:-m-0'
  | 'mg:-m-0'
  | 'lg:-m-0'
  | 'xl:-m-0'
  | 'sm:-m-1'
  | 'md:-m-1'
  | 'mg:-m-1'
  | 'lg:-m-1'
  | 'xl:-m-1'
  | 'sm:-m-2'
  | 'md:-m-2'
  | 'mg:-m-2'
  | 'lg:-m-2'
  | 'xl:-m-2'
  | 'sm:-m-3'
  | 'md:-m-3'
  | 'mg:-m-3'
  | 'lg:-m-3'
  | 'xl:-m-3'
  | 'sm:-m-4'
  | 'md:-m-4'
  | 'mg:-m-4'
  | 'lg:-m-4'
  | 'xl:-m-4'
  | 'sm:-m-5'
  | 'md:-m-5'
  | 'mg:-m-5'
  | 'lg:-m-5'
  | 'xl:-m-5'
  | 'sm:-m-6'
  | 'md:-m-6'
  | 'mg:-m-6'
  | 'lg:-m-6'
  | 'xl:-m-6'
  | 'sm:-m-7'
  | 'md:-m-7'
  | 'mg:-m-7'
  | 'lg:-m-7'
  | 'xl:-m-7'
  | 'sm:-m-8'
  | 'md:-m-8'
  | 'mg:-m-8'
  | 'lg:-m-8'
  | 'xl:-m-8'
  | 'sm:-m-9'
  | 'md:-m-9'
  | 'mg:-m-9'
  | 'lg:-m-9'
  | 'xl:-m-9'
  | 'sm:-m-10'
  | 'md:-m-10'
  | 'mg:-m-10'
  | 'lg:-m-10'
  | 'xl:-m-10'
  | 'sm:-m-11'
  | 'md:-m-11'
  | 'mg:-m-11'
  | 'lg:-m-11'
  | 'xl:-m-11'
  | 'sm:-m-12'
  | 'md:-m-12'
  | 'mg:-m-12'
  | 'lg:-m-12'
  | 'xl:-m-12'
  | 'sm:-m-14'
  | 'md:-m-14'
  | 'mg:-m-14'
  | 'lg:-m-14'
  | 'xl:-m-14'
  | 'sm:-m-16'
  | 'md:-m-16'
  | 'mg:-m-16'
  | 'lg:-m-16'
  | 'xl:-m-16'
  | 'sm:-m-20'
  | 'md:-m-20'
  | 'mg:-m-20'
  | 'lg:-m-20'
  | 'xl:-m-20'
  | 'sm:-m-24'
  | 'md:-m-24'
  | 'mg:-m-24'
  | 'lg:-m-24'
  | 'xl:-m-24'
  | 'sm:-m-28'
  | 'md:-m-28'
  | 'mg:-m-28'
  | 'lg:-m-28'
  | 'xl:-m-28'
  | 'sm:-m-32'
  | 'md:-m-32'
  | 'mg:-m-32'
  | 'lg:-m-32'
  | 'xl:-m-32'
  | 'sm:-m-36'
  | 'md:-m-36'
  | 'mg:-m-36'
  | 'lg:-m-36'
  | 'xl:-m-36'
  | 'sm:-m-40'
  | 'md:-m-40'
  | 'mg:-m-40'
  | 'lg:-m-40'
  | 'xl:-m-40'
  | 'sm:-m-44'
  | 'md:-m-44'
  | 'mg:-m-44'
  | 'lg:-m-44'
  | 'xl:-m-44'
  | 'sm:-m-48'
  | 'md:-m-48'
  | 'mg:-m-48'
  | 'lg:-m-48'
  | 'xl:-m-48'
  | 'sm:-m-52'
  | 'md:-m-52'
  | 'mg:-m-52'
  | 'lg:-m-52'
  | 'xl:-m-52'
  | 'sm:-m-56'
  | 'md:-m-56'
  | 'mg:-m-56'
  | 'lg:-m-56'
  | 'xl:-m-56'
  | 'sm:-m-60'
  | 'md:-m-60'
  | 'mg:-m-60'
  | 'lg:-m-60'
  | 'xl:-m-60'
  | 'sm:-m-64'
  | 'md:-m-64'
  | 'mg:-m-64'
  | 'lg:-m-64'
  | 'xl:-m-64'
  | 'sm:-m-72'
  | 'md:-m-72'
  | 'mg:-m-72'
  | 'lg:-m-72'
  | 'xl:-m-72'
  | 'sm:-m-80'
  | 'md:-m-80'
  | 'mg:-m-80'
  | 'lg:-m-80'
  | 'xl:-m-80'
  | 'sm:-m-96'
  | 'md:-m-96'
  | 'mg:-m-96'
  | 'lg:-m-96'
  | 'xl:-m-96'
  | 'sm:-m-px'
  | 'md:-m-px'
  | 'mg:-m-px'
  | 'lg:-m-px'
  | 'xl:-m-px'
  | 'sm:-m-0.5'
  | 'md:-m-0.5'
  | 'mg:-m-0.5'
  | 'lg:-m-0.5'
  | 'xl:-m-0.5'
  | 'sm:-m-1.5'
  | 'md:-m-1.5'
  | 'mg:-m-1.5'
  | 'lg:-m-1.5'
  | 'xl:-m-1.5'
  | 'sm:-m-2.5'
  | 'md:-m-2.5'
  | 'mg:-m-2.5'
  | 'lg:-m-2.5'
  | 'xl:-m-2.5'
  | 'sm:-m-3.5'
  | 'md:-m-3.5'
  | 'mg:-m-3.5'
  | 'lg:-m-3.5'
  | 'xl:-m-3.5'
  | 'sm:m-1/2'
  | 'md:m-1/2'
  | 'mg:m-1/2'
  | 'lg:m-1/2'
  | 'xl:m-1/2'
  | 'sm:m-full'
  | 'md:m-full'
  | 'mg:m-full'
  | 'lg:m-full'
  | 'xl:m-full'
  | 'sm:m-4.5'
  | 'md:m-4.5'
  | 'mg:m-4.5'
  | 'lg:m-4.5'
  | 'xl:m-4.5'
  | 'sm:m-7.5'
  | 'md:m-7.5'
  | 'mg:m-7.5'
  | 'lg:m-7.5'
  | 'xl:m-7.5'
  | 'sm:m-9.5'
  | 'md:m-9.5'
  | 'mg:m-9.5'
  | 'lg:m-9.5'
  | 'xl:m-9.5'
  | 'sm:m-11.5'
  | 'md:m-11.5'
  | 'mg:m-11.5'
  | 'lg:m-11.5'
  | 'xl:m-11.5'
  | 'sm:-m-15'
  | 'md:-m-15'
  | 'mg:-m-15'
  | 'lg:-m-15'
  | 'xl:-m-15'
  | 'sm:-m-17'
  | 'md:-m-17'
  | 'mg:-m-17'
  | 'lg:-m-17'
  | 'xl:-m-17'
  | 'sm:-m-18'
  | 'md:-m-18'
  | 'mg:-m-18'
  | 'lg:-m-18'
  | 'xl:-m-18'
  | 'sm:-m-21'
  | 'md:-m-21'
  | 'mg:-m-21'
  | 'lg:-m-21'
  | 'xl:-m-21'
  | 'sm:-m-22'
  | 'md:-m-22'
  | 'mg:-m-22'
  | 'lg:-m-22'
  | 'xl:-m-22'
  | 'sm:-m-30'
  | 'md:-m-30'
  | 'mg:-m-30'
  | 'lg:-m-30'
  | 'xl:-m-30'
  | 'sm:-m-1/2'
  | 'md:-m-1/2'
  | 'mg:-m-1/2'
  | 'lg:-m-1/2'
  | 'xl:-m-1/2'
  | 'sm:-m-full'
  | 'md:-m-full'
  | 'mg:-m-full'
  | 'lg:-m-full'
  | 'xl:-m-full'
  | 'sm:-m-4.5'
  | 'md:-m-4.5'
  | 'mg:-m-4.5'
  | 'lg:-m-4.5'
  | 'xl:-m-4.5'
  | 'sm:-m-7.5'
  | 'md:-m-7.5'
  | 'mg:-m-7.5'
  | 'lg:-m-7.5'
  | 'xl:-m-7.5'
  | 'sm:-m-9.5'
  | 'md:-m-9.5'
  | 'mg:-m-9.5'
  | 'lg:-m-9.5'
  | 'xl:-m-9.5'
  | 'sm:-m-11.5'
  | 'md:-m-11.5'
  | 'mg:-m-11.5'
  | 'lg:-m-11.5'
  | 'xl:-m-11.5'
  | 'sm:my-0'
  | 'md:my-0'
  | 'mg:my-0'
  | 'lg:my-0'
  | 'xl:my-0'
  | 'sm:my-1'
  | 'md:my-1'
  | 'mg:my-1'
  | 'lg:my-1'
  | 'xl:my-1'
  | 'sm:my-2'
  | 'md:my-2'
  | 'mg:my-2'
  | 'lg:my-2'
  | 'xl:my-2'
  | 'sm:my-3'
  | 'md:my-3'
  | 'mg:my-3'
  | 'lg:my-3'
  | 'xl:my-3'
  | 'sm:my-4'
  | 'md:my-4'
  | 'mg:my-4'
  | 'lg:my-4'
  | 'xl:my-4'
  | 'sm:my-5'
  | 'md:my-5'
  | 'mg:my-5'
  | 'lg:my-5'
  | 'xl:my-5'
  | 'sm:my-6'
  | 'md:my-6'
  | 'mg:my-6'
  | 'lg:my-6'
  | 'xl:my-6'
  | 'sm:my-7'
  | 'md:my-7'
  | 'mg:my-7'
  | 'lg:my-7'
  | 'xl:my-7'
  | 'sm:my-8'
  | 'md:my-8'
  | 'mg:my-8'
  | 'lg:my-8'
  | 'xl:my-8'
  | 'sm:my-9'
  | 'md:my-9'
  | 'mg:my-9'
  | 'lg:my-9'
  | 'xl:my-9'
  | 'sm:my-10'
  | 'md:my-10'
  | 'mg:my-10'
  | 'lg:my-10'
  | 'xl:my-10'
  | 'sm:my-11'
  | 'md:my-11'
  | 'mg:my-11'
  | 'lg:my-11'
  | 'xl:my-11'
  | 'sm:my-12'
  | 'md:my-12'
  | 'mg:my-12'
  | 'lg:my-12'
  | 'xl:my-12'
  | 'sm:my-14'
  | 'md:my-14'
  | 'mg:my-14'
  | 'lg:my-14'
  | 'xl:my-14'
  | 'sm:my-15'
  | 'md:my-15'
  | 'mg:my-15'
  | 'lg:my-15'
  | 'xl:my-15'
  | 'sm:my-16'
  | 'md:my-16'
  | 'mg:my-16'
  | 'lg:my-16'
  | 'xl:my-16'
  | 'sm:my-17'
  | 'md:my-17'
  | 'mg:my-17'
  | 'lg:my-17'
  | 'xl:my-17'
  | 'sm:my-18'
  | 'md:my-18'
  | 'mg:my-18'
  | 'lg:my-18'
  | 'xl:my-18'
  | 'sm:my-20'
  | 'md:my-20'
  | 'mg:my-20'
  | 'lg:my-20'
  | 'xl:my-20'
  | 'sm:my-21'
  | 'md:my-21'
  | 'mg:my-21'
  | 'lg:my-21'
  | 'xl:my-21'
  | 'sm:my-22'
  | 'md:my-22'
  | 'mg:my-22'
  | 'lg:my-22'
  | 'xl:my-22'
  | 'sm:my-24'
  | 'md:my-24'
  | 'mg:my-24'
  | 'lg:my-24'
  | 'xl:my-24'
  | 'sm:my-28'
  | 'md:my-28'
  | 'mg:my-28'
  | 'lg:my-28'
  | 'xl:my-28'
  | 'sm:my-30'
  | 'md:my-30'
  | 'mg:my-30'
  | 'lg:my-30'
  | 'xl:my-30'
  | 'sm:my-32'
  | 'md:my-32'
  | 'mg:my-32'
  | 'lg:my-32'
  | 'xl:my-32'
  | 'sm:my-36'
  | 'md:my-36'
  | 'mg:my-36'
  | 'lg:my-36'
  | 'xl:my-36'
  | 'sm:my-40'
  | 'md:my-40'
  | 'mg:my-40'
  | 'lg:my-40'
  | 'xl:my-40'
  | 'sm:my-44'
  | 'md:my-44'
  | 'mg:my-44'
  | 'lg:my-44'
  | 'xl:my-44'
  | 'sm:my-48'
  | 'md:my-48'
  | 'mg:my-48'
  | 'lg:my-48'
  | 'xl:my-48'
  | 'sm:my-52'
  | 'md:my-52'
  | 'mg:my-52'
  | 'lg:my-52'
  | 'xl:my-52'
  | 'sm:my-56'
  | 'md:my-56'
  | 'mg:my-56'
  | 'lg:my-56'
  | 'xl:my-56'
  | 'sm:my-60'
  | 'md:my-60'
  | 'mg:my-60'
  | 'lg:my-60'
  | 'xl:my-60'
  | 'sm:my-64'
  | 'md:my-64'
  | 'mg:my-64'
  | 'lg:my-64'
  | 'xl:my-64'
  | 'sm:my-72'
  | 'md:my-72'
  | 'mg:my-72'
  | 'lg:my-72'
  | 'xl:my-72'
  | 'sm:my-80'
  | 'md:my-80'
  | 'mg:my-80'
  | 'lg:my-80'
  | 'xl:my-80'
  | 'sm:my-96'
  | 'md:my-96'
  | 'mg:my-96'
  | 'lg:my-96'
  | 'xl:my-96'
  | 'sm:my-auto'
  | 'md:my-auto'
  | 'mg:my-auto'
  | 'lg:my-auto'
  | 'xl:my-auto'
  | 'sm:my-px'
  | 'md:my-px'
  | 'mg:my-px'
  | 'lg:my-px'
  | 'xl:my-px'
  | 'sm:my-0.5'
  | 'md:my-0.5'
  | 'mg:my-0.5'
  | 'lg:my-0.5'
  | 'xl:my-0.5'
  | 'sm:my-1.5'
  | 'md:my-1.5'
  | 'mg:my-1.5'
  | 'lg:my-1.5'
  | 'xl:my-1.5'
  | 'sm:my-2.5'
  | 'md:my-2.5'
  | 'mg:my-2.5'
  | 'lg:my-2.5'
  | 'xl:my-2.5'
  | 'sm:my-3.5'
  | 'md:my-3.5'
  | 'mg:my-3.5'
  | 'lg:my-3.5'
  | 'xl:my-3.5'
  | 'sm:-my-0'
  | 'md:-my-0'
  | 'mg:-my-0'
  | 'lg:-my-0'
  | 'xl:-my-0'
  | 'sm:-my-1'
  | 'md:-my-1'
  | 'mg:-my-1'
  | 'lg:-my-1'
  | 'xl:-my-1'
  | 'sm:-my-2'
  | 'md:-my-2'
  | 'mg:-my-2'
  | 'lg:-my-2'
  | 'xl:-my-2'
  | 'sm:-my-3'
  | 'md:-my-3'
  | 'mg:-my-3'
  | 'lg:-my-3'
  | 'xl:-my-3'
  | 'sm:-my-4'
  | 'md:-my-4'
  | 'mg:-my-4'
  | 'lg:-my-4'
  | 'xl:-my-4'
  | 'sm:-my-5'
  | 'md:-my-5'
  | 'mg:-my-5'
  | 'lg:-my-5'
  | 'xl:-my-5'
  | 'sm:-my-6'
  | 'md:-my-6'
  | 'mg:-my-6'
  | 'lg:-my-6'
  | 'xl:-my-6'
  | 'sm:-my-7'
  | 'md:-my-7'
  | 'mg:-my-7'
  | 'lg:-my-7'
  | 'xl:-my-7'
  | 'sm:-my-8'
  | 'md:-my-8'
  | 'mg:-my-8'
  | 'lg:-my-8'
  | 'xl:-my-8'
  | 'sm:-my-9'
  | 'md:-my-9'
  | 'mg:-my-9'
  | 'lg:-my-9'
  | 'xl:-my-9'
  | 'sm:-my-10'
  | 'md:-my-10'
  | 'mg:-my-10'
  | 'lg:-my-10'
  | 'xl:-my-10'
  | 'sm:-my-11'
  | 'md:-my-11'
  | 'mg:-my-11'
  | 'lg:-my-11'
  | 'xl:-my-11'
  | 'sm:-my-12'
  | 'md:-my-12'
  | 'mg:-my-12'
  | 'lg:-my-12'
  | 'xl:-my-12'
  | 'sm:-my-14'
  | 'md:-my-14'
  | 'mg:-my-14'
  | 'lg:-my-14'
  | 'xl:-my-14'
  | 'sm:-my-16'
  | 'md:-my-16'
  | 'mg:-my-16'
  | 'lg:-my-16'
  | 'xl:-my-16'
  | 'sm:-my-20'
  | 'md:-my-20'
  | 'mg:-my-20'
  | 'lg:-my-20'
  | 'xl:-my-20'
  | 'sm:-my-24'
  | 'md:-my-24'
  | 'mg:-my-24'
  | 'lg:-my-24'
  | 'xl:-my-24'
  | 'sm:-my-28'
  | 'md:-my-28'
  | 'mg:-my-28'
  | 'lg:-my-28'
  | 'xl:-my-28'
  | 'sm:-my-32'
  | 'md:-my-32'
  | 'mg:-my-32'
  | 'lg:-my-32'
  | 'xl:-my-32'
  | 'sm:-my-36'
  | 'md:-my-36'
  | 'mg:-my-36'
  | 'lg:-my-36'
  | 'xl:-my-36'
  | 'sm:-my-40'
  | 'md:-my-40'
  | 'mg:-my-40'
  | 'lg:-my-40'
  | 'xl:-my-40'
  | 'sm:-my-44'
  | 'md:-my-44'
  | 'mg:-my-44'
  | 'lg:-my-44'
  | 'xl:-my-44'
  | 'sm:-my-48'
  | 'md:-my-48'
  | 'mg:-my-48'
  | 'lg:-my-48'
  | 'xl:-my-48'
  | 'sm:-my-52'
  | 'md:-my-52'
  | 'mg:-my-52'
  | 'lg:-my-52'
  | 'xl:-my-52'
  | 'sm:-my-56'
  | 'md:-my-56'
  | 'mg:-my-56'
  | 'lg:-my-56'
  | 'xl:-my-56'
  | 'sm:-my-60'
  | 'md:-my-60'
  | 'mg:-my-60'
  | 'lg:-my-60'
  | 'xl:-my-60'
  | 'sm:-my-64'
  | 'md:-my-64'
  | 'mg:-my-64'
  | 'lg:-my-64'
  | 'xl:-my-64'
  | 'sm:-my-72'
  | 'md:-my-72'
  | 'mg:-my-72'
  | 'lg:-my-72'
  | 'xl:-my-72'
  | 'sm:-my-80'
  | 'md:-my-80'
  | 'mg:-my-80'
  | 'lg:-my-80'
  | 'xl:-my-80'
  | 'sm:-my-96'
  | 'md:-my-96'
  | 'mg:-my-96'
  | 'lg:-my-96'
  | 'xl:-my-96'
  | 'sm:-my-px'
  | 'md:-my-px'
  | 'mg:-my-px'
  | 'lg:-my-px'
  | 'xl:-my-px'
  | 'sm:-my-0.5'
  | 'md:-my-0.5'
  | 'mg:-my-0.5'
  | 'lg:-my-0.5'
  | 'xl:-my-0.5'
  | 'sm:-my-1.5'
  | 'md:-my-1.5'
  | 'mg:-my-1.5'
  | 'lg:-my-1.5'
  | 'xl:-my-1.5'
  | 'sm:-my-2.5'
  | 'md:-my-2.5'
  | 'mg:-my-2.5'
  | 'lg:-my-2.5'
  | 'xl:-my-2.5'
  | 'sm:-my-3.5'
  | 'md:-my-3.5'
  | 'mg:-my-3.5'
  | 'lg:-my-3.5'
  | 'xl:-my-3.5'
  | 'sm:my-1/2'
  | 'md:my-1/2'
  | 'mg:my-1/2'
  | 'lg:my-1/2'
  | 'xl:my-1/2'
  | 'sm:my-full'
  | 'md:my-full'
  | 'mg:my-full'
  | 'lg:my-full'
  | 'xl:my-full'
  | 'sm:my-4.5'
  | 'md:my-4.5'
  | 'mg:my-4.5'
  | 'lg:my-4.5'
  | 'xl:my-4.5'
  | 'sm:my-7.5'
  | 'md:my-7.5'
  | 'mg:my-7.5'
  | 'lg:my-7.5'
  | 'xl:my-7.5'
  | 'sm:my-9.5'
  | 'md:my-9.5'
  | 'mg:my-9.5'
  | 'lg:my-9.5'
  | 'xl:my-9.5'
  | 'sm:my-11.5'
  | 'md:my-11.5'
  | 'mg:my-11.5'
  | 'lg:my-11.5'
  | 'xl:my-11.5'
  | 'sm:-my-15'
  | 'md:-my-15'
  | 'mg:-my-15'
  | 'lg:-my-15'
  | 'xl:-my-15'
  | 'sm:-my-17'
  | 'md:-my-17'
  | 'mg:-my-17'
  | 'lg:-my-17'
  | 'xl:-my-17'
  | 'sm:-my-18'
  | 'md:-my-18'
  | 'mg:-my-18'
  | 'lg:-my-18'
  | 'xl:-my-18'
  | 'sm:-my-21'
  | 'md:-my-21'
  | 'mg:-my-21'
  | 'lg:-my-21'
  | 'xl:-my-21'
  | 'sm:-my-22'
  | 'md:-my-22'
  | 'mg:-my-22'
  | 'lg:-my-22'
  | 'xl:-my-22'
  | 'sm:-my-30'
  | 'md:-my-30'
  | 'mg:-my-30'
  | 'lg:-my-30'
  | 'xl:-my-30'
  | 'sm:-my-1/2'
  | 'md:-my-1/2'
  | 'mg:-my-1/2'
  | 'lg:-my-1/2'
  | 'xl:-my-1/2'
  | 'sm:-my-full'
  | 'md:-my-full'
  | 'mg:-my-full'
  | 'lg:-my-full'
  | 'xl:-my-full'
  | 'sm:-my-4.5'
  | 'md:-my-4.5'
  | 'mg:-my-4.5'
  | 'lg:-my-4.5'
  | 'xl:-my-4.5'
  | 'sm:-my-7.5'
  | 'md:-my-7.5'
  | 'mg:-my-7.5'
  | 'lg:-my-7.5'
  | 'xl:-my-7.5'
  | 'sm:-my-9.5'
  | 'md:-my-9.5'
  | 'mg:-my-9.5'
  | 'lg:-my-9.5'
  | 'xl:-my-9.5'
  | 'sm:-my-11.5'
  | 'md:-my-11.5'
  | 'mg:-my-11.5'
  | 'lg:-my-11.5'
  | 'xl:-my-11.5'
  | 'sm:mx-0'
  | 'md:mx-0'
  | 'mg:mx-0'
  | 'lg:mx-0'
  | 'xl:mx-0'
  | 'sm:mx-1'
  | 'md:mx-1'
  | 'mg:mx-1'
  | 'lg:mx-1'
  | 'xl:mx-1'
  | 'sm:mx-2'
  | 'md:mx-2'
  | 'mg:mx-2'
  | 'lg:mx-2'
  | 'xl:mx-2'
  | 'sm:mx-3'
  | 'md:mx-3'
  | 'mg:mx-3'
  | 'lg:mx-3'
  | 'xl:mx-3'
  | 'sm:mx-4'
  | 'md:mx-4'
  | 'mg:mx-4'
  | 'lg:mx-4'
  | 'xl:mx-4'
  | 'sm:mx-5'
  | 'md:mx-5'
  | 'mg:mx-5'
  | 'lg:mx-5'
  | 'xl:mx-5'
  | 'sm:mx-6'
  | 'md:mx-6'
  | 'mg:mx-6'
  | 'lg:mx-6'
  | 'xl:mx-6'
  | 'sm:mx-7'
  | 'md:mx-7'
  | 'mg:mx-7'
  | 'lg:mx-7'
  | 'xl:mx-7'
  | 'sm:mx-8'
  | 'md:mx-8'
  | 'mg:mx-8'
  | 'lg:mx-8'
  | 'xl:mx-8'
  | 'sm:mx-9'
  | 'md:mx-9'
  | 'mg:mx-9'
  | 'lg:mx-9'
  | 'xl:mx-9'
  | 'sm:mx-10'
  | 'md:mx-10'
  | 'mg:mx-10'
  | 'lg:mx-10'
  | 'xl:mx-10'
  | 'sm:mx-11'
  | 'md:mx-11'
  | 'mg:mx-11'
  | 'lg:mx-11'
  | 'xl:mx-11'
  | 'sm:mx-12'
  | 'md:mx-12'
  | 'mg:mx-12'
  | 'lg:mx-12'
  | 'xl:mx-12'
  | 'sm:mx-14'
  | 'md:mx-14'
  | 'mg:mx-14'
  | 'lg:mx-14'
  | 'xl:mx-14'
  | 'sm:mx-15'
  | 'md:mx-15'
  | 'mg:mx-15'
  | 'lg:mx-15'
  | 'xl:mx-15'
  | 'sm:mx-16'
  | 'md:mx-16'
  | 'mg:mx-16'
  | 'lg:mx-16'
  | 'xl:mx-16'
  | 'sm:mx-17'
  | 'md:mx-17'
  | 'mg:mx-17'
  | 'lg:mx-17'
  | 'xl:mx-17'
  | 'sm:mx-18'
  | 'md:mx-18'
  | 'mg:mx-18'
  | 'lg:mx-18'
  | 'xl:mx-18'
  | 'sm:mx-20'
  | 'md:mx-20'
  | 'mg:mx-20'
  | 'lg:mx-20'
  | 'xl:mx-20'
  | 'sm:mx-21'
  | 'md:mx-21'
  | 'mg:mx-21'
  | 'lg:mx-21'
  | 'xl:mx-21'
  | 'sm:mx-22'
  | 'md:mx-22'
  | 'mg:mx-22'
  | 'lg:mx-22'
  | 'xl:mx-22'
  | 'sm:mx-24'
  | 'md:mx-24'
  | 'mg:mx-24'
  | 'lg:mx-24'
  | 'xl:mx-24'
  | 'sm:mx-28'
  | 'md:mx-28'
  | 'mg:mx-28'
  | 'lg:mx-28'
  | 'xl:mx-28'
  | 'sm:mx-30'
  | 'md:mx-30'
  | 'mg:mx-30'
  | 'lg:mx-30'
  | 'xl:mx-30'
  | 'sm:mx-32'
  | 'md:mx-32'
  | 'mg:mx-32'
  | 'lg:mx-32'
  | 'xl:mx-32'
  | 'sm:mx-36'
  | 'md:mx-36'
  | 'mg:mx-36'
  | 'lg:mx-36'
  | 'xl:mx-36'
  | 'sm:mx-40'
  | 'md:mx-40'
  | 'mg:mx-40'
  | 'lg:mx-40'
  | 'xl:mx-40'
  | 'sm:mx-44'
  | 'md:mx-44'
  | 'mg:mx-44'
  | 'lg:mx-44'
  | 'xl:mx-44'
  | 'sm:mx-48'
  | 'md:mx-48'
  | 'mg:mx-48'
  | 'lg:mx-48'
  | 'xl:mx-48'
  | 'sm:mx-52'
  | 'md:mx-52'
  | 'mg:mx-52'
  | 'lg:mx-52'
  | 'xl:mx-52'
  | 'sm:mx-56'
  | 'md:mx-56'
  | 'mg:mx-56'
  | 'lg:mx-56'
  | 'xl:mx-56'
  | 'sm:mx-60'
  | 'md:mx-60'
  | 'mg:mx-60'
  | 'lg:mx-60'
  | 'xl:mx-60'
  | 'sm:mx-64'
  | 'md:mx-64'
  | 'mg:mx-64'
  | 'lg:mx-64'
  | 'xl:mx-64'
  | 'sm:mx-72'
  | 'md:mx-72'
  | 'mg:mx-72'
  | 'lg:mx-72'
  | 'xl:mx-72'
  | 'sm:mx-80'
  | 'md:mx-80'
  | 'mg:mx-80'
  | 'lg:mx-80'
  | 'xl:mx-80'
  | 'sm:mx-96'
  | 'md:mx-96'
  | 'mg:mx-96'
  | 'lg:mx-96'
  | 'xl:mx-96'
  | 'sm:mx-auto'
  | 'md:mx-auto'
  | 'mg:mx-auto'
  | 'lg:mx-auto'
  | 'xl:mx-auto'
  | 'sm:mx-px'
  | 'md:mx-px'
  | 'mg:mx-px'
  | 'lg:mx-px'
  | 'xl:mx-px'
  | 'sm:mx-0.5'
  | 'md:mx-0.5'
  | 'mg:mx-0.5'
  | 'lg:mx-0.5'
  | 'xl:mx-0.5'
  | 'sm:mx-1.5'
  | 'md:mx-1.5'
  | 'mg:mx-1.5'
  | 'lg:mx-1.5'
  | 'xl:mx-1.5'
  | 'sm:mx-2.5'
  | 'md:mx-2.5'
  | 'mg:mx-2.5'
  | 'lg:mx-2.5'
  | 'xl:mx-2.5'
  | 'sm:mx-3.5'
  | 'md:mx-3.5'
  | 'mg:mx-3.5'
  | 'lg:mx-3.5'
  | 'xl:mx-3.5'
  | 'sm:-mx-0'
  | 'md:-mx-0'
  | 'mg:-mx-0'
  | 'lg:-mx-0'
  | 'xl:-mx-0'
  | 'sm:-mx-1'
  | 'md:-mx-1'
  | 'mg:-mx-1'
  | 'lg:-mx-1'
  | 'xl:-mx-1'
  | 'sm:-mx-2'
  | 'md:-mx-2'
  | 'mg:-mx-2'
  | 'lg:-mx-2'
  | 'xl:-mx-2'
  | 'sm:-mx-3'
  | 'md:-mx-3'
  | 'mg:-mx-3'
  | 'lg:-mx-3'
  | 'xl:-mx-3'
  | 'sm:-mx-4'
  | 'md:-mx-4'
  | 'mg:-mx-4'
  | 'lg:-mx-4'
  | 'xl:-mx-4'
  | 'sm:-mx-5'
  | 'md:-mx-5'
  | 'mg:-mx-5'
  | 'lg:-mx-5'
  | 'xl:-mx-5'
  | 'sm:-mx-6'
  | 'md:-mx-6'
  | 'mg:-mx-6'
  | 'lg:-mx-6'
  | 'xl:-mx-6'
  | 'sm:-mx-7'
  | 'md:-mx-7'
  | 'mg:-mx-7'
  | 'lg:-mx-7'
  | 'xl:-mx-7'
  | 'sm:-mx-8'
  | 'md:-mx-8'
  | 'mg:-mx-8'
  | 'lg:-mx-8'
  | 'xl:-mx-8'
  | 'sm:-mx-9'
  | 'md:-mx-9'
  | 'mg:-mx-9'
  | 'lg:-mx-9'
  | 'xl:-mx-9'
  | 'sm:-mx-10'
  | 'md:-mx-10'
  | 'mg:-mx-10'
  | 'lg:-mx-10'
  | 'xl:-mx-10'
  | 'sm:-mx-11'
  | 'md:-mx-11'
  | 'mg:-mx-11'
  | 'lg:-mx-11'
  | 'xl:-mx-11'
  | 'sm:-mx-12'
  | 'md:-mx-12'
  | 'mg:-mx-12'
  | 'lg:-mx-12'
  | 'xl:-mx-12'
  | 'sm:-mx-14'
  | 'md:-mx-14'
  | 'mg:-mx-14'
  | 'lg:-mx-14'
  | 'xl:-mx-14'
  | 'sm:-mx-16'
  | 'md:-mx-16'
  | 'mg:-mx-16'
  | 'lg:-mx-16'
  | 'xl:-mx-16'
  | 'sm:-mx-20'
  | 'md:-mx-20'
  | 'mg:-mx-20'
  | 'lg:-mx-20'
  | 'xl:-mx-20'
  | 'sm:-mx-24'
  | 'md:-mx-24'
  | 'mg:-mx-24'
  | 'lg:-mx-24'
  | 'xl:-mx-24'
  | 'sm:-mx-28'
  | 'md:-mx-28'
  | 'mg:-mx-28'
  | 'lg:-mx-28'
  | 'xl:-mx-28'
  | 'sm:-mx-32'
  | 'md:-mx-32'
  | 'mg:-mx-32'
  | 'lg:-mx-32'
  | 'xl:-mx-32'
  | 'sm:-mx-36'
  | 'md:-mx-36'
  | 'mg:-mx-36'
  | 'lg:-mx-36'
  | 'xl:-mx-36'
  | 'sm:-mx-40'
  | 'md:-mx-40'
  | 'mg:-mx-40'
  | 'lg:-mx-40'
  | 'xl:-mx-40'
  | 'sm:-mx-44'
  | 'md:-mx-44'
  | 'mg:-mx-44'
  | 'lg:-mx-44'
  | 'xl:-mx-44'
  | 'sm:-mx-48'
  | 'md:-mx-48'
  | 'mg:-mx-48'
  | 'lg:-mx-48'
  | 'xl:-mx-48'
  | 'sm:-mx-52'
  | 'md:-mx-52'
  | 'mg:-mx-52'
  | 'lg:-mx-52'
  | 'xl:-mx-52'
  | 'sm:-mx-56'
  | 'md:-mx-56'
  | 'mg:-mx-56'
  | 'lg:-mx-56'
  | 'xl:-mx-56'
  | 'sm:-mx-60'
  | 'md:-mx-60'
  | 'mg:-mx-60'
  | 'lg:-mx-60'
  | 'xl:-mx-60'
  | 'sm:-mx-64'
  | 'md:-mx-64'
  | 'mg:-mx-64'
  | 'lg:-mx-64'
  | 'xl:-mx-64'
  | 'sm:-mx-72'
  | 'md:-mx-72'
  | 'mg:-mx-72'
  | 'lg:-mx-72'
  | 'xl:-mx-72'
  | 'sm:-mx-80'
  | 'md:-mx-80'
  | 'mg:-mx-80'
  | 'lg:-mx-80'
  | 'xl:-mx-80'
  | 'sm:-mx-96'
  | 'md:-mx-96'
  | 'mg:-mx-96'
  | 'lg:-mx-96'
  | 'xl:-mx-96'
  | 'sm:-mx-px'
  | 'md:-mx-px'
  | 'mg:-mx-px'
  | 'lg:-mx-px'
  | 'xl:-mx-px'
  | 'sm:-mx-0.5'
  | 'md:-mx-0.5'
  | 'mg:-mx-0.5'
  | 'lg:-mx-0.5'
  | 'xl:-mx-0.5'
  | 'sm:-mx-1.5'
  | 'md:-mx-1.5'
  | 'mg:-mx-1.5'
  | 'lg:-mx-1.5'
  | 'xl:-mx-1.5'
  | 'sm:-mx-2.5'
  | 'md:-mx-2.5'
  | 'mg:-mx-2.5'
  | 'lg:-mx-2.5'
  | 'xl:-mx-2.5'
  | 'sm:-mx-3.5'
  | 'md:-mx-3.5'
  | 'mg:-mx-3.5'
  | 'lg:-mx-3.5'
  | 'xl:-mx-3.5'
  | 'sm:mx-1/2'
  | 'md:mx-1/2'
  | 'mg:mx-1/2'
  | 'lg:mx-1/2'
  | 'xl:mx-1/2'
  | 'sm:mx-full'
  | 'md:mx-full'
  | 'mg:mx-full'
  | 'lg:mx-full'
  | 'xl:mx-full'
  | 'sm:mx-4.5'
  | 'md:mx-4.5'
  | 'mg:mx-4.5'
  | 'lg:mx-4.5'
  | 'xl:mx-4.5'
  | 'sm:mx-7.5'
  | 'md:mx-7.5'
  | 'mg:mx-7.5'
  | 'lg:mx-7.5'
  | 'xl:mx-7.5'
  | 'sm:mx-9.5'
  | 'md:mx-9.5'
  | 'mg:mx-9.5'
  | 'lg:mx-9.5'
  | 'xl:mx-9.5'
  | 'sm:mx-11.5'
  | 'md:mx-11.5'
  | 'mg:mx-11.5'
  | 'lg:mx-11.5'
  | 'xl:mx-11.5'
  | 'sm:-mx-15'
  | 'md:-mx-15'
  | 'mg:-mx-15'
  | 'lg:-mx-15'
  | 'xl:-mx-15'
  | 'sm:-mx-17'
  | 'md:-mx-17'
  | 'mg:-mx-17'
  | 'lg:-mx-17'
  | 'xl:-mx-17'
  | 'sm:-mx-18'
  | 'md:-mx-18'
  | 'mg:-mx-18'
  | 'lg:-mx-18'
  | 'xl:-mx-18'
  | 'sm:-mx-21'
  | 'md:-mx-21'
  | 'mg:-mx-21'
  | 'lg:-mx-21'
  | 'xl:-mx-21'
  | 'sm:-mx-22'
  | 'md:-mx-22'
  | 'mg:-mx-22'
  | 'lg:-mx-22'
  | 'xl:-mx-22'
  | 'sm:-mx-30'
  | 'md:-mx-30'
  | 'mg:-mx-30'
  | 'lg:-mx-30'
  | 'xl:-mx-30'
  | 'sm:-mx-1/2'
  | 'md:-mx-1/2'
  | 'mg:-mx-1/2'
  | 'lg:-mx-1/2'
  | 'xl:-mx-1/2'
  | 'sm:-mx-full'
  | 'md:-mx-full'
  | 'mg:-mx-full'
  | 'lg:-mx-full'
  | 'xl:-mx-full'
  | 'sm:-mx-4.5'
  | 'md:-mx-4.5'
  | 'mg:-mx-4.5'
  | 'lg:-mx-4.5'
  | 'xl:-mx-4.5'
  | 'sm:-mx-7.5'
  | 'md:-mx-7.5'
  | 'mg:-mx-7.5'
  | 'lg:-mx-7.5'
  | 'xl:-mx-7.5'
  | 'sm:-mx-9.5'
  | 'md:-mx-9.5'
  | 'mg:-mx-9.5'
  | 'lg:-mx-9.5'
  | 'xl:-mx-9.5'
  | 'sm:-mx-11.5'
  | 'md:-mx-11.5'
  | 'mg:-mx-11.5'
  | 'lg:-mx-11.5'
  | 'xl:-mx-11.5'
  | 'sm:mt-0'
  | 'md:mt-0'
  | 'mg:mt-0'
  | 'lg:mt-0'
  | 'xl:mt-0'
  | 'sm:mt-1'
  | 'md:mt-1'
  | 'mg:mt-1'
  | 'lg:mt-1'
  | 'xl:mt-1'
  | 'sm:mt-2'
  | 'md:mt-2'
  | 'mg:mt-2'
  | 'lg:mt-2'
  | 'xl:mt-2'
  | 'sm:mt-3'
  | 'md:mt-3'
  | 'mg:mt-3'
  | 'lg:mt-3'
  | 'xl:mt-3'
  | 'sm:mt-4'
  | 'md:mt-4'
  | 'mg:mt-4'
  | 'lg:mt-4'
  | 'xl:mt-4'
  | 'sm:mt-5'
  | 'md:mt-5'
  | 'mg:mt-5'
  | 'lg:mt-5'
  | 'xl:mt-5'
  | 'sm:mt-6'
  | 'md:mt-6'
  | 'mg:mt-6'
  | 'lg:mt-6'
  | 'xl:mt-6'
  | 'sm:mt-7'
  | 'md:mt-7'
  | 'mg:mt-7'
  | 'lg:mt-7'
  | 'xl:mt-7'
  | 'sm:mt-8'
  | 'md:mt-8'
  | 'mg:mt-8'
  | 'lg:mt-8'
  | 'xl:mt-8'
  | 'sm:mt-9'
  | 'md:mt-9'
  | 'mg:mt-9'
  | 'lg:mt-9'
  | 'xl:mt-9'
  | 'sm:mt-10'
  | 'md:mt-10'
  | 'mg:mt-10'
  | 'lg:mt-10'
  | 'xl:mt-10'
  | 'sm:mt-11'
  | 'md:mt-11'
  | 'mg:mt-11'
  | 'lg:mt-11'
  | 'xl:mt-11'
  | 'sm:mt-12'
  | 'md:mt-12'
  | 'mg:mt-12'
  | 'lg:mt-12'
  | 'xl:mt-12'
  | 'sm:mt-14'
  | 'md:mt-14'
  | 'mg:mt-14'
  | 'lg:mt-14'
  | 'xl:mt-14'
  | 'sm:mt-15'
  | 'md:mt-15'
  | 'mg:mt-15'
  | 'lg:mt-15'
  | 'xl:mt-15'
  | 'sm:mt-16'
  | 'md:mt-16'
  | 'mg:mt-16'
  | 'lg:mt-16'
  | 'xl:mt-16'
  | 'sm:mt-17'
  | 'md:mt-17'
  | 'mg:mt-17'
  | 'lg:mt-17'
  | 'xl:mt-17'
  | 'sm:mt-18'
  | 'md:mt-18'
  | 'mg:mt-18'
  | 'lg:mt-18'
  | 'xl:mt-18'
  | 'sm:mt-20'
  | 'md:mt-20'
  | 'mg:mt-20'
  | 'lg:mt-20'
  | 'xl:mt-20'
  | 'sm:mt-21'
  | 'md:mt-21'
  | 'mg:mt-21'
  | 'lg:mt-21'
  | 'xl:mt-21'
  | 'sm:mt-22'
  | 'md:mt-22'
  | 'mg:mt-22'
  | 'lg:mt-22'
  | 'xl:mt-22'
  | 'sm:mt-24'
  | 'md:mt-24'
  | 'mg:mt-24'
  | 'lg:mt-24'
  | 'xl:mt-24'
  | 'sm:mt-28'
  | 'md:mt-28'
  | 'mg:mt-28'
  | 'lg:mt-28'
  | 'xl:mt-28'
  | 'sm:mt-30'
  | 'md:mt-30'
  | 'mg:mt-30'
  | 'lg:mt-30'
  | 'xl:mt-30'
  | 'sm:mt-32'
  | 'md:mt-32'
  | 'mg:mt-32'
  | 'lg:mt-32'
  | 'xl:mt-32'
  | 'sm:mt-36'
  | 'md:mt-36'
  | 'mg:mt-36'
  | 'lg:mt-36'
  | 'xl:mt-36'
  | 'sm:mt-40'
  | 'md:mt-40'
  | 'mg:mt-40'
  | 'lg:mt-40'
  | 'xl:mt-40'
  | 'sm:mt-44'
  | 'md:mt-44'
  | 'mg:mt-44'
  | 'lg:mt-44'
  | 'xl:mt-44'
  | 'sm:mt-48'
  | 'md:mt-48'
  | 'mg:mt-48'
  | 'lg:mt-48'
  | 'xl:mt-48'
  | 'sm:mt-52'
  | 'md:mt-52'
  | 'mg:mt-52'
  | 'lg:mt-52'
  | 'xl:mt-52'
  | 'sm:mt-56'
  | 'md:mt-56'
  | 'mg:mt-56'
  | 'lg:mt-56'
  | 'xl:mt-56'
  | 'sm:mt-60'
  | 'md:mt-60'
  | 'mg:mt-60'
  | 'lg:mt-60'
  | 'xl:mt-60'
  | 'sm:mt-64'
  | 'md:mt-64'
  | 'mg:mt-64'
  | 'lg:mt-64'
  | 'xl:mt-64'
  | 'sm:mt-72'
  | 'md:mt-72'
  | 'mg:mt-72'
  | 'lg:mt-72'
  | 'xl:mt-72'
  | 'sm:mt-80'
  | 'md:mt-80'
  | 'mg:mt-80'
  | 'lg:mt-80'
  | 'xl:mt-80'
  | 'sm:mt-96'
  | 'md:mt-96'
  | 'mg:mt-96'
  | 'lg:mt-96'
  | 'xl:mt-96'
  | 'sm:mt-auto'
  | 'md:mt-auto'
  | 'mg:mt-auto'
  | 'lg:mt-auto'
  | 'xl:mt-auto'
  | 'sm:mt-px'
  | 'md:mt-px'
  | 'mg:mt-px'
  | 'lg:mt-px'
  | 'xl:mt-px'
  | 'sm:mt-0.5'
  | 'md:mt-0.5'
  | 'mg:mt-0.5'
  | 'lg:mt-0.5'
  | 'xl:mt-0.5'
  | 'sm:mt-1.5'
  | 'md:mt-1.5'
  | 'mg:mt-1.5'
  | 'lg:mt-1.5'
  | 'xl:mt-1.5'
  | 'sm:mt-2.5'
  | 'md:mt-2.5'
  | 'mg:mt-2.5'
  | 'lg:mt-2.5'
  | 'xl:mt-2.5'
  | 'sm:mt-3.5'
  | 'md:mt-3.5'
  | 'mg:mt-3.5'
  | 'lg:mt-3.5'
  | 'xl:mt-3.5'
  | 'sm:-mt-0'
  | 'md:-mt-0'
  | 'mg:-mt-0'
  | 'lg:-mt-0'
  | 'xl:-mt-0'
  | 'sm:-mt-1'
  | 'md:-mt-1'
  | 'mg:-mt-1'
  | 'lg:-mt-1'
  | 'xl:-mt-1'
  | 'sm:-mt-2'
  | 'md:-mt-2'
  | 'mg:-mt-2'
  | 'lg:-mt-2'
  | 'xl:-mt-2'
  | 'sm:-mt-3'
  | 'md:-mt-3'
  | 'mg:-mt-3'
  | 'lg:-mt-3'
  | 'xl:-mt-3'
  | 'sm:-mt-4'
  | 'md:-mt-4'
  | 'mg:-mt-4'
  | 'lg:-mt-4'
  | 'xl:-mt-4'
  | 'sm:-mt-5'
  | 'md:-mt-5'
  | 'mg:-mt-5'
  | 'lg:-mt-5'
  | 'xl:-mt-5'
  | 'sm:-mt-6'
  | 'md:-mt-6'
  | 'mg:-mt-6'
  | 'lg:-mt-6'
  | 'xl:-mt-6'
  | 'sm:-mt-7'
  | 'md:-mt-7'
  | 'mg:-mt-7'
  | 'lg:-mt-7'
  | 'xl:-mt-7'
  | 'sm:-mt-8'
  | 'md:-mt-8'
  | 'mg:-mt-8'
  | 'lg:-mt-8'
  | 'xl:-mt-8'
  | 'sm:-mt-9'
  | 'md:-mt-9'
  | 'mg:-mt-9'
  | 'lg:-mt-9'
  | 'xl:-mt-9'
  | 'sm:-mt-10'
  | 'md:-mt-10'
  | 'mg:-mt-10'
  | 'lg:-mt-10'
  | 'xl:-mt-10'
  | 'sm:-mt-11'
  | 'md:-mt-11'
  | 'mg:-mt-11'
  | 'lg:-mt-11'
  | 'xl:-mt-11'
  | 'sm:-mt-12'
  | 'md:-mt-12'
  | 'mg:-mt-12'
  | 'lg:-mt-12'
  | 'xl:-mt-12'
  | 'sm:-mt-14'
  | 'md:-mt-14'
  | 'mg:-mt-14'
  | 'lg:-mt-14'
  | 'xl:-mt-14'
  | 'sm:-mt-16'
  | 'md:-mt-16'
  | 'mg:-mt-16'
  | 'lg:-mt-16'
  | 'xl:-mt-16'
  | 'sm:-mt-20'
  | 'md:-mt-20'
  | 'mg:-mt-20'
  | 'lg:-mt-20'
  | 'xl:-mt-20'
  | 'sm:-mt-24'
  | 'md:-mt-24'
  | 'mg:-mt-24'
  | 'lg:-mt-24'
  | 'xl:-mt-24'
  | 'sm:-mt-28'
  | 'md:-mt-28'
  | 'mg:-mt-28'
  | 'lg:-mt-28'
  | 'xl:-mt-28'
  | 'sm:-mt-32'
  | 'md:-mt-32'
  | 'mg:-mt-32'
  | 'lg:-mt-32'
  | 'xl:-mt-32'
  | 'sm:-mt-36'
  | 'md:-mt-36'
  | 'mg:-mt-36'
  | 'lg:-mt-36'
  | 'xl:-mt-36'
  | 'sm:-mt-40'
  | 'md:-mt-40'
  | 'mg:-mt-40'
  | 'lg:-mt-40'
  | 'xl:-mt-40'
  | 'sm:-mt-44'
  | 'md:-mt-44'
  | 'mg:-mt-44'
  | 'lg:-mt-44'
  | 'xl:-mt-44'
  | 'sm:-mt-48'
  | 'md:-mt-48'
  | 'mg:-mt-48'
  | 'lg:-mt-48'
  | 'xl:-mt-48'
  | 'sm:-mt-52'
  | 'md:-mt-52'
  | 'mg:-mt-52'
  | 'lg:-mt-52'
  | 'xl:-mt-52'
  | 'sm:-mt-56'
  | 'md:-mt-56'
  | 'mg:-mt-56'
  | 'lg:-mt-56'
  | 'xl:-mt-56'
  | 'sm:-mt-60'
  | 'md:-mt-60'
  | 'mg:-mt-60'
  | 'lg:-mt-60'
  | 'xl:-mt-60'
  | 'sm:-mt-64'
  | 'md:-mt-64'
  | 'mg:-mt-64'
  | 'lg:-mt-64'
  | 'xl:-mt-64'
  | 'sm:-mt-72'
  | 'md:-mt-72'
  | 'mg:-mt-72'
  | 'lg:-mt-72'
  | 'xl:-mt-72'
  | 'sm:-mt-80'
  | 'md:-mt-80'
  | 'mg:-mt-80'
  | 'lg:-mt-80'
  | 'xl:-mt-80'
  | 'sm:-mt-96'
  | 'md:-mt-96'
  | 'mg:-mt-96'
  | 'lg:-mt-96'
  | 'xl:-mt-96'
  | 'sm:-mt-px'
  | 'md:-mt-px'
  | 'mg:-mt-px'
  | 'lg:-mt-px'
  | 'xl:-mt-px'
  | 'sm:-mt-0.5'
  | 'md:-mt-0.5'
  | 'mg:-mt-0.5'
  | 'lg:-mt-0.5'
  | 'xl:-mt-0.5'
  | 'sm:-mt-1.5'
  | 'md:-mt-1.5'
  | 'mg:-mt-1.5'
  | 'lg:-mt-1.5'
  | 'xl:-mt-1.5'
  | 'sm:-mt-2.5'
  | 'md:-mt-2.5'
  | 'mg:-mt-2.5'
  | 'lg:-mt-2.5'
  | 'xl:-mt-2.5'
  | 'sm:-mt-3.5'
  | 'md:-mt-3.5'
  | 'mg:-mt-3.5'
  | 'lg:-mt-3.5'
  | 'xl:-mt-3.5'
  | 'sm:mt-1/2'
  | 'md:mt-1/2'
  | 'mg:mt-1/2'
  | 'lg:mt-1/2'
  | 'xl:mt-1/2'
  | 'sm:mt-full'
  | 'md:mt-full'
  | 'mg:mt-full'
  | 'lg:mt-full'
  | 'xl:mt-full'
  | 'sm:mt-4.5'
  | 'md:mt-4.5'
  | 'mg:mt-4.5'
  | 'lg:mt-4.5'
  | 'xl:mt-4.5'
  | 'sm:mt-7.5'
  | 'md:mt-7.5'
  | 'mg:mt-7.5'
  | 'lg:mt-7.5'
  | 'xl:mt-7.5'
  | 'sm:mt-9.5'
  | 'md:mt-9.5'
  | 'mg:mt-9.5'
  | 'lg:mt-9.5'
  | 'xl:mt-9.5'
  | 'sm:mt-11.5'
  | 'md:mt-11.5'
  | 'mg:mt-11.5'
  | 'lg:mt-11.5'
  | 'xl:mt-11.5'
  | 'sm:-mt-15'
  | 'md:-mt-15'
  | 'mg:-mt-15'
  | 'lg:-mt-15'
  | 'xl:-mt-15'
  | 'sm:-mt-17'
  | 'md:-mt-17'
  | 'mg:-mt-17'
  | 'lg:-mt-17'
  | 'xl:-mt-17'
  | 'sm:-mt-18'
  | 'md:-mt-18'
  | 'mg:-mt-18'
  | 'lg:-mt-18'
  | 'xl:-mt-18'
  | 'sm:-mt-21'
  | 'md:-mt-21'
  | 'mg:-mt-21'
  | 'lg:-mt-21'
  | 'xl:-mt-21'
  | 'sm:-mt-22'
  | 'md:-mt-22'
  | 'mg:-mt-22'
  | 'lg:-mt-22'
  | 'xl:-mt-22'
  | 'sm:-mt-30'
  | 'md:-mt-30'
  | 'mg:-mt-30'
  | 'lg:-mt-30'
  | 'xl:-mt-30'
  | 'sm:-mt-1/2'
  | 'md:-mt-1/2'
  | 'mg:-mt-1/2'
  | 'lg:-mt-1/2'
  | 'xl:-mt-1/2'
  | 'sm:-mt-full'
  | 'md:-mt-full'
  | 'mg:-mt-full'
  | 'lg:-mt-full'
  | 'xl:-mt-full'
  | 'sm:-mt-4.5'
  | 'md:-mt-4.5'
  | 'mg:-mt-4.5'
  | 'lg:-mt-4.5'
  | 'xl:-mt-4.5'
  | 'sm:-mt-7.5'
  | 'md:-mt-7.5'
  | 'mg:-mt-7.5'
  | 'lg:-mt-7.5'
  | 'xl:-mt-7.5'
  | 'sm:-mt-9.5'
  | 'md:-mt-9.5'
  | 'mg:-mt-9.5'
  | 'lg:-mt-9.5'
  | 'xl:-mt-9.5'
  | 'sm:-mt-11.5'
  | 'md:-mt-11.5'
  | 'mg:-mt-11.5'
  | 'lg:-mt-11.5'
  | 'xl:-mt-11.5'
  | 'sm:mr-0'
  | 'md:mr-0'
  | 'mg:mr-0'
  | 'lg:mr-0'
  | 'xl:mr-0'
  | 'sm:mr-1'
  | 'md:mr-1'
  | 'mg:mr-1'
  | 'lg:mr-1'
  | 'xl:mr-1'
  | 'sm:mr-2'
  | 'md:mr-2'
  | 'mg:mr-2'
  | 'lg:mr-2'
  | 'xl:mr-2'
  | 'sm:mr-3'
  | 'md:mr-3'
  | 'mg:mr-3'
  | 'lg:mr-3'
  | 'xl:mr-3'
  | 'sm:mr-4'
  | 'md:mr-4'
  | 'mg:mr-4'
  | 'lg:mr-4'
  | 'xl:mr-4'
  | 'sm:mr-5'
  | 'md:mr-5'
  | 'mg:mr-5'
  | 'lg:mr-5'
  | 'xl:mr-5'
  | 'sm:mr-6'
  | 'md:mr-6'
  | 'mg:mr-6'
  | 'lg:mr-6'
  | 'xl:mr-6'
  | 'sm:mr-7'
  | 'md:mr-7'
  | 'mg:mr-7'
  | 'lg:mr-7'
  | 'xl:mr-7'
  | 'sm:mr-8'
  | 'md:mr-8'
  | 'mg:mr-8'
  | 'lg:mr-8'
  | 'xl:mr-8'
  | 'sm:mr-9'
  | 'md:mr-9'
  | 'mg:mr-9'
  | 'lg:mr-9'
  | 'xl:mr-9'
  | 'sm:mr-10'
  | 'md:mr-10'
  | 'mg:mr-10'
  | 'lg:mr-10'
  | 'xl:mr-10'
  | 'sm:mr-11'
  | 'md:mr-11'
  | 'mg:mr-11'
  | 'lg:mr-11'
  | 'xl:mr-11'
  | 'sm:mr-12'
  | 'md:mr-12'
  | 'mg:mr-12'
  | 'lg:mr-12'
  | 'xl:mr-12'
  | 'sm:mr-14'
  | 'md:mr-14'
  | 'mg:mr-14'
  | 'lg:mr-14'
  | 'xl:mr-14'
  | 'sm:mr-15'
  | 'md:mr-15'
  | 'mg:mr-15'
  | 'lg:mr-15'
  | 'xl:mr-15'
  | 'sm:mr-16'
  | 'md:mr-16'
  | 'mg:mr-16'
  | 'lg:mr-16'
  | 'xl:mr-16'
  | 'sm:mr-17'
  | 'md:mr-17'
  | 'mg:mr-17'
  | 'lg:mr-17'
  | 'xl:mr-17'
  | 'sm:mr-18'
  | 'md:mr-18'
  | 'mg:mr-18'
  | 'lg:mr-18'
  | 'xl:mr-18'
  | 'sm:mr-20'
  | 'md:mr-20'
  | 'mg:mr-20'
  | 'lg:mr-20'
  | 'xl:mr-20'
  | 'sm:mr-21'
  | 'md:mr-21'
  | 'mg:mr-21'
  | 'lg:mr-21'
  | 'xl:mr-21'
  | 'sm:mr-22'
  | 'md:mr-22'
  | 'mg:mr-22'
  | 'lg:mr-22'
  | 'xl:mr-22'
  | 'sm:mr-24'
  | 'md:mr-24'
  | 'mg:mr-24'
  | 'lg:mr-24'
  | 'xl:mr-24'
  | 'sm:mr-28'
  | 'md:mr-28'
  | 'mg:mr-28'
  | 'lg:mr-28'
  | 'xl:mr-28'
  | 'sm:mr-30'
  | 'md:mr-30'
  | 'mg:mr-30'
  | 'lg:mr-30'
  | 'xl:mr-30'
  | 'sm:mr-32'
  | 'md:mr-32'
  | 'mg:mr-32'
  | 'lg:mr-32'
  | 'xl:mr-32'
  | 'sm:mr-36'
  | 'md:mr-36'
  | 'mg:mr-36'
  | 'lg:mr-36'
  | 'xl:mr-36'
  | 'sm:mr-40'
  | 'md:mr-40'
  | 'mg:mr-40'
  | 'lg:mr-40'
  | 'xl:mr-40'
  | 'sm:mr-44'
  | 'md:mr-44'
  | 'mg:mr-44'
  | 'lg:mr-44'
  | 'xl:mr-44'
  | 'sm:mr-48'
  | 'md:mr-48'
  | 'mg:mr-48'
  | 'lg:mr-48'
  | 'xl:mr-48'
  | 'sm:mr-52'
  | 'md:mr-52'
  | 'mg:mr-52'
  | 'lg:mr-52'
  | 'xl:mr-52'
  | 'sm:mr-56'
  | 'md:mr-56'
  | 'mg:mr-56'
  | 'lg:mr-56'
  | 'xl:mr-56'
  | 'sm:mr-60'
  | 'md:mr-60'
  | 'mg:mr-60'
  | 'lg:mr-60'
  | 'xl:mr-60'
  | 'sm:mr-64'
  | 'md:mr-64'
  | 'mg:mr-64'
  | 'lg:mr-64'
  | 'xl:mr-64'
  | 'sm:mr-72'
  | 'md:mr-72'
  | 'mg:mr-72'
  | 'lg:mr-72'
  | 'xl:mr-72'
  | 'sm:mr-80'
  | 'md:mr-80'
  | 'mg:mr-80'
  | 'lg:mr-80'
  | 'xl:mr-80'
  | 'sm:mr-96'
  | 'md:mr-96'
  | 'mg:mr-96'
  | 'lg:mr-96'
  | 'xl:mr-96'
  | 'sm:mr-auto'
  | 'md:mr-auto'
  | 'mg:mr-auto'
  | 'lg:mr-auto'
  | 'xl:mr-auto'
  | 'sm:mr-px'
  | 'md:mr-px'
  | 'mg:mr-px'
  | 'lg:mr-px'
  | 'xl:mr-px'
  | 'sm:mr-0.5'
  | 'md:mr-0.5'
  | 'mg:mr-0.5'
  | 'lg:mr-0.5'
  | 'xl:mr-0.5'
  | 'sm:mr-1.5'
  | 'md:mr-1.5'
  | 'mg:mr-1.5'
  | 'lg:mr-1.5'
  | 'xl:mr-1.5'
  | 'sm:mr-2.5'
  | 'md:mr-2.5'
  | 'mg:mr-2.5'
  | 'lg:mr-2.5'
  | 'xl:mr-2.5'
  | 'sm:mr-3.5'
  | 'md:mr-3.5'
  | 'mg:mr-3.5'
  | 'lg:mr-3.5'
  | 'xl:mr-3.5'
  | 'sm:-mr-0'
  | 'md:-mr-0'
  | 'mg:-mr-0'
  | 'lg:-mr-0'
  | 'xl:-mr-0'
  | 'sm:-mr-1'
  | 'md:-mr-1'
  | 'mg:-mr-1'
  | 'lg:-mr-1'
  | 'xl:-mr-1'
  | 'sm:-mr-2'
  | 'md:-mr-2'
  | 'mg:-mr-2'
  | 'lg:-mr-2'
  | 'xl:-mr-2'
  | 'sm:-mr-3'
  | 'md:-mr-3'
  | 'mg:-mr-3'
  | 'lg:-mr-3'
  | 'xl:-mr-3'
  | 'sm:-mr-4'
  | 'md:-mr-4'
  | 'mg:-mr-4'
  | 'lg:-mr-4'
  | 'xl:-mr-4'
  | 'sm:-mr-5'
  | 'md:-mr-5'
  | 'mg:-mr-5'
  | 'lg:-mr-5'
  | 'xl:-mr-5'
  | 'sm:-mr-6'
  | 'md:-mr-6'
  | 'mg:-mr-6'
  | 'lg:-mr-6'
  | 'xl:-mr-6'
  | 'sm:-mr-7'
  | 'md:-mr-7'
  | 'mg:-mr-7'
  | 'lg:-mr-7'
  | 'xl:-mr-7'
  | 'sm:-mr-8'
  | 'md:-mr-8'
  | 'mg:-mr-8'
  | 'lg:-mr-8'
  | 'xl:-mr-8'
  | 'sm:-mr-9'
  | 'md:-mr-9'
  | 'mg:-mr-9'
  | 'lg:-mr-9'
  | 'xl:-mr-9'
  | 'sm:-mr-10'
  | 'md:-mr-10'
  | 'mg:-mr-10'
  | 'lg:-mr-10'
  | 'xl:-mr-10'
  | 'sm:-mr-11'
  | 'md:-mr-11'
  | 'mg:-mr-11'
  | 'lg:-mr-11'
  | 'xl:-mr-11'
  | 'sm:-mr-12'
  | 'md:-mr-12'
  | 'mg:-mr-12'
  | 'lg:-mr-12'
  | 'xl:-mr-12'
  | 'sm:-mr-14'
  | 'md:-mr-14'
  | 'mg:-mr-14'
  | 'lg:-mr-14'
  | 'xl:-mr-14'
  | 'sm:-mr-16'
  | 'md:-mr-16'
  | 'mg:-mr-16'
  | 'lg:-mr-16'
  | 'xl:-mr-16'
  | 'sm:-mr-20'
  | 'md:-mr-20'
  | 'mg:-mr-20'
  | 'lg:-mr-20'
  | 'xl:-mr-20'
  | 'sm:-mr-24'
  | 'md:-mr-24'
  | 'mg:-mr-24'
  | 'lg:-mr-24'
  | 'xl:-mr-24'
  | 'sm:-mr-28'
  | 'md:-mr-28'
  | 'mg:-mr-28'
  | 'lg:-mr-28'
  | 'xl:-mr-28'
  | 'sm:-mr-32'
  | 'md:-mr-32'
  | 'mg:-mr-32'
  | 'lg:-mr-32'
  | 'xl:-mr-32'
  | 'sm:-mr-36'
  | 'md:-mr-36'
  | 'mg:-mr-36'
  | 'lg:-mr-36'
  | 'xl:-mr-36'
  | 'sm:-mr-40'
  | 'md:-mr-40'
  | 'mg:-mr-40'
  | 'lg:-mr-40'
  | 'xl:-mr-40'
  | 'sm:-mr-44'
  | 'md:-mr-44'
  | 'mg:-mr-44'
  | 'lg:-mr-44'
  | 'xl:-mr-44'
  | 'sm:-mr-48'
  | 'md:-mr-48'
  | 'mg:-mr-48'
  | 'lg:-mr-48'
  | 'xl:-mr-48'
  | 'sm:-mr-52'
  | 'md:-mr-52'
  | 'mg:-mr-52'
  | 'lg:-mr-52'
  | 'xl:-mr-52'
  | 'sm:-mr-56'
  | 'md:-mr-56'
  | 'mg:-mr-56'
  | 'lg:-mr-56'
  | 'xl:-mr-56'
  | 'sm:-mr-60'
  | 'md:-mr-60'
  | 'mg:-mr-60'
  | 'lg:-mr-60'
  | 'xl:-mr-60'
  | 'sm:-mr-64'
  | 'md:-mr-64'
  | 'mg:-mr-64'
  | 'lg:-mr-64'
  | 'xl:-mr-64'
  | 'sm:-mr-72'
  | 'md:-mr-72'
  | 'mg:-mr-72'
  | 'lg:-mr-72'
  | 'xl:-mr-72'
  | 'sm:-mr-80'
  | 'md:-mr-80'
  | 'mg:-mr-80'
  | 'lg:-mr-80'
  | 'xl:-mr-80'
  | 'sm:-mr-96'
  | 'md:-mr-96'
  | 'mg:-mr-96'
  | 'lg:-mr-96'
  | 'xl:-mr-96'
  | 'sm:-mr-px'
  | 'md:-mr-px'
  | 'mg:-mr-px'
  | 'lg:-mr-px'
  | 'xl:-mr-px'
  | 'sm:-mr-0.5'
  | 'md:-mr-0.5'
  | 'mg:-mr-0.5'
  | 'lg:-mr-0.5'
  | 'xl:-mr-0.5'
  | 'sm:-mr-1.5'
  | 'md:-mr-1.5'
  | 'mg:-mr-1.5'
  | 'lg:-mr-1.5'
  | 'xl:-mr-1.5'
  | 'sm:-mr-2.5'
  | 'md:-mr-2.5'
  | 'mg:-mr-2.5'
  | 'lg:-mr-2.5'
  | 'xl:-mr-2.5'
  | 'sm:-mr-3.5'
  | 'md:-mr-3.5'
  | 'mg:-mr-3.5'
  | 'lg:-mr-3.5'
  | 'xl:-mr-3.5'
  | 'sm:mr-1/2'
  | 'md:mr-1/2'
  | 'mg:mr-1/2'
  | 'lg:mr-1/2'
  | 'xl:mr-1/2'
  | 'sm:mr-full'
  | 'md:mr-full'
  | 'mg:mr-full'
  | 'lg:mr-full'
  | 'xl:mr-full'
  | 'sm:mr-4.5'
  | 'md:mr-4.5'
  | 'mg:mr-4.5'
  | 'lg:mr-4.5'
  | 'xl:mr-4.5'
  | 'sm:mr-7.5'
  | 'md:mr-7.5'
  | 'mg:mr-7.5'
  | 'lg:mr-7.5'
  | 'xl:mr-7.5'
  | 'sm:mr-9.5'
  | 'md:mr-9.5'
  | 'mg:mr-9.5'
  | 'lg:mr-9.5'
  | 'xl:mr-9.5'
  | 'sm:mr-11.5'
  | 'md:mr-11.5'
  | 'mg:mr-11.5'
  | 'lg:mr-11.5'
  | 'xl:mr-11.5'
  | 'sm:-mr-15'
  | 'md:-mr-15'
  | 'mg:-mr-15'
  | 'lg:-mr-15'
  | 'xl:-mr-15'
  | 'sm:-mr-17'
  | 'md:-mr-17'
  | 'mg:-mr-17'
  | 'lg:-mr-17'
  | 'xl:-mr-17'
  | 'sm:-mr-18'
  | 'md:-mr-18'
  | 'mg:-mr-18'
  | 'lg:-mr-18'
  | 'xl:-mr-18'
  | 'sm:-mr-21'
  | 'md:-mr-21'
  | 'mg:-mr-21'
  | 'lg:-mr-21'
  | 'xl:-mr-21'
  | 'sm:-mr-22'
  | 'md:-mr-22'
  | 'mg:-mr-22'
  | 'lg:-mr-22'
  | 'xl:-mr-22'
  | 'sm:-mr-30'
  | 'md:-mr-30'
  | 'mg:-mr-30'
  | 'lg:-mr-30'
  | 'xl:-mr-30'
  | 'sm:-mr-1/2'
  | 'md:-mr-1/2'
  | 'mg:-mr-1/2'
  | 'lg:-mr-1/2'
  | 'xl:-mr-1/2'
  | 'sm:-mr-full'
  | 'md:-mr-full'
  | 'mg:-mr-full'
  | 'lg:-mr-full'
  | 'xl:-mr-full'
  | 'sm:-mr-4.5'
  | 'md:-mr-4.5'
  | 'mg:-mr-4.5'
  | 'lg:-mr-4.5'
  | 'xl:-mr-4.5'
  | 'sm:-mr-7.5'
  | 'md:-mr-7.5'
  | 'mg:-mr-7.5'
  | 'lg:-mr-7.5'
  | 'xl:-mr-7.5'
  | 'sm:-mr-9.5'
  | 'md:-mr-9.5'
  | 'mg:-mr-9.5'
  | 'lg:-mr-9.5'
  | 'xl:-mr-9.5'
  | 'sm:-mr-11.5'
  | 'md:-mr-11.5'
  | 'mg:-mr-11.5'
  | 'lg:-mr-11.5'
  | 'xl:-mr-11.5'
  | 'sm:mb-0'
  | 'md:mb-0'
  | 'mg:mb-0'
  | 'lg:mb-0'
  | 'xl:mb-0'
  | 'sm:mb-1'
  | 'md:mb-1'
  | 'mg:mb-1'
  | 'lg:mb-1'
  | 'xl:mb-1'
  | 'sm:mb-2'
  | 'md:mb-2'
  | 'mg:mb-2'
  | 'lg:mb-2'
  | 'xl:mb-2'
  | 'sm:mb-3'
  | 'md:mb-3'
  | 'mg:mb-3'
  | 'lg:mb-3'
  | 'xl:mb-3'
  | 'sm:mb-4'
  | 'md:mb-4'
  | 'mg:mb-4'
  | 'lg:mb-4'
  | 'xl:mb-4'
  | 'sm:mb-5'
  | 'md:mb-5'
  | 'mg:mb-5'
  | 'lg:mb-5'
  | 'xl:mb-5'
  | 'sm:mb-6'
  | 'md:mb-6'
  | 'mg:mb-6'
  | 'lg:mb-6'
  | 'xl:mb-6'
  | 'sm:mb-7'
  | 'md:mb-7'
  | 'mg:mb-7'
  | 'lg:mb-7'
  | 'xl:mb-7'
  | 'sm:mb-8'
  | 'md:mb-8'
  | 'mg:mb-8'
  | 'lg:mb-8'
  | 'xl:mb-8'
  | 'sm:mb-9'
  | 'md:mb-9'
  | 'mg:mb-9'
  | 'lg:mb-9'
  | 'xl:mb-9'
  | 'sm:mb-10'
  | 'md:mb-10'
  | 'mg:mb-10'
  | 'lg:mb-10'
  | 'xl:mb-10'
  | 'sm:mb-11'
  | 'md:mb-11'
  | 'mg:mb-11'
  | 'lg:mb-11'
  | 'xl:mb-11'
  | 'sm:mb-12'
  | 'md:mb-12'
  | 'mg:mb-12'
  | 'lg:mb-12'
  | 'xl:mb-12'
  | 'sm:mb-14'
  | 'md:mb-14'
  | 'mg:mb-14'
  | 'lg:mb-14'
  | 'xl:mb-14'
  | 'sm:mb-15'
  | 'md:mb-15'
  | 'mg:mb-15'
  | 'lg:mb-15'
  | 'xl:mb-15'
  | 'sm:mb-16'
  | 'md:mb-16'
  | 'mg:mb-16'
  | 'lg:mb-16'
  | 'xl:mb-16'
  | 'sm:mb-17'
  | 'md:mb-17'
  | 'mg:mb-17'
  | 'lg:mb-17'
  | 'xl:mb-17'
  | 'sm:mb-18'
  | 'md:mb-18'
  | 'mg:mb-18'
  | 'lg:mb-18'
  | 'xl:mb-18'
  | 'sm:mb-20'
  | 'md:mb-20'
  | 'mg:mb-20'
  | 'lg:mb-20'
  | 'xl:mb-20'
  | 'sm:mb-21'
  | 'md:mb-21'
  | 'mg:mb-21'
  | 'lg:mb-21'
  | 'xl:mb-21'
  | 'sm:mb-22'
  | 'md:mb-22'
  | 'mg:mb-22'
  | 'lg:mb-22'
  | 'xl:mb-22'
  | 'sm:mb-24'
  | 'md:mb-24'
  | 'mg:mb-24'
  | 'lg:mb-24'
  | 'xl:mb-24'
  | 'sm:mb-28'
  | 'md:mb-28'
  | 'mg:mb-28'
  | 'lg:mb-28'
  | 'xl:mb-28'
  | 'sm:mb-30'
  | 'md:mb-30'
  | 'mg:mb-30'
  | 'lg:mb-30'
  | 'xl:mb-30'
  | 'sm:mb-32'
  | 'md:mb-32'
  | 'mg:mb-32'
  | 'lg:mb-32'
  | 'xl:mb-32'
  | 'sm:mb-36'
  | 'md:mb-36'
  | 'mg:mb-36'
  | 'lg:mb-36'
  | 'xl:mb-36'
  | 'sm:mb-40'
  | 'md:mb-40'
  | 'mg:mb-40'
  | 'lg:mb-40'
  | 'xl:mb-40'
  | 'sm:mb-44'
  | 'md:mb-44'
  | 'mg:mb-44'
  | 'lg:mb-44'
  | 'xl:mb-44'
  | 'sm:mb-48'
  | 'md:mb-48'
  | 'mg:mb-48'
  | 'lg:mb-48'
  | 'xl:mb-48'
  | 'sm:mb-52'
  | 'md:mb-52'
  | 'mg:mb-52'
  | 'lg:mb-52'
  | 'xl:mb-52'
  | 'sm:mb-56'
  | 'md:mb-56'
  | 'mg:mb-56'
  | 'lg:mb-56'
  | 'xl:mb-56'
  | 'sm:mb-60'
  | 'md:mb-60'
  | 'mg:mb-60'
  | 'lg:mb-60'
  | 'xl:mb-60'
  | 'sm:mb-64'
  | 'md:mb-64'
  | 'mg:mb-64'
  | 'lg:mb-64'
  | 'xl:mb-64'
  | 'sm:mb-72'
  | 'md:mb-72'
  | 'mg:mb-72'
  | 'lg:mb-72'
  | 'xl:mb-72'
  | 'sm:mb-80'
  | 'md:mb-80'
  | 'mg:mb-80'
  | 'lg:mb-80'
  | 'xl:mb-80'
  | 'sm:mb-96'
  | 'md:mb-96'
  | 'mg:mb-96'
  | 'lg:mb-96'
  | 'xl:mb-96'
  | 'sm:mb-auto'
  | 'md:mb-auto'
  | 'mg:mb-auto'
  | 'lg:mb-auto'
  | 'xl:mb-auto'
  | 'sm:mb-px'
  | 'md:mb-px'
  | 'mg:mb-px'
  | 'lg:mb-px'
  | 'xl:mb-px'
  | 'sm:mb-0.5'
  | 'md:mb-0.5'
  | 'mg:mb-0.5'
  | 'lg:mb-0.5'
  | 'xl:mb-0.5'
  | 'sm:mb-1.5'
  | 'md:mb-1.5'
  | 'mg:mb-1.5'
  | 'lg:mb-1.5'
  | 'xl:mb-1.5'
  | 'sm:mb-2.5'
  | 'md:mb-2.5'
  | 'mg:mb-2.5'
  | 'lg:mb-2.5'
  | 'xl:mb-2.5'
  | 'sm:mb-3.5'
  | 'md:mb-3.5'
  | 'mg:mb-3.5'
  | 'lg:mb-3.5'
  | 'xl:mb-3.5'
  | 'sm:-mb-0'
  | 'md:-mb-0'
  | 'mg:-mb-0'
  | 'lg:-mb-0'
  | 'xl:-mb-0'
  | 'sm:-mb-1'
  | 'md:-mb-1'
  | 'mg:-mb-1'
  | 'lg:-mb-1'
  | 'xl:-mb-1'
  | 'sm:-mb-2'
  | 'md:-mb-2'
  | 'mg:-mb-2'
  | 'lg:-mb-2'
  | 'xl:-mb-2'
  | 'sm:-mb-3'
  | 'md:-mb-3'
  | 'mg:-mb-3'
  | 'lg:-mb-3'
  | 'xl:-mb-3'
  | 'sm:-mb-4'
  | 'md:-mb-4'
  | 'mg:-mb-4'
  | 'lg:-mb-4'
  | 'xl:-mb-4'
  | 'sm:-mb-5'
  | 'md:-mb-5'
  | 'mg:-mb-5'
  | 'lg:-mb-5'
  | 'xl:-mb-5'
  | 'sm:-mb-6'
  | 'md:-mb-6'
  | 'mg:-mb-6'
  | 'lg:-mb-6'
  | 'xl:-mb-6'
  | 'sm:-mb-7'
  | 'md:-mb-7'
  | 'mg:-mb-7'
  | 'lg:-mb-7'
  | 'xl:-mb-7'
  | 'sm:-mb-8'
  | 'md:-mb-8'
  | 'mg:-mb-8'
  | 'lg:-mb-8'
  | 'xl:-mb-8'
  | 'sm:-mb-9'
  | 'md:-mb-9'
  | 'mg:-mb-9'
  | 'lg:-mb-9'
  | 'xl:-mb-9'
  | 'sm:-mb-10'
  | 'md:-mb-10'
  | 'mg:-mb-10'
  | 'lg:-mb-10'
  | 'xl:-mb-10'
  | 'sm:-mb-11'
  | 'md:-mb-11'
  | 'mg:-mb-11'
  | 'lg:-mb-11'
  | 'xl:-mb-11'
  | 'sm:-mb-12'
  | 'md:-mb-12'
  | 'mg:-mb-12'
  | 'lg:-mb-12'
  | 'xl:-mb-12'
  | 'sm:-mb-14'
  | 'md:-mb-14'
  | 'mg:-mb-14'
  | 'lg:-mb-14'
  | 'xl:-mb-14'
  | 'sm:-mb-16'
  | 'md:-mb-16'
  | 'mg:-mb-16'
  | 'lg:-mb-16'
  | 'xl:-mb-16'
  | 'sm:-mb-20'
  | 'md:-mb-20'
  | 'mg:-mb-20'
  | 'lg:-mb-20'
  | 'xl:-mb-20'
  | 'sm:-mb-24'
  | 'md:-mb-24'
  | 'mg:-mb-24'
  | 'lg:-mb-24'
  | 'xl:-mb-24'
  | 'sm:-mb-28'
  | 'md:-mb-28'
  | 'mg:-mb-28'
  | 'lg:-mb-28'
  | 'xl:-mb-28'
  | 'sm:-mb-32'
  | 'md:-mb-32'
  | 'mg:-mb-32'
  | 'lg:-mb-32'
  | 'xl:-mb-32'
  | 'sm:-mb-36'
  | 'md:-mb-36'
  | 'mg:-mb-36'
  | 'lg:-mb-36'
  | 'xl:-mb-36'
  | 'sm:-mb-40'
  | 'md:-mb-40'
  | 'mg:-mb-40'
  | 'lg:-mb-40'
  | 'xl:-mb-40'
  | 'sm:-mb-44'
  | 'md:-mb-44'
  | 'mg:-mb-44'
  | 'lg:-mb-44'
  | 'xl:-mb-44'
  | 'sm:-mb-48'
  | 'md:-mb-48'
  | 'mg:-mb-48'
  | 'lg:-mb-48'
  | 'xl:-mb-48'
  | 'sm:-mb-52'
  | 'md:-mb-52'
  | 'mg:-mb-52'
  | 'lg:-mb-52'
  | 'xl:-mb-52'
  | 'sm:-mb-56'
  | 'md:-mb-56'
  | 'mg:-mb-56'
  | 'lg:-mb-56'
  | 'xl:-mb-56'
  | 'sm:-mb-60'
  | 'md:-mb-60'
  | 'mg:-mb-60'
  | 'lg:-mb-60'
  | 'xl:-mb-60'
  | 'sm:-mb-64'
  | 'md:-mb-64'
  | 'mg:-mb-64'
  | 'lg:-mb-64'
  | 'xl:-mb-64'
  | 'sm:-mb-72'
  | 'md:-mb-72'
  | 'mg:-mb-72'
  | 'lg:-mb-72'
  | 'xl:-mb-72'
  | 'sm:-mb-80'
  | 'md:-mb-80'
  | 'mg:-mb-80'
  | 'lg:-mb-80'
  | 'xl:-mb-80'
  | 'sm:-mb-96'
  | 'md:-mb-96'
  | 'mg:-mb-96'
  | 'lg:-mb-96'
  | 'xl:-mb-96'
  | 'sm:-mb-px'
  | 'md:-mb-px'
  | 'mg:-mb-px'
  | 'lg:-mb-px'
  | 'xl:-mb-px'
  | 'sm:-mb-0.5'
  | 'md:-mb-0.5'
  | 'mg:-mb-0.5'
  | 'lg:-mb-0.5'
  | 'xl:-mb-0.5'
  | 'sm:-mb-1.5'
  | 'md:-mb-1.5'
  | 'mg:-mb-1.5'
  | 'lg:-mb-1.5'
  | 'xl:-mb-1.5'
  | 'sm:-mb-2.5'
  | 'md:-mb-2.5'
  | 'mg:-mb-2.5'
  | 'lg:-mb-2.5'
  | 'xl:-mb-2.5'
  | 'sm:-mb-3.5'
  | 'md:-mb-3.5'
  | 'mg:-mb-3.5'
  | 'lg:-mb-3.5'
  | 'xl:-mb-3.5'
  | 'sm:mb-1/2'
  | 'md:mb-1/2'
  | 'mg:mb-1/2'
  | 'lg:mb-1/2'
  | 'xl:mb-1/2'
  | 'sm:mb-full'
  | 'md:mb-full'
  | 'mg:mb-full'
  | 'lg:mb-full'
  | 'xl:mb-full'
  | 'sm:mb-4.5'
  | 'md:mb-4.5'
  | 'mg:mb-4.5'
  | 'lg:mb-4.5'
  | 'xl:mb-4.5'
  | 'sm:mb-7.5'
  | 'md:mb-7.5'
  | 'mg:mb-7.5'
  | 'lg:mb-7.5'
  | 'xl:mb-7.5'
  | 'sm:mb-9.5'
  | 'md:mb-9.5'
  | 'mg:mb-9.5'
  | 'lg:mb-9.5'
  | 'xl:mb-9.5'
  | 'sm:mb-11.5'
  | 'md:mb-11.5'
  | 'mg:mb-11.5'
  | 'lg:mb-11.5'
  | 'xl:mb-11.5'
  | 'sm:-mb-15'
  | 'md:-mb-15'
  | 'mg:-mb-15'
  | 'lg:-mb-15'
  | 'xl:-mb-15'
  | 'sm:-mb-17'
  | 'md:-mb-17'
  | 'mg:-mb-17'
  | 'lg:-mb-17'
  | 'xl:-mb-17'
  | 'sm:-mb-18'
  | 'md:-mb-18'
  | 'mg:-mb-18'
  | 'lg:-mb-18'
  | 'xl:-mb-18'
  | 'sm:-mb-21'
  | 'md:-mb-21'
  | 'mg:-mb-21'
  | 'lg:-mb-21'
  | 'xl:-mb-21'
  | 'sm:-mb-22'
  | 'md:-mb-22'
  | 'mg:-mb-22'
  | 'lg:-mb-22'
  | 'xl:-mb-22'
  | 'sm:-mb-30'
  | 'md:-mb-30'
  | 'mg:-mb-30'
  | 'lg:-mb-30'
  | 'xl:-mb-30'
  | 'sm:-mb-1/2'
  | 'md:-mb-1/2'
  | 'mg:-mb-1/2'
  | 'lg:-mb-1/2'
  | 'xl:-mb-1/2'
  | 'sm:-mb-full'
  | 'md:-mb-full'
  | 'mg:-mb-full'
  | 'lg:-mb-full'
  | 'xl:-mb-full'
  | 'sm:-mb-4.5'
  | 'md:-mb-4.5'
  | 'mg:-mb-4.5'
  | 'lg:-mb-4.5'
  | 'xl:-mb-4.5'
  | 'sm:-mb-7.5'
  | 'md:-mb-7.5'
  | 'mg:-mb-7.5'
  | 'lg:-mb-7.5'
  | 'xl:-mb-7.5'
  | 'sm:-mb-9.5'
  | 'md:-mb-9.5'
  | 'mg:-mb-9.5'
  | 'lg:-mb-9.5'
  | 'xl:-mb-9.5'
  | 'sm:-mb-11.5'
  | 'md:-mb-11.5'
  | 'mg:-mb-11.5'
  | 'lg:-mb-11.5'
  | 'xl:-mb-11.5'
  | 'sm:ml-0'
  | 'md:ml-0'
  | 'mg:ml-0'
  | 'lg:ml-0'
  | 'xl:ml-0'
  | 'sm:ml-1'
  | 'md:ml-1'
  | 'mg:ml-1'
  | 'lg:ml-1'
  | 'xl:ml-1'
  | 'sm:ml-2'
  | 'md:ml-2'
  | 'mg:ml-2'
  | 'lg:ml-2'
  | 'xl:ml-2'
  | 'sm:ml-3'
  | 'md:ml-3'
  | 'mg:ml-3'
  | 'lg:ml-3'
  | 'xl:ml-3'
  | 'sm:ml-4'
  | 'md:ml-4'
  | 'mg:ml-4'
  | 'lg:ml-4'
  | 'xl:ml-4'
  | 'sm:ml-5'
  | 'md:ml-5'
  | 'mg:ml-5'
  | 'lg:ml-5'
  | 'xl:ml-5'
  | 'sm:ml-6'
  | 'md:ml-6'
  | 'mg:ml-6'
  | 'lg:ml-6'
  | 'xl:ml-6'
  | 'sm:ml-7'
  | 'md:ml-7'
  | 'mg:ml-7'
  | 'lg:ml-7'
  | 'xl:ml-7'
  | 'sm:ml-8'
  | 'md:ml-8'
  | 'mg:ml-8'
  | 'lg:ml-8'
  | 'xl:ml-8'
  | 'sm:ml-9'
  | 'md:ml-9'
  | 'mg:ml-9'
  | 'lg:ml-9'
  | 'xl:ml-9'
  | 'sm:ml-10'
  | 'md:ml-10'
  | 'mg:ml-10'
  | 'lg:ml-10'
  | 'xl:ml-10'
  | 'sm:ml-11'
  | 'md:ml-11'
  | 'mg:ml-11'
  | 'lg:ml-11'
  | 'xl:ml-11'
  | 'sm:ml-12'
  | 'md:ml-12'
  | 'mg:ml-12'
  | 'lg:ml-12'
  | 'xl:ml-12'
  | 'sm:ml-14'
  | 'md:ml-14'
  | 'mg:ml-14'
  | 'lg:ml-14'
  | 'xl:ml-14'
  | 'sm:ml-15'
  | 'md:ml-15'
  | 'mg:ml-15'
  | 'lg:ml-15'
  | 'xl:ml-15'
  | 'sm:ml-16'
  | 'md:ml-16'
  | 'mg:ml-16'
  | 'lg:ml-16'
  | 'xl:ml-16'
  | 'sm:ml-17'
  | 'md:ml-17'
  | 'mg:ml-17'
  | 'lg:ml-17'
  | 'xl:ml-17'
  | 'sm:ml-18'
  | 'md:ml-18'
  | 'mg:ml-18'
  | 'lg:ml-18'
  | 'xl:ml-18'
  | 'sm:ml-20'
  | 'md:ml-20'
  | 'mg:ml-20'
  | 'lg:ml-20'
  | 'xl:ml-20'
  | 'sm:ml-21'
  | 'md:ml-21'
  | 'mg:ml-21'
  | 'lg:ml-21'
  | 'xl:ml-21'
  | 'sm:ml-22'
  | 'md:ml-22'
  | 'mg:ml-22'
  | 'lg:ml-22'
  | 'xl:ml-22'
  | 'sm:ml-24'
  | 'md:ml-24'
  | 'mg:ml-24'
  | 'lg:ml-24'
  | 'xl:ml-24'
  | 'sm:ml-28'
  | 'md:ml-28'
  | 'mg:ml-28'
  | 'lg:ml-28'
  | 'xl:ml-28'
  | 'sm:ml-30'
  | 'md:ml-30'
  | 'mg:ml-30'
  | 'lg:ml-30'
  | 'xl:ml-30'
  | 'sm:ml-32'
  | 'md:ml-32'
  | 'mg:ml-32'
  | 'lg:ml-32'
  | 'xl:ml-32'
  | 'sm:ml-36'
  | 'md:ml-36'
  | 'mg:ml-36'
  | 'lg:ml-36'
  | 'xl:ml-36'
  | 'sm:ml-40'
  | 'md:ml-40'
  | 'mg:ml-40'
  | 'lg:ml-40'
  | 'xl:ml-40'
  | 'sm:ml-44'
  | 'md:ml-44'
  | 'mg:ml-44'
  | 'lg:ml-44'
  | 'xl:ml-44'
  | 'sm:ml-48'
  | 'md:ml-48'
  | 'mg:ml-48'
  | 'lg:ml-48'
  | 'xl:ml-48'
  | 'sm:ml-52'
  | 'md:ml-52'
  | 'mg:ml-52'
  | 'lg:ml-52'
  | 'xl:ml-52'
  | 'sm:ml-56'
  | 'md:ml-56'
  | 'mg:ml-56'
  | 'lg:ml-56'
  | 'xl:ml-56'
  | 'sm:ml-60'
  | 'md:ml-60'
  | 'mg:ml-60'
  | 'lg:ml-60'
  | 'xl:ml-60'
  | 'sm:ml-64'
  | 'md:ml-64'
  | 'mg:ml-64'
  | 'lg:ml-64'
  | 'xl:ml-64'
  | 'sm:ml-72'
  | 'md:ml-72'
  | 'mg:ml-72'
  | 'lg:ml-72'
  | 'xl:ml-72'
  | 'sm:ml-80'
  | 'md:ml-80'
  | 'mg:ml-80'
  | 'lg:ml-80'
  | 'xl:ml-80'
  | 'sm:ml-96'
  | 'md:ml-96'
  | 'mg:ml-96'
  | 'lg:ml-96'
  | 'xl:ml-96'
  | 'sm:ml-auto'
  | 'md:ml-auto'
  | 'mg:ml-auto'
  | 'lg:ml-auto'
  | 'xl:ml-auto'
  | 'sm:ml-px'
  | 'md:ml-px'
  | 'mg:ml-px'
  | 'lg:ml-px'
  | 'xl:ml-px'
  | 'sm:ml-0.5'
  | 'md:ml-0.5'
  | 'mg:ml-0.5'
  | 'lg:ml-0.5'
  | 'xl:ml-0.5'
  | 'sm:ml-1.5'
  | 'md:ml-1.5'
  | 'mg:ml-1.5'
  | 'lg:ml-1.5'
  | 'xl:ml-1.5'
  | 'sm:ml-2.5'
  | 'md:ml-2.5'
  | 'mg:ml-2.5'
  | 'lg:ml-2.5'
  | 'xl:ml-2.5'
  | 'sm:ml-3.5'
  | 'md:ml-3.5'
  | 'mg:ml-3.5'
  | 'lg:ml-3.5'
  | 'xl:ml-3.5'
  | 'sm:-ml-0'
  | 'md:-ml-0'
  | 'mg:-ml-0'
  | 'lg:-ml-0'
  | 'xl:-ml-0'
  | 'sm:-ml-1'
  | 'md:-ml-1'
  | 'mg:-ml-1'
  | 'lg:-ml-1'
  | 'xl:-ml-1'
  | 'sm:-ml-2'
  | 'md:-ml-2'
  | 'mg:-ml-2'
  | 'lg:-ml-2'
  | 'xl:-ml-2'
  | 'sm:-ml-3'
  | 'md:-ml-3'
  | 'mg:-ml-3'
  | 'lg:-ml-3'
  | 'xl:-ml-3'
  | 'sm:-ml-4'
  | 'md:-ml-4'
  | 'mg:-ml-4'
  | 'lg:-ml-4'
  | 'xl:-ml-4'
  | 'sm:-ml-5'
  | 'md:-ml-5'
  | 'mg:-ml-5'
  | 'lg:-ml-5'
  | 'xl:-ml-5'
  | 'sm:-ml-6'
  | 'md:-ml-6'
  | 'mg:-ml-6'
  | 'lg:-ml-6'
  | 'xl:-ml-6'
  | 'sm:-ml-7'
  | 'md:-ml-7'
  | 'mg:-ml-7'
  | 'lg:-ml-7'
  | 'xl:-ml-7'
  | 'sm:-ml-8'
  | 'md:-ml-8'
  | 'mg:-ml-8'
  | 'lg:-ml-8'
  | 'xl:-ml-8'
  | 'sm:-ml-9'
  | 'md:-ml-9'
  | 'mg:-ml-9'
  | 'lg:-ml-9'
  | 'xl:-ml-9'
  | 'sm:-ml-10'
  | 'md:-ml-10'
  | 'mg:-ml-10'
  | 'lg:-ml-10'
  | 'xl:-ml-10'
  | 'sm:-ml-11'
  | 'md:-ml-11'
  | 'mg:-ml-11'
  | 'lg:-ml-11'
  | 'xl:-ml-11'
  | 'sm:-ml-12'
  | 'md:-ml-12'
  | 'mg:-ml-12'
  | 'lg:-ml-12'
  | 'xl:-ml-12'
  | 'sm:-ml-14'
  | 'md:-ml-14'
  | 'mg:-ml-14'
  | 'lg:-ml-14'
  | 'xl:-ml-14'
  | 'sm:-ml-16'
  | 'md:-ml-16'
  | 'mg:-ml-16'
  | 'lg:-ml-16'
  | 'xl:-ml-16'
  | 'sm:-ml-20'
  | 'md:-ml-20'
  | 'mg:-ml-20'
  | 'lg:-ml-20'
  | 'xl:-ml-20'
  | 'sm:-ml-24'
  | 'md:-ml-24'
  | 'mg:-ml-24'
  | 'lg:-ml-24'
  | 'xl:-ml-24'
  | 'sm:-ml-28'
  | 'md:-ml-28'
  | 'mg:-ml-28'
  | 'lg:-ml-28'
  | 'xl:-ml-28'
  | 'sm:-ml-32'
  | 'md:-ml-32'
  | 'mg:-ml-32'
  | 'lg:-ml-32'
  | 'xl:-ml-32'
  | 'sm:-ml-36'
  | 'md:-ml-36'
  | 'mg:-ml-36'
  | 'lg:-ml-36'
  | 'xl:-ml-36'
  | 'sm:-ml-40'
  | 'md:-ml-40'
  | 'mg:-ml-40'
  | 'lg:-ml-40'
  | 'xl:-ml-40'
  | 'sm:-ml-44'
  | 'md:-ml-44'
  | 'mg:-ml-44'
  | 'lg:-ml-44'
  | 'xl:-ml-44'
  | 'sm:-ml-48'
  | 'md:-ml-48'
  | 'mg:-ml-48'
  | 'lg:-ml-48'
  | 'xl:-ml-48'
  | 'sm:-ml-52'
  | 'md:-ml-52'
  | 'mg:-ml-52'
  | 'lg:-ml-52'
  | 'xl:-ml-52'
  | 'sm:-ml-56'
  | 'md:-ml-56'
  | 'mg:-ml-56'
  | 'lg:-ml-56'
  | 'xl:-ml-56'
  | 'sm:-ml-60'
  | 'md:-ml-60'
  | 'mg:-ml-60'
  | 'lg:-ml-60'
  | 'xl:-ml-60'
  | 'sm:-ml-64'
  | 'md:-ml-64'
  | 'mg:-ml-64'
  | 'lg:-ml-64'
  | 'xl:-ml-64'
  | 'sm:-ml-72'
  | 'md:-ml-72'
  | 'mg:-ml-72'
  | 'lg:-ml-72'
  | 'xl:-ml-72'
  | 'sm:-ml-80'
  | 'md:-ml-80'
  | 'mg:-ml-80'
  | 'lg:-ml-80'
  | 'xl:-ml-80'
  | 'sm:-ml-96'
  | 'md:-ml-96'
  | 'mg:-ml-96'
  | 'lg:-ml-96'
  | 'xl:-ml-96'
  | 'sm:-ml-px'
  | 'md:-ml-px'
  | 'mg:-ml-px'
  | 'lg:-ml-px'
  | 'xl:-ml-px'
  | 'sm:-ml-0.5'
  | 'md:-ml-0.5'
  | 'mg:-ml-0.5'
  | 'lg:-ml-0.5'
  | 'xl:-ml-0.5'
  | 'sm:-ml-1.5'
  | 'md:-ml-1.5'
  | 'mg:-ml-1.5'
  | 'lg:-ml-1.5'
  | 'xl:-ml-1.5'
  | 'sm:-ml-2.5'
  | 'md:-ml-2.5'
  | 'mg:-ml-2.5'
  | 'lg:-ml-2.5'
  | 'xl:-ml-2.5'
  | 'sm:-ml-3.5'
  | 'md:-ml-3.5'
  | 'mg:-ml-3.5'
  | 'lg:-ml-3.5'
  | 'xl:-ml-3.5'
  | 'sm:ml-1/2'
  | 'md:ml-1/2'
  | 'mg:ml-1/2'
  | 'lg:ml-1/2'
  | 'xl:ml-1/2'
  | 'sm:ml-full'
  | 'md:ml-full'
  | 'mg:ml-full'
  | 'lg:ml-full'
  | 'xl:ml-full'
  | 'sm:ml-4.5'
  | 'md:ml-4.5'
  | 'mg:ml-4.5'
  | 'lg:ml-4.5'
  | 'xl:ml-4.5'
  | 'sm:ml-7.5'
  | 'md:ml-7.5'
  | 'mg:ml-7.5'
  | 'lg:ml-7.5'
  | 'xl:ml-7.5'
  | 'sm:ml-9.5'
  | 'md:ml-9.5'
  | 'mg:ml-9.5'
  | 'lg:ml-9.5'
  | 'xl:ml-9.5'
  | 'sm:ml-11.5'
  | 'md:ml-11.5'
  | 'mg:ml-11.5'
  | 'lg:ml-11.5'
  | 'xl:ml-11.5'
  | 'sm:-ml-15'
  | 'md:-ml-15'
  | 'mg:-ml-15'
  | 'lg:-ml-15'
  | 'xl:-ml-15'
  | 'sm:-ml-17'
  | 'md:-ml-17'
  | 'mg:-ml-17'
  | 'lg:-ml-17'
  | 'xl:-ml-17'
  | 'sm:-ml-18'
  | 'md:-ml-18'
  | 'mg:-ml-18'
  | 'lg:-ml-18'
  | 'xl:-ml-18'
  | 'sm:-ml-21'
  | 'md:-ml-21'
  | 'mg:-ml-21'
  | 'lg:-ml-21'
  | 'xl:-ml-21'
  | 'sm:-ml-22'
  | 'md:-ml-22'
  | 'mg:-ml-22'
  | 'lg:-ml-22'
  | 'xl:-ml-22'
  | 'sm:-ml-30'
  | 'md:-ml-30'
  | 'mg:-ml-30'
  | 'lg:-ml-30'
  | 'xl:-ml-30'
  | 'sm:-ml-1/2'
  | 'md:-ml-1/2'
  | 'mg:-ml-1/2'
  | 'lg:-ml-1/2'
  | 'xl:-ml-1/2'
  | 'sm:-ml-full'
  | 'md:-ml-full'
  | 'mg:-ml-full'
  | 'lg:-ml-full'
  | 'xl:-ml-full'
  | 'sm:-ml-4.5'
  | 'md:-ml-4.5'
  | 'mg:-ml-4.5'
  | 'lg:-ml-4.5'
  | 'xl:-ml-4.5'
  | 'sm:-ml-7.5'
  | 'md:-ml-7.5'
  | 'mg:-ml-7.5'
  | 'lg:-ml-7.5'
  | 'xl:-ml-7.5'
  | 'sm:-ml-9.5'
  | 'md:-ml-9.5'
  | 'mg:-ml-9.5'
  | 'lg:-ml-9.5'
  | 'xl:-ml-9.5'
  | 'sm:-ml-11.5'
  | 'md:-ml-11.5'
  | 'mg:-ml-11.5'
  | 'lg:-ml-11.5'
  | 'xl:-ml-11.5'
  | 'sm:max-h-0'
  | 'md:max-h-0'
  | 'mg:max-h-0'
  | 'lg:max-h-0'
  | 'xl:max-h-0'
  | 'sm:max-h-1'
  | 'md:max-h-1'
  | 'mg:max-h-1'
  | 'lg:max-h-1'
  | 'xl:max-h-1'
  | 'sm:max-h-2'
  | 'md:max-h-2'
  | 'mg:max-h-2'
  | 'lg:max-h-2'
  | 'xl:max-h-2'
  | 'sm:max-h-3'
  | 'md:max-h-3'
  | 'mg:max-h-3'
  | 'lg:max-h-3'
  | 'xl:max-h-3'
  | 'sm:max-h-4'
  | 'md:max-h-4'
  | 'mg:max-h-4'
  | 'lg:max-h-4'
  | 'xl:max-h-4'
  | 'sm:max-h-5'
  | 'md:max-h-5'
  | 'mg:max-h-5'
  | 'lg:max-h-5'
  | 'xl:max-h-5'
  | 'sm:max-h-6'
  | 'md:max-h-6'
  | 'mg:max-h-6'
  | 'lg:max-h-6'
  | 'xl:max-h-6'
  | 'sm:max-h-7'
  | 'md:max-h-7'
  | 'mg:max-h-7'
  | 'lg:max-h-7'
  | 'xl:max-h-7'
  | 'sm:max-h-8'
  | 'md:max-h-8'
  | 'mg:max-h-8'
  | 'lg:max-h-8'
  | 'xl:max-h-8'
  | 'sm:max-h-9'
  | 'md:max-h-9'
  | 'mg:max-h-9'
  | 'lg:max-h-9'
  | 'xl:max-h-9'
  | 'sm:max-h-10'
  | 'md:max-h-10'
  | 'mg:max-h-10'
  | 'lg:max-h-10'
  | 'xl:max-h-10'
  | 'sm:max-h-11'
  | 'md:max-h-11'
  | 'mg:max-h-11'
  | 'lg:max-h-11'
  | 'xl:max-h-11'
  | 'sm:max-h-12'
  | 'md:max-h-12'
  | 'mg:max-h-12'
  | 'lg:max-h-12'
  | 'xl:max-h-12'
  | 'sm:max-h-14'
  | 'md:max-h-14'
  | 'mg:max-h-14'
  | 'lg:max-h-14'
  | 'xl:max-h-14'
  | 'sm:max-h-15'
  | 'md:max-h-15'
  | 'mg:max-h-15'
  | 'lg:max-h-15'
  | 'xl:max-h-15'
  | 'sm:max-h-16'
  | 'md:max-h-16'
  | 'mg:max-h-16'
  | 'lg:max-h-16'
  | 'xl:max-h-16'
  | 'sm:max-h-17'
  | 'md:max-h-17'
  | 'mg:max-h-17'
  | 'lg:max-h-17'
  | 'xl:max-h-17'
  | 'sm:max-h-18'
  | 'md:max-h-18'
  | 'mg:max-h-18'
  | 'lg:max-h-18'
  | 'xl:max-h-18'
  | 'sm:max-h-20'
  | 'md:max-h-20'
  | 'mg:max-h-20'
  | 'lg:max-h-20'
  | 'xl:max-h-20'
  | 'sm:max-h-21'
  | 'md:max-h-21'
  | 'mg:max-h-21'
  | 'lg:max-h-21'
  | 'xl:max-h-21'
  | 'sm:max-h-22'
  | 'md:max-h-22'
  | 'mg:max-h-22'
  | 'lg:max-h-22'
  | 'xl:max-h-22'
  | 'sm:max-h-24'
  | 'md:max-h-24'
  | 'mg:max-h-24'
  | 'lg:max-h-24'
  | 'xl:max-h-24'
  | 'sm:max-h-28'
  | 'md:max-h-28'
  | 'mg:max-h-28'
  | 'lg:max-h-28'
  | 'xl:max-h-28'
  | 'sm:max-h-30'
  | 'md:max-h-30'
  | 'mg:max-h-30'
  | 'lg:max-h-30'
  | 'xl:max-h-30'
  | 'sm:max-h-32'
  | 'md:max-h-32'
  | 'mg:max-h-32'
  | 'lg:max-h-32'
  | 'xl:max-h-32'
  | 'sm:max-h-36'
  | 'md:max-h-36'
  | 'mg:max-h-36'
  | 'lg:max-h-36'
  | 'xl:max-h-36'
  | 'sm:max-h-40'
  | 'md:max-h-40'
  | 'mg:max-h-40'
  | 'lg:max-h-40'
  | 'xl:max-h-40'
  | 'sm:max-h-44'
  | 'md:max-h-44'
  | 'mg:max-h-44'
  | 'lg:max-h-44'
  | 'xl:max-h-44'
  | 'sm:max-h-48'
  | 'md:max-h-48'
  | 'mg:max-h-48'
  | 'lg:max-h-48'
  | 'xl:max-h-48'
  | 'sm:max-h-52'
  | 'md:max-h-52'
  | 'mg:max-h-52'
  | 'lg:max-h-52'
  | 'xl:max-h-52'
  | 'sm:max-h-56'
  | 'md:max-h-56'
  | 'mg:max-h-56'
  | 'lg:max-h-56'
  | 'xl:max-h-56'
  | 'sm:max-h-60'
  | 'md:max-h-60'
  | 'mg:max-h-60'
  | 'lg:max-h-60'
  | 'xl:max-h-60'
  | 'sm:max-h-64'
  | 'md:max-h-64'
  | 'mg:max-h-64'
  | 'lg:max-h-64'
  | 'xl:max-h-64'
  | 'sm:max-h-72'
  | 'md:max-h-72'
  | 'mg:max-h-72'
  | 'lg:max-h-72'
  | 'xl:max-h-72'
  | 'sm:max-h-80'
  | 'md:max-h-80'
  | 'mg:max-h-80'
  | 'lg:max-h-80'
  | 'xl:max-h-80'
  | 'sm:max-h-96'
  | 'md:max-h-96'
  | 'mg:max-h-96'
  | 'lg:max-h-96'
  | 'xl:max-h-96'
  | 'sm:max-h-px'
  | 'md:max-h-px'
  | 'mg:max-h-px'
  | 'lg:max-h-px'
  | 'xl:max-h-px'
  | 'sm:max-h-0.5'
  | 'md:max-h-0.5'
  | 'mg:max-h-0.5'
  | 'lg:max-h-0.5'
  | 'xl:max-h-0.5'
  | 'sm:max-h-1.5'
  | 'md:max-h-1.5'
  | 'mg:max-h-1.5'
  | 'lg:max-h-1.5'
  | 'xl:max-h-1.5'
  | 'sm:max-h-2.5'
  | 'md:max-h-2.5'
  | 'mg:max-h-2.5'
  | 'lg:max-h-2.5'
  | 'xl:max-h-2.5'
  | 'sm:max-h-3.5'
  | 'md:max-h-3.5'
  | 'mg:max-h-3.5'
  | 'lg:max-h-3.5'
  | 'xl:max-h-3.5'
  | 'sm:max-h-full'
  | 'md:max-h-full'
  | 'mg:max-h-full'
  | 'lg:max-h-full'
  | 'xl:max-h-full'
  | 'sm:max-h-screen'
  | 'md:max-h-screen'
  | 'mg:max-h-screen'
  | 'lg:max-h-screen'
  | 'xl:max-h-screen'
  | 'sm:max-h-dynamic-screen'
  | 'md:max-h-dynamic-screen'
  | 'mg:max-h-dynamic-screen'
  | 'lg:max-h-dynamic-screen'
  | 'xl:max-h-dynamic-screen'
  | 'sm:max-h-tiny-swatch'
  | 'md:max-h-tiny-swatch'
  | 'mg:max-h-tiny-swatch'
  | 'lg:max-h-tiny-swatch'
  | 'xl:max-h-tiny-swatch'
  | 'sm:max-h-mini-swatch'
  | 'md:max-h-mini-swatch'
  | 'mg:max-h-mini-swatch'
  | 'lg:max-h-mini-swatch'
  | 'xl:max-h-mini-swatch'
  | 'sm:max-h-swatch'
  | 'md:max-h-swatch'
  | 'mg:max-h-swatch'
  | 'lg:max-h-swatch'
  | 'xl:max-h-swatch'
  | 'sm:max-h-1/2'
  | 'md:max-h-1/2'
  | 'mg:max-h-1/2'
  | 'lg:max-h-1/2'
  | 'xl:max-h-1/2'
  | 'sm:max-h-4.5'
  | 'md:max-h-4.5'
  | 'mg:max-h-4.5'
  | 'lg:max-h-4.5'
  | 'xl:max-h-4.5'
  | 'sm:max-h-7.5'
  | 'md:max-h-7.5'
  | 'mg:max-h-7.5'
  | 'lg:max-h-7.5'
  | 'xl:max-h-7.5'
  | 'sm:max-h-9.5'
  | 'md:max-h-9.5'
  | 'mg:max-h-9.5'
  | 'lg:max-h-9.5'
  | 'xl:max-h-9.5'
  | 'sm:max-h-11.5'
  | 'md:max-h-11.5'
  | 'mg:max-h-11.5'
  | 'lg:max-h-11.5'
  | 'xl:max-h-11.5'
  | 'sm:max-w-0'
  | 'md:max-w-0'
  | 'mg:max-w-0'
  | 'lg:max-w-0'
  | 'xl:max-w-0'
  | 'sm:max-w-24'
  | 'md:max-w-24'
  | 'mg:max-w-24'
  | 'lg:max-w-24'
  | 'xl:max-w-24'
  | 'sm:max-w-72'
  | 'md:max-w-72'
  | 'mg:max-w-72'
  | 'lg:max-w-72'
  | 'xl:max-w-72'
  | 'sm:max-w-none'
  | 'md:max-w-none'
  | 'mg:max-w-none'
  | 'lg:max-w-none'
  | 'xl:max-w-none'
  | 'sm:max-w-xs'
  | 'md:max-w-xs'
  | 'mg:max-w-xs'
  | 'lg:max-w-xs'
  | 'xl:max-w-xs'
  | 'sm:max-w-sm'
  | 'md:max-w-sm'
  | 'mg:max-w-sm'
  | 'lg:max-w-sm'
  | 'xl:max-w-sm'
  | 'sm:max-w-md'
  | 'md:max-w-md'
  | 'mg:max-w-md'
  | 'lg:max-w-md'
  | 'xl:max-w-md'
  | 'sm:max-w-lg'
  | 'md:max-w-lg'
  | 'mg:max-w-lg'
  | 'lg:max-w-lg'
  | 'xl:max-w-lg'
  | 'sm:max-w-xl'
  | 'md:max-w-xl'
  | 'mg:max-w-xl'
  | 'lg:max-w-xl'
  | 'xl:max-w-xl'
  | 'sm:max-w-2xl'
  | 'md:max-w-2xl'
  | 'mg:max-w-2xl'
  | 'lg:max-w-2xl'
  | 'xl:max-w-2xl'
  | 'sm:max-w-3xl'
  | 'md:max-w-3xl'
  | 'mg:max-w-3xl'
  | 'lg:max-w-3xl'
  | 'xl:max-w-3xl'
  | 'sm:max-w-4xl'
  | 'md:max-w-4xl'
  | 'mg:max-w-4xl'
  | 'lg:max-w-4xl'
  | 'xl:max-w-4xl'
  | 'sm:max-w-5xl'
  | 'md:max-w-5xl'
  | 'mg:max-w-5xl'
  | 'lg:max-w-5xl'
  | 'xl:max-w-5xl'
  | 'sm:max-w-6xl'
  | 'md:max-w-6xl'
  | 'mg:max-w-6xl'
  | 'lg:max-w-6xl'
  | 'xl:max-w-6xl'
  | 'sm:max-w-7xl'
  | 'md:max-w-7xl'
  | 'mg:max-w-7xl'
  | 'lg:max-w-7xl'
  | 'xl:max-w-7xl'
  | 'sm:max-w-full'
  | 'md:max-w-full'
  | 'mg:max-w-full'
  | 'lg:max-w-full'
  | 'xl:max-w-full'
  | 'sm:max-w-min'
  | 'md:max-w-min'
  | 'mg:max-w-min'
  | 'lg:max-w-min'
  | 'xl:max-w-min'
  | 'sm:max-w-max'
  | 'md:max-w-max'
  | 'mg:max-w-max'
  | 'lg:max-w-max'
  | 'xl:max-w-max'
  | 'sm:max-w-prose'
  | 'md:max-w-prose'
  | 'mg:max-w-prose'
  | 'lg:max-w-prose'
  | 'xl:max-w-prose'
  | 'sm:max-w-screen-sm'
  | 'md:max-w-screen-sm'
  | 'mg:max-w-screen-sm'
  | 'lg:max-w-screen-sm'
  | 'xl:max-w-screen-sm'
  | 'sm:max-w-screen-md'
  | 'md:max-w-screen-md'
  | 'mg:max-w-screen-md'
  | 'lg:max-w-screen-md'
  | 'xl:max-w-screen-md'
  | 'sm:max-w-screen-mg'
  | 'md:max-w-screen-mg'
  | 'mg:max-w-screen-mg'
  | 'lg:max-w-screen-mg'
  | 'xl:max-w-screen-mg'
  | 'sm:max-w-screen-lg'
  | 'md:max-w-screen-lg'
  | 'mg:max-w-screen-lg'
  | 'lg:max-w-screen-lg'
  | 'xl:max-w-screen-lg'
  | 'sm:max-w-screen-xl'
  | 'md:max-w-screen-xl'
  | 'mg:max-w-screen-xl'
  | 'lg:max-w-screen-xl'
  | 'xl:max-w-screen-xl'
  | 'sm:max-w-sidebar'
  | 'md:max-w-sidebar'
  | 'mg:max-w-sidebar'
  | 'lg:max-w-sidebar'
  | 'xl:max-w-sidebar'
  | 'sm:max-w-xxs'
  | 'md:max-w-xxs'
  | 'mg:max-w-xxs'
  | 'lg:max-w-xxs'
  | 'xl:max-w-xxs'
  | 'sm:max-w-1/2'
  | 'md:max-w-1/2'
  | 'mg:max-w-1/2'
  | 'lg:max-w-1/2'
  | 'xl:max-w-1/2'
  | 'sm:max-w-1/4'
  | 'md:max-w-1/4'
  | 'mg:max-w-1/4'
  | 'lg:max-w-1/4'
  | 'xl:max-w-1/4'
  | 'sm:min-h-0'
  | 'md:min-h-0'
  | 'mg:min-h-0'
  | 'lg:min-h-0'
  | 'xl:min-h-0'
  | 'sm:min-h-11'
  | 'md:min-h-11'
  | 'mg:min-h-11'
  | 'lg:min-h-11'
  | 'xl:min-h-11'
  | 'sm:min-h-15'
  | 'md:min-h-15'
  | 'mg:min-h-15'
  | 'lg:min-h-15'
  | 'xl:min-h-15'
  | 'sm:min-h-full'
  | 'md:min-h-full'
  | 'mg:min-h-full'
  | 'lg:min-h-full'
  | 'xl:min-h-full'
  | 'sm:min-h-screen'
  | 'md:min-h-screen'
  | 'mg:min-h-screen'
  | 'lg:min-h-screen'
  | 'xl:min-h-screen'
  | 'sm:min-h-dynamic-screen'
  | 'md:min-h-dynamic-screen'
  | 'mg:min-h-dynamic-screen'
  | 'lg:min-h-dynamic-screen'
  | 'xl:min-h-dynamic-screen'
  | 'sm:min-h-tiny-swatch'
  | 'md:min-h-tiny-swatch'
  | 'mg:min-h-tiny-swatch'
  | 'lg:min-h-tiny-swatch'
  | 'xl:min-h-tiny-swatch'
  | 'sm:min-h-mini-swatch'
  | 'md:min-h-mini-swatch'
  | 'mg:min-h-mini-swatch'
  | 'lg:min-h-mini-swatch'
  | 'xl:min-h-mini-swatch'
  | 'sm:min-h-swatch'
  | 'md:min-h-swatch'
  | 'mg:min-h-swatch'
  | 'lg:min-h-swatch'
  | 'xl:min-h-swatch'
  | 'sm:min-w-0'
  | 'md:min-w-0'
  | 'mg:min-w-0'
  | 'lg:min-w-0'
  | 'xl:min-w-0'
  | 'sm:min-w-24'
  | 'md:min-w-24'
  | 'mg:min-w-24'
  | 'lg:min-w-24'
  | 'xl:min-w-24'
  | 'sm:min-w-72'
  | 'md:min-w-72'
  | 'mg:min-w-72'
  | 'lg:min-w-72'
  | 'xl:min-w-72'
  | 'sm:min-w-full'
  | 'md:min-w-full'
  | 'mg:min-w-full'
  | 'lg:min-w-full'
  | 'xl:min-w-full'
  | 'sm:min-w-min'
  | 'md:min-w-min'
  | 'mg:min-w-min'
  | 'lg:min-w-min'
  | 'xl:min-w-min'
  | 'sm:min-w-max'
  | 'md:min-w-max'
  | 'mg:min-w-max'
  | 'lg:min-w-max'
  | 'xl:min-w-max'
  | 'sm:min-w-sidebar'
  | 'md:min-w-sidebar'
  | 'mg:min-w-sidebar'
  | 'lg:min-w-sidebar'
  | 'xl:min-w-sidebar'
  | 'sm:min-w-xxs'
  | 'md:min-w-xxs'
  | 'mg:min-w-xxs'
  | 'lg:min-w-xxs'
  | 'xl:min-w-xxs'
  | 'sm:min-w-1/2'
  | 'md:min-w-1/2'
  | 'mg:min-w-1/2'
  | 'lg:min-w-1/2'
  | 'xl:min-w-1/2'
  | 'sm:min-w-1/4'
  | 'md:min-w-1/4'
  | 'mg:min-w-1/4'
  | 'lg:min-w-1/4'
  | 'xl:min-w-1/4'
  | 'sm:mix-blend-normal'
  | 'md:mix-blend-normal'
  | 'mg:mix-blend-normal'
  | 'lg:mix-blend-normal'
  | 'xl:mix-blend-normal'
  | 'sm:mix-blend-multiply'
  | 'md:mix-blend-multiply'
  | 'mg:mix-blend-multiply'
  | 'lg:mix-blend-multiply'
  | 'xl:mix-blend-multiply'
  | 'sm:mix-blend-screen'
  | 'md:mix-blend-screen'
  | 'mg:mix-blend-screen'
  | 'lg:mix-blend-screen'
  | 'xl:mix-blend-screen'
  | 'sm:mix-blend-overlay'
  | 'md:mix-blend-overlay'
  | 'mg:mix-blend-overlay'
  | 'lg:mix-blend-overlay'
  | 'xl:mix-blend-overlay'
  | 'sm:mix-blend-darken'
  | 'md:mix-blend-darken'
  | 'mg:mix-blend-darken'
  | 'lg:mix-blend-darken'
  | 'xl:mix-blend-darken'
  | 'sm:mix-blend-lighten'
  | 'md:mix-blend-lighten'
  | 'mg:mix-blend-lighten'
  | 'lg:mix-blend-lighten'
  | 'xl:mix-blend-lighten'
  | 'sm:mix-blend-color-dodge'
  | 'md:mix-blend-color-dodge'
  | 'mg:mix-blend-color-dodge'
  | 'lg:mix-blend-color-dodge'
  | 'xl:mix-blend-color-dodge'
  | 'sm:mix-blend-color-burn'
  | 'md:mix-blend-color-burn'
  | 'mg:mix-blend-color-burn'
  | 'lg:mix-blend-color-burn'
  | 'xl:mix-blend-color-burn'
  | 'sm:mix-blend-hard-light'
  | 'md:mix-blend-hard-light'
  | 'mg:mix-blend-hard-light'
  | 'lg:mix-blend-hard-light'
  | 'xl:mix-blend-hard-light'
  | 'sm:mix-blend-soft-light'
  | 'md:mix-blend-soft-light'
  | 'mg:mix-blend-soft-light'
  | 'lg:mix-blend-soft-light'
  | 'xl:mix-blend-soft-light'
  | 'sm:mix-blend-difference'
  | 'md:mix-blend-difference'
  | 'mg:mix-blend-difference'
  | 'lg:mix-blend-difference'
  | 'xl:mix-blend-difference'
  | 'sm:mix-blend-exclusion'
  | 'md:mix-blend-exclusion'
  | 'mg:mix-blend-exclusion'
  | 'lg:mix-blend-exclusion'
  | 'xl:mix-blend-exclusion'
  | 'sm:mix-blend-hue'
  | 'md:mix-blend-hue'
  | 'mg:mix-blend-hue'
  | 'lg:mix-blend-hue'
  | 'xl:mix-blend-hue'
  | 'sm:mix-blend-saturation'
  | 'md:mix-blend-saturation'
  | 'mg:mix-blend-saturation'
  | 'lg:mix-blend-saturation'
  | 'xl:mix-blend-saturation'
  | 'sm:mix-blend-color'
  | 'md:mix-blend-color'
  | 'mg:mix-blend-color'
  | 'lg:mix-blend-color'
  | 'xl:mix-blend-color'
  | 'sm:mix-blend-luminosity'
  | 'md:mix-blend-luminosity'
  | 'mg:mix-blend-luminosity'
  | 'lg:mix-blend-luminosity'
  | 'xl:mix-blend-luminosity'
  | 'sm:object-contain'
  | 'md:object-contain'
  | 'mg:object-contain'
  | 'lg:object-contain'
  | 'xl:object-contain'
  | 'sm:object-cover'
  | 'md:object-cover'
  | 'mg:object-cover'
  | 'lg:object-cover'
  | 'xl:object-cover'
  | 'sm:object-fill'
  | 'md:object-fill'
  | 'mg:object-fill'
  | 'lg:object-fill'
  | 'xl:object-fill'
  | 'sm:object-none'
  | 'md:object-none'
  | 'mg:object-none'
  | 'lg:object-none'
  | 'xl:object-none'
  | 'sm:object-scale-down'
  | 'md:object-scale-down'
  | 'mg:object-scale-down'
  | 'lg:object-scale-down'
  | 'xl:object-scale-down'
  | 'sm:object-bottom'
  | 'md:object-bottom'
  | 'mg:object-bottom'
  | 'lg:object-bottom'
  | 'xl:object-bottom'
  | 'sm:object-center'
  | 'md:object-center'
  | 'mg:object-center'
  | 'lg:object-center'
  | 'xl:object-center'
  | 'sm:object-left'
  | 'md:object-left'
  | 'mg:object-left'
  | 'lg:object-left'
  | 'xl:object-left'
  | 'sm:object-left-bottom'
  | 'md:object-left-bottom'
  | 'mg:object-left-bottom'
  | 'lg:object-left-bottom'
  | 'xl:object-left-bottom'
  | 'sm:object-left-top'
  | 'md:object-left-top'
  | 'mg:object-left-top'
  | 'lg:object-left-top'
  | 'xl:object-left-top'
  | 'sm:object-right'
  | 'md:object-right'
  | 'mg:object-right'
  | 'lg:object-right'
  | 'xl:object-right'
  | 'sm:object-right-bottom'
  | 'md:object-right-bottom'
  | 'mg:object-right-bottom'
  | 'lg:object-right-bottom'
  | 'xl:object-right-bottom'
  | 'sm:object-right-top'
  | 'md:object-right-top'
  | 'mg:object-right-top'
  | 'lg:object-right-top'
  | 'xl:object-right-top'
  | 'sm:object-top'
  | 'md:object-top'
  | 'mg:object-top'
  | 'lg:object-top'
  | 'xl:object-top'
  | 'sm:object-center-0'
  | 'md:object-center-0'
  | 'mg:object-center-0'
  | 'lg:object-center-0'
  | 'xl:object-center-0'
  | 'sm:object-center-20'
  | 'md:object-center-20'
  | 'mg:object-center-20'
  | 'lg:object-center-20'
  | 'xl:object-center-20'
  | 'sm:object-center-40'
  | 'md:object-center-40'
  | 'mg:object-center-40'
  | 'lg:object-center-40'
  | 'xl:object-center-40'
  | 'sm:object-center-50'
  | 'md:object-center-50'
  | 'mg:object-center-50'
  | 'lg:object-center-50'
  | 'xl:object-center-50'
  | 'sm:object-center-60'
  | 'md:object-center-60'
  | 'mg:object-center-60'
  | 'lg:object-center-60'
  | 'xl:object-center-60'
  | 'sm:object-center-80'
  | 'md:object-center-80'
  | 'mg:object-center-80'
  | 'lg:object-center-80'
  | 'xl:object-center-80'
  | 'sm:object-center-100'
  | 'md:object-center-100'
  | 'mg:object-center-100'
  | 'lg:object-center-100'
  | 'xl:object-center-100'
  | 'sm:object-center-top'
  | 'md:object-center-top'
  | 'mg:object-center-top'
  | 'lg:object-center-top'
  | 'xl:object-center-top'
  | 'sm:object-center-bottom'
  | 'md:object-center-bottom'
  | 'mg:object-center-bottom'
  | 'lg:object-center-bottom'
  | 'xl:object-center-bottom'
  | 'sm:opacity-0'
  | 'md:opacity-0'
  | 'mg:opacity-0'
  | 'lg:opacity-0'
  | 'xl:opacity-0'
  | 'group-hover:opacity-0'
  | 'focus-within:opacity-0'
  | 'hover:opacity-0'
  | 'focus:opacity-0'
  | 'sm:opacity-5'
  | 'md:opacity-5'
  | 'mg:opacity-5'
  | 'lg:opacity-5'
  | 'xl:opacity-5'
  | 'group-hover:opacity-5'
  | 'focus-within:opacity-5'
  | 'hover:opacity-5'
  | 'focus:opacity-5'
  | 'sm:opacity-10'
  | 'md:opacity-10'
  | 'mg:opacity-10'
  | 'lg:opacity-10'
  | 'xl:opacity-10'
  | 'group-hover:opacity-10'
  | 'focus-within:opacity-10'
  | 'hover:opacity-10'
  | 'focus:opacity-10'
  | 'sm:opacity-20'
  | 'md:opacity-20'
  | 'mg:opacity-20'
  | 'lg:opacity-20'
  | 'xl:opacity-20'
  | 'group-hover:opacity-20'
  | 'focus-within:opacity-20'
  | 'hover:opacity-20'
  | 'focus:opacity-20'
  | 'sm:opacity-25'
  | 'md:opacity-25'
  | 'mg:opacity-25'
  | 'lg:opacity-25'
  | 'xl:opacity-25'
  | 'group-hover:opacity-25'
  | 'focus-within:opacity-25'
  | 'hover:opacity-25'
  | 'focus:opacity-25'
  | 'sm:opacity-30'
  | 'md:opacity-30'
  | 'mg:opacity-30'
  | 'lg:opacity-30'
  | 'xl:opacity-30'
  | 'group-hover:opacity-30'
  | 'focus-within:opacity-30'
  | 'hover:opacity-30'
  | 'focus:opacity-30'
  | 'sm:opacity-40'
  | 'md:opacity-40'
  | 'mg:opacity-40'
  | 'lg:opacity-40'
  | 'xl:opacity-40'
  | 'group-hover:opacity-40'
  | 'focus-within:opacity-40'
  | 'hover:opacity-40'
  | 'focus:opacity-40'
  | 'sm:opacity-50'
  | 'md:opacity-50'
  | 'mg:opacity-50'
  | 'lg:opacity-50'
  | 'xl:opacity-50'
  | 'group-hover:opacity-50'
  | 'focus-within:opacity-50'
  | 'hover:opacity-50'
  | 'focus:opacity-50'
  | 'sm:opacity-60'
  | 'md:opacity-60'
  | 'mg:opacity-60'
  | 'lg:opacity-60'
  | 'xl:opacity-60'
  | 'group-hover:opacity-60'
  | 'focus-within:opacity-60'
  | 'hover:opacity-60'
  | 'focus:opacity-60'
  | 'sm:opacity-70'
  | 'md:opacity-70'
  | 'mg:opacity-70'
  | 'lg:opacity-70'
  | 'xl:opacity-70'
  | 'group-hover:opacity-70'
  | 'focus-within:opacity-70'
  | 'hover:opacity-70'
  | 'focus:opacity-70'
  | 'sm:opacity-75'
  | 'md:opacity-75'
  | 'mg:opacity-75'
  | 'lg:opacity-75'
  | 'xl:opacity-75'
  | 'group-hover:opacity-75'
  | 'focus-within:opacity-75'
  | 'hover:opacity-75'
  | 'focus:opacity-75'
  | 'sm:opacity-80'
  | 'md:opacity-80'
  | 'mg:opacity-80'
  | 'lg:opacity-80'
  | 'xl:opacity-80'
  | 'group-hover:opacity-80'
  | 'focus-within:opacity-80'
  | 'hover:opacity-80'
  | 'focus:opacity-80'
  | 'sm:opacity-90'
  | 'md:opacity-90'
  | 'mg:opacity-90'
  | 'lg:opacity-90'
  | 'xl:opacity-90'
  | 'group-hover:opacity-90'
  | 'focus-within:opacity-90'
  | 'hover:opacity-90'
  | 'focus:opacity-90'
  | 'sm:opacity-95'
  | 'md:opacity-95'
  | 'mg:opacity-95'
  | 'lg:opacity-95'
  | 'xl:opacity-95'
  | 'group-hover:opacity-95'
  | 'focus-within:opacity-95'
  | 'hover:opacity-95'
  | 'focus:opacity-95'
  | 'sm:opacity-100'
  | 'md:opacity-100'
  | 'mg:opacity-100'
  | 'lg:opacity-100'
  | 'xl:opacity-100'
  | 'group-hover:opacity-100'
  | 'focus-within:opacity-100'
  | 'hover:opacity-100'
  | 'focus:opacity-100'
  | 'sm:order-1'
  | 'md:order-1'
  | 'mg:order-1'
  | 'lg:order-1'
  | 'xl:order-1'
  | 'sm:order-2'
  | 'md:order-2'
  | 'mg:order-2'
  | 'lg:order-2'
  | 'xl:order-2'
  | 'sm:order-3'
  | 'md:order-3'
  | 'mg:order-3'
  | 'lg:order-3'
  | 'xl:order-3'
  | 'sm:order-4'
  | 'md:order-4'
  | 'mg:order-4'
  | 'lg:order-4'
  | 'xl:order-4'
  | 'sm:order-5'
  | 'md:order-5'
  | 'mg:order-5'
  | 'lg:order-5'
  | 'xl:order-5'
  | 'sm:order-6'
  | 'md:order-6'
  | 'mg:order-6'
  | 'lg:order-6'
  | 'xl:order-6'
  | 'sm:order-7'
  | 'md:order-7'
  | 'mg:order-7'
  | 'lg:order-7'
  | 'xl:order-7'
  | 'sm:order-8'
  | 'md:order-8'
  | 'mg:order-8'
  | 'lg:order-8'
  | 'xl:order-8'
  | 'sm:order-9'
  | 'md:order-9'
  | 'mg:order-9'
  | 'lg:order-9'
  | 'xl:order-9'
  | 'sm:order-10'
  | 'md:order-10'
  | 'mg:order-10'
  | 'lg:order-10'
  | 'xl:order-10'
  | 'sm:order-11'
  | 'md:order-11'
  | 'mg:order-11'
  | 'lg:order-11'
  | 'xl:order-11'
  | 'sm:order-12'
  | 'md:order-12'
  | 'mg:order-12'
  | 'lg:order-12'
  | 'xl:order-12'
  | 'sm:order-first'
  | 'md:order-first'
  | 'mg:order-first'
  | 'lg:order-first'
  | 'xl:order-first'
  | 'sm:order-last'
  | 'md:order-last'
  | 'mg:order-last'
  | 'lg:order-last'
  | 'xl:order-last'
  | 'sm:order-none'
  | 'md:order-none'
  | 'mg:order-none'
  | 'lg:order-none'
  | 'xl:order-none'
  | 'sm:outline-none'
  | 'md:outline-none'
  | 'mg:outline-none'
  | 'lg:outline-none'
  | 'xl:outline-none'
  | 'focus-within:outline-none'
  | 'focus:outline-none'
  | 'sm:outline-white'
  | 'md:outline-white'
  | 'mg:outline-white'
  | 'lg:outline-white'
  | 'xl:outline-white'
  | 'focus-within:outline-white'
  | 'focus:outline-white'
  | 'sm:outline-black'
  | 'md:outline-black'
  | 'mg:outline-black'
  | 'lg:outline-black'
  | 'xl:outline-black'
  | 'focus-within:outline-black'
  | 'focus:outline-black'
  | 'sm:overflow-auto'
  | 'md:overflow-auto'
  | 'mg:overflow-auto'
  | 'lg:overflow-auto'
  | 'xl:overflow-auto'
  | 'sm:overflow-hidden'
  | 'md:overflow-hidden'
  | 'mg:overflow-hidden'
  | 'lg:overflow-hidden'
  | 'xl:overflow-hidden'
  | 'sm:overflow-visible'
  | 'md:overflow-visible'
  | 'mg:overflow-visible'
  | 'lg:overflow-visible'
  | 'xl:overflow-visible'
  | 'sm:overflow-scroll'
  | 'md:overflow-scroll'
  | 'mg:overflow-scroll'
  | 'lg:overflow-scroll'
  | 'xl:overflow-scroll'
  | 'sm:overflow-x-auto'
  | 'md:overflow-x-auto'
  | 'mg:overflow-x-auto'
  | 'lg:overflow-x-auto'
  | 'xl:overflow-x-auto'
  | 'sm:overflow-y-auto'
  | 'md:overflow-y-auto'
  | 'mg:overflow-y-auto'
  | 'lg:overflow-y-auto'
  | 'xl:overflow-y-auto'
  | 'sm:overflow-x-hidden'
  | 'md:overflow-x-hidden'
  | 'mg:overflow-x-hidden'
  | 'lg:overflow-x-hidden'
  | 'xl:overflow-x-hidden'
  | 'sm:overflow-y-hidden'
  | 'md:overflow-y-hidden'
  | 'mg:overflow-y-hidden'
  | 'lg:overflow-y-hidden'
  | 'xl:overflow-y-hidden'
  | 'sm:overflow-x-visible'
  | 'md:overflow-x-visible'
  | 'mg:overflow-x-visible'
  | 'lg:overflow-x-visible'
  | 'xl:overflow-x-visible'
  | 'sm:overflow-y-visible'
  | 'md:overflow-y-visible'
  | 'mg:overflow-y-visible'
  | 'lg:overflow-y-visible'
  | 'xl:overflow-y-visible'
  | 'sm:overflow-x-scroll'
  | 'md:overflow-x-scroll'
  | 'mg:overflow-x-scroll'
  | 'lg:overflow-x-scroll'
  | 'xl:overflow-x-scroll'
  | 'sm:overflow-y-scroll'
  | 'md:overflow-y-scroll'
  | 'mg:overflow-y-scroll'
  | 'lg:overflow-y-scroll'
  | 'xl:overflow-y-scroll'
  | 'sm:overscroll-auto'
  | 'md:overscroll-auto'
  | 'mg:overscroll-auto'
  | 'lg:overscroll-auto'
  | 'xl:overscroll-auto'
  | 'sm:overscroll-contain'
  | 'md:overscroll-contain'
  | 'mg:overscroll-contain'
  | 'lg:overscroll-contain'
  | 'xl:overscroll-contain'
  | 'sm:overscroll-none'
  | 'md:overscroll-none'
  | 'mg:overscroll-none'
  | 'lg:overscroll-none'
  | 'xl:overscroll-none'
  | 'sm:overscroll-y-auto'
  | 'md:overscroll-y-auto'
  | 'mg:overscroll-y-auto'
  | 'lg:overscroll-y-auto'
  | 'xl:overscroll-y-auto'
  | 'sm:overscroll-y-contain'
  | 'md:overscroll-y-contain'
  | 'mg:overscroll-y-contain'
  | 'lg:overscroll-y-contain'
  | 'xl:overscroll-y-contain'
  | 'sm:overscroll-y-none'
  | 'md:overscroll-y-none'
  | 'mg:overscroll-y-none'
  | 'lg:overscroll-y-none'
  | 'xl:overscroll-y-none'
  | 'sm:overscroll-x-auto'
  | 'md:overscroll-x-auto'
  | 'mg:overscroll-x-auto'
  | 'lg:overscroll-x-auto'
  | 'xl:overscroll-x-auto'
  | 'sm:overscroll-x-contain'
  | 'md:overscroll-x-contain'
  | 'mg:overscroll-x-contain'
  | 'lg:overscroll-x-contain'
  | 'xl:overscroll-x-contain'
  | 'sm:overscroll-x-none'
  | 'md:overscroll-x-none'
  | 'mg:overscroll-x-none'
  | 'lg:overscroll-x-none'
  | 'xl:overscroll-x-none'
  | 'sm:p-0'
  | 'md:p-0'
  | 'mg:p-0'
  | 'lg:p-0'
  | 'xl:p-0'
  | 'sm:p-1'
  | 'md:p-1'
  | 'mg:p-1'
  | 'lg:p-1'
  | 'xl:p-1'
  | 'sm:p-2'
  | 'md:p-2'
  | 'mg:p-2'
  | 'lg:p-2'
  | 'xl:p-2'
  | 'sm:p-3'
  | 'md:p-3'
  | 'mg:p-3'
  | 'lg:p-3'
  | 'xl:p-3'
  | 'sm:p-4'
  | 'md:p-4'
  | 'mg:p-4'
  | 'lg:p-4'
  | 'xl:p-4'
  | 'sm:p-5'
  | 'md:p-5'
  | 'mg:p-5'
  | 'lg:p-5'
  | 'xl:p-5'
  | 'sm:p-6'
  | 'md:p-6'
  | 'mg:p-6'
  | 'lg:p-6'
  | 'xl:p-6'
  | 'sm:p-7'
  | 'md:p-7'
  | 'mg:p-7'
  | 'lg:p-7'
  | 'xl:p-7'
  | 'sm:p-8'
  | 'md:p-8'
  | 'mg:p-8'
  | 'lg:p-8'
  | 'xl:p-8'
  | 'sm:p-9'
  | 'md:p-9'
  | 'mg:p-9'
  | 'lg:p-9'
  | 'xl:p-9'
  | 'sm:p-10'
  | 'md:p-10'
  | 'mg:p-10'
  | 'lg:p-10'
  | 'xl:p-10'
  | 'sm:p-11'
  | 'md:p-11'
  | 'mg:p-11'
  | 'lg:p-11'
  | 'xl:p-11'
  | 'sm:p-12'
  | 'md:p-12'
  | 'mg:p-12'
  | 'lg:p-12'
  | 'xl:p-12'
  | 'sm:p-14'
  | 'md:p-14'
  | 'mg:p-14'
  | 'lg:p-14'
  | 'xl:p-14'
  | 'sm:p-15'
  | 'md:p-15'
  | 'mg:p-15'
  | 'lg:p-15'
  | 'xl:p-15'
  | 'sm:p-16'
  | 'md:p-16'
  | 'mg:p-16'
  | 'lg:p-16'
  | 'xl:p-16'
  | 'sm:p-17'
  | 'md:p-17'
  | 'mg:p-17'
  | 'lg:p-17'
  | 'xl:p-17'
  | 'sm:p-18'
  | 'md:p-18'
  | 'mg:p-18'
  | 'lg:p-18'
  | 'xl:p-18'
  | 'sm:p-20'
  | 'md:p-20'
  | 'mg:p-20'
  | 'lg:p-20'
  | 'xl:p-20'
  | 'sm:p-21'
  | 'md:p-21'
  | 'mg:p-21'
  | 'lg:p-21'
  | 'xl:p-21'
  | 'sm:p-22'
  | 'md:p-22'
  | 'mg:p-22'
  | 'lg:p-22'
  | 'xl:p-22'
  | 'sm:p-24'
  | 'md:p-24'
  | 'mg:p-24'
  | 'lg:p-24'
  | 'xl:p-24'
  | 'sm:p-28'
  | 'md:p-28'
  | 'mg:p-28'
  | 'lg:p-28'
  | 'xl:p-28'
  | 'sm:p-30'
  | 'md:p-30'
  | 'mg:p-30'
  | 'lg:p-30'
  | 'xl:p-30'
  | 'sm:p-32'
  | 'md:p-32'
  | 'mg:p-32'
  | 'lg:p-32'
  | 'xl:p-32'
  | 'sm:p-36'
  | 'md:p-36'
  | 'mg:p-36'
  | 'lg:p-36'
  | 'xl:p-36'
  | 'sm:p-40'
  | 'md:p-40'
  | 'mg:p-40'
  | 'lg:p-40'
  | 'xl:p-40'
  | 'sm:p-44'
  | 'md:p-44'
  | 'mg:p-44'
  | 'lg:p-44'
  | 'xl:p-44'
  | 'sm:p-48'
  | 'md:p-48'
  | 'mg:p-48'
  | 'lg:p-48'
  | 'xl:p-48'
  | 'sm:p-52'
  | 'md:p-52'
  | 'mg:p-52'
  | 'lg:p-52'
  | 'xl:p-52'
  | 'sm:p-56'
  | 'md:p-56'
  | 'mg:p-56'
  | 'lg:p-56'
  | 'xl:p-56'
  | 'sm:p-60'
  | 'md:p-60'
  | 'mg:p-60'
  | 'lg:p-60'
  | 'xl:p-60'
  | 'sm:p-64'
  | 'md:p-64'
  | 'mg:p-64'
  | 'lg:p-64'
  | 'xl:p-64'
  | 'sm:p-72'
  | 'md:p-72'
  | 'mg:p-72'
  | 'lg:p-72'
  | 'xl:p-72'
  | 'sm:p-80'
  | 'md:p-80'
  | 'mg:p-80'
  | 'lg:p-80'
  | 'xl:p-80'
  | 'sm:p-96'
  | 'md:p-96'
  | 'mg:p-96'
  | 'lg:p-96'
  | 'xl:p-96'
  | 'sm:p-px'
  | 'md:p-px'
  | 'mg:p-px'
  | 'lg:p-px'
  | 'xl:p-px'
  | 'sm:p-0.5'
  | 'md:p-0.5'
  | 'mg:p-0.5'
  | 'lg:p-0.5'
  | 'xl:p-0.5'
  | 'sm:p-1.5'
  | 'md:p-1.5'
  | 'mg:p-1.5'
  | 'lg:p-1.5'
  | 'xl:p-1.5'
  | 'sm:p-2.5'
  | 'md:p-2.5'
  | 'mg:p-2.5'
  | 'lg:p-2.5'
  | 'xl:p-2.5'
  | 'sm:p-3.5'
  | 'md:p-3.5'
  | 'mg:p-3.5'
  | 'lg:p-3.5'
  | 'xl:p-3.5'
  | 'sm:p-1/2'
  | 'md:p-1/2'
  | 'mg:p-1/2'
  | 'lg:p-1/2'
  | 'xl:p-1/2'
  | 'sm:p-full'
  | 'md:p-full'
  | 'mg:p-full'
  | 'lg:p-full'
  | 'xl:p-full'
  | 'sm:p-4.5'
  | 'md:p-4.5'
  | 'mg:p-4.5'
  | 'lg:p-4.5'
  | 'xl:p-4.5'
  | 'sm:p-7.5'
  | 'md:p-7.5'
  | 'mg:p-7.5'
  | 'lg:p-7.5'
  | 'xl:p-7.5'
  | 'sm:p-9.5'
  | 'md:p-9.5'
  | 'mg:p-9.5'
  | 'lg:p-9.5'
  | 'xl:p-9.5'
  | 'sm:p-11.5'
  | 'md:p-11.5'
  | 'mg:p-11.5'
  | 'lg:p-11.5'
  | 'xl:p-11.5'
  | 'sm:py-0'
  | 'md:py-0'
  | 'mg:py-0'
  | 'lg:py-0'
  | 'xl:py-0'
  | 'sm:py-1'
  | 'md:py-1'
  | 'mg:py-1'
  | 'lg:py-1'
  | 'xl:py-1'
  | 'sm:py-2'
  | 'md:py-2'
  | 'mg:py-2'
  | 'lg:py-2'
  | 'xl:py-2'
  | 'sm:py-3'
  | 'md:py-3'
  | 'mg:py-3'
  | 'lg:py-3'
  | 'xl:py-3'
  | 'sm:py-4'
  | 'md:py-4'
  | 'mg:py-4'
  | 'lg:py-4'
  | 'xl:py-4'
  | 'sm:py-5'
  | 'md:py-5'
  | 'mg:py-5'
  | 'lg:py-5'
  | 'xl:py-5'
  | 'sm:py-6'
  | 'md:py-6'
  | 'mg:py-6'
  | 'lg:py-6'
  | 'xl:py-6'
  | 'sm:py-7'
  | 'md:py-7'
  | 'mg:py-7'
  | 'lg:py-7'
  | 'xl:py-7'
  | 'sm:py-8'
  | 'md:py-8'
  | 'mg:py-8'
  | 'lg:py-8'
  | 'xl:py-8'
  | 'sm:py-9'
  | 'md:py-9'
  | 'mg:py-9'
  | 'lg:py-9'
  | 'xl:py-9'
  | 'sm:py-10'
  | 'md:py-10'
  | 'mg:py-10'
  | 'lg:py-10'
  | 'xl:py-10'
  | 'sm:py-11'
  | 'md:py-11'
  | 'mg:py-11'
  | 'lg:py-11'
  | 'xl:py-11'
  | 'sm:py-12'
  | 'md:py-12'
  | 'mg:py-12'
  | 'lg:py-12'
  | 'xl:py-12'
  | 'sm:py-14'
  | 'md:py-14'
  | 'mg:py-14'
  | 'lg:py-14'
  | 'xl:py-14'
  | 'sm:py-15'
  | 'md:py-15'
  | 'mg:py-15'
  | 'lg:py-15'
  | 'xl:py-15'
  | 'sm:py-16'
  | 'md:py-16'
  | 'mg:py-16'
  | 'lg:py-16'
  | 'xl:py-16'
  | 'sm:py-17'
  | 'md:py-17'
  | 'mg:py-17'
  | 'lg:py-17'
  | 'xl:py-17'
  | 'sm:py-18'
  | 'md:py-18'
  | 'mg:py-18'
  | 'lg:py-18'
  | 'xl:py-18'
  | 'sm:py-20'
  | 'md:py-20'
  | 'mg:py-20'
  | 'lg:py-20'
  | 'xl:py-20'
  | 'sm:py-21'
  | 'md:py-21'
  | 'mg:py-21'
  | 'lg:py-21'
  | 'xl:py-21'
  | 'sm:py-22'
  | 'md:py-22'
  | 'mg:py-22'
  | 'lg:py-22'
  | 'xl:py-22'
  | 'sm:py-24'
  | 'md:py-24'
  | 'mg:py-24'
  | 'lg:py-24'
  | 'xl:py-24'
  | 'sm:py-28'
  | 'md:py-28'
  | 'mg:py-28'
  | 'lg:py-28'
  | 'xl:py-28'
  | 'sm:py-30'
  | 'md:py-30'
  | 'mg:py-30'
  | 'lg:py-30'
  | 'xl:py-30'
  | 'sm:py-32'
  | 'md:py-32'
  | 'mg:py-32'
  | 'lg:py-32'
  | 'xl:py-32'
  | 'sm:py-36'
  | 'md:py-36'
  | 'mg:py-36'
  | 'lg:py-36'
  | 'xl:py-36'
  | 'sm:py-40'
  | 'md:py-40'
  | 'mg:py-40'
  | 'lg:py-40'
  | 'xl:py-40'
  | 'sm:py-44'
  | 'md:py-44'
  | 'mg:py-44'
  | 'lg:py-44'
  | 'xl:py-44'
  | 'sm:py-48'
  | 'md:py-48'
  | 'mg:py-48'
  | 'lg:py-48'
  | 'xl:py-48'
  | 'sm:py-52'
  | 'md:py-52'
  | 'mg:py-52'
  | 'lg:py-52'
  | 'xl:py-52'
  | 'sm:py-56'
  | 'md:py-56'
  | 'mg:py-56'
  | 'lg:py-56'
  | 'xl:py-56'
  | 'sm:py-60'
  | 'md:py-60'
  | 'mg:py-60'
  | 'lg:py-60'
  | 'xl:py-60'
  | 'sm:py-64'
  | 'md:py-64'
  | 'mg:py-64'
  | 'lg:py-64'
  | 'xl:py-64'
  | 'sm:py-72'
  | 'md:py-72'
  | 'mg:py-72'
  | 'lg:py-72'
  | 'xl:py-72'
  | 'sm:py-80'
  | 'md:py-80'
  | 'mg:py-80'
  | 'lg:py-80'
  | 'xl:py-80'
  | 'sm:py-96'
  | 'md:py-96'
  | 'mg:py-96'
  | 'lg:py-96'
  | 'xl:py-96'
  | 'sm:py-px'
  | 'md:py-px'
  | 'mg:py-px'
  | 'lg:py-px'
  | 'xl:py-px'
  | 'sm:py-0.5'
  | 'md:py-0.5'
  | 'mg:py-0.5'
  | 'lg:py-0.5'
  | 'xl:py-0.5'
  | 'sm:py-1.5'
  | 'md:py-1.5'
  | 'mg:py-1.5'
  | 'lg:py-1.5'
  | 'xl:py-1.5'
  | 'sm:py-2.5'
  | 'md:py-2.5'
  | 'mg:py-2.5'
  | 'lg:py-2.5'
  | 'xl:py-2.5'
  | 'sm:py-3.5'
  | 'md:py-3.5'
  | 'mg:py-3.5'
  | 'lg:py-3.5'
  | 'xl:py-3.5'
  | 'sm:py-1/2'
  | 'md:py-1/2'
  | 'mg:py-1/2'
  | 'lg:py-1/2'
  | 'xl:py-1/2'
  | 'sm:py-full'
  | 'md:py-full'
  | 'mg:py-full'
  | 'lg:py-full'
  | 'xl:py-full'
  | 'sm:py-4.5'
  | 'md:py-4.5'
  | 'mg:py-4.5'
  | 'lg:py-4.5'
  | 'xl:py-4.5'
  | 'sm:py-7.5'
  | 'md:py-7.5'
  | 'mg:py-7.5'
  | 'lg:py-7.5'
  | 'xl:py-7.5'
  | 'sm:py-9.5'
  | 'md:py-9.5'
  | 'mg:py-9.5'
  | 'lg:py-9.5'
  | 'xl:py-9.5'
  | 'sm:py-11.5'
  | 'md:py-11.5'
  | 'mg:py-11.5'
  | 'lg:py-11.5'
  | 'xl:py-11.5'
  | 'sm:px-0'
  | 'md:px-0'
  | 'mg:px-0'
  | 'lg:px-0'
  | 'xl:px-0'
  | 'sm:px-1'
  | 'md:px-1'
  | 'mg:px-1'
  | 'lg:px-1'
  | 'xl:px-1'
  | 'sm:px-2'
  | 'md:px-2'
  | 'mg:px-2'
  | 'lg:px-2'
  | 'xl:px-2'
  | 'sm:px-3'
  | 'md:px-3'
  | 'mg:px-3'
  | 'lg:px-3'
  | 'xl:px-3'
  | 'sm:px-4'
  | 'md:px-4'
  | 'mg:px-4'
  | 'lg:px-4'
  | 'xl:px-4'
  | 'sm:px-5'
  | 'md:px-5'
  | 'mg:px-5'
  | 'lg:px-5'
  | 'xl:px-5'
  | 'sm:px-6'
  | 'md:px-6'
  | 'mg:px-6'
  | 'lg:px-6'
  | 'xl:px-6'
  | 'sm:px-7'
  | 'md:px-7'
  | 'mg:px-7'
  | 'lg:px-7'
  | 'xl:px-7'
  | 'sm:px-8'
  | 'md:px-8'
  | 'mg:px-8'
  | 'lg:px-8'
  | 'xl:px-8'
  | 'sm:px-9'
  | 'md:px-9'
  | 'mg:px-9'
  | 'lg:px-9'
  | 'xl:px-9'
  | 'sm:px-10'
  | 'md:px-10'
  | 'mg:px-10'
  | 'lg:px-10'
  | 'xl:px-10'
  | 'sm:px-11'
  | 'md:px-11'
  | 'mg:px-11'
  | 'lg:px-11'
  | 'xl:px-11'
  | 'sm:px-12'
  | 'md:px-12'
  | 'mg:px-12'
  | 'lg:px-12'
  | 'xl:px-12'
  | 'sm:px-14'
  | 'md:px-14'
  | 'mg:px-14'
  | 'lg:px-14'
  | 'xl:px-14'
  | 'sm:px-15'
  | 'md:px-15'
  | 'mg:px-15'
  | 'lg:px-15'
  | 'xl:px-15'
  | 'sm:px-16'
  | 'md:px-16'
  | 'mg:px-16'
  | 'lg:px-16'
  | 'xl:px-16'
  | 'sm:px-17'
  | 'md:px-17'
  | 'mg:px-17'
  | 'lg:px-17'
  | 'xl:px-17'
  | 'sm:px-18'
  | 'md:px-18'
  | 'mg:px-18'
  | 'lg:px-18'
  | 'xl:px-18'
  | 'sm:px-20'
  | 'md:px-20'
  | 'mg:px-20'
  | 'lg:px-20'
  | 'xl:px-20'
  | 'sm:px-21'
  | 'md:px-21'
  | 'mg:px-21'
  | 'lg:px-21'
  | 'xl:px-21'
  | 'sm:px-22'
  | 'md:px-22'
  | 'mg:px-22'
  | 'lg:px-22'
  | 'xl:px-22'
  | 'sm:px-24'
  | 'md:px-24'
  | 'mg:px-24'
  | 'lg:px-24'
  | 'xl:px-24'
  | 'sm:px-28'
  | 'md:px-28'
  | 'mg:px-28'
  | 'lg:px-28'
  | 'xl:px-28'
  | 'sm:px-30'
  | 'md:px-30'
  | 'mg:px-30'
  | 'lg:px-30'
  | 'xl:px-30'
  | 'sm:px-32'
  | 'md:px-32'
  | 'mg:px-32'
  | 'lg:px-32'
  | 'xl:px-32'
  | 'sm:px-36'
  | 'md:px-36'
  | 'mg:px-36'
  | 'lg:px-36'
  | 'xl:px-36'
  | 'sm:px-40'
  | 'md:px-40'
  | 'mg:px-40'
  | 'lg:px-40'
  | 'xl:px-40'
  | 'sm:px-44'
  | 'md:px-44'
  | 'mg:px-44'
  | 'lg:px-44'
  | 'xl:px-44'
  | 'sm:px-48'
  | 'md:px-48'
  | 'mg:px-48'
  | 'lg:px-48'
  | 'xl:px-48'
  | 'sm:px-52'
  | 'md:px-52'
  | 'mg:px-52'
  | 'lg:px-52'
  | 'xl:px-52'
  | 'sm:px-56'
  | 'md:px-56'
  | 'mg:px-56'
  | 'lg:px-56'
  | 'xl:px-56'
  | 'sm:px-60'
  | 'md:px-60'
  | 'mg:px-60'
  | 'lg:px-60'
  | 'xl:px-60'
  | 'sm:px-64'
  | 'md:px-64'
  | 'mg:px-64'
  | 'lg:px-64'
  | 'xl:px-64'
  | 'sm:px-72'
  | 'md:px-72'
  | 'mg:px-72'
  | 'lg:px-72'
  | 'xl:px-72'
  | 'sm:px-80'
  | 'md:px-80'
  | 'mg:px-80'
  | 'lg:px-80'
  | 'xl:px-80'
  | 'sm:px-96'
  | 'md:px-96'
  | 'mg:px-96'
  | 'lg:px-96'
  | 'xl:px-96'
  | 'sm:px-px'
  | 'md:px-px'
  | 'mg:px-px'
  | 'lg:px-px'
  | 'xl:px-px'
  | 'sm:px-0.5'
  | 'md:px-0.5'
  | 'mg:px-0.5'
  | 'lg:px-0.5'
  | 'xl:px-0.5'
  | 'sm:px-1.5'
  | 'md:px-1.5'
  | 'mg:px-1.5'
  | 'lg:px-1.5'
  | 'xl:px-1.5'
  | 'sm:px-2.5'
  | 'md:px-2.5'
  | 'mg:px-2.5'
  | 'lg:px-2.5'
  | 'xl:px-2.5'
  | 'sm:px-3.5'
  | 'md:px-3.5'
  | 'mg:px-3.5'
  | 'lg:px-3.5'
  | 'xl:px-3.5'
  | 'sm:px-1/2'
  | 'md:px-1/2'
  | 'mg:px-1/2'
  | 'lg:px-1/2'
  | 'xl:px-1/2'
  | 'sm:px-full'
  | 'md:px-full'
  | 'mg:px-full'
  | 'lg:px-full'
  | 'xl:px-full'
  | 'sm:px-4.5'
  | 'md:px-4.5'
  | 'mg:px-4.5'
  | 'lg:px-4.5'
  | 'xl:px-4.5'
  | 'sm:px-7.5'
  | 'md:px-7.5'
  | 'mg:px-7.5'
  | 'lg:px-7.5'
  | 'xl:px-7.5'
  | 'sm:px-9.5'
  | 'md:px-9.5'
  | 'mg:px-9.5'
  | 'lg:px-9.5'
  | 'xl:px-9.5'
  | 'sm:px-11.5'
  | 'md:px-11.5'
  | 'mg:px-11.5'
  | 'lg:px-11.5'
  | 'xl:px-11.5'
  | 'sm:pt-0'
  | 'md:pt-0'
  | 'mg:pt-0'
  | 'lg:pt-0'
  | 'xl:pt-0'
  | 'sm:pt-1'
  | 'md:pt-1'
  | 'mg:pt-1'
  | 'lg:pt-1'
  | 'xl:pt-1'
  | 'sm:pt-2'
  | 'md:pt-2'
  | 'mg:pt-2'
  | 'lg:pt-2'
  | 'xl:pt-2'
  | 'sm:pt-3'
  | 'md:pt-3'
  | 'mg:pt-3'
  | 'lg:pt-3'
  | 'xl:pt-3'
  | 'sm:pt-4'
  | 'md:pt-4'
  | 'mg:pt-4'
  | 'lg:pt-4'
  | 'xl:pt-4'
  | 'sm:pt-5'
  | 'md:pt-5'
  | 'mg:pt-5'
  | 'lg:pt-5'
  | 'xl:pt-5'
  | 'sm:pt-6'
  | 'md:pt-6'
  | 'mg:pt-6'
  | 'lg:pt-6'
  | 'xl:pt-6'
  | 'sm:pt-7'
  | 'md:pt-7'
  | 'mg:pt-7'
  | 'lg:pt-7'
  | 'xl:pt-7'
  | 'sm:pt-8'
  | 'md:pt-8'
  | 'mg:pt-8'
  | 'lg:pt-8'
  | 'xl:pt-8'
  | 'sm:pt-9'
  | 'md:pt-9'
  | 'mg:pt-9'
  | 'lg:pt-9'
  | 'xl:pt-9'
  | 'sm:pt-10'
  | 'md:pt-10'
  | 'mg:pt-10'
  | 'lg:pt-10'
  | 'xl:pt-10'
  | 'sm:pt-11'
  | 'md:pt-11'
  | 'mg:pt-11'
  | 'lg:pt-11'
  | 'xl:pt-11'
  | 'sm:pt-12'
  | 'md:pt-12'
  | 'mg:pt-12'
  | 'lg:pt-12'
  | 'xl:pt-12'
  | 'sm:pt-14'
  | 'md:pt-14'
  | 'mg:pt-14'
  | 'lg:pt-14'
  | 'xl:pt-14'
  | 'sm:pt-15'
  | 'md:pt-15'
  | 'mg:pt-15'
  | 'lg:pt-15'
  | 'xl:pt-15'
  | 'sm:pt-16'
  | 'md:pt-16'
  | 'mg:pt-16'
  | 'lg:pt-16'
  | 'xl:pt-16'
  | 'sm:pt-17'
  | 'md:pt-17'
  | 'mg:pt-17'
  | 'lg:pt-17'
  | 'xl:pt-17'
  | 'sm:pt-18'
  | 'md:pt-18'
  | 'mg:pt-18'
  | 'lg:pt-18'
  | 'xl:pt-18'
  | 'sm:pt-20'
  | 'md:pt-20'
  | 'mg:pt-20'
  | 'lg:pt-20'
  | 'xl:pt-20'
  | 'sm:pt-21'
  | 'md:pt-21'
  | 'mg:pt-21'
  | 'lg:pt-21'
  | 'xl:pt-21'
  | 'sm:pt-22'
  | 'md:pt-22'
  | 'mg:pt-22'
  | 'lg:pt-22'
  | 'xl:pt-22'
  | 'sm:pt-24'
  | 'md:pt-24'
  | 'mg:pt-24'
  | 'lg:pt-24'
  | 'xl:pt-24'
  | 'sm:pt-28'
  | 'md:pt-28'
  | 'mg:pt-28'
  | 'lg:pt-28'
  | 'xl:pt-28'
  | 'sm:pt-30'
  | 'md:pt-30'
  | 'mg:pt-30'
  | 'lg:pt-30'
  | 'xl:pt-30'
  | 'sm:pt-32'
  | 'md:pt-32'
  | 'mg:pt-32'
  | 'lg:pt-32'
  | 'xl:pt-32'
  | 'sm:pt-36'
  | 'md:pt-36'
  | 'mg:pt-36'
  | 'lg:pt-36'
  | 'xl:pt-36'
  | 'sm:pt-40'
  | 'md:pt-40'
  | 'mg:pt-40'
  | 'lg:pt-40'
  | 'xl:pt-40'
  | 'sm:pt-44'
  | 'md:pt-44'
  | 'mg:pt-44'
  | 'lg:pt-44'
  | 'xl:pt-44'
  | 'sm:pt-48'
  | 'md:pt-48'
  | 'mg:pt-48'
  | 'lg:pt-48'
  | 'xl:pt-48'
  | 'sm:pt-52'
  | 'md:pt-52'
  | 'mg:pt-52'
  | 'lg:pt-52'
  | 'xl:pt-52'
  | 'sm:pt-56'
  | 'md:pt-56'
  | 'mg:pt-56'
  | 'lg:pt-56'
  | 'xl:pt-56'
  | 'sm:pt-60'
  | 'md:pt-60'
  | 'mg:pt-60'
  | 'lg:pt-60'
  | 'xl:pt-60'
  | 'sm:pt-64'
  | 'md:pt-64'
  | 'mg:pt-64'
  | 'lg:pt-64'
  | 'xl:pt-64'
  | 'sm:pt-72'
  | 'md:pt-72'
  | 'mg:pt-72'
  | 'lg:pt-72'
  | 'xl:pt-72'
  | 'sm:pt-80'
  | 'md:pt-80'
  | 'mg:pt-80'
  | 'lg:pt-80'
  | 'xl:pt-80'
  | 'sm:pt-96'
  | 'md:pt-96'
  | 'mg:pt-96'
  | 'lg:pt-96'
  | 'xl:pt-96'
  | 'sm:pt-px'
  | 'md:pt-px'
  | 'mg:pt-px'
  | 'lg:pt-px'
  | 'xl:pt-px'
  | 'sm:pt-0.5'
  | 'md:pt-0.5'
  | 'mg:pt-0.5'
  | 'lg:pt-0.5'
  | 'xl:pt-0.5'
  | 'sm:pt-1.5'
  | 'md:pt-1.5'
  | 'mg:pt-1.5'
  | 'lg:pt-1.5'
  | 'xl:pt-1.5'
  | 'sm:pt-2.5'
  | 'md:pt-2.5'
  | 'mg:pt-2.5'
  | 'lg:pt-2.5'
  | 'xl:pt-2.5'
  | 'sm:pt-3.5'
  | 'md:pt-3.5'
  | 'mg:pt-3.5'
  | 'lg:pt-3.5'
  | 'xl:pt-3.5'
  | 'sm:pt-1/2'
  | 'md:pt-1/2'
  | 'mg:pt-1/2'
  | 'lg:pt-1/2'
  | 'xl:pt-1/2'
  | 'sm:pt-full'
  | 'md:pt-full'
  | 'mg:pt-full'
  | 'lg:pt-full'
  | 'xl:pt-full'
  | 'sm:pt-4.5'
  | 'md:pt-4.5'
  | 'mg:pt-4.5'
  | 'lg:pt-4.5'
  | 'xl:pt-4.5'
  | 'sm:pt-7.5'
  | 'md:pt-7.5'
  | 'mg:pt-7.5'
  | 'lg:pt-7.5'
  | 'xl:pt-7.5'
  | 'sm:pt-9.5'
  | 'md:pt-9.5'
  | 'mg:pt-9.5'
  | 'lg:pt-9.5'
  | 'xl:pt-9.5'
  | 'sm:pt-11.5'
  | 'md:pt-11.5'
  | 'mg:pt-11.5'
  | 'lg:pt-11.5'
  | 'xl:pt-11.5'
  | 'sm:pr-0'
  | 'md:pr-0'
  | 'mg:pr-0'
  | 'lg:pr-0'
  | 'xl:pr-0'
  | 'sm:pr-1'
  | 'md:pr-1'
  | 'mg:pr-1'
  | 'lg:pr-1'
  | 'xl:pr-1'
  | 'sm:pr-2'
  | 'md:pr-2'
  | 'mg:pr-2'
  | 'lg:pr-2'
  | 'xl:pr-2'
  | 'sm:pr-3'
  | 'md:pr-3'
  | 'mg:pr-3'
  | 'lg:pr-3'
  | 'xl:pr-3'
  | 'sm:pr-4'
  | 'md:pr-4'
  | 'mg:pr-4'
  | 'lg:pr-4'
  | 'xl:pr-4'
  | 'sm:pr-5'
  | 'md:pr-5'
  | 'mg:pr-5'
  | 'lg:pr-5'
  | 'xl:pr-5'
  | 'sm:pr-6'
  | 'md:pr-6'
  | 'mg:pr-6'
  | 'lg:pr-6'
  | 'xl:pr-6'
  | 'sm:pr-7'
  | 'md:pr-7'
  | 'mg:pr-7'
  | 'lg:pr-7'
  | 'xl:pr-7'
  | 'sm:pr-8'
  | 'md:pr-8'
  | 'mg:pr-8'
  | 'lg:pr-8'
  | 'xl:pr-8'
  | 'sm:pr-9'
  | 'md:pr-9'
  | 'mg:pr-9'
  | 'lg:pr-9'
  | 'xl:pr-9'
  | 'sm:pr-10'
  | 'md:pr-10'
  | 'mg:pr-10'
  | 'lg:pr-10'
  | 'xl:pr-10'
  | 'sm:pr-11'
  | 'md:pr-11'
  | 'mg:pr-11'
  | 'lg:pr-11'
  | 'xl:pr-11'
  | 'sm:pr-12'
  | 'md:pr-12'
  | 'mg:pr-12'
  | 'lg:pr-12'
  | 'xl:pr-12'
  | 'sm:pr-14'
  | 'md:pr-14'
  | 'mg:pr-14'
  | 'lg:pr-14'
  | 'xl:pr-14'
  | 'sm:pr-15'
  | 'md:pr-15'
  | 'mg:pr-15'
  | 'lg:pr-15'
  | 'xl:pr-15'
  | 'sm:pr-16'
  | 'md:pr-16'
  | 'mg:pr-16'
  | 'lg:pr-16'
  | 'xl:pr-16'
  | 'sm:pr-17'
  | 'md:pr-17'
  | 'mg:pr-17'
  | 'lg:pr-17'
  | 'xl:pr-17'
  | 'sm:pr-18'
  | 'md:pr-18'
  | 'mg:pr-18'
  | 'lg:pr-18'
  | 'xl:pr-18'
  | 'sm:pr-20'
  | 'md:pr-20'
  | 'mg:pr-20'
  | 'lg:pr-20'
  | 'xl:pr-20'
  | 'sm:pr-21'
  | 'md:pr-21'
  | 'mg:pr-21'
  | 'lg:pr-21'
  | 'xl:pr-21'
  | 'sm:pr-22'
  | 'md:pr-22'
  | 'mg:pr-22'
  | 'lg:pr-22'
  | 'xl:pr-22'
  | 'sm:pr-24'
  | 'md:pr-24'
  | 'mg:pr-24'
  | 'lg:pr-24'
  | 'xl:pr-24'
  | 'sm:pr-28'
  | 'md:pr-28'
  | 'mg:pr-28'
  | 'lg:pr-28'
  | 'xl:pr-28'
  | 'sm:pr-30'
  | 'md:pr-30'
  | 'mg:pr-30'
  | 'lg:pr-30'
  | 'xl:pr-30'
  | 'sm:pr-32'
  | 'md:pr-32'
  | 'mg:pr-32'
  | 'lg:pr-32'
  | 'xl:pr-32'
  | 'sm:pr-36'
  | 'md:pr-36'
  | 'mg:pr-36'
  | 'lg:pr-36'
  | 'xl:pr-36'
  | 'sm:pr-40'
  | 'md:pr-40'
  | 'mg:pr-40'
  | 'lg:pr-40'
  | 'xl:pr-40'
  | 'sm:pr-44'
  | 'md:pr-44'
  | 'mg:pr-44'
  | 'lg:pr-44'
  | 'xl:pr-44'
  | 'sm:pr-48'
  | 'md:pr-48'
  | 'mg:pr-48'
  | 'lg:pr-48'
  | 'xl:pr-48'
  | 'sm:pr-52'
  | 'md:pr-52'
  | 'mg:pr-52'
  | 'lg:pr-52'
  | 'xl:pr-52'
  | 'sm:pr-56'
  | 'md:pr-56'
  | 'mg:pr-56'
  | 'lg:pr-56'
  | 'xl:pr-56'
  | 'sm:pr-60'
  | 'md:pr-60'
  | 'mg:pr-60'
  | 'lg:pr-60'
  | 'xl:pr-60'
  | 'sm:pr-64'
  | 'md:pr-64'
  | 'mg:pr-64'
  | 'lg:pr-64'
  | 'xl:pr-64'
  | 'sm:pr-72'
  | 'md:pr-72'
  | 'mg:pr-72'
  | 'lg:pr-72'
  | 'xl:pr-72'
  | 'sm:pr-80'
  | 'md:pr-80'
  | 'mg:pr-80'
  | 'lg:pr-80'
  | 'xl:pr-80'
  | 'sm:pr-96'
  | 'md:pr-96'
  | 'mg:pr-96'
  | 'lg:pr-96'
  | 'xl:pr-96'
  | 'sm:pr-px'
  | 'md:pr-px'
  | 'mg:pr-px'
  | 'lg:pr-px'
  | 'xl:pr-px'
  | 'sm:pr-0.5'
  | 'md:pr-0.5'
  | 'mg:pr-0.5'
  | 'lg:pr-0.5'
  | 'xl:pr-0.5'
  | 'sm:pr-1.5'
  | 'md:pr-1.5'
  | 'mg:pr-1.5'
  | 'lg:pr-1.5'
  | 'xl:pr-1.5'
  | 'sm:pr-2.5'
  | 'md:pr-2.5'
  | 'mg:pr-2.5'
  | 'lg:pr-2.5'
  | 'xl:pr-2.5'
  | 'sm:pr-3.5'
  | 'md:pr-3.5'
  | 'mg:pr-3.5'
  | 'lg:pr-3.5'
  | 'xl:pr-3.5'
  | 'sm:pr-1/2'
  | 'md:pr-1/2'
  | 'mg:pr-1/2'
  | 'lg:pr-1/2'
  | 'xl:pr-1/2'
  | 'sm:pr-full'
  | 'md:pr-full'
  | 'mg:pr-full'
  | 'lg:pr-full'
  | 'xl:pr-full'
  | 'sm:pr-4.5'
  | 'md:pr-4.5'
  | 'mg:pr-4.5'
  | 'lg:pr-4.5'
  | 'xl:pr-4.5'
  | 'sm:pr-7.5'
  | 'md:pr-7.5'
  | 'mg:pr-7.5'
  | 'lg:pr-7.5'
  | 'xl:pr-7.5'
  | 'sm:pr-9.5'
  | 'md:pr-9.5'
  | 'mg:pr-9.5'
  | 'lg:pr-9.5'
  | 'xl:pr-9.5'
  | 'sm:pr-11.5'
  | 'md:pr-11.5'
  | 'mg:pr-11.5'
  | 'lg:pr-11.5'
  | 'xl:pr-11.5'
  | 'sm:pb-0'
  | 'md:pb-0'
  | 'mg:pb-0'
  | 'lg:pb-0'
  | 'xl:pb-0'
  | 'sm:pb-1'
  | 'md:pb-1'
  | 'mg:pb-1'
  | 'lg:pb-1'
  | 'xl:pb-1'
  | 'sm:pb-2'
  | 'md:pb-2'
  | 'mg:pb-2'
  | 'lg:pb-2'
  | 'xl:pb-2'
  | 'sm:pb-3'
  | 'md:pb-3'
  | 'mg:pb-3'
  | 'lg:pb-3'
  | 'xl:pb-3'
  | 'sm:pb-4'
  | 'md:pb-4'
  | 'mg:pb-4'
  | 'lg:pb-4'
  | 'xl:pb-4'
  | 'sm:pb-5'
  | 'md:pb-5'
  | 'mg:pb-5'
  | 'lg:pb-5'
  | 'xl:pb-5'
  | 'sm:pb-6'
  | 'md:pb-6'
  | 'mg:pb-6'
  | 'lg:pb-6'
  | 'xl:pb-6'
  | 'sm:pb-7'
  | 'md:pb-7'
  | 'mg:pb-7'
  | 'lg:pb-7'
  | 'xl:pb-7'
  | 'sm:pb-8'
  | 'md:pb-8'
  | 'mg:pb-8'
  | 'lg:pb-8'
  | 'xl:pb-8'
  | 'sm:pb-9'
  | 'md:pb-9'
  | 'mg:pb-9'
  | 'lg:pb-9'
  | 'xl:pb-9'
  | 'sm:pb-10'
  | 'md:pb-10'
  | 'mg:pb-10'
  | 'lg:pb-10'
  | 'xl:pb-10'
  | 'sm:pb-11'
  | 'md:pb-11'
  | 'mg:pb-11'
  | 'lg:pb-11'
  | 'xl:pb-11'
  | 'sm:pb-12'
  | 'md:pb-12'
  | 'mg:pb-12'
  | 'lg:pb-12'
  | 'xl:pb-12'
  | 'sm:pb-14'
  | 'md:pb-14'
  | 'mg:pb-14'
  | 'lg:pb-14'
  | 'xl:pb-14'
  | 'sm:pb-15'
  | 'md:pb-15'
  | 'mg:pb-15'
  | 'lg:pb-15'
  | 'xl:pb-15'
  | 'sm:pb-16'
  | 'md:pb-16'
  | 'mg:pb-16'
  | 'lg:pb-16'
  | 'xl:pb-16'
  | 'sm:pb-17'
  | 'md:pb-17'
  | 'mg:pb-17'
  | 'lg:pb-17'
  | 'xl:pb-17'
  | 'sm:pb-18'
  | 'md:pb-18'
  | 'mg:pb-18'
  | 'lg:pb-18'
  | 'xl:pb-18'
  | 'sm:pb-20'
  | 'md:pb-20'
  | 'mg:pb-20'
  | 'lg:pb-20'
  | 'xl:pb-20'
  | 'sm:pb-21'
  | 'md:pb-21'
  | 'mg:pb-21'
  | 'lg:pb-21'
  | 'xl:pb-21'
  | 'sm:pb-22'
  | 'md:pb-22'
  | 'mg:pb-22'
  | 'lg:pb-22'
  | 'xl:pb-22'
  | 'sm:pb-24'
  | 'md:pb-24'
  | 'mg:pb-24'
  | 'lg:pb-24'
  | 'xl:pb-24'
  | 'sm:pb-28'
  | 'md:pb-28'
  | 'mg:pb-28'
  | 'lg:pb-28'
  | 'xl:pb-28'
  | 'sm:pb-30'
  | 'md:pb-30'
  | 'mg:pb-30'
  | 'lg:pb-30'
  | 'xl:pb-30'
  | 'sm:pb-32'
  | 'md:pb-32'
  | 'mg:pb-32'
  | 'lg:pb-32'
  | 'xl:pb-32'
  | 'sm:pb-36'
  | 'md:pb-36'
  | 'mg:pb-36'
  | 'lg:pb-36'
  | 'xl:pb-36'
  | 'sm:pb-40'
  | 'md:pb-40'
  | 'mg:pb-40'
  | 'lg:pb-40'
  | 'xl:pb-40'
  | 'sm:pb-44'
  | 'md:pb-44'
  | 'mg:pb-44'
  | 'lg:pb-44'
  | 'xl:pb-44'
  | 'sm:pb-48'
  | 'md:pb-48'
  | 'mg:pb-48'
  | 'lg:pb-48'
  | 'xl:pb-48'
  | 'sm:pb-52'
  | 'md:pb-52'
  | 'mg:pb-52'
  | 'lg:pb-52'
  | 'xl:pb-52'
  | 'sm:pb-56'
  | 'md:pb-56'
  | 'mg:pb-56'
  | 'lg:pb-56'
  | 'xl:pb-56'
  | 'sm:pb-60'
  | 'md:pb-60'
  | 'mg:pb-60'
  | 'lg:pb-60'
  | 'xl:pb-60'
  | 'sm:pb-64'
  | 'md:pb-64'
  | 'mg:pb-64'
  | 'lg:pb-64'
  | 'xl:pb-64'
  | 'sm:pb-72'
  | 'md:pb-72'
  | 'mg:pb-72'
  | 'lg:pb-72'
  | 'xl:pb-72'
  | 'sm:pb-80'
  | 'md:pb-80'
  | 'mg:pb-80'
  | 'lg:pb-80'
  | 'xl:pb-80'
  | 'sm:pb-96'
  | 'md:pb-96'
  | 'mg:pb-96'
  | 'lg:pb-96'
  | 'xl:pb-96'
  | 'sm:pb-px'
  | 'md:pb-px'
  | 'mg:pb-px'
  | 'lg:pb-px'
  | 'xl:pb-px'
  | 'sm:pb-0.5'
  | 'md:pb-0.5'
  | 'mg:pb-0.5'
  | 'lg:pb-0.5'
  | 'xl:pb-0.5'
  | 'sm:pb-1.5'
  | 'md:pb-1.5'
  | 'mg:pb-1.5'
  | 'lg:pb-1.5'
  | 'xl:pb-1.5'
  | 'sm:pb-2.5'
  | 'md:pb-2.5'
  | 'mg:pb-2.5'
  | 'lg:pb-2.5'
  | 'xl:pb-2.5'
  | 'sm:pb-3.5'
  | 'md:pb-3.5'
  | 'mg:pb-3.5'
  | 'lg:pb-3.5'
  | 'xl:pb-3.5'
  | 'sm:pb-1/2'
  | 'md:pb-1/2'
  | 'mg:pb-1/2'
  | 'lg:pb-1/2'
  | 'xl:pb-1/2'
  | 'sm:pb-full'
  | 'md:pb-full'
  | 'mg:pb-full'
  | 'lg:pb-full'
  | 'xl:pb-full'
  | 'sm:pb-4.5'
  | 'md:pb-4.5'
  | 'mg:pb-4.5'
  | 'lg:pb-4.5'
  | 'xl:pb-4.5'
  | 'sm:pb-7.5'
  | 'md:pb-7.5'
  | 'mg:pb-7.5'
  | 'lg:pb-7.5'
  | 'xl:pb-7.5'
  | 'sm:pb-9.5'
  | 'md:pb-9.5'
  | 'mg:pb-9.5'
  | 'lg:pb-9.5'
  | 'xl:pb-9.5'
  | 'sm:pb-11.5'
  | 'md:pb-11.5'
  | 'mg:pb-11.5'
  | 'lg:pb-11.5'
  | 'xl:pb-11.5'
  | 'sm:pl-0'
  | 'md:pl-0'
  | 'mg:pl-0'
  | 'lg:pl-0'
  | 'xl:pl-0'
  | 'sm:pl-1'
  | 'md:pl-1'
  | 'mg:pl-1'
  | 'lg:pl-1'
  | 'xl:pl-1'
  | 'sm:pl-2'
  | 'md:pl-2'
  | 'mg:pl-2'
  | 'lg:pl-2'
  | 'xl:pl-2'
  | 'sm:pl-3'
  | 'md:pl-3'
  | 'mg:pl-3'
  | 'lg:pl-3'
  | 'xl:pl-3'
  | 'sm:pl-4'
  | 'md:pl-4'
  | 'mg:pl-4'
  | 'lg:pl-4'
  | 'xl:pl-4'
  | 'sm:pl-5'
  | 'md:pl-5'
  | 'mg:pl-5'
  | 'lg:pl-5'
  | 'xl:pl-5'
  | 'sm:pl-6'
  | 'md:pl-6'
  | 'mg:pl-6'
  | 'lg:pl-6'
  | 'xl:pl-6'
  | 'sm:pl-7'
  | 'md:pl-7'
  | 'mg:pl-7'
  | 'lg:pl-7'
  | 'xl:pl-7'
  | 'sm:pl-8'
  | 'md:pl-8'
  | 'mg:pl-8'
  | 'lg:pl-8'
  | 'xl:pl-8'
  | 'sm:pl-9'
  | 'md:pl-9'
  | 'mg:pl-9'
  | 'lg:pl-9'
  | 'xl:pl-9'
  | 'sm:pl-10'
  | 'md:pl-10'
  | 'mg:pl-10'
  | 'lg:pl-10'
  | 'xl:pl-10'
  | 'sm:pl-11'
  | 'md:pl-11'
  | 'mg:pl-11'
  | 'lg:pl-11'
  | 'xl:pl-11'
  | 'sm:pl-12'
  | 'md:pl-12'
  | 'mg:pl-12'
  | 'lg:pl-12'
  | 'xl:pl-12'
  | 'sm:pl-14'
  | 'md:pl-14'
  | 'mg:pl-14'
  | 'lg:pl-14'
  | 'xl:pl-14'
  | 'sm:pl-15'
  | 'md:pl-15'
  | 'mg:pl-15'
  | 'lg:pl-15'
  | 'xl:pl-15'
  | 'sm:pl-16'
  | 'md:pl-16'
  | 'mg:pl-16'
  | 'lg:pl-16'
  | 'xl:pl-16'
  | 'sm:pl-17'
  | 'md:pl-17'
  | 'mg:pl-17'
  | 'lg:pl-17'
  | 'xl:pl-17'
  | 'sm:pl-18'
  | 'md:pl-18'
  | 'mg:pl-18'
  | 'lg:pl-18'
  | 'xl:pl-18'
  | 'sm:pl-20'
  | 'md:pl-20'
  | 'mg:pl-20'
  | 'lg:pl-20'
  | 'xl:pl-20'
  | 'sm:pl-21'
  | 'md:pl-21'
  | 'mg:pl-21'
  | 'lg:pl-21'
  | 'xl:pl-21'
  | 'sm:pl-22'
  | 'md:pl-22'
  | 'mg:pl-22'
  | 'lg:pl-22'
  | 'xl:pl-22'
  | 'sm:pl-24'
  | 'md:pl-24'
  | 'mg:pl-24'
  | 'lg:pl-24'
  | 'xl:pl-24'
  | 'sm:pl-28'
  | 'md:pl-28'
  | 'mg:pl-28'
  | 'lg:pl-28'
  | 'xl:pl-28'
  | 'sm:pl-30'
  | 'md:pl-30'
  | 'mg:pl-30'
  | 'lg:pl-30'
  | 'xl:pl-30'
  | 'sm:pl-32'
  | 'md:pl-32'
  | 'mg:pl-32'
  | 'lg:pl-32'
  | 'xl:pl-32'
  | 'sm:pl-36'
  | 'md:pl-36'
  | 'mg:pl-36'
  | 'lg:pl-36'
  | 'xl:pl-36'
  | 'sm:pl-40'
  | 'md:pl-40'
  | 'mg:pl-40'
  | 'lg:pl-40'
  | 'xl:pl-40'
  | 'sm:pl-44'
  | 'md:pl-44'
  | 'mg:pl-44'
  | 'lg:pl-44'
  | 'xl:pl-44'
  | 'sm:pl-48'
  | 'md:pl-48'
  | 'mg:pl-48'
  | 'lg:pl-48'
  | 'xl:pl-48'
  | 'sm:pl-52'
  | 'md:pl-52'
  | 'mg:pl-52'
  | 'lg:pl-52'
  | 'xl:pl-52'
  | 'sm:pl-56'
  | 'md:pl-56'
  | 'mg:pl-56'
  | 'lg:pl-56'
  | 'xl:pl-56'
  | 'sm:pl-60'
  | 'md:pl-60'
  | 'mg:pl-60'
  | 'lg:pl-60'
  | 'xl:pl-60'
  | 'sm:pl-64'
  | 'md:pl-64'
  | 'mg:pl-64'
  | 'lg:pl-64'
  | 'xl:pl-64'
  | 'sm:pl-72'
  | 'md:pl-72'
  | 'mg:pl-72'
  | 'lg:pl-72'
  | 'xl:pl-72'
  | 'sm:pl-80'
  | 'md:pl-80'
  | 'mg:pl-80'
  | 'lg:pl-80'
  | 'xl:pl-80'
  | 'sm:pl-96'
  | 'md:pl-96'
  | 'mg:pl-96'
  | 'lg:pl-96'
  | 'xl:pl-96'
  | 'sm:pl-px'
  | 'md:pl-px'
  | 'mg:pl-px'
  | 'lg:pl-px'
  | 'xl:pl-px'
  | 'sm:pl-0.5'
  | 'md:pl-0.5'
  | 'mg:pl-0.5'
  | 'lg:pl-0.5'
  | 'xl:pl-0.5'
  | 'sm:pl-1.5'
  | 'md:pl-1.5'
  | 'mg:pl-1.5'
  | 'lg:pl-1.5'
  | 'xl:pl-1.5'
  | 'sm:pl-2.5'
  | 'md:pl-2.5'
  | 'mg:pl-2.5'
  | 'lg:pl-2.5'
  | 'xl:pl-2.5'
  | 'sm:pl-3.5'
  | 'md:pl-3.5'
  | 'mg:pl-3.5'
  | 'lg:pl-3.5'
  | 'xl:pl-3.5'
  | 'sm:pl-1/2'
  | 'md:pl-1/2'
  | 'mg:pl-1/2'
  | 'lg:pl-1/2'
  | 'xl:pl-1/2'
  | 'sm:pl-full'
  | 'md:pl-full'
  | 'mg:pl-full'
  | 'lg:pl-full'
  | 'xl:pl-full'
  | 'sm:pl-4.5'
  | 'md:pl-4.5'
  | 'mg:pl-4.5'
  | 'lg:pl-4.5'
  | 'xl:pl-4.5'
  | 'sm:pl-7.5'
  | 'md:pl-7.5'
  | 'mg:pl-7.5'
  | 'lg:pl-7.5'
  | 'xl:pl-7.5'
  | 'sm:pl-9.5'
  | 'md:pl-9.5'
  | 'mg:pl-9.5'
  | 'lg:pl-9.5'
  | 'xl:pl-9.5'
  | 'sm:pl-11.5'
  | 'md:pl-11.5'
  | 'mg:pl-11.5'
  | 'lg:pl-11.5'
  | 'xl:pl-11.5'
  | 'sm:place-content-start'
  | 'md:place-content-start'
  | 'mg:place-content-start'
  | 'lg:place-content-start'
  | 'xl:place-content-start'
  | 'sm:place-content-center'
  | 'md:place-content-center'
  | 'mg:place-content-center'
  | 'lg:place-content-center'
  | 'xl:place-content-center'
  | 'sm:place-content-end'
  | 'md:place-content-end'
  | 'mg:place-content-end'
  | 'lg:place-content-end'
  | 'xl:place-content-end'
  | 'sm:place-content-between'
  | 'md:place-content-between'
  | 'mg:place-content-between'
  | 'lg:place-content-between'
  | 'xl:place-content-between'
  | 'sm:place-content-around'
  | 'md:place-content-around'
  | 'mg:place-content-around'
  | 'lg:place-content-around'
  | 'xl:place-content-around'
  | 'sm:place-content-evenly'
  | 'md:place-content-evenly'
  | 'mg:place-content-evenly'
  | 'lg:place-content-evenly'
  | 'xl:place-content-evenly'
  | 'sm:place-content-stretch'
  | 'md:place-content-stretch'
  | 'mg:place-content-stretch'
  | 'lg:place-content-stretch'
  | 'xl:place-content-stretch'
  | 'sm:place-items-auto'
  | 'md:place-items-auto'
  | 'mg:place-items-auto'
  | 'lg:place-items-auto'
  | 'xl:place-items-auto'
  | 'sm:place-items-start'
  | 'md:place-items-start'
  | 'mg:place-items-start'
  | 'lg:place-items-start'
  | 'xl:place-items-start'
  | 'sm:place-items-center'
  | 'md:place-items-center'
  | 'mg:place-items-center'
  | 'lg:place-items-center'
  | 'xl:place-items-center'
  | 'sm:place-items-end'
  | 'md:place-items-end'
  | 'mg:place-items-end'
  | 'lg:place-items-end'
  | 'xl:place-items-end'
  | 'sm:place-items-stretch'
  | 'md:place-items-stretch'
  | 'mg:place-items-stretch'
  | 'lg:place-items-stretch'
  | 'xl:place-items-stretch'
  | 'sm:place-self-auto'
  | 'md:place-self-auto'
  | 'mg:place-self-auto'
  | 'lg:place-self-auto'
  | 'xl:place-self-auto'
  | 'sm:place-self-start'
  | 'md:place-self-start'
  | 'mg:place-self-start'
  | 'lg:place-self-start'
  | 'xl:place-self-start'
  | 'sm:place-self-center'
  | 'md:place-self-center'
  | 'mg:place-self-center'
  | 'lg:place-self-center'
  | 'xl:place-self-center'
  | 'sm:place-self-end'
  | 'md:place-self-end'
  | 'mg:place-self-end'
  | 'lg:place-self-end'
  | 'xl:place-self-end'
  | 'sm:place-self-stretch'
  | 'md:place-self-stretch'
  | 'mg:place-self-stretch'
  | 'lg:place-self-stretch'
  | 'xl:place-self-stretch'
  | 'sm:placeholder-transparent'
  | 'md:placeholder-transparent'
  | 'mg:placeholder-transparent'
  | 'lg:placeholder-transparent'
  | 'xl:placeholder-transparent'
  | 'focus:placeholder-transparent'
  | 'sm:placeholder-current'
  | 'md:placeholder-current'
  | 'mg:placeholder-current'
  | 'lg:placeholder-current'
  | 'xl:placeholder-current'
  | 'focus:placeholder-current'
  | 'sm:placeholder-overlay'
  | 'md:placeholder-overlay'
  | 'mg:placeholder-overlay'
  | 'lg:placeholder-overlay'
  | 'xl:placeholder-overlay'
  | 'focus:placeholder-overlay'
  | 'sm:placeholder-black'
  | 'md:placeholder-black'
  | 'mg:placeholder-black'
  | 'lg:placeholder-black'
  | 'xl:placeholder-black'
  | 'focus:placeholder-black'
  | 'sm:placeholder-white'
  | 'md:placeholder-white'
  | 'mg:placeholder-white'
  | 'lg:placeholder-white'
  | 'xl:placeholder-white'
  | 'focus:placeholder-white'
  | 'sm:placeholder-white-hover'
  | 'md:placeholder-white-hover'
  | 'mg:placeholder-white-hover'
  | 'lg:placeholder-white-hover'
  | 'xl:placeholder-white-hover'
  | 'focus:placeholder-white-hover'
  | 'sm:placeholder-white-pressed'
  | 'md:placeholder-white-pressed'
  | 'mg:placeholder-white-pressed'
  | 'lg:placeholder-white-pressed'
  | 'xl:placeholder-white-pressed'
  | 'focus:placeholder-white-pressed'
  | 'sm:placeholder-product-acid'
  | 'md:placeholder-product-acid'
  | 'mg:placeholder-product-acid'
  | 'lg:placeholder-product-acid'
  | 'xl:placeholder-product-acid'
  | 'focus:placeholder-product-acid'
  | 'sm:placeholder-product-aura'
  | 'md:placeholder-product-aura'
  | 'mg:placeholder-product-aura'
  | 'lg:placeholder-product-aura'
  | 'xl:placeholder-product-aura'
  | 'focus:placeholder-product-aura'
  | 'sm:placeholder-product-azul'
  | 'md:placeholder-product-azul'
  | 'mg:placeholder-product-azul'
  | 'lg:placeholder-product-azul'
  | 'xl:placeholder-product-azul'
  | 'focus:placeholder-product-azul'
  | 'sm:placeholder-product-blanch'
  | 'md:placeholder-product-blanch'
  | 'mg:placeholder-product-blanch'
  | 'lg:placeholder-product-blanch'
  | 'xl:placeholder-product-blanch'
  | 'focus:placeholder-product-blanch'
  | 'sm:placeholder-product-blue-salt'
  | 'md:placeholder-product-blue-salt'
  | 'mg:placeholder-product-blue-salt'
  | 'lg:placeholder-product-blue-salt'
  | 'xl:placeholder-product-blue-salt'
  | 'focus:placeholder-product-blue-salt'
  | 'sm:placeholder-product-burgundy'
  | 'md:placeholder-product-burgundy'
  | 'mg:placeholder-product-burgundy'
  | 'lg:placeholder-product-burgundy'
  | 'xl:placeholder-product-burgundy'
  | 'focus:placeholder-product-burgundy'
  | 'sm:placeholder-product-butter-yellow'
  | 'md:placeholder-product-butter-yellow'
  | 'mg:placeholder-product-butter-yellow'
  | 'lg:placeholder-product-butter-yellow'
  | 'xl:placeholder-product-butter-yellow'
  | 'focus:placeholder-product-butter-yellow'
  | 'sm:placeholder-product-chai'
  | 'md:placeholder-product-chai'
  | 'mg:placeholder-product-chai'
  | 'lg:placeholder-product-chai'
  | 'xl:placeholder-product-chai'
  | 'focus:placeholder-product-chai'
  | 'sm:placeholder-product-char'
  | 'md:placeholder-product-char'
  | 'mg:placeholder-product-char'
  | 'lg:placeholder-product-char'
  | 'xl:placeholder-product-char'
  | 'focus:placeholder-product-char'
  | 'sm:placeholder-product-charm'
  | 'md:placeholder-product-charm'
  | 'mg:placeholder-product-charm'
  | 'lg:placeholder-product-charm'
  | 'xl:placeholder-product-charm'
  | 'focus:placeholder-product-charm'
  | 'sm:placeholder-product-chickpea'
  | 'md:placeholder-product-chickpea'
  | 'mg:placeholder-product-chickpea'
  | 'lg:placeholder-product-chickpea'
  | 'xl:placeholder-product-chickpea'
  | 'focus:placeholder-product-chickpea'
  | 'sm:placeholder-product-cielo'
  | 'md:placeholder-product-cielo'
  | 'mg:placeholder-product-cielo'
  | 'lg:placeholder-product-cielo'
  | 'xl:placeholder-product-cielo'
  | 'focus:placeholder-product-cielo'
  | 'sm:placeholder-product-clay'
  | 'md:placeholder-product-clay'
  | 'mg:placeholder-product-clay'
  | 'lg:placeholder-product-clay'
  | 'xl:placeholder-product-clay'
  | 'focus:placeholder-product-clay'
  | 'sm:placeholder-product-clear'
  | 'md:placeholder-product-clear'
  | 'mg:placeholder-product-clear'
  | 'lg:placeholder-product-clear'
  | 'xl:placeholder-product-clear'
  | 'focus:placeholder-product-clear'
  | 'sm:placeholder-product-coriander'
  | 'md:placeholder-product-coriander'
  | 'mg:placeholder-product-coriander'
  | 'lg:placeholder-product-coriander'
  | 'xl:placeholder-product-coriander'
  | 'focus:placeholder-product-coriander'
  | 'sm:placeholder-product-cream'
  | 'md:placeholder-product-cream'
  | 'mg:placeholder-product-cream'
  | 'lg:placeholder-product-cream'
  | 'xl:placeholder-product-cream'
  | 'focus:placeholder-product-cream'
  | 'sm:placeholder-product-crescent'
  | 'md:placeholder-product-crescent'
  | 'mg:placeholder-product-crescent'
  | 'lg:placeholder-product-crescent'
  | 'xl:placeholder-product-crescent'
  | 'focus:placeholder-product-crescent'
  | 'sm:placeholder-product-dawn'
  | 'md:placeholder-product-dawn'
  | 'mg:placeholder-product-dawn'
  | 'lg:placeholder-product-dawn'
  | 'xl:placeholder-product-dawn'
  | 'focus:placeholder-product-dawn'
  | 'sm:placeholder-product-dusk'
  | 'md:placeholder-product-dusk'
  | 'mg:placeholder-product-dusk'
  | 'lg:placeholder-product-dusk'
  | 'xl:placeholder-product-dusk'
  | 'focus:placeholder-product-dusk'
  | 'sm:placeholder-product-egg-yolk'
  | 'md:placeholder-product-egg-yolk'
  | 'mg:placeholder-product-egg-yolk'
  | 'lg:placeholder-product-egg-yolk'
  | 'xl:placeholder-product-egg-yolk'
  | 'focus:placeholder-product-egg-yolk'
  | 'sm:placeholder-product-espresso'
  | 'md:placeholder-product-espresso'
  | 'mg:placeholder-product-espresso'
  | 'lg:placeholder-product-espresso'
  | 'xl:placeholder-product-espresso'
  | 'focus:placeholder-product-espresso'
  | 'sm:placeholder-product-eve'
  | 'md:placeholder-product-eve'
  | 'mg:placeholder-product-eve'
  | 'lg:placeholder-product-eve'
  | 'xl:placeholder-product-eve'
  | 'focus:placeholder-product-eve'
  | 'sm:placeholder-product-firecracker'
  | 'md:placeholder-product-firecracker'
  | 'mg:placeholder-product-firecracker'
  | 'lg:placeholder-product-firecracker'
  | 'xl:placeholder-product-firecracker'
  | 'focus:placeholder-product-firecracker'
  | 'sm:placeholder-product-forget-me-not-blue'
  | 'md:placeholder-product-forget-me-not-blue'
  | 'mg:placeholder-product-forget-me-not-blue'
  | 'lg:placeholder-product-forget-me-not-blue'
  | 'xl:placeholder-product-forget-me-not-blue'
  | 'focus:placeholder-product-forget-me-not-blue'
  | 'sm:placeholder-product-gold'
  | 'md:placeholder-product-gold'
  | 'mg:placeholder-product-gold'
  | 'lg:placeholder-product-gold'
  | 'xl:placeholder-product-gold'
  | 'focus:placeholder-product-gold'
  | 'sm:placeholder-product-golden'
  | 'md:placeholder-product-golden'
  | 'mg:placeholder-product-golden'
  | 'lg:placeholder-product-golden'
  | 'xl:placeholder-product-golden'
  | 'focus:placeholder-product-golden'
  | 'sm:placeholder-product-heat'
  | 'md:placeholder-product-heat'
  | 'mg:placeholder-product-heat'
  | 'lg:placeholder-product-heat'
  | 'xl:placeholder-product-heat'
  | 'focus:placeholder-product-heat'
  | 'sm:placeholder-product-himalayan-salt'
  | 'md:placeholder-product-himalayan-salt'
  | 'mg:placeholder-product-himalayan-salt'
  | 'lg:placeholder-product-himalayan-salt'
  | 'xl:placeholder-product-himalayan-salt'
  | 'focus:placeholder-product-himalayan-salt'
  | 'sm:placeholder-product-indigo'
  | 'md:placeholder-product-indigo'
  | 'mg:placeholder-product-indigo'
  | 'lg:placeholder-product-indigo'
  | 'xl:placeholder-product-indigo'
  | 'focus:placeholder-product-indigo'
  | 'sm:placeholder-product-lavender'
  | 'md:placeholder-product-lavender'
  | 'mg:placeholder-product-lavender'
  | 'lg:placeholder-product-lavender'
  | 'xl:placeholder-product-lavender'
  | 'focus:placeholder-product-lavender'
  | 'sm:placeholder-product-lavender-marble'
  | 'md:placeholder-product-lavender-marble'
  | 'mg:placeholder-product-lavender-marble'
  | 'lg:placeholder-product-lavender-marble'
  | 'xl:placeholder-product-lavender-marble'
  | 'focus:placeholder-product-lavender-marble'
  | 'sm:placeholder-product-midnight-marble'
  | 'md:placeholder-product-midnight-marble'
  | 'mg:placeholder-product-midnight-marble'
  | 'lg:placeholder-product-midnight-marble'
  | 'xl:placeholder-product-midnight-marble'
  | 'focus:placeholder-product-midnight-marble'
  | 'sm:placeholder-product-nougat'
  | 'md:placeholder-product-nougat'
  | 'mg:placeholder-product-nougat'
  | 'lg:placeholder-product-nougat'
  | 'xl:placeholder-product-nougat'
  | 'focus:placeholder-product-nougat'
  | 'sm:placeholder-product-pistachio'
  | 'md:placeholder-product-pistachio'
  | 'mg:placeholder-product-pistachio'
  | 'lg:placeholder-product-pistachio'
  | 'xl:placeholder-product-pistachio'
  | 'focus:placeholder-product-pistachio'
  | 'sm:placeholder-product-rosa'
  | 'md:placeholder-product-rosa'
  | 'mg:placeholder-product-rosa'
  | 'lg:placeholder-product-rosa'
  | 'xl:placeholder-product-rosa'
  | 'focus:placeholder-product-rosa'
  | 'sm:placeholder-product-rose-gold'
  | 'md:placeholder-product-rose-gold'
  | 'mg:placeholder-product-rose-gold'
  | 'lg:placeholder-product-rose-gold'
  | 'xl:placeholder-product-rose-gold'
  | 'focus:placeholder-product-rose-gold'
  | 'sm:placeholder-product-rust'
  | 'md:placeholder-product-rust'
  | 'mg:placeholder-product-rust'
  | 'lg:placeholder-product-rust'
  | 'xl:placeholder-product-rust'
  | 'focus:placeholder-product-rust'
  | 'sm:placeholder-product-saffron'
  | 'md:placeholder-product-saffron'
  | 'mg:placeholder-product-saffron'
  | 'lg:placeholder-product-saffron'
  | 'xl:placeholder-product-saffron'
  | 'focus:placeholder-product-saffron'
  | 'sm:placeholder-product-sage'
  | 'md:placeholder-product-sage'
  | 'mg:placeholder-product-sage'
  | 'lg:placeholder-product-sage'
  | 'xl:placeholder-product-sage'
  | 'focus:placeholder-product-sage'
  | 'sm:placeholder-product-sear'
  | 'md:placeholder-product-sear'
  | 'mg:placeholder-product-sear'
  | 'lg:placeholder-product-sear'
  | 'xl:placeholder-product-sear'
  | 'focus:placeholder-product-sear'
  | 'sm:placeholder-product-spice'
  | 'md:placeholder-product-spice'
  | 'mg:placeholder-product-spice'
  | 'lg:placeholder-product-spice'
  | 'xl:placeholder-product-spice'
  | 'focus:placeholder-product-spice'
  | 'sm:placeholder-product-steam'
  | 'md:placeholder-product-steam'
  | 'mg:placeholder-product-steam'
  | 'lg:placeholder-product-steam'
  | 'xl:placeholder-product-steam'
  | 'focus:placeholder-product-steam'
  | 'sm:placeholder-product-strawberry'
  | 'md:placeholder-product-strawberry'
  | 'mg:placeholder-product-strawberry'
  | 'lg:placeholder-product-strawberry'
  | 'xl:placeholder-product-strawberry'
  | 'focus:placeholder-product-strawberry'
  | 'sm:placeholder-product-sunrise'
  | 'md:placeholder-product-sunrise'
  | 'mg:placeholder-product-sunrise'
  | 'lg:placeholder-product-sunrise'
  | 'xl:placeholder-product-sunrise'
  | 'focus:placeholder-product-sunrise'
  | 'sm:placeholder-product-sunset'
  | 'md:placeholder-product-sunset'
  | 'mg:placeholder-product-sunset'
  | 'lg:placeholder-product-sunset'
  | 'xl:placeholder-product-sunset'
  | 'focus:placeholder-product-sunset'
  | 'sm:placeholder-product-sunset-marble'
  | 'md:placeholder-product-sunset-marble'
  | 'mg:placeholder-product-sunset-marble'
  | 'lg:placeholder-product-sunset-marble'
  | 'xl:placeholder-product-sunset-marble'
  | 'focus:placeholder-product-sunset-marble'
  | 'sm:placeholder-product-terracotta'
  | 'md:placeholder-product-terracotta'
  | 'mg:placeholder-product-terracotta'
  | 'lg:placeholder-product-terracotta'
  | 'xl:placeholder-product-terracotta'
  | 'focus:placeholder-product-terracotta'
  | 'sm:placeholder-product-tierra'
  | 'md:placeholder-product-tierra'
  | 'mg:placeholder-product-tierra'
  | 'lg:placeholder-product-tierra'
  | 'xl:placeholder-product-tierra'
  | 'focus:placeholder-product-tierra'
  | 'sm:placeholder-product-turmeric'
  | 'md:placeholder-product-turmeric'
  | 'mg:placeholder-product-turmeric'
  | 'lg:placeholder-product-turmeric'
  | 'xl:placeholder-product-turmeric'
  | 'focus:placeholder-product-turmeric'
  | 'sm:placeholder-product-turqoise'
  | 'md:placeholder-product-turqoise'
  | 'mg:placeholder-product-turqoise'
  | 'lg:placeholder-product-turqoise'
  | 'xl:placeholder-product-turqoise'
  | 'focus:placeholder-product-turqoise'
  | 'sm:placeholder-product-twilight'
  | 'md:placeholder-product-twilight'
  | 'mg:placeholder-product-twilight'
  | 'lg:placeholder-product-twilight'
  | 'xl:placeholder-product-twilight'
  | 'focus:placeholder-product-twilight'
  | 'sm:placeholder-product-walnut'
  | 'md:placeholder-product-walnut'
  | 'mg:placeholder-product-walnut'
  | 'lg:placeholder-product-walnut'
  | 'xl:placeholder-product-walnut'
  | 'focus:placeholder-product-walnut'
  | 'sm:placeholder-product-warm-white'
  | 'md:placeholder-product-warm-white'
  | 'mg:placeholder-product-warm-white'
  | 'lg:placeholder-product-warm-white'
  | 'xl:placeholder-product-warm-white'
  | 'focus:placeholder-product-warm-white'
  | 'sm:placeholder-product-zest'
  | 'md:placeholder-product-zest'
  | 'mg:placeholder-product-zest'
  | 'lg:placeholder-product-zest'
  | 'xl:placeholder-product-zest'
  | 'focus:placeholder-product-zest'
  | 'sm:placeholder-placeholder'
  | 'md:placeholder-placeholder'
  | 'mg:placeholder-placeholder'
  | 'lg:placeholder-placeholder'
  | 'xl:placeholder-placeholder'
  | 'focus:placeholder-placeholder'
  | 'sm:placeholder-interactive-bone'
  | 'md:placeholder-interactive-bone'
  | 'mg:placeholder-interactive-bone'
  | 'lg:placeholder-interactive-bone'
  | 'xl:placeholder-interactive-bone'
  | 'focus:placeholder-interactive-bone'
  | 'sm:placeholder-interactive-brick'
  | 'md:placeholder-interactive-brick'
  | 'mg:placeholder-interactive-brick'
  | 'lg:placeholder-interactive-brick'
  | 'xl:placeholder-interactive-brick'
  | 'focus:placeholder-interactive-brick'
  | 'sm:placeholder-interactive-char'
  | 'md:placeholder-interactive-char'
  | 'mg:placeholder-interactive-char'
  | 'lg:placeholder-interactive-char'
  | 'xl:placeholder-interactive-char'
  | 'focus:placeholder-interactive-char'
  | 'sm:placeholder-interactive-white'
  | 'md:placeholder-interactive-white'
  | 'mg:placeholder-interactive-white'
  | 'lg:placeholder-interactive-white'
  | 'xl:placeholder-interactive-white'
  | 'focus:placeholder-interactive-white'
  | 'sm:placeholder-interactive-disabled'
  | 'md:placeholder-interactive-disabled'
  | 'mg:placeholder-interactive-disabled'
  | 'lg:placeholder-interactive-disabled'
  | 'xl:placeholder-interactive-disabled'
  | 'focus:placeholder-interactive-disabled'
  | 'sm:placeholder-interactive-error'
  | 'md:placeholder-interactive-error'
  | 'mg:placeholder-interactive-error'
  | 'lg:placeholder-interactive-error'
  | 'xl:placeholder-interactive-error'
  | 'focus:placeholder-interactive-error'
  | 'sm:placeholder-interactive-outline'
  | 'md:placeholder-interactive-outline'
  | 'mg:placeholder-interactive-outline'
  | 'lg:placeholder-interactive-outline'
  | 'xl:placeholder-interactive-outline'
  | 'focus:placeholder-interactive-outline'
  | 'sm:placeholder-translucent-char'
  | 'md:placeholder-translucent-char'
  | 'mg:placeholder-translucent-char'
  | 'lg:placeholder-translucent-char'
  | 'xl:placeholder-translucent-char'
  | 'focus:placeholder-translucent-char'
  | 'sm:placeholder-translucent-white'
  | 'md:placeholder-translucent-white'
  | 'mg:placeholder-translucent-white'
  | 'lg:placeholder-translucent-white'
  | 'xl:placeholder-translucent-white'
  | 'focus:placeholder-translucent-white'
  | 'sm:placeholder-char-50'
  | 'md:placeholder-char-50'
  | 'mg:placeholder-char-50'
  | 'lg:placeholder-char-50'
  | 'xl:placeholder-char-50'
  | 'focus:placeholder-char-50'
  | 'sm:placeholder-char-100'
  | 'md:placeholder-char-100'
  | 'mg:placeholder-char-100'
  | 'lg:placeholder-char-100'
  | 'xl:placeholder-char-100'
  | 'focus:placeholder-char-100'
  | 'sm:placeholder-char-200'
  | 'md:placeholder-char-200'
  | 'mg:placeholder-char-200'
  | 'lg:placeholder-char-200'
  | 'xl:placeholder-char-200'
  | 'focus:placeholder-char-200'
  | 'sm:placeholder-char-300'
  | 'md:placeholder-char-300'
  | 'mg:placeholder-char-300'
  | 'lg:placeholder-char-300'
  | 'xl:placeholder-char-300'
  | 'focus:placeholder-char-300'
  | 'sm:placeholder-char-400'
  | 'md:placeholder-char-400'
  | 'mg:placeholder-char-400'
  | 'lg:placeholder-char-400'
  | 'xl:placeholder-char-400'
  | 'focus:placeholder-char-400'
  | 'sm:placeholder-char-500'
  | 'md:placeholder-char-500'
  | 'mg:placeholder-char-500'
  | 'lg:placeholder-char-500'
  | 'xl:placeholder-char-500'
  | 'focus:placeholder-char-500'
  | 'sm:placeholder-char-600'
  | 'md:placeholder-char-600'
  | 'mg:placeholder-char-600'
  | 'lg:placeholder-char-600'
  | 'xl:placeholder-char-600'
  | 'focus:placeholder-char-600'
  | 'sm:placeholder-char-700'
  | 'md:placeholder-char-700'
  | 'mg:placeholder-char-700'
  | 'lg:placeholder-char-700'
  | 'xl:placeholder-char-700'
  | 'focus:placeholder-char-700'
  | 'sm:placeholder-char-800'
  | 'md:placeholder-char-800'
  | 'mg:placeholder-char-800'
  | 'lg:placeholder-char-800'
  | 'xl:placeholder-char-800'
  | 'focus:placeholder-char-800'
  | 'sm:placeholder-char-900'
  | 'md:placeholder-char-900'
  | 'mg:placeholder-char-900'
  | 'lg:placeholder-char-900'
  | 'xl:placeholder-char-900'
  | 'focus:placeholder-char-900'
  | 'sm:placeholder-bone-50'
  | 'md:placeholder-bone-50'
  | 'mg:placeholder-bone-50'
  | 'lg:placeholder-bone-50'
  | 'xl:placeholder-bone-50'
  | 'focus:placeholder-bone-50'
  | 'sm:placeholder-bone-100'
  | 'md:placeholder-bone-100'
  | 'mg:placeholder-bone-100'
  | 'lg:placeholder-bone-100'
  | 'xl:placeholder-bone-100'
  | 'focus:placeholder-bone-100'
  | 'sm:placeholder-bone-200'
  | 'md:placeholder-bone-200'
  | 'mg:placeholder-bone-200'
  | 'lg:placeholder-bone-200'
  | 'xl:placeholder-bone-200'
  | 'focus:placeholder-bone-200'
  | 'sm:placeholder-bone-300'
  | 'md:placeholder-bone-300'
  | 'mg:placeholder-bone-300'
  | 'lg:placeholder-bone-300'
  | 'xl:placeholder-bone-300'
  | 'focus:placeholder-bone-300'
  | 'sm:placeholder-bone-400'
  | 'md:placeholder-bone-400'
  | 'mg:placeholder-bone-400'
  | 'lg:placeholder-bone-400'
  | 'xl:placeholder-bone-400'
  | 'focus:placeholder-bone-400'
  | 'sm:placeholder-bone-500'
  | 'md:placeholder-bone-500'
  | 'mg:placeholder-bone-500'
  | 'lg:placeholder-bone-500'
  | 'xl:placeholder-bone-500'
  | 'focus:placeholder-bone-500'
  | 'sm:placeholder-bone-600'
  | 'md:placeholder-bone-600'
  | 'mg:placeholder-bone-600'
  | 'lg:placeholder-bone-600'
  | 'xl:placeholder-bone-600'
  | 'focus:placeholder-bone-600'
  | 'sm:placeholder-bone-700'
  | 'md:placeholder-bone-700'
  | 'mg:placeholder-bone-700'
  | 'lg:placeholder-bone-700'
  | 'xl:placeholder-bone-700'
  | 'focus:placeholder-bone-700'
  | 'sm:placeholder-bone-800'
  | 'md:placeholder-bone-800'
  | 'mg:placeholder-bone-800'
  | 'lg:placeholder-bone-800'
  | 'xl:placeholder-bone-800'
  | 'focus:placeholder-bone-800'
  | 'sm:placeholder-bone-900'
  | 'md:placeholder-bone-900'
  | 'mg:placeholder-bone-900'
  | 'lg:placeholder-bone-900'
  | 'xl:placeholder-bone-900'
  | 'focus:placeholder-bone-900'
  | 'sm:placeholder-brick-50'
  | 'md:placeholder-brick-50'
  | 'mg:placeholder-brick-50'
  | 'lg:placeholder-brick-50'
  | 'xl:placeholder-brick-50'
  | 'focus:placeholder-brick-50'
  | 'sm:placeholder-brick-300'
  | 'md:placeholder-brick-300'
  | 'mg:placeholder-brick-300'
  | 'lg:placeholder-brick-300'
  | 'xl:placeholder-brick-300'
  | 'focus:placeholder-brick-300'
  | 'sm:placeholder-brick-500'
  | 'md:placeholder-brick-500'
  | 'mg:placeholder-brick-500'
  | 'lg:placeholder-brick-500'
  | 'xl:placeholder-brick-500'
  | 'focus:placeholder-brick-500'
  | 'sm:placeholder-brick-700'
  | 'md:placeholder-brick-700'
  | 'mg:placeholder-brick-700'
  | 'lg:placeholder-brick-700'
  | 'xl:placeholder-brick-700'
  | 'focus:placeholder-brick-700'
  | 'sm:placeholder-brick-900'
  | 'md:placeholder-brick-900'
  | 'mg:placeholder-brick-900'
  | 'lg:placeholder-brick-900'
  | 'xl:placeholder-brick-900'
  | 'focus:placeholder-brick-900'
  | 'sm:placeholder-sage-50'
  | 'md:placeholder-sage-50'
  | 'mg:placeholder-sage-50'
  | 'lg:placeholder-sage-50'
  | 'xl:placeholder-sage-50'
  | 'focus:placeholder-sage-50'
  | 'sm:placeholder-sage-300'
  | 'md:placeholder-sage-300'
  | 'mg:placeholder-sage-300'
  | 'lg:placeholder-sage-300'
  | 'xl:placeholder-sage-300'
  | 'focus:placeholder-sage-300'
  | 'sm:placeholder-sage-500'
  | 'md:placeholder-sage-500'
  | 'mg:placeholder-sage-500'
  | 'lg:placeholder-sage-500'
  | 'xl:placeholder-sage-500'
  | 'focus:placeholder-sage-500'
  | 'sm:placeholder-sage-700'
  | 'md:placeholder-sage-700'
  | 'mg:placeholder-sage-700'
  | 'lg:placeholder-sage-700'
  | 'xl:placeholder-sage-700'
  | 'focus:placeholder-sage-700'
  | 'sm:placeholder-sage-900'
  | 'md:placeholder-sage-900'
  | 'mg:placeholder-sage-900'
  | 'lg:placeholder-sage-900'
  | 'xl:placeholder-sage-900'
  | 'focus:placeholder-sage-900'
  | 'sm:placeholder-blue-50'
  | 'md:placeholder-blue-50'
  | 'mg:placeholder-blue-50'
  | 'lg:placeholder-blue-50'
  | 'xl:placeholder-blue-50'
  | 'focus:placeholder-blue-50'
  | 'sm:placeholder-blue-300'
  | 'md:placeholder-blue-300'
  | 'mg:placeholder-blue-300'
  | 'lg:placeholder-blue-300'
  | 'xl:placeholder-blue-300'
  | 'focus:placeholder-blue-300'
  | 'sm:placeholder-blue-500'
  | 'md:placeholder-blue-500'
  | 'mg:placeholder-blue-500'
  | 'lg:placeholder-blue-500'
  | 'xl:placeholder-blue-500'
  | 'focus:placeholder-blue-500'
  | 'sm:placeholder-blue-700'
  | 'md:placeholder-blue-700'
  | 'mg:placeholder-blue-700'
  | 'lg:placeholder-blue-700'
  | 'xl:placeholder-blue-700'
  | 'focus:placeholder-blue-700'
  | 'sm:placeholder-blue-900'
  | 'md:placeholder-blue-900'
  | 'mg:placeholder-blue-900'
  | 'lg:placeholder-blue-900'
  | 'xl:placeholder-blue-900'
  | 'focus:placeholder-blue-900'
  | 'sm:placeholder-misc-bright-blue'
  | 'md:placeholder-misc-bright-blue'
  | 'mg:placeholder-misc-bright-blue'
  | 'lg:placeholder-misc-bright-blue'
  | 'xl:placeholder-misc-bright-blue'
  | 'focus:placeholder-misc-bright-blue'
  | 'sm:placeholder-misc-focus'
  | 'md:placeholder-misc-focus'
  | 'mg:placeholder-misc-focus'
  | 'lg:placeholder-misc-focus'
  | 'xl:placeholder-misc-focus'
  | 'focus:placeholder-misc-focus'
  | 'sm:placeholder-misc-legal-blue'
  | 'md:placeholder-misc-legal-blue'
  | 'mg:placeholder-misc-legal-blue'
  | 'lg:placeholder-misc-legal-blue'
  | 'xl:placeholder-misc-legal-blue'
  | 'focus:placeholder-misc-legal-blue'
  | 'sm:placeholder-misc-neutral'
  | 'md:placeholder-misc-neutral'
  | 'mg:placeholder-misc-neutral'
  | 'lg:placeholder-misc-neutral'
  | 'xl:placeholder-misc-neutral'
  | 'focus:placeholder-misc-neutral'
  | 'sm:placeholder-misc-yellow-orange'
  | 'md:placeholder-misc-yellow-orange'
  | 'mg:placeholder-misc-yellow-orange'
  | 'lg:placeholder-misc-yellow-orange'
  | 'xl:placeholder-misc-yellow-orange'
  | 'focus:placeholder-misc-yellow-orange'
  | 'sm:placeholder-opacity-0'
  | 'md:placeholder-opacity-0'
  | 'mg:placeholder-opacity-0'
  | 'lg:placeholder-opacity-0'
  | 'xl:placeholder-opacity-0'
  | 'focus:placeholder-opacity-0'
  | 'sm:placeholder-opacity-5'
  | 'md:placeholder-opacity-5'
  | 'mg:placeholder-opacity-5'
  | 'lg:placeholder-opacity-5'
  | 'xl:placeholder-opacity-5'
  | 'focus:placeholder-opacity-5'
  | 'sm:placeholder-opacity-10'
  | 'md:placeholder-opacity-10'
  | 'mg:placeholder-opacity-10'
  | 'lg:placeholder-opacity-10'
  | 'xl:placeholder-opacity-10'
  | 'focus:placeholder-opacity-10'
  | 'sm:placeholder-opacity-20'
  | 'md:placeholder-opacity-20'
  | 'mg:placeholder-opacity-20'
  | 'lg:placeholder-opacity-20'
  | 'xl:placeholder-opacity-20'
  | 'focus:placeholder-opacity-20'
  | 'sm:placeholder-opacity-25'
  | 'md:placeholder-opacity-25'
  | 'mg:placeholder-opacity-25'
  | 'lg:placeholder-opacity-25'
  | 'xl:placeholder-opacity-25'
  | 'focus:placeholder-opacity-25'
  | 'sm:placeholder-opacity-30'
  | 'md:placeholder-opacity-30'
  | 'mg:placeholder-opacity-30'
  | 'lg:placeholder-opacity-30'
  | 'xl:placeholder-opacity-30'
  | 'focus:placeholder-opacity-30'
  | 'sm:placeholder-opacity-40'
  | 'md:placeholder-opacity-40'
  | 'mg:placeholder-opacity-40'
  | 'lg:placeholder-opacity-40'
  | 'xl:placeholder-opacity-40'
  | 'focus:placeholder-opacity-40'
  | 'sm:placeholder-opacity-50'
  | 'md:placeholder-opacity-50'
  | 'mg:placeholder-opacity-50'
  | 'lg:placeholder-opacity-50'
  | 'xl:placeholder-opacity-50'
  | 'focus:placeholder-opacity-50'
  | 'sm:placeholder-opacity-60'
  | 'md:placeholder-opacity-60'
  | 'mg:placeholder-opacity-60'
  | 'lg:placeholder-opacity-60'
  | 'xl:placeholder-opacity-60'
  | 'focus:placeholder-opacity-60'
  | 'sm:placeholder-opacity-70'
  | 'md:placeholder-opacity-70'
  | 'mg:placeholder-opacity-70'
  | 'lg:placeholder-opacity-70'
  | 'xl:placeholder-opacity-70'
  | 'focus:placeholder-opacity-70'
  | 'sm:placeholder-opacity-75'
  | 'md:placeholder-opacity-75'
  | 'mg:placeholder-opacity-75'
  | 'lg:placeholder-opacity-75'
  | 'xl:placeholder-opacity-75'
  | 'focus:placeholder-opacity-75'
  | 'sm:placeholder-opacity-80'
  | 'md:placeholder-opacity-80'
  | 'mg:placeholder-opacity-80'
  | 'lg:placeholder-opacity-80'
  | 'xl:placeholder-opacity-80'
  | 'focus:placeholder-opacity-80'
  | 'sm:placeholder-opacity-90'
  | 'md:placeholder-opacity-90'
  | 'mg:placeholder-opacity-90'
  | 'lg:placeholder-opacity-90'
  | 'xl:placeholder-opacity-90'
  | 'focus:placeholder-opacity-90'
  | 'sm:placeholder-opacity-95'
  | 'md:placeholder-opacity-95'
  | 'mg:placeholder-opacity-95'
  | 'lg:placeholder-opacity-95'
  | 'xl:placeholder-opacity-95'
  | 'focus:placeholder-opacity-95'
  | 'sm:placeholder-opacity-100'
  | 'md:placeholder-opacity-100'
  | 'mg:placeholder-opacity-100'
  | 'lg:placeholder-opacity-100'
  | 'xl:placeholder-opacity-100'
  | 'focus:placeholder-opacity-100'
  | 'sm:pointer-events-none'
  | 'md:pointer-events-none'
  | 'mg:pointer-events-none'
  | 'lg:pointer-events-none'
  | 'xl:pointer-events-none'
  | 'sm:pointer-events-auto'
  | 'md:pointer-events-auto'
  | 'mg:pointer-events-auto'
  | 'lg:pointer-events-auto'
  | 'xl:pointer-events-auto'
  | 'sm:static'
  | 'md:static'
  | 'mg:static'
  | 'lg:static'
  | 'xl:static'
  | 'sm:fixed'
  | 'md:fixed'
  | 'mg:fixed'
  | 'lg:fixed'
  | 'xl:fixed'
  | 'sm:absolute'
  | 'md:absolute'
  | 'mg:absolute'
  | 'lg:absolute'
  | 'xl:absolute'
  | 'sm:relative'
  | 'md:relative'
  | 'mg:relative'
  | 'lg:relative'
  | 'xl:relative'
  | 'sm:sticky'
  | 'md:sticky'
  | 'mg:sticky'
  | 'lg:sticky'
  | 'xl:sticky'
  | 'sm:resize-none'
  | 'md:resize-none'
  | 'mg:resize-none'
  | 'lg:resize-none'
  | 'xl:resize-none'
  | 'sm:resize'
  | 'md:resize'
  | 'mg:resize'
  | 'lg:resize'
  | 'xl:resize'
  | 'sm:resize-y'
  | 'md:resize-y'
  | 'mg:resize-y'
  | 'lg:resize-y'
  | 'xl:resize-y'
  | 'sm:resize-x'
  | 'md:resize-x'
  | 'mg:resize-x'
  | 'lg:resize-x'
  | 'xl:resize-x'
  | 'sm:ring-transparent'
  | 'md:ring-transparent'
  | 'mg:ring-transparent'
  | 'lg:ring-transparent'
  | 'xl:ring-transparent'
  | 'focus-within:ring-transparent'
  | 'focus:ring-transparent'
  | 'sm:ring-current'
  | 'md:ring-current'
  | 'mg:ring-current'
  | 'lg:ring-current'
  | 'xl:ring-current'
  | 'focus-within:ring-current'
  | 'focus:ring-current'
  | 'sm:ring-overlay'
  | 'md:ring-overlay'
  | 'mg:ring-overlay'
  | 'lg:ring-overlay'
  | 'xl:ring-overlay'
  | 'focus-within:ring-overlay'
  | 'focus:ring-overlay'
  | 'sm:ring-black'
  | 'md:ring-black'
  | 'mg:ring-black'
  | 'lg:ring-black'
  | 'xl:ring-black'
  | 'focus-within:ring-black'
  | 'focus:ring-black'
  | 'sm:ring-white'
  | 'md:ring-white'
  | 'mg:ring-white'
  | 'lg:ring-white'
  | 'xl:ring-white'
  | 'focus-within:ring-white'
  | 'focus:ring-white'
  | 'sm:ring-product'
  | 'md:ring-product'
  | 'mg:ring-product'
  | 'lg:ring-product'
  | 'xl:ring-product'
  | 'focus-within:ring-product'
  | 'focus:ring-product'
  | 'sm:ring-product-hover'
  | 'md:ring-product-hover'
  | 'mg:ring-product-hover'
  | 'lg:ring-product-hover'
  | 'xl:ring-product-hover'
  | 'focus-within:ring-product-hover'
  | 'focus:ring-product-hover'
  | 'sm:ring-product-pressed'
  | 'md:ring-product-pressed'
  | 'mg:ring-product-pressed'
  | 'lg:ring-product-pressed'
  | 'xl:ring-product-pressed'
  | 'focus-within:ring-product-pressed'
  | 'focus:ring-product-pressed'
  | 'sm:ring-placeholder-acid'
  | 'md:ring-placeholder-acid'
  | 'mg:ring-placeholder-acid'
  | 'lg:ring-placeholder-acid'
  | 'xl:ring-placeholder-acid'
  | 'focus-within:ring-placeholder-acid'
  | 'focus:ring-placeholder-acid'
  | 'sm:ring-placeholder-aura'
  | 'md:ring-placeholder-aura'
  | 'mg:ring-placeholder-aura'
  | 'lg:ring-placeholder-aura'
  | 'xl:ring-placeholder-aura'
  | 'focus-within:ring-placeholder-aura'
  | 'focus:ring-placeholder-aura'
  | 'sm:ring-placeholder-azul'
  | 'md:ring-placeholder-azul'
  | 'mg:ring-placeholder-azul'
  | 'lg:ring-placeholder-azul'
  | 'xl:ring-placeholder-azul'
  | 'focus-within:ring-placeholder-azul'
  | 'focus:ring-placeholder-azul'
  | 'sm:ring-placeholder-blanch'
  | 'md:ring-placeholder-blanch'
  | 'mg:ring-placeholder-blanch'
  | 'lg:ring-placeholder-blanch'
  | 'xl:ring-placeholder-blanch'
  | 'focus-within:ring-placeholder-blanch'
  | 'focus:ring-placeholder-blanch'
  | 'sm:ring-placeholder-blue-salt'
  | 'md:ring-placeholder-blue-salt'
  | 'mg:ring-placeholder-blue-salt'
  | 'lg:ring-placeholder-blue-salt'
  | 'xl:ring-placeholder-blue-salt'
  | 'focus-within:ring-placeholder-blue-salt'
  | 'focus:ring-placeholder-blue-salt'
  | 'sm:ring-placeholder-burgundy'
  | 'md:ring-placeholder-burgundy'
  | 'mg:ring-placeholder-burgundy'
  | 'lg:ring-placeholder-burgundy'
  | 'xl:ring-placeholder-burgundy'
  | 'focus-within:ring-placeholder-burgundy'
  | 'focus:ring-placeholder-burgundy'
  | 'sm:ring-placeholder-butter-yellow'
  | 'md:ring-placeholder-butter-yellow'
  | 'mg:ring-placeholder-butter-yellow'
  | 'lg:ring-placeholder-butter-yellow'
  | 'xl:ring-placeholder-butter-yellow'
  | 'focus-within:ring-placeholder-butter-yellow'
  | 'focus:ring-placeholder-butter-yellow'
  | 'sm:ring-placeholder-chai'
  | 'md:ring-placeholder-chai'
  | 'mg:ring-placeholder-chai'
  | 'lg:ring-placeholder-chai'
  | 'xl:ring-placeholder-chai'
  | 'focus-within:ring-placeholder-chai'
  | 'focus:ring-placeholder-chai'
  | 'sm:ring-placeholder-char'
  | 'md:ring-placeholder-char'
  | 'mg:ring-placeholder-char'
  | 'lg:ring-placeholder-char'
  | 'xl:ring-placeholder-char'
  | 'focus-within:ring-placeholder-char'
  | 'focus:ring-placeholder-char'
  | 'sm:ring-placeholder-charm'
  | 'md:ring-placeholder-charm'
  | 'mg:ring-placeholder-charm'
  | 'lg:ring-placeholder-charm'
  | 'xl:ring-placeholder-charm'
  | 'focus-within:ring-placeholder-charm'
  | 'focus:ring-placeholder-charm'
  | 'sm:ring-placeholder-chickpea'
  | 'md:ring-placeholder-chickpea'
  | 'mg:ring-placeholder-chickpea'
  | 'lg:ring-placeholder-chickpea'
  | 'xl:ring-placeholder-chickpea'
  | 'focus-within:ring-placeholder-chickpea'
  | 'focus:ring-placeholder-chickpea'
  | 'sm:ring-placeholder-cielo'
  | 'md:ring-placeholder-cielo'
  | 'mg:ring-placeholder-cielo'
  | 'lg:ring-placeholder-cielo'
  | 'xl:ring-placeholder-cielo'
  | 'focus-within:ring-placeholder-cielo'
  | 'focus:ring-placeholder-cielo'
  | 'sm:ring-placeholder-clay'
  | 'md:ring-placeholder-clay'
  | 'mg:ring-placeholder-clay'
  | 'lg:ring-placeholder-clay'
  | 'xl:ring-placeholder-clay'
  | 'focus-within:ring-placeholder-clay'
  | 'focus:ring-placeholder-clay'
  | 'sm:ring-placeholder-clear'
  | 'md:ring-placeholder-clear'
  | 'mg:ring-placeholder-clear'
  | 'lg:ring-placeholder-clear'
  | 'xl:ring-placeholder-clear'
  | 'focus-within:ring-placeholder-clear'
  | 'focus:ring-placeholder-clear'
  | 'sm:ring-placeholder-coriander'
  | 'md:ring-placeholder-coriander'
  | 'mg:ring-placeholder-coriander'
  | 'lg:ring-placeholder-coriander'
  | 'xl:ring-placeholder-coriander'
  | 'focus-within:ring-placeholder-coriander'
  | 'focus:ring-placeholder-coriander'
  | 'sm:ring-placeholder-cream'
  | 'md:ring-placeholder-cream'
  | 'mg:ring-placeholder-cream'
  | 'lg:ring-placeholder-cream'
  | 'xl:ring-placeholder-cream'
  | 'focus-within:ring-placeholder-cream'
  | 'focus:ring-placeholder-cream'
  | 'sm:ring-placeholder-crescent'
  | 'md:ring-placeholder-crescent'
  | 'mg:ring-placeholder-crescent'
  | 'lg:ring-placeholder-crescent'
  | 'xl:ring-placeholder-crescent'
  | 'focus-within:ring-placeholder-crescent'
  | 'focus:ring-placeholder-crescent'
  | 'sm:ring-placeholder-dawn'
  | 'md:ring-placeholder-dawn'
  | 'mg:ring-placeholder-dawn'
  | 'lg:ring-placeholder-dawn'
  | 'xl:ring-placeholder-dawn'
  | 'focus-within:ring-placeholder-dawn'
  | 'focus:ring-placeholder-dawn'
  | 'sm:ring-placeholder-dusk'
  | 'md:ring-placeholder-dusk'
  | 'mg:ring-placeholder-dusk'
  | 'lg:ring-placeholder-dusk'
  | 'xl:ring-placeholder-dusk'
  | 'focus-within:ring-placeholder-dusk'
  | 'focus:ring-placeholder-dusk'
  | 'sm:ring-placeholder-egg-yolk'
  | 'md:ring-placeholder-egg-yolk'
  | 'mg:ring-placeholder-egg-yolk'
  | 'lg:ring-placeholder-egg-yolk'
  | 'xl:ring-placeholder-egg-yolk'
  | 'focus-within:ring-placeholder-egg-yolk'
  | 'focus:ring-placeholder-egg-yolk'
  | 'sm:ring-placeholder-espresso'
  | 'md:ring-placeholder-espresso'
  | 'mg:ring-placeholder-espresso'
  | 'lg:ring-placeholder-espresso'
  | 'xl:ring-placeholder-espresso'
  | 'focus-within:ring-placeholder-espresso'
  | 'focus:ring-placeholder-espresso'
  | 'sm:ring-placeholder-eve'
  | 'md:ring-placeholder-eve'
  | 'mg:ring-placeholder-eve'
  | 'lg:ring-placeholder-eve'
  | 'xl:ring-placeholder-eve'
  | 'focus-within:ring-placeholder-eve'
  | 'focus:ring-placeholder-eve'
  | 'sm:ring-placeholder-firecracker'
  | 'md:ring-placeholder-firecracker'
  | 'mg:ring-placeholder-firecracker'
  | 'lg:ring-placeholder-firecracker'
  | 'xl:ring-placeholder-firecracker'
  | 'focus-within:ring-placeholder-firecracker'
  | 'focus:ring-placeholder-firecracker'
  | 'sm:ring-placeholder-forget-me-not-blue'
  | 'md:ring-placeholder-forget-me-not-blue'
  | 'mg:ring-placeholder-forget-me-not-blue'
  | 'lg:ring-placeholder-forget-me-not-blue'
  | 'xl:ring-placeholder-forget-me-not-blue'
  | 'focus-within:ring-placeholder-forget-me-not-blue'
  | 'focus:ring-placeholder-forget-me-not-blue'
  | 'sm:ring-placeholder-gold'
  | 'md:ring-placeholder-gold'
  | 'mg:ring-placeholder-gold'
  | 'lg:ring-placeholder-gold'
  | 'xl:ring-placeholder-gold'
  | 'focus-within:ring-placeholder-gold'
  | 'focus:ring-placeholder-gold'
  | 'sm:ring-placeholder-golden'
  | 'md:ring-placeholder-golden'
  | 'mg:ring-placeholder-golden'
  | 'lg:ring-placeholder-golden'
  | 'xl:ring-placeholder-golden'
  | 'focus-within:ring-placeholder-golden'
  | 'focus:ring-placeholder-golden'
  | 'sm:ring-placeholder-heat'
  | 'md:ring-placeholder-heat'
  | 'mg:ring-placeholder-heat'
  | 'lg:ring-placeholder-heat'
  | 'xl:ring-placeholder-heat'
  | 'focus-within:ring-placeholder-heat'
  | 'focus:ring-placeholder-heat'
  | 'sm:ring-placeholder-himalayan-salt'
  | 'md:ring-placeholder-himalayan-salt'
  | 'mg:ring-placeholder-himalayan-salt'
  | 'lg:ring-placeholder-himalayan-salt'
  | 'xl:ring-placeholder-himalayan-salt'
  | 'focus-within:ring-placeholder-himalayan-salt'
  | 'focus:ring-placeholder-himalayan-salt'
  | 'sm:ring-placeholder-indigo'
  | 'md:ring-placeholder-indigo'
  | 'mg:ring-placeholder-indigo'
  | 'lg:ring-placeholder-indigo'
  | 'xl:ring-placeholder-indigo'
  | 'focus-within:ring-placeholder-indigo'
  | 'focus:ring-placeholder-indigo'
  | 'sm:ring-placeholder-lavender'
  | 'md:ring-placeholder-lavender'
  | 'mg:ring-placeholder-lavender'
  | 'lg:ring-placeholder-lavender'
  | 'xl:ring-placeholder-lavender'
  | 'focus-within:ring-placeholder-lavender'
  | 'focus:ring-placeholder-lavender'
  | 'sm:ring-placeholder-lavender-marble'
  | 'md:ring-placeholder-lavender-marble'
  | 'mg:ring-placeholder-lavender-marble'
  | 'lg:ring-placeholder-lavender-marble'
  | 'xl:ring-placeholder-lavender-marble'
  | 'focus-within:ring-placeholder-lavender-marble'
  | 'focus:ring-placeholder-lavender-marble'
  | 'sm:ring-placeholder-midnight-marble'
  | 'md:ring-placeholder-midnight-marble'
  | 'mg:ring-placeholder-midnight-marble'
  | 'lg:ring-placeholder-midnight-marble'
  | 'xl:ring-placeholder-midnight-marble'
  | 'focus-within:ring-placeholder-midnight-marble'
  | 'focus:ring-placeholder-midnight-marble'
  | 'sm:ring-placeholder-nougat'
  | 'md:ring-placeholder-nougat'
  | 'mg:ring-placeholder-nougat'
  | 'lg:ring-placeholder-nougat'
  | 'xl:ring-placeholder-nougat'
  | 'focus-within:ring-placeholder-nougat'
  | 'focus:ring-placeholder-nougat'
  | 'sm:ring-placeholder-pistachio'
  | 'md:ring-placeholder-pistachio'
  | 'mg:ring-placeholder-pistachio'
  | 'lg:ring-placeholder-pistachio'
  | 'xl:ring-placeholder-pistachio'
  | 'focus-within:ring-placeholder-pistachio'
  | 'focus:ring-placeholder-pistachio'
  | 'sm:ring-placeholder-rosa'
  | 'md:ring-placeholder-rosa'
  | 'mg:ring-placeholder-rosa'
  | 'lg:ring-placeholder-rosa'
  | 'xl:ring-placeholder-rosa'
  | 'focus-within:ring-placeholder-rosa'
  | 'focus:ring-placeholder-rosa'
  | 'sm:ring-placeholder-rose-gold'
  | 'md:ring-placeholder-rose-gold'
  | 'mg:ring-placeholder-rose-gold'
  | 'lg:ring-placeholder-rose-gold'
  | 'xl:ring-placeholder-rose-gold'
  | 'focus-within:ring-placeholder-rose-gold'
  | 'focus:ring-placeholder-rose-gold'
  | 'sm:ring-placeholder-rust'
  | 'md:ring-placeholder-rust'
  | 'mg:ring-placeholder-rust'
  | 'lg:ring-placeholder-rust'
  | 'xl:ring-placeholder-rust'
  | 'focus-within:ring-placeholder-rust'
  | 'focus:ring-placeholder-rust'
  | 'sm:ring-placeholder-saffron'
  | 'md:ring-placeholder-saffron'
  | 'mg:ring-placeholder-saffron'
  | 'lg:ring-placeholder-saffron'
  | 'xl:ring-placeholder-saffron'
  | 'focus-within:ring-placeholder-saffron'
  | 'focus:ring-placeholder-saffron'
  | 'sm:ring-placeholder-sage'
  | 'md:ring-placeholder-sage'
  | 'mg:ring-placeholder-sage'
  | 'lg:ring-placeholder-sage'
  | 'xl:ring-placeholder-sage'
  | 'focus-within:ring-placeholder-sage'
  | 'focus:ring-placeholder-sage'
  | 'sm:ring-placeholder-sear'
  | 'md:ring-placeholder-sear'
  | 'mg:ring-placeholder-sear'
  | 'lg:ring-placeholder-sear'
  | 'xl:ring-placeholder-sear'
  | 'focus-within:ring-placeholder-sear'
  | 'focus:ring-placeholder-sear'
  | 'sm:ring-placeholder-spice'
  | 'md:ring-placeholder-spice'
  | 'mg:ring-placeholder-spice'
  | 'lg:ring-placeholder-spice'
  | 'xl:ring-placeholder-spice'
  | 'focus-within:ring-placeholder-spice'
  | 'focus:ring-placeholder-spice'
  | 'sm:ring-placeholder-steam'
  | 'md:ring-placeholder-steam'
  | 'mg:ring-placeholder-steam'
  | 'lg:ring-placeholder-steam'
  | 'xl:ring-placeholder-steam'
  | 'focus-within:ring-placeholder-steam'
  | 'focus:ring-placeholder-steam'
  | 'sm:ring-placeholder-strawberry'
  | 'md:ring-placeholder-strawberry'
  | 'mg:ring-placeholder-strawberry'
  | 'lg:ring-placeholder-strawberry'
  | 'xl:ring-placeholder-strawberry'
  | 'focus-within:ring-placeholder-strawberry'
  | 'focus:ring-placeholder-strawberry'
  | 'sm:ring-placeholder-sunrise'
  | 'md:ring-placeholder-sunrise'
  | 'mg:ring-placeholder-sunrise'
  | 'lg:ring-placeholder-sunrise'
  | 'xl:ring-placeholder-sunrise'
  | 'focus-within:ring-placeholder-sunrise'
  | 'focus:ring-placeholder-sunrise'
  | 'sm:ring-placeholder-sunset'
  | 'md:ring-placeholder-sunset'
  | 'mg:ring-placeholder-sunset'
  | 'lg:ring-placeholder-sunset'
  | 'xl:ring-placeholder-sunset'
  | 'focus-within:ring-placeholder-sunset'
  | 'focus:ring-placeholder-sunset'
  | 'sm:ring-placeholder-sunset-marble'
  | 'md:ring-placeholder-sunset-marble'
  | 'mg:ring-placeholder-sunset-marble'
  | 'lg:ring-placeholder-sunset-marble'
  | 'xl:ring-placeholder-sunset-marble'
  | 'focus-within:ring-placeholder-sunset-marble'
  | 'focus:ring-placeholder-sunset-marble'
  | 'sm:ring-placeholder-terracotta'
  | 'md:ring-placeholder-terracotta'
  | 'mg:ring-placeholder-terracotta'
  | 'lg:ring-placeholder-terracotta'
  | 'xl:ring-placeholder-terracotta'
  | 'focus-within:ring-placeholder-terracotta'
  | 'focus:ring-placeholder-terracotta'
  | 'sm:ring-placeholder-tierra'
  | 'md:ring-placeholder-tierra'
  | 'mg:ring-placeholder-tierra'
  | 'lg:ring-placeholder-tierra'
  | 'xl:ring-placeholder-tierra'
  | 'focus-within:ring-placeholder-tierra'
  | 'focus:ring-placeholder-tierra'
  | 'sm:ring-placeholder-turmeric'
  | 'md:ring-placeholder-turmeric'
  | 'mg:ring-placeholder-turmeric'
  | 'lg:ring-placeholder-turmeric'
  | 'xl:ring-placeholder-turmeric'
  | 'focus-within:ring-placeholder-turmeric'
  | 'focus:ring-placeholder-turmeric'
  | 'sm:ring-placeholder-turqoise'
  | 'md:ring-placeholder-turqoise'
  | 'mg:ring-placeholder-turqoise'
  | 'lg:ring-placeholder-turqoise'
  | 'xl:ring-placeholder-turqoise'
  | 'focus-within:ring-placeholder-turqoise'
  | 'focus:ring-placeholder-turqoise'
  | 'sm:ring-placeholder-twilight'
  | 'md:ring-placeholder-twilight'
  | 'mg:ring-placeholder-twilight'
  | 'lg:ring-placeholder-twilight'
  | 'xl:ring-placeholder-twilight'
  | 'focus-within:ring-placeholder-twilight'
  | 'focus:ring-placeholder-twilight'
  | 'sm:ring-placeholder-walnut'
  | 'md:ring-placeholder-walnut'
  | 'mg:ring-placeholder-walnut'
  | 'lg:ring-placeholder-walnut'
  | 'xl:ring-placeholder-walnut'
  | 'focus-within:ring-placeholder-walnut'
  | 'focus:ring-placeholder-walnut'
  | 'sm:ring-placeholder-warm-white'
  | 'md:ring-placeholder-warm-white'
  | 'mg:ring-placeholder-warm-white'
  | 'lg:ring-placeholder-warm-white'
  | 'xl:ring-placeholder-warm-white'
  | 'focus-within:ring-placeholder-warm-white'
  | 'focus:ring-placeholder-warm-white'
  | 'sm:ring-placeholder-zest'
  | 'md:ring-placeholder-zest'
  | 'mg:ring-placeholder-zest'
  | 'lg:ring-placeholder-zest'
  | 'xl:ring-placeholder-zest'
  | 'focus-within:ring-placeholder-zest'
  | 'focus:ring-placeholder-zest'
  | 'sm:ring-interactive'
  | 'md:ring-interactive'
  | 'mg:ring-interactive'
  | 'lg:ring-interactive'
  | 'xl:ring-interactive'
  | 'focus-within:ring-interactive'
  | 'focus:ring-interactive'
  | 'sm:ring-translucent-bone'
  | 'md:ring-translucent-bone'
  | 'mg:ring-translucent-bone'
  | 'lg:ring-translucent-bone'
  | 'xl:ring-translucent-bone'
  | 'focus-within:ring-translucent-bone'
  | 'focus:ring-translucent-bone'
  | 'sm:ring-translucent-brick'
  | 'md:ring-translucent-brick'
  | 'mg:ring-translucent-brick'
  | 'lg:ring-translucent-brick'
  | 'xl:ring-translucent-brick'
  | 'focus-within:ring-translucent-brick'
  | 'focus:ring-translucent-brick'
  | 'sm:ring-translucent-char'
  | 'md:ring-translucent-char'
  | 'mg:ring-translucent-char'
  | 'lg:ring-translucent-char'
  | 'xl:ring-translucent-char'
  | 'focus-within:ring-translucent-char'
  | 'focus:ring-translucent-char'
  | 'sm:ring-translucent-white'
  | 'md:ring-translucent-white'
  | 'mg:ring-translucent-white'
  | 'lg:ring-translucent-white'
  | 'xl:ring-translucent-white'
  | 'focus-within:ring-translucent-white'
  | 'focus:ring-translucent-white'
  | 'sm:ring-translucent-disabled'
  | 'md:ring-translucent-disabled'
  | 'mg:ring-translucent-disabled'
  | 'lg:ring-translucent-disabled'
  | 'xl:ring-translucent-disabled'
  | 'focus-within:ring-translucent-disabled'
  | 'focus:ring-translucent-disabled'
  | 'sm:ring-translucent-error'
  | 'md:ring-translucent-error'
  | 'mg:ring-translucent-error'
  | 'lg:ring-translucent-error'
  | 'xl:ring-translucent-error'
  | 'focus-within:ring-translucent-error'
  | 'focus:ring-translucent-error'
  | 'sm:ring-translucent-outline'
  | 'md:ring-translucent-outline'
  | 'mg:ring-translucent-outline'
  | 'lg:ring-translucent-outline'
  | 'xl:ring-translucent-outline'
  | 'focus-within:ring-translucent-outline'
  | 'focus:ring-translucent-outline'
  | 'sm:ring-char-char'
  | 'md:ring-char-char'
  | 'mg:ring-char-char'
  | 'lg:ring-char-char'
  | 'xl:ring-char-char'
  | 'focus-within:ring-char-char'
  | 'focus:ring-char-char'
  | 'sm:ring-char-white'
  | 'md:ring-char-white'
  | 'mg:ring-char-white'
  | 'lg:ring-char-white'
  | 'xl:ring-char-white'
  | 'focus-within:ring-char-white'
  | 'focus:ring-char-white'
  | 'sm:ring-bone-50'
  | 'md:ring-bone-50'
  | 'mg:ring-bone-50'
  | 'lg:ring-bone-50'
  | 'xl:ring-bone-50'
  | 'focus-within:ring-bone-50'
  | 'focus:ring-bone-50'
  | 'sm:ring-bone-100'
  | 'md:ring-bone-100'
  | 'mg:ring-bone-100'
  | 'lg:ring-bone-100'
  | 'xl:ring-bone-100'
  | 'focus-within:ring-bone-100'
  | 'focus:ring-bone-100'
  | 'sm:ring-bone-200'
  | 'md:ring-bone-200'
  | 'mg:ring-bone-200'
  | 'lg:ring-bone-200'
  | 'xl:ring-bone-200'
  | 'focus-within:ring-bone-200'
  | 'focus:ring-bone-200'
  | 'sm:ring-bone-300'
  | 'md:ring-bone-300'
  | 'mg:ring-bone-300'
  | 'lg:ring-bone-300'
  | 'xl:ring-bone-300'
  | 'focus-within:ring-bone-300'
  | 'focus:ring-bone-300'
  | 'sm:ring-bone-400'
  | 'md:ring-bone-400'
  | 'mg:ring-bone-400'
  | 'lg:ring-bone-400'
  | 'xl:ring-bone-400'
  | 'focus-within:ring-bone-400'
  | 'focus:ring-bone-400'
  | 'sm:ring-bone-500'
  | 'md:ring-bone-500'
  | 'mg:ring-bone-500'
  | 'lg:ring-bone-500'
  | 'xl:ring-bone-500'
  | 'focus-within:ring-bone-500'
  | 'focus:ring-bone-500'
  | 'sm:ring-bone-600'
  | 'md:ring-bone-600'
  | 'mg:ring-bone-600'
  | 'lg:ring-bone-600'
  | 'xl:ring-bone-600'
  | 'focus-within:ring-bone-600'
  | 'focus:ring-bone-600'
  | 'sm:ring-bone-700'
  | 'md:ring-bone-700'
  | 'mg:ring-bone-700'
  | 'lg:ring-bone-700'
  | 'xl:ring-bone-700'
  | 'focus-within:ring-bone-700'
  | 'focus:ring-bone-700'
  | 'sm:ring-bone-800'
  | 'md:ring-bone-800'
  | 'mg:ring-bone-800'
  | 'lg:ring-bone-800'
  | 'xl:ring-bone-800'
  | 'focus-within:ring-bone-800'
  | 'focus:ring-bone-800'
  | 'sm:ring-bone-900'
  | 'md:ring-bone-900'
  | 'mg:ring-bone-900'
  | 'lg:ring-bone-900'
  | 'xl:ring-bone-900'
  | 'focus-within:ring-bone-900'
  | 'focus:ring-bone-900'
  | 'sm:ring-brick-50'
  | 'md:ring-brick-50'
  | 'mg:ring-brick-50'
  | 'lg:ring-brick-50'
  | 'xl:ring-brick-50'
  | 'focus-within:ring-brick-50'
  | 'focus:ring-brick-50'
  | 'sm:ring-brick-100'
  | 'md:ring-brick-100'
  | 'mg:ring-brick-100'
  | 'lg:ring-brick-100'
  | 'xl:ring-brick-100'
  | 'focus-within:ring-brick-100'
  | 'focus:ring-brick-100'
  | 'sm:ring-brick-200'
  | 'md:ring-brick-200'
  | 'mg:ring-brick-200'
  | 'lg:ring-brick-200'
  | 'xl:ring-brick-200'
  | 'focus-within:ring-brick-200'
  | 'focus:ring-brick-200'
  | 'sm:ring-brick-300'
  | 'md:ring-brick-300'
  | 'mg:ring-brick-300'
  | 'lg:ring-brick-300'
  | 'xl:ring-brick-300'
  | 'focus-within:ring-brick-300'
  | 'focus:ring-brick-300'
  | 'sm:ring-brick-400'
  | 'md:ring-brick-400'
  | 'mg:ring-brick-400'
  | 'lg:ring-brick-400'
  | 'xl:ring-brick-400'
  | 'focus-within:ring-brick-400'
  | 'focus:ring-brick-400'
  | 'sm:ring-brick-500'
  | 'md:ring-brick-500'
  | 'mg:ring-brick-500'
  | 'lg:ring-brick-500'
  | 'xl:ring-brick-500'
  | 'focus-within:ring-brick-500'
  | 'focus:ring-brick-500'
  | 'sm:ring-brick-600'
  | 'md:ring-brick-600'
  | 'mg:ring-brick-600'
  | 'lg:ring-brick-600'
  | 'xl:ring-brick-600'
  | 'focus-within:ring-brick-600'
  | 'focus:ring-brick-600'
  | 'sm:ring-brick-700'
  | 'md:ring-brick-700'
  | 'mg:ring-brick-700'
  | 'lg:ring-brick-700'
  | 'xl:ring-brick-700'
  | 'focus-within:ring-brick-700'
  | 'focus:ring-brick-700'
  | 'sm:ring-brick-800'
  | 'md:ring-brick-800'
  | 'mg:ring-brick-800'
  | 'lg:ring-brick-800'
  | 'xl:ring-brick-800'
  | 'focus-within:ring-brick-800'
  | 'focus:ring-brick-800'
  | 'sm:ring-brick-900'
  | 'md:ring-brick-900'
  | 'mg:ring-brick-900'
  | 'lg:ring-brick-900'
  | 'xl:ring-brick-900'
  | 'focus-within:ring-brick-900'
  | 'focus:ring-brick-900'
  | 'sm:ring-sage-50'
  | 'md:ring-sage-50'
  | 'mg:ring-sage-50'
  | 'lg:ring-sage-50'
  | 'xl:ring-sage-50'
  | 'focus-within:ring-sage-50'
  | 'focus:ring-sage-50'
  | 'sm:ring-sage-300'
  | 'md:ring-sage-300'
  | 'mg:ring-sage-300'
  | 'lg:ring-sage-300'
  | 'xl:ring-sage-300'
  | 'focus-within:ring-sage-300'
  | 'focus:ring-sage-300'
  | 'sm:ring-sage-500'
  | 'md:ring-sage-500'
  | 'mg:ring-sage-500'
  | 'lg:ring-sage-500'
  | 'xl:ring-sage-500'
  | 'focus-within:ring-sage-500'
  | 'focus:ring-sage-500'
  | 'sm:ring-sage-700'
  | 'md:ring-sage-700'
  | 'mg:ring-sage-700'
  | 'lg:ring-sage-700'
  | 'xl:ring-sage-700'
  | 'focus-within:ring-sage-700'
  | 'focus:ring-sage-700'
  | 'sm:ring-sage-900'
  | 'md:ring-sage-900'
  | 'mg:ring-sage-900'
  | 'lg:ring-sage-900'
  | 'xl:ring-sage-900'
  | 'focus-within:ring-sage-900'
  | 'focus:ring-sage-900'
  | 'sm:ring-blue-50'
  | 'md:ring-blue-50'
  | 'mg:ring-blue-50'
  | 'lg:ring-blue-50'
  | 'xl:ring-blue-50'
  | 'focus-within:ring-blue-50'
  | 'focus:ring-blue-50'
  | 'sm:ring-blue-300'
  | 'md:ring-blue-300'
  | 'mg:ring-blue-300'
  | 'lg:ring-blue-300'
  | 'xl:ring-blue-300'
  | 'focus-within:ring-blue-300'
  | 'focus:ring-blue-300'
  | 'sm:ring-blue-500'
  | 'md:ring-blue-500'
  | 'mg:ring-blue-500'
  | 'lg:ring-blue-500'
  | 'xl:ring-blue-500'
  | 'focus-within:ring-blue-500'
  | 'focus:ring-blue-500'
  | 'sm:ring-blue-700'
  | 'md:ring-blue-700'
  | 'mg:ring-blue-700'
  | 'lg:ring-blue-700'
  | 'xl:ring-blue-700'
  | 'focus-within:ring-blue-700'
  | 'focus:ring-blue-700'
  | 'sm:ring-blue-900'
  | 'md:ring-blue-900'
  | 'mg:ring-blue-900'
  | 'lg:ring-blue-900'
  | 'xl:ring-blue-900'
  | 'focus-within:ring-blue-900'
  | 'focus:ring-blue-900'
  | 'sm:ring-misc-50'
  | 'md:ring-misc-50'
  | 'mg:ring-misc-50'
  | 'lg:ring-misc-50'
  | 'xl:ring-misc-50'
  | 'focus-within:ring-misc-50'
  | 'focus:ring-misc-50'
  | 'sm:ring-misc-300'
  | 'md:ring-misc-300'
  | 'mg:ring-misc-300'
  | 'lg:ring-misc-300'
  | 'xl:ring-misc-300'
  | 'focus-within:ring-misc-300'
  | 'focus:ring-misc-300'
  | 'sm:ring-misc-500'
  | 'md:ring-misc-500'
  | 'mg:ring-misc-500'
  | 'lg:ring-misc-500'
  | 'xl:ring-misc-500'
  | 'focus-within:ring-misc-500'
  | 'focus:ring-misc-500'
  | 'sm:ring-misc-700'
  | 'md:ring-misc-700'
  | 'mg:ring-misc-700'
  | 'lg:ring-misc-700'
  | 'xl:ring-misc-700'
  | 'focus-within:ring-misc-700'
  | 'focus:ring-misc-700'
  | 'sm:ring-misc-900'
  | 'md:ring-misc-900'
  | 'mg:ring-misc-900'
  | 'lg:ring-misc-900'
  | 'xl:ring-misc-900'
  | 'focus-within:ring-misc-900'
  | 'focus:ring-misc-900'
  | 'sm:ring-offset-transparent'
  | 'md:ring-offset-transparent'
  | 'mg:ring-offset-transparent'
  | 'lg:ring-offset-transparent'
  | 'xl:ring-offset-transparent'
  | 'focus-within:ring-offset-transparent'
  | 'focus:ring-offset-transparent'
  | 'sm:ring-offset-current'
  | 'md:ring-offset-current'
  | 'mg:ring-offset-current'
  | 'lg:ring-offset-current'
  | 'xl:ring-offset-current'
  | 'focus-within:ring-offset-current'
  | 'focus:ring-offset-current'
  | 'sm:ring-offset-overlay'
  | 'md:ring-offset-overlay'
  | 'mg:ring-offset-overlay'
  | 'lg:ring-offset-overlay'
  | 'xl:ring-offset-overlay'
  | 'focus-within:ring-offset-overlay'
  | 'focus:ring-offset-overlay'
  | 'sm:ring-offset-black'
  | 'md:ring-offset-black'
  | 'mg:ring-offset-black'
  | 'lg:ring-offset-black'
  | 'xl:ring-offset-black'
  | 'focus-within:ring-offset-black'
  | 'focus:ring-offset-black'
  | 'sm:ring-offset-white'
  | 'md:ring-offset-white'
  | 'mg:ring-offset-white'
  | 'lg:ring-offset-white'
  | 'xl:ring-offset-white'
  | 'focus-within:ring-offset-white'
  | 'focus:ring-offset-white'
  | 'sm:ring-offset-white-hover'
  | 'md:ring-offset-white-hover'
  | 'mg:ring-offset-white-hover'
  | 'lg:ring-offset-white-hover'
  | 'xl:ring-offset-white-hover'
  | 'focus-within:ring-offset-white-hover'
  | 'focus:ring-offset-white-hover'
  | 'sm:ring-offset-white-pressed'
  | 'md:ring-offset-white-pressed'
  | 'mg:ring-offset-white-pressed'
  | 'lg:ring-offset-white-pressed'
  | 'xl:ring-offset-white-pressed'
  | 'focus-within:ring-offset-white-pressed'
  | 'focus:ring-offset-white-pressed'
  | 'sm:ring-offset-product-acid'
  | 'md:ring-offset-product-acid'
  | 'mg:ring-offset-product-acid'
  | 'lg:ring-offset-product-acid'
  | 'xl:ring-offset-product-acid'
  | 'focus-within:ring-offset-product-acid'
  | 'focus:ring-offset-product-acid'
  | 'sm:ring-offset-product-aura'
  | 'md:ring-offset-product-aura'
  | 'mg:ring-offset-product-aura'
  | 'lg:ring-offset-product-aura'
  | 'xl:ring-offset-product-aura'
  | 'focus-within:ring-offset-product-aura'
  | 'focus:ring-offset-product-aura'
  | 'sm:ring-offset-product-azul'
  | 'md:ring-offset-product-azul'
  | 'mg:ring-offset-product-azul'
  | 'lg:ring-offset-product-azul'
  | 'xl:ring-offset-product-azul'
  | 'focus-within:ring-offset-product-azul'
  | 'focus:ring-offset-product-azul'
  | 'sm:ring-offset-product-blanch'
  | 'md:ring-offset-product-blanch'
  | 'mg:ring-offset-product-blanch'
  | 'lg:ring-offset-product-blanch'
  | 'xl:ring-offset-product-blanch'
  | 'focus-within:ring-offset-product-blanch'
  | 'focus:ring-offset-product-blanch'
  | 'sm:ring-offset-product-blue-salt'
  | 'md:ring-offset-product-blue-salt'
  | 'mg:ring-offset-product-blue-salt'
  | 'lg:ring-offset-product-blue-salt'
  | 'xl:ring-offset-product-blue-salt'
  | 'focus-within:ring-offset-product-blue-salt'
  | 'focus:ring-offset-product-blue-salt'
  | 'sm:ring-offset-product-burgundy'
  | 'md:ring-offset-product-burgundy'
  | 'mg:ring-offset-product-burgundy'
  | 'lg:ring-offset-product-burgundy'
  | 'xl:ring-offset-product-burgundy'
  | 'focus-within:ring-offset-product-burgundy'
  | 'focus:ring-offset-product-burgundy'
  | 'sm:ring-offset-product-butter-yellow'
  | 'md:ring-offset-product-butter-yellow'
  | 'mg:ring-offset-product-butter-yellow'
  | 'lg:ring-offset-product-butter-yellow'
  | 'xl:ring-offset-product-butter-yellow'
  | 'focus-within:ring-offset-product-butter-yellow'
  | 'focus:ring-offset-product-butter-yellow'
  | 'sm:ring-offset-product-chai'
  | 'md:ring-offset-product-chai'
  | 'mg:ring-offset-product-chai'
  | 'lg:ring-offset-product-chai'
  | 'xl:ring-offset-product-chai'
  | 'focus-within:ring-offset-product-chai'
  | 'focus:ring-offset-product-chai'
  | 'sm:ring-offset-product-char'
  | 'md:ring-offset-product-char'
  | 'mg:ring-offset-product-char'
  | 'lg:ring-offset-product-char'
  | 'xl:ring-offset-product-char'
  | 'focus-within:ring-offset-product-char'
  | 'focus:ring-offset-product-char'
  | 'sm:ring-offset-product-charm'
  | 'md:ring-offset-product-charm'
  | 'mg:ring-offset-product-charm'
  | 'lg:ring-offset-product-charm'
  | 'xl:ring-offset-product-charm'
  | 'focus-within:ring-offset-product-charm'
  | 'focus:ring-offset-product-charm'
  | 'sm:ring-offset-product-chickpea'
  | 'md:ring-offset-product-chickpea'
  | 'mg:ring-offset-product-chickpea'
  | 'lg:ring-offset-product-chickpea'
  | 'xl:ring-offset-product-chickpea'
  | 'focus-within:ring-offset-product-chickpea'
  | 'focus:ring-offset-product-chickpea'
  | 'sm:ring-offset-product-cielo'
  | 'md:ring-offset-product-cielo'
  | 'mg:ring-offset-product-cielo'
  | 'lg:ring-offset-product-cielo'
  | 'xl:ring-offset-product-cielo'
  | 'focus-within:ring-offset-product-cielo'
  | 'focus:ring-offset-product-cielo'
  | 'sm:ring-offset-product-clay'
  | 'md:ring-offset-product-clay'
  | 'mg:ring-offset-product-clay'
  | 'lg:ring-offset-product-clay'
  | 'xl:ring-offset-product-clay'
  | 'focus-within:ring-offset-product-clay'
  | 'focus:ring-offset-product-clay'
  | 'sm:ring-offset-product-clear'
  | 'md:ring-offset-product-clear'
  | 'mg:ring-offset-product-clear'
  | 'lg:ring-offset-product-clear'
  | 'xl:ring-offset-product-clear'
  | 'focus-within:ring-offset-product-clear'
  | 'focus:ring-offset-product-clear'
  | 'sm:ring-offset-product-coriander'
  | 'md:ring-offset-product-coriander'
  | 'mg:ring-offset-product-coriander'
  | 'lg:ring-offset-product-coriander'
  | 'xl:ring-offset-product-coriander'
  | 'focus-within:ring-offset-product-coriander'
  | 'focus:ring-offset-product-coriander'
  | 'sm:ring-offset-product-cream'
  | 'md:ring-offset-product-cream'
  | 'mg:ring-offset-product-cream'
  | 'lg:ring-offset-product-cream'
  | 'xl:ring-offset-product-cream'
  | 'focus-within:ring-offset-product-cream'
  | 'focus:ring-offset-product-cream'
  | 'sm:ring-offset-product-crescent'
  | 'md:ring-offset-product-crescent'
  | 'mg:ring-offset-product-crescent'
  | 'lg:ring-offset-product-crescent'
  | 'xl:ring-offset-product-crescent'
  | 'focus-within:ring-offset-product-crescent'
  | 'focus:ring-offset-product-crescent'
  | 'sm:ring-offset-product-dawn'
  | 'md:ring-offset-product-dawn'
  | 'mg:ring-offset-product-dawn'
  | 'lg:ring-offset-product-dawn'
  | 'xl:ring-offset-product-dawn'
  | 'focus-within:ring-offset-product-dawn'
  | 'focus:ring-offset-product-dawn'
  | 'sm:ring-offset-product-dusk'
  | 'md:ring-offset-product-dusk'
  | 'mg:ring-offset-product-dusk'
  | 'lg:ring-offset-product-dusk'
  | 'xl:ring-offset-product-dusk'
  | 'focus-within:ring-offset-product-dusk'
  | 'focus:ring-offset-product-dusk'
  | 'sm:ring-offset-product-egg-yolk'
  | 'md:ring-offset-product-egg-yolk'
  | 'mg:ring-offset-product-egg-yolk'
  | 'lg:ring-offset-product-egg-yolk'
  | 'xl:ring-offset-product-egg-yolk'
  | 'focus-within:ring-offset-product-egg-yolk'
  | 'focus:ring-offset-product-egg-yolk'
  | 'sm:ring-offset-product-espresso'
  | 'md:ring-offset-product-espresso'
  | 'mg:ring-offset-product-espresso'
  | 'lg:ring-offset-product-espresso'
  | 'xl:ring-offset-product-espresso'
  | 'focus-within:ring-offset-product-espresso'
  | 'focus:ring-offset-product-espresso'
  | 'sm:ring-offset-product-eve'
  | 'md:ring-offset-product-eve'
  | 'mg:ring-offset-product-eve'
  | 'lg:ring-offset-product-eve'
  | 'xl:ring-offset-product-eve'
  | 'focus-within:ring-offset-product-eve'
  | 'focus:ring-offset-product-eve'
  | 'sm:ring-offset-product-firecracker'
  | 'md:ring-offset-product-firecracker'
  | 'mg:ring-offset-product-firecracker'
  | 'lg:ring-offset-product-firecracker'
  | 'xl:ring-offset-product-firecracker'
  | 'focus-within:ring-offset-product-firecracker'
  | 'focus:ring-offset-product-firecracker'
  | 'sm:ring-offset-product-forget-me-not-blue'
  | 'md:ring-offset-product-forget-me-not-blue'
  | 'mg:ring-offset-product-forget-me-not-blue'
  | 'lg:ring-offset-product-forget-me-not-blue'
  | 'xl:ring-offset-product-forget-me-not-blue'
  | 'focus-within:ring-offset-product-forget-me-not-blue'
  | 'focus:ring-offset-product-forget-me-not-blue'
  | 'sm:ring-offset-product-gold'
  | 'md:ring-offset-product-gold'
  | 'mg:ring-offset-product-gold'
  | 'lg:ring-offset-product-gold'
  | 'xl:ring-offset-product-gold'
  | 'focus-within:ring-offset-product-gold'
  | 'focus:ring-offset-product-gold'
  | 'sm:ring-offset-product-golden'
  | 'md:ring-offset-product-golden'
  | 'mg:ring-offset-product-golden'
  | 'lg:ring-offset-product-golden'
  | 'xl:ring-offset-product-golden'
  | 'focus-within:ring-offset-product-golden'
  | 'focus:ring-offset-product-golden'
  | 'sm:ring-offset-product-heat'
  | 'md:ring-offset-product-heat'
  | 'mg:ring-offset-product-heat'
  | 'lg:ring-offset-product-heat'
  | 'xl:ring-offset-product-heat'
  | 'focus-within:ring-offset-product-heat'
  | 'focus:ring-offset-product-heat'
  | 'sm:ring-offset-product-himalayan-salt'
  | 'md:ring-offset-product-himalayan-salt'
  | 'mg:ring-offset-product-himalayan-salt'
  | 'lg:ring-offset-product-himalayan-salt'
  | 'xl:ring-offset-product-himalayan-salt'
  | 'focus-within:ring-offset-product-himalayan-salt'
  | 'focus:ring-offset-product-himalayan-salt'
  | 'sm:ring-offset-product-indigo'
  | 'md:ring-offset-product-indigo'
  | 'mg:ring-offset-product-indigo'
  | 'lg:ring-offset-product-indigo'
  | 'xl:ring-offset-product-indigo'
  | 'focus-within:ring-offset-product-indigo'
  | 'focus:ring-offset-product-indigo'
  | 'sm:ring-offset-product-lavender'
  | 'md:ring-offset-product-lavender'
  | 'mg:ring-offset-product-lavender'
  | 'lg:ring-offset-product-lavender'
  | 'xl:ring-offset-product-lavender'
  | 'focus-within:ring-offset-product-lavender'
  | 'focus:ring-offset-product-lavender'
  | 'sm:ring-offset-product-lavender-marble'
  | 'md:ring-offset-product-lavender-marble'
  | 'mg:ring-offset-product-lavender-marble'
  | 'lg:ring-offset-product-lavender-marble'
  | 'xl:ring-offset-product-lavender-marble'
  | 'focus-within:ring-offset-product-lavender-marble'
  | 'focus:ring-offset-product-lavender-marble'
  | 'sm:ring-offset-product-midnight-marble'
  | 'md:ring-offset-product-midnight-marble'
  | 'mg:ring-offset-product-midnight-marble'
  | 'lg:ring-offset-product-midnight-marble'
  | 'xl:ring-offset-product-midnight-marble'
  | 'focus-within:ring-offset-product-midnight-marble'
  | 'focus:ring-offset-product-midnight-marble'
  | 'sm:ring-offset-product-nougat'
  | 'md:ring-offset-product-nougat'
  | 'mg:ring-offset-product-nougat'
  | 'lg:ring-offset-product-nougat'
  | 'xl:ring-offset-product-nougat'
  | 'focus-within:ring-offset-product-nougat'
  | 'focus:ring-offset-product-nougat'
  | 'sm:ring-offset-product-pistachio'
  | 'md:ring-offset-product-pistachio'
  | 'mg:ring-offset-product-pistachio'
  | 'lg:ring-offset-product-pistachio'
  | 'xl:ring-offset-product-pistachio'
  | 'focus-within:ring-offset-product-pistachio'
  | 'focus:ring-offset-product-pistachio'
  | 'sm:ring-offset-product-rosa'
  | 'md:ring-offset-product-rosa'
  | 'mg:ring-offset-product-rosa'
  | 'lg:ring-offset-product-rosa'
  | 'xl:ring-offset-product-rosa'
  | 'focus-within:ring-offset-product-rosa'
  | 'focus:ring-offset-product-rosa'
  | 'sm:ring-offset-product-rose-gold'
  | 'md:ring-offset-product-rose-gold'
  | 'mg:ring-offset-product-rose-gold'
  | 'lg:ring-offset-product-rose-gold'
  | 'xl:ring-offset-product-rose-gold'
  | 'focus-within:ring-offset-product-rose-gold'
  | 'focus:ring-offset-product-rose-gold'
  | 'sm:ring-offset-product-rust'
  | 'md:ring-offset-product-rust'
  | 'mg:ring-offset-product-rust'
  | 'lg:ring-offset-product-rust'
  | 'xl:ring-offset-product-rust'
  | 'focus-within:ring-offset-product-rust'
  | 'focus:ring-offset-product-rust'
  | 'sm:ring-offset-product-saffron'
  | 'md:ring-offset-product-saffron'
  | 'mg:ring-offset-product-saffron'
  | 'lg:ring-offset-product-saffron'
  | 'xl:ring-offset-product-saffron'
  | 'focus-within:ring-offset-product-saffron'
  | 'focus:ring-offset-product-saffron'
  | 'sm:ring-offset-product-sage'
  | 'md:ring-offset-product-sage'
  | 'mg:ring-offset-product-sage'
  | 'lg:ring-offset-product-sage'
  | 'xl:ring-offset-product-sage'
  | 'focus-within:ring-offset-product-sage'
  | 'focus:ring-offset-product-sage'
  | 'sm:ring-offset-product-sear'
  | 'md:ring-offset-product-sear'
  | 'mg:ring-offset-product-sear'
  | 'lg:ring-offset-product-sear'
  | 'xl:ring-offset-product-sear'
  | 'focus-within:ring-offset-product-sear'
  | 'focus:ring-offset-product-sear'
  | 'sm:ring-offset-product-spice'
  | 'md:ring-offset-product-spice'
  | 'mg:ring-offset-product-spice'
  | 'lg:ring-offset-product-spice'
  | 'xl:ring-offset-product-spice'
  | 'focus-within:ring-offset-product-spice'
  | 'focus:ring-offset-product-spice'
  | 'sm:ring-offset-product-steam'
  | 'md:ring-offset-product-steam'
  | 'mg:ring-offset-product-steam'
  | 'lg:ring-offset-product-steam'
  | 'xl:ring-offset-product-steam'
  | 'focus-within:ring-offset-product-steam'
  | 'focus:ring-offset-product-steam'
  | 'sm:ring-offset-product-strawberry'
  | 'md:ring-offset-product-strawberry'
  | 'mg:ring-offset-product-strawberry'
  | 'lg:ring-offset-product-strawberry'
  | 'xl:ring-offset-product-strawberry'
  | 'focus-within:ring-offset-product-strawberry'
  | 'focus:ring-offset-product-strawberry'
  | 'sm:ring-offset-product-sunrise'
  | 'md:ring-offset-product-sunrise'
  | 'mg:ring-offset-product-sunrise'
  | 'lg:ring-offset-product-sunrise'
  | 'xl:ring-offset-product-sunrise'
  | 'focus-within:ring-offset-product-sunrise'
  | 'focus:ring-offset-product-sunrise'
  | 'sm:ring-offset-product-sunset'
  | 'md:ring-offset-product-sunset'
  | 'mg:ring-offset-product-sunset'
  | 'lg:ring-offset-product-sunset'
  | 'xl:ring-offset-product-sunset'
  | 'focus-within:ring-offset-product-sunset'
  | 'focus:ring-offset-product-sunset'
  | 'sm:ring-offset-product-sunset-marble'
  | 'md:ring-offset-product-sunset-marble'
  | 'mg:ring-offset-product-sunset-marble'
  | 'lg:ring-offset-product-sunset-marble'
  | 'xl:ring-offset-product-sunset-marble'
  | 'focus-within:ring-offset-product-sunset-marble'
  | 'focus:ring-offset-product-sunset-marble'
  | 'sm:ring-offset-product-terracotta'
  | 'md:ring-offset-product-terracotta'
  | 'mg:ring-offset-product-terracotta'
  | 'lg:ring-offset-product-terracotta'
  | 'xl:ring-offset-product-terracotta'
  | 'focus-within:ring-offset-product-terracotta'
  | 'focus:ring-offset-product-terracotta'
  | 'sm:ring-offset-product-tierra'
  | 'md:ring-offset-product-tierra'
  | 'mg:ring-offset-product-tierra'
  | 'lg:ring-offset-product-tierra'
  | 'xl:ring-offset-product-tierra'
  | 'focus-within:ring-offset-product-tierra'
  | 'focus:ring-offset-product-tierra'
  | 'sm:ring-offset-product-turmeric'
  | 'md:ring-offset-product-turmeric'
  | 'mg:ring-offset-product-turmeric'
  | 'lg:ring-offset-product-turmeric'
  | 'xl:ring-offset-product-turmeric'
  | 'focus-within:ring-offset-product-turmeric'
  | 'focus:ring-offset-product-turmeric'
  | 'sm:ring-offset-product-turqoise'
  | 'md:ring-offset-product-turqoise'
  | 'mg:ring-offset-product-turqoise'
  | 'lg:ring-offset-product-turqoise'
  | 'xl:ring-offset-product-turqoise'
  | 'focus-within:ring-offset-product-turqoise'
  | 'focus:ring-offset-product-turqoise'
  | 'sm:ring-offset-product-twilight'
  | 'md:ring-offset-product-twilight'
  | 'mg:ring-offset-product-twilight'
  | 'lg:ring-offset-product-twilight'
  | 'xl:ring-offset-product-twilight'
  | 'focus-within:ring-offset-product-twilight'
  | 'focus:ring-offset-product-twilight'
  | 'sm:ring-offset-product-walnut'
  | 'md:ring-offset-product-walnut'
  | 'mg:ring-offset-product-walnut'
  | 'lg:ring-offset-product-walnut'
  | 'xl:ring-offset-product-walnut'
  | 'focus-within:ring-offset-product-walnut'
  | 'focus:ring-offset-product-walnut'
  | 'sm:ring-offset-product-warm-white'
  | 'md:ring-offset-product-warm-white'
  | 'mg:ring-offset-product-warm-white'
  | 'lg:ring-offset-product-warm-white'
  | 'xl:ring-offset-product-warm-white'
  | 'focus-within:ring-offset-product-warm-white'
  | 'focus:ring-offset-product-warm-white'
  | 'sm:ring-offset-product-zest'
  | 'md:ring-offset-product-zest'
  | 'mg:ring-offset-product-zest'
  | 'lg:ring-offset-product-zest'
  | 'xl:ring-offset-product-zest'
  | 'focus-within:ring-offset-product-zest'
  | 'focus:ring-offset-product-zest'
  | 'sm:ring-offset-placeholder'
  | 'md:ring-offset-placeholder'
  | 'mg:ring-offset-placeholder'
  | 'lg:ring-offset-placeholder'
  | 'xl:ring-offset-placeholder'
  | 'focus-within:ring-offset-placeholder'
  | 'focus:ring-offset-placeholder'
  | 'sm:ring-offset-interactive-bone'
  | 'md:ring-offset-interactive-bone'
  | 'mg:ring-offset-interactive-bone'
  | 'lg:ring-offset-interactive-bone'
  | 'xl:ring-offset-interactive-bone'
  | 'focus-within:ring-offset-interactive-bone'
  | 'focus:ring-offset-interactive-bone'
  | 'sm:ring-offset-interactive-brick'
  | 'md:ring-offset-interactive-brick'
  | 'mg:ring-offset-interactive-brick'
  | 'lg:ring-offset-interactive-brick'
  | 'xl:ring-offset-interactive-brick'
  | 'focus-within:ring-offset-interactive-brick'
  | 'focus:ring-offset-interactive-brick'
  | 'sm:ring-offset-interactive-char'
  | 'md:ring-offset-interactive-char'
  | 'mg:ring-offset-interactive-char'
  | 'lg:ring-offset-interactive-char'
  | 'xl:ring-offset-interactive-char'
  | 'focus-within:ring-offset-interactive-char'
  | 'focus:ring-offset-interactive-char'
  | 'sm:ring-offset-interactive-white'
  | 'md:ring-offset-interactive-white'
  | 'mg:ring-offset-interactive-white'
  | 'lg:ring-offset-interactive-white'
  | 'xl:ring-offset-interactive-white'
  | 'focus-within:ring-offset-interactive-white'
  | 'focus:ring-offset-interactive-white'
  | 'sm:ring-offset-interactive-disabled'
  | 'md:ring-offset-interactive-disabled'
  | 'mg:ring-offset-interactive-disabled'
  | 'lg:ring-offset-interactive-disabled'
  | 'xl:ring-offset-interactive-disabled'
  | 'focus-within:ring-offset-interactive-disabled'
  | 'focus:ring-offset-interactive-disabled'
  | 'sm:ring-offset-interactive-error'
  | 'md:ring-offset-interactive-error'
  | 'mg:ring-offset-interactive-error'
  | 'lg:ring-offset-interactive-error'
  | 'xl:ring-offset-interactive-error'
  | 'focus-within:ring-offset-interactive-error'
  | 'focus:ring-offset-interactive-error'
  | 'sm:ring-offset-interactive-outline'
  | 'md:ring-offset-interactive-outline'
  | 'mg:ring-offset-interactive-outline'
  | 'lg:ring-offset-interactive-outline'
  | 'xl:ring-offset-interactive-outline'
  | 'focus-within:ring-offset-interactive-outline'
  | 'focus:ring-offset-interactive-outline'
  | 'sm:ring-offset-translucent-char'
  | 'md:ring-offset-translucent-char'
  | 'mg:ring-offset-translucent-char'
  | 'lg:ring-offset-translucent-char'
  | 'xl:ring-offset-translucent-char'
  | 'focus-within:ring-offset-translucent-char'
  | 'focus:ring-offset-translucent-char'
  | 'sm:ring-offset-translucent-white'
  | 'md:ring-offset-translucent-white'
  | 'mg:ring-offset-translucent-white'
  | 'lg:ring-offset-translucent-white'
  | 'xl:ring-offset-translucent-white'
  | 'focus-within:ring-offset-translucent-white'
  | 'focus:ring-offset-translucent-white'
  | 'sm:ring-offset-char-50'
  | 'md:ring-offset-char-50'
  | 'mg:ring-offset-char-50'
  | 'lg:ring-offset-char-50'
  | 'xl:ring-offset-char-50'
  | 'focus-within:ring-offset-char-50'
  | 'focus:ring-offset-char-50'
  | 'sm:ring-offset-char-100'
  | 'md:ring-offset-char-100'
  | 'mg:ring-offset-char-100'
  | 'lg:ring-offset-char-100'
  | 'xl:ring-offset-char-100'
  | 'focus-within:ring-offset-char-100'
  | 'focus:ring-offset-char-100'
  | 'sm:ring-offset-char-200'
  | 'md:ring-offset-char-200'
  | 'mg:ring-offset-char-200'
  | 'lg:ring-offset-char-200'
  | 'xl:ring-offset-char-200'
  | 'focus-within:ring-offset-char-200'
  | 'focus:ring-offset-char-200'
  | 'sm:ring-offset-char-300'
  | 'md:ring-offset-char-300'
  | 'mg:ring-offset-char-300'
  | 'lg:ring-offset-char-300'
  | 'xl:ring-offset-char-300'
  | 'focus-within:ring-offset-char-300'
  | 'focus:ring-offset-char-300'
  | 'sm:ring-offset-char-400'
  | 'md:ring-offset-char-400'
  | 'mg:ring-offset-char-400'
  | 'lg:ring-offset-char-400'
  | 'xl:ring-offset-char-400'
  | 'focus-within:ring-offset-char-400'
  | 'focus:ring-offset-char-400'
  | 'sm:ring-offset-char-500'
  | 'md:ring-offset-char-500'
  | 'mg:ring-offset-char-500'
  | 'lg:ring-offset-char-500'
  | 'xl:ring-offset-char-500'
  | 'focus-within:ring-offset-char-500'
  | 'focus:ring-offset-char-500'
  | 'sm:ring-offset-char-600'
  | 'md:ring-offset-char-600'
  | 'mg:ring-offset-char-600'
  | 'lg:ring-offset-char-600'
  | 'xl:ring-offset-char-600'
  | 'focus-within:ring-offset-char-600'
  | 'focus:ring-offset-char-600'
  | 'sm:ring-offset-char-700'
  | 'md:ring-offset-char-700'
  | 'mg:ring-offset-char-700'
  | 'lg:ring-offset-char-700'
  | 'xl:ring-offset-char-700'
  | 'focus-within:ring-offset-char-700'
  | 'focus:ring-offset-char-700'
  | 'sm:ring-offset-char-800'
  | 'md:ring-offset-char-800'
  | 'mg:ring-offset-char-800'
  | 'lg:ring-offset-char-800'
  | 'xl:ring-offset-char-800'
  | 'focus-within:ring-offset-char-800'
  | 'focus:ring-offset-char-800'
  | 'sm:ring-offset-char-900'
  | 'md:ring-offset-char-900'
  | 'mg:ring-offset-char-900'
  | 'lg:ring-offset-char-900'
  | 'xl:ring-offset-char-900'
  | 'focus-within:ring-offset-char-900'
  | 'focus:ring-offset-char-900'
  | 'sm:ring-offset-bone-50'
  | 'md:ring-offset-bone-50'
  | 'mg:ring-offset-bone-50'
  | 'lg:ring-offset-bone-50'
  | 'xl:ring-offset-bone-50'
  | 'focus-within:ring-offset-bone-50'
  | 'focus:ring-offset-bone-50'
  | 'sm:ring-offset-bone-100'
  | 'md:ring-offset-bone-100'
  | 'mg:ring-offset-bone-100'
  | 'lg:ring-offset-bone-100'
  | 'xl:ring-offset-bone-100'
  | 'focus-within:ring-offset-bone-100'
  | 'focus:ring-offset-bone-100'
  | 'sm:ring-offset-bone-200'
  | 'md:ring-offset-bone-200'
  | 'mg:ring-offset-bone-200'
  | 'lg:ring-offset-bone-200'
  | 'xl:ring-offset-bone-200'
  | 'focus-within:ring-offset-bone-200'
  | 'focus:ring-offset-bone-200'
  | 'sm:ring-offset-bone-300'
  | 'md:ring-offset-bone-300'
  | 'mg:ring-offset-bone-300'
  | 'lg:ring-offset-bone-300'
  | 'xl:ring-offset-bone-300'
  | 'focus-within:ring-offset-bone-300'
  | 'focus:ring-offset-bone-300'
  | 'sm:ring-offset-bone-400'
  | 'md:ring-offset-bone-400'
  | 'mg:ring-offset-bone-400'
  | 'lg:ring-offset-bone-400'
  | 'xl:ring-offset-bone-400'
  | 'focus-within:ring-offset-bone-400'
  | 'focus:ring-offset-bone-400'
  | 'sm:ring-offset-bone-500'
  | 'md:ring-offset-bone-500'
  | 'mg:ring-offset-bone-500'
  | 'lg:ring-offset-bone-500'
  | 'xl:ring-offset-bone-500'
  | 'focus-within:ring-offset-bone-500'
  | 'focus:ring-offset-bone-500'
  | 'sm:ring-offset-bone-600'
  | 'md:ring-offset-bone-600'
  | 'mg:ring-offset-bone-600'
  | 'lg:ring-offset-bone-600'
  | 'xl:ring-offset-bone-600'
  | 'focus-within:ring-offset-bone-600'
  | 'focus:ring-offset-bone-600'
  | 'sm:ring-offset-bone-700'
  | 'md:ring-offset-bone-700'
  | 'mg:ring-offset-bone-700'
  | 'lg:ring-offset-bone-700'
  | 'xl:ring-offset-bone-700'
  | 'focus-within:ring-offset-bone-700'
  | 'focus:ring-offset-bone-700'
  | 'sm:ring-offset-bone-800'
  | 'md:ring-offset-bone-800'
  | 'mg:ring-offset-bone-800'
  | 'lg:ring-offset-bone-800'
  | 'xl:ring-offset-bone-800'
  | 'focus-within:ring-offset-bone-800'
  | 'focus:ring-offset-bone-800'
  | 'sm:ring-offset-bone-900'
  | 'md:ring-offset-bone-900'
  | 'mg:ring-offset-bone-900'
  | 'lg:ring-offset-bone-900'
  | 'xl:ring-offset-bone-900'
  | 'focus-within:ring-offset-bone-900'
  | 'focus:ring-offset-bone-900'
  | 'sm:ring-offset-brick-50'
  | 'md:ring-offset-brick-50'
  | 'mg:ring-offset-brick-50'
  | 'lg:ring-offset-brick-50'
  | 'xl:ring-offset-brick-50'
  | 'focus-within:ring-offset-brick-50'
  | 'focus:ring-offset-brick-50'
  | 'sm:ring-offset-brick-300'
  | 'md:ring-offset-brick-300'
  | 'mg:ring-offset-brick-300'
  | 'lg:ring-offset-brick-300'
  | 'xl:ring-offset-brick-300'
  | 'focus-within:ring-offset-brick-300'
  | 'focus:ring-offset-brick-300'
  | 'sm:ring-offset-brick-500'
  | 'md:ring-offset-brick-500'
  | 'mg:ring-offset-brick-500'
  | 'lg:ring-offset-brick-500'
  | 'xl:ring-offset-brick-500'
  | 'focus-within:ring-offset-brick-500'
  | 'focus:ring-offset-brick-500'
  | 'sm:ring-offset-brick-700'
  | 'md:ring-offset-brick-700'
  | 'mg:ring-offset-brick-700'
  | 'lg:ring-offset-brick-700'
  | 'xl:ring-offset-brick-700'
  | 'focus-within:ring-offset-brick-700'
  | 'focus:ring-offset-brick-700'
  | 'sm:ring-offset-brick-900'
  | 'md:ring-offset-brick-900'
  | 'mg:ring-offset-brick-900'
  | 'lg:ring-offset-brick-900'
  | 'xl:ring-offset-brick-900'
  | 'focus-within:ring-offset-brick-900'
  | 'focus:ring-offset-brick-900'
  | 'sm:ring-offset-sage-50'
  | 'md:ring-offset-sage-50'
  | 'mg:ring-offset-sage-50'
  | 'lg:ring-offset-sage-50'
  | 'xl:ring-offset-sage-50'
  | 'focus-within:ring-offset-sage-50'
  | 'focus:ring-offset-sage-50'
  | 'sm:ring-offset-sage-300'
  | 'md:ring-offset-sage-300'
  | 'mg:ring-offset-sage-300'
  | 'lg:ring-offset-sage-300'
  | 'xl:ring-offset-sage-300'
  | 'focus-within:ring-offset-sage-300'
  | 'focus:ring-offset-sage-300'
  | 'sm:ring-offset-sage-500'
  | 'md:ring-offset-sage-500'
  | 'mg:ring-offset-sage-500'
  | 'lg:ring-offset-sage-500'
  | 'xl:ring-offset-sage-500'
  | 'focus-within:ring-offset-sage-500'
  | 'focus:ring-offset-sage-500'
  | 'sm:ring-offset-sage-700'
  | 'md:ring-offset-sage-700'
  | 'mg:ring-offset-sage-700'
  | 'lg:ring-offset-sage-700'
  | 'xl:ring-offset-sage-700'
  | 'focus-within:ring-offset-sage-700'
  | 'focus:ring-offset-sage-700'
  | 'sm:ring-offset-sage-900'
  | 'md:ring-offset-sage-900'
  | 'mg:ring-offset-sage-900'
  | 'lg:ring-offset-sage-900'
  | 'xl:ring-offset-sage-900'
  | 'focus-within:ring-offset-sage-900'
  | 'focus:ring-offset-sage-900'
  | 'sm:ring-offset-blue-50'
  | 'md:ring-offset-blue-50'
  | 'mg:ring-offset-blue-50'
  | 'lg:ring-offset-blue-50'
  | 'xl:ring-offset-blue-50'
  | 'focus-within:ring-offset-blue-50'
  | 'focus:ring-offset-blue-50'
  | 'sm:ring-offset-blue-300'
  | 'md:ring-offset-blue-300'
  | 'mg:ring-offset-blue-300'
  | 'lg:ring-offset-blue-300'
  | 'xl:ring-offset-blue-300'
  | 'focus-within:ring-offset-blue-300'
  | 'focus:ring-offset-blue-300'
  | 'sm:ring-offset-blue-500'
  | 'md:ring-offset-blue-500'
  | 'mg:ring-offset-blue-500'
  | 'lg:ring-offset-blue-500'
  | 'xl:ring-offset-blue-500'
  | 'focus-within:ring-offset-blue-500'
  | 'focus:ring-offset-blue-500'
  | 'sm:ring-offset-blue-700'
  | 'md:ring-offset-blue-700'
  | 'mg:ring-offset-blue-700'
  | 'lg:ring-offset-blue-700'
  | 'xl:ring-offset-blue-700'
  | 'focus-within:ring-offset-blue-700'
  | 'focus:ring-offset-blue-700'
  | 'sm:ring-offset-blue-900'
  | 'md:ring-offset-blue-900'
  | 'mg:ring-offset-blue-900'
  | 'lg:ring-offset-blue-900'
  | 'xl:ring-offset-blue-900'
  | 'focus-within:ring-offset-blue-900'
  | 'focus:ring-offset-blue-900'
  | 'sm:ring-offset-misc-bright-blue'
  | 'md:ring-offset-misc-bright-blue'
  | 'mg:ring-offset-misc-bright-blue'
  | 'lg:ring-offset-misc-bright-blue'
  | 'xl:ring-offset-misc-bright-blue'
  | 'focus-within:ring-offset-misc-bright-blue'
  | 'focus:ring-offset-misc-bright-blue'
  | 'sm:ring-offset-misc-focus'
  | 'md:ring-offset-misc-focus'
  | 'mg:ring-offset-misc-focus'
  | 'lg:ring-offset-misc-focus'
  | 'xl:ring-offset-misc-focus'
  | 'focus-within:ring-offset-misc-focus'
  | 'focus:ring-offset-misc-focus'
  | 'sm:ring-offset-misc-legal-blue'
  | 'md:ring-offset-misc-legal-blue'
  | 'mg:ring-offset-misc-legal-blue'
  | 'lg:ring-offset-misc-legal-blue'
  | 'xl:ring-offset-misc-legal-blue'
  | 'focus-within:ring-offset-misc-legal-blue'
  | 'focus:ring-offset-misc-legal-blue'
  | 'sm:ring-offset-misc-neutral'
  | 'md:ring-offset-misc-neutral'
  | 'mg:ring-offset-misc-neutral'
  | 'lg:ring-offset-misc-neutral'
  | 'xl:ring-offset-misc-neutral'
  | 'focus-within:ring-offset-misc-neutral'
  | 'focus:ring-offset-misc-neutral'
  | 'sm:ring-offset-misc-yellow-orange'
  | 'md:ring-offset-misc-yellow-orange'
  | 'mg:ring-offset-misc-yellow-orange'
  | 'lg:ring-offset-misc-yellow-orange'
  | 'xl:ring-offset-misc-yellow-orange'
  | 'focus-within:ring-offset-misc-yellow-orange'
  | 'focus:ring-offset-misc-yellow-orange'
  | 'sm:ring-offset-0'
  | 'md:ring-offset-0'
  | 'mg:ring-offset-0'
  | 'lg:ring-offset-0'
  | 'xl:ring-offset-0'
  | 'focus-within:ring-offset-0'
  | 'focus:ring-offset-0'
  | 'sm:ring-offset-1'
  | 'md:ring-offset-1'
  | 'mg:ring-offset-1'
  | 'lg:ring-offset-1'
  | 'xl:ring-offset-1'
  | 'focus-within:ring-offset-1'
  | 'focus:ring-offset-1'
  | 'sm:ring-offset-2'
  | 'md:ring-offset-2'
  | 'mg:ring-offset-2'
  | 'lg:ring-offset-2'
  | 'xl:ring-offset-2'
  | 'focus-within:ring-offset-2'
  | 'focus:ring-offset-2'
  | 'sm:ring-offset-4'
  | 'md:ring-offset-4'
  | 'mg:ring-offset-4'
  | 'lg:ring-offset-4'
  | 'xl:ring-offset-4'
  | 'focus-within:ring-offset-4'
  | 'focus:ring-offset-4'
  | 'sm:ring-offset-8'
  | 'md:ring-offset-8'
  | 'mg:ring-offset-8'
  | 'lg:ring-offset-8'
  | 'xl:ring-offset-8'
  | 'focus-within:ring-offset-8'
  | 'focus:ring-offset-8'
  | 'sm:ring-opacity-0'
  | 'md:ring-opacity-0'
  | 'mg:ring-opacity-0'
  | 'lg:ring-opacity-0'
  | 'xl:ring-opacity-0'
  | 'focus-within:ring-opacity-0'
  | 'focus:ring-opacity-0'
  | 'sm:ring-opacity-5'
  | 'md:ring-opacity-5'
  | 'mg:ring-opacity-5'
  | 'lg:ring-opacity-5'
  | 'xl:ring-opacity-5'
  | 'focus-within:ring-opacity-5'
  | 'focus:ring-opacity-5'
  | 'sm:ring-opacity-10'
  | 'md:ring-opacity-10'
  | 'mg:ring-opacity-10'
  | 'lg:ring-opacity-10'
  | 'xl:ring-opacity-10'
  | 'focus-within:ring-opacity-10'
  | 'focus:ring-opacity-10'
  | 'sm:ring-opacity-20'
  | 'md:ring-opacity-20'
  | 'mg:ring-opacity-20'
  | 'lg:ring-opacity-20'
  | 'xl:ring-opacity-20'
  | 'focus-within:ring-opacity-20'
  | 'focus:ring-opacity-20'
  | 'sm:ring-opacity-25'
  | 'md:ring-opacity-25'
  | 'mg:ring-opacity-25'
  | 'lg:ring-opacity-25'
  | 'xl:ring-opacity-25'
  | 'focus-within:ring-opacity-25'
  | 'focus:ring-opacity-25'
  | 'sm:ring-opacity-30'
  | 'md:ring-opacity-30'
  | 'mg:ring-opacity-30'
  | 'lg:ring-opacity-30'
  | 'xl:ring-opacity-30'
  | 'focus-within:ring-opacity-30'
  | 'focus:ring-opacity-30'
  | 'sm:ring-opacity-40'
  | 'md:ring-opacity-40'
  | 'mg:ring-opacity-40'
  | 'lg:ring-opacity-40'
  | 'xl:ring-opacity-40'
  | 'focus-within:ring-opacity-40'
  | 'focus:ring-opacity-40'
  | 'sm:ring-opacity-50'
  | 'md:ring-opacity-50'
  | 'mg:ring-opacity-50'
  | 'lg:ring-opacity-50'
  | 'xl:ring-opacity-50'
  | 'focus-within:ring-opacity-50'
  | 'focus:ring-opacity-50'
  | 'sm:ring-opacity-60'
  | 'md:ring-opacity-60'
  | 'mg:ring-opacity-60'
  | 'lg:ring-opacity-60'
  | 'xl:ring-opacity-60'
  | 'focus-within:ring-opacity-60'
  | 'focus:ring-opacity-60'
  | 'sm:ring-opacity-70'
  | 'md:ring-opacity-70'
  | 'mg:ring-opacity-70'
  | 'lg:ring-opacity-70'
  | 'xl:ring-opacity-70'
  | 'focus-within:ring-opacity-70'
  | 'focus:ring-opacity-70'
  | 'sm:ring-opacity-75'
  | 'md:ring-opacity-75'
  | 'mg:ring-opacity-75'
  | 'lg:ring-opacity-75'
  | 'xl:ring-opacity-75'
  | 'focus-within:ring-opacity-75'
  | 'focus:ring-opacity-75'
  | 'sm:ring-opacity-80'
  | 'md:ring-opacity-80'
  | 'mg:ring-opacity-80'
  | 'lg:ring-opacity-80'
  | 'xl:ring-opacity-80'
  | 'focus-within:ring-opacity-80'
  | 'focus:ring-opacity-80'
  | 'sm:ring-opacity-90'
  | 'md:ring-opacity-90'
  | 'mg:ring-opacity-90'
  | 'lg:ring-opacity-90'
  | 'xl:ring-opacity-90'
  | 'focus-within:ring-opacity-90'
  | 'focus:ring-opacity-90'
  | 'sm:ring-opacity-95'
  | 'md:ring-opacity-95'
  | 'mg:ring-opacity-95'
  | 'lg:ring-opacity-95'
  | 'xl:ring-opacity-95'
  | 'focus-within:ring-opacity-95'
  | 'focus:ring-opacity-95'
  | 'sm:ring-opacity-100'
  | 'md:ring-opacity-100'
  | 'mg:ring-opacity-100'
  | 'lg:ring-opacity-100'
  | 'xl:ring-opacity-100'
  | 'focus-within:ring-opacity-100'
  | 'focus:ring-opacity-100'
  | 'sm:ring-opacity'
  | 'md:ring-opacity'
  | 'mg:ring-opacity'
  | 'lg:ring-opacity'
  | 'xl:ring-opacity'
  | 'focus-within:ring-opacity'
  | 'focus:ring-opacity'
  | 'sm:ring-0'
  | 'md:ring-0'
  | 'mg:ring-0'
  | 'lg:ring-0'
  | 'xl:ring-0'
  | 'focus-within:ring-0'
  | 'focus:ring-0'
  | 'sm:ring-1'
  | 'md:ring-1'
  | 'mg:ring-1'
  | 'lg:ring-1'
  | 'xl:ring-1'
  | 'focus-within:ring-1'
  | 'focus:ring-1'
  | 'sm:ring-2'
  | 'md:ring-2'
  | 'mg:ring-2'
  | 'lg:ring-2'
  | 'xl:ring-2'
  | 'focus-within:ring-2'
  | 'focus:ring-2'
  | 'sm:ring-4'
  | 'md:ring-4'
  | 'mg:ring-4'
  | 'lg:ring-4'
  | 'xl:ring-4'
  | 'focus-within:ring-4'
  | 'focus:ring-4'
  | 'sm:ring-8'
  | 'md:ring-8'
  | 'mg:ring-8'
  | 'lg:ring-8'
  | 'xl:ring-8'
  | 'focus-within:ring-8'
  | 'focus:ring-8'
  | 'sm:ring'
  | 'md:ring'
  | 'mg:ring'
  | 'lg:ring'
  | 'xl:ring'
  | 'focus-within:ring'
  | 'focus:ring'
  | 'sm:inset'
  | 'md:inset'
  | 'mg:inset'
  | 'lg:inset'
  | 'xl:inset'
  | 'focus-within:inset'
  | 'focus:inset'
  | 'sm:rotate-0'
  | 'md:rotate-0'
  | 'mg:rotate-0'
  | 'lg:rotate-0'
  | 'xl:rotate-0'
  | 'hover:rotate-0'
  | 'focus:rotate-0'
  | 'sm:rotate-1'
  | 'md:rotate-1'
  | 'mg:rotate-1'
  | 'lg:rotate-1'
  | 'xl:rotate-1'
  | 'hover:rotate-1'
  | 'focus:rotate-1'
  | 'sm:rotate-2'
  | 'md:rotate-2'
  | 'mg:rotate-2'
  | 'lg:rotate-2'
  | 'xl:rotate-2'
  | 'hover:rotate-2'
  | 'focus:rotate-2'
  | 'sm:rotate-3'
  | 'md:rotate-3'
  | 'mg:rotate-3'
  | 'lg:rotate-3'
  | 'xl:rotate-3'
  | 'hover:rotate-3'
  | 'focus:rotate-3'
  | 'sm:rotate-6'
  | 'md:rotate-6'
  | 'mg:rotate-6'
  | 'lg:rotate-6'
  | 'xl:rotate-6'
  | 'hover:rotate-6'
  | 'focus:rotate-6'
  | 'sm:rotate-12'
  | 'md:rotate-12'
  | 'mg:rotate-12'
  | 'lg:rotate-12'
  | 'xl:rotate-12'
  | 'hover:rotate-12'
  | 'focus:rotate-12'
  | 'sm:rotate-45'
  | 'md:rotate-45'
  | 'mg:rotate-45'
  | 'lg:rotate-45'
  | 'xl:rotate-45'
  | 'hover:rotate-45'
  | 'focus:rotate-45'
  | 'sm:rotate-90'
  | 'md:rotate-90'
  | 'mg:rotate-90'
  | 'lg:rotate-90'
  | 'xl:rotate-90'
  | 'hover:rotate-90'
  | 'focus:rotate-90'
  | 'sm:rotate-180'
  | 'md:rotate-180'
  | 'mg:rotate-180'
  | 'lg:rotate-180'
  | 'xl:rotate-180'
  | 'hover:rotate-180'
  | 'focus:rotate-180'
  | 'sm:-rotate-180'
  | 'md:-rotate-180'
  | 'mg:-rotate-180'
  | 'lg:-rotate-180'
  | 'xl:-rotate-180'
  | 'hover:-rotate-180'
  | 'focus:-rotate-180'
  | 'sm:-rotate-90'
  | 'md:-rotate-90'
  | 'mg:-rotate-90'
  | 'lg:-rotate-90'
  | 'xl:-rotate-90'
  | 'hover:-rotate-90'
  | 'focus:-rotate-90'
  | 'sm:-rotate-45'
  | 'md:-rotate-45'
  | 'mg:-rotate-45'
  | 'lg:-rotate-45'
  | 'xl:-rotate-45'
  | 'hover:-rotate-45'
  | 'focus:-rotate-45'
  | 'sm:-rotate-12'
  | 'md:-rotate-12'
  | 'mg:-rotate-12'
  | 'lg:-rotate-12'
  | 'xl:-rotate-12'
  | 'hover:-rotate-12'
  | 'focus:-rotate-12'
  | 'sm:-rotate-6'
  | 'md:-rotate-6'
  | 'mg:-rotate-6'
  | 'lg:-rotate-6'
  | 'xl:-rotate-6'
  | 'hover:-rotate-6'
  | 'focus:-rotate-6'
  | 'sm:-rotate-3'
  | 'md:-rotate-3'
  | 'mg:-rotate-3'
  | 'lg:-rotate-3'
  | 'xl:-rotate-3'
  | 'hover:-rotate-3'
  | 'focus:-rotate-3'
  | 'sm:-rotate-2'
  | 'md:-rotate-2'
  | 'mg:-rotate-2'
  | 'lg:-rotate-2'
  | 'xl:-rotate-2'
  | 'hover:-rotate-2'
  | 'focus:-rotate-2'
  | 'sm:-rotate-1'
  | 'md:-rotate-1'
  | 'mg:-rotate-1'
  | 'lg:-rotate-1'
  | 'xl:-rotate-1'
  | 'hover:-rotate-1'
  | 'focus:-rotate-1'
  | 'sm:saturate-0'
  | 'md:saturate-0'
  | 'mg:saturate-0'
  | 'lg:saturate-0'
  | 'xl:saturate-0'
  | 'sm:saturate-50'
  | 'md:saturate-50'
  | 'mg:saturate-50'
  | 'lg:saturate-50'
  | 'xl:saturate-50'
  | 'sm:saturate-100'
  | 'md:saturate-100'
  | 'mg:saturate-100'
  | 'lg:saturate-100'
  | 'xl:saturate-100'
  | 'sm:saturate-150'
  | 'md:saturate-150'
  | 'mg:saturate-150'
  | 'lg:saturate-150'
  | 'xl:saturate-150'
  | 'sm:saturate-200'
  | 'md:saturate-200'
  | 'mg:saturate-200'
  | 'lg:saturate-200'
  | 'xl:saturate-200'
  | 'sm:scale-0'
  | 'md:scale-0'
  | 'mg:scale-0'
  | 'lg:scale-0'
  | 'xl:scale-0'
  | 'hover:scale-0'
  | 'focus:scale-0'
  | 'sm:scale-50'
  | 'md:scale-50'
  | 'mg:scale-50'
  | 'lg:scale-50'
  | 'xl:scale-50'
  | 'hover:scale-50'
  | 'focus:scale-50'
  | 'sm:scale-75'
  | 'md:scale-75'
  | 'mg:scale-75'
  | 'lg:scale-75'
  | 'xl:scale-75'
  | 'hover:scale-75'
  | 'focus:scale-75'
  | 'sm:scale-90'
  | 'md:scale-90'
  | 'mg:scale-90'
  | 'lg:scale-90'
  | 'xl:scale-90'
  | 'hover:scale-90'
  | 'focus:scale-90'
  | 'sm:scale-95'
  | 'md:scale-95'
  | 'mg:scale-95'
  | 'lg:scale-95'
  | 'xl:scale-95'
  | 'hover:scale-95'
  | 'focus:scale-95'
  | 'sm:scale-100'
  | 'md:scale-100'
  | 'mg:scale-100'
  | 'lg:scale-100'
  | 'xl:scale-100'
  | 'hover:scale-100'
  | 'focus:scale-100'
  | 'sm:scale-105'
  | 'md:scale-105'
  | 'mg:scale-105'
  | 'lg:scale-105'
  | 'xl:scale-105'
  | 'hover:scale-105'
  | 'focus:scale-105'
  | 'sm:scale-110'
  | 'md:scale-110'
  | 'mg:scale-110'
  | 'lg:scale-110'
  | 'xl:scale-110'
  | 'hover:scale-110'
  | 'focus:scale-110'
  | 'sm:scale-125'
  | 'md:scale-125'
  | 'mg:scale-125'
  | 'lg:scale-125'
  | 'xl:scale-125'
  | 'hover:scale-125'
  | 'focus:scale-125'
  | 'sm:scale-150'
  | 'md:scale-150'
  | 'mg:scale-150'
  | 'lg:scale-150'
  | 'xl:scale-150'
  | 'hover:scale-150'
  | 'focus:scale-150'
  | 'sm:scale-x-0'
  | 'md:scale-x-0'
  | 'mg:scale-x-0'
  | 'lg:scale-x-0'
  | 'xl:scale-x-0'
  | 'hover:scale-x-0'
  | 'focus:scale-x-0'
  | 'sm:scale-x-50'
  | 'md:scale-x-50'
  | 'mg:scale-x-50'
  | 'lg:scale-x-50'
  | 'xl:scale-x-50'
  | 'hover:scale-x-50'
  | 'focus:scale-x-50'
  | 'sm:scale-x-75'
  | 'md:scale-x-75'
  | 'mg:scale-x-75'
  | 'lg:scale-x-75'
  | 'xl:scale-x-75'
  | 'hover:scale-x-75'
  | 'focus:scale-x-75'
  | 'sm:scale-x-90'
  | 'md:scale-x-90'
  | 'mg:scale-x-90'
  | 'lg:scale-x-90'
  | 'xl:scale-x-90'
  | 'hover:scale-x-90'
  | 'focus:scale-x-90'
  | 'sm:scale-x-95'
  | 'md:scale-x-95'
  | 'mg:scale-x-95'
  | 'lg:scale-x-95'
  | 'xl:scale-x-95'
  | 'hover:scale-x-95'
  | 'focus:scale-x-95'
  | 'sm:scale-x-100'
  | 'md:scale-x-100'
  | 'mg:scale-x-100'
  | 'lg:scale-x-100'
  | 'xl:scale-x-100'
  | 'hover:scale-x-100'
  | 'focus:scale-x-100'
  | 'sm:scale-x-105'
  | 'md:scale-x-105'
  | 'mg:scale-x-105'
  | 'lg:scale-x-105'
  | 'xl:scale-x-105'
  | 'hover:scale-x-105'
  | 'focus:scale-x-105'
  | 'sm:scale-x-110'
  | 'md:scale-x-110'
  | 'mg:scale-x-110'
  | 'lg:scale-x-110'
  | 'xl:scale-x-110'
  | 'hover:scale-x-110'
  | 'focus:scale-x-110'
  | 'sm:scale-x-125'
  | 'md:scale-x-125'
  | 'mg:scale-x-125'
  | 'lg:scale-x-125'
  | 'xl:scale-x-125'
  | 'hover:scale-x-125'
  | 'focus:scale-x-125'
  | 'sm:scale-x-150'
  | 'md:scale-x-150'
  | 'mg:scale-x-150'
  | 'lg:scale-x-150'
  | 'xl:scale-x-150'
  | 'hover:scale-x-150'
  | 'focus:scale-x-150'
  | 'sm:scale-y-0'
  | 'md:scale-y-0'
  | 'mg:scale-y-0'
  | 'lg:scale-y-0'
  | 'xl:scale-y-0'
  | 'hover:scale-y-0'
  | 'focus:scale-y-0'
  | 'sm:scale-y-50'
  | 'md:scale-y-50'
  | 'mg:scale-y-50'
  | 'lg:scale-y-50'
  | 'xl:scale-y-50'
  | 'hover:scale-y-50'
  | 'focus:scale-y-50'
  | 'sm:scale-y-75'
  | 'md:scale-y-75'
  | 'mg:scale-y-75'
  | 'lg:scale-y-75'
  | 'xl:scale-y-75'
  | 'hover:scale-y-75'
  | 'focus:scale-y-75'
  | 'sm:scale-y-90'
  | 'md:scale-y-90'
  | 'mg:scale-y-90'
  | 'lg:scale-y-90'
  | 'xl:scale-y-90'
  | 'hover:scale-y-90'
  | 'focus:scale-y-90'
  | 'sm:scale-y-95'
  | 'md:scale-y-95'
  | 'mg:scale-y-95'
  | 'lg:scale-y-95'
  | 'xl:scale-y-95'
  | 'hover:scale-y-95'
  | 'focus:scale-y-95'
  | 'sm:scale-y-100'
  | 'md:scale-y-100'
  | 'mg:scale-y-100'
  | 'lg:scale-y-100'
  | 'xl:scale-y-100'
  | 'hover:scale-y-100'
  | 'focus:scale-y-100'
  | 'sm:scale-y-105'
  | 'md:scale-y-105'
  | 'mg:scale-y-105'
  | 'lg:scale-y-105'
  | 'xl:scale-y-105'
  | 'hover:scale-y-105'
  | 'focus:scale-y-105'
  | 'sm:scale-y-110'
  | 'md:scale-y-110'
  | 'mg:scale-y-110'
  | 'lg:scale-y-110'
  | 'xl:scale-y-110'
  | 'hover:scale-y-110'
  | 'focus:scale-y-110'
  | 'sm:scale-y-125'
  | 'md:scale-y-125'
  | 'mg:scale-y-125'
  | 'lg:scale-y-125'
  | 'xl:scale-y-125'
  | 'hover:scale-y-125'
  | 'focus:scale-y-125'
  | 'sm:scale-y-150'
  | 'md:scale-y-150'
  | 'mg:scale-y-150'
  | 'lg:scale-y-150'
  | 'xl:scale-y-150'
  | 'hover:scale-y-150'
  | 'focus:scale-y-150'
  | 'sm:sepia-0'
  | 'md:sepia-0'
  | 'mg:sepia-0'
  | 'lg:sepia-0'
  | 'xl:sepia-0'
  | 'sm:sepia'
  | 'md:sepia'
  | 'mg:sepia'
  | 'lg:sepia'
  | 'xl:sepia'
  | 'sm:skew-x-0'
  | 'md:skew-x-0'
  | 'mg:skew-x-0'
  | 'lg:skew-x-0'
  | 'xl:skew-x-0'
  | 'hover:skew-x-0'
  | 'focus:skew-x-0'
  | 'sm:skew-x-1'
  | 'md:skew-x-1'
  | 'mg:skew-x-1'
  | 'lg:skew-x-1'
  | 'xl:skew-x-1'
  | 'hover:skew-x-1'
  | 'focus:skew-x-1'
  | 'sm:skew-x-2'
  | 'md:skew-x-2'
  | 'mg:skew-x-2'
  | 'lg:skew-x-2'
  | 'xl:skew-x-2'
  | 'hover:skew-x-2'
  | 'focus:skew-x-2'
  | 'sm:skew-x-3'
  | 'md:skew-x-3'
  | 'mg:skew-x-3'
  | 'lg:skew-x-3'
  | 'xl:skew-x-3'
  | 'hover:skew-x-3'
  | 'focus:skew-x-3'
  | 'sm:skew-x-6'
  | 'md:skew-x-6'
  | 'mg:skew-x-6'
  | 'lg:skew-x-6'
  | 'xl:skew-x-6'
  | 'hover:skew-x-6'
  | 'focus:skew-x-6'
  | 'sm:skew-x-12'
  | 'md:skew-x-12'
  | 'mg:skew-x-12'
  | 'lg:skew-x-12'
  | 'xl:skew-x-12'
  | 'hover:skew-x-12'
  | 'focus:skew-x-12'
  | 'sm:-skew-x-12'
  | 'md:-skew-x-12'
  | 'mg:-skew-x-12'
  | 'lg:-skew-x-12'
  | 'xl:-skew-x-12'
  | 'hover:-skew-x-12'
  | 'focus:-skew-x-12'
  | 'sm:-skew-x-6'
  | 'md:-skew-x-6'
  | 'mg:-skew-x-6'
  | 'lg:-skew-x-6'
  | 'xl:-skew-x-6'
  | 'hover:-skew-x-6'
  | 'focus:-skew-x-6'
  | 'sm:-skew-x-3'
  | 'md:-skew-x-3'
  | 'mg:-skew-x-3'
  | 'lg:-skew-x-3'
  | 'xl:-skew-x-3'
  | 'hover:-skew-x-3'
  | 'focus:-skew-x-3'
  | 'sm:-skew-x-2'
  | 'md:-skew-x-2'
  | 'mg:-skew-x-2'
  | 'lg:-skew-x-2'
  | 'xl:-skew-x-2'
  | 'hover:-skew-x-2'
  | 'focus:-skew-x-2'
  | 'sm:-skew-x-1'
  | 'md:-skew-x-1'
  | 'mg:-skew-x-1'
  | 'lg:-skew-x-1'
  | 'xl:-skew-x-1'
  | 'hover:-skew-x-1'
  | 'focus:-skew-x-1'
  | 'sm:skew-y-0'
  | 'md:skew-y-0'
  | 'mg:skew-y-0'
  | 'lg:skew-y-0'
  | 'xl:skew-y-0'
  | 'hover:skew-y-0'
  | 'focus:skew-y-0'
  | 'sm:skew-y-1'
  | 'md:skew-y-1'
  | 'mg:skew-y-1'
  | 'lg:skew-y-1'
  | 'xl:skew-y-1'
  | 'hover:skew-y-1'
  | 'focus:skew-y-1'
  | 'sm:skew-y-2'
  | 'md:skew-y-2'
  | 'mg:skew-y-2'
  | 'lg:skew-y-2'
  | 'xl:skew-y-2'
  | 'hover:skew-y-2'
  | 'focus:skew-y-2'
  | 'sm:skew-y-3'
  | 'md:skew-y-3'
  | 'mg:skew-y-3'
  | 'lg:skew-y-3'
  | 'xl:skew-y-3'
  | 'hover:skew-y-3'
  | 'focus:skew-y-3'
  | 'sm:skew-y-6'
  | 'md:skew-y-6'
  | 'mg:skew-y-6'
  | 'lg:skew-y-6'
  | 'xl:skew-y-6'
  | 'hover:skew-y-6'
  | 'focus:skew-y-6'
  | 'sm:skew-y-12'
  | 'md:skew-y-12'
  | 'mg:skew-y-12'
  | 'lg:skew-y-12'
  | 'xl:skew-y-12'
  | 'hover:skew-y-12'
  | 'focus:skew-y-12'
  | 'sm:-skew-y-12'
  | 'md:-skew-y-12'
  | 'mg:-skew-y-12'
  | 'lg:-skew-y-12'
  | 'xl:-skew-y-12'
  | 'hover:-skew-y-12'
  | 'focus:-skew-y-12'
  | 'sm:-skew-y-6'
  | 'md:-skew-y-6'
  | 'mg:-skew-y-6'
  | 'lg:-skew-y-6'
  | 'xl:-skew-y-6'
  | 'hover:-skew-y-6'
  | 'focus:-skew-y-6'
  | 'sm:-skew-y-3'
  | 'md:-skew-y-3'
  | 'mg:-skew-y-3'
  | 'lg:-skew-y-3'
  | 'xl:-skew-y-3'
  | 'hover:-skew-y-3'
  | 'focus:-skew-y-3'
  | 'sm:-skew-y-2'
  | 'md:-skew-y-2'
  | 'mg:-skew-y-2'
  | 'lg:-skew-y-2'
  | 'xl:-skew-y-2'
  | 'hover:-skew-y-2'
  | 'focus:-skew-y-2'
  | 'sm:-skew-y-1'
  | 'md:-skew-y-1'
  | 'mg:-skew-y-1'
  | 'lg:-skew-y-1'
  | 'xl:-skew-y-1'
  | 'hover:-skew-y-1'
  | 'focus:-skew-y-1'
  | 'sm:space-x-0'
  | 'md:space-x-0'
  | 'mg:space-x-0'
  | 'lg:space-x-0'
  | 'xl:space-x-0'
  | 'sm:space-x-1'
  | 'md:space-x-1'
  | 'mg:space-x-1'
  | 'lg:space-x-1'
  | 'xl:space-x-1'
  | 'sm:space-x-2'
  | 'md:space-x-2'
  | 'mg:space-x-2'
  | 'lg:space-x-2'
  | 'xl:space-x-2'
  | 'sm:space-x-3'
  | 'md:space-x-3'
  | 'mg:space-x-3'
  | 'lg:space-x-3'
  | 'xl:space-x-3'
  | 'sm:space-x-4'
  | 'md:space-x-4'
  | 'mg:space-x-4'
  | 'lg:space-x-4'
  | 'xl:space-x-4'
  | 'sm:space-x-5'
  | 'md:space-x-5'
  | 'mg:space-x-5'
  | 'lg:space-x-5'
  | 'xl:space-x-5'
  | 'sm:space-x-6'
  | 'md:space-x-6'
  | 'mg:space-x-6'
  | 'lg:space-x-6'
  | 'xl:space-x-6'
  | 'sm:space-x-7'
  | 'md:space-x-7'
  | 'mg:space-x-7'
  | 'lg:space-x-7'
  | 'xl:space-x-7'
  | 'sm:space-x-8'
  | 'md:space-x-8'
  | 'mg:space-x-8'
  | 'lg:space-x-8'
  | 'xl:space-x-8'
  | 'sm:space-x-9'
  | 'md:space-x-9'
  | 'mg:space-x-9'
  | 'lg:space-x-9'
  | 'xl:space-x-9'
  | 'sm:space-x-10'
  | 'md:space-x-10'
  | 'mg:space-x-10'
  | 'lg:space-x-10'
  | 'xl:space-x-10'
  | 'sm:space-x-11'
  | 'md:space-x-11'
  | 'mg:space-x-11'
  | 'lg:space-x-11'
  | 'xl:space-x-11'
  | 'sm:space-x-12'
  | 'md:space-x-12'
  | 'mg:space-x-12'
  | 'lg:space-x-12'
  | 'xl:space-x-12'
  | 'sm:space-x-14'
  | 'md:space-x-14'
  | 'mg:space-x-14'
  | 'lg:space-x-14'
  | 'xl:space-x-14'
  | 'sm:space-x-15'
  | 'md:space-x-15'
  | 'mg:space-x-15'
  | 'lg:space-x-15'
  | 'xl:space-x-15'
  | 'sm:space-x-16'
  | 'md:space-x-16'
  | 'mg:space-x-16'
  | 'lg:space-x-16'
  | 'xl:space-x-16'
  | 'sm:space-x-17'
  | 'md:space-x-17'
  | 'mg:space-x-17'
  | 'lg:space-x-17'
  | 'xl:space-x-17'
  | 'sm:space-x-18'
  | 'md:space-x-18'
  | 'mg:space-x-18'
  | 'lg:space-x-18'
  | 'xl:space-x-18'
  | 'sm:space-x-20'
  | 'md:space-x-20'
  | 'mg:space-x-20'
  | 'lg:space-x-20'
  | 'xl:space-x-20'
  | 'sm:space-x-21'
  | 'md:space-x-21'
  | 'mg:space-x-21'
  | 'lg:space-x-21'
  | 'xl:space-x-21'
  | 'sm:space-x-22'
  | 'md:space-x-22'
  | 'mg:space-x-22'
  | 'lg:space-x-22'
  | 'xl:space-x-22'
  | 'sm:space-x-24'
  | 'md:space-x-24'
  | 'mg:space-x-24'
  | 'lg:space-x-24'
  | 'xl:space-x-24'
  | 'sm:space-x-28'
  | 'md:space-x-28'
  | 'mg:space-x-28'
  | 'lg:space-x-28'
  | 'xl:space-x-28'
  | 'sm:space-x-30'
  | 'md:space-x-30'
  | 'mg:space-x-30'
  | 'lg:space-x-30'
  | 'xl:space-x-30'
  | 'sm:space-x-32'
  | 'md:space-x-32'
  | 'mg:space-x-32'
  | 'lg:space-x-32'
  | 'xl:space-x-32'
  | 'sm:space-x-36'
  | 'md:space-x-36'
  | 'mg:space-x-36'
  | 'lg:space-x-36'
  | 'xl:space-x-36'
  | 'sm:space-x-40'
  | 'md:space-x-40'
  | 'mg:space-x-40'
  | 'lg:space-x-40'
  | 'xl:space-x-40'
  | 'sm:space-x-44'
  | 'md:space-x-44'
  | 'mg:space-x-44'
  | 'lg:space-x-44'
  | 'xl:space-x-44'
  | 'sm:space-x-48'
  | 'md:space-x-48'
  | 'mg:space-x-48'
  | 'lg:space-x-48'
  | 'xl:space-x-48'
  | 'sm:space-x-52'
  | 'md:space-x-52'
  | 'mg:space-x-52'
  | 'lg:space-x-52'
  | 'xl:space-x-52'
  | 'sm:space-x-56'
  | 'md:space-x-56'
  | 'mg:space-x-56'
  | 'lg:space-x-56'
  | 'xl:space-x-56'
  | 'sm:space-x-60'
  | 'md:space-x-60'
  | 'mg:space-x-60'
  | 'lg:space-x-60'
  | 'xl:space-x-60'
  | 'sm:space-x-64'
  | 'md:space-x-64'
  | 'mg:space-x-64'
  | 'lg:space-x-64'
  | 'xl:space-x-64'
  | 'sm:space-x-72'
  | 'md:space-x-72'
  | 'mg:space-x-72'
  | 'lg:space-x-72'
  | 'xl:space-x-72'
  | 'sm:space-x-80'
  | 'md:space-x-80'
  | 'mg:space-x-80'
  | 'lg:space-x-80'
  | 'xl:space-x-80'
  | 'sm:space-x-96'
  | 'md:space-x-96'
  | 'mg:space-x-96'
  | 'lg:space-x-96'
  | 'xl:space-x-96'
  | 'sm:space-x-px'
  | 'md:space-x-px'
  | 'mg:space-x-px'
  | 'lg:space-x-px'
  | 'xl:space-x-px'
  | 'sm:space-x-0.5'
  | 'md:space-x-0.5'
  | 'mg:space-x-0.5'
  | 'lg:space-x-0.5'
  | 'xl:space-x-0.5'
  | 'sm:space-x-1.5'
  | 'md:space-x-1.5'
  | 'mg:space-x-1.5'
  | 'lg:space-x-1.5'
  | 'xl:space-x-1.5'
  | 'sm:space-x-2.5'
  | 'md:space-x-2.5'
  | 'mg:space-x-2.5'
  | 'lg:space-x-2.5'
  | 'xl:space-x-2.5'
  | 'sm:space-x-3.5'
  | 'md:space-x-3.5'
  | 'mg:space-x-3.5'
  | 'lg:space-x-3.5'
  | 'xl:space-x-3.5'
  | 'sm:-space-x-0'
  | 'md:-space-x-0'
  | 'mg:-space-x-0'
  | 'lg:-space-x-0'
  | 'xl:-space-x-0'
  | 'sm:-space-x-1'
  | 'md:-space-x-1'
  | 'mg:-space-x-1'
  | 'lg:-space-x-1'
  | 'xl:-space-x-1'
  | 'sm:-space-x-2'
  | 'md:-space-x-2'
  | 'mg:-space-x-2'
  | 'lg:-space-x-2'
  | 'xl:-space-x-2'
  | 'sm:-space-x-3'
  | 'md:-space-x-3'
  | 'mg:-space-x-3'
  | 'lg:-space-x-3'
  | 'xl:-space-x-3'
  | 'sm:-space-x-4'
  | 'md:-space-x-4'
  | 'mg:-space-x-4'
  | 'lg:-space-x-4'
  | 'xl:-space-x-4'
  | 'sm:-space-x-5'
  | 'md:-space-x-5'
  | 'mg:-space-x-5'
  | 'lg:-space-x-5'
  | 'xl:-space-x-5'
  | 'sm:-space-x-6'
  | 'md:-space-x-6'
  | 'mg:-space-x-6'
  | 'lg:-space-x-6'
  | 'xl:-space-x-6'
  | 'sm:-space-x-7'
  | 'md:-space-x-7'
  | 'mg:-space-x-7'
  | 'lg:-space-x-7'
  | 'xl:-space-x-7'
  | 'sm:-space-x-8'
  | 'md:-space-x-8'
  | 'mg:-space-x-8'
  | 'lg:-space-x-8'
  | 'xl:-space-x-8'
  | 'sm:-space-x-9'
  | 'md:-space-x-9'
  | 'mg:-space-x-9'
  | 'lg:-space-x-9'
  | 'xl:-space-x-9'
  | 'sm:-space-x-10'
  | 'md:-space-x-10'
  | 'mg:-space-x-10'
  | 'lg:-space-x-10'
  | 'xl:-space-x-10'
  | 'sm:-space-x-11'
  | 'md:-space-x-11'
  | 'mg:-space-x-11'
  | 'lg:-space-x-11'
  | 'xl:-space-x-11'
  | 'sm:-space-x-12'
  | 'md:-space-x-12'
  | 'mg:-space-x-12'
  | 'lg:-space-x-12'
  | 'xl:-space-x-12'
  | 'sm:-space-x-14'
  | 'md:-space-x-14'
  | 'mg:-space-x-14'
  | 'lg:-space-x-14'
  | 'xl:-space-x-14'
  | 'sm:-space-x-16'
  | 'md:-space-x-16'
  | 'mg:-space-x-16'
  | 'lg:-space-x-16'
  | 'xl:-space-x-16'
  | 'sm:-space-x-20'
  | 'md:-space-x-20'
  | 'mg:-space-x-20'
  | 'lg:-space-x-20'
  | 'xl:-space-x-20'
  | 'sm:-space-x-24'
  | 'md:-space-x-24'
  | 'mg:-space-x-24'
  | 'lg:-space-x-24'
  | 'xl:-space-x-24'
  | 'sm:-space-x-28'
  | 'md:-space-x-28'
  | 'mg:-space-x-28'
  | 'lg:-space-x-28'
  | 'xl:-space-x-28'
  | 'sm:-space-x-32'
  | 'md:-space-x-32'
  | 'mg:-space-x-32'
  | 'lg:-space-x-32'
  | 'xl:-space-x-32'
  | 'sm:-space-x-36'
  | 'md:-space-x-36'
  | 'mg:-space-x-36'
  | 'lg:-space-x-36'
  | 'xl:-space-x-36'
  | 'sm:-space-x-40'
  | 'md:-space-x-40'
  | 'mg:-space-x-40'
  | 'lg:-space-x-40'
  | 'xl:-space-x-40'
  | 'sm:-space-x-44'
  | 'md:-space-x-44'
  | 'mg:-space-x-44'
  | 'lg:-space-x-44'
  | 'xl:-space-x-44'
  | 'sm:-space-x-48'
  | 'md:-space-x-48'
  | 'mg:-space-x-48'
  | 'lg:-space-x-48'
  | 'xl:-space-x-48'
  | 'sm:-space-x-52'
  | 'md:-space-x-52'
  | 'mg:-space-x-52'
  | 'lg:-space-x-52'
  | 'xl:-space-x-52'
  | 'sm:-space-x-56'
  | 'md:-space-x-56'
  | 'mg:-space-x-56'
  | 'lg:-space-x-56'
  | 'xl:-space-x-56'
  | 'sm:-space-x-60'
  | 'md:-space-x-60'
  | 'mg:-space-x-60'
  | 'lg:-space-x-60'
  | 'xl:-space-x-60'
  | 'sm:-space-x-64'
  | 'md:-space-x-64'
  | 'mg:-space-x-64'
  | 'lg:-space-x-64'
  | 'xl:-space-x-64'
  | 'sm:-space-x-72'
  | 'md:-space-x-72'
  | 'mg:-space-x-72'
  | 'lg:-space-x-72'
  | 'xl:-space-x-72'
  | 'sm:-space-x-80'
  | 'md:-space-x-80'
  | 'mg:-space-x-80'
  | 'lg:-space-x-80'
  | 'xl:-space-x-80'
  | 'sm:-space-x-96'
  | 'md:-space-x-96'
  | 'mg:-space-x-96'
  | 'lg:-space-x-96'
  | 'xl:-space-x-96'
  | 'sm:-space-x-px'
  | 'md:-space-x-px'
  | 'mg:-space-x-px'
  | 'lg:-space-x-px'
  | 'xl:-space-x-px'
  | 'sm:-space-x-0.5'
  | 'md:-space-x-0.5'
  | 'mg:-space-x-0.5'
  | 'lg:-space-x-0.5'
  | 'xl:-space-x-0.5'
  | 'sm:-space-x-1.5'
  | 'md:-space-x-1.5'
  | 'mg:-space-x-1.5'
  | 'lg:-space-x-1.5'
  | 'xl:-space-x-1.5'
  | 'sm:-space-x-2.5'
  | 'md:-space-x-2.5'
  | 'mg:-space-x-2.5'
  | 'lg:-space-x-2.5'
  | 'xl:-space-x-2.5'
  | 'sm:-space-x-3.5'
  | 'md:-space-x-3.5'
  | 'mg:-space-x-3.5'
  | 'lg:-space-x-3.5'
  | 'xl:-space-x-3.5'
  | 'sm:space-x-1/2'
  | 'md:space-x-1/2'
  | 'mg:space-x-1/2'
  | 'lg:space-x-1/2'
  | 'xl:space-x-1/2'
  | 'sm:space-x-full'
  | 'md:space-x-full'
  | 'mg:space-x-full'
  | 'lg:space-x-full'
  | 'xl:space-x-full'
  | 'sm:space-x-4.5'
  | 'md:space-x-4.5'
  | 'mg:space-x-4.5'
  | 'lg:space-x-4.5'
  | 'xl:space-x-4.5'
  | 'sm:space-x-7.5'
  | 'md:space-x-7.5'
  | 'mg:space-x-7.5'
  | 'lg:space-x-7.5'
  | 'xl:space-x-7.5'
  | 'sm:space-x-9.5'
  | 'md:space-x-9.5'
  | 'mg:space-x-9.5'
  | 'lg:space-x-9.5'
  | 'xl:space-x-9.5'
  | 'sm:space-x-11.5'
  | 'md:space-x-11.5'
  | 'mg:space-x-11.5'
  | 'lg:space-x-11.5'
  | 'xl:space-x-11.5'
  | 'sm:-space-x-15'
  | 'md:-space-x-15'
  | 'mg:-space-x-15'
  | 'lg:-space-x-15'
  | 'xl:-space-x-15'
  | 'sm:-space-x-17'
  | 'md:-space-x-17'
  | 'mg:-space-x-17'
  | 'lg:-space-x-17'
  | 'xl:-space-x-17'
  | 'sm:-space-x-18'
  | 'md:-space-x-18'
  | 'mg:-space-x-18'
  | 'lg:-space-x-18'
  | 'xl:-space-x-18'
  | 'sm:-space-x-21'
  | 'md:-space-x-21'
  | 'mg:-space-x-21'
  | 'lg:-space-x-21'
  | 'xl:-space-x-21'
  | 'sm:-space-x-22'
  | 'md:-space-x-22'
  | 'mg:-space-x-22'
  | 'lg:-space-x-22'
  | 'xl:-space-x-22'
  | 'sm:-space-x-30'
  | 'md:-space-x-30'
  | 'mg:-space-x-30'
  | 'lg:-space-x-30'
  | 'xl:-space-x-30'
  | 'sm:-space-x-1/2'
  | 'md:-space-x-1/2'
  | 'mg:-space-x-1/2'
  | 'lg:-space-x-1/2'
  | 'xl:-space-x-1/2'
  | 'sm:-space-x-full'
  | 'md:-space-x-full'
  | 'mg:-space-x-full'
  | 'lg:-space-x-full'
  | 'xl:-space-x-full'
  | 'sm:-space-x-4.5'
  | 'md:-space-x-4.5'
  | 'mg:-space-x-4.5'
  | 'lg:-space-x-4.5'
  | 'xl:-space-x-4.5'
  | 'sm:-space-x-7.5'
  | 'md:-space-x-7.5'
  | 'mg:-space-x-7.5'
  | 'lg:-space-x-7.5'
  | 'xl:-space-x-7.5'
  | 'sm:-space-x-9.5'
  | 'md:-space-x-9.5'
  | 'mg:-space-x-9.5'
  | 'lg:-space-x-9.5'
  | 'xl:-space-x-9.5'
  | 'sm:-space-x-11.5'
  | 'md:-space-x-11.5'
  | 'mg:-space-x-11.5'
  | 'lg:-space-x-11.5'
  | 'xl:-space-x-11.5'
  | 'sm:space-x-reverse'
  | 'md:space-x-reverse'
  | 'mg:space-x-reverse'
  | 'lg:space-x-reverse'
  | 'xl:space-x-reverse'
  | 'sm:space-y-0'
  | 'md:space-y-0'
  | 'mg:space-y-0'
  | 'lg:space-y-0'
  | 'xl:space-y-0'
  | 'sm:space-y-1'
  | 'md:space-y-1'
  | 'mg:space-y-1'
  | 'lg:space-y-1'
  | 'xl:space-y-1'
  | 'sm:space-y-2'
  | 'md:space-y-2'
  | 'mg:space-y-2'
  | 'lg:space-y-2'
  | 'xl:space-y-2'
  | 'sm:space-y-3'
  | 'md:space-y-3'
  | 'mg:space-y-3'
  | 'lg:space-y-3'
  | 'xl:space-y-3'
  | 'sm:space-y-4'
  | 'md:space-y-4'
  | 'mg:space-y-4'
  | 'lg:space-y-4'
  | 'xl:space-y-4'
  | 'sm:space-y-5'
  | 'md:space-y-5'
  | 'mg:space-y-5'
  | 'lg:space-y-5'
  | 'xl:space-y-5'
  | 'sm:space-y-6'
  | 'md:space-y-6'
  | 'mg:space-y-6'
  | 'lg:space-y-6'
  | 'xl:space-y-6'
  | 'sm:space-y-7'
  | 'md:space-y-7'
  | 'mg:space-y-7'
  | 'lg:space-y-7'
  | 'xl:space-y-7'
  | 'sm:space-y-8'
  | 'md:space-y-8'
  | 'mg:space-y-8'
  | 'lg:space-y-8'
  | 'xl:space-y-8'
  | 'sm:space-y-9'
  | 'md:space-y-9'
  | 'mg:space-y-9'
  | 'lg:space-y-9'
  | 'xl:space-y-9'
  | 'sm:space-y-10'
  | 'md:space-y-10'
  | 'mg:space-y-10'
  | 'lg:space-y-10'
  | 'xl:space-y-10'
  | 'sm:space-y-11'
  | 'md:space-y-11'
  | 'mg:space-y-11'
  | 'lg:space-y-11'
  | 'xl:space-y-11'
  | 'sm:space-y-12'
  | 'md:space-y-12'
  | 'mg:space-y-12'
  | 'lg:space-y-12'
  | 'xl:space-y-12'
  | 'sm:space-y-14'
  | 'md:space-y-14'
  | 'mg:space-y-14'
  | 'lg:space-y-14'
  | 'xl:space-y-14'
  | 'sm:space-y-15'
  | 'md:space-y-15'
  | 'mg:space-y-15'
  | 'lg:space-y-15'
  | 'xl:space-y-15'
  | 'sm:space-y-16'
  | 'md:space-y-16'
  | 'mg:space-y-16'
  | 'lg:space-y-16'
  | 'xl:space-y-16'
  | 'sm:space-y-17'
  | 'md:space-y-17'
  | 'mg:space-y-17'
  | 'lg:space-y-17'
  | 'xl:space-y-17'
  | 'sm:space-y-18'
  | 'md:space-y-18'
  | 'mg:space-y-18'
  | 'lg:space-y-18'
  | 'xl:space-y-18'
  | 'sm:space-y-20'
  | 'md:space-y-20'
  | 'mg:space-y-20'
  | 'lg:space-y-20'
  | 'xl:space-y-20'
  | 'sm:space-y-21'
  | 'md:space-y-21'
  | 'mg:space-y-21'
  | 'lg:space-y-21'
  | 'xl:space-y-21'
  | 'sm:space-y-22'
  | 'md:space-y-22'
  | 'mg:space-y-22'
  | 'lg:space-y-22'
  | 'xl:space-y-22'
  | 'sm:space-y-24'
  | 'md:space-y-24'
  | 'mg:space-y-24'
  | 'lg:space-y-24'
  | 'xl:space-y-24'
  | 'sm:space-y-28'
  | 'md:space-y-28'
  | 'mg:space-y-28'
  | 'lg:space-y-28'
  | 'xl:space-y-28'
  | 'sm:space-y-30'
  | 'md:space-y-30'
  | 'mg:space-y-30'
  | 'lg:space-y-30'
  | 'xl:space-y-30'
  | 'sm:space-y-32'
  | 'md:space-y-32'
  | 'mg:space-y-32'
  | 'lg:space-y-32'
  | 'xl:space-y-32'
  | 'sm:space-y-36'
  | 'md:space-y-36'
  | 'mg:space-y-36'
  | 'lg:space-y-36'
  | 'xl:space-y-36'
  | 'sm:space-y-40'
  | 'md:space-y-40'
  | 'mg:space-y-40'
  | 'lg:space-y-40'
  | 'xl:space-y-40'
  | 'sm:space-y-44'
  | 'md:space-y-44'
  | 'mg:space-y-44'
  | 'lg:space-y-44'
  | 'xl:space-y-44'
  | 'sm:space-y-48'
  | 'md:space-y-48'
  | 'mg:space-y-48'
  | 'lg:space-y-48'
  | 'xl:space-y-48'
  | 'sm:space-y-52'
  | 'md:space-y-52'
  | 'mg:space-y-52'
  | 'lg:space-y-52'
  | 'xl:space-y-52'
  | 'sm:space-y-56'
  | 'md:space-y-56'
  | 'mg:space-y-56'
  | 'lg:space-y-56'
  | 'xl:space-y-56'
  | 'sm:space-y-60'
  | 'md:space-y-60'
  | 'mg:space-y-60'
  | 'lg:space-y-60'
  | 'xl:space-y-60'
  | 'sm:space-y-64'
  | 'md:space-y-64'
  | 'mg:space-y-64'
  | 'lg:space-y-64'
  | 'xl:space-y-64'
  | 'sm:space-y-72'
  | 'md:space-y-72'
  | 'mg:space-y-72'
  | 'lg:space-y-72'
  | 'xl:space-y-72'
  | 'sm:space-y-80'
  | 'md:space-y-80'
  | 'mg:space-y-80'
  | 'lg:space-y-80'
  | 'xl:space-y-80'
  | 'sm:space-y-96'
  | 'md:space-y-96'
  | 'mg:space-y-96'
  | 'lg:space-y-96'
  | 'xl:space-y-96'
  | 'sm:space-y-px'
  | 'md:space-y-px'
  | 'mg:space-y-px'
  | 'lg:space-y-px'
  | 'xl:space-y-px'
  | 'sm:space-y-0.5'
  | 'md:space-y-0.5'
  | 'mg:space-y-0.5'
  | 'lg:space-y-0.5'
  | 'xl:space-y-0.5'
  | 'sm:space-y-1.5'
  | 'md:space-y-1.5'
  | 'mg:space-y-1.5'
  | 'lg:space-y-1.5'
  | 'xl:space-y-1.5'
  | 'sm:space-y-2.5'
  | 'md:space-y-2.5'
  | 'mg:space-y-2.5'
  | 'lg:space-y-2.5'
  | 'xl:space-y-2.5'
  | 'sm:space-y-3.5'
  | 'md:space-y-3.5'
  | 'mg:space-y-3.5'
  | 'lg:space-y-3.5'
  | 'xl:space-y-3.5'
  | 'sm:-space-y-0'
  | 'md:-space-y-0'
  | 'mg:-space-y-0'
  | 'lg:-space-y-0'
  | 'xl:-space-y-0'
  | 'sm:-space-y-1'
  | 'md:-space-y-1'
  | 'mg:-space-y-1'
  | 'lg:-space-y-1'
  | 'xl:-space-y-1'
  | 'sm:-space-y-2'
  | 'md:-space-y-2'
  | 'mg:-space-y-2'
  | 'lg:-space-y-2'
  | 'xl:-space-y-2'
  | 'sm:-space-y-3'
  | 'md:-space-y-3'
  | 'mg:-space-y-3'
  | 'lg:-space-y-3'
  | 'xl:-space-y-3'
  | 'sm:-space-y-4'
  | 'md:-space-y-4'
  | 'mg:-space-y-4'
  | 'lg:-space-y-4'
  | 'xl:-space-y-4'
  | 'sm:-space-y-5'
  | 'md:-space-y-5'
  | 'mg:-space-y-5'
  | 'lg:-space-y-5'
  | 'xl:-space-y-5'
  | 'sm:-space-y-6'
  | 'md:-space-y-6'
  | 'mg:-space-y-6'
  | 'lg:-space-y-6'
  | 'xl:-space-y-6'
  | 'sm:-space-y-7'
  | 'md:-space-y-7'
  | 'mg:-space-y-7'
  | 'lg:-space-y-7'
  | 'xl:-space-y-7'
  | 'sm:-space-y-8'
  | 'md:-space-y-8'
  | 'mg:-space-y-8'
  | 'lg:-space-y-8'
  | 'xl:-space-y-8'
  | 'sm:-space-y-9'
  | 'md:-space-y-9'
  | 'mg:-space-y-9'
  | 'lg:-space-y-9'
  | 'xl:-space-y-9'
  | 'sm:-space-y-10'
  | 'md:-space-y-10'
  | 'mg:-space-y-10'
  | 'lg:-space-y-10'
  | 'xl:-space-y-10'
  | 'sm:-space-y-11'
  | 'md:-space-y-11'
  | 'mg:-space-y-11'
  | 'lg:-space-y-11'
  | 'xl:-space-y-11'
  | 'sm:-space-y-12'
  | 'md:-space-y-12'
  | 'mg:-space-y-12'
  | 'lg:-space-y-12'
  | 'xl:-space-y-12'
  | 'sm:-space-y-14'
  | 'md:-space-y-14'
  | 'mg:-space-y-14'
  | 'lg:-space-y-14'
  | 'xl:-space-y-14'
  | 'sm:-space-y-16'
  | 'md:-space-y-16'
  | 'mg:-space-y-16'
  | 'lg:-space-y-16'
  | 'xl:-space-y-16'
  | 'sm:-space-y-20'
  | 'md:-space-y-20'
  | 'mg:-space-y-20'
  | 'lg:-space-y-20'
  | 'xl:-space-y-20'
  | 'sm:-space-y-24'
  | 'md:-space-y-24'
  | 'mg:-space-y-24'
  | 'lg:-space-y-24'
  | 'xl:-space-y-24'
  | 'sm:-space-y-28'
  | 'md:-space-y-28'
  | 'mg:-space-y-28'
  | 'lg:-space-y-28'
  | 'xl:-space-y-28'
  | 'sm:-space-y-32'
  | 'md:-space-y-32'
  | 'mg:-space-y-32'
  | 'lg:-space-y-32'
  | 'xl:-space-y-32'
  | 'sm:-space-y-36'
  | 'md:-space-y-36'
  | 'mg:-space-y-36'
  | 'lg:-space-y-36'
  | 'xl:-space-y-36'
  | 'sm:-space-y-40'
  | 'md:-space-y-40'
  | 'mg:-space-y-40'
  | 'lg:-space-y-40'
  | 'xl:-space-y-40'
  | 'sm:-space-y-44'
  | 'md:-space-y-44'
  | 'mg:-space-y-44'
  | 'lg:-space-y-44'
  | 'xl:-space-y-44'
  | 'sm:-space-y-48'
  | 'md:-space-y-48'
  | 'mg:-space-y-48'
  | 'lg:-space-y-48'
  | 'xl:-space-y-48'
  | 'sm:-space-y-52'
  | 'md:-space-y-52'
  | 'mg:-space-y-52'
  | 'lg:-space-y-52'
  | 'xl:-space-y-52'
  | 'sm:-space-y-56'
  | 'md:-space-y-56'
  | 'mg:-space-y-56'
  | 'lg:-space-y-56'
  | 'xl:-space-y-56'
  | 'sm:-space-y-60'
  | 'md:-space-y-60'
  | 'mg:-space-y-60'
  | 'lg:-space-y-60'
  | 'xl:-space-y-60'
  | 'sm:-space-y-64'
  | 'md:-space-y-64'
  | 'mg:-space-y-64'
  | 'lg:-space-y-64'
  | 'xl:-space-y-64'
  | 'sm:-space-y-72'
  | 'md:-space-y-72'
  | 'mg:-space-y-72'
  | 'lg:-space-y-72'
  | 'xl:-space-y-72'
  | 'sm:-space-y-80'
  | 'md:-space-y-80'
  | 'mg:-space-y-80'
  | 'lg:-space-y-80'
  | 'xl:-space-y-80'
  | 'sm:-space-y-96'
  | 'md:-space-y-96'
  | 'mg:-space-y-96'
  | 'lg:-space-y-96'
  | 'xl:-space-y-96'
  | 'sm:-space-y-px'
  | 'md:-space-y-px'
  | 'mg:-space-y-px'
  | 'lg:-space-y-px'
  | 'xl:-space-y-px'
  | 'sm:-space-y-0.5'
  | 'md:-space-y-0.5'
  | 'mg:-space-y-0.5'
  | 'lg:-space-y-0.5'
  | 'xl:-space-y-0.5'
  | 'sm:-space-y-1.5'
  | 'md:-space-y-1.5'
  | 'mg:-space-y-1.5'
  | 'lg:-space-y-1.5'
  | 'xl:-space-y-1.5'
  | 'sm:-space-y-2.5'
  | 'md:-space-y-2.5'
  | 'mg:-space-y-2.5'
  | 'lg:-space-y-2.5'
  | 'xl:-space-y-2.5'
  | 'sm:-space-y-3.5'
  | 'md:-space-y-3.5'
  | 'mg:-space-y-3.5'
  | 'lg:-space-y-3.5'
  | 'xl:-space-y-3.5'
  | 'sm:space-y-1/2'
  | 'md:space-y-1/2'
  | 'mg:space-y-1/2'
  | 'lg:space-y-1/2'
  | 'xl:space-y-1/2'
  | 'sm:space-y-full'
  | 'md:space-y-full'
  | 'mg:space-y-full'
  | 'lg:space-y-full'
  | 'xl:space-y-full'
  | 'sm:space-y-4.5'
  | 'md:space-y-4.5'
  | 'mg:space-y-4.5'
  | 'lg:space-y-4.5'
  | 'xl:space-y-4.5'
  | 'sm:space-y-7.5'
  | 'md:space-y-7.5'
  | 'mg:space-y-7.5'
  | 'lg:space-y-7.5'
  | 'xl:space-y-7.5'
  | 'sm:space-y-9.5'
  | 'md:space-y-9.5'
  | 'mg:space-y-9.5'
  | 'lg:space-y-9.5'
  | 'xl:space-y-9.5'
  | 'sm:space-y-11.5'
  | 'md:space-y-11.5'
  | 'mg:space-y-11.5'
  | 'lg:space-y-11.5'
  | 'xl:space-y-11.5'
  | 'sm:-space-y-15'
  | 'md:-space-y-15'
  | 'mg:-space-y-15'
  | 'lg:-space-y-15'
  | 'xl:-space-y-15'
  | 'sm:-space-y-17'
  | 'md:-space-y-17'
  | 'mg:-space-y-17'
  | 'lg:-space-y-17'
  | 'xl:-space-y-17'
  | 'sm:-space-y-18'
  | 'md:-space-y-18'
  | 'mg:-space-y-18'
  | 'lg:-space-y-18'
  | 'xl:-space-y-18'
  | 'sm:-space-y-21'
  | 'md:-space-y-21'
  | 'mg:-space-y-21'
  | 'lg:-space-y-21'
  | 'xl:-space-y-21'
  | 'sm:-space-y-22'
  | 'md:-space-y-22'
  | 'mg:-space-y-22'
  | 'lg:-space-y-22'
  | 'xl:-space-y-22'
  | 'sm:-space-y-30'
  | 'md:-space-y-30'
  | 'mg:-space-y-30'
  | 'lg:-space-y-30'
  | 'xl:-space-y-30'
  | 'sm:-space-y-1/2'
  | 'md:-space-y-1/2'
  | 'mg:-space-y-1/2'
  | 'lg:-space-y-1/2'
  | 'xl:-space-y-1/2'
  | 'sm:-space-y-full'
  | 'md:-space-y-full'
  | 'mg:-space-y-full'
  | 'lg:-space-y-full'
  | 'xl:-space-y-full'
  | 'sm:-space-y-4.5'
  | 'md:-space-y-4.5'
  | 'mg:-space-y-4.5'
  | 'lg:-space-y-4.5'
  | 'xl:-space-y-4.5'
  | 'sm:-space-y-7.5'
  | 'md:-space-y-7.5'
  | 'mg:-space-y-7.5'
  | 'lg:-space-y-7.5'
  | 'xl:-space-y-7.5'
  | 'sm:-space-y-9.5'
  | 'md:-space-y-9.5'
  | 'mg:-space-y-9.5'
  | 'lg:-space-y-9.5'
  | 'xl:-space-y-9.5'
  | 'sm:-space-y-11.5'
  | 'md:-space-y-11.5'
  | 'mg:-space-y-11.5'
  | 'lg:-space-y-11.5'
  | 'xl:-space-y-11.5'
  | 'sm:space-y-reverse'
  | 'md:space-y-reverse'
  | 'mg:space-y-reverse'
  | 'lg:space-y-reverse'
  | 'xl:space-y-reverse'
  | 'sm:stroke-current'
  | 'md:stroke-current'
  | 'mg:stroke-current'
  | 'lg:stroke-current'
  | 'xl:stroke-current'
  | 'sm:stroke-0'
  | 'md:stroke-0'
  | 'mg:stroke-0'
  | 'lg:stroke-0'
  | 'xl:stroke-0'
  | 'sm:stroke-1'
  | 'md:stroke-1'
  | 'mg:stroke-1'
  | 'lg:stroke-1'
  | 'xl:stroke-1'
  | 'sm:stroke-2'
  | 'md:stroke-2'
  | 'mg:stroke-2'
  | 'lg:stroke-2'
  | 'xl:stroke-2'
  | 'sm:table-auto'
  | 'md:table-auto'
  | 'mg:table-auto'
  | 'lg:table-auto'
  | 'xl:table-auto'
  | 'sm:table-fixed'
  | 'md:table-fixed'
  | 'mg:table-fixed'
  | 'lg:table-fixed'
  | 'xl:table-fixed'
  | 'sm:text-left'
  | 'md:text-left'
  | 'mg:text-left'
  | 'lg:text-left'
  | 'xl:text-left'
  | 'sm:text-center'
  | 'md:text-center'
  | 'mg:text-center'
  | 'lg:text-center'
  | 'xl:text-center'
  | 'sm:text-right'
  | 'md:text-right'
  | 'mg:text-right'
  | 'lg:text-right'
  | 'xl:text-right'
  | 'sm:text-justify'
  | 'md:text-justify'
  | 'mg:text-justify'
  | 'lg:text-justify'
  | 'xl:text-justify'
  | 'sm:text-transparent'
  | 'md:text-transparent'
  | 'mg:text-transparent'
  | 'lg:text-transparent'
  | 'xl:text-transparent'
  | 'group-hover:text-transparent'
  | 'focus-within:text-transparent'
  | 'hover:text-transparent'
  | 'focus:text-transparent'
  | 'sm:text-current'
  | 'md:text-current'
  | 'mg:text-current'
  | 'lg:text-current'
  | 'xl:text-current'
  | 'group-hover:text-current'
  | 'focus-within:text-current'
  | 'hover:text-current'
  | 'focus:text-current'
  | 'sm:text-overlay'
  | 'md:text-overlay'
  | 'mg:text-overlay'
  | 'lg:text-overlay'
  | 'xl:text-overlay'
  | 'group-hover:text-overlay'
  | 'focus-within:text-overlay'
  | 'hover:text-overlay'
  | 'focus:text-overlay'
  | 'sm:text-black'
  | 'md:text-black'
  | 'mg:text-black'
  | 'lg:text-black'
  | 'xl:text-black'
  | 'group-hover:text-black'
  | 'focus-within:text-black'
  | 'hover:text-black'
  | 'focus:text-black'
  | 'sm:text-white'
  | 'md:text-white'
  | 'mg:text-white'
  | 'lg:text-white'
  | 'xl:text-white'
  | 'group-hover:text-white'
  | 'focus-within:text-white'
  | 'hover:text-white'
  | 'focus:text-white'
  | 'sm:text-white-hover'
  | 'md:text-white-hover'
  | 'mg:text-white-hover'
  | 'lg:text-white-hover'
  | 'xl:text-white-hover'
  | 'group-hover:text-white-hover'
  | 'focus-within:text-white-hover'
  | 'hover:text-white-hover'
  | 'focus:text-white-hover'
  | 'sm:text-white-pressed'
  | 'md:text-white-pressed'
  | 'mg:text-white-pressed'
  | 'lg:text-white-pressed'
  | 'xl:text-white-pressed'
  | 'group-hover:text-white-pressed'
  | 'focus-within:text-white-pressed'
  | 'hover:text-white-pressed'
  | 'focus:text-white-pressed'
  | 'sm:text-product-acid'
  | 'md:text-product-acid'
  | 'mg:text-product-acid'
  | 'lg:text-product-acid'
  | 'xl:text-product-acid'
  | 'group-hover:text-product-acid'
  | 'focus-within:text-product-acid'
  | 'hover:text-product-acid'
  | 'focus:text-product-acid'
  | 'sm:text-product-aura'
  | 'md:text-product-aura'
  | 'mg:text-product-aura'
  | 'lg:text-product-aura'
  | 'xl:text-product-aura'
  | 'group-hover:text-product-aura'
  | 'focus-within:text-product-aura'
  | 'hover:text-product-aura'
  | 'focus:text-product-aura'
  | 'sm:text-product-azul'
  | 'md:text-product-azul'
  | 'mg:text-product-azul'
  | 'lg:text-product-azul'
  | 'xl:text-product-azul'
  | 'group-hover:text-product-azul'
  | 'focus-within:text-product-azul'
  | 'hover:text-product-azul'
  | 'focus:text-product-azul'
  | 'sm:text-product-blanch'
  | 'md:text-product-blanch'
  | 'mg:text-product-blanch'
  | 'lg:text-product-blanch'
  | 'xl:text-product-blanch'
  | 'group-hover:text-product-blanch'
  | 'focus-within:text-product-blanch'
  | 'hover:text-product-blanch'
  | 'focus:text-product-blanch'
  | 'sm:text-product-blue-salt'
  | 'md:text-product-blue-salt'
  | 'mg:text-product-blue-salt'
  | 'lg:text-product-blue-salt'
  | 'xl:text-product-blue-salt'
  | 'group-hover:text-product-blue-salt'
  | 'focus-within:text-product-blue-salt'
  | 'hover:text-product-blue-salt'
  | 'focus:text-product-blue-salt'
  | 'sm:text-product-burgundy'
  | 'md:text-product-burgundy'
  | 'mg:text-product-burgundy'
  | 'lg:text-product-burgundy'
  | 'xl:text-product-burgundy'
  | 'group-hover:text-product-burgundy'
  | 'focus-within:text-product-burgundy'
  | 'hover:text-product-burgundy'
  | 'focus:text-product-burgundy'
  | 'sm:text-product-butter-yellow'
  | 'md:text-product-butter-yellow'
  | 'mg:text-product-butter-yellow'
  | 'lg:text-product-butter-yellow'
  | 'xl:text-product-butter-yellow'
  | 'group-hover:text-product-butter-yellow'
  | 'focus-within:text-product-butter-yellow'
  | 'hover:text-product-butter-yellow'
  | 'focus:text-product-butter-yellow'
  | 'sm:text-product-chai'
  | 'md:text-product-chai'
  | 'mg:text-product-chai'
  | 'lg:text-product-chai'
  | 'xl:text-product-chai'
  | 'group-hover:text-product-chai'
  | 'focus-within:text-product-chai'
  | 'hover:text-product-chai'
  | 'focus:text-product-chai'
  | 'sm:text-product-char'
  | 'md:text-product-char'
  | 'mg:text-product-char'
  | 'lg:text-product-char'
  | 'xl:text-product-char'
  | 'group-hover:text-product-char'
  | 'focus-within:text-product-char'
  | 'hover:text-product-char'
  | 'focus:text-product-char'
  | 'sm:text-product-charm'
  | 'md:text-product-charm'
  | 'mg:text-product-charm'
  | 'lg:text-product-charm'
  | 'xl:text-product-charm'
  | 'group-hover:text-product-charm'
  | 'focus-within:text-product-charm'
  | 'hover:text-product-charm'
  | 'focus:text-product-charm'
  | 'sm:text-product-chickpea'
  | 'md:text-product-chickpea'
  | 'mg:text-product-chickpea'
  | 'lg:text-product-chickpea'
  | 'xl:text-product-chickpea'
  | 'group-hover:text-product-chickpea'
  | 'focus-within:text-product-chickpea'
  | 'hover:text-product-chickpea'
  | 'focus:text-product-chickpea'
  | 'sm:text-product-cielo'
  | 'md:text-product-cielo'
  | 'mg:text-product-cielo'
  | 'lg:text-product-cielo'
  | 'xl:text-product-cielo'
  | 'group-hover:text-product-cielo'
  | 'focus-within:text-product-cielo'
  | 'hover:text-product-cielo'
  | 'focus:text-product-cielo'
  | 'sm:text-product-clay'
  | 'md:text-product-clay'
  | 'mg:text-product-clay'
  | 'lg:text-product-clay'
  | 'xl:text-product-clay'
  | 'group-hover:text-product-clay'
  | 'focus-within:text-product-clay'
  | 'hover:text-product-clay'
  | 'focus:text-product-clay'
  | 'sm:text-product-clear'
  | 'md:text-product-clear'
  | 'mg:text-product-clear'
  | 'lg:text-product-clear'
  | 'xl:text-product-clear'
  | 'group-hover:text-product-clear'
  | 'focus-within:text-product-clear'
  | 'hover:text-product-clear'
  | 'focus:text-product-clear'
  | 'sm:text-product-coriander'
  | 'md:text-product-coriander'
  | 'mg:text-product-coriander'
  | 'lg:text-product-coriander'
  | 'xl:text-product-coriander'
  | 'group-hover:text-product-coriander'
  | 'focus-within:text-product-coriander'
  | 'hover:text-product-coriander'
  | 'focus:text-product-coriander'
  | 'sm:text-product-cream'
  | 'md:text-product-cream'
  | 'mg:text-product-cream'
  | 'lg:text-product-cream'
  | 'xl:text-product-cream'
  | 'group-hover:text-product-cream'
  | 'focus-within:text-product-cream'
  | 'hover:text-product-cream'
  | 'focus:text-product-cream'
  | 'sm:text-product-crescent'
  | 'md:text-product-crescent'
  | 'mg:text-product-crescent'
  | 'lg:text-product-crescent'
  | 'xl:text-product-crescent'
  | 'group-hover:text-product-crescent'
  | 'focus-within:text-product-crescent'
  | 'hover:text-product-crescent'
  | 'focus:text-product-crescent'
  | 'sm:text-product-dawn'
  | 'md:text-product-dawn'
  | 'mg:text-product-dawn'
  | 'lg:text-product-dawn'
  | 'xl:text-product-dawn'
  | 'group-hover:text-product-dawn'
  | 'focus-within:text-product-dawn'
  | 'hover:text-product-dawn'
  | 'focus:text-product-dawn'
  | 'sm:text-product-dusk'
  | 'md:text-product-dusk'
  | 'mg:text-product-dusk'
  | 'lg:text-product-dusk'
  | 'xl:text-product-dusk'
  | 'group-hover:text-product-dusk'
  | 'focus-within:text-product-dusk'
  | 'hover:text-product-dusk'
  | 'focus:text-product-dusk'
  | 'sm:text-product-egg-yolk'
  | 'md:text-product-egg-yolk'
  | 'mg:text-product-egg-yolk'
  | 'lg:text-product-egg-yolk'
  | 'xl:text-product-egg-yolk'
  | 'group-hover:text-product-egg-yolk'
  | 'focus-within:text-product-egg-yolk'
  | 'hover:text-product-egg-yolk'
  | 'focus:text-product-egg-yolk'
  | 'sm:text-product-espresso'
  | 'md:text-product-espresso'
  | 'mg:text-product-espresso'
  | 'lg:text-product-espresso'
  | 'xl:text-product-espresso'
  | 'group-hover:text-product-espresso'
  | 'focus-within:text-product-espresso'
  | 'hover:text-product-espresso'
  | 'focus:text-product-espresso'
  | 'sm:text-product-eve'
  | 'md:text-product-eve'
  | 'mg:text-product-eve'
  | 'lg:text-product-eve'
  | 'xl:text-product-eve'
  | 'group-hover:text-product-eve'
  | 'focus-within:text-product-eve'
  | 'hover:text-product-eve'
  | 'focus:text-product-eve'
  | 'sm:text-product-firecracker'
  | 'md:text-product-firecracker'
  | 'mg:text-product-firecracker'
  | 'lg:text-product-firecracker'
  | 'xl:text-product-firecracker'
  | 'group-hover:text-product-firecracker'
  | 'focus-within:text-product-firecracker'
  | 'hover:text-product-firecracker'
  | 'focus:text-product-firecracker'
  | 'sm:text-product-forget-me-not-blue'
  | 'md:text-product-forget-me-not-blue'
  | 'mg:text-product-forget-me-not-blue'
  | 'lg:text-product-forget-me-not-blue'
  | 'xl:text-product-forget-me-not-blue'
  | 'group-hover:text-product-forget-me-not-blue'
  | 'focus-within:text-product-forget-me-not-blue'
  | 'hover:text-product-forget-me-not-blue'
  | 'focus:text-product-forget-me-not-blue'
  | 'sm:text-product-gold'
  | 'md:text-product-gold'
  | 'mg:text-product-gold'
  | 'lg:text-product-gold'
  | 'xl:text-product-gold'
  | 'group-hover:text-product-gold'
  | 'focus-within:text-product-gold'
  | 'hover:text-product-gold'
  | 'focus:text-product-gold'
  | 'sm:text-product-golden'
  | 'md:text-product-golden'
  | 'mg:text-product-golden'
  | 'lg:text-product-golden'
  | 'xl:text-product-golden'
  | 'group-hover:text-product-golden'
  | 'focus-within:text-product-golden'
  | 'hover:text-product-golden'
  | 'focus:text-product-golden'
  | 'sm:text-product-heat'
  | 'md:text-product-heat'
  | 'mg:text-product-heat'
  | 'lg:text-product-heat'
  | 'xl:text-product-heat'
  | 'group-hover:text-product-heat'
  | 'focus-within:text-product-heat'
  | 'hover:text-product-heat'
  | 'focus:text-product-heat'
  | 'sm:text-product-himalayan-salt'
  | 'md:text-product-himalayan-salt'
  | 'mg:text-product-himalayan-salt'
  | 'lg:text-product-himalayan-salt'
  | 'xl:text-product-himalayan-salt'
  | 'group-hover:text-product-himalayan-salt'
  | 'focus-within:text-product-himalayan-salt'
  | 'hover:text-product-himalayan-salt'
  | 'focus:text-product-himalayan-salt'
  | 'sm:text-product-indigo'
  | 'md:text-product-indigo'
  | 'mg:text-product-indigo'
  | 'lg:text-product-indigo'
  | 'xl:text-product-indigo'
  | 'group-hover:text-product-indigo'
  | 'focus-within:text-product-indigo'
  | 'hover:text-product-indigo'
  | 'focus:text-product-indigo'
  | 'sm:text-product-lavender'
  | 'md:text-product-lavender'
  | 'mg:text-product-lavender'
  | 'lg:text-product-lavender'
  | 'xl:text-product-lavender'
  | 'group-hover:text-product-lavender'
  | 'focus-within:text-product-lavender'
  | 'hover:text-product-lavender'
  | 'focus:text-product-lavender'
  | 'sm:text-product-lavender-marble'
  | 'md:text-product-lavender-marble'
  | 'mg:text-product-lavender-marble'
  | 'lg:text-product-lavender-marble'
  | 'xl:text-product-lavender-marble'
  | 'group-hover:text-product-lavender-marble'
  | 'focus-within:text-product-lavender-marble'
  | 'hover:text-product-lavender-marble'
  | 'focus:text-product-lavender-marble'
  | 'sm:text-product-midnight-marble'
  | 'md:text-product-midnight-marble'
  | 'mg:text-product-midnight-marble'
  | 'lg:text-product-midnight-marble'
  | 'xl:text-product-midnight-marble'
  | 'group-hover:text-product-midnight-marble'
  | 'focus-within:text-product-midnight-marble'
  | 'hover:text-product-midnight-marble'
  | 'focus:text-product-midnight-marble'
  | 'sm:text-product-nougat'
  | 'md:text-product-nougat'
  | 'mg:text-product-nougat'
  | 'lg:text-product-nougat'
  | 'xl:text-product-nougat'
  | 'group-hover:text-product-nougat'
  | 'focus-within:text-product-nougat'
  | 'hover:text-product-nougat'
  | 'focus:text-product-nougat'
  | 'sm:text-product-pistachio'
  | 'md:text-product-pistachio'
  | 'mg:text-product-pistachio'
  | 'lg:text-product-pistachio'
  | 'xl:text-product-pistachio'
  | 'group-hover:text-product-pistachio'
  | 'focus-within:text-product-pistachio'
  | 'hover:text-product-pistachio'
  | 'focus:text-product-pistachio'
  | 'sm:text-product-rosa'
  | 'md:text-product-rosa'
  | 'mg:text-product-rosa'
  | 'lg:text-product-rosa'
  | 'xl:text-product-rosa'
  | 'group-hover:text-product-rosa'
  | 'focus-within:text-product-rosa'
  | 'hover:text-product-rosa'
  | 'focus:text-product-rosa'
  | 'sm:text-product-rose-gold'
  | 'md:text-product-rose-gold'
  | 'mg:text-product-rose-gold'
  | 'lg:text-product-rose-gold'
  | 'xl:text-product-rose-gold'
  | 'group-hover:text-product-rose-gold'
  | 'focus-within:text-product-rose-gold'
  | 'hover:text-product-rose-gold'
  | 'focus:text-product-rose-gold'
  | 'sm:text-product-rust'
  | 'md:text-product-rust'
  | 'mg:text-product-rust'
  | 'lg:text-product-rust'
  | 'xl:text-product-rust'
  | 'group-hover:text-product-rust'
  | 'focus-within:text-product-rust'
  | 'hover:text-product-rust'
  | 'focus:text-product-rust'
  | 'sm:text-product-saffron'
  | 'md:text-product-saffron'
  | 'mg:text-product-saffron'
  | 'lg:text-product-saffron'
  | 'xl:text-product-saffron'
  | 'group-hover:text-product-saffron'
  | 'focus-within:text-product-saffron'
  | 'hover:text-product-saffron'
  | 'focus:text-product-saffron'
  | 'sm:text-product-sage'
  | 'md:text-product-sage'
  | 'mg:text-product-sage'
  | 'lg:text-product-sage'
  | 'xl:text-product-sage'
  | 'group-hover:text-product-sage'
  | 'focus-within:text-product-sage'
  | 'hover:text-product-sage'
  | 'focus:text-product-sage'
  | 'sm:text-product-sear'
  | 'md:text-product-sear'
  | 'mg:text-product-sear'
  | 'lg:text-product-sear'
  | 'xl:text-product-sear'
  | 'group-hover:text-product-sear'
  | 'focus-within:text-product-sear'
  | 'hover:text-product-sear'
  | 'focus:text-product-sear'
  | 'sm:text-product-spice'
  | 'md:text-product-spice'
  | 'mg:text-product-spice'
  | 'lg:text-product-spice'
  | 'xl:text-product-spice'
  | 'group-hover:text-product-spice'
  | 'focus-within:text-product-spice'
  | 'hover:text-product-spice'
  | 'focus:text-product-spice'
  | 'sm:text-product-steam'
  | 'md:text-product-steam'
  | 'mg:text-product-steam'
  | 'lg:text-product-steam'
  | 'xl:text-product-steam'
  | 'group-hover:text-product-steam'
  | 'focus-within:text-product-steam'
  | 'hover:text-product-steam'
  | 'focus:text-product-steam'
  | 'sm:text-product-strawberry'
  | 'md:text-product-strawberry'
  | 'mg:text-product-strawberry'
  | 'lg:text-product-strawberry'
  | 'xl:text-product-strawberry'
  | 'group-hover:text-product-strawberry'
  | 'focus-within:text-product-strawberry'
  | 'hover:text-product-strawberry'
  | 'focus:text-product-strawberry'
  | 'sm:text-product-sunrise'
  | 'md:text-product-sunrise'
  | 'mg:text-product-sunrise'
  | 'lg:text-product-sunrise'
  | 'xl:text-product-sunrise'
  | 'group-hover:text-product-sunrise'
  | 'focus-within:text-product-sunrise'
  | 'hover:text-product-sunrise'
  | 'focus:text-product-sunrise'
  | 'sm:text-product-sunset'
  | 'md:text-product-sunset'
  | 'mg:text-product-sunset'
  | 'lg:text-product-sunset'
  | 'xl:text-product-sunset'
  | 'group-hover:text-product-sunset'
  | 'focus-within:text-product-sunset'
  | 'hover:text-product-sunset'
  | 'focus:text-product-sunset'
  | 'sm:text-product-sunset-marble'
  | 'md:text-product-sunset-marble'
  | 'mg:text-product-sunset-marble'
  | 'lg:text-product-sunset-marble'
  | 'xl:text-product-sunset-marble'
  | 'group-hover:text-product-sunset-marble'
  | 'focus-within:text-product-sunset-marble'
  | 'hover:text-product-sunset-marble'
  | 'focus:text-product-sunset-marble'
  | 'sm:text-product-terracotta'
  | 'md:text-product-terracotta'
  | 'mg:text-product-terracotta'
  | 'lg:text-product-terracotta'
  | 'xl:text-product-terracotta'
  | 'group-hover:text-product-terracotta'
  | 'focus-within:text-product-terracotta'
  | 'hover:text-product-terracotta'
  | 'focus:text-product-terracotta'
  | 'sm:text-product-tierra'
  | 'md:text-product-tierra'
  | 'mg:text-product-tierra'
  | 'lg:text-product-tierra'
  | 'xl:text-product-tierra'
  | 'group-hover:text-product-tierra'
  | 'focus-within:text-product-tierra'
  | 'hover:text-product-tierra'
  | 'focus:text-product-tierra'
  | 'sm:text-product-turmeric'
  | 'md:text-product-turmeric'
  | 'mg:text-product-turmeric'
  | 'lg:text-product-turmeric'
  | 'xl:text-product-turmeric'
  | 'group-hover:text-product-turmeric'
  | 'focus-within:text-product-turmeric'
  | 'hover:text-product-turmeric'
  | 'focus:text-product-turmeric'
  | 'sm:text-product-turqoise'
  | 'md:text-product-turqoise'
  | 'mg:text-product-turqoise'
  | 'lg:text-product-turqoise'
  | 'xl:text-product-turqoise'
  | 'group-hover:text-product-turqoise'
  | 'focus-within:text-product-turqoise'
  | 'hover:text-product-turqoise'
  | 'focus:text-product-turqoise'
  | 'sm:text-product-twilight'
  | 'md:text-product-twilight'
  | 'mg:text-product-twilight'
  | 'lg:text-product-twilight'
  | 'xl:text-product-twilight'
  | 'group-hover:text-product-twilight'
  | 'focus-within:text-product-twilight'
  | 'hover:text-product-twilight'
  | 'focus:text-product-twilight'
  | 'sm:text-product-walnut'
  | 'md:text-product-walnut'
  | 'mg:text-product-walnut'
  | 'lg:text-product-walnut'
  | 'xl:text-product-walnut'
  | 'group-hover:text-product-walnut'
  | 'focus-within:text-product-walnut'
  | 'hover:text-product-walnut'
  | 'focus:text-product-walnut'
  | 'sm:text-product-warm-white'
  | 'md:text-product-warm-white'
  | 'mg:text-product-warm-white'
  | 'lg:text-product-warm-white'
  | 'xl:text-product-warm-white'
  | 'group-hover:text-product-warm-white'
  | 'focus-within:text-product-warm-white'
  | 'hover:text-product-warm-white'
  | 'focus:text-product-warm-white'
  | 'sm:text-product-zest'
  | 'md:text-product-zest'
  | 'mg:text-product-zest'
  | 'lg:text-product-zest'
  | 'xl:text-product-zest'
  | 'group-hover:text-product-zest'
  | 'focus-within:text-product-zest'
  | 'hover:text-product-zest'
  | 'focus:text-product-zest'
  | 'sm:text-placeholder'
  | 'md:text-placeholder'
  | 'mg:text-placeholder'
  | 'lg:text-placeholder'
  | 'xl:text-placeholder'
  | 'group-hover:text-placeholder'
  | 'focus-within:text-placeholder'
  | 'hover:text-placeholder'
  | 'focus:text-placeholder'
  | 'sm:text-interactive-bone'
  | 'md:text-interactive-bone'
  | 'mg:text-interactive-bone'
  | 'lg:text-interactive-bone'
  | 'xl:text-interactive-bone'
  | 'group-hover:text-interactive-bone'
  | 'focus-within:text-interactive-bone'
  | 'hover:text-interactive-bone'
  | 'focus:text-interactive-bone'
  | 'sm:text-interactive-brick'
  | 'md:text-interactive-brick'
  | 'mg:text-interactive-brick'
  | 'lg:text-interactive-brick'
  | 'xl:text-interactive-brick'
  | 'group-hover:text-interactive-brick'
  | 'focus-within:text-interactive-brick'
  | 'hover:text-interactive-brick'
  | 'focus:text-interactive-brick'
  | 'sm:text-interactive-char'
  | 'md:text-interactive-char'
  | 'mg:text-interactive-char'
  | 'lg:text-interactive-char'
  | 'xl:text-interactive-char'
  | 'group-hover:text-interactive-char'
  | 'focus-within:text-interactive-char'
  | 'hover:text-interactive-char'
  | 'focus:text-interactive-char'
  | 'sm:text-interactive-white'
  | 'md:text-interactive-white'
  | 'mg:text-interactive-white'
  | 'lg:text-interactive-white'
  | 'xl:text-interactive-white'
  | 'group-hover:text-interactive-white'
  | 'focus-within:text-interactive-white'
  | 'hover:text-interactive-white'
  | 'focus:text-interactive-white'
  | 'sm:text-interactive-disabled'
  | 'md:text-interactive-disabled'
  | 'mg:text-interactive-disabled'
  | 'lg:text-interactive-disabled'
  | 'xl:text-interactive-disabled'
  | 'group-hover:text-interactive-disabled'
  | 'focus-within:text-interactive-disabled'
  | 'hover:text-interactive-disabled'
  | 'focus:text-interactive-disabled'
  | 'sm:text-interactive-error'
  | 'md:text-interactive-error'
  | 'mg:text-interactive-error'
  | 'lg:text-interactive-error'
  | 'xl:text-interactive-error'
  | 'group-hover:text-interactive-error'
  | 'focus-within:text-interactive-error'
  | 'hover:text-interactive-error'
  | 'focus:text-interactive-error'
  | 'sm:text-interactive-outline'
  | 'md:text-interactive-outline'
  | 'mg:text-interactive-outline'
  | 'lg:text-interactive-outline'
  | 'xl:text-interactive-outline'
  | 'group-hover:text-interactive-outline'
  | 'focus-within:text-interactive-outline'
  | 'hover:text-interactive-outline'
  | 'focus:text-interactive-outline'
  | 'sm:text-translucent-char'
  | 'md:text-translucent-char'
  | 'mg:text-translucent-char'
  | 'lg:text-translucent-char'
  | 'xl:text-translucent-char'
  | 'group-hover:text-translucent-char'
  | 'focus-within:text-translucent-char'
  | 'hover:text-translucent-char'
  | 'focus:text-translucent-char'
  | 'sm:text-translucent-white'
  | 'md:text-translucent-white'
  | 'mg:text-translucent-white'
  | 'lg:text-translucent-white'
  | 'xl:text-translucent-white'
  | 'group-hover:text-translucent-white'
  | 'focus-within:text-translucent-white'
  | 'hover:text-translucent-white'
  | 'focus:text-translucent-white'
  | 'sm:text-char-50'
  | 'md:text-char-50'
  | 'mg:text-char-50'
  | 'lg:text-char-50'
  | 'xl:text-char-50'
  | 'group-hover:text-char-50'
  | 'focus-within:text-char-50'
  | 'hover:text-char-50'
  | 'focus:text-char-50'
  | 'sm:text-char-100'
  | 'md:text-char-100'
  | 'mg:text-char-100'
  | 'lg:text-char-100'
  | 'xl:text-char-100'
  | 'group-hover:text-char-100'
  | 'focus-within:text-char-100'
  | 'hover:text-char-100'
  | 'focus:text-char-100'
  | 'sm:text-char-200'
  | 'md:text-char-200'
  | 'mg:text-char-200'
  | 'lg:text-char-200'
  | 'xl:text-char-200'
  | 'group-hover:text-char-200'
  | 'focus-within:text-char-200'
  | 'hover:text-char-200'
  | 'focus:text-char-200'
  | 'sm:text-char-300'
  | 'md:text-char-300'
  | 'mg:text-char-300'
  | 'lg:text-char-300'
  | 'xl:text-char-300'
  | 'group-hover:text-char-300'
  | 'focus-within:text-char-300'
  | 'hover:text-char-300'
  | 'focus:text-char-300'
  | 'sm:text-char-400'
  | 'md:text-char-400'
  | 'mg:text-char-400'
  | 'lg:text-char-400'
  | 'xl:text-char-400'
  | 'group-hover:text-char-400'
  | 'focus-within:text-char-400'
  | 'hover:text-char-400'
  | 'focus:text-char-400'
  | 'sm:text-char-500'
  | 'md:text-char-500'
  | 'mg:text-char-500'
  | 'lg:text-char-500'
  | 'xl:text-char-500'
  | 'group-hover:text-char-500'
  | 'focus-within:text-char-500'
  | 'hover:text-char-500'
  | 'focus:text-char-500'
  | 'sm:text-char-600'
  | 'md:text-char-600'
  | 'mg:text-char-600'
  | 'lg:text-char-600'
  | 'xl:text-char-600'
  | 'group-hover:text-char-600'
  | 'focus-within:text-char-600'
  | 'hover:text-char-600'
  | 'focus:text-char-600'
  | 'sm:text-char-700'
  | 'md:text-char-700'
  | 'mg:text-char-700'
  | 'lg:text-char-700'
  | 'xl:text-char-700'
  | 'group-hover:text-char-700'
  | 'focus-within:text-char-700'
  | 'hover:text-char-700'
  | 'focus:text-char-700'
  | 'sm:text-char-800'
  | 'md:text-char-800'
  | 'mg:text-char-800'
  | 'lg:text-char-800'
  | 'xl:text-char-800'
  | 'group-hover:text-char-800'
  | 'focus-within:text-char-800'
  | 'hover:text-char-800'
  | 'focus:text-char-800'
  | 'sm:text-char-900'
  | 'md:text-char-900'
  | 'mg:text-char-900'
  | 'lg:text-char-900'
  | 'xl:text-char-900'
  | 'group-hover:text-char-900'
  | 'focus-within:text-char-900'
  | 'hover:text-char-900'
  | 'focus:text-char-900'
  | 'sm:text-bone-50'
  | 'md:text-bone-50'
  | 'mg:text-bone-50'
  | 'lg:text-bone-50'
  | 'xl:text-bone-50'
  | 'group-hover:text-bone-50'
  | 'focus-within:text-bone-50'
  | 'hover:text-bone-50'
  | 'focus:text-bone-50'
  | 'sm:text-bone-100'
  | 'md:text-bone-100'
  | 'mg:text-bone-100'
  | 'lg:text-bone-100'
  | 'xl:text-bone-100'
  | 'group-hover:text-bone-100'
  | 'focus-within:text-bone-100'
  | 'hover:text-bone-100'
  | 'focus:text-bone-100'
  | 'sm:text-bone-200'
  | 'md:text-bone-200'
  | 'mg:text-bone-200'
  | 'lg:text-bone-200'
  | 'xl:text-bone-200'
  | 'group-hover:text-bone-200'
  | 'focus-within:text-bone-200'
  | 'hover:text-bone-200'
  | 'focus:text-bone-200'
  | 'sm:text-bone-300'
  | 'md:text-bone-300'
  | 'mg:text-bone-300'
  | 'lg:text-bone-300'
  | 'xl:text-bone-300'
  | 'group-hover:text-bone-300'
  | 'focus-within:text-bone-300'
  | 'hover:text-bone-300'
  | 'focus:text-bone-300'
  | 'sm:text-bone-400'
  | 'md:text-bone-400'
  | 'mg:text-bone-400'
  | 'lg:text-bone-400'
  | 'xl:text-bone-400'
  | 'group-hover:text-bone-400'
  | 'focus-within:text-bone-400'
  | 'hover:text-bone-400'
  | 'focus:text-bone-400'
  | 'sm:text-bone-500'
  | 'md:text-bone-500'
  | 'mg:text-bone-500'
  | 'lg:text-bone-500'
  | 'xl:text-bone-500'
  | 'group-hover:text-bone-500'
  | 'focus-within:text-bone-500'
  | 'hover:text-bone-500'
  | 'focus:text-bone-500'
  | 'sm:text-bone-600'
  | 'md:text-bone-600'
  | 'mg:text-bone-600'
  | 'lg:text-bone-600'
  | 'xl:text-bone-600'
  | 'group-hover:text-bone-600'
  | 'focus-within:text-bone-600'
  | 'hover:text-bone-600'
  | 'focus:text-bone-600'
  | 'sm:text-bone-700'
  | 'md:text-bone-700'
  | 'mg:text-bone-700'
  | 'lg:text-bone-700'
  | 'xl:text-bone-700'
  | 'group-hover:text-bone-700'
  | 'focus-within:text-bone-700'
  | 'hover:text-bone-700'
  | 'focus:text-bone-700'
  | 'sm:text-bone-800'
  | 'md:text-bone-800'
  | 'mg:text-bone-800'
  | 'lg:text-bone-800'
  | 'xl:text-bone-800'
  | 'group-hover:text-bone-800'
  | 'focus-within:text-bone-800'
  | 'hover:text-bone-800'
  | 'focus:text-bone-800'
  | 'sm:text-bone-900'
  | 'md:text-bone-900'
  | 'mg:text-bone-900'
  | 'lg:text-bone-900'
  | 'xl:text-bone-900'
  | 'group-hover:text-bone-900'
  | 'focus-within:text-bone-900'
  | 'hover:text-bone-900'
  | 'focus:text-bone-900'
  | 'sm:text-brick-50'
  | 'md:text-brick-50'
  | 'mg:text-brick-50'
  | 'lg:text-brick-50'
  | 'xl:text-brick-50'
  | 'group-hover:text-brick-50'
  | 'focus-within:text-brick-50'
  | 'hover:text-brick-50'
  | 'focus:text-brick-50'
  | 'sm:text-brick-300'
  | 'md:text-brick-300'
  | 'mg:text-brick-300'
  | 'lg:text-brick-300'
  | 'xl:text-brick-300'
  | 'group-hover:text-brick-300'
  | 'focus-within:text-brick-300'
  | 'hover:text-brick-300'
  | 'focus:text-brick-300'
  | 'sm:text-brick-500'
  | 'md:text-brick-500'
  | 'mg:text-brick-500'
  | 'lg:text-brick-500'
  | 'xl:text-brick-500'
  | 'group-hover:text-brick-500'
  | 'focus-within:text-brick-500'
  | 'hover:text-brick-500'
  | 'focus:text-brick-500'
  | 'sm:text-brick-700'
  | 'md:text-brick-700'
  | 'mg:text-brick-700'
  | 'lg:text-brick-700'
  | 'xl:text-brick-700'
  | 'group-hover:text-brick-700'
  | 'focus-within:text-brick-700'
  | 'hover:text-brick-700'
  | 'focus:text-brick-700'
  | 'sm:text-brick-900'
  | 'md:text-brick-900'
  | 'mg:text-brick-900'
  | 'lg:text-brick-900'
  | 'xl:text-brick-900'
  | 'group-hover:text-brick-900'
  | 'focus-within:text-brick-900'
  | 'hover:text-brick-900'
  | 'focus:text-brick-900'
  | 'sm:text-sage-50'
  | 'md:text-sage-50'
  | 'mg:text-sage-50'
  | 'lg:text-sage-50'
  | 'xl:text-sage-50'
  | 'group-hover:text-sage-50'
  | 'focus-within:text-sage-50'
  | 'hover:text-sage-50'
  | 'focus:text-sage-50'
  | 'sm:text-sage-300'
  | 'md:text-sage-300'
  | 'mg:text-sage-300'
  | 'lg:text-sage-300'
  | 'xl:text-sage-300'
  | 'group-hover:text-sage-300'
  | 'focus-within:text-sage-300'
  | 'hover:text-sage-300'
  | 'focus:text-sage-300'
  | 'sm:text-sage-500'
  | 'md:text-sage-500'
  | 'mg:text-sage-500'
  | 'lg:text-sage-500'
  | 'xl:text-sage-500'
  | 'group-hover:text-sage-500'
  | 'focus-within:text-sage-500'
  | 'hover:text-sage-500'
  | 'focus:text-sage-500'
  | 'sm:text-sage-700'
  | 'md:text-sage-700'
  | 'mg:text-sage-700'
  | 'lg:text-sage-700'
  | 'xl:text-sage-700'
  | 'group-hover:text-sage-700'
  | 'focus-within:text-sage-700'
  | 'hover:text-sage-700'
  | 'focus:text-sage-700'
  | 'sm:text-sage-900'
  | 'md:text-sage-900'
  | 'mg:text-sage-900'
  | 'lg:text-sage-900'
  | 'xl:text-sage-900'
  | 'group-hover:text-sage-900'
  | 'focus-within:text-sage-900'
  | 'hover:text-sage-900'
  | 'focus:text-sage-900'
  | 'sm:text-blue-50'
  | 'md:text-blue-50'
  | 'mg:text-blue-50'
  | 'lg:text-blue-50'
  | 'xl:text-blue-50'
  | 'group-hover:text-blue-50'
  | 'focus-within:text-blue-50'
  | 'hover:text-blue-50'
  | 'focus:text-blue-50'
  | 'sm:text-blue-300'
  | 'md:text-blue-300'
  | 'mg:text-blue-300'
  | 'lg:text-blue-300'
  | 'xl:text-blue-300'
  | 'group-hover:text-blue-300'
  | 'focus-within:text-blue-300'
  | 'hover:text-blue-300'
  | 'focus:text-blue-300'
  | 'sm:text-blue-500'
  | 'md:text-blue-500'
  | 'mg:text-blue-500'
  | 'lg:text-blue-500'
  | 'xl:text-blue-500'
  | 'group-hover:text-blue-500'
  | 'focus-within:text-blue-500'
  | 'hover:text-blue-500'
  | 'focus:text-blue-500'
  | 'sm:text-blue-700'
  | 'md:text-blue-700'
  | 'mg:text-blue-700'
  | 'lg:text-blue-700'
  | 'xl:text-blue-700'
  | 'group-hover:text-blue-700'
  | 'focus-within:text-blue-700'
  | 'hover:text-blue-700'
  | 'focus:text-blue-700'
  | 'sm:text-blue-900'
  | 'md:text-blue-900'
  | 'mg:text-blue-900'
  | 'lg:text-blue-900'
  | 'xl:text-blue-900'
  | 'group-hover:text-blue-900'
  | 'focus-within:text-blue-900'
  | 'hover:text-blue-900'
  | 'focus:text-blue-900'
  | 'sm:text-misc-bright-blue'
  | 'md:text-misc-bright-blue'
  | 'mg:text-misc-bright-blue'
  | 'lg:text-misc-bright-blue'
  | 'xl:text-misc-bright-blue'
  | 'group-hover:text-misc-bright-blue'
  | 'focus-within:text-misc-bright-blue'
  | 'hover:text-misc-bright-blue'
  | 'focus:text-misc-bright-blue'
  | 'sm:text-misc-focus'
  | 'md:text-misc-focus'
  | 'mg:text-misc-focus'
  | 'lg:text-misc-focus'
  | 'xl:text-misc-focus'
  | 'group-hover:text-misc-focus'
  | 'focus-within:text-misc-focus'
  | 'hover:text-misc-focus'
  | 'focus:text-misc-focus'
  | 'sm:text-misc-legal-blue'
  | 'md:text-misc-legal-blue'
  | 'mg:text-misc-legal-blue'
  | 'lg:text-misc-legal-blue'
  | 'xl:text-misc-legal-blue'
  | 'group-hover:text-misc-legal-blue'
  | 'focus-within:text-misc-legal-blue'
  | 'hover:text-misc-legal-blue'
  | 'focus:text-misc-legal-blue'
  | 'sm:text-misc-neutral'
  | 'md:text-misc-neutral'
  | 'mg:text-misc-neutral'
  | 'lg:text-misc-neutral'
  | 'xl:text-misc-neutral'
  | 'group-hover:text-misc-neutral'
  | 'focus-within:text-misc-neutral'
  | 'hover:text-misc-neutral'
  | 'focus:text-misc-neutral'
  | 'sm:text-misc-yellow-orange'
  | 'md:text-misc-yellow-orange'
  | 'mg:text-misc-yellow-orange'
  | 'lg:text-misc-yellow-orange'
  | 'xl:text-misc-yellow-orange'
  | 'group-hover:text-misc-yellow-orange'
  | 'focus-within:text-misc-yellow-orange'
  | 'hover:text-misc-yellow-orange'
  | 'focus:text-misc-yellow-orange'
  | 'sm:underline'
  | 'md:underline'
  | 'mg:underline'
  | 'lg:underline'
  | 'xl:underline'
  | 'group-hover:underline'
  | 'focus-within:underline'
  | 'hover:underline'
  | 'focus:underline'
  | 'sm:line-through'
  | 'md:line-through'
  | 'mg:line-through'
  | 'lg:line-through'
  | 'xl:line-through'
  | 'group-hover:line-through'
  | 'focus-within:line-through'
  | 'hover:line-through'
  | 'focus:line-through'
  | 'sm:no-underline'
  | 'md:no-underline'
  | 'mg:no-underline'
  | 'lg:no-underline'
  | 'xl:no-underline'
  | 'group-hover:no-underline'
  | 'focus-within:no-underline'
  | 'hover:no-underline'
  | 'focus:no-underline'
  | 'sm:text-opacity-0'
  | 'md:text-opacity-0'
  | 'mg:text-opacity-0'
  | 'lg:text-opacity-0'
  | 'xl:text-opacity-0'
  | 'group-hover:text-opacity-0'
  | 'focus-within:text-opacity-0'
  | 'hover:text-opacity-0'
  | 'focus:text-opacity-0'
  | 'sm:text-opacity-5'
  | 'md:text-opacity-5'
  | 'mg:text-opacity-5'
  | 'lg:text-opacity-5'
  | 'xl:text-opacity-5'
  | 'group-hover:text-opacity-5'
  | 'focus-within:text-opacity-5'
  | 'hover:text-opacity-5'
  | 'focus:text-opacity-5'
  | 'sm:text-opacity-10'
  | 'md:text-opacity-10'
  | 'mg:text-opacity-10'
  | 'lg:text-opacity-10'
  | 'xl:text-opacity-10'
  | 'group-hover:text-opacity-10'
  | 'focus-within:text-opacity-10'
  | 'hover:text-opacity-10'
  | 'focus:text-opacity-10'
  | 'sm:text-opacity-20'
  | 'md:text-opacity-20'
  | 'mg:text-opacity-20'
  | 'lg:text-opacity-20'
  | 'xl:text-opacity-20'
  | 'group-hover:text-opacity-20'
  | 'focus-within:text-opacity-20'
  | 'hover:text-opacity-20'
  | 'focus:text-opacity-20'
  | 'sm:text-opacity-25'
  | 'md:text-opacity-25'
  | 'mg:text-opacity-25'
  | 'lg:text-opacity-25'
  | 'xl:text-opacity-25'
  | 'group-hover:text-opacity-25'
  | 'focus-within:text-opacity-25'
  | 'hover:text-opacity-25'
  | 'focus:text-opacity-25'
  | 'sm:text-opacity-30'
  | 'md:text-opacity-30'
  | 'mg:text-opacity-30'
  | 'lg:text-opacity-30'
  | 'xl:text-opacity-30'
  | 'group-hover:text-opacity-30'
  | 'focus-within:text-opacity-30'
  | 'hover:text-opacity-30'
  | 'focus:text-opacity-30'
  | 'sm:text-opacity-40'
  | 'md:text-opacity-40'
  | 'mg:text-opacity-40'
  | 'lg:text-opacity-40'
  | 'xl:text-opacity-40'
  | 'group-hover:text-opacity-40'
  | 'focus-within:text-opacity-40'
  | 'hover:text-opacity-40'
  | 'focus:text-opacity-40'
  | 'sm:text-opacity-50'
  | 'md:text-opacity-50'
  | 'mg:text-opacity-50'
  | 'lg:text-opacity-50'
  | 'xl:text-opacity-50'
  | 'group-hover:text-opacity-50'
  | 'focus-within:text-opacity-50'
  | 'hover:text-opacity-50'
  | 'focus:text-opacity-50'
  | 'sm:text-opacity-60'
  | 'md:text-opacity-60'
  | 'mg:text-opacity-60'
  | 'lg:text-opacity-60'
  | 'xl:text-opacity-60'
  | 'group-hover:text-opacity-60'
  | 'focus-within:text-opacity-60'
  | 'hover:text-opacity-60'
  | 'focus:text-opacity-60'
  | 'sm:text-opacity-70'
  | 'md:text-opacity-70'
  | 'mg:text-opacity-70'
  | 'lg:text-opacity-70'
  | 'xl:text-opacity-70'
  | 'group-hover:text-opacity-70'
  | 'focus-within:text-opacity-70'
  | 'hover:text-opacity-70'
  | 'focus:text-opacity-70'
  | 'sm:text-opacity-75'
  | 'md:text-opacity-75'
  | 'mg:text-opacity-75'
  | 'lg:text-opacity-75'
  | 'xl:text-opacity-75'
  | 'group-hover:text-opacity-75'
  | 'focus-within:text-opacity-75'
  | 'hover:text-opacity-75'
  | 'focus:text-opacity-75'
  | 'sm:text-opacity-80'
  | 'md:text-opacity-80'
  | 'mg:text-opacity-80'
  | 'lg:text-opacity-80'
  | 'xl:text-opacity-80'
  | 'group-hover:text-opacity-80'
  | 'focus-within:text-opacity-80'
  | 'hover:text-opacity-80'
  | 'focus:text-opacity-80'
  | 'sm:text-opacity-90'
  | 'md:text-opacity-90'
  | 'mg:text-opacity-90'
  | 'lg:text-opacity-90'
  | 'xl:text-opacity-90'
  | 'group-hover:text-opacity-90'
  | 'focus-within:text-opacity-90'
  | 'hover:text-opacity-90'
  | 'focus:text-opacity-90'
  | 'sm:text-opacity-95'
  | 'md:text-opacity-95'
  | 'mg:text-opacity-95'
  | 'lg:text-opacity-95'
  | 'xl:text-opacity-95'
  | 'group-hover:text-opacity-95'
  | 'focus-within:text-opacity-95'
  | 'hover:text-opacity-95'
  | 'focus:text-opacity-95'
  | 'sm:text-opacity-100'
  | 'md:text-opacity-100'
  | 'mg:text-opacity-100'
  | 'lg:text-opacity-100'
  | 'xl:text-opacity-100'
  | 'group-hover:text-opacity-100'
  | 'focus-within:text-opacity-100'
  | 'hover:text-opacity-100'
  | 'focus:text-opacity-100'
  | 'sm:truncate'
  | 'md:truncate'
  | 'mg:truncate'
  | 'lg:truncate'
  | 'xl:truncate'
  | 'sm:overflow-ellipsis'
  | 'md:overflow-ellipsis'
  | 'mg:overflow-ellipsis'
  | 'lg:overflow-ellipsis'
  | 'xl:overflow-ellipsis'
  | 'sm:overflow-clip'
  | 'md:overflow-clip'
  | 'mg:overflow-clip'
  | 'lg:overflow-clip'
  | 'xl:overflow-clip'
  | 'sm:uppercase'
  | 'md:uppercase'
  | 'mg:uppercase'
  | 'lg:uppercase'
  | 'xl:uppercase'
  | 'sm:lowercase'
  | 'md:lowercase'
  | 'mg:lowercase'
  | 'lg:lowercase'
  | 'xl:lowercase'
  | 'sm:capitalize'
  | 'md:capitalize'
  | 'mg:capitalize'
  | 'lg:capitalize'
  | 'xl:capitalize'
  | 'sm:normal-case'
  | 'md:normal-case'
  | 'mg:normal-case'
  | 'lg:normal-case'
  | 'xl:normal-case'
  | 'sm:origin-center'
  | 'md:origin-center'
  | 'mg:origin-center'
  | 'lg:origin-center'
  | 'xl:origin-center'
  | 'sm:origin-top'
  | 'md:origin-top'
  | 'mg:origin-top'
  | 'lg:origin-top'
  | 'xl:origin-top'
  | 'sm:origin-top-right'
  | 'md:origin-top-right'
  | 'mg:origin-top-right'
  | 'lg:origin-top-right'
  | 'xl:origin-top-right'
  | 'sm:origin-right'
  | 'md:origin-right'
  | 'mg:origin-right'
  | 'lg:origin-right'
  | 'xl:origin-right'
  | 'sm:origin-bottom-right'
  | 'md:origin-bottom-right'
  | 'mg:origin-bottom-right'
  | 'lg:origin-bottom-right'
  | 'xl:origin-bottom-right'
  | 'sm:origin-bottom'
  | 'md:origin-bottom'
  | 'mg:origin-bottom'
  | 'lg:origin-bottom'
  | 'xl:origin-bottom'
  | 'sm:origin-bottom-left'
  | 'md:origin-bottom-left'
  | 'mg:origin-bottom-left'
  | 'lg:origin-bottom-left'
  | 'xl:origin-bottom-left'
  | 'sm:origin-left'
  | 'md:origin-left'
  | 'mg:origin-left'
  | 'lg:origin-left'
  | 'xl:origin-left'
  | 'sm:origin-top-left'
  | 'md:origin-top-left'
  | 'mg:origin-top-left'
  | 'lg:origin-top-left'
  | 'xl:origin-top-left'
  | 'sm:delay-75'
  | 'md:delay-75'
  | 'mg:delay-75'
  | 'lg:delay-75'
  | 'xl:delay-75'
  | 'sm:delay-100'
  | 'md:delay-100'
  | 'mg:delay-100'
  | 'lg:delay-100'
  | 'xl:delay-100'
  | 'sm:delay-150'
  | 'md:delay-150'
  | 'mg:delay-150'
  | 'lg:delay-150'
  | 'xl:delay-150'
  | 'sm:delay-200'
  | 'md:delay-200'
  | 'mg:delay-200'
  | 'lg:delay-200'
  | 'xl:delay-200'
  | 'sm:delay-300'
  | 'md:delay-300'
  | 'mg:delay-300'
  | 'lg:delay-300'
  | 'xl:delay-300'
  | 'sm:delay-500'
  | 'md:delay-500'
  | 'mg:delay-500'
  | 'lg:delay-500'
  | 'xl:delay-500'
  | 'sm:delay-700'
  | 'md:delay-700'
  | 'mg:delay-700'
  | 'lg:delay-700'
  | 'xl:delay-700'
  | 'sm:delay-1000'
  | 'md:delay-1000'
  | 'mg:delay-1000'
  | 'lg:delay-1000'
  | 'xl:delay-1000'
  | 'sm:duration-75'
  | 'md:duration-75'
  | 'mg:duration-75'
  | 'lg:duration-75'
  | 'xl:duration-75'
  | 'sm:duration-100'
  | 'md:duration-100'
  | 'mg:duration-100'
  | 'lg:duration-100'
  | 'xl:duration-100'
  | 'sm:duration-150'
  | 'md:duration-150'
  | 'mg:duration-150'
  | 'lg:duration-150'
  | 'xl:duration-150'
  | 'sm:duration-200'
  | 'md:duration-200'
  | 'mg:duration-200'
  | 'lg:duration-200'
  | 'xl:duration-200'
  | 'sm:duration-275'
  | 'md:duration-275'
  | 'mg:duration-275'
  | 'lg:duration-275'
  | 'xl:duration-275'
  | 'sm:duration-300'
  | 'md:duration-300'
  | 'mg:duration-300'
  | 'lg:duration-300'
  | 'xl:duration-300'
  | 'sm:duration-400'
  | 'md:duration-400'
  | 'mg:duration-400'
  | 'lg:duration-400'
  | 'xl:duration-400'
  | 'sm:duration-500'
  | 'md:duration-500'
  | 'mg:duration-500'
  | 'lg:duration-500'
  | 'xl:duration-500'
  | 'sm:duration-600'
  | 'md:duration-600'
  | 'mg:duration-600'
  | 'lg:duration-600'
  | 'xl:duration-600'
  | 'sm:duration-700'
  | 'md:duration-700'
  | 'mg:duration-700'
  | 'lg:duration-700'
  | 'xl:duration-700'
  | 'sm:duration-800'
  | 'md:duration-800'
  | 'mg:duration-800'
  | 'lg:duration-800'
  | 'xl:duration-800'
  | 'sm:duration-1000'
  | 'md:duration-1000'
  | 'mg:duration-1000'
  | 'lg:duration-1000'
  | 'xl:duration-1000'
  | 'sm:duration'
  | 'md:duration'
  | 'mg:duration'
  | 'lg:duration'
  | 'xl:duration'
  | 'sm:duration-debug'
  | 'md:duration-debug'
  | 'mg:duration-debug'
  | 'lg:duration-debug'
  | 'xl:duration-debug'
  | 'sm:transition-none'
  | 'md:transition-none'
  | 'mg:transition-none'
  | 'lg:transition-none'
  | 'xl:transition-none'
  | 'sm:transition-all'
  | 'md:transition-all'
  | 'mg:transition-all'
  | 'lg:transition-all'
  | 'xl:transition-all'
  | 'sm:transition'
  | 'md:transition'
  | 'mg:transition'
  | 'lg:transition'
  | 'xl:transition'
  | 'sm:transition-colors'
  | 'md:transition-colors'
  | 'mg:transition-colors'
  | 'lg:transition-colors'
  | 'xl:transition-colors'
  | 'sm:transition-opacity'
  | 'md:transition-opacity'
  | 'mg:transition-opacity'
  | 'lg:transition-opacity'
  | 'xl:transition-opacity'
  | 'sm:transition-shadow'
  | 'md:transition-shadow'
  | 'mg:transition-shadow'
  | 'lg:transition-shadow'
  | 'xl:transition-shadow'
  | 'sm:transition-transform'
  | 'md:transition-transform'
  | 'mg:transition-transform'
  | 'lg:transition-transform'
  | 'xl:transition-transform'
  | 'sm:transition-grid-rows'
  | 'md:transition-grid-rows'
  | 'mg:transition-grid-rows'
  | 'lg:transition-grid-rows'
  | 'xl:transition-grid-rows'
  | 'sm:transition-height'
  | 'md:transition-height'
  | 'mg:transition-height'
  | 'lg:transition-height'
  | 'xl:transition-height'
  | 'sm:transition-left'
  | 'md:transition-left'
  | 'mg:transition-left'
  | 'lg:transition-left'
  | 'xl:transition-left'
  | 'sm:transition-visibility'
  | 'md:transition-visibility'
  | 'mg:transition-visibility'
  | 'lg:transition-visibility'
  | 'xl:transition-visibility'
  | 'sm:ease-linear'
  | 'md:ease-linear'
  | 'mg:ease-linear'
  | 'lg:ease-linear'
  | 'xl:ease-linear'
  | 'sm:ease-in'
  | 'md:ease-in'
  | 'mg:ease-in'
  | 'lg:ease-in'
  | 'xl:ease-in'
  | 'sm:ease-out'
  | 'md:ease-out'
  | 'mg:ease-out'
  | 'lg:ease-out'
  | 'xl:ease-out'
  | 'sm:ease-in-out'
  | 'md:ease-in-out'
  | 'mg:ease-in-out'
  | 'lg:ease-in-out'
  | 'xl:ease-in-out'
  | 'sm:translate-x-0'
  | 'md:translate-x-0'
  | 'mg:translate-x-0'
  | 'lg:translate-x-0'
  | 'xl:translate-x-0'
  | 'hover:translate-x-0'
  | 'focus:translate-x-0'
  | 'sm:translate-x-1'
  | 'md:translate-x-1'
  | 'mg:translate-x-1'
  | 'lg:translate-x-1'
  | 'xl:translate-x-1'
  | 'hover:translate-x-1'
  | 'focus:translate-x-1'
  | 'sm:translate-x-2'
  | 'md:translate-x-2'
  | 'mg:translate-x-2'
  | 'lg:translate-x-2'
  | 'xl:translate-x-2'
  | 'hover:translate-x-2'
  | 'focus:translate-x-2'
  | 'sm:translate-x-3'
  | 'md:translate-x-3'
  | 'mg:translate-x-3'
  | 'lg:translate-x-3'
  | 'xl:translate-x-3'
  | 'hover:translate-x-3'
  | 'focus:translate-x-3'
  | 'sm:translate-x-4'
  | 'md:translate-x-4'
  | 'mg:translate-x-4'
  | 'lg:translate-x-4'
  | 'xl:translate-x-4'
  | 'hover:translate-x-4'
  | 'focus:translate-x-4'
  | 'sm:translate-x-5'
  | 'md:translate-x-5'
  | 'mg:translate-x-5'
  | 'lg:translate-x-5'
  | 'xl:translate-x-5'
  | 'hover:translate-x-5'
  | 'focus:translate-x-5'
  | 'sm:translate-x-6'
  | 'md:translate-x-6'
  | 'mg:translate-x-6'
  | 'lg:translate-x-6'
  | 'xl:translate-x-6'
  | 'hover:translate-x-6'
  | 'focus:translate-x-6'
  | 'sm:translate-x-7'
  | 'md:translate-x-7'
  | 'mg:translate-x-7'
  | 'lg:translate-x-7'
  | 'xl:translate-x-7'
  | 'hover:translate-x-7'
  | 'focus:translate-x-7'
  | 'sm:translate-x-8'
  | 'md:translate-x-8'
  | 'mg:translate-x-8'
  | 'lg:translate-x-8'
  | 'xl:translate-x-8'
  | 'hover:translate-x-8'
  | 'focus:translate-x-8'
  | 'sm:translate-x-9'
  | 'md:translate-x-9'
  | 'mg:translate-x-9'
  | 'lg:translate-x-9'
  | 'xl:translate-x-9'
  | 'hover:translate-x-9'
  | 'focus:translate-x-9'
  | 'sm:translate-x-10'
  | 'md:translate-x-10'
  | 'mg:translate-x-10'
  | 'lg:translate-x-10'
  | 'xl:translate-x-10'
  | 'hover:translate-x-10'
  | 'focus:translate-x-10'
  | 'sm:translate-x-11'
  | 'md:translate-x-11'
  | 'mg:translate-x-11'
  | 'lg:translate-x-11'
  | 'xl:translate-x-11'
  | 'hover:translate-x-11'
  | 'focus:translate-x-11'
  | 'sm:translate-x-12'
  | 'md:translate-x-12'
  | 'mg:translate-x-12'
  | 'lg:translate-x-12'
  | 'xl:translate-x-12'
  | 'hover:translate-x-12'
  | 'focus:translate-x-12'
  | 'sm:translate-x-14'
  | 'md:translate-x-14'
  | 'mg:translate-x-14'
  | 'lg:translate-x-14'
  | 'xl:translate-x-14'
  | 'hover:translate-x-14'
  | 'focus:translate-x-14'
  | 'sm:translate-x-15'
  | 'md:translate-x-15'
  | 'mg:translate-x-15'
  | 'lg:translate-x-15'
  | 'xl:translate-x-15'
  | 'hover:translate-x-15'
  | 'focus:translate-x-15'
  | 'sm:translate-x-16'
  | 'md:translate-x-16'
  | 'mg:translate-x-16'
  | 'lg:translate-x-16'
  | 'xl:translate-x-16'
  | 'hover:translate-x-16'
  | 'focus:translate-x-16'
  | 'sm:translate-x-17'
  | 'md:translate-x-17'
  | 'mg:translate-x-17'
  | 'lg:translate-x-17'
  | 'xl:translate-x-17'
  | 'hover:translate-x-17'
  | 'focus:translate-x-17'
  | 'sm:translate-x-18'
  | 'md:translate-x-18'
  | 'mg:translate-x-18'
  | 'lg:translate-x-18'
  | 'xl:translate-x-18'
  | 'hover:translate-x-18'
  | 'focus:translate-x-18'
  | 'sm:translate-x-20'
  | 'md:translate-x-20'
  | 'mg:translate-x-20'
  | 'lg:translate-x-20'
  | 'xl:translate-x-20'
  | 'hover:translate-x-20'
  | 'focus:translate-x-20'
  | 'sm:translate-x-21'
  | 'md:translate-x-21'
  | 'mg:translate-x-21'
  | 'lg:translate-x-21'
  | 'xl:translate-x-21'
  | 'hover:translate-x-21'
  | 'focus:translate-x-21'
  | 'sm:translate-x-22'
  | 'md:translate-x-22'
  | 'mg:translate-x-22'
  | 'lg:translate-x-22'
  | 'xl:translate-x-22'
  | 'hover:translate-x-22'
  | 'focus:translate-x-22'
  | 'sm:translate-x-24'
  | 'md:translate-x-24'
  | 'mg:translate-x-24'
  | 'lg:translate-x-24'
  | 'xl:translate-x-24'
  | 'hover:translate-x-24'
  | 'focus:translate-x-24'
  | 'sm:translate-x-28'
  | 'md:translate-x-28'
  | 'mg:translate-x-28'
  | 'lg:translate-x-28'
  | 'xl:translate-x-28'
  | 'hover:translate-x-28'
  | 'focus:translate-x-28'
  | 'sm:translate-x-30'
  | 'md:translate-x-30'
  | 'mg:translate-x-30'
  | 'lg:translate-x-30'
  | 'xl:translate-x-30'
  | 'hover:translate-x-30'
  | 'focus:translate-x-30'
  | 'sm:translate-x-32'
  | 'md:translate-x-32'
  | 'mg:translate-x-32'
  | 'lg:translate-x-32'
  | 'xl:translate-x-32'
  | 'hover:translate-x-32'
  | 'focus:translate-x-32'
  | 'sm:translate-x-36'
  | 'md:translate-x-36'
  | 'mg:translate-x-36'
  | 'lg:translate-x-36'
  | 'xl:translate-x-36'
  | 'hover:translate-x-36'
  | 'focus:translate-x-36'
  | 'sm:translate-x-40'
  | 'md:translate-x-40'
  | 'mg:translate-x-40'
  | 'lg:translate-x-40'
  | 'xl:translate-x-40'
  | 'hover:translate-x-40'
  | 'focus:translate-x-40'
  | 'sm:translate-x-44'
  | 'md:translate-x-44'
  | 'mg:translate-x-44'
  | 'lg:translate-x-44'
  | 'xl:translate-x-44'
  | 'hover:translate-x-44'
  | 'focus:translate-x-44'
  | 'sm:translate-x-48'
  | 'md:translate-x-48'
  | 'mg:translate-x-48'
  | 'lg:translate-x-48'
  | 'xl:translate-x-48'
  | 'hover:translate-x-48'
  | 'focus:translate-x-48'
  | 'sm:translate-x-52'
  | 'md:translate-x-52'
  | 'mg:translate-x-52'
  | 'lg:translate-x-52'
  | 'xl:translate-x-52'
  | 'hover:translate-x-52'
  | 'focus:translate-x-52'
  | 'sm:translate-x-56'
  | 'md:translate-x-56'
  | 'mg:translate-x-56'
  | 'lg:translate-x-56'
  | 'xl:translate-x-56'
  | 'hover:translate-x-56'
  | 'focus:translate-x-56'
  | 'sm:translate-x-60'
  | 'md:translate-x-60'
  | 'mg:translate-x-60'
  | 'lg:translate-x-60'
  | 'xl:translate-x-60'
  | 'hover:translate-x-60'
  | 'focus:translate-x-60'
  | 'sm:translate-x-64'
  | 'md:translate-x-64'
  | 'mg:translate-x-64'
  | 'lg:translate-x-64'
  | 'xl:translate-x-64'
  | 'hover:translate-x-64'
  | 'focus:translate-x-64'
  | 'sm:translate-x-72'
  | 'md:translate-x-72'
  | 'mg:translate-x-72'
  | 'lg:translate-x-72'
  | 'xl:translate-x-72'
  | 'hover:translate-x-72'
  | 'focus:translate-x-72'
  | 'sm:translate-x-80'
  | 'md:translate-x-80'
  | 'mg:translate-x-80'
  | 'lg:translate-x-80'
  | 'xl:translate-x-80'
  | 'hover:translate-x-80'
  | 'focus:translate-x-80'
  | 'sm:translate-x-96'
  | 'md:translate-x-96'
  | 'mg:translate-x-96'
  | 'lg:translate-x-96'
  | 'xl:translate-x-96'
  | 'hover:translate-x-96'
  | 'focus:translate-x-96'
  | 'sm:translate-x-px'
  | 'md:translate-x-px'
  | 'mg:translate-x-px'
  | 'lg:translate-x-px'
  | 'xl:translate-x-px'
  | 'hover:translate-x-px'
  | 'focus:translate-x-px'
  | 'sm:translate-x-0.5'
  | 'md:translate-x-0.5'
  | 'mg:translate-x-0.5'
  | 'lg:translate-x-0.5'
  | 'xl:translate-x-0.5'
  | 'hover:translate-x-0.5'
  | 'focus:translate-x-0.5'
  | 'sm:translate-x-1.5'
  | 'md:translate-x-1.5'
  | 'mg:translate-x-1.5'
  | 'lg:translate-x-1.5'
  | 'xl:translate-x-1.5'
  | 'hover:translate-x-1.5'
  | 'focus:translate-x-1.5'
  | 'sm:translate-x-2.5'
  | 'md:translate-x-2.5'
  | 'mg:translate-x-2.5'
  | 'lg:translate-x-2.5'
  | 'xl:translate-x-2.5'
  | 'hover:translate-x-2.5'
  | 'focus:translate-x-2.5'
  | 'sm:translate-x-3.5'
  | 'md:translate-x-3.5'
  | 'mg:translate-x-3.5'
  | 'lg:translate-x-3.5'
  | 'xl:translate-x-3.5'
  | 'hover:translate-x-3.5'
  | 'focus:translate-x-3.5'
  | 'sm:-translate-x-0'
  | 'md:-translate-x-0'
  | 'mg:-translate-x-0'
  | 'lg:-translate-x-0'
  | 'xl:-translate-x-0'
  | 'hover:-translate-x-0'
  | 'focus:-translate-x-0'
  | 'sm:-translate-x-1'
  | 'md:-translate-x-1'
  | 'mg:-translate-x-1'
  | 'lg:-translate-x-1'
  | 'xl:-translate-x-1'
  | 'hover:-translate-x-1'
  | 'focus:-translate-x-1'
  | 'sm:-translate-x-2'
  | 'md:-translate-x-2'
  | 'mg:-translate-x-2'
  | 'lg:-translate-x-2'
  | 'xl:-translate-x-2'
  | 'hover:-translate-x-2'
  | 'focus:-translate-x-2'
  | 'sm:-translate-x-3'
  | 'md:-translate-x-3'
  | 'mg:-translate-x-3'
  | 'lg:-translate-x-3'
  | 'xl:-translate-x-3'
  | 'hover:-translate-x-3'
  | 'focus:-translate-x-3'
  | 'sm:-translate-x-4'
  | 'md:-translate-x-4'
  | 'mg:-translate-x-4'
  | 'lg:-translate-x-4'
  | 'xl:-translate-x-4'
  | 'hover:-translate-x-4'
  | 'focus:-translate-x-4'
  | 'sm:-translate-x-5'
  | 'md:-translate-x-5'
  | 'mg:-translate-x-5'
  | 'lg:-translate-x-5'
  | 'xl:-translate-x-5'
  | 'hover:-translate-x-5'
  | 'focus:-translate-x-5'
  | 'sm:-translate-x-6'
  | 'md:-translate-x-6'
  | 'mg:-translate-x-6'
  | 'lg:-translate-x-6'
  | 'xl:-translate-x-6'
  | 'hover:-translate-x-6'
  | 'focus:-translate-x-6'
  | 'sm:-translate-x-7'
  | 'md:-translate-x-7'
  | 'mg:-translate-x-7'
  | 'lg:-translate-x-7'
  | 'xl:-translate-x-7'
  | 'hover:-translate-x-7'
  | 'focus:-translate-x-7'
  | 'sm:-translate-x-8'
  | 'md:-translate-x-8'
  | 'mg:-translate-x-8'
  | 'lg:-translate-x-8'
  | 'xl:-translate-x-8'
  | 'hover:-translate-x-8'
  | 'focus:-translate-x-8'
  | 'sm:-translate-x-9'
  | 'md:-translate-x-9'
  | 'mg:-translate-x-9'
  | 'lg:-translate-x-9'
  | 'xl:-translate-x-9'
  | 'hover:-translate-x-9'
  | 'focus:-translate-x-9'
  | 'sm:-translate-x-10'
  | 'md:-translate-x-10'
  | 'mg:-translate-x-10'
  | 'lg:-translate-x-10'
  | 'xl:-translate-x-10'
  | 'hover:-translate-x-10'
  | 'focus:-translate-x-10'
  | 'sm:-translate-x-11'
  | 'md:-translate-x-11'
  | 'mg:-translate-x-11'
  | 'lg:-translate-x-11'
  | 'xl:-translate-x-11'
  | 'hover:-translate-x-11'
  | 'focus:-translate-x-11'
  | 'sm:-translate-x-12'
  | 'md:-translate-x-12'
  | 'mg:-translate-x-12'
  | 'lg:-translate-x-12'
  | 'xl:-translate-x-12'
  | 'hover:-translate-x-12'
  | 'focus:-translate-x-12'
  | 'sm:-translate-x-14'
  | 'md:-translate-x-14'
  | 'mg:-translate-x-14'
  | 'lg:-translate-x-14'
  | 'xl:-translate-x-14'
  | 'hover:-translate-x-14'
  | 'focus:-translate-x-14'
  | 'sm:-translate-x-16'
  | 'md:-translate-x-16'
  | 'mg:-translate-x-16'
  | 'lg:-translate-x-16'
  | 'xl:-translate-x-16'
  | 'hover:-translate-x-16'
  | 'focus:-translate-x-16'
  | 'sm:-translate-x-20'
  | 'md:-translate-x-20'
  | 'mg:-translate-x-20'
  | 'lg:-translate-x-20'
  | 'xl:-translate-x-20'
  | 'hover:-translate-x-20'
  | 'focus:-translate-x-20'
  | 'sm:-translate-x-24'
  | 'md:-translate-x-24'
  | 'mg:-translate-x-24'
  | 'lg:-translate-x-24'
  | 'xl:-translate-x-24'
  | 'hover:-translate-x-24'
  | 'focus:-translate-x-24'
  | 'sm:-translate-x-28'
  | 'md:-translate-x-28'
  | 'mg:-translate-x-28'
  | 'lg:-translate-x-28'
  | 'xl:-translate-x-28'
  | 'hover:-translate-x-28'
  | 'focus:-translate-x-28'
  | 'sm:-translate-x-32'
  | 'md:-translate-x-32'
  | 'mg:-translate-x-32'
  | 'lg:-translate-x-32'
  | 'xl:-translate-x-32'
  | 'hover:-translate-x-32'
  | 'focus:-translate-x-32'
  | 'sm:-translate-x-36'
  | 'md:-translate-x-36'
  | 'mg:-translate-x-36'
  | 'lg:-translate-x-36'
  | 'xl:-translate-x-36'
  | 'hover:-translate-x-36'
  | 'focus:-translate-x-36'
  | 'sm:-translate-x-40'
  | 'md:-translate-x-40'
  | 'mg:-translate-x-40'
  | 'lg:-translate-x-40'
  | 'xl:-translate-x-40'
  | 'hover:-translate-x-40'
  | 'focus:-translate-x-40'
  | 'sm:-translate-x-44'
  | 'md:-translate-x-44'
  | 'mg:-translate-x-44'
  | 'lg:-translate-x-44'
  | 'xl:-translate-x-44'
  | 'hover:-translate-x-44'
  | 'focus:-translate-x-44'
  | 'sm:-translate-x-48'
  | 'md:-translate-x-48'
  | 'mg:-translate-x-48'
  | 'lg:-translate-x-48'
  | 'xl:-translate-x-48'
  | 'hover:-translate-x-48'
  | 'focus:-translate-x-48'
  | 'sm:-translate-x-52'
  | 'md:-translate-x-52'
  | 'mg:-translate-x-52'
  | 'lg:-translate-x-52'
  | 'xl:-translate-x-52'
  | 'hover:-translate-x-52'
  | 'focus:-translate-x-52'
  | 'sm:-translate-x-56'
  | 'md:-translate-x-56'
  | 'mg:-translate-x-56'
  | 'lg:-translate-x-56'
  | 'xl:-translate-x-56'
  | 'hover:-translate-x-56'
  | 'focus:-translate-x-56'
  | 'sm:-translate-x-60'
  | 'md:-translate-x-60'
  | 'mg:-translate-x-60'
  | 'lg:-translate-x-60'
  | 'xl:-translate-x-60'
  | 'hover:-translate-x-60'
  | 'focus:-translate-x-60'
  | 'sm:-translate-x-64'
  | 'md:-translate-x-64'
  | 'mg:-translate-x-64'
  | 'lg:-translate-x-64'
  | 'xl:-translate-x-64'
  | 'hover:-translate-x-64'
  | 'focus:-translate-x-64'
  | 'sm:-translate-x-72'
  | 'md:-translate-x-72'
  | 'mg:-translate-x-72'
  | 'lg:-translate-x-72'
  | 'xl:-translate-x-72'
  | 'hover:-translate-x-72'
  | 'focus:-translate-x-72'
  | 'sm:-translate-x-80'
  | 'md:-translate-x-80'
  | 'mg:-translate-x-80'
  | 'lg:-translate-x-80'
  | 'xl:-translate-x-80'
  | 'hover:-translate-x-80'
  | 'focus:-translate-x-80'
  | 'sm:-translate-x-96'
  | 'md:-translate-x-96'
  | 'mg:-translate-x-96'
  | 'lg:-translate-x-96'
  | 'xl:-translate-x-96'
  | 'hover:-translate-x-96'
  | 'focus:-translate-x-96'
  | 'sm:-translate-x-px'
  | 'md:-translate-x-px'
  | 'mg:-translate-x-px'
  | 'lg:-translate-x-px'
  | 'xl:-translate-x-px'
  | 'hover:-translate-x-px'
  | 'focus:-translate-x-px'
  | 'sm:-translate-x-0.5'
  | 'md:-translate-x-0.5'
  | 'mg:-translate-x-0.5'
  | 'lg:-translate-x-0.5'
  | 'xl:-translate-x-0.5'
  | 'hover:-translate-x-0.5'
  | 'focus:-translate-x-0.5'
  | 'sm:-translate-x-1.5'
  | 'md:-translate-x-1.5'
  | 'mg:-translate-x-1.5'
  | 'lg:-translate-x-1.5'
  | 'xl:-translate-x-1.5'
  | 'hover:-translate-x-1.5'
  | 'focus:-translate-x-1.5'
  | 'sm:-translate-x-2.5'
  | 'md:-translate-x-2.5'
  | 'mg:-translate-x-2.5'
  | 'lg:-translate-x-2.5'
  | 'xl:-translate-x-2.5'
  | 'hover:-translate-x-2.5'
  | 'focus:-translate-x-2.5'
  | 'sm:-translate-x-3.5'
  | 'md:-translate-x-3.5'
  | 'mg:-translate-x-3.5'
  | 'lg:-translate-x-3.5'
  | 'xl:-translate-x-3.5'
  | 'hover:-translate-x-3.5'
  | 'focus:-translate-x-3.5'
  | 'sm:translate-x-1/2'
  | 'md:translate-x-1/2'
  | 'mg:translate-x-1/2'
  | 'lg:translate-x-1/2'
  | 'xl:translate-x-1/2'
  | 'hover:translate-x-1/2'
  | 'focus:translate-x-1/2'
  | 'sm:translate-x-1/3'
  | 'md:translate-x-1/3'
  | 'mg:translate-x-1/3'
  | 'lg:translate-x-1/3'
  | 'xl:translate-x-1/3'
  | 'hover:translate-x-1/3'
  | 'focus:translate-x-1/3'
  | 'sm:translate-x-2/3'
  | 'md:translate-x-2/3'
  | 'mg:translate-x-2/3'
  | 'lg:translate-x-2/3'
  | 'xl:translate-x-2/3'
  | 'hover:translate-x-2/3'
  | 'focus:translate-x-2/3'
  | 'sm:translate-x-1/4'
  | 'md:translate-x-1/4'
  | 'mg:translate-x-1/4'
  | 'lg:translate-x-1/4'
  | 'xl:translate-x-1/4'
  | 'hover:translate-x-1/4'
  | 'focus:translate-x-1/4'
  | 'sm:translate-x-2/4'
  | 'md:translate-x-2/4'
  | 'mg:translate-x-2/4'
  | 'lg:translate-x-2/4'
  | 'xl:translate-x-2/4'
  | 'hover:translate-x-2/4'
  | 'focus:translate-x-2/4'
  | 'sm:translate-x-3/4'
  | 'md:translate-x-3/4'
  | 'mg:translate-x-3/4'
  | 'lg:translate-x-3/4'
  | 'xl:translate-x-3/4'
  | 'hover:translate-x-3/4'
  | 'focus:translate-x-3/4'
  | 'sm:translate-x-full'
  | 'md:translate-x-full'
  | 'mg:translate-x-full'
  | 'lg:translate-x-full'
  | 'xl:translate-x-full'
  | 'hover:translate-x-full'
  | 'focus:translate-x-full'
  | 'sm:-translate-x-1/2'
  | 'md:-translate-x-1/2'
  | 'mg:-translate-x-1/2'
  | 'lg:-translate-x-1/2'
  | 'xl:-translate-x-1/2'
  | 'hover:-translate-x-1/2'
  | 'focus:-translate-x-1/2'
  | 'sm:-translate-x-1/3'
  | 'md:-translate-x-1/3'
  | 'mg:-translate-x-1/3'
  | 'lg:-translate-x-1/3'
  | 'xl:-translate-x-1/3'
  | 'hover:-translate-x-1/3'
  | 'focus:-translate-x-1/3'
  | 'sm:-translate-x-2/3'
  | 'md:-translate-x-2/3'
  | 'mg:-translate-x-2/3'
  | 'lg:-translate-x-2/3'
  | 'xl:-translate-x-2/3'
  | 'hover:-translate-x-2/3'
  | 'focus:-translate-x-2/3'
  | 'sm:-translate-x-1/4'
  | 'md:-translate-x-1/4'
  | 'mg:-translate-x-1/4'
  | 'lg:-translate-x-1/4'
  | 'xl:-translate-x-1/4'
  | 'hover:-translate-x-1/4'
  | 'focus:-translate-x-1/4'
  | 'sm:-translate-x-2/4'
  | 'md:-translate-x-2/4'
  | 'mg:-translate-x-2/4'
  | 'lg:-translate-x-2/4'
  | 'xl:-translate-x-2/4'
  | 'hover:-translate-x-2/4'
  | 'focus:-translate-x-2/4'
  | 'sm:-translate-x-3/4'
  | 'md:-translate-x-3/4'
  | 'mg:-translate-x-3/4'
  | 'lg:-translate-x-3/4'
  | 'xl:-translate-x-3/4'
  | 'hover:-translate-x-3/4'
  | 'focus:-translate-x-3/4'
  | 'sm:-translate-x-full'
  | 'md:-translate-x-full'
  | 'mg:-translate-x-full'
  | 'lg:-translate-x-full'
  | 'xl:-translate-x-full'
  | 'hover:-translate-x-full'
  | 'focus:-translate-x-full'
  | 'sm:translate-x-4.5'
  | 'md:translate-x-4.5'
  | 'mg:translate-x-4.5'
  | 'lg:translate-x-4.5'
  | 'xl:translate-x-4.5'
  | 'hover:translate-x-4.5'
  | 'focus:translate-x-4.5'
  | 'sm:translate-x-7.5'
  | 'md:translate-x-7.5'
  | 'mg:translate-x-7.5'
  | 'lg:translate-x-7.5'
  | 'xl:translate-x-7.5'
  | 'hover:translate-x-7.5'
  | 'focus:translate-x-7.5'
  | 'sm:translate-x-9.5'
  | 'md:translate-x-9.5'
  | 'mg:translate-x-9.5'
  | 'lg:translate-x-9.5'
  | 'xl:translate-x-9.5'
  | 'hover:translate-x-9.5'
  | 'focus:translate-x-9.5'
  | 'sm:translate-x-11.5'
  | 'md:translate-x-11.5'
  | 'mg:translate-x-11.5'
  | 'lg:translate-x-11.5'
  | 'xl:translate-x-11.5'
  | 'hover:translate-x-11.5'
  | 'focus:translate-x-11.5'
  | 'sm:-translate-x-15'
  | 'md:-translate-x-15'
  | 'mg:-translate-x-15'
  | 'lg:-translate-x-15'
  | 'xl:-translate-x-15'
  | 'hover:-translate-x-15'
  | 'focus:-translate-x-15'
  | 'sm:-translate-x-17'
  | 'md:-translate-x-17'
  | 'mg:-translate-x-17'
  | 'lg:-translate-x-17'
  | 'xl:-translate-x-17'
  | 'hover:-translate-x-17'
  | 'focus:-translate-x-17'
  | 'sm:-translate-x-18'
  | 'md:-translate-x-18'
  | 'mg:-translate-x-18'
  | 'lg:-translate-x-18'
  | 'xl:-translate-x-18'
  | 'hover:-translate-x-18'
  | 'focus:-translate-x-18'
  | 'sm:-translate-x-21'
  | 'md:-translate-x-21'
  | 'mg:-translate-x-21'
  | 'lg:-translate-x-21'
  | 'xl:-translate-x-21'
  | 'hover:-translate-x-21'
  | 'focus:-translate-x-21'
  | 'sm:-translate-x-22'
  | 'md:-translate-x-22'
  | 'mg:-translate-x-22'
  | 'lg:-translate-x-22'
  | 'xl:-translate-x-22'
  | 'hover:-translate-x-22'
  | 'focus:-translate-x-22'
  | 'sm:-translate-x-30'
  | 'md:-translate-x-30'
  | 'mg:-translate-x-30'
  | 'lg:-translate-x-30'
  | 'xl:-translate-x-30'
  | 'hover:-translate-x-30'
  | 'focus:-translate-x-30'
  | 'sm:-translate-x-4.5'
  | 'md:-translate-x-4.5'
  | 'mg:-translate-x-4.5'
  | 'lg:-translate-x-4.5'
  | 'xl:-translate-x-4.5'
  | 'hover:-translate-x-4.5'
  | 'focus:-translate-x-4.5'
  | 'sm:-translate-x-7.5'
  | 'md:-translate-x-7.5'
  | 'mg:-translate-x-7.5'
  | 'lg:-translate-x-7.5'
  | 'xl:-translate-x-7.5'
  | 'hover:-translate-x-7.5'
  | 'focus:-translate-x-7.5'
  | 'sm:-translate-x-9.5'
  | 'md:-translate-x-9.5'
  | 'mg:-translate-x-9.5'
  | 'lg:-translate-x-9.5'
  | 'xl:-translate-x-9.5'
  | 'hover:-translate-x-9.5'
  | 'focus:-translate-x-9.5'
  | 'sm:-translate-x-11.5'
  | 'md:-translate-x-11.5'
  | 'mg:-translate-x-11.5'
  | 'lg:-translate-x-11.5'
  | 'xl:-translate-x-11.5'
  | 'hover:-translate-x-11.5'
  | 'focus:-translate-x-11.5'
  | 'sm:translate-y-0'
  | 'md:translate-y-0'
  | 'mg:translate-y-0'
  | 'lg:translate-y-0'
  | 'xl:translate-y-0'
  | 'hover:translate-y-0'
  | 'focus:translate-y-0'
  | 'sm:translate-y-1'
  | 'md:translate-y-1'
  | 'mg:translate-y-1'
  | 'lg:translate-y-1'
  | 'xl:translate-y-1'
  | 'hover:translate-y-1'
  | 'focus:translate-y-1'
  | 'sm:translate-y-2'
  | 'md:translate-y-2'
  | 'mg:translate-y-2'
  | 'lg:translate-y-2'
  | 'xl:translate-y-2'
  | 'hover:translate-y-2'
  | 'focus:translate-y-2'
  | 'sm:translate-y-3'
  | 'md:translate-y-3'
  | 'mg:translate-y-3'
  | 'lg:translate-y-3'
  | 'xl:translate-y-3'
  | 'hover:translate-y-3'
  | 'focus:translate-y-3'
  | 'sm:translate-y-4'
  | 'md:translate-y-4'
  | 'mg:translate-y-4'
  | 'lg:translate-y-4'
  | 'xl:translate-y-4'
  | 'hover:translate-y-4'
  | 'focus:translate-y-4'
  | 'sm:translate-y-5'
  | 'md:translate-y-5'
  | 'mg:translate-y-5'
  | 'lg:translate-y-5'
  | 'xl:translate-y-5'
  | 'hover:translate-y-5'
  | 'focus:translate-y-5'
  | 'sm:translate-y-6'
  | 'md:translate-y-6'
  | 'mg:translate-y-6'
  | 'lg:translate-y-6'
  | 'xl:translate-y-6'
  | 'hover:translate-y-6'
  | 'focus:translate-y-6'
  | 'sm:translate-y-7'
  | 'md:translate-y-7'
  | 'mg:translate-y-7'
  | 'lg:translate-y-7'
  | 'xl:translate-y-7'
  | 'hover:translate-y-7'
  | 'focus:translate-y-7'
  | 'sm:translate-y-8'
  | 'md:translate-y-8'
  | 'mg:translate-y-8'
  | 'lg:translate-y-8'
  | 'xl:translate-y-8'
  | 'hover:translate-y-8'
  | 'focus:translate-y-8'
  | 'sm:translate-y-9'
  | 'md:translate-y-9'
  | 'mg:translate-y-9'
  | 'lg:translate-y-9'
  | 'xl:translate-y-9'
  | 'hover:translate-y-9'
  | 'focus:translate-y-9'
  | 'sm:translate-y-10'
  | 'md:translate-y-10'
  | 'mg:translate-y-10'
  | 'lg:translate-y-10'
  | 'xl:translate-y-10'
  | 'hover:translate-y-10'
  | 'focus:translate-y-10'
  | 'sm:translate-y-11'
  | 'md:translate-y-11'
  | 'mg:translate-y-11'
  | 'lg:translate-y-11'
  | 'xl:translate-y-11'
  | 'hover:translate-y-11'
  | 'focus:translate-y-11'
  | 'sm:translate-y-12'
  | 'md:translate-y-12'
  | 'mg:translate-y-12'
  | 'lg:translate-y-12'
  | 'xl:translate-y-12'
  | 'hover:translate-y-12'
  | 'focus:translate-y-12'
  | 'sm:translate-y-14'
  | 'md:translate-y-14'
  | 'mg:translate-y-14'
  | 'lg:translate-y-14'
  | 'xl:translate-y-14'
  | 'hover:translate-y-14'
  | 'focus:translate-y-14'
  | 'sm:translate-y-15'
  | 'md:translate-y-15'
  | 'mg:translate-y-15'
  | 'lg:translate-y-15'
  | 'xl:translate-y-15'
  | 'hover:translate-y-15'
  | 'focus:translate-y-15'
  | 'sm:translate-y-16'
  | 'md:translate-y-16'
  | 'mg:translate-y-16'
  | 'lg:translate-y-16'
  | 'xl:translate-y-16'
  | 'hover:translate-y-16'
  | 'focus:translate-y-16'
  | 'sm:translate-y-17'
  | 'md:translate-y-17'
  | 'mg:translate-y-17'
  | 'lg:translate-y-17'
  | 'xl:translate-y-17'
  | 'hover:translate-y-17'
  | 'focus:translate-y-17'
  | 'sm:translate-y-18'
  | 'md:translate-y-18'
  | 'mg:translate-y-18'
  | 'lg:translate-y-18'
  | 'xl:translate-y-18'
  | 'hover:translate-y-18'
  | 'focus:translate-y-18'
  | 'sm:translate-y-20'
  | 'md:translate-y-20'
  | 'mg:translate-y-20'
  | 'lg:translate-y-20'
  | 'xl:translate-y-20'
  | 'hover:translate-y-20'
  | 'focus:translate-y-20'
  | 'sm:translate-y-21'
  | 'md:translate-y-21'
  | 'mg:translate-y-21'
  | 'lg:translate-y-21'
  | 'xl:translate-y-21'
  | 'hover:translate-y-21'
  | 'focus:translate-y-21'
  | 'sm:translate-y-22'
  | 'md:translate-y-22'
  | 'mg:translate-y-22'
  | 'lg:translate-y-22'
  | 'xl:translate-y-22'
  | 'hover:translate-y-22'
  | 'focus:translate-y-22'
  | 'sm:translate-y-24'
  | 'md:translate-y-24'
  | 'mg:translate-y-24'
  | 'lg:translate-y-24'
  | 'xl:translate-y-24'
  | 'hover:translate-y-24'
  | 'focus:translate-y-24'
  | 'sm:translate-y-28'
  | 'md:translate-y-28'
  | 'mg:translate-y-28'
  | 'lg:translate-y-28'
  | 'xl:translate-y-28'
  | 'hover:translate-y-28'
  | 'focus:translate-y-28'
  | 'sm:translate-y-30'
  | 'md:translate-y-30'
  | 'mg:translate-y-30'
  | 'lg:translate-y-30'
  | 'xl:translate-y-30'
  | 'hover:translate-y-30'
  | 'focus:translate-y-30'
  | 'sm:translate-y-32'
  | 'md:translate-y-32'
  | 'mg:translate-y-32'
  | 'lg:translate-y-32'
  | 'xl:translate-y-32'
  | 'hover:translate-y-32'
  | 'focus:translate-y-32'
  | 'sm:translate-y-36'
  | 'md:translate-y-36'
  | 'mg:translate-y-36'
  | 'lg:translate-y-36'
  | 'xl:translate-y-36'
  | 'hover:translate-y-36'
  | 'focus:translate-y-36'
  | 'sm:translate-y-40'
  | 'md:translate-y-40'
  | 'mg:translate-y-40'
  | 'lg:translate-y-40'
  | 'xl:translate-y-40'
  | 'hover:translate-y-40'
  | 'focus:translate-y-40'
  | 'sm:translate-y-44'
  | 'md:translate-y-44'
  | 'mg:translate-y-44'
  | 'lg:translate-y-44'
  | 'xl:translate-y-44'
  | 'hover:translate-y-44'
  | 'focus:translate-y-44'
  | 'sm:translate-y-48'
  | 'md:translate-y-48'
  | 'mg:translate-y-48'
  | 'lg:translate-y-48'
  | 'xl:translate-y-48'
  | 'hover:translate-y-48'
  | 'focus:translate-y-48'
  | 'sm:translate-y-52'
  | 'md:translate-y-52'
  | 'mg:translate-y-52'
  | 'lg:translate-y-52'
  | 'xl:translate-y-52'
  | 'hover:translate-y-52'
  | 'focus:translate-y-52'
  | 'sm:translate-y-56'
  | 'md:translate-y-56'
  | 'mg:translate-y-56'
  | 'lg:translate-y-56'
  | 'xl:translate-y-56'
  | 'hover:translate-y-56'
  | 'focus:translate-y-56'
  | 'sm:translate-y-60'
  | 'md:translate-y-60'
  | 'mg:translate-y-60'
  | 'lg:translate-y-60'
  | 'xl:translate-y-60'
  | 'hover:translate-y-60'
  | 'focus:translate-y-60'
  | 'sm:translate-y-64'
  | 'md:translate-y-64'
  | 'mg:translate-y-64'
  | 'lg:translate-y-64'
  | 'xl:translate-y-64'
  | 'hover:translate-y-64'
  | 'focus:translate-y-64'
  | 'sm:translate-y-72'
  | 'md:translate-y-72'
  | 'mg:translate-y-72'
  | 'lg:translate-y-72'
  | 'xl:translate-y-72'
  | 'hover:translate-y-72'
  | 'focus:translate-y-72'
  | 'sm:translate-y-80'
  | 'md:translate-y-80'
  | 'mg:translate-y-80'
  | 'lg:translate-y-80'
  | 'xl:translate-y-80'
  | 'hover:translate-y-80'
  | 'focus:translate-y-80'
  | 'sm:translate-y-96'
  | 'md:translate-y-96'
  | 'mg:translate-y-96'
  | 'lg:translate-y-96'
  | 'xl:translate-y-96'
  | 'hover:translate-y-96'
  | 'focus:translate-y-96'
  | 'sm:translate-y-px'
  | 'md:translate-y-px'
  | 'mg:translate-y-px'
  | 'lg:translate-y-px'
  | 'xl:translate-y-px'
  | 'hover:translate-y-px'
  | 'focus:translate-y-px'
  | 'sm:translate-y-0.5'
  | 'md:translate-y-0.5'
  | 'mg:translate-y-0.5'
  | 'lg:translate-y-0.5'
  | 'xl:translate-y-0.5'
  | 'hover:translate-y-0.5'
  | 'focus:translate-y-0.5'
  | 'sm:translate-y-1.5'
  | 'md:translate-y-1.5'
  | 'mg:translate-y-1.5'
  | 'lg:translate-y-1.5'
  | 'xl:translate-y-1.5'
  | 'hover:translate-y-1.5'
  | 'focus:translate-y-1.5'
  | 'sm:translate-y-2.5'
  | 'md:translate-y-2.5'
  | 'mg:translate-y-2.5'
  | 'lg:translate-y-2.5'
  | 'xl:translate-y-2.5'
  | 'hover:translate-y-2.5'
  | 'focus:translate-y-2.5'
  | 'sm:translate-y-3.5'
  | 'md:translate-y-3.5'
  | 'mg:translate-y-3.5'
  | 'lg:translate-y-3.5'
  | 'xl:translate-y-3.5'
  | 'hover:translate-y-3.5'
  | 'focus:translate-y-3.5'
  | 'sm:-translate-y-0'
  | 'md:-translate-y-0'
  | 'mg:-translate-y-0'
  | 'lg:-translate-y-0'
  | 'xl:-translate-y-0'
  | 'hover:-translate-y-0'
  | 'focus:-translate-y-0'
  | 'sm:-translate-y-1'
  | 'md:-translate-y-1'
  | 'mg:-translate-y-1'
  | 'lg:-translate-y-1'
  | 'xl:-translate-y-1'
  | 'hover:-translate-y-1'
  | 'focus:-translate-y-1'
  | 'sm:-translate-y-2'
  | 'md:-translate-y-2'
  | 'mg:-translate-y-2'
  | 'lg:-translate-y-2'
  | 'xl:-translate-y-2'
  | 'hover:-translate-y-2'
  | 'focus:-translate-y-2'
  | 'sm:-translate-y-3'
  | 'md:-translate-y-3'
  | 'mg:-translate-y-3'
  | 'lg:-translate-y-3'
  | 'xl:-translate-y-3'
  | 'hover:-translate-y-3'
  | 'focus:-translate-y-3'
  | 'sm:-translate-y-4'
  | 'md:-translate-y-4'
  | 'mg:-translate-y-4'
  | 'lg:-translate-y-4'
  | 'xl:-translate-y-4'
  | 'hover:-translate-y-4'
  | 'focus:-translate-y-4'
  | 'sm:-translate-y-5'
  | 'md:-translate-y-5'
  | 'mg:-translate-y-5'
  | 'lg:-translate-y-5'
  | 'xl:-translate-y-5'
  | 'hover:-translate-y-5'
  | 'focus:-translate-y-5'
  | 'sm:-translate-y-6'
  | 'md:-translate-y-6'
  | 'mg:-translate-y-6'
  | 'lg:-translate-y-6'
  | 'xl:-translate-y-6'
  | 'hover:-translate-y-6'
  | 'focus:-translate-y-6'
  | 'sm:-translate-y-7'
  | 'md:-translate-y-7'
  | 'mg:-translate-y-7'
  | 'lg:-translate-y-7'
  | 'xl:-translate-y-7'
  | 'hover:-translate-y-7'
  | 'focus:-translate-y-7'
  | 'sm:-translate-y-8'
  | 'md:-translate-y-8'
  | 'mg:-translate-y-8'
  | 'lg:-translate-y-8'
  | 'xl:-translate-y-8'
  | 'hover:-translate-y-8'
  | 'focus:-translate-y-8'
  | 'sm:-translate-y-9'
  | 'md:-translate-y-9'
  | 'mg:-translate-y-9'
  | 'lg:-translate-y-9'
  | 'xl:-translate-y-9'
  | 'hover:-translate-y-9'
  | 'focus:-translate-y-9'
  | 'sm:-translate-y-10'
  | 'md:-translate-y-10'
  | 'mg:-translate-y-10'
  | 'lg:-translate-y-10'
  | 'xl:-translate-y-10'
  | 'hover:-translate-y-10'
  | 'focus:-translate-y-10'
  | 'sm:-translate-y-11'
  | 'md:-translate-y-11'
  | 'mg:-translate-y-11'
  | 'lg:-translate-y-11'
  | 'xl:-translate-y-11'
  | 'hover:-translate-y-11'
  | 'focus:-translate-y-11'
  | 'sm:-translate-y-12'
  | 'md:-translate-y-12'
  | 'mg:-translate-y-12'
  | 'lg:-translate-y-12'
  | 'xl:-translate-y-12'
  | 'hover:-translate-y-12'
  | 'focus:-translate-y-12'
  | 'sm:-translate-y-14'
  | 'md:-translate-y-14'
  | 'mg:-translate-y-14'
  | 'lg:-translate-y-14'
  | 'xl:-translate-y-14'
  | 'hover:-translate-y-14'
  | 'focus:-translate-y-14'
  | 'sm:-translate-y-16'
  | 'md:-translate-y-16'
  | 'mg:-translate-y-16'
  | 'lg:-translate-y-16'
  | 'xl:-translate-y-16'
  | 'hover:-translate-y-16'
  | 'focus:-translate-y-16'
  | 'sm:-translate-y-20'
  | 'md:-translate-y-20'
  | 'mg:-translate-y-20'
  | 'lg:-translate-y-20'
  | 'xl:-translate-y-20'
  | 'hover:-translate-y-20'
  | 'focus:-translate-y-20'
  | 'sm:-translate-y-24'
  | 'md:-translate-y-24'
  | 'mg:-translate-y-24'
  | 'lg:-translate-y-24'
  | 'xl:-translate-y-24'
  | 'hover:-translate-y-24'
  | 'focus:-translate-y-24'
  | 'sm:-translate-y-28'
  | 'md:-translate-y-28'
  | 'mg:-translate-y-28'
  | 'lg:-translate-y-28'
  | 'xl:-translate-y-28'
  | 'hover:-translate-y-28'
  | 'focus:-translate-y-28'
  | 'sm:-translate-y-32'
  | 'md:-translate-y-32'
  | 'mg:-translate-y-32'
  | 'lg:-translate-y-32'
  | 'xl:-translate-y-32'
  | 'hover:-translate-y-32'
  | 'focus:-translate-y-32'
  | 'sm:-translate-y-36'
  | 'md:-translate-y-36'
  | 'mg:-translate-y-36'
  | 'lg:-translate-y-36'
  | 'xl:-translate-y-36'
  | 'hover:-translate-y-36'
  | 'focus:-translate-y-36'
  | 'sm:-translate-y-40'
  | 'md:-translate-y-40'
  | 'mg:-translate-y-40'
  | 'lg:-translate-y-40'
  | 'xl:-translate-y-40'
  | 'hover:-translate-y-40'
  | 'focus:-translate-y-40'
  | 'sm:-translate-y-44'
  | 'md:-translate-y-44'
  | 'mg:-translate-y-44'
  | 'lg:-translate-y-44'
  | 'xl:-translate-y-44'
  | 'hover:-translate-y-44'
  | 'focus:-translate-y-44'
  | 'sm:-translate-y-48'
  | 'md:-translate-y-48'
  | 'mg:-translate-y-48'
  | 'lg:-translate-y-48'
  | 'xl:-translate-y-48'
  | 'hover:-translate-y-48'
  | 'focus:-translate-y-48'
  | 'sm:-translate-y-52'
  | 'md:-translate-y-52'
  | 'mg:-translate-y-52'
  | 'lg:-translate-y-52'
  | 'xl:-translate-y-52'
  | 'hover:-translate-y-52'
  | 'focus:-translate-y-52'
  | 'sm:-translate-y-56'
  | 'md:-translate-y-56'
  | 'mg:-translate-y-56'
  | 'lg:-translate-y-56'
  | 'xl:-translate-y-56'
  | 'hover:-translate-y-56'
  | 'focus:-translate-y-56'
  | 'sm:-translate-y-60'
  | 'md:-translate-y-60'
  | 'mg:-translate-y-60'
  | 'lg:-translate-y-60'
  | 'xl:-translate-y-60'
  | 'hover:-translate-y-60'
  | 'focus:-translate-y-60'
  | 'sm:-translate-y-64'
  | 'md:-translate-y-64'
  | 'mg:-translate-y-64'
  | 'lg:-translate-y-64'
  | 'xl:-translate-y-64'
  | 'hover:-translate-y-64'
  | 'focus:-translate-y-64'
  | 'sm:-translate-y-72'
  | 'md:-translate-y-72'
  | 'mg:-translate-y-72'
  | 'lg:-translate-y-72'
  | 'xl:-translate-y-72'
  | 'hover:-translate-y-72'
  | 'focus:-translate-y-72'
  | 'sm:-translate-y-80'
  | 'md:-translate-y-80'
  | 'mg:-translate-y-80'
  | 'lg:-translate-y-80'
  | 'xl:-translate-y-80'
  | 'hover:-translate-y-80'
  | 'focus:-translate-y-80'
  | 'sm:-translate-y-96'
  | 'md:-translate-y-96'
  | 'mg:-translate-y-96'
  | 'lg:-translate-y-96'
  | 'xl:-translate-y-96'
  | 'hover:-translate-y-96'
  | 'focus:-translate-y-96'
  | 'sm:-translate-y-px'
  | 'md:-translate-y-px'
  | 'mg:-translate-y-px'
  | 'lg:-translate-y-px'
  | 'xl:-translate-y-px'
  | 'hover:-translate-y-px'
  | 'focus:-translate-y-px'
  | 'sm:-translate-y-0.5'
  | 'md:-translate-y-0.5'
  | 'mg:-translate-y-0.5'
  | 'lg:-translate-y-0.5'
  | 'xl:-translate-y-0.5'
  | 'hover:-translate-y-0.5'
  | 'focus:-translate-y-0.5'
  | 'sm:-translate-y-1.5'
  | 'md:-translate-y-1.5'
  | 'mg:-translate-y-1.5'
  | 'lg:-translate-y-1.5'
  | 'xl:-translate-y-1.5'
  | 'hover:-translate-y-1.5'
  | 'focus:-translate-y-1.5'
  | 'sm:-translate-y-2.5'
  | 'md:-translate-y-2.5'
  | 'mg:-translate-y-2.5'
  | 'lg:-translate-y-2.5'
  | 'xl:-translate-y-2.5'
  | 'hover:-translate-y-2.5'
  | 'focus:-translate-y-2.5'
  | 'sm:-translate-y-3.5'
  | 'md:-translate-y-3.5'
  | 'mg:-translate-y-3.5'
  | 'lg:-translate-y-3.5'
  | 'xl:-translate-y-3.5'
  | 'hover:-translate-y-3.5'
  | 'focus:-translate-y-3.5'
  | 'sm:translate-y-1/2'
  | 'md:translate-y-1/2'
  | 'mg:translate-y-1/2'
  | 'lg:translate-y-1/2'
  | 'xl:translate-y-1/2'
  | 'hover:translate-y-1/2'
  | 'focus:translate-y-1/2'
  | 'sm:translate-y-1/3'
  | 'md:translate-y-1/3'
  | 'mg:translate-y-1/3'
  | 'lg:translate-y-1/3'
  | 'xl:translate-y-1/3'
  | 'hover:translate-y-1/3'
  | 'focus:translate-y-1/3'
  | 'sm:translate-y-2/3'
  | 'md:translate-y-2/3'
  | 'mg:translate-y-2/3'
  | 'lg:translate-y-2/3'
  | 'xl:translate-y-2/3'
  | 'hover:translate-y-2/3'
  | 'focus:translate-y-2/3'
  | 'sm:translate-y-1/4'
  | 'md:translate-y-1/4'
  | 'mg:translate-y-1/4'
  | 'lg:translate-y-1/4'
  | 'xl:translate-y-1/4'
  | 'hover:translate-y-1/4'
  | 'focus:translate-y-1/4'
  | 'sm:translate-y-2/4'
  | 'md:translate-y-2/4'
  | 'mg:translate-y-2/4'
  | 'lg:translate-y-2/4'
  | 'xl:translate-y-2/4'
  | 'hover:translate-y-2/4'
  | 'focus:translate-y-2/4'
  | 'sm:translate-y-3/4'
  | 'md:translate-y-3/4'
  | 'mg:translate-y-3/4'
  | 'lg:translate-y-3/4'
  | 'xl:translate-y-3/4'
  | 'hover:translate-y-3/4'
  | 'focus:translate-y-3/4'
  | 'sm:translate-y-full'
  | 'md:translate-y-full'
  | 'mg:translate-y-full'
  | 'lg:translate-y-full'
  | 'xl:translate-y-full'
  | 'hover:translate-y-full'
  | 'focus:translate-y-full'
  | 'sm:-translate-y-1/2'
  | 'md:-translate-y-1/2'
  | 'mg:-translate-y-1/2'
  | 'lg:-translate-y-1/2'
  | 'xl:-translate-y-1/2'
  | 'hover:-translate-y-1/2'
  | 'focus:-translate-y-1/2'
  | 'sm:-translate-y-1/3'
  | 'md:-translate-y-1/3'
  | 'mg:-translate-y-1/3'
  | 'lg:-translate-y-1/3'
  | 'xl:-translate-y-1/3'
  | 'hover:-translate-y-1/3'
  | 'focus:-translate-y-1/3'
  | 'sm:-translate-y-2/3'
  | 'md:-translate-y-2/3'
  | 'mg:-translate-y-2/3'
  | 'lg:-translate-y-2/3'
  | 'xl:-translate-y-2/3'
  | 'hover:-translate-y-2/3'
  | 'focus:-translate-y-2/3'
  | 'sm:-translate-y-1/4'
  | 'md:-translate-y-1/4'
  | 'mg:-translate-y-1/4'
  | 'lg:-translate-y-1/4'
  | 'xl:-translate-y-1/4'
  | 'hover:-translate-y-1/4'
  | 'focus:-translate-y-1/4'
  | 'sm:-translate-y-2/4'
  | 'md:-translate-y-2/4'
  | 'mg:-translate-y-2/4'
  | 'lg:-translate-y-2/4'
  | 'xl:-translate-y-2/4'
  | 'hover:-translate-y-2/4'
  | 'focus:-translate-y-2/4'
  | 'sm:-translate-y-3/4'
  | 'md:-translate-y-3/4'
  | 'mg:-translate-y-3/4'
  | 'lg:-translate-y-3/4'
  | 'xl:-translate-y-3/4'
  | 'hover:-translate-y-3/4'
  | 'focus:-translate-y-3/4'
  | 'sm:-translate-y-full'
  | 'md:-translate-y-full'
  | 'mg:-translate-y-full'
  | 'lg:-translate-y-full'
  | 'xl:-translate-y-full'
  | 'hover:-translate-y-full'
  | 'focus:-translate-y-full'
  | 'sm:translate-y-4.5'
  | 'md:translate-y-4.5'
  | 'mg:translate-y-4.5'
  | 'lg:translate-y-4.5'
  | 'xl:translate-y-4.5'
  | 'hover:translate-y-4.5'
  | 'focus:translate-y-4.5'
  | 'sm:translate-y-7.5'
  | 'md:translate-y-7.5'
  | 'mg:translate-y-7.5'
  | 'lg:translate-y-7.5'
  | 'xl:translate-y-7.5'
  | 'hover:translate-y-7.5'
  | 'focus:translate-y-7.5'
  | 'sm:translate-y-9.5'
  | 'md:translate-y-9.5'
  | 'mg:translate-y-9.5'
  | 'lg:translate-y-9.5'
  | 'xl:translate-y-9.5'
  | 'hover:translate-y-9.5'
  | 'focus:translate-y-9.5'
  | 'sm:translate-y-11.5'
  | 'md:translate-y-11.5'
  | 'mg:translate-y-11.5'
  | 'lg:translate-y-11.5'
  | 'xl:translate-y-11.5'
  | 'hover:translate-y-11.5'
  | 'focus:translate-y-11.5'
  | 'sm:-translate-y-15'
  | 'md:-translate-y-15'
  | 'mg:-translate-y-15'
  | 'lg:-translate-y-15'
  | 'xl:-translate-y-15'
  | 'hover:-translate-y-15'
  | 'focus:-translate-y-15'
  | 'sm:-translate-y-17'
  | 'md:-translate-y-17'
  | 'mg:-translate-y-17'
  | 'lg:-translate-y-17'
  | 'xl:-translate-y-17'
  | 'hover:-translate-y-17'
  | 'focus:-translate-y-17'
  | 'sm:-translate-y-18'
  | 'md:-translate-y-18'
  | 'mg:-translate-y-18'
  | 'lg:-translate-y-18'
  | 'xl:-translate-y-18'
  | 'hover:-translate-y-18'
  | 'focus:-translate-y-18'
  | 'sm:-translate-y-21'
  | 'md:-translate-y-21'
  | 'mg:-translate-y-21'
  | 'lg:-translate-y-21'
  | 'xl:-translate-y-21'
  | 'hover:-translate-y-21'
  | 'focus:-translate-y-21'
  | 'sm:-translate-y-22'
  | 'md:-translate-y-22'
  | 'mg:-translate-y-22'
  | 'lg:-translate-y-22'
  | 'xl:-translate-y-22'
  | 'hover:-translate-y-22'
  | 'focus:-translate-y-22'
  | 'sm:-translate-y-30'
  | 'md:-translate-y-30'
  | 'mg:-translate-y-30'
  | 'lg:-translate-y-30'
  | 'xl:-translate-y-30'
  | 'hover:-translate-y-30'
  | 'focus:-translate-y-30'
  | 'sm:-translate-y-4.5'
  | 'md:-translate-y-4.5'
  | 'mg:-translate-y-4.5'
  | 'lg:-translate-y-4.5'
  | 'xl:-translate-y-4.5'
  | 'hover:-translate-y-4.5'
  | 'focus:-translate-y-4.5'
  | 'sm:-translate-y-7.5'
  | 'md:-translate-y-7.5'
  | 'mg:-translate-y-7.5'
  | 'lg:-translate-y-7.5'
  | 'xl:-translate-y-7.5'
  | 'hover:-translate-y-7.5'
  | 'focus:-translate-y-7.5'
  | 'sm:-translate-y-9.5'
  | 'md:-translate-y-9.5'
  | 'mg:-translate-y-9.5'
  | 'lg:-translate-y-9.5'
  | 'xl:-translate-y-9.5'
  | 'hover:-translate-y-9.5'
  | 'focus:-translate-y-9.5'
  | 'sm:-translate-y-11.5'
  | 'md:-translate-y-11.5'
  | 'mg:-translate-y-11.5'
  | 'lg:-translate-y-11.5'
  | 'xl:-translate-y-11.5'
  | 'hover:-translate-y-11.5'
  | 'focus:-translate-y-11.5'
  | 'sm:select-none'
  | 'md:select-none'
  | 'mg:select-none'
  | 'lg:select-none'
  | 'xl:select-none'
  | 'sm:select-text'
  | 'md:select-text'
  | 'mg:select-text'
  | 'lg:select-text'
  | 'xl:select-text'
  | 'sm:select-all'
  | 'md:select-all'
  | 'mg:select-all'
  | 'lg:select-all'
  | 'xl:select-all'
  | 'sm:select-auto'
  | 'md:select-auto'
  | 'mg:select-auto'
  | 'lg:select-auto'
  | 'xl:select-auto'
  | 'sm:align-baseline'
  | 'md:align-baseline'
  | 'mg:align-baseline'
  | 'lg:align-baseline'
  | 'xl:align-baseline'
  | 'sm:align-top'
  | 'md:align-top'
  | 'mg:align-top'
  | 'lg:align-top'
  | 'xl:align-top'
  | 'sm:align-middle'
  | 'md:align-middle'
  | 'mg:align-middle'
  | 'lg:align-middle'
  | 'xl:align-middle'
  | 'sm:align-bottom'
  | 'md:align-bottom'
  | 'mg:align-bottom'
  | 'lg:align-bottom'
  | 'xl:align-bottom'
  | 'sm:align-text-top'
  | 'md:align-text-top'
  | 'mg:align-text-top'
  | 'lg:align-text-top'
  | 'xl:align-text-top'
  | 'sm:align-text-bottom'
  | 'md:align-text-bottom'
  | 'mg:align-text-bottom'
  | 'lg:align-text-bottom'
  | 'xl:align-text-bottom'
  | 'sm:visible'
  | 'md:visible'
  | 'mg:visible'
  | 'lg:visible'
  | 'xl:visible'
  | 'sm:invisible'
  | 'md:invisible'
  | 'mg:invisible'
  | 'lg:invisible'
  | 'xl:invisible'
  | 'sm:whitespace-normal'
  | 'md:whitespace-normal'
  | 'mg:whitespace-normal'
  | 'lg:whitespace-normal'
  | 'xl:whitespace-normal'
  | 'sm:whitespace-nowrap'
  | 'md:whitespace-nowrap'
  | 'mg:whitespace-nowrap'
  | 'lg:whitespace-nowrap'
  | 'xl:whitespace-nowrap'
  | 'sm:whitespace-pre'
  | 'md:whitespace-pre'
  | 'mg:whitespace-pre'
  | 'lg:whitespace-pre'
  | 'xl:whitespace-pre'
  | 'sm:whitespace-pre-line'
  | 'md:whitespace-pre-line'
  | 'mg:whitespace-pre-line'
  | 'lg:whitespace-pre-line'
  | 'xl:whitespace-pre-line'
  | 'sm:whitespace-pre-wrap'
  | 'md:whitespace-pre-wrap'
  | 'mg:whitespace-pre-wrap'
  | 'lg:whitespace-pre-wrap'
  | 'xl:whitespace-pre-wrap'
  | 'sm:w-0'
  | 'md:w-0'
  | 'mg:w-0'
  | 'lg:w-0'
  | 'xl:w-0'
  | 'sm:w-1'
  | 'md:w-1'
  | 'mg:w-1'
  | 'lg:w-1'
  | 'xl:w-1'
  | 'sm:w-2'
  | 'md:w-2'
  | 'mg:w-2'
  | 'lg:w-2'
  | 'xl:w-2'
  | 'sm:w-3'
  | 'md:w-3'
  | 'mg:w-3'
  | 'lg:w-3'
  | 'xl:w-3'
  | 'sm:w-4'
  | 'md:w-4'
  | 'mg:w-4'
  | 'lg:w-4'
  | 'xl:w-4'
  | 'sm:w-5'
  | 'md:w-5'
  | 'mg:w-5'
  | 'lg:w-5'
  | 'xl:w-5'
  | 'sm:w-6'
  | 'md:w-6'
  | 'mg:w-6'
  | 'lg:w-6'
  | 'xl:w-6'
  | 'sm:w-7'
  | 'md:w-7'
  | 'mg:w-7'
  | 'lg:w-7'
  | 'xl:w-7'
  | 'sm:w-8'
  | 'md:w-8'
  | 'mg:w-8'
  | 'lg:w-8'
  | 'xl:w-8'
  | 'sm:w-9'
  | 'md:w-9'
  | 'mg:w-9'
  | 'lg:w-9'
  | 'xl:w-9'
  | 'sm:w-10'
  | 'md:w-10'
  | 'mg:w-10'
  | 'lg:w-10'
  | 'xl:w-10'
  | 'sm:w-11'
  | 'md:w-11'
  | 'mg:w-11'
  | 'lg:w-11'
  | 'xl:w-11'
  | 'sm:w-12'
  | 'md:w-12'
  | 'mg:w-12'
  | 'lg:w-12'
  | 'xl:w-12'
  | 'sm:w-14'
  | 'md:w-14'
  | 'mg:w-14'
  | 'lg:w-14'
  | 'xl:w-14'
  | 'sm:w-15'
  | 'md:w-15'
  | 'mg:w-15'
  | 'lg:w-15'
  | 'xl:w-15'
  | 'sm:w-16'
  | 'md:w-16'
  | 'mg:w-16'
  | 'lg:w-16'
  | 'xl:w-16'
  | 'sm:w-17'
  | 'md:w-17'
  | 'mg:w-17'
  | 'lg:w-17'
  | 'xl:w-17'
  | 'sm:w-18'
  | 'md:w-18'
  | 'mg:w-18'
  | 'lg:w-18'
  | 'xl:w-18'
  | 'sm:w-20'
  | 'md:w-20'
  | 'mg:w-20'
  | 'lg:w-20'
  | 'xl:w-20'
  | 'sm:w-21'
  | 'md:w-21'
  | 'mg:w-21'
  | 'lg:w-21'
  | 'xl:w-21'
  | 'sm:w-22'
  | 'md:w-22'
  | 'mg:w-22'
  | 'lg:w-22'
  | 'xl:w-22'
  | 'sm:w-24'
  | 'md:w-24'
  | 'mg:w-24'
  | 'lg:w-24'
  | 'xl:w-24'
  | 'sm:w-28'
  | 'md:w-28'
  | 'mg:w-28'
  | 'lg:w-28'
  | 'xl:w-28'
  | 'sm:w-30'
  | 'md:w-30'
  | 'mg:w-30'
  | 'lg:w-30'
  | 'xl:w-30'
  | 'sm:w-32'
  | 'md:w-32'
  | 'mg:w-32'
  | 'lg:w-32'
  | 'xl:w-32'
  | 'sm:w-36'
  | 'md:w-36'
  | 'mg:w-36'
  | 'lg:w-36'
  | 'xl:w-36'
  | 'sm:w-40'
  | 'md:w-40'
  | 'mg:w-40'
  | 'lg:w-40'
  | 'xl:w-40'
  | 'sm:w-44'
  | 'md:w-44'
  | 'mg:w-44'
  | 'lg:w-44'
  | 'xl:w-44'
  | 'sm:w-48'
  | 'md:w-48'
  | 'mg:w-48'
  | 'lg:w-48'
  | 'xl:w-48'
  | 'sm:w-52'
  | 'md:w-52'
  | 'mg:w-52'
  | 'lg:w-52'
  | 'xl:w-52'
  | 'sm:w-56'
  | 'md:w-56'
  | 'mg:w-56'
  | 'lg:w-56'
  | 'xl:w-56'
  | 'sm:w-60'
  | 'md:w-60'
  | 'mg:w-60'
  | 'lg:w-60'
  | 'xl:w-60'
  | 'sm:w-64'
  | 'md:w-64'
  | 'mg:w-64'
  | 'lg:w-64'
  | 'xl:w-64'
  | 'sm:w-72'
  | 'md:w-72'
  | 'mg:w-72'
  | 'lg:w-72'
  | 'xl:w-72'
  | 'sm:w-80'
  | 'md:w-80'
  | 'mg:w-80'
  | 'lg:w-80'
  | 'xl:w-80'
  | 'sm:w-96'
  | 'md:w-96'
  | 'mg:w-96'
  | 'lg:w-96'
  | 'xl:w-96'
  | 'sm:w-auto'
  | 'md:w-auto'
  | 'mg:w-auto'
  | 'lg:w-auto'
  | 'xl:w-auto'
  | 'sm:w-px'
  | 'md:w-px'
  | 'mg:w-px'
  | 'lg:w-px'
  | 'xl:w-px'
  | 'sm:w-0.5'
  | 'md:w-0.5'
  | 'mg:w-0.5'
  | 'lg:w-0.5'
  | 'xl:w-0.5'
  | 'sm:w-1.5'
  | 'md:w-1.5'
  | 'mg:w-1.5'
  | 'lg:w-1.5'
  | 'xl:w-1.5'
  | 'sm:w-2.5'
  | 'md:w-2.5'
  | 'mg:w-2.5'
  | 'lg:w-2.5'
  | 'xl:w-2.5'
  | 'sm:w-3.5'
  | 'md:w-3.5'
  | 'mg:w-3.5'
  | 'lg:w-3.5'
  | 'xl:w-3.5'
  | 'sm:w-1/2'
  | 'md:w-1/2'
  | 'mg:w-1/2'
  | 'lg:w-1/2'
  | 'xl:w-1/2'
  | 'sm:w-1/3'
  | 'md:w-1/3'
  | 'mg:w-1/3'
  | 'lg:w-1/3'
  | 'xl:w-1/3'
  | 'sm:w-2/3'
  | 'md:w-2/3'
  | 'mg:w-2/3'
  | 'lg:w-2/3'
  | 'xl:w-2/3'
  | 'sm:w-1/4'
  | 'md:w-1/4'
  | 'mg:w-1/4'
  | 'lg:w-1/4'
  | 'xl:w-1/4'
  | 'sm:w-2/4'
  | 'md:w-2/4'
  | 'mg:w-2/4'
  | 'lg:w-2/4'
  | 'xl:w-2/4'
  | 'sm:w-3/4'
  | 'md:w-3/4'
  | 'mg:w-3/4'
  | 'lg:w-3/4'
  | 'xl:w-3/4'
  | 'sm:w-1/5'
  | 'md:w-1/5'
  | 'mg:w-1/5'
  | 'lg:w-1/5'
  | 'xl:w-1/5'
  | 'sm:w-2/5'
  | 'md:w-2/5'
  | 'mg:w-2/5'
  | 'lg:w-2/5'
  | 'xl:w-2/5'
  | 'sm:w-3/5'
  | 'md:w-3/5'
  | 'mg:w-3/5'
  | 'lg:w-3/5'
  | 'xl:w-3/5'
  | 'sm:w-4/5'
  | 'md:w-4/5'
  | 'mg:w-4/5'
  | 'lg:w-4/5'
  | 'xl:w-4/5'
  | 'sm:w-1/6'
  | 'md:w-1/6'
  | 'mg:w-1/6'
  | 'lg:w-1/6'
  | 'xl:w-1/6'
  | 'sm:w-2/6'
  | 'md:w-2/6'
  | 'mg:w-2/6'
  | 'lg:w-2/6'
  | 'xl:w-2/6'
  | 'sm:w-3/6'
  | 'md:w-3/6'
  | 'mg:w-3/6'
  | 'lg:w-3/6'
  | 'xl:w-3/6'
  | 'sm:w-4/6'
  | 'md:w-4/6'
  | 'mg:w-4/6'
  | 'lg:w-4/6'
  | 'xl:w-4/6'
  | 'sm:w-5/6'
  | 'md:w-5/6'
  | 'mg:w-5/6'
  | 'lg:w-5/6'
  | 'xl:w-5/6'
  | 'sm:w-1/12'
  | 'md:w-1/12'
  | 'mg:w-1/12'
  | 'lg:w-1/12'
  | 'xl:w-1/12'
  | 'sm:w-2/12'
  | 'md:w-2/12'
  | 'mg:w-2/12'
  | 'lg:w-2/12'
  | 'xl:w-2/12'
  | 'sm:w-3/12'
  | 'md:w-3/12'
  | 'mg:w-3/12'
  | 'lg:w-3/12'
  | 'xl:w-3/12'
  | 'sm:w-4/12'
  | 'md:w-4/12'
  | 'mg:w-4/12'
  | 'lg:w-4/12'
  | 'xl:w-4/12'
  | 'sm:w-5/12'
  | 'md:w-5/12'
  | 'mg:w-5/12'
  | 'lg:w-5/12'
  | 'xl:w-5/12'
  | 'sm:w-6/12'
  | 'md:w-6/12'
  | 'mg:w-6/12'
  | 'lg:w-6/12'
  | 'xl:w-6/12'
  | 'sm:w-7/12'
  | 'md:w-7/12'
  | 'mg:w-7/12'
  | 'lg:w-7/12'
  | 'xl:w-7/12'
  | 'sm:w-8/12'
  | 'md:w-8/12'
  | 'mg:w-8/12'
  | 'lg:w-8/12'
  | 'xl:w-8/12'
  | 'sm:w-9/12'
  | 'md:w-9/12'
  | 'mg:w-9/12'
  | 'lg:w-9/12'
  | 'xl:w-9/12'
  | 'sm:w-10/12'
  | 'md:w-10/12'
  | 'mg:w-10/12'
  | 'lg:w-10/12'
  | 'xl:w-10/12'
  | 'sm:w-11/12'
  | 'md:w-11/12'
  | 'mg:w-11/12'
  | 'lg:w-11/12'
  | 'xl:w-11/12'
  | 'sm:w-full'
  | 'md:w-full'
  | 'mg:w-full'
  | 'lg:w-full'
  | 'xl:w-full'
  | 'sm:w-screen'
  | 'md:w-screen'
  | 'mg:w-screen'
  | 'lg:w-screen'
  | 'xl:w-screen'
  | 'sm:w-min'
  | 'md:w-min'
  | 'mg:w-min'
  | 'lg:w-min'
  | 'xl:w-min'
  | 'sm:w-max'
  | 'md:w-max'
  | 'mg:w-max'
  | 'lg:w-max'
  | 'xl:w-max'
  | 'sm:w-4.5'
  | 'md:w-4.5'
  | 'mg:w-4.5'
  | 'lg:w-4.5'
  | 'xl:w-4.5'
  | 'sm:w-7.5'
  | 'md:w-7.5'
  | 'mg:w-7.5'
  | 'lg:w-7.5'
  | 'xl:w-7.5'
  | 'sm:w-9.5'
  | 'md:w-9.5'
  | 'mg:w-9.5'
  | 'lg:w-9.5'
  | 'xl:w-9.5'
  | 'sm:w-11.5'
  | 'md:w-11.5'
  | 'mg:w-11.5'
  | 'lg:w-11.5'
  | 'xl:w-11.5'
  | 'sm:w-sidebar'
  | 'md:w-sidebar'
  | 'mg:w-sidebar'
  | 'lg:w-sidebar'
  | 'xl:w-sidebar'
  | 'sm:w-tiny-swatch'
  | 'md:w-tiny-swatch'
  | 'mg:w-tiny-swatch'
  | 'lg:w-tiny-swatch'
  | 'xl:w-tiny-swatch'
  | 'sm:w-mini-swatch'
  | 'md:w-mini-swatch'
  | 'mg:w-mini-swatch'
  | 'lg:w-mini-swatch'
  | 'xl:w-mini-swatch'
  | 'sm:w-swatch'
  | 'md:w-swatch'
  | 'mg:w-swatch'
  | 'lg:w-swatch'
  | 'xl:w-swatch'
  | 'sm:w-collections-sidebar'
  | 'md:w-collections-sidebar'
  | 'mg:w-collections-sidebar'
  | 'lg:w-collections-sidebar'
  | 'xl:w-collections-sidebar'
  | 'sm:w-cart-upsell-card'
  | 'md:w-cart-upsell-card'
  | 'mg:w-cart-upsell-card'
  | 'lg:w-cart-upsell-card'
  | 'xl:w-cart-upsell-card'
  | 'sm:break-normal'
  | 'md:break-normal'
  | 'mg:break-normal'
  | 'lg:break-normal'
  | 'xl:break-normal'
  | 'sm:break-words'
  | 'md:break-words'
  | 'mg:break-words'
  | 'lg:break-words'
  | 'xl:break-words'
  | 'sm:break-all'
  | 'md:break-all'
  | 'mg:break-all'
  | 'lg:break-all'
  | 'xl:break-all'
  | 'sm:z-0'
  | 'md:z-0'
  | 'mg:z-0'
  | 'lg:z-0'
  | 'xl:z-0'
  | 'focus-within:z-0'
  | 'focus:z-0'
  | 'sm:z-10'
  | 'md:z-10'
  | 'mg:z-10'
  | 'lg:z-10'
  | 'xl:z-10'
  | 'focus-within:z-10'
  | 'focus:z-10'
  | 'sm:z-20'
  | 'md:z-20'
  | 'mg:z-20'
  | 'lg:z-20'
  | 'xl:z-20'
  | 'focus-within:z-20'
  | 'focus:z-20'
  | 'sm:z-30'
  | 'md:z-30'
  | 'mg:z-30'
  | 'lg:z-30'
  | 'xl:z-30'
  | 'focus-within:z-30'
  | 'focus:z-30'
  | 'sm:z-40'
  | 'md:z-40'
  | 'mg:z-40'
  | 'lg:z-40'
  | 'xl:z-40'
  | 'focus-within:z-40'
  | 'focus:z-40'
  | 'sm:z-50'
  | 'md:z-50'
  | 'mg:z-50'
  | 'lg:z-50'
  | 'xl:z-50'
  | 'focus-within:z-50'
  | 'focus:z-50'
  | 'sm:z-60'
  | 'md:z-60'
  | 'mg:z-60'
  | 'lg:z-60'
  | 'xl:z-60'
  | 'focus-within:z-60'
  | 'focus:z-60'
  | 'sm:z-70'
  | 'md:z-70'
  | 'mg:z-70'
  | 'lg:z-70'
  | 'xl:z-70'
  | 'focus-within:z-70'
  | 'focus:z-70'
  | 'sm:z-80'
  | 'md:z-80'
  | 'mg:z-80'
  | 'lg:z-80'
  | 'xl:z-80'
  | 'focus-within:z-80'
  | 'focus:z-80'
  | 'sm:z-90'
  | 'md:z-90'
  | 'mg:z-90'
  | 'lg:z-90'
  | 'xl:z-90'
  | 'focus-within:z-90'
  | 'focus:z-90'
  | 'sm:z-100'
  | 'md:z-100'
  | 'mg:z-100'
  | 'lg:z-100'
  | 'xl:z-100'
  | 'focus-within:z-100'
  | 'focus:z-100'
  | 'sm:z-200'
  | 'md:z-200'
  | 'mg:z-200'
  | 'lg:z-200'
  | 'xl:z-200'
  | 'focus-within:z-200'
  | 'focus:z-200'
  | 'sm:z-300'
  | 'md:z-300'
  | 'mg:z-300'
  | 'lg:z-300'
  | 'xl:z-300'
  | 'focus-within:z-300'
  | 'focus:z-300'
  | 'sm:z-400'
  | 'md:z-400'
  | 'mg:z-400'
  | 'lg:z-400'
  | 'xl:z-400'
  | 'focus-within:z-400'
  | 'focus:z-400'
  | 'sm:z-500'
  | 'md:z-500'
  | 'mg:z-500'
  | 'lg:z-500'
  | 'xl:z-500'
  | 'focus-within:z-500'
  | 'focus:z-500'
  | 'sm:z-1000'
  | 'md:z-1000'
  | 'mg:z-1000'
  | 'lg:z-1000'
  | 'xl:z-1000'
  | 'focus-within:z-1000'
  | 'focus:z-1000'
  | 'sm:z-auto'
  | 'md:z-auto'
  | 'mg:z-auto'
  | 'lg:z-auto'
  | 'xl:z-auto'
  | 'focus-within:z-auto'
  | 'focus:z-auto'
  | 'sm:z-max'
  | 'md:z-max'
  | 'mg:z-max'
  | 'lg:z-max'
  | 'xl:z-max'
  | 'focus-within:z-max'
  | 'focus:z-max'
  | 'sm:sr-only'
  | 'md:sr-only'
  | 'mg:sr-only'
  | 'lg:sr-only'
  | 'xl:sr-only'
  | 'focus-within:sr-only'
  | 'focus:sr-only'
  | 'sm:not-sr-only'
  | 'md:not-sr-only'
  | 'mg:not-sr-only'
  | 'lg:not-sr-only'
  | 'xl:not-sr-only'
  | 'focus-within:not-sr-only'
  | 'focus:not-sr-only'

export type TClasses =
  | TAccessibility
  | TBackgrounds
  | TBorders
  | TTables
  | TEffects
  | TTransitionsAndAnimations
  | TFilters
  | TFlexBox
  | TGrid
  | TSpacing
  | TInteractivity
  | TLayout
  | TSizing
  | TSVG
  | TTransforms
  | TTypography
  | TPseudoClasses

export type TTailwindString = string & {
  /**
  * Brand property used to differentiate a Tailwind
  * class string from a regular string. The value is
  * intentionally opaque and should not be relied on
  * at runtime.
  */
  readonly __twBrand: unique symbol
}

export type TKey = TClasses | TTailwindString | TCustomClassesFromExternalFile

export type TArg =
| TClasses
| null
| undefined
| {[key in TKey]?: boolean}
| TTailwindString
| TCustomClassesFromExternalFile

export type TTailwind = (...args: TArg[]) => TTailwindString

export const classnames: TTailwind = classnamesLib as any

export const tw = classnames

export default tw

